// src/flow/enums.ts
var ConditionFact = /* @__PURE__ */ ((ConditionFact2) => {
  ConditionFact2["SPECIFIC_PRODUCT"] = "SPECIFIC_PRODUCT";
  ConditionFact2["PRODUCT_COLLECTION"] = "PRODUCT_COLLECTION";
  ConditionFact2["PRODUCT_TAGS"] = "PRODUCT_TAGS";
  ConditionFact2["PRODUCT_TITLE"] = "PRODUCT_TITLE";
  ConditionFact2["PRODUCT_SKU"] = "PRODUCT_SKU";
  ConditionFact2["CART_OR_ORDER_VALUE"] = "CART_OR_ORDER_VALUE";
  ConditionFact2["PRODUCT_VARIANT_NAME"] = "PRODUCT_VARIANT_NAME";
  ConditionFact2["PRODUCT_SALES_CHANNEL"] = "PRODUCT_SALES_CHANNEL";
  ConditionFact2["DISCOUNT_CODE"] = "DISCOUNT_CODE";
  ConditionFact2["CUSTOMER_LANGUAGE"] = "CUSTOMER_LANGUAGE";
  ConditionFact2["CUSTOMER_COUNTRY"] = "CUSTOMER_COUNTRY";
  ConditionFact2["PREV_PAGE_OFFER"] = "PREV_PAGE_OFFER";
  ConditionFact2["CUSTOMER_EMAIL"] = "CUSTOMER_EMAIL";
  ConditionFact2["CUSTOMER_NUMBER_OF_ORDERS"] = "CUSTOMER_NUMBER_OF_ORDERS";
  ConditionFact2["CUSTOMER_TAG"] = "CUSTOMER_TAG";
  ConditionFact2["CUSTOMER_SEGMENTS"] = "CUSTOMER_SEGMENTS";
  ConditionFact2["MARKETING_CONSENT"] = "MARKETING_CONSENT";
  ConditionFact2["PRODUCT_PRICE"] = "PRODUCT_PRICE";
  ConditionFact2["TOTAL_ITEM_COUNT"] = "TOTAL_ITEM_COUNT";
  ConditionFact2["PHYSICAL_PRODUCT_OR_REQUIRE_SHIPPING"] = "PHYSICAL_PRODUCT_OR_REQUIRE_SHIPPING";
  ConditionFact2["SHIPPING_VALUE"] = "SHIPPING_VALUE";
  ConditionFact2["ORDER_NOTE"] = "ORDER_NOTE";
  ConditionFact2["PAYMENT_METHOD"] = "PAYMENT_METHOD";
  ConditionFact2["PRODUCT_TYPE"] = "PRODUCT_TYPE";
  ConditionFact2["PRODUCT_VENDOR"] = "PRODUCT_VENDOR";
  ConditionFact2["PRODUCT_IS_AVAILABLE_AT_SALES_CHANNEL"] = "PRODUCT_IS_AVAILABLE_AT_SALES_CHANNEL";
  ConditionFact2["FULFILLMENT_STATUS"] = "FULFILLMENT_STATUS";
  ConditionFact2["PAYMENT_STATUS"] = "PAYMENT_STATUS";
  ConditionFact2["SHIPPING_METHOD"] = "SHIPPING_METHOD";
  ConditionFact2["ORDER_TAGS"] = "ORDER_TAGS";
  ConditionFact2["PRODUCT_ITEM_COST"] = "PRODUCT_ITEM_COST";
  ConditionFact2["CUSTOMER_TAGS"] = "CUSTOMER_TAGS";
  ConditionFact2["CUSTOMER_TIME_SINCE_LAST_ORDER"] = "CUSTOMER_TIME_SINCE_LAST_ORDER";
  ConditionFact2["CUSTOMER_BIRTHDAY"] = "CUSTOMER_BIRTHDAY";
  return ConditionFact2;
})(ConditionFact || {});
var PageType = /* @__PURE__ */ ((PageType2) => {
  PageType2["PRE_PURCHASE_PRODUCT_PAGE"] = "PRE_PURCHASE_PRODUCT_PAGE";
  PageType2["PRE_PURCHASE_CART_PAGE"] = "PRE_PURCHASE_CART_PAGE";
  PageType2["PRE_PURCHASE_CART_DRAWER_PAGE"] = "PRE_PURCHASE_CART_DRAWER_PAGE";
  PageType2["CHECKOUT"] = "CHECKOUT";
  PageType2["POST_PURCHASE_PAGE1"] = "POST_PURCHASE_PAGE1";
  PageType2["POST_PURCHASE_PAGE2"] = "POST_PURCHASE_PAGE2";
  PageType2["THANK_YOU_PAGE"] = "THANK_YOU_PAGE";
  PageType2["ORDER_STATUS_PAGE"] = "ORDER_STATUS_PAGE";
  PageType2["FORM_EDITOR"] = "FORM_EDITOR";
  return PageType2;
})(PageType || {});
var PageTypeOrder = /* @__PURE__ */ ((PageTypeOrder2) => {
  PageTypeOrder2[PageTypeOrder2["PRE_PURCHASE_PRODUCT_PAGE"] = 0] = "PRE_PURCHASE_PRODUCT_PAGE";
  PageTypeOrder2[PageTypeOrder2["PRE_PURCHASE_CART_PAGE"] = 1] = "PRE_PURCHASE_CART_PAGE";
  PageTypeOrder2[PageTypeOrder2["PRE_PURCHASE_CART_DRAWER_PAGE"] = 2] = "PRE_PURCHASE_CART_DRAWER_PAGE";
  PageTypeOrder2[PageTypeOrder2["CHECKOUT"] = 3] = "CHECKOUT";
  PageTypeOrder2[PageTypeOrder2["POST_PURCHASE_PAGE1"] = 4] = "POST_PURCHASE_PAGE1";
  PageTypeOrder2[PageTypeOrder2["POST_PURCHASE_PAGE2"] = 5] = "POST_PURCHASE_PAGE2";
  PageTypeOrder2[PageTypeOrder2["THANK_YOU_PAGE"] = 6] = "THANK_YOU_PAGE";
  PageTypeOrder2[PageTypeOrder2["ORDER_STATUS_PAGE"] = 7] = "ORDER_STATUS_PAGE";
  return PageTypeOrder2;
})(PageTypeOrder || {});
var Platform = /* @__PURE__ */ ((Platform4) => {
  Platform4["SHOPIFY"] = "shopify";
  Platform4["WIX"] = "wix";
  return Platform4;
})(Platform || {});
var PreMadeTemplateType = /* @__PURE__ */ ((PreMadeTemplateType2) => {
  PreMadeTemplateType2["CUSTOM_SLOT"] = "CUSTOM_SLOT";
  PreMadeTemplateType2["DUPLICATE_SLOT"] = "DUPLICATE_SLOT";
  PreMadeTemplateType2["PRODUCT_UPSELL"] = "PRODUCT_UPSELL";
  PreMadeTemplateType2["PRODUCT_RECOMMENDATION"] = "PRODUCT_RECOMMENDATION";
  PreMadeTemplateType2["BUNDLE"] = "BUNDLE";
  PreMadeTemplateType2["BANNER"] = "BANNER";
  PreMadeTemplateType2["ANNOUNCEMENT_BAR"] = "ANNOUNCEMENT_BAR";
  return PreMadeTemplateType2;
})(PreMadeTemplateType || {});
var WidgetType = /* @__PURE__ */ ((WidgetType2) => {
  WidgetType2["MultiProductUpsell"] = "MULTI_PRODUCT_UPSELL";
  WidgetType2["Bundle"] = "BUNDLE";
  WidgetType2["Recommendations"] = "RECOMMENDATIONS";
  WidgetType2["Upsell"] = "UPSELL";
  WidgetType2["Banner"] = "BANNER";
  WidgetType2["Divider"] = "DIVIDER";
  WidgetType2["Timer"] = "TIMER";
  WidgetType2["Text"] = "TEXT";
  WidgetType2["DatePicker"] = "DATE_PICKER";
  WidgetType2["FormWidget"] = "FORM_WIDGET";
  WidgetType2["DiscountTimer"] = "DISCOUNT_TIMER";
  WidgetType2["ThankYouPageBar"] = "THANK_YOU_PAGE_BAR";
  WidgetType2["OrderStatusPageBar"] = "ORDER_STATUS_PAGE_BAR";
  WidgetType2["OnlineStoreBar"] = "ONLINE_STORE_BAR";
  WidgetType2["ImageWidget"] = "IMAGE_WIDGET";
  return WidgetType2;
})(WidgetType || {});

// src/utils/i18n.ts
import i18next from "i18next";
import HttpBackend from "i18next-http-backend";

// src/lang/en.json
var en_default = {
  "An offer was accepted": "An offer was accepted",
  "An offer was declined": "An offer was declined",
  and: "and",
  "Announcement bar": "Announcement bar",
  "Are available at all the sales channels from the list": "Are available at all the sales channels from the list",
  "Are available at one of the sales channels from the list": "Are available at one of the sales channels from the list",
  "Are not available at all the sales channels from the list": "Are not available at all the sales channels from the list",
  "Are not available at one of the sales channels from the list": "Are not available at one of the sales channels from the list",
  "At least one product in the cart": "At least one product in the cart",
  Banner: "Banner",
  Between: "Between",
  Bundle: "Bundle",
  "Cart/Order value": "Cart/Order value",
  categories: "categories",
  category: "category",
  collection: "collection",
  collections: "collections",
  Contains: "Contains",
  "Customer accepted marketing": "Customer accepted marketing",
  "Customer country": "Customer country",
  "customer doesn't have all the tags from the list": "customer doesn't have all the tags from the list",
  "customer doesn't have any of the tags from the list": "customer doesn't have any of the tags from the list",
  "Customer don't accepted marketing": "Customer don't accepted marketing",
  "Customer email": "Customer email",
  "customer has all the tags from the list": "customer has all the tags from the list",
  "customer has at least one of the tags from the list ": "customer has at least one of the tags from the list ",
  "Customer number of orders": "Customer number of orders",
  "Customer segments": "Customer segments",
  "Customer tag": "Customer tag",
  Days: "Days",
  "Discount code": "Discount code",
  "Does not require shipping": "Does not require shipping",
  "Doesn't contain": "Doesn't contain",
  "Doesn't end with": "Doesn't end with",
  "Doesn't have all the tags from the list": "Doesn't have all the tags from the list",
  "Doesn't have some of the tags from the list": "Doesn't have some of the tags from the list",
  "Doesn't start with": "Doesn't start with",
  "Ends with": "Ends with",
  "Equal to": "Equal to",
  "Every product in the cart": "Every product in the cart",
  "Greater than": "Greater than",
  "Greater than or equals to": "Greater than or equals to",
  "Has all the tags from the list": "Has all the tags from the list",
  "Has at least one of the tags from the list": "Has at least one of the tags from the list",
  Hours: "Hours",
  "Is (exact code)": "Is (exact code)",
  "Is (exact email)": "Is (exact email)",
  "Is (exact sku)": "Is (exact sku)",
  "Is (exact title)": "Is (exact title)",
  "Is (exact variant name)": "Is (exact variant name)",
  "Is available at all the sales channels from the list": "Is available at all the sales channels from the list",
  "Is available at all the sales channels in the list": "Is available at all the sales channels in the list",
  "Is available at one of the sales channels from the list": "Is available at one of the sales channels from the list",
  "Is available at one of the sales channels in the list": "Is available at one of the sales channels in the list",
  "Is from a vendor in the list": "Is from a vendor in the list",
  "Is from the list": "Is from the list",
  "Is in a category from the list": "Is in a category from the list",
  "Is in a collection from the list": "Is in a collection from the list",
  "Is not (exact code)": "Is not (exact code)",
  "Is not (exact email)": "Is not (exact email)",
  "Is not (exact sku)": "Is not (exact sku)",
  "Is not (exact title)": "Is not (exact title)",
  "Is not (exact variant name)": "Is not (exact variant name)",
  "Is not available at all the sales channels from the list": "Is not available at all the sales channels from the list",
  "Is not available at all the sales channels in the list": "Is not available at all the sales channels in the list",
  "Is not available at one of the sales channels from the list": "Is not available at one of the sales channels from the list",
  "Is not available at one of the sales channels in the list": "Is not available at one of the sales channels in the list",
  "Is not between": "Is not between",
  "Is not equal to": "Is not equal to",
  "Is not from a vendor in the list": "Is not from a vendor in the list",
  "Is not from the list": "Is not from the list",
  "Is not in a category from the list": "Is not in a category from the list",
  "Is not in a collection from the list": "Is not in a collection from the list",
  "Is not of a type from the list": "Is not of a type from the list",
  "Is not one of the countries from the list": "Is not one of the countries from the list",
  "Is not one of the customer segments from the list": "Is not one of the customer segments from the list",
  "Is not one of the fulfillment statuses in the list": "Is not one of the fulfillment statuses in the list",
  "Is not one of the languages from the list": "Is not one of the languages from the list",
  "Is not one of the methods in the list": "Is not one of the methods in the list",
  "Is not one of the payment statuses in the list": "Is not one of the payment statuses in the list",
  "Is not tagged with all the tags in the list": "Is not tagged with all the tags in the list",
  "Is not tagged with any of the tags in the list": "Is not tagged with any of the tags in the list",
  "Is not tagged with at least one of the tags in the list": "Is not tagged with at least one of the tags in the list",
  "Is of a type from the list": "Is of a type from the list",
  "Is one of the countries from the list": "Is one of the countries from the list",
  "Is one of the customer segments from the list": "Is one of the customer segments from the list",
  "Is one of the fulfillment statuses in the list": "Is one of the fulfillment statuses in the list",
  "Is one of the languages from the list": "Is one of the languages from the list",
  "Is one of the methods in the list": "Is one of the methods in the list",
  "Is one of the payment statuses in the list": "Is one of the payment statuses in the list",
  "Is tagged with all the tags in the list": "Is tagged with all the tags in the list",
  "Is tagged with at least one of the tags in the list": "Is tagged with at least one of the tags in the list",
  "Item cost": "Item cost",
  Language: "Language",
  "Less than": "Less than",
  "Less than or equals to": "Less than or equals to",
  Minutes: "Minutes",
  Months: "Months",
  "Number of orders": "Number of orders",
  "On all of the post purchase pages": "On all of the post purchase pages",
  "On one of the post purchase pages": "On one of the post purchase pages",
  "On the checkout": "On the checkout",
  "On the post purchase 1st page": "On the post purchase 1st page",
  "On the post purchase 2nd page": "On the post purchase 2nd page",
  "On the thank you page": "On the thank you page",
  "Order note": "Order note",
  "Order tags": "Order tags",
  "Payment method": "Payment method",
  "please add cart or order value": "please add cart or order value",
  "please add customer email": "please add customer email",
  "please add customer number of orders": "please add customer number of orders",
  "please add discount code": "please add discount code",
  "please add item cost": "please add item cost",
  "please add number of orders": "please add number of orders",
  "please add order note": "please add order note",
  "please add product price": "please add product price",
  "please add product sku": "please add product sku",
  "please add product title": "please add product title",
  "please add product variant name": "please add product variant name",
  "please add shipping value": "please add shipping value",
  "please add time since last order": "please add time since last order",
  "please add value": "please add value",
  "please select collections": "please select collections",
  "please select customer country": "please select customer country",
  "please select customer language": "please select customer language",
  "please select customer segments": "please select customer segments",
  "please select customer tag": "please select customer tag",
  "please select customer tags": "please select customer tags",
  "please select fulfillment statuses": "please select fulfillment statuses",
  "please select offer": "please select offer",
  "please select payment method": "please select payment method",
  "please select payment statuses": "please select payment statuses",
  "please select product type": "please select product type",
  "please select product vendor": "Please select product vendor",
  "please select products": "please select products",
  "please select sales channel": "please select sales channel",
  "please select shipping methods": "please select shipping methods",
  "please select tags": "please select tags",
  "Previous page offer": "Previous page offer",
  product: "product",
  "Product recommendations": "Product recommendations",
  "Product type": "Product type",
  "Product upsell": "Product upsell",
  products: "products",
  "Requires shipping": "Requires shipping",
  "Shipping method": "Shipping method",
  "Shipping value": "Shipping value",
  "Starts with": "Starts with",
  Status: "Status",
  "The displayed product": "The displayed product",
  "The displayed product SKU": "The displayed product SKU",
  "The only product title in the cart": "The only product title in the cart",
  "The only SKU in the cart": "The only SKU in the cart",
  "The SKU of all products in the cart": "The SKU of all products in the cart",
  "The SKU of at least one product in the cart": "The SKU of at least one product in the cart",
  "The title of all products in the cart": "The title of all products in the cart",
  "The title of at least one product in the cart": "The title of at least one product in the cart",
  "The title of the displayed product": "The title of the displayed product",
  "The variant of all products in the cart": "The variant of all products in the cart",
  "The variant of at least one product in the cart": "The variant of at least one product in the cart",
  "The variant of only product in the cart": "The variant of only product in the cart",
  "The variant of the displayed product": "The variant of the displayed product",
  Weeks: "Weeks",
  Years: "Years"
};

// src/lang/es.json
var es_default = {
  "An offer was accepted": "Se acept\xF3 una oferta",
  "An offer was declined": "Se rechaz\xF3 una oferta",
  and: "y",
  "Announcement bar": "Barra de anuncios",
  "Are available at all the sales channels from the list": "Est\xE1n disponibles en todos los canales de ventas de la lista",
  "Are available at one of the sales channels from the list": "Est\xE1n disponibles en al menos un canal de ventas de la lista",
  "Are not available at all the sales channels from the list": "No est\xE1n disponibles en todos los canales de ventas de la lista",
  "Are not available at one of the sales channels from the list": "No est\xE1n disponibles en ninguno de los canales de ventas de la lista",
  "At least one product in the cart": "Al menos un producto en el carrito",
  Banner: "Banner",
  Between: "Entre",
  Bundle: "Paquete (Bundle)",
  "Cart/Order value": "Valor del carrito/pedido",
  categories: "categor\xEDas",
  category: "categor\xEDa",
  collection: "colecci\xF3n",
  collections: "colecciones",
  Contains: "Contiene",
  "Customer accepted marketing": "El cliente acept\xF3 marketing",
  "Customer birthday": "Cumplea\xF1os del cliente",
  "Customer country": "Pa\xEDs del cliente",
  "customer doesn't have all the tags from the list": "el cliente no tiene todas las etiquetas de la lista",
  "customer doesn't have any of the tags from the list": "el cliente no tiene ninguna de las etiquetas de la lista",
  "Customer don't accepted marketing": "El cliente no acept\xF3 marketing",
  "Customer email": "Email del cliente",
  "customer has all the tags from the list": "el cliente tiene todas las etiquetas de la lista",
  "customer has at least one of the tags from the list ": "el cliente tiene al menos una de las etiquetas de la lista ",
  "Customer number of orders": "N\xFAmero de pedidos del cliente",
  "Customer segments": "Segmentos de clientes",
  "Customer tag": "Etiqueta de cliente",
  Days: "D\xEDas",
  "Discount code": "C\xF3digo de descuento",
  "Does not require shipping": "No requiere env\xEDo",
  "Doesn't contain": "No contiene",
  "Doesn't end with": "No termina con",
  "Doesn't have all the tags from the list": "No tiene todas las etiquetas de la lista",
  "Doesn't have some of the tags from the list": "No tiene alguna de las etiquetas de la lista",
  "Doesn't start with": "No empieza con",
  "Ends with": "Termina con",
  "Equal to": "Igual a",
  Equals: "Es igual a",
  "Every product in the cart": "Cada producto en el carrito",
  "Greater than": "Mayor que",
  "Greater than or equals to": "Mayor o igual que",
  "Has all the tags from the list": "Tiene todas las etiquetas de la lista",
  "Has at least one of the tags from the list": "Tiene al menos una de las etiquetas de la lista",
  Hours: "Horas",
  "in less than": "en menos de",
  "Is (exact code)": "Es (c\xF3digo exacto)",
  "Is (exact email)": "Es (email exacto)",
  "Is (exact sku)": "Es (SKU exacto)",
  "Is (exact title)": "Es (t\xEDtulo exacto)",
  "Is (exact variant name)": "Es (nombre de variante exacto)",
  "Is after": "Es despu\xE9s del",
  "Is available at all the sales channels from the list": "Est\xE1 disponible en todos los canales de ventas de la lista",
  "Is available at all the sales channels in the list": "Est\xE1 disponible en todos los canales de ventas de la lista",
  "Is available at one of the sales channels from the list": "Est\xE1 disponible en al menos un canal de ventas de la lista",
  "Is available at one of the sales channels in the list": "Est\xE1 disponible en uno de los canales de ventas de la lista",
  "Is before": "Es antes del",
  "Is between": "Est\xE1 entre",
  "Is from a vendor in the list": "Es de un proveedor de la lista",
  "Is from the list": "Est\xE1 en la lista",
  "Is greater than": "Es mayor que",
  "Is greater than or equals to": "Es mayor o igual a",
  "Is in a category from the list": "Est\xE1 en una categor\xEDa de la lista",
  "Is in a collection from the list": "Est\xE1 en una colecci\xF3n de la lista",
  "Is less than": "Es menor que",
  "Is less than or equals to": "Es menor o igual a",
  "Is not (exact code)": "No es (c\xF3digo exacto)",
  "Is not (exact email)": "No es (email exacto)",
  "Is not (exact sku)": "No es (SKU exacto)",
  "Is not (exact title)": "No es (t\xEDtulo exacto)",
  "Is not (exact variant name)": "No es (nombre de variante exacto)",
  "Is not available at all the sales channels from the list": "No est\xE1 disponible en todos los canales de ventas de la lista",
  "Is not available at all the sales channels in the list": "No est\xE1 disponible en todos los canales de ventas de la lista",
  "Is not available at one of the sales channels from the list": "No est\xE1 disponible en ninguno de los canales de ventas de la lista",
  "Is not available at one of the sales channels in the list": "No est\xE1 disponible en ninguno de los canales de ventas de la lista",
  "Is not between": "No est\xE1 entre",
  "Is not equal to": "No es igual a",
  "Is not from a vendor in the list": "No es de un proveedor de la lista",
  "Is not from the list": "No est\xE1 en la lista",
  "Is not in a category from the list": "No est\xE1 en una categor\xEDa de la lista",
  "Is not in a collection from the list": "No est\xE1 en una colecci\xF3n de la lista",
  "Is not of a type from the list": "No es de un tipo de la lista",
  "Is not on": "No es el",
  "Is not one of the countries from the list": "No es uno de los pa\xEDses de la lista",
  "Is not one of the customer segments from the list": "No es uno de los segmentos de clientes de la lista",
  "Is not one of the fulfillment statuses in the list": "No es uno de los estados de cumplimiento de la lista",
  "Is not one of the languages from the list": "No es uno de los idiomas de la lista",
  "Is not one of the methods in the list": "No es uno de los m\xE9todos de la lista",
  "Is not one of the payment statuses in the list": "No es uno de los estados de pago de la lista",
  "Is not tagged with all the tags in the list": "No est\xE1 etiquetado con todas las etiquetas de la lista",
  "Is not tagged with any of the tags in the list": "No est\xE1 etiquetado con ninguna de las etiquetas de la lista",
  "Is not tagged with at least one of the tags in the list": "No est\xE1 etiquetado con al menos una de las etiquetas de la lista",
  "Is of a type from the list": "Es de un tipo de la lista",
  "Is on": "Es el",
  "Is one of the countries from the list": "Es uno de los pa\xEDses de la lista",
  "Is one of the customer segments from the list": "Es uno de los segmentos de clientes de la lista",
  "Is one of the fulfillment statuses in the list": "Es uno de los estados de cumplimiento de la lista",
  "Is one of the languages from the list": "Es uno de los idiomas de la lista",
  "Is one of the methods in the list": "Es uno de los m\xE9todos de la lista",
  "Is one of the payment statuses in the list": "Es uno de los estados de pago de la lista",
  "Is tagged with all the tags in the list": "Est\xE1 etiquetado con todas las etiquetas de la lista",
  "Is tagged with at least one of the tags in the list": "Est\xE1 etiquetado con al menos una de las etiquetas de la lista",
  "Item cost": "Costo del art\xEDculo",
  Language: "Idioma",
  "Less than": "Menor que",
  "Less than or equals to": "Menor o igual que",
  "Marketing consent": "Consentimiento de marketing",
  Minutes: "Minutos",
  Months: "Meses",
  "Number of orders": "N\xFAmero de pedidos",
  "On all of the post purchase pages": "En todas las p\xE1ginas post-compra",
  "On one of the post purchase pages": "En una de las p\xE1ginas post-compra",
  "On the checkout": "En la p\xE1gina de pago",
  "On the post purchase 1st page": "En la 1\xAA p\xE1gina post-compra",
  "On the post purchase 2nd page": "En la 2\xAA p\xE1gina post-compra",
  "On the thank you page": "En la p\xE1gina de agradecimiento",
  "Order note": "Nota del pedido",
  "Order tags": "Etiquetas del pedido",
  "Passed X time ago": "Pas\xF3 hace X",
  "Payment method": "M\xE9todo de pago",
  "please add cart or order value": "por favor, a\xF1ade el valor del carrito o del pedido",
  "please add customer email": "por favor, a\xF1ade el email del cliente",
  "please add customer number of orders": "por favor, a\xF1ade el n\xFAmero de pedidos del cliente",
  "please add discount code": "por favor, a\xF1ade un c\xF3digo de descuento",
  "please add item cost": "por favor, a\xF1ade el costo del art\xEDculo",
  "please add number of orders": "Por favor, a\xF1ada el n\xFAmero de pedidos",
  "please add order note": "por favor, a\xF1ade la nota del pedido",
  "please add product price": "Por favor, a\xF1ada el precio del producto",
  "please add product sku": "por favor, a\xF1ade el SKU del producto",
  "please add product title": "por favor, a\xF1ade el t\xEDtulo del producto",
  "please add product variant name": "por favor, a\xF1ade el nombre de la variante del producto",
  "please add shipping value": "por favor, a\xF1ade el valor de env\xEDo",
  "please add time since last order": "Por favor, a\xF1ade el tiempo desde el \xFAltimo pedido",
  "please add total item count": "Por favor, a\xF1ada el recuento total de art\xEDculos",
  "please add value": "por favor, a\xF1ade un valor",
  "please select collections": "por favor, selecciona colecciones",
  "please select customer birthday": "Por favor, selecciona el cumplea\xF1os del cliente",
  "please select customer country": "por favor, selecciona el pa\xEDs del cliente",
  "please select customer language": "por favor, selecciona el idioma del cliente",
  "please select customer segments": "por favor, selecciona segmentos de clientes",
  "please select customer tag": "por favor, selecciona la etiqueta del cliente",
  "please select customer tags": "Por favor, selecciona etiquetas de cliente",
  "please select fulfillment statuses": "por favor, selecciona los estados de cumplimiento",
  "please select offer": "por favor, selecciona una oferta",
  "please select payment method": "Por favor, seleccione el m\xE9todo de pago",
  "please select payment statuses": "Por favor, seleccione los estados de pago",
  "please select product type": "Por favor, seleccione el tipo de producto",
  "please select product vendor": "Por favor, seleccione el proveedor del producto",
  "please select products": "por favor, selecciona productos",
  "please select sales channel": "por favor, selecciona un canal de ventas",
  "please select shipping methods": "por favor, selecciona m\xE9todos de env\xEDo",
  "please select tags": "por favor, selecciona etiquetas",
  "Previous page offer": "Oferta de la p\xE1gina anterior",
  product: "producto",
  "Product recommendations": "Recomendaciones de productos",
  "Product type": "Tipo de producto",
  "Product upsell": "Venta adicional de producto",
  products: "productos",
  "Requires shipping": "Requiere env\xEDo",
  "Shipping method": "M\xE9todo de env\xEDo",
  "Shipping value": "Valor de env\xEDo",
  "Starts with": "Empieza con",
  Status: "Estado",
  "The displayed product": "El producto mostrado",
  "The displayed product SKU": "El SKU del producto mostrado",
  "The only product title in the cart": "El \xFAnico t\xEDtulo de producto en el carrito",
  "The only SKU in the cart": "El \xFAnico SKU en el carrito",
  "The SKU of all products in the cart": "El SKU de todos los productos en el carrito",
  "The SKU of at least one product in the cart": "El SKU de al menos un producto en el carrito",
  "The title of all products in the cart": "El t\xEDtulo de todos los productos en el carrito",
  "The title of at least one product in the cart": "El t\xEDtulo de al menos un producto en el carrito",
  "The title of the displayed product": "El t\xEDtulo del producto mostrado",
  "The variant of all products in the cart": "La variante de todos los productos en el carrito",
  "The variant of at least one product in the cart": "La variante de al menos un producto en el carrito",
  "The variant of only product in the cart": "La variante del \xFAnico producto en el carrito",
  "The variant of the displayed product": "La variante del producto mostrado",
  "Total item count": "Recuento total de art\xEDculos",
  Weeks: "Semanas",
  Years: "A\xF1os"
};

// src/lang/he_IL.json
var he_IL_default = {
  "An offer was accepted": "\u05D4\u05E6\u05E2\u05D4 \u05D4\u05EA\u05E7\u05D1\u05DC\u05D4",
  "An offer was declined": "\u05D4\u05E6\u05E2\u05D4 \u05E0\u05D3\u05D7\u05EA\u05D4",
  and: "\u05D5\u05D2\u05DD",
  "Announcement bar": "\u05E1\u05E8\u05D2\u05DC \u05D4\u05DB\u05E8\u05D6\u05D5\u05EA",
  "Are available at all the sales channels from the list": "\u05D6\u05DE\u05D9\u05E0\u05D9\u05DD \u05D1\u05DB\u05DC \u05E2\u05E8\u05D5\u05E6\u05D9 \u05D4\u05DE\u05DB\u05D9\u05E8\u05D4 \u05E9\u05D1\u05E8\u05E9\u05D9\u05DE\u05D4",
  "Are available at one of the sales channels from the list": "\u05D6\u05DE\u05D9\u05E0\u05D9\u05DD \u05D1\u05DC\u05E4\u05D7\u05D5\u05EA \u05D0\u05D7\u05D3 \u05DE\u05E2\u05E8\u05D5\u05E6\u05D9 \u05D4\u05DE\u05DB\u05D9\u05E8\u05D4 \u05E9\u05D1\u05E8\u05E9\u05D9\u05DE\u05D4",
  "Are not available at all the sales channels from the list": "\u05DC\u05D0 \u05D6\u05DE\u05D9\u05E0\u05D9\u05DD \u05D1\u05DB\u05DC \u05E2\u05E8\u05D5\u05E6\u05D9 \u05D4\u05DE\u05DB\u05D9\u05E8\u05D4 \u05E9\u05D1\u05E8\u05E9\u05D9\u05DE\u05D4",
  "Are not available at one of the sales channels from the list": "\u05DC\u05D0 \u05D6\u05DE\u05D9\u05E0\u05D9\u05DD \u05D1\u05D0\u05E3 \u05D0\u05D7\u05D3 \u05DE\u05E2\u05E8\u05D5\u05E6\u05D9 \u05D4\u05DE\u05DB\u05D9\u05E8\u05D4 \u05E9\u05D1\u05E8\u05E9\u05D9\u05DE\u05D4",
  "At least one product in the cart": "\u05DC\u05E4\u05D7\u05D5\u05EA \u05DE\u05D5\u05E6\u05E8 \u05D0\u05D7\u05D3 \u05D1\u05E2\u05D2\u05DC\u05D4",
  Banner: "\u05D1\u05D0\u05E0\u05E8",
  Between: "\u05D1\u05D9\u05DF",
  Bundle: "\u05D1\u05D0\u05E0\u05D3\u05DC",
  "Cart/Order value": "\u05E2\u05E8\u05DA \u05E2\u05D2\u05DC\u05D4/\u05D4\u05D6\u05DE\u05E0\u05D4",
  categories: "\u05E7\u05D8\u05D2\u05D5\u05E8\u05D9\u05D5\u05EA",
  category: "\u05E7\u05D8\u05D2\u05D5\u05E8\u05D9\u05D4",
  collection: "\u05E7\u05D5\u05DC\u05E7\u05E6\u05D9\u05D4",
  collections: "\u05E7\u05D5\u05DC\u05E7\u05E6\u05D9\u05D5\u05EA",
  Contains: "\u05DE\u05DB\u05D9\u05DC",
  "Customer accepted marketing": "\u05D4\u05DC\u05E7\u05D5\u05D7 \u05D0\u05D9\u05E9\u05E8 \u05E9\u05D9\u05D5\u05D5\u05E7",
  "Customer birthday": "\u05D9\u05D5\u05DD \u05D4\u05D5\u05DC\u05D3\u05EA \u05E9\u05DC \u05DC\u05E7\u05D5\u05D7",
  "Customer country": "\u05DE\u05D3\u05D9\u05E0\u05EA \u05D4\u05DC\u05E7\u05D5\u05D7",
  "customer doesn't have all the tags from the list": "\u05DC\u05DC\u05E7\u05D5\u05D7 \u05D0\u05D9\u05DF \u05D0\u05EA \u05DB\u05DC \u05D4\u05EA\u05D2\u05D9\u05D5\u05EA \u05DE\u05D4\u05E8\u05E9\u05D9\u05DE\u05D4",
  "customer doesn't have any of the tags from the list": "\u05DC\u05DC\u05E7\u05D5\u05D7 \u05D0\u05D9\u05DF \u05D0\u05E3 \u05EA\u05D2\u05D9\u05EA \u05DE\u05D4\u05E8\u05E9\u05D9\u05DE\u05D4",
  "Customer don't accepted marketing": "\u05D4\u05DC\u05E7\u05D5\u05D7 \u05DC\u05D0 \u05D0\u05D9\u05E9\u05E8 \u05E9\u05D9\u05D5\u05D5\u05E7",
  "Customer email": "\u05D0\u05D9\u05DE\u05D9\u05D9\u05DC \u05D4\u05DC\u05E7\u05D5\u05D7",
  "customer has all the tags from the list": "\u05DC\u05DC\u05E7\u05D5\u05D7 \u05D9\u05E9 \u05D0\u05EA \u05DB\u05DC \u05D4\u05EA\u05D2\u05D9\u05D5\u05EA \u05DE\u05D4\u05E8\u05E9\u05D9\u05DE\u05D4",
  "customer has at least one of the tags from the list ": "\u05DC\u05DC\u05E7\u05D5\u05D7 \u05D9\u05E9 \u05DC\u05E4\u05D7\u05D5\u05EA \u05EA\u05D2\u05D9\u05EA \u05D0\u05D7\u05EA \u05DE\u05D4\u05E8\u05E9\u05D9\u05DE\u05D4 ",
  "Customer number of orders": "\u05DE\u05E1\u05E4\u05E8 \u05D4\u05D4\u05D6\u05DE\u05E0\u05D5\u05EA \u05E9\u05DC \u05D4\u05DC\u05E7\u05D5\u05D7",
  "Customer segments": "\u05E4\u05DC\u05D7\u05D9 \u05DC\u05E7\u05D5\u05D7\u05D5\u05EA",
  "Customer tag": "\u05EA\u05D2\u05D9\u05EA \u05DC\u05E7\u05D5\u05D7",
  Days: "\u05D9\u05DE\u05D9\u05DD",
  "Discount code": "\u05E7\u05D5\u05D3 \u05D4\u05E0\u05D7\u05D4",
  "Does not require shipping": "\u05DC\u05D0 \u05D3\u05D5\u05E8\u05E9 \u05DE\u05E9\u05DC\u05D5\u05D7",
  "Doesn't contain": "\u05DC\u05D0 \u05DE\u05DB\u05D9\u05DC",
  "Doesn't end with": "\u05DC\u05D0 \u05DE\u05E1\u05EA\u05D9\u05D9\u05DD \u05D1-",
  "Doesn't have all the tags from the list": "\u05D0\u05D9\u05E0\u05D5 \u05DE\u05DB\u05D9\u05DC \u05D0\u05EA \u05DB\u05DC \u05D4\u05EA\u05D2\u05D9\u05D5\u05EA \u05DE\u05D4\u05E8\u05E9\u05D9\u05DE\u05D4",
  "Doesn't have some of the tags from the list": "\u05D0\u05D9\u05E0\u05D5 \u05DE\u05DB\u05D9\u05DC \u05D0\u05E3 \u05EA\u05D2\u05D9\u05EA \u05DE\u05D4\u05E8\u05E9\u05D9\u05DE\u05D4",
  "Doesn't start with": "\u05DC\u05D0 \u05DE\u05EA\u05D7\u05D9\u05DC \u05D1-",
  "Ends with": "\u05DE\u05E1\u05EA\u05D9\u05D9\u05DD \u05D1-",
  "Equal to": "\u05E9\u05D5\u05D5\u05D4 \u05DC",
  Equals: "\u05E9\u05D5\u05D5\u05D4 \u05DC",
  "Every product in the cart": "\u05DB\u05DC \u05DE\u05D5\u05E6\u05E8 \u05D1\u05E2\u05D2\u05DC\u05D4",
  "Greater than": "\u05D2\u05D3\u05D5\u05DC \u05DE",
  "Greater than or equals to": "\u05D2\u05D3\u05D5\u05DC \u05D0\u05D5 \u05E9\u05D5\u05D5\u05D4 \u05DC",
  "Has all the tags from the list": "\u05D1\u05E2\u05DC \u05DB\u05DC \u05D4\u05EA\u05D2\u05D9\u05D5\u05EA \u05DE\u05D4\u05E8\u05E9\u05D9\u05DE\u05D4",
  "Has at least one of the tags from the list": "\u05D1\u05E2\u05DC \u05EA\u05D2\u05D9\u05EA \u05D0\u05D7\u05EA \u05DC\u05E4\u05D7\u05D5\u05EA \u05DE\u05D4\u05E8\u05E9\u05D9\u05DE\u05D4",
  Hours: "\u05E9\u05E2\u05D5\u05EA",
  "in less than": "\u05D1\u05EA\u05D5\u05DA \u05E4\u05D7\u05D5\u05EA \u05DE-",
  "Is (exact code)": "\u05D4\u05D5\u05D0 (\u05E7\u05D5\u05D3 \u05DE\u05D3\u05D5\u05D9\u05E7)",
  "Is (exact email)": "\u05D4\u05D5\u05D0 (\u05D0\u05D9\u05DE\u05D9\u05D9\u05DC \u05DE\u05D3\u05D5\u05D9\u05E7)",
  "Is (exact sku)": "\u05D4\u05D5\u05D0 (\u05DE\u05E7\u05F4\u05D8 \u05DE\u05D3\u05D5\u05D9\u05E7)",
  "Is (exact title)": "\u05D4\u05D9\u05D0 (\u05DB\u05D5\u05EA\u05E8\u05EA \u05DE\u05D3\u05D5\u05D9\u05E7\u05EA)",
  "Is (exact variant name)": "\u05D4\u05D5\u05D0 (\u05E9\u05DD \u05D5\u05E8\u05D9\u05D0\u05E0\u05D8 \u05DE\u05D3\u05D5\u05D9\u05E7)",
  "Is after": "\u05D4\u05D5\u05D0 \u05D0\u05D7\u05E8\u05D9",
  "Is available at all the sales channels from the list": "\u05D6\u05DE\u05D9\u05DF \u05D1\u05DB\u05DC \u05E2\u05E8\u05D5\u05E6\u05D9 \u05D4\u05DE\u05DB\u05D9\u05E8\u05D4 \u05E9\u05D1\u05E8\u05E9\u05D9\u05DE\u05D4",
  "Is available at all the sales channels in the list": "\u05D6\u05DE\u05D9\u05DF \u05D1\u05DB\u05DC \u05E2\u05E8\u05D5\u05E6\u05D9 \u05D4\u05DE\u05DB\u05D9\u05E8\u05D4 \u05D1\u05E8\u05E9\u05D9\u05DE\u05D4",
  "Is available at one of the sales channels from the list": "\u05D6\u05DE\u05D9\u05DF \u05DC\u05E4\u05D7\u05D5\u05EA \u05D1\u05D0\u05D7\u05D3 \u05DE\u05E2\u05E8\u05D5\u05E6\u05D9 \u05D4\u05DE\u05DB\u05D9\u05E8\u05D4 \u05E9\u05D1\u05E8\u05E9\u05D9\u05DE\u05D4",
  "Is available at one of the sales channels in the list": "\u05D6\u05DE\u05D9\u05DF \u05D1\u05D0\u05D7\u05D3 \u05DE\u05E2\u05E8\u05D5\u05E6\u05D9 \u05D4\u05DE\u05DB\u05D9\u05E8\u05D4 \u05D1\u05E8\u05E9\u05D9\u05DE\u05D4",
  "Is before": "\u05D4\u05D5\u05D0 \u05DC\u05E4\u05E0\u05D9",
  "Is between": "\u05E0\u05DE\u05E6\u05D0 \u05D1\u05D9\u05DF",
  "Is from a vendor in the list": "\u05D4\u05D5\u05D0 \u05DE\u05E1\u05E4\u05E7 \u05D4\u05DE\u05D5\u05E4\u05D9\u05E2 \u05D1\u05E8\u05E9\u05D9\u05DE\u05D4",
  "Is from the list": "\u05E0\u05DE\u05E6\u05D0 \u05D1\u05E8\u05E9\u05D9\u05DE\u05D4",
  "Is greater than": "\u05D2\u05D3\u05D5\u05DC \u05DE",
  "Is greater than or equals to": "\u05D2\u05D3\u05D5\u05DC \u05D0\u05D5 \u05E9\u05D5\u05D5\u05D4 \u05DC",
  "Is in a category from the list": "\u05E0\u05DE\u05E6\u05D0 \u05D1\u05E7\u05D8\u05D2\u05D5\u05E8\u05D9\u05D4 \u05DE\u05D4\u05E8\u05E9\u05D9\u05DE\u05D4",
  "Is in a collection from the list": "\u05E0\u05DE\u05E6\u05D0 \u05D1\u05E7\u05D5\u05DC\u05E7\u05E6\u05D9\u05D4 \u05DE\u05D4\u05E8\u05E9\u05D9\u05DE\u05D4",
  "Is less than": "\u05E7\u05D8\u05DF \u05DE",
  "Is less than or equals to": "\u05E7\u05D8\u05DF \u05D0\u05D5 \u05E9\u05D5\u05D5\u05D4 \u05DC",
  "Is not (exact code)": "\u05D0\u05D9\u05E0\u05D5 (\u05E7\u05D5\u05D3 \u05DE\u05D3\u05D5\u05D9\u05E7)",
  "Is not (exact email)": "\u05D0\u05D9\u05E0\u05D5 (\u05D0\u05D9\u05DE\u05D9\u05D9\u05DC \u05DE\u05D3\u05D5\u05D9\u05E7)",
  "Is not (exact sku)": "\u05D0\u05D9\u05E0\u05D5 (\u05DE\u05E7\u05F4\u05D8 \u05DE\u05D3\u05D5\u05D9\u05E7)",
  "Is not (exact title)": "\u05D0\u05D9\u05E0\u05D4 (\u05DB\u05D5\u05EA\u05E8\u05EA \u05DE\u05D3\u05D5\u05D9\u05E7\u05EA)",
  "Is not (exact variant name)": "\u05D0\u05D9\u05E0\u05D5 (\u05E9\u05DD \u05D5\u05E8\u05D9\u05D0\u05E0\u05D8 \u05DE\u05D3\u05D5\u05D9\u05E7)",
  "Is not available at all the sales channels from the list": "\u05DC\u05D0 \u05D6\u05DE\u05D9\u05DF \u05D1\u05DB\u05DC \u05E2\u05E8\u05D5\u05E6\u05D9 \u05D4\u05DE\u05DB\u05D9\u05E8\u05D4 \u05E9\u05D1\u05E8\u05E9\u05D9\u05DE\u05D4",
  "Is not available at all the sales channels in the list": "\u05DC\u05D0 \u05D6\u05DE\u05D9\u05DF \u05D1\u05DB\u05DC \u05E2\u05E8\u05D5\u05E6\u05D9 \u05D4\u05DE\u05DB\u05D9\u05E8\u05D4 \u05D1\u05E8\u05E9\u05D9\u05DE\u05D4",
  "Is not available at one of the sales channels from the list": "\u05DC\u05D0 \u05D6\u05DE\u05D9\u05DF \u05D1\u05D0\u05E3 \u05D0\u05D7\u05D3 \u05DE\u05E2\u05E8\u05D5\u05E6\u05D9 \u05D4\u05DE\u05DB\u05D9\u05E8\u05D4 \u05E9\u05D1\u05E8\u05E9\u05D9\u05DE\u05D4",
  "Is not available at one of the sales channels in the list": "\u05DC\u05D0 \u05D6\u05DE\u05D9\u05DF \u05D1\u05D0\u05E3 \u05D0\u05D7\u05D3 \u05DE\u05E2\u05E8\u05D5\u05E6\u05D9 \u05D4\u05DE\u05DB\u05D9\u05E8\u05D4 \u05D1\u05E8\u05E9\u05D9\u05DE\u05D4",
  "Is not between": "\u05DC\u05D0 \u05D1\u05D9\u05DF",
  "Is not equal to": "\u05DC\u05D0 \u05E9\u05D5\u05D5\u05D4 \u05DC",
  "Is not from a vendor in the list": "\u05D0\u05D9\u05E0\u05D5 \u05DE\u05E1\u05E4\u05E7 \u05D4\u05DE\u05D5\u05E4\u05D9\u05E2 \u05D1\u05E8\u05E9\u05D9\u05DE\u05D4",
  "Is not from the list": "\u05DC\u05D0 \u05E0\u05DE\u05E6\u05D0 \u05D1\u05E8\u05E9\u05D9\u05DE\u05D4",
  "Is not in a category from the list": "\u05DC\u05D0 \u05E0\u05DE\u05E6\u05D0 \u05D1\u05E7\u05D8\u05D2\u05D5\u05E8\u05D9\u05D4 \u05DE\u05D4\u05E8\u05E9\u05D9\u05DE\u05D4",
  "Is not in a collection from the list": "\u05DC\u05D0 \u05E0\u05DE\u05E6\u05D0 \u05D1\u05E7\u05D5\u05DC\u05E7\u05E6\u05D9\u05D4 \u05DE\u05D4\u05E8\u05E9\u05D9\u05DE\u05D4",
  "Is not of a type from the list": "\u05D0\u05D9\u05E0\u05D5 \u05DE\u05E1\u05D5\u05D2 \u05D4\u05DE\u05D5\u05E4\u05D9\u05E2 \u05D1\u05E8\u05E9\u05D9\u05DE\u05D4",
  "Is not on": "\u05D0\u05D9\u05E0\u05D5 \u05D1-",
  "Is not one of the countries from the list": "\u05DC\u05D0 \u05D0\u05D7\u05EA \u05DE\u05D4\u05DE\u05D3\u05D9\u05E0\u05D5\u05EA \u05D1\u05E8\u05E9\u05D9\u05DE\u05D4",
  "Is not one of the customer segments from the list": "\u05DC\u05D0 \u05D0\u05D7\u05D3 \u05DE\u05E4\u05DC\u05D7\u05D9 \u05D4\u05DC\u05E7\u05D5\u05D7\u05D5\u05EA \u05D1\u05E8\u05E9\u05D9\u05DE\u05D4",
  "Is not one of the fulfillment statuses in the list": "\u05DC\u05D0 \u05D0\u05D7\u05D3 \u05DE\u05DE\u05E6\u05D1\u05D9 \u05D4\u05D1\u05D9\u05E6\u05D5\u05E2 \u05D1\u05E8\u05E9\u05D9\u05DE\u05D4",
  "Is not one of the languages from the list": "\u05DC\u05D0 \u05D0\u05D7\u05EA \u05DE\u05D4\u05E9\u05E4\u05D5\u05EA \u05D1\u05E8\u05E9\u05D9\u05DE\u05D4",
  "Is not one of the methods in the list": "\u05DC\u05D0 \u05E0\u05DE\u05E6\u05D0 \u05D1\u05E8\u05E9\u05D9\u05DE\u05EA \u05D4\u05E9\u05D9\u05D8\u05D5\u05EA",
  "Is not one of the payment statuses in the list": "\u05DC\u05D0 \u05D0\u05D7\u05D3 \u05DE\u05DE\u05E6\u05D1\u05D9 \u05D4\u05EA\u05E9\u05DC\u05D5\u05DD \u05D1\u05E8\u05E9\u05D9\u05DE\u05D4",
  "Is not tagged with all the tags in the list": "\u05D0\u05D9\u05E0\u05D5 \u05DE\u05EA\u05D5\u05D9\u05D2 \u05E2\u05DD \u05DB\u05DC \u05D4\u05EA\u05D2\u05D9\u05D5\u05EA \u05D1\u05E8\u05E9\u05D9\u05DE\u05D4",
  "Is not tagged with any of the tags in the list": "\u05DC\u05D0 \u05DE\u05EA\u05D5\u05D9\u05D2 \u05D1\u05D0\u05E3 \u05D0\u05D7\u05D3 \u05DE\u05D4\u05EA\u05D2\u05D9\u05D5\u05EA \u05D1\u05E8\u05E9\u05D9\u05DE\u05D4",
  "Is not tagged with at least one of the tags in the list": "\u05D0\u05D9\u05E0\u05D5 \u05DE\u05EA\u05D5\u05D9\u05D2 \u05E2\u05DD \u05DC\u05E4\u05D7\u05D5\u05EA \u05D0\u05D7\u05EA \u05DE\u05D4\u05EA\u05D2\u05D9\u05D5\u05EA \u05D1\u05E8\u05E9\u05D9\u05DE\u05D4",
  "Is of a type from the list": "\u05D4\u05D5\u05D0 \u05DE\u05E1\u05D5\u05D2 \u05D4\u05DE\u05D5\u05E4\u05D9\u05E2 \u05D1\u05E8\u05E9\u05D9\u05DE\u05D4",
  "Is on": "\u05D4\u05D5\u05D0 \u05D1-",
  "Is one of the countries from the list": "\u05D0\u05D7\u05EA \u05DE\u05D4\u05DE\u05D3\u05D9\u05E0\u05D5\u05EA \u05D1\u05E8\u05E9\u05D9\u05DE\u05D4",
  "Is one of the customer segments from the list": "\u05D0\u05D7\u05D3 \u05DE\u05E4\u05DC\u05D7\u05D9 \u05D4\u05DC\u05E7\u05D5\u05D7\u05D5\u05EA \u05D1\u05E8\u05E9\u05D9\u05DE\u05D4",
  "Is one of the fulfillment statuses in the list": "\u05D0\u05D7\u05D3 \u05DE\u05DE\u05E6\u05D1\u05D9 \u05D4\u05D1\u05D9\u05E6\u05D5\u05E2 \u05D1\u05E8\u05E9\u05D9\u05DE\u05D4",
  "Is one of the languages from the list": "\u05D0\u05D7\u05EA \u05DE\u05D4\u05E9\u05E4\u05D5\u05EA \u05D1\u05E8\u05E9\u05D9\u05DE\u05D4",
  "Is one of the methods in the list": "\u05E0\u05DE\u05E6\u05D0 \u05D1\u05E8\u05E9\u05D9\u05DE\u05EA \u05D4\u05E9\u05D9\u05D8\u05D5\u05EA",
  "Is one of the payment statuses in the list": "\u05D0\u05D7\u05D3 \u05DE\u05DE\u05E6\u05D1\u05D9 \u05D4\u05EA\u05E9\u05DC\u05D5\u05DD \u05D1\u05E8\u05E9\u05D9\u05DE\u05D4",
  "Is tagged with all the tags in the list": "\u05DE\u05EA\u05D5\u05D9\u05D2 \u05D1\u05DB\u05DC \u05D4\u05EA\u05D2\u05D9\u05D5\u05EA \u05D1\u05E8\u05E9\u05D9\u05DE\u05D4",
  "Is tagged with at least one of the tags in the list": "\u05DE\u05EA\u05D5\u05D9\u05D2 \u05DC\u05E4\u05D7\u05D5\u05EA \u05D1\u05D0\u05D7\u05EA \u05DE\u05D4\u05EA\u05D2\u05D9\u05D5\u05EA \u05D1\u05E8\u05E9\u05D9\u05DE\u05D4",
  "Item cost": "\u05E2\u05DC\u05D5\u05EA \u05E4\u05E8\u05D9\u05D8",
  Language: "\u05E9\u05E4\u05D4",
  "Less than": "\u05E7\u05D8\u05DF \u05DE",
  "Less than or equals to": "\u05E7\u05D8\u05DF \u05D0\u05D5 \u05E9\u05D5\u05D5\u05D4 \u05DC",
  "Marketing consent": "\u05D4\u05E1\u05DB\u05DE\u05D4 \u05DC\u05E9\u05D9\u05D5\u05D5\u05E7",
  Minutes: "\u05D3\u05E7\u05D5\u05EA",
  Months: "\u05D7\u05D5\u05D3\u05E9\u05D9\u05DD",
  "Number of orders": "\u05DE\u05E1\u05E4\u05E8 \u05D4\u05D6\u05DE\u05E0\u05D5\u05EA",
  "On all of the post purchase pages": "\u05D1\u05DB\u05DC \u05D4\u05E2\u05DE\u05D5\u05D3\u05D9\u05DD \u05E9\u05DC\u05D0\u05D7\u05E8 \u05D4\u05E8\u05DB\u05D9\u05E9\u05D4",
  "On one of the post purchase pages": "\u05D1\u05D0\u05D7\u05D3 \u05DE\u05D4\u05E2\u05DE\u05D5\u05D3\u05D9\u05DD \u05E9\u05DC\u05D0\u05D7\u05E8 \u05D4\u05E8\u05DB\u05D9\u05E9\u05D4",
  "On the checkout": "\u05D1\u05E2\u05DE\u05D5\u05D3 \u05D4\u05EA\u05E9\u05DC\u05D5\u05DD",
  "On the post purchase 1st page": "\u05D1\u05E2\u05DE\u05D5\u05D3 \u05D4\u05E8\u05D0\u05E9\u05D5\u05DF \u05E9\u05DC\u05D0\u05D7\u05E8 \u05D4\u05E8\u05DB\u05D9\u05E9\u05D4",
  "On the post purchase 2nd page": "\u05D1\u05E2\u05DE\u05D5\u05D3 \u05D4\u05E9\u05E0\u05D9 \u05E9\u05DC\u05D0\u05D7\u05E8 \u05D4\u05E8\u05DB\u05D9\u05E9\u05D4",
  "On the thank you page": "\u05D1\u05E2\u05DE\u05D5\u05D3 \u05D4\u05EA\u05D5\u05D3\u05D4",
  "Order note": "\u05D4\u05E2\u05E8\u05EA \u05D4\u05D6\u05DE\u05E0\u05D4",
  "Order tags": "\u05EA\u05D2\u05D9\u05D5\u05EA \u05D4\u05D6\u05DE\u05E0\u05D4",
  "Passed X time ago": "\u05E2\u05D1\u05E8 \u05DC\u05E4\u05E0\u05D9 X",
  "Payment method": "\u05E9\u05D9\u05D8\u05EA \u05EA\u05E9\u05DC\u05D5\u05DD",
  "please add cart or order value": "\u05E0\u05D0 \u05DC\u05D4\u05D5\u05E1\u05D9\u05E3 \u05E2\u05E8\u05DA \u05E2\u05D2\u05DC\u05D4 \u05D0\u05D5 \u05D4\u05D6\u05DE\u05E0\u05D4",
  "please add customer email": "\u05E0\u05D0 \u05DC\u05D4\u05D5\u05E1\u05D9\u05E3 \u05D0\u05D9\u05DE\u05D9\u05D9\u05DC \u05DC\u05E7\u05D5\u05D7",
  "please add customer number of orders": "\u05E0\u05D0 \u05DC\u05D4\u05D5\u05E1\u05D9\u05E3 \u05DE\u05E1\u05E4\u05E8 \u05D4\u05D6\u05DE\u05E0\u05D5\u05EA \u05E9\u05DC \u05D4\u05DC\u05E7\u05D5\u05D7",
  "please add discount code": "\u05E0\u05D0 \u05DC\u05D4\u05D5\u05E1\u05D9\u05E3 \u05E7\u05D5\u05D3 \u05D4\u05E0\u05D7\u05D4",
  "please add item cost": "\u05E0\u05D0 \u05DC\u05D4\u05D5\u05E1\u05D9\u05E3 \u05E2\u05DC\u05D5\u05EA \u05E4\u05E8\u05D9\u05D8",
  "please add number of orders": "\u05D0\u05E0\u05D0 \u05D4\u05D5\u05E1\u05E3 \u05DE\u05E1\u05E4\u05E8 \u05D4\u05D6\u05DE\u05E0\u05D5\u05EA",
  "please add order note": "\u05E0\u05D0 \u05DC\u05D4\u05D5\u05E1\u05D9\u05E3 \u05D4\u05E2\u05E8\u05EA \u05D4\u05D6\u05DE\u05E0\u05D4",
  "please add product price": "\u05D0\u05E0\u05D0 \u05D4\u05D5\u05E1\u05E3 \u05DE\u05D7\u05D9\u05E8 \u05DE\u05D5\u05E6\u05E8",
  "please add product sku": "\u05E0\u05D0 \u05DC\u05D4\u05D5\u05E1\u05D9\u05E3 \u05DE\u05E7\u05F4\u05D8 \u05DE\u05D5\u05E6\u05E8",
  "please add product title": "\u05E0\u05D0 \u05DC\u05D4\u05D5\u05E1\u05D9\u05E3 \u05DB\u05D5\u05EA\u05E8\u05EA \u05DE\u05D5\u05E6\u05E8",
  "please add product variant name": "\u05E0\u05D0 \u05DC\u05D4\u05D5\u05E1\u05D9\u05E3 \u05E9\u05DD \u05D5\u05E8\u05D9\u05D0\u05E0\u05D8 \u05E9\u05DC \u05D4\u05DE\u05D5\u05E6\u05E8",
  "please add shipping value": "\u05E0\u05D0 \u05DC\u05D4\u05D5\u05E1\u05D9\u05E3 \u05E2\u05E8\u05DA \u05DE\u05E9\u05DC\u05D5\u05D7",
  "please add time since last order": "\u05E0\u05D0 \u05DC\u05D4\u05D5\u05E1\u05D9\u05E3 \u05D6\u05DE\u05DF \u05DE\u05D0\u05D6 \u05D4\u05D4\u05D6\u05DE\u05E0\u05D4 \u05D4\u05D0\u05D7\u05E8\u05D5\u05E0\u05D4",
  "please add total item count": "\u05D0\u05E0\u05D0 \u05D4\u05D5\u05E1\u05E3 \u05E1\u05E4\u05D9\u05E8\u05EA \u05E4\u05E8\u05D9\u05D8\u05D9\u05DD \u05DB\u05D5\u05DC\u05DC\u05EA",
  "please add value": "\u05E0\u05D0 \u05DC\u05D4\u05D5\u05E1\u05D9\u05E3 \u05E2\u05E8\u05DA",
  "please select collections": "\u05E0\u05D0 \u05DC\u05D1\u05D7\u05D5\u05E8 \u05E7\u05D5\u05DC\u05E7\u05E6\u05D9\u05D5\u05EA",
  "please select customer birthday": "\u05E0\u05D0 \u05DC\u05D1\u05D7\u05D5\u05E8 \u05D9\u05D5\u05DD \u05D4\u05D5\u05DC\u05D3\u05EA \u05E9\u05DC \u05DC\u05E7\u05D5\u05D7",
  "please select customer country": "\u05E0\u05D0 \u05DC\u05D1\u05D7\u05D5\u05E8 \u05DE\u05D3\u05D9\u05E0\u05EA \u05DC\u05E7\u05D5\u05D7",
  "please select customer language": "\u05E0\u05D0 \u05DC\u05D1\u05D7\u05D5\u05E8 \u05E9\u05E4\u05EA \u05DC\u05E7\u05D5\u05D7",
  "please select customer segments": "\u05E0\u05D0 \u05DC\u05D1\u05D7\u05D5\u05E8 \u05E4\u05DC\u05D7\u05D9 \u05DC\u05E7\u05D5\u05D7\u05D5\u05EA",
  "please select customer tag": "\u05E0\u05D0 \u05DC\u05D1\u05D7\u05D5\u05E8 \u05EA\u05D2\u05D9\u05EA \u05DC\u05E7\u05D5\u05D7",
  "please select customer tags": "\u05E0\u05D0 \u05DC\u05D1\u05D7\u05D5\u05E8 \u05EA\u05D2\u05D9\u05D5\u05EA \u05DC\u05E7\u05D5\u05D7",
  "please select fulfillment statuses": "\u05E0\u05D0 \u05DC\u05D1\u05D7\u05D5\u05E8 \u05DE\u05E6\u05D1\u05D9 \u05D1\u05D9\u05E6\u05D5\u05E2",
  "please select offer": "\u05E0\u05D0 \u05DC\u05D1\u05D7\u05D5\u05E8 \u05D4\u05E6\u05E2\u05D4",
  "please select payment method": "\u05D0\u05E0\u05D0 \u05D1\u05D7\u05E8 \u05E9\u05D9\u05D8\u05EA \u05EA\u05E9\u05DC\u05D5\u05DD",
  "please select payment statuses": "\u05D0\u05E0\u05D0 \u05D1\u05D7\u05E8 \u05DE\u05E6\u05D1\u05D9 \u05EA\u05E9\u05DC\u05D5\u05DD",
  "please select product type": "\u05D0\u05E0\u05D0 \u05D1\u05D7\u05E8 \u05E1\u05D5\u05D2 \u05DE\u05D5\u05E6\u05E8",
  "please select product vendor": "\u05D0\u05E0\u05D0 \u05D1\u05D7\u05E8 \u05E1\u05E4\u05E7 \u05DE\u05D5\u05E6\u05E8",
  "please select products": "\u05E0\u05D0 \u05DC\u05D1\u05D7\u05D5\u05E8 \u05DE\u05D5\u05E6\u05E8\u05D9\u05DD",
  "please select sales channel": "\u05E0\u05D0 \u05DC\u05D1\u05D7\u05D5\u05E8 \u05E2\u05E8\u05D5\u05E5 \u05DE\u05DB\u05D9\u05E8\u05D4",
  "please select shipping methods": "\u05E0\u05D0 \u05DC\u05D1\u05D7\u05D5\u05E8 \u05E9\u05D9\u05D8\u05D5\u05EA \u05DE\u05E9\u05DC\u05D5\u05D7",
  "please select tags": "\u05E0\u05D0 \u05DC\u05D1\u05D7\u05D5\u05E8 \u05EA\u05D2\u05D9\u05D5\u05EA",
  "Previous page offer": "\u05D4\u05E6\u05E2\u05D4 \u05DE\u05D4\u05E2\u05DE\u05D5\u05D3 \u05D4\u05E7\u05D5\u05D3\u05DD",
  product: "\u05DE\u05D5\u05E6\u05E8",
  "Product recommendations": "\u05D4\u05DE\u05DC\u05E6\u05D5\u05EA \u05E2\u05DC \u05DE\u05D5\u05E6\u05E8\u05D9\u05DD",
  "Product type": "\u05E1\u05D5\u05D2 \u05DE\u05D5\u05E6\u05E8",
  "Product upsell": "\u05D0\u05E4\u05E1\u05D9\u05D9\u05DC \u05DE\u05D5\u05E6\u05E8",
  products: "\u05DE\u05D5\u05E6\u05E8\u05D9\u05DD",
  "Requires shipping": "\u05D3\u05D5\u05E8\u05E9 \u05DE\u05E9\u05DC\u05D5\u05D7",
  "Shipping method": "\u05E9\u05D9\u05D8\u05EA \u05DE\u05E9\u05DC\u05D5\u05D7",
  "Shipping value": "\u05E2\u05E8\u05DA \u05DE\u05E9\u05DC\u05D5\u05D7",
  "Starts with": "\u05DE\u05EA\u05D7\u05D9\u05DC \u05D1-",
  Status: "\u05DE\u05E6\u05D1",
  "The displayed product": "\u05D4\u05DE\u05D5\u05E6\u05E8 \u05D4\u05DE\u05D5\u05E6\u05D2",
  "The displayed product SKU": "\u05D4\u05DE\u05E7\u05F4\u05D8 \u05E9\u05DC \u05D4\u05DE\u05D5\u05E6\u05E8 \u05D4\u05DE\u05D5\u05E6\u05D2",
  "The only product title in the cart": "\u05DB\u05D5\u05EA\u05E8\u05EA \u05D4\u05DE\u05D5\u05E6\u05E8 \u05D4\u05D9\u05D7\u05D9\u05D3 \u05D1\u05E2\u05D2\u05DC\u05D4",
  "The only SKU in the cart": "\u05D4\u05DE\u05E7\u05F4\u05D8 \u05D4\u05D9\u05D7\u05D9\u05D3 \u05D1\u05E2\u05D2\u05DC\u05D4",
  "The SKU of all products in the cart": "\u05D4\u05DE\u05E7\u05F4\u05D8 \u05E9\u05DC \u05DB\u05DC \u05D4\u05DE\u05D5\u05E6\u05E8\u05D9\u05DD \u05D1\u05E2\u05D2\u05DC\u05D4",
  "The SKU of at least one product in the cart": "\u05D4\u05DE\u05E7\u05F4\u05D8 \u05E9\u05DC \u05DE\u05D5\u05E6\u05E8 \u05D0\u05D7\u05D3 \u05DC\u05E4\u05D7\u05D5\u05EA \u05D1\u05E2\u05D2\u05DC\u05D4",
  "The title of all products in the cart": "\u05D4\u05DB\u05D5\u05EA\u05E8\u05EA \u05E9\u05DC \u05DB\u05DC \u05D4\u05DE\u05D5\u05E6\u05E8\u05D9\u05DD \u05D1\u05E2\u05D2\u05DC\u05D4",
  "The title of at least one product in the cart": "\u05D4\u05DB\u05D5\u05EA\u05E8\u05EA \u05E9\u05DC \u05DE\u05D5\u05E6\u05E8 \u05D0\u05D7\u05D3 \u05DC\u05E4\u05D7\u05D5\u05EA \u05D1\u05E2\u05D2\u05DC\u05D4",
  "The title of the displayed product": "\u05D4\u05DB\u05D5\u05EA\u05E8\u05EA \u05E9\u05DC \u05D4\u05DE\u05D5\u05E6\u05E8 \u05D4\u05DE\u05D5\u05E6\u05D2",
  "The variant of all products in the cart": "\u05D4\u05D5\u05D5\u05E8\u05D9\u05D0\u05E0\u05D8 \u05E9\u05DC \u05DB\u05DC \u05D4\u05DE\u05D5\u05E6\u05E8\u05D9\u05DD \u05D1\u05E2\u05D2\u05DC\u05D4",
  "The variant of at least one product in the cart": "\u05D4\u05D5\u05D5\u05E8\u05D9\u05D0\u05E0\u05D8 \u05E9\u05DC \u05DE\u05D5\u05E6\u05E8 \u05D0\u05D7\u05D3 \u05DC\u05E4\u05D7\u05D5\u05EA \u05D1\u05E2\u05D2\u05DC\u05D4",
  "The variant of only product in the cart": "\u05D4\u05D5\u05D5\u05E8\u05D9\u05D0\u05E0\u05D8 \u05E9\u05DC \u05D4\u05DE\u05D5\u05E6\u05E8 \u05D4\u05D9\u05D7\u05D9\u05D3 \u05D1\u05E2\u05D2\u05DC\u05D4",
  "The variant of the displayed product": "\u05D4\u05D5\u05D5\u05E8\u05D9\u05D0\u05E0\u05D8 \u05E9\u05DC \u05D4\u05DE\u05D5\u05E6\u05E8 \u05D4\u05DE\u05D5\u05E6\u05D2",
  "Total item count": "\u05E1\u05E4\u05D9\u05E8\u05EA \u05E4\u05E8\u05D9\u05D8\u05D9\u05DD \u05DB\u05D5\u05DC\u05DC\u05EA",
  Weeks: "\u05E9\u05D1\u05D5\u05E2\u05D5\u05EA",
  Years: "\u05E9\u05E0\u05D9\u05DD"
};

// src/lang/pt_BR.json
var pt_BR_default = {
  "An offer was accepted": "Uma oferta foi aceita",
  "An offer was declined": "Uma oferta foi recusada",
  and: "e",
  "Announcement bar": "Barra de an\xFAncios",
  "Are available at all the sales channels from the list": "Est\xE3o dispon\xEDveis em todos os canais de venda da lista",
  "Are available at one of the sales channels from the list": "Est\xE3o dispon\xEDveis em um dos canais de venda da lista",
  "Are not available at all the sales channels from the list": "N\xE3o est\xE3o dispon\xEDveis em todos os canais de venda da lista",
  "Are not available at one of the sales channels from the list": "N\xE3o est\xE3o dispon\xEDveis em um dos canais de venda da lista",
  "At least one product in the cart": "Pelo menos um produto no carrinho",
  Banner: "Banner",
  Between: "Entre",
  Bundle: "Pacote",
  "Cart/Order value": "Valor do Carrinho/Pedido",
  categories: "categorias",
  category: "categoria",
  collection: "cole\xE7\xE3o",
  collections: "cole\xE7\xF5es",
  Contains: "Cont\xE9m",
  "Customer accepted marketing": "O cliente aceitou o marketing",
  "Customer birthday": "Anivers\xE1rio do cliente",
  "Customer country": "Pa\xEDs do Cliente",
  "customer doesn't have all the tags from the list": "o cliente n\xE3o tem todas as tags da lista",
  "customer doesn't have any of the tags from the list": "o cliente n\xE3o tem nenhuma das tags da lista",
  "Customer don't accepted marketing": "O cliente n\xE3o aceitou o marketing",
  "Customer email": "E-mail do Cliente",
  "customer has all the tags from the list": "o cliente tem todas as tags da lista",
  "customer has at least one of the tags from the list ": "o cliente tem pelo menos uma das tags da lista",
  "Customer number of orders": "N\xFAmero de Pedidos do Cliente",
  "Customer segments": "Segmentos de Clientes",
  "Customer tag": "Tag de cliente",
  Days: "Dias",
  "Discount code": "C\xF3digo de Desconto",
  "Does not require shipping": "N\xE3o requer envio",
  "Doesn't contain": "N\xE3o cont\xE9m",
  "Doesn't end with": "N\xE3o termina com",
  "Doesn't have all the tags from the list": "N\xE3o possui todas as tags da lista",
  "Doesn't have some of the tags from the list": "N\xE3o possui algumas das tags da lista",
  "Doesn't start with": "N\xE3o come\xE7a com",
  "Ends with": "Termina com",
  "Equal to": "Igual a",
  Equals: "\xC9 igual a",
  "Every product in the cart": "Todos os produtos no carrinho",
  "Greater than": "Maior que",
  "Greater than or equals to": "Maior ou igual a",
  "Has all the tags from the list": "Possui todas as tags da lista",
  "Has at least one of the tags from the list": "Possui pelo menos uma das tags da lista",
  Hours: "Horas",
  "in less than": "em menos de",
  "Is (exact code)": "\xC9 (c\xF3digo exato)",
  "Is (exact email)": "\xC9 (e-mail exato)",
  "Is (exact sku)": "\xC9 (SKU exato)",
  "Is (exact title)": "\xC9 (t\xEDtulo exato)",
  "Is (exact variant name)": "\xC9 (nome da variante exato)",
  "Is after": "\xC9 depois de",
  "Is available at all the sales channels from the list": "Est\xE1 dispon\xEDvel em todos os canais de venda da lista",
  "Is available at all the sales channels in the list": "Est\xE1 dispon\xEDvel em todos os canais de vendas da lista",
  "Is available at one of the sales channels from the list": "Est\xE1 dispon\xEDvel em um dos canais de venda da lista",
  "Is available at one of the sales channels in the list": "Est\xE1 dispon\xEDvel em um dos canais de vendas da lista",
  "Is before": "\xC9 antes de",
  "Is between": "Est\xE1 entre",
  "Is from a vendor in the list": "\xC9 de um fornecedor da lista",
  "Is from the list": "Est\xE1 na lista",
  "Is greater than": "\xC9 maior que",
  "Is greater than or equals to": "\xC9 maior ou igual a",
  "Is in a category from the list": "Est\xE1 em uma categoria da lista",
  "Is in a collection from the list": "Est\xE1 em uma cole\xE7\xE3o da lista",
  "Is less than": "\xC9 menor que",
  "Is less than or equals to": "\xC9 menor ou igual a",
  "Is not (exact code)": "N\xE3o \xE9 (c\xF3digo exato)",
  "Is not (exact email)": "N\xE3o \xE9 (e-mail exato)",
  "Is not (exact sku)": "N\xE3o \xE9 (SKU exato)",
  "Is not (exact title)": "N\xE3o \xE9 (t\xEDtulo exato)",
  "Is not (exact variant name)": "N\xE3o \xE9 (nome da variante exato)",
  "Is not available at all the sales channels from the list": "N\xE3o est\xE1 dispon\xEDvel em todos os canais de venda da lista",
  "Is not available at all the sales channels in the list": "N\xE3o est\xE1 dispon\xEDvel em todos os canais de vendas da lista",
  "Is not available at one of the sales channels from the list": "N\xE3o est\xE1 dispon\xEDvel em um dos canais de venda da lista",
  "Is not available at one of the sales channels in the list": "N\xE3o est\xE1 dispon\xEDvel em nenhum dos canais de vendas da lista",
  "Is not between": "N\xE3o est\xE1 entre",
  "Is not equal to": "N\xE3o \xE9 igual a",
  "Is not from a vendor in the list": "N\xE3o \xE9 de um fornecedor da lista",
  "Is not from the list": "N\xE3o est\xE1 na lista",
  "Is not in a category from the list": "N\xE3o est\xE1 em uma categoria da lista",
  "Is not in a collection from the list": "N\xE3o est\xE1 em uma cole\xE7\xE3o da lista",
  "Is not of a type from the list": "N\xE3o \xE9 de um tipo da lista",
  "Is not on": "N\xE3o \xE9 em",
  "Is not one of the countries from the list": "N\xE3o \xE9 um dos pa\xEDses da lista",
  "Is not one of the customer segments from the list": "N\xE3o \xE9 um dos segmentos de clientes da lista",
  "Is not one of the fulfillment statuses in the list": "N\xE3o \xE9 um dos status de cumprimento da lista",
  "Is not one of the languages from the list": "N\xE3o \xE9 um dos idiomas da lista",
  "Is not one of the methods in the list": "N\xE3o \xE9 um dos m\xE9todos da lista",
  "Is not one of the payment statuses in the list": "N\xE3o \xE9 um dos status de pagamento da lista",
  "Is not tagged with all the tags in the list": "N\xE3o est\xE1 marcado com todas as tags da lista",
  "Is not tagged with any of the tags in the list": "N\xE3o est\xE1 marcado com nenhuma das tags da lista",
  "Is not tagged with at least one of the tags in the list": "N\xE3o est\xE1 marcado com pelo menos uma das tags da lista",
  "Is of a type from the list": "\xC9 de um tipo da lista",
  "Is on": "\xC9 em",
  "Is one of the countries from the list": "\xC9 um dos pa\xEDses da lista",
  "Is one of the customer segments from the list": "\xC9 um dos segmentos de clientes da lista",
  "Is one of the fulfillment statuses in the list": "\xC9 um dos status de cumprimento da lista",
  "Is one of the languages from the list": "\xC9 um dos idiomas da lista",
  "Is one of the methods in the list": "\xC9 um dos m\xE9todos da lista",
  "Is one of the payment statuses in the list": "\xC9 um dos status de pagamento da lista",
  "Is tagged with all the tags in the list": "Est\xE1 marcado com todas as tags da lista",
  "Is tagged with at least one of the tags in the list": "Est\xE1 marcado com pelo menos uma das tags da lista",
  "Item cost": "Custo do item",
  Language: "Idioma",
  "Less than": "Menor que",
  "Less than or equals to": "Menor ou igual a",
  "Marketing consent": "Consentimento de marketing",
  Minutes: "Minutos",
  Months: "Meses",
  "Number of orders": "N\xFAmero de pedidos",
  "On all of the post purchase pages": "Em todas as p\xE1ginas p\xF3s-compra",
  "On one of the post purchase pages": "Em uma das p\xE1ginas p\xF3s-compra",
  "On the checkout": "No checkout",
  "On the post purchase 1st page": "Na 1\xAA p\xE1gina p\xF3s-compra",
  "On the post purchase 2nd page": "Na 2\xAA p\xE1gina p\xF3s-compra",
  "On the thank you page": "Na p\xE1gina de agradecimento",
  "Order note": "Nota do pedido",
  "Order tags": "Tags do pedido",
  "Passed X time ago": "Passou h\xE1 X",
  "Payment method": "Forma de pagamento",
  "please add cart or order value": "por favor, adicione o valor do carrinho ou do pedido",
  "please add customer email": "por favor, adicione o e-mail do cliente",
  "please add customer number of orders": "por favor, adicione o n\xFAmero de pedidos do cliente",
  "please add discount code": "por favor, adicione o c\xF3digo de desconto",
  "please add item cost": "por favor, adicione o custo do item",
  "please add number of orders": "Por favor, adicione o n\xFAmero de pedidos",
  "please add order note": "por favor, adicione a nota do pedido",
  "please add product price": "Por favor, adicione o pre\xE7o do produto",
  "please add product sku": "por favor, adicione o SKU do produto",
  "please add product title": "por favor, adicione o t\xEDtulo do produto",
  "please add product variant name": "por favor, adicione o nome da variante do produto",
  "please add shipping value": "por favor, adicione o valor de envio",
  "please add time since last order": "Adicione o tempo desde o \xFAltimo pedido",
  "please add total item count": "Por favor, adicione a contagem total de itens",
  "please add value": "por favor, adicione um valor",
  "please select collections": "por favor, selecione as cole\xE7\xF5es",
  "please select customer birthday": "Selecione o anivers\xE1rio do cliente",
  "please select customer country": "por favor, selecione o pa\xEDs do cliente",
  "please select customer language": "por favor, selecione o idioma do cliente",
  "please select customer segments": "por favor, selecione os segmentos de clientes",
  "please select customer tag": "por favor, selecione a tag do cliente",
  "please select customer tags": "Selecione as tags de cliente",
  "please select fulfillment statuses": "por favor, selecione os status de cumprimento",
  "please select offer": "por favor, selecione a oferta",
  "please select payment method": "Por favor, selecione a forma de pagamento",
  "please select payment statuses": "Por favor, selecione os status de pagamento",
  "please select product type": "Por favor, selecione o tipo de produto",
  "please select product vendor": "Por favor, selecione o fornecedor do produto",
  "please select products": "por favor, selecione os produtos",
  "please select sales channel": "por favor, selecione o canal de vendas",
  "please select shipping methods": "por favor, selecione os m\xE9todos de envio",
  "please select tags": "por favor, selecione as tags",
  "Previous page offer": "Oferta da P\xE1gina Anterior",
  product: "produto",
  "Product recommendations": "Recomenda\xE7\xF5es de Produtos",
  "Product type": "Tipo de produto",
  "Product upsell": "Upsell de Produto",
  products: "produtos",
  "Requires shipping": "Requer envio",
  "Shipping method": "M\xE9todo de envio",
  "Shipping value": "Valor de envio",
  "Starts with": "Come\xE7a com",
  Status: "Status",
  "The displayed product": "O produto exibido",
  "The displayed product SKU": "O SKU do produto exibido",
  "The only product title in the cart": "O \xFAnico t\xEDtulo de produto no carrinho",
  "The only SKU in the cart": "O \xFAnico SKU no carrinho",
  "The SKU of all products in the cart": "O SKU de todos os produtos no carrinho",
  "The SKU of at least one product in the cart": "O SKU de pelo menos um produto no carrinho",
  "The title of all products in the cart": "O t\xEDtulo de todos os produtos no carrinho",
  "The title of at least one product in the cart": "O t\xEDtulo de pelo menos um produto no carrinho",
  "The title of the displayed product": "O t\xEDtulo do produto exibido",
  "The variant of all products in the cart": "A variante de todos os produtos no carrinho",
  "The variant of at least one product in the cart": "A variante de pelo menos um produto no carrinho",
  "The variant of only product in the cart": "A variante do \xFAnico produto no carrinho",
  "The variant of the displayed product": "A variante do produto exibida",
  "Total item count": "Contagem total de itens",
  Weeks: "Semanas",
  Years: "Anos"
};

// src/lang/de.json
var de_default = {
  "An offer was accepted": "Ein Angebot wurde angenommen",
  "An offer was declined": "Ein Angebot wurde abgelehnt",
  and: "und",
  "Announcement bar": "Ank\xFCndigungsleiste",
  "Are available at all the sales channels from the list": "Sind auf allen Vertriebskan\xE4len aus der Liste verf\xFCgbar",
  "Are available at one of the sales channels from the list": "Sind auf einem der Vertriebskan\xE4le aus der Liste verf\xFCgbar",
  "Are not available at all the sales channels from the list": "Sind auf keinem der Vertriebskan\xE4le aus der Liste verf\xFCgbar",
  "Are not available at one of the sales channels from the list": "Sind auf einem der Vertriebskan\xE4le aus der Liste nicht verf\xFCgbar",
  "At least one product in the cart": "Mindestens ein Produkt im Warenkorb",
  Banner: "Banner",
  Between: "Zwischen",
  Bundle: "Bundle",
  "Cart/Order value": "Warenkorb-/Bestellwert",
  categories: "Kategorien",
  category: "Kategorie",
  collection: "Kollektion",
  collections: "Kollektionen",
  Contains: "Enth\xE4lt",
  "Customer accepted marketing": "Kunde hat Marketing akzeptiert",
  "Customer birthday": "Geburtstag des Kunden",
  "Customer country": "Land des Kunden",
  "customer doesn't have all the tags from the list": "Kunde hat nicht alle Tags aus der Liste",
  "customer doesn't have any of the tags from the list": "Kunde hat keinen der Tags aus der Liste",
  "Customer don't accepted marketing": "Kunde hat Marketing nicht akzeptiert",
  "Customer email": "Kunden-E-Mail",
  "customer has all the tags from the list": "Kunde hat alle Tags aus der Liste",
  "customer has at least one of the tags from the list ": "Kunde hat mindestens einen der Tags aus der Liste",
  "Customer number of orders": "Anzahl der Bestellungen des Kunden",
  "Customer segments": "Kundensegmente",
  "Customer tag": "Kunden-Tag",
  Days: "Tage",
  "Discount code": "Rabattcode",
  "Does not require shipping": "Kein Versand erforderlich",
  "Doesn't contain": "Enth\xE4lt nicht",
  "Doesn't end with": "Endet nicht mit",
  "Doesn't have all the tags from the list": "Hat nicht alle Tags aus der Liste",
  "Doesn't have some of the tags from the list": "Hat einige der Tags aus der Liste nicht",
  "Doesn't start with": "Beginnt nicht mit",
  "Ends with": "Endet mit",
  "Equal to": "Gleich",
  Equals: "Ist gleich",
  "Every product in the cart": "Jedes Produkt im Warenkorb",
  "Greater than": "Gr\xF6\xDFer als",
  "Greater than or equals to": "Gr\xF6\xDFer oder gleich",
  "Has all the tags from the list": "Hat alle Tags aus der Liste",
  "Has at least one of the tags from the list": "Hat mindestens einen der Tags aus der Liste",
  Hours: "Stunden",
  "in less than": "in weniger als",
  "Is (exact code)": "Ist (genauer Code)",
  "Is (exact email)": "Ist (genaue E-Mail)",
  "Is (exact sku)": "Ist (genaue SKU)",
  "Is (exact title)": "Ist (genauer Titel)",
  "Is (exact variant name)": "Ist (genauer Variantenname)",
  "Is after": "Ist nach dem",
  "Is available at all the sales channels from the list": "Ist auf allen Vertriebskan\xE4len aus der Liste verf\xFCgbar",
  "Is available at all the sales channels in the list": "Ist in allen Vertriebskan\xE4len in der Liste verf\xFCgbar",
  "Is available at one of the sales channels from the list": "Ist auf einem der Vertriebskan\xE4le aus der Liste verf\xFCgbar",
  "Is available at one of the sales channels in the list": "Ist in einem der Vertriebskan\xE4le in der Liste verf\xFCgbar",
  "Is before": "Ist vor dem",
  "Is between": "Ist zwischen",
  "Is from a vendor in the list": "Ist von einem Anbieter aus der Liste",
  "Is from the list": "Ist aus der Liste",
  "Is greater than": "Ist gr\xF6\xDFer als",
  "Is greater than or equals to": "Ist gr\xF6\xDFer als oder gleich",
  "Is in a category from the list": "Ist in einer Kategorie aus der Liste",
  "Is in a collection from the list": "Ist in einer Kollektion aus der Liste",
  "Is less than": "Ist kleiner als",
  "Is less than or equals to": "Ist kleiner als oder gleich",
  "Is not (exact code)": "Ist nicht (genauer Code)",
  "Is not (exact email)": "Ist nicht (genaue E-Mail)",
  "Is not (exact sku)": "Ist nicht (genaue SKU)",
  "Is not (exact title)": "Ist nicht (genauer Titel)",
  "Is not (exact variant name)": "Ist nicht (genauer Variantenname)",
  "Is not available at all the sales channels from the list": "Ist auf keinem der Vertriebskan\xE4le aus der Liste verf\xFCgbar",
  "Is not available at all the sales channels in the list": "Ist nicht in allen Vertriebskan\xE4len in der Liste verf\xFCgbar",
  "Is not available at one of the sales channels from the list": "Ist auf einem der Vertriebskan\xE4le aus der Liste nicht verf\xFCgbar",
  "Is not available at one of the sales channels in the list": "Ist in keinem der Vertriebskan\xE4le in der Liste verf\xFCgbar",
  "Is not between": "Ist nicht zwischen",
  "Is not equal to": "Ist nicht gleich",
  "Is not from a vendor in the list": "Ist von keinem Anbieter aus der Liste",
  "Is not from the list": "Ist nicht aus der Liste",
  "Is not in a category from the list": "Ist nicht in einer Kategorie aus der Liste",
  "Is not in a collection from the list": "Ist nicht in einer Kollektion aus der Liste",
  "Is not of a type from the list": "Ist von keinem Typ aus der Liste",
  "Is not on": "Ist nicht am",
  "Is not one of the countries from the list": "Ist keines der L\xE4nder aus der Liste",
  "Is not one of the customer segments from the list": "Ist keines der Kundensegmente aus der Liste",
  "Is not one of the fulfillment statuses in the list": "Ist keiner der Erf\xFCllungsstatusse in der Liste",
  "Is not one of the languages from the list": "Ist keine der Sprachen aus der Liste",
  "Is not one of the methods in the list": "Ist keine der Methoden in der Liste",
  "Is not one of the payment statuses in the list": "Ist keiner der Zahlungsstatusse in der Liste",
  "Is not tagged with all the tags in the list": "Ist nicht mit allen Tags in der Liste markiert",
  "Is not tagged with any of the tags in the list": "Ist nicht mit einem der Tags in der Liste markiert",
  "Is not tagged with at least one of the tags in the list": "Ist nicht mit mindestens einem der Tags in der Liste markiert",
  "Is of a type from the list": "Ist von einem Typ aus der Liste",
  "Is on": "Ist am",
  "Is one of the countries from the list": "Ist eines der L\xE4nder aus der Liste",
  "Is one of the customer segments from the list": "Ist eines der Kundensegmente aus der Liste",
  "Is one of the fulfillment statuses in the list": "Ist einer der Erf\xFCllungsstatusse in der Liste",
  "Is one of the languages from the list": "Ist eine der Sprachen aus der Liste",
  "Is one of the methods in the list": "Ist eine der Methoden in der Liste",
  "Is one of the payment statuses in the list": "Ist einer der Zahlungsstatusse in der Liste",
  "Is tagged with all the tags in the list": "Ist mit allen Tags in der Liste markiert",
  "Is tagged with at least one of the tags in the list": "Ist mit mindestens einem der Tags in der Liste markiert",
  "Item cost": "Artikelkosten",
  Language: "Sprache",
  "Less than": "Kleiner als",
  "Less than or equals to": "Kleiner oder gleich",
  "Marketing consent": "Marketing-Einwilligung",
  Minutes: "Minuten",
  Months: "Monate",
  "Number of orders": "Anzahl der Bestellungen",
  "On all of the post purchase pages": "Auf allen Post-Purchase-Seiten",
  "On one of the post purchase pages": "Auf einer der Post-Purchase-Seiten",
  "On the checkout": "Im Checkout",
  "On the post purchase 1st page": "Auf der 1. Post-Purchase-Seite",
  "On the post purchase 2nd page": "Auf der 2. Post-Purchase-Seite",
  "On the thank you page": "Auf der Dankeseite",
  "Order note": "Bestellnotiz",
  "Order tags": "Bestell-Tags",
  "Passed X time ago": "Vor X vergangen",
  "Payment method": "Zahlungsmethode",
  "please add cart or order value": "Bitte Warenkorb- oder Bestellwert hinzuf\xFCgen",
  "please add customer email": "Bitte Kunden-E-Mail hinzuf\xFCgen",
  "please add customer number of orders": "Bitte Anzahl der Kundenbestellungen hinzuf\xFCgen",
  "please add discount code": "Bitte Rabattcode hinzuf\xFCgen",
  "please add item cost": "Bitte Artikelkosten hinzuf\xFCgen",
  "please add number of orders": "Bitte Anzahl der Bestellungen hinzuf\xFCgen",
  "please add order note": "Bitte Bestellnotiz hinzuf\xFCgen",
  "please add product price": "Bitte Produktpreis hinzuf\xFCgen",
  "please add product sku": "Bitte Produkt-SKU hinzuf\xFCgen",
  "please add product title": "Bitte Produkttitel hinzuf\xFCgen",
  "please add product variant name": "Bitte Variantennamen hinzuf\xFCgen",
  "please add shipping value": "Bitte Versandwert hinzuf\xFCgen",
  "please add time since last order": "Bitte Zeit seit der letzten Bestellung hinzuf\xFCgen",
  "please add total item count": "Bitte Gesamtartikelanzahl hinzuf\xFCgen",
  "please add value": "Bitte Wert hinzuf\xFCgen",
  "please select collections": "Bitte Kollektionen ausw\xE4hlen",
  "please select customer birthday": "Bitte Geburtstag des Kunden ausw\xE4hlen",
  "please select customer country": "Bitte Land des Kunden ausw\xE4hlen",
  "please select customer language": "Bitte Kundensprache ausw\xE4hlen",
  "please select customer segments": "Bitte Kundensegmente ausw\xE4hlen",
  "please select customer tag": "Bitte Kunden-Tag ausw\xE4hlen",
  "please select customer tags": "Bitte Kunden-Tags ausw\xE4hlen",
  "please select fulfillment statuses": "Bitte Erf\xFCllungsstatusse ausw\xE4hlen",
  "please select offer": "Bitte Angebot ausw\xE4hlen",
  "please select payment method": "Bitte Zahlungsmethode ausw\xE4hlen",
  "please select payment statuses": "Bitte Zahlungsstatusse ausw\xE4hlen",
  "please select product type": "Bitte Produkttyp ausw\xE4hlen",
  "please select product vendor": "Bitte Produktanbieter ausw\xE4hlen",
  "please select products": "Bitte Produkte ausw\xE4hlen",
  "please select sales channel": "Bitte Vertriebskanal ausw\xE4hlen",
  "please select shipping methods": "Bitte Versandmethoden ausw\xE4hlen",
  "please select tags": "Bitte Tags ausw\xE4hlen",
  "Previous page offer": "Angebot der vorherigen Seite",
  product: "Produkt",
  "Product recommendations": "Produktempfehlungen",
  "Product type": "Produkttyp",
  "Product upsell": "Produkt-Upsell",
  products: "Produkte",
  "Requires shipping": "Versand erforderlich",
  "Shipping method": "Versandmethode",
  "Shipping value": "Versandwert",
  "Starts with": "Beginnt mit",
  Status: "Status",
  "The displayed product": "Das angezeigte Produkt",
  "The displayed product SKU": "Die SKU des angezeigten Produkts",
  "The only product title in the cart": "Der einzige Produkttitel im Warenkorb",
  "The only SKU in the cart": "Die einzige SKU im Warenkorb",
  "The SKU of all products in the cart": "Die SKU aller Produkte im Warenkorb",
  "The SKU of at least one product in the cart": "Die SKU von mindestens einem Produkt im Warenkorb",
  "The title of all products in the cart": "Der Titel aller Produkte im Warenkorb",
  "The title of at least one product in the cart": "Der Titel von mindestens einem Produkt im Warenkorb",
  "The title of the displayed product": "Der Titel des angezeigten Produkts",
  "The variant of all products in the cart": "Die Variante aller Produkte im Warenkorb",
  "The variant of at least one product in the cart": "Die Variante von mindestens einem Produkt im Warenkorb",
  "The variant of only product in the cart": "Die Variante des einzigen Produkts im Warenkorb",
  "The variant of the displayed product": "Die Variante des angezeigten Produkts",
  "Total item count": "Gesamtartikelanzahl",
  Weeks: "Wochen",
  Years: "Jahre"
};

// src/lang/fr.json
var fr_default = {
  "An offer was accepted": "Une offre a \xE9t\xE9 accept\xE9e",
  "An offer was declined": "Une offre a \xE9t\xE9 refus\xE9e",
  and: "et",
  "Announcement bar": "Barre d'annonce",
  "Are available at all the sales channels from the list": "Sont disponibles sur tous les canaux de vente de la liste",
  "Are available at one of the sales channels from the list": "Sont disponibles sur au moins un des canaux de vente de la liste",
  "Are not available at all the sales channels from the list": "Ne sont pas disponibles sur tous les canaux de vente de la liste",
  "Are not available at one of the sales channels from the list": "Ne sont pas disponibles sur l'un des canaux de vente de la liste",
  "At least one product in the cart": "Au moins un produit dans le panier",
  Banner: "Banni\xE8re",
  Between: "Entre",
  Bundle: "Bundle",
  "Cart/Order value": "Valeur du panier/de la commande",
  categories: "cat\xE9gories",
  category: "cat\xE9gorie",
  collection: "collection",
  collections: "collections",
  Contains: "Contient",
  "Customer accepted marketing": "Le client a accept\xE9 le marketing",
  "Customer birthday": "Anniversaire du client",
  "Customer country": "Pays du client",
  "customer doesn't have all the tags from the list": "le client n'a pas toutes les \xE9tiquettes de la liste",
  "customer doesn't have any of the tags from the list": "le client n'a aucune des \xE9tiquettes de la liste",
  "Customer don't accepted marketing": "Le client n'a pas accept\xE9 le marketing",
  "Customer email": "Email du client",
  "customer has all the tags from the list": "le client a toutes les \xE9tiquettes de la liste",
  "customer has at least one of the tags from the list ": "le client a au moins une des \xE9tiquettes de la liste",
  "Customer number of orders": "Nombre de commandes du client",
  "Customer segments": "Segments de client\xE8le",
  "Customer tag": "Balise client",
  Days: "Jours",
  "Discount code": "Code de r\xE9duction",
  "Does not require shipping": "Ne n\xE9cessite pas d'exp\xE9dition",
  "Doesn't contain": "Ne contient pas",
  "Doesn't end with": "Ne se termine pas par",
  "Doesn't have all the tags from the list": "N'a pas toutes les \xE9tiquettes de la liste",
  "Doesn't have some of the tags from the list": "N'a pas certaines des \xE9tiquettes de la liste",
  "Doesn't start with": "Ne commence pas par",
  "Ends with": "Se termine par",
  "Equal to": "\xC9gal \xE0",
  Equals: "Est \xE9gal \xE0",
  "Every product in the cart": "Chaque produit dans le panier",
  "Greater than": "Sup\xE9rieur \xE0",
  "Greater than or equals to": "Sup\xE9rieur ou \xE9gal \xE0",
  "Has all the tags from the list": "A toutes les \xE9tiquettes de la liste",
  "Has at least one of the tags from the list": "A au moins une des \xE9tiquettes de la liste",
  Hours: "Heures",
  "in less than": "dans moins de",
  "Is (exact code)": "Est (code exact)",
  "Is (exact email)": "Est (email exact)",
  "Is (exact sku)": "Est (SKU exact)",
  "Is (exact title)": "Est (titre exact)",
  "Is (exact variant name)": "Est (nom de variante exact)",
  "Is after": "Est apr\xE8s le",
  "Is available at all the sales channels from the list": "Est disponible sur tous les canaux de vente de la liste",
  "Is available at all the sales channels in the list": "Est disponible sur tous les canaux de vente de la liste",
  "Is available at one of the sales channels from the list": "Est disponible sur au moins un des canaux de vente de la liste",
  "Is available at one of the sales channels in the list": "Est disponible sur l'un des canaux de vente de la liste",
  "Is before": "Est avant le",
  "Is between": "Est compris entre",
  "Is from a vendor in the list": "Provient d'un vendeur de la liste",
  "Is from the list": "Provient de la liste",
  "Is greater than": "Est sup\xE9rieur \xE0",
  "Is greater than or equals to": "Est sup\xE9rieur ou \xE9gal \xE0",
  "Is in a category from the list": "Est dans une cat\xE9gorie de la liste",
  "Is in a collection from the list": "Est dans une collection de la liste",
  "Is less than": "Est inf\xE9rieur \xE0",
  "Is less than or equals to": "Est inf\xE9rieur ou \xE9gal \xE0",
  "Is not (exact code)": "N'est pas (code exact)",
  "Is not (exact email)": "N'est pas (email exact)",
  "Is not (exact sku)": "N'est pas (SKU exact)",
  "Is not (exact title)": "N'est pas (titre exact)",
  "Is not (exact variant name)": "N'est pas (nom de variante exact)",
  "Is not available at all the sales channels from the list": "N'est pas disponible sur tous les canaux de vente de la liste",
  "Is not available at all the sales channels in the list": "N'est pas disponible sur tous les canaux de vente de la liste",
  "Is not available at one of the sales channels from the list": "N'est pas disponible sur l'un des canaux de vente de la liste",
  "Is not available at one of the sales channels in the list": "N'est disponible sur aucun des canaux de vente de la liste",
  "Is not between": "N'est pas entre",
  "Is not equal to": "N'est pas \xE9gal \xE0",
  "Is not from a vendor in the list": "Ne provient pas d'un vendeur de la liste",
  "Is not from the list": "Ne provient pas de la liste",
  "Is not in a category from the list": "N'est pas dans une cat\xE9gorie de la liste",
  "Is not in a collection from the list": "N'est pas dans une collection de la liste",
  "Is not of a type from the list": "N'est pas d'un type de la liste",
  "Is not on": "N'est pas le",
  "Is not one of the countries from the list": "N'est pas l'un des pays de la liste",
  "Is not one of the customer segments from the list": "Ne fait pas partie d'un des segments de client\xE8le de la liste",
  "Is not one of the fulfillment statuses in the list": "N'est pas l'un des statuts d'ex\xE9cution de la liste",
  "Is not one of the languages from the list": "N'est pas l'une des langues de la liste",
  "Is not one of the methods in the list": "N'est pas l'une des m\xE9thodes de la liste",
  "Is not one of the payment statuses in the list": "N'est pas l'un des statuts de paiement de la liste",
  "Is not tagged with all the tags in the list": "N'est pas balis\xE9 avec toutes les balises de la liste",
  "Is not tagged with any of the tags in the list": "N'est pas \xE9tiquet\xE9 avec l'une des \xE9tiquettes de la liste",
  "Is not tagged with at least one of the tags in the list": "N'est pas balis\xE9 avec au moins une des balises de la liste",
  "Is of a type from the list": "Est d'un type de la liste",
  "Is on": "Est le",
  "Is one of the countries from the list": "Est l'un des pays de la liste",
  "Is one of the customer segments from the list": "Fait partie d'un des segments de client\xE8le de la liste",
  "Is one of the fulfillment statuses in the list": "Est l'un des statuts d'ex\xE9cution de la liste",
  "Is one of the languages from the list": "Est l'une des langues de la liste",
  "Is one of the methods in the list": "Est l'une des m\xE9thodes de la liste",
  "Is one of the payment statuses in the list": "Est l'un des statuts de paiement de la liste",
  "Is tagged with all the tags in the list": "Est \xE9tiquet\xE9 avec toutes les \xE9tiquettes de la liste",
  "Is tagged with at least one of the tags in the list": "Est \xE9tiquet\xE9 avec au moins une des \xE9tiquettes de la liste",
  "Item cost": "Co\xFBt de l'article",
  Language: "Langue",
  "Less than": "Inf\xE9rieur \xE0",
  "Less than or equals to": "Inf\xE9rieur ou \xE9gal \xE0",
  "Marketing consent": "Consentement marketing",
  Minutes: "Minutes",
  Months: "Mois",
  "Number of orders": "Nombre de commandes",
  "On all of the post purchase pages": "Sur toutes les pages post-achat",
  "On one of the post purchase pages": "Sur l'une des pages post-achat",
  "On the checkout": "Sur la page de paiement",
  "On the post purchase 1st page": "Sur la 1\xE8re page post-achat",
  "On the post purchase 2nd page": "Sur la 2\xE8me page post-achat",
  "On the thank you page": "Sur la page de remerciement",
  "Order note": "Note de commande",
  "Order tags": "\xC9tiquettes de commande",
  "Passed X time ago": "Pass\xE9 il y a X",
  "Payment method": "Mode de paiement",
  "please add cart or order value": "veuillez ajouter une valeur de panier ou de commande",
  "please add customer email": "veuillez ajouter l'email du client",
  "please add customer number of orders": "veuillez ajouter le nombre de commandes du client",
  "please add discount code": "veuillez ajouter un code de r\xE9duction",
  "please add item cost": "veuillez ajouter le co\xFBt de l'article",
  "please add number of orders": "Veuillez ajouter le nombre de commandes",
  "please add order note": "veuillez ajouter une note de commande",
  "please add product price": "Veuillez ajouter le prix du produit",
  "please add product sku": "veuillez ajouter un SKU de produit",
  "please add product title": "veuillez ajouter un titre de produit",
  "please add product variant name": "veuillez ajouter un nom de variante de produit",
  "please add shipping value": "veuillez ajouter la valeur de livraison",
  "please add time since last order": "Veuillez ajouter le temps \xE9coul\xE9 depuis la derni\xE8re commande",
  "please add total item count": "Veuillez ajouter le nombre total d'articles",
  "please add value": "veuillez ajouter une valeur",
  "please select collections": "veuillez s\xE9lectionner des collections",
  "please select customer birthday": "Veuillez s\xE9lectionner l'anniversaire du client",
  "please select customer country": "veuillez s\xE9lectionner le pays du client",
  "please select customer language": "veuillez s\xE9lectionner la langue du client",
  "please select customer segments": "veuillez s\xE9lectionner des segments de client\xE8le",
  "please select customer tag": "veuillez s\xE9lectionner l'\xE9tiquette du client",
  "please select customer tags": "Veuillez s\xE9lectionner des balises client",
  "please select fulfillment statuses": "veuillez s\xE9lectionner les statuts d'ex\xE9cution",
  "please select offer": "veuillez s\xE9lectionner une offre",
  "please select payment method": "Veuillez s\xE9lectionner le mode de paiement",
  "please select payment statuses": "Veuillez s\xE9lectionner les statuts de paiement",
  "please select product type": "Veuillez s\xE9lectionner le type de produit",
  "please select product vendor": "Veuillez s\xE9lectionner le vendeur du produit",
  "please select products": "veuillez s\xE9lectionner des produits",
  "please select sales channel": "veuillez s\xE9lectionner un canal de vente",
  "please select shipping methods": "veuillez s\xE9lectionner les m\xE9thodes d'exp\xE9dition",
  "please select tags": "veuillez s\xE9lectionner des \xE9tiquettes",
  "Previous page offer": "Offre de la page pr\xE9c\xE9dente",
  product: "produit",
  "Product recommendations": "Recommandations de produits",
  "Product type": "Type de produit",
  "Product upsell": "Upsell de produit",
  products: "produits",
  "Requires shipping": "N\xE9cessite une exp\xE9dition",
  "Shipping method": "M\xE9thode d'exp\xE9dition",
  "Shipping value": "Valeur de livraison",
  "Starts with": "Commence par",
  Status: "Statut",
  "The displayed product": "Le produit affich\xE9",
  "The displayed product SKU": "Le SKU du produit affich\xE9",
  "The only product title in the cart": "Le seul titre de produit dans le panier",
  "The only SKU in the cart": "Le seul SKU dans le panier",
  "The SKU of all products in the cart": "Le SKU de tous les produits dans le panier",
  "The SKU of at least one product in the cart": "Le SKU d'au moins un produit dans le panier",
  "The title of all products in the cart": "Le titre de tous les produits dans le panier",
  "The title of at least one product in the cart": "Le titre d'au moins un produit dans le panier",
  "The title of the displayed product": "Le titre du produit affich\xE9",
  "The variant of all products in the cart": "La variante de tous les produits dans le panier",
  "The variant of at least one product in the cart": "La variante d'au moins un produit dans le panier",
  "The variant of only product in the cart": "La variante du seul produit dans le panier",
  "The variant of the displayed product": "La variante du produit affich\xE9",
  "Total item count": "Nombre total d'articles",
  Weeks: "Semaines",
  Years: "Ann\xE9es"
};

// src/lang/it.json
var it_default = {
  "An offer was accepted": "Un'offerta \xE8 stata accettata",
  "An offer was declined": "Un'offerta \xE8 stata rifiutata",
  and: "e",
  "Announcement bar": "Barra degli annunci",
  "Are available at all the sales channels from the list": "Sono disponibili in tutti i canali di vendita della lista",
  "Are available at one of the sales channels from the list": "Sono disponibili in uno dei canali di vendita della lista",
  "Are not available at all the sales channels from the list": "Non sono disponibili in nessuno dei canali di vendita della lista",
  "Are not available at one of the sales channels from the list": "Non sono disponibili in uno dei canali di vendita della lista",
  "At least one product in the cart": "Almeno un prodotto nel carrello",
  Banner: "Banner",
  Between: "Tra",
  Bundle: "Bundle",
  "Cart/Order value": "Valore carrello/ordine",
  categories: "categorie",
  category: "categoria",
  collection: "collezione",
  collections: "collezioni",
  Contains: "Contiene",
  "Customer accepted marketing": "Il cliente ha accettato il marketing",
  "Customer birthday": "Compleanno del cliente",
  "Customer country": "Paese del cliente",
  "customer doesn't have all the tags from the list": "il cliente non ha tutti i tag della lista",
  "customer doesn't have any of the tags from the list": "il cliente non ha nessuno dei tag della lista",
  "Customer don't accepted marketing": "Il cliente non ha accettato il marketing",
  "Customer email": "Email del cliente",
  "customer has all the tags from the list": "il cliente ha tutti i tag della lista",
  "customer has at least one of the tags from the list ": "il cliente ha almeno uno dei tag della lista",
  "Customer number of orders": "Numero di ordini del cliente",
  "Customer segments": "Segmenti di clientela",
  "Customer tag": "Tag cliente",
  Days: "Giorni",
  "Discount code": "Codice sconto",
  "Does not require shipping": "Non richiede spedizione",
  "Doesn't contain": "Non contiene",
  "Doesn't end with": "Non finisce con",
  "Doesn't have all the tags from the list": "Non ha tutti i tag della lista",
  "Doesn't have some of the tags from the list": "Non ha alcuni dei tag della lista",
  "Doesn't start with": "Non inizia con",
  "Ends with": "Finisce con",
  "Equal to": "Uguale a",
  Equals: "\xC8 uguale a",
  "Every product in the cart": "Ogni prodotto nel carrello",
  "Greater than": "Maggiore di",
  "Greater than or equals to": "Maggiore o uguale a",
  "Has all the tags from the list": "Ha tutti i tag della lista",
  "Has at least one of the tags from the list": "Ha almeno uno dei tag della lista",
  Hours: "Ore",
  "in less than": "tra meno di",
  "Is (exact code)": "\xC8 (codice esatto)",
  "Is (exact email)": "\xC8 (email esatta)",
  "Is (exact sku)": "\xC8 (SKU esatto)",
  "Is (exact title)": "\xC8 (titolo esatto)",
  "Is (exact variant name)": "\xC8 (nome variante esatto)",
  "Is after": "\xC8 dopo il",
  "Is available at all the sales channels from the list": "\xC8 disponibile in tutti i canali di vendita della lista",
  "Is available at all the sales channels in the list": "\xC8 disponibile in tutti i canali di vendita nell'elenco",
  "Is available at one of the sales channels from the list": "\xC8 disponibile in uno dei canali di vendita della lista",
  "Is available at one of the sales channels in the list": "\xC8 disponibile in uno dei canali di vendita nell'elenco",
  "Is before": "\xC8 prima del",
  "Is between": "\xC8 compreso tra",
  "Is from a vendor in the list": "Proviene da un fornitore nell'elenco",
  "Is from the list": "\xC8 dalla lista",
  "Is greater than": "\xC8 maggiore di",
  "Is greater than or equals to": "\xC8 maggiore o uguale a",
  "Is in a category from the list": "\xC8 in una categoria dalla lista",
  "Is in a collection from the list": "\xC8 in una collezione dalla lista",
  "Is less than": "\xC8 minore di",
  "Is less than or equals to": "\xC8 minore o uguale a",
  "Is not (exact code)": "Non \xE8 (codice esatto)",
  "Is not (exact email)": "Non \xE8 (email esatta)",
  "Is not (exact sku)": "Non \xE8 (SKU esatto)",
  "Is not (exact title)": "Non \xE8 (titolo esatto)",
  "Is not (exact variant name)": "Non \xE8 (nome variante esatto)",
  "Is not available at all the sales channels from the list": "Non \xE8 disponibile in nessuno dei canali di vendita della lista",
  "Is not available at all the sales channels in the list": "Non \xE8 disponibile in tutti i canali di vendita nell'elenco",
  "Is not available at one of the sales channels from the list": "Non \xE8 disponibile in uno dei canali di vendita della lista",
  "Is not available at one of the sales channels in the list": "Non \xE8 disponibile in nessuno dei canali di vendita nell'elenco",
  "Is not between": "Non \xE8 tra",
  "Is not equal to": "Non \xE8 uguale a",
  "Is not from a vendor in the list": "Non proviene da un fornitore nell'elenco",
  "Is not from the list": "Non \xE8 dalla lista",
  "Is not in a category from the list": "Non \xE8 in una categoria dalla lista",
  "Is not in a collection from the list": "Non \xE8 in una collezione dalla lista",
  "Is not of a type from the list": "Non \xE8 di un tipo presente nell'elenco",
  "Is not on": "Non \xE8 il",
  "Is not one of the countries from the list": "Non \xE8 uno dei paesi della lista",
  "Is not one of the customer segments from the list": "Non appartiene a uno dei segmenti di clientela della lista",
  "Is not one of the fulfillment statuses in the list": "Non \xE8 uno degli stati di evasione nella lista",
  "Is not one of the languages from the list": "Non \xE8 una delle lingue della lista",
  "Is not one of the methods in the list": "Non \xE8 uno dei metodi nell'elenco",
  "Is not one of the payment statuses in the list": "Non \xE8 uno degli stati di pagamento nell'elenco",
  "Is not tagged with all the tags in the list": "Non \xE8 contrassegnato con tutti i tag nell'elenco",
  "Is not tagged with any of the tags in the list": "Non \xE8 contrassegnato con nessuno dei tag nella lista",
  "Is not tagged with at least one of the tags in the list": "Non \xE8 contrassegnato con almeno uno dei tag nell'elenco",
  "Is of a type from the list": "\xC8 di un tipo presente nell'elenco",
  "Is on": "\xC8 il",
  "Is one of the countries from the list": "\xC8 uno dei paesi della lista",
  "Is one of the customer segments from the list": "Appartiene a uno dei segmenti di clientela della lista",
  "Is one of the fulfillment statuses in the list": "\xC8 uno degli stati di evasione nella lista",
  "Is one of the languages from the list": "\xC8 una delle lingue della lista",
  "Is one of the methods in the list": "\xC8 uno dei metodi nell'elenco",
  "Is one of the payment statuses in the list": "\xC8 uno degli stati di pagamento nell'elenco",
  "Is tagged with all the tags in the list": "\xC8 contrassegnato con tutti i tag nella lista",
  "Is tagged with at least one of the tags in the list": "\xC8 contrassegnato con almeno uno dei tag nella lista",
  "Item cost": "Costo dell'articolo",
  Language: "Lingua",
  "Less than": "Minore di",
  "Less than or equals to": "Minore o uguale a",
  "Marketing consent": "Consenso al marketing",
  Minutes: "Minuti",
  Months: "Mesi",
  "Number of orders": "Numero di ordini",
  "On all of the post purchase pages": "Su tutte le pagine post-acquisto",
  "On one of the post purchase pages": "Su una delle pagine post-acquisto",
  "On the checkout": "Al checkout",
  "On the post purchase 1st page": "Sulla 1\xAA pagina post-acquisto",
  "On the post purchase 2nd page": "Sulla 2\xAA pagina post-acquisto",
  "On the thank you page": "Sulla pagina di ringraziamento",
  "Order note": "Nota dell'ordine",
  "Order tags": "Tag dell'ordine",
  "Passed X time ago": "Passato da X",
  "Payment method": "Metodo di pagamento",
  "please add cart or order value": "aggiungi il valore del carrello o dell'ordine",
  "please add customer email": "aggiungi l'email del cliente",
  "please add customer number of orders": "aggiungi il numero di ordini del cliente",
  "please add discount code": "aggiungi il codice sconto",
  "please add item cost": "Si prega di aggiungere il costo dell'articolo",
  "please add number of orders": "Si prega di aggiungere il numero di ordini",
  "please add order note": "aggiungi la nota dell'ordine",
  "please add product price": "Si prega di aggiungere il prezzo del prodotto",
  "please add product sku": "aggiungi lo SKU del prodotto",
  "please add product title": "aggiungi il titolo del prodotto",
  "please add product variant name": "aggiungi il nome della variante del prodotto",
  "please add shipping value": "aggiungi il valore di spedizione",
  "please add time since last order": "Aggiungi il tempo trascorso dall'ultimo ordine",
  "please add total item count": "Si prega di aggiungere il conteggio totale degli articoli",
  "please add value": "aggiungi un valore",
  "please select collections": "seleziona le collezioni",
  "please select customer birthday": "Seleziona il compleanno del cliente",
  "please select customer country": "seleziona il paese del cliente",
  "please select customer language": "seleziona la lingua del cliente",
  "please select customer segments": "seleziona i segmenti di clientela",
  "please select customer tag": "seleziona il tag del cliente",
  "please select customer tags": "Seleziona i tag cliente",
  "please select fulfillment statuses": "seleziona gli stati di evasione",
  "please select offer": "seleziona l'offerta",
  "please select payment method": "Si prega di selezionare il metodo di pagamento",
  "please select payment statuses": "Si prega di selezionare gli stati di pagamento",
  "please select product type": "Si prega di selezionare il tipo di prodotto",
  "please select product vendor": "Si prega di selezionare il fornitore del prodotto",
  "please select products": "seleziona i prodotti",
  "please select sales channel": "seleziona il canale di vendita",
  "please select shipping methods": "seleziona i metodi di spedizione",
  "please select tags": "seleziona i tag",
  "Previous page offer": "Offerta della pagina precedente",
  product: "prodotto",
  "Product recommendations": "Raccomandazioni di prodotti",
  "Product type": "Tipo di prodotto",
  "Product upsell": "Upsell di prodotto",
  products: "prodotti",
  "Requires shipping": "Richiede spedizione",
  "Shipping method": "Metodo di spedizione",
  "Shipping value": "Valore di spedizione",
  "Starts with": "Inizia con",
  Status: "Stato",
  "The displayed product": "Il prodotto visualizzato",
  "The displayed product SKU": "Lo SKU del prodotto visualizzato",
  "The only product title in the cart": "L'unico titolo del prodotto nel carrello",
  "The only SKU in the cart": "L'unico SKU nel carrello",
  "The SKU of all products in the cart": "Lo SKU di tutti i prodotti nel carrello",
  "The SKU of at least one product in the cart": "Lo SKU di almeno un prodotto nel carrello",
  "The title of all products in the cart": "Il titolo di tutti i prodotti nel carrello",
  "The title of at least one product in the cart": "Il titolo di almeno un prodotto nel carrello",
  "The title of the displayed product": "Il titolo del prodotto visualizzato",
  "The variant of all products in the cart": "La variante di tutti i prodotti nel carrello",
  "The variant of at least one product in the cart": "La variante di almeno un prodotto nel carrello",
  "The variant of only product in the cart": "La variante dell'unico prodotto nel carrello",
  "The variant of the displayed product": "La variante del prodotto visualizzato",
  "Total item count": "Conteggio totale articoli",
  Weeks: "Settimane",
  Years: "Anni"
};

// src/lang/zh_CN.json
var zh_CN_default = {
  "An offer was accepted": "\u4E00\u4E2A\u4F18\u60E0\u88AB\u63A5\u53D7",
  "An offer was declined": "\u4E00\u4E2A\u4F18\u60E0\u88AB\u62D2\u7EDD",
  and: "\u548C",
  "Announcement bar": "\u516C\u544A\u680F",
  "Are available at all the sales channels from the list": "\u5728\u5217\u8868\u4E2D\u7684\u6240\u6709\u9500\u552E\u6E20\u9053\u4E0A\u53EF\u7528",
  "Are available at one of the sales channels from the list": "\u5728\u5217\u8868\u4E2D\u7684\u67D0\u4E2A\u9500\u552E\u6E20\u9053\u4E0A\u53EF\u7528",
  "Are not available at all the sales channels from the list": "\u4E0D\u5728\u5217\u8868\u4E2D\u7684\u4EFB\u4F55\u9500\u552E\u6E20\u9053\u4E0A\u53EF\u7528",
  "Are not available at one of the sales channels from the list": "\u4E0D\u5728\u5217\u8868\u4E2D\u7684\u4EFB\u4F55\u4E00\u4E2A\u9500\u552E\u6E20\u9053\u4E0A\u53EF\u7528",
  "At least one product in the cart": "\u8D2D\u7269\u8F66\u4E2D\u81F3\u5C11\u6709\u4E00\u4EF6\u4EA7\u54C1",
  Banner: "\u6A2A\u5E45",
  Between: "\u4ECB\u4E8E",
  Bundle: "\u6346\u7ED1\u5305",
  "Cart/Order value": "\u8D2D\u7269\u8F66/\u8BA2\u5355\u4EF7\u503C",
  categories: "\u7C7B\u522B",
  category: "\u7C7B\u522B",
  collection: "\u7CFB\u5217",
  collections: "\u7CFB\u5217",
  Contains: "\u5305\u542B",
  "Customer accepted marketing": "\u5BA2\u6237\u63A5\u53D7\u8425\u9500",
  "Customer birthday": "\u5BA2\u6237\u751F\u65E5",
  "Customer country": "\u987E\u5BA2\u56FD\u5BB6",
  "customer doesn't have all the tags from the list": "\u987E\u5BA2\u6CA1\u6709\u5217\u8868\u4E2D\u7684\u6240\u6709\u6807\u7B7E",
  "customer doesn't have any of the tags from the list": "\u987E\u5BA2\u6CA1\u6709\u4EFB\u4F55\u5217\u8868\u4E2D\u7684\u6807\u7B7E",
  "Customer don't accepted marketing": "\u5BA2\u6237\u4E0D\u63A5\u53D7\u8425\u9500",
  "Customer email": "\u987E\u5BA2\u90AE\u7BB1",
  "customer has all the tags from the list": "\u987E\u5BA2\u62E5\u6709\u5217\u8868\u4E2D\u7684\u6240\u6709\u6807\u7B7E",
  "customer has at least one of the tags from the list ": "\u987E\u5BA2\u81F3\u5C11\u62E5\u6709\u5217\u8868\u4E2D\u7684\u4E00\u4E2A\u6807\u7B7E",
  "Customer number of orders": "\u987E\u5BA2\u8BA2\u5355\u6570",
  "Customer segments": "\u987E\u5BA2\u7EC6\u5206",
  "Customer tag": "\u5BA2\u6237\u6807\u7B7E",
  Days: "\u5929",
  "Discount code": "\u6298\u6263\u7801",
  "Does not require shipping": "\u4E0D\u9700\u8981\u8FD0\u9001",
  "Doesn't contain": "\u4E0D\u5305\u542B",
  "Doesn't end with": "\u7ED3\u5C3E\u4E0D\u662F",
  "Doesn't have all the tags from the list": "\u6CA1\u6709\u5217\u8868\u4E2D\u7684\u6240\u6709\u6807\u7B7E",
  "Doesn't have some of the tags from the list": "\u6CA1\u6709\u5217\u8868\u4E2D\u7684\u67D0\u4E9B\u6807\u7B7E",
  "Doesn't start with": "\u5F00\u5934\u4E0D\u662F",
  "Ends with": "\u7ED3\u5C3E\u662F",
  "Equal to": "\u7B49\u4E8E",
  Equals: "\u7B49\u4E8E",
  "Every product in the cart": "\u8D2D\u7269\u8F66\u4E2D\u7684\u6BCF\u4E00\u4EF6\u4EA7\u54C1",
  "Greater than": "\u5927\u4E8E",
  "Greater than or equals to": "\u5927\u4E8E\u6216\u7B49\u4E8E",
  "Has all the tags from the list": "\u62E5\u6709\u5217\u8868\u4E2D\u7684\u6240\u6709\u6807\u7B7E",
  "Has at least one of the tags from the list": "\u81F3\u5C11\u6709\u5217\u8868\u4E2D\u7684\u4E00\u4E2A\u6807\u7B7E",
  Hours: "\u5C0F\u65F6",
  "in less than": "\u5C11\u4E8E",
  "Is (exact code)": "\u662F\uFF08\u786E\u5207\u4EE3\u7801\uFF09",
  "Is (exact email)": "\u662F\uFF08\u786E\u5207\u90AE\u7BB1\uFF09",
  "Is (exact sku)": "\u662F\uFF08\u786E\u5207 SKU\uFF09",
  "Is (exact title)": "\u662F\uFF08\u786E\u5207\u6807\u9898\uFF09",
  "Is (exact variant name)": "\u662F\uFF08\u786E\u5207\u53D8\u4F53\u540D\u79F0\uFF09",
  "Is after": "\u665A\u4E8E",
  "Is available at all the sales channels from the list": "\u5728\u5217\u8868\u4E2D\u7684\u6240\u6709\u9500\u552E\u6E20\u9053\u4E0A\u53EF\u7528",
  "Is available at all the sales channels in the list": "\u5728\u5217\u8868\u4E2D\u7684\u6240\u6709\u9500\u552E\u6E20\u9053\u90FD\u53EF\u7528",
  "Is available at one of the sales channels from the list": "\u5728\u5217\u8868\u4E2D\u7684\u67D0\u4E2A\u9500\u552E\u6E20\u9053\u4E0A\u53EF\u7528",
  "Is available at one of the sales channels in the list": "\u5728\u5217\u8868\u4E2D\u7684\u67D0\u4E2A\u9500\u552E\u6E20\u9053\u53EF\u7528",
  "Is before": "\u65E9\u4E8E",
  "Is between": "\u4ECB\u4E8E",
  "Is from a vendor in the list": "\u5C5E\u4E8E\u5217\u8868\u4E2D\u7684\u5382\u5546",
  "Is from the list": "\u6765\u81EA\u5217\u8868",
  "Is greater than": "\u5927\u4E8E",
  "Is greater than or equals to": "\u5927\u4E8E\u6216\u7B49\u4E8E",
  "Is in a category from the list": "\u5728\u5217\u8868\u4E2D\u7684\u67D0\u4E2A\u7C7B\u522B\u91CC",
  "Is in a collection from the list": "\u5728\u5217\u8868\u4E2D\u7684\u67D0\u4E2A\u7CFB\u5217\u91CC",
  "Is less than": "\u5C0F\u4E8E",
  "Is less than or equals to": "\u5C0F\u4E8E\u6216\u7B49\u4E8E",
  "Is not (exact code)": "\u4E0D\u662F\uFF08\u786E\u5207\u4EE3\u7801\uFF09",
  "Is not (exact email)": "\u4E0D\u662F\uFF08\u786E\u5207\u90AE\u7BB1\uFF09",
  "Is not (exact sku)": "\u4E0D\u662F\uFF08\u786E\u5207 SKU\uFF09",
  "Is not (exact title)": "\u4E0D\u662F\uFF08\u786E\u5207\u6807\u9898\uFF09",
  "Is not (exact variant name)": "\u4E0D\u662F\uFF08\u786E\u5207\u53D8\u4F53\u540D\u79F0\uFF09",
  "Is not available at all the sales channels from the list": "\u4E0D\u5728\u5217\u8868\u4E2D\u7684\u4EFB\u4F55\u9500\u552E\u6E20\u9053\u4E0A\u53EF\u7528",
  "Is not available at all the sales channels in the list": "\u5E76\u975E\u5728\u5217\u8868\u4E2D\u7684\u6240\u6709\u9500\u552E\u6E20\u9053\u90FD\u53EF\u7528",
  "Is not available at one of the sales channels from the list": "\u4E0D\u5728\u5217\u8868\u4E2D\u7684\u4EFB\u4F55\u4E00\u4E2A\u9500\u552E\u6E20\u9053\u4E0A\u53EF\u7528",
  "Is not available at one of the sales channels in the list": "\u5728\u5217\u8868\u4E2D\u7684\u4EFB\u4F55\u9500\u552E\u6E20\u9053\u90FD\u4E0D\u53EF\u7528",
  "Is not between": "\u4E0D\u4ECB\u4E8E",
  "Is not equal to": "\u4E0D\u7B49\u4E8E",
  "Is not from a vendor in the list": "\u4E0D\u5C5E\u4E8E\u5217\u8868\u4E2D\u7684\u5382\u5546",
  "Is not from the list": "\u4E0D\u6765\u81EA\u5217\u8868",
  "Is not in a category from the list": "\u4E0D\u5728\u5217\u8868\u4E2D\u7684\u4EFB\u4F55\u7C7B\u522B\u91CC",
  "Is not in a collection from the list": "\u4E0D\u5728\u5217\u8868\u4E2D\u7684\u4EFB\u4F55\u7CFB\u5217\u91CC",
  "Is not of a type from the list": "\u4E0D\u5C5E\u4E8E\u5217\u8868\u4E2D\u7684\u7C7B\u578B",
  "Is not on": "\u4E0D\u662F",
  "Is not one of the countries from the list": "\u4E0D\u662F\u5217\u8868\u4E2D\u7684\u56FD\u5BB6\u4E4B\u4E00",
  "Is not one of the customer segments from the list": "\u4E0D\u662F\u5217\u8868\u4E2D\u7684\u987E\u5BA2\u7EC6\u5206\u5E02\u573A\u4E4B\u4E00",
  "Is not one of the fulfillment statuses in the list": "\u4E0D\u662F\u5217\u8868\u4E2D\u7684\u5C65\u7EA6\u72B6\u6001\u4E4B\u4E00",
  "Is not one of the languages from the list": "\u4E0D\u662F\u5217\u8868\u4E2D\u7684\u8BED\u8A00\u4E4B\u4E00",
  "Is not one of the methods in the list": "\u4E0D\u662F\u5217\u8868\u4E2D\u7684\u65B9\u5F0F\u4E4B\u4E00",
  "Is not one of the payment statuses in the list": "\u4E0D\u662F\u5217\u8868\u4E2D\u7684\u4ED8\u6B3E\u72B6\u6001\u4E4B\u4E00",
  "Is not tagged with all the tags in the list": "\u672A\u6807\u8BB0\u5217\u8868\u4E2D\u7684\u6240\u6709\u6807\u7B7E",
  "Is not tagged with any of the tags in the list": "\u672A\u6807\u8BB0\u5217\u8868\u4E2D\u7684\u4EFB\u4F55\u6807\u7B7E",
  "Is not tagged with at least one of the tags in the list": "\u672A\u6807\u8BB0\u5217\u8868\u4E2D\u7684\u81F3\u5C11\u4E00\u4E2A\u6807\u7B7E",
  "Is of a type from the list": "\u5C5E\u4E8E\u5217\u8868\u4E2D\u7684\u7C7B\u578B",
  "Is on": "\u662F",
  "Is one of the countries from the list": "\u662F\u5217\u8868\u4E2D\u7684\u56FD\u5BB6\u4E4B\u4E00",
  "Is one of the customer segments from the list": "\u662F\u5217\u8868\u4E2D\u7684\u987E\u5BA2\u7EC6\u5206\u5E02\u573A\u4E4B\u4E00",
  "Is one of the fulfillment statuses in the list": "\u662F\u5217\u8868\u4E2D\u7684\u5C65\u7EA6\u72B6\u6001\u4E4B\u4E00",
  "Is one of the languages from the list": "\u662F\u5217\u8868\u4E2D\u7684\u8BED\u8A00\u4E4B\u4E00",
  "Is one of the methods in the list": "\u662F\u5217\u8868\u4E2D\u7684\u65B9\u5F0F\u4E4B\u4E00",
  "Is one of the payment statuses in the list": "\u662F\u5217\u8868\u4E2D\u7684\u4ED8\u6B3E\u72B6\u6001\u4E4B\u4E00",
  "Is tagged with all the tags in the list": "\u6807\u8BB0\u4E86\u5217\u8868\u4E2D\u7684\u6240\u6709\u6807\u7B7E",
  "Is tagged with at least one of the tags in the list": "\u6807\u8BB0\u4E86\u5217\u8868\u4E2D\u81F3\u5C11\u4E00\u4E2A\u6807\u7B7E",
  "Item cost": "\u5546\u54C1\u6210\u672C",
  Language: "\u8BED\u8A00",
  "Less than": "\u5C0F\u4E8E",
  "Less than or equals to": "\u5C0F\u4E8E\u6216\u7B49\u4E8E",
  "Marketing consent": "\u8425\u9500\u8BB8\u53EF",
  Minutes: "\u5206\u949F",
  Months: "\u6708",
  "Number of orders": "\u8BA2\u5355\u6570\u91CF",
  "On all of the post purchase pages": "\u5728\u6240\u6709\u8D2D\u540E\u9875\u9762\u4E0A",
  "On one of the post purchase pages": "\u5728\u5176\u4E2D\u4E00\u4E2A\u8D2D\u540E\u9875\u9762\u4E0A",
  "On the checkout": "\u5728\u7ED3\u8D26\u65F6",
  "On the post purchase 1st page": "\u5728\u8D2D\u540E\u7B2C 1 \u9875\u4E0A",
  "On the post purchase 2nd page": "\u5728\u8D2D\u540E\u7B2C 2 \u9875\u4E0A",
  "On the thank you page": "\u5728\u611F\u8C22\u9875\u9762\u4E0A",
  "Order note": "\u8BA2\u5355\u5907\u6CE8",
  "Order tags": "\u8BA2\u5355\u6807\u7B7E",
  "Passed X time ago": "\u8FC7\u53BB X \u524D",
  "Payment method": "\u4ED8\u6B3E\u65B9\u5F0F",
  "please add cart or order value": "\u8BF7\u6DFB\u52A0\u8D2D\u7269\u8F66\u6216\u8BA2\u5355\u4EF7\u503C",
  "please add customer email": "\u8BF7\u6DFB\u52A0\u987E\u5BA2\u90AE\u7BB1",
  "please add customer number of orders": "\u8BF7\u6DFB\u52A0\u987E\u5BA2\u8BA2\u5355\u6570",
  "please add discount code": "\u8BF7\u6DFB\u52A0\u6298\u6263\u7801",
  "please add item cost": "\u8BF7\u6DFB\u52A0\u5546\u54C1\u6210\u672C",
  "please add number of orders": "\u8BF7\u6DFB\u52A0\u8BA2\u5355\u6570\u91CF",
  "please add order note": "\u8BF7\u6DFB\u52A0\u8BA2\u5355\u5907\u6CE8",
  "please add product price": "\u8BF7\u6DFB\u52A0\u4EA7\u54C1\u4EF7\u683C",
  "please add product sku": "\u8BF7\u6DFB\u52A0\u4EA7\u54C1 SKU",
  "please add product title": "\u8BF7\u6DFB\u52A0\u4EA7\u54C1\u6807\u9898",
  "please add product variant name": "\u8BF7\u6DFB\u52A0\u4EA7\u54C1\u53D8\u4F53\u540D\u79F0",
  "please add shipping value": "\u8BF7\u6DFB\u52A0\u8FD0\u8D39",
  "please add time since last order": "\u8BF7\u6DFB\u52A0\u81EA\u4E0A\u6B21\u8BA2\u5355\u4EE5\u6765\u7684\u65F6\u95F4",
  "please add total item count": "\u8BF7\u6DFB\u52A0\u603B\u5546\u54C1\u6570\u91CF",
  "please add value": "\u8BF7\u6DFB\u52A0\u503C",
  "please select collections": "\u8BF7\u9009\u62E9\u7CFB\u5217",
  "please select customer birthday": "\u8BF7\u9009\u62E9\u5BA2\u6237\u751F\u65E5",
  "please select customer country": "\u8BF7\u9009\u62E9\u987E\u5BA2\u56FD\u5BB6",
  "please select customer language": "\u8BF7\u9009\u62E9\u987E\u5BA2\u8BED\u8A00",
  "please select customer segments": "\u8BF7\u9009\u62E9\u987E\u5BA2\u7EC6\u5206",
  "please select customer tag": "\u8BF7\u9009\u62E9\u987E\u5BA2\u6807\u7B7E",
  "please select customer tags": "\u8BF7\u9009\u62E9\u5BA2\u6237\u6807\u7B7E",
  "please select fulfillment statuses": "\u8BF7\u9009\u62E9\u5C65\u7EA6\u72B6\u6001",
  "please select offer": "\u8BF7\u9009\u62E9\u4F18\u60E0",
  "please select payment method": "\u8BF7\u9009\u62E9\u4ED8\u6B3E\u65B9\u5F0F",
  "please select payment statuses": "\u8BF7\u9009\u62E9\u4ED8\u6B3E\u72B6\u6001",
  "please select product type": "\u8BF7\u9009\u62E9\u4EA7\u54C1\u7C7B\u578B",
  "please select product vendor": "\u8BF7\u9009\u62E9\u4EA7\u54C1\u5382\u5546",
  "please select products": "\u8BF7\u9009\u62E9\u4EA7\u54C1",
  "please select sales channel": "\u8BF7\u9009\u62E9\u9500\u552E\u6E20\u9053",
  "please select shipping methods": "\u8BF7\u9009\u62E9\u914D\u9001\u65B9\u5F0F",
  "please select tags": "\u8BF7\u9009\u62E9\u6807\u7B7E",
  "Previous page offer": "\u4E0A\u4E00\u9875\u4F18\u60E0",
  product: "\u4EA7\u54C1",
  "Product recommendations": "\u4EA7\u54C1\u63A8\u8350",
  "Product type": "\u4EA7\u54C1\u7C7B\u578B",
  "Product upsell": "\u4EA7\u54C1\u589E\u9500",
  products: "\u4EA7\u54C1",
  "Requires shipping": "\u9700\u8981\u8FD0\u9001",
  "Shipping method": "\u914D\u9001\u65B9\u5F0F",
  "Shipping value": "\u8FD0\u8D39",
  "Starts with": "\u5F00\u5934\u662F",
  Status: "\u72B6\u6001",
  "The displayed product": "\u663E\u793A\u7684\u4EA7\u54C1",
  "The displayed product SKU": "\u663E\u793A\u4EA7\u54C1\u7684 SKU",
  "The only product title in the cart": "\u8D2D\u7269\u8F66\u4E2D\u552F\u4E00\u4EA7\u54C1\u7684\u6807\u9898",
  "The only SKU in the cart": "\u8D2D\u7269\u8F66\u4E2D\u552F\u4E00\u7684 SKU",
  "The SKU of all products in the cart": "\u8D2D\u7269\u8F66\u4E2D\u6240\u6709\u4EA7\u54C1\u7684 SKU",
  "The SKU of at least one product in the cart": "\u8D2D\u7269\u8F66\u4E2D\u81F3\u5C11\u4E00\u4EF6\u4EA7\u54C1\u7684 SKU",
  "The title of all products in the cart": "\u8D2D\u7269\u8F66\u4E2D\u6240\u6709\u4EA7\u54C1\u7684\u6807\u9898",
  "The title of at least one product in the cart": "\u8D2D\u7269\u8F66\u4E2D\u81F3\u5C11\u4E00\u4EF6\u4EA7\u54C1\u7684\u6807\u9898",
  "The title of the displayed product": "\u663E\u793A\u4EA7\u54C1\u7684\u6807\u9898",
  "The variant of all products in the cart": "\u8D2D\u7269\u8F66\u4E2D\u6240\u6709\u4EA7\u54C1\u7684\u53D8\u4F53",
  "The variant of at least one product in the cart": "\u8D2D\u7269\u8F66\u4E2D\u81F3\u5C11\u4E00\u4EF6\u4EA7\u54C1\u7684\u53D8\u4F53",
  "The variant of only product in the cart": "\u8D2D\u7269\u8F66\u4E2D\u552F\u4E00\u4EA7\u54C1\u7684\u53D8\u4F53",
  "The variant of the displayed product": "\u663E\u793A\u4EA7\u54C1\u7684\u53D8\u4F53",
  "Total item count": "\u603B\u5546\u54C1\u6570\u91CF",
  Weeks: "\u5468",
  Years: "\u5E74"
};

// src/lang/zh_TW.json
var zh_TW_default = {
  "An offer was accepted": "\u4E00\u500B\u512A\u60E0\u5DF2\u88AB\u63A5\u53D7",
  "An offer was declined": "\u4E00\u500B\u512A\u60E0\u5DF2\u88AB\u62D2\u7D55",
  and: "\u8207",
  "Announcement bar": "\u516C\u544A\u6B04",
  "Are available at all the sales channels from the list": "\u5728\u6E05\u55AE\u4E2D\u7684\u6240\u6709\u92B7\u552E\u6E20\u9053\u4E2D\u6709\u8CA8",
  "Are available at one of the sales channels from the list": "\u5728\u6E05\u55AE\u4E2D\u7684\u5176\u4E2D\u4E00\u500B\u92B7\u552E\u6E20\u9053\u4E2D\u6709\u8CA8",
  "Are not available at all the sales channels from the list": "\u5728\u6E05\u55AE\u4E2D\u7684\u6240\u6709\u92B7\u552E\u6E20\u9053\u4E2D\u90FD\u7121\u8CA8",
  "Are not available at one of the sales channels from the list": "\u5728\u6E05\u55AE\u4E2D\u7684\u5176\u4E2D\u4E00\u500B\u92B7\u552E\u6E20\u9053\u4E2D\u7121\u8CA8",
  "At least one product in the cart": "\u8CFC\u7269\u8ECA\u4E2D\u81F3\u5C11\u6709\u4E00\u9805\u5546\u54C1",
  Banner: "\u6A6B\u5E45",
  Between: "\u4ECB\u65BC",
  Bundle: "\u6346\u7D81\u92B7\u552E",
  "Cart/Order value": "\u8CFC\u7269\u8ECA/\u8A02\u55AE\u50F9\u503C",
  categories: "\u985E\u5225",
  category: "\u985E\u5225",
  collection: "\u5546\u54C1\u7CFB\u5217",
  collections: "\u5546\u54C1\u7CFB\u5217",
  Contains: "\u5305\u542B",
  "Customer accepted marketing": "\u5BA2\u6236\u63A5\u53D7\u884C\u92B7",
  "Customer birthday": "\u5BA2\u6236\u751F\u65E5",
  "Customer country": "\u5BA2\u6236\u570B\u5BB6",
  "customer doesn't have all the tags from the list": "\u5BA2\u6236\u6C92\u6709\u6E05\u55AE\u4E2D\u7684\u6240\u6709\u6A19\u7C64",
  "customer doesn't have any of the tags from the list": "\u5BA2\u6236\u6C92\u6709\u6E05\u55AE\u4E2D\u7684\u4EFB\u4F55\u6A19\u7C64",
  "Customer don't accepted marketing": "\u5BA2\u6236\u4E0D\u63A5\u53D7\u884C\u92B7",
  "Customer email": "\u5BA2\u6236\u96FB\u5B50\u90F5\u4EF6",
  "customer has all the tags from the list": "\u5BA2\u6236\u64C1\u6709\u6E05\u55AE\u4E2D\u7684\u6240\u6709\u6A19\u7C64",
  "customer has at least one of the tags from the list ": "\u5BA2\u6236\u81F3\u5C11\u6709\u6E05\u55AE\u4E2D\u7684\u4E00\u500B\u6A19\u7C64 ",
  "Customer number of orders": "\u5BA2\u6236\u8A02\u55AE\u6578",
  "Customer segments": "\u5BA2\u6236\u5340\u9694",
  "Customer tag": "\u5BA2\u6236\u6A19\u7C64",
  Days: "\u5929",
  "Discount code": "\u6298\u6263\u4EE3\u78BC",
  "Does not require shipping": "\u4E0D\u9700\u8981\u904B\u9001",
  "Doesn't contain": "\u4E0D\u5305\u542B",
  "Doesn't end with": "\u7D50\u5C3E\u4E0D\u662F",
  "Doesn't have all the tags from the list": "\u6C92\u6709\u6E05\u55AE\u4E2D\u7684\u6240\u6709\u6A19\u7C64",
  "Doesn't have some of the tags from the list": "\u6C92\u6709\u6E05\u55AE\u4E2D\u7684\u67D0\u4E9B\u6A19\u7C64",
  "Doesn't start with": "\u958B\u982D\u4E0D\u662F",
  "Ends with": "\u7D50\u5C3E\u662F",
  "Equal to": "\u7B49\u65BC",
  Equals: "\u7B49\u65BC",
  "Every product in the cart": "\u8CFC\u7269\u8ECA\u4E2D\u7684\u6BCF\u9805\u5546\u54C1",
  "Greater than": "\u5927\u65BC",
  "Greater than or equals to": "\u5927\u65BC\u6216\u7B49\u65BC",
  "Has all the tags from the list": "\u64C1\u6709\u6E05\u55AE\u4E2D\u7684\u6240\u6709\u6A19\u7C64",
  "Has at least one of the tags from the list": "\u81F3\u5C11\u6709\u6E05\u55AE\u4E2D\u7684\u4E00\u500B\u6A19\u7C64",
  Hours: "\u5C0F\u6642",
  "in less than": "\u5C11\u65BC",
  "Is (exact code)": "\u662F (\u78BA\u5207\u4EE3\u78BC)",
  "Is (exact email)": "\u662F (\u78BA\u5207\u96FB\u5B50\u90F5\u4EF6)",
  "Is (exact sku)": "\u662F (\u78BA\u5207 SKU)",
  "Is (exact title)": "\u662F (\u78BA\u5207\u6A19\u984C)",
  "Is (exact variant name)": "\u662F (\u78BA\u5207\u5B50\u985E\u540D\u7A31)",
  "Is after": "\u665A\u65BC",
  "Is available at all the sales channels from the list": "\u5728\u6E05\u55AE\u4E2D\u7684\u6240\u6709\u92B7\u552E\u6E20\u9053\u4E2D\u6709\u8CA8",
  "Is available at all the sales channels in the list": "\u5728\u6E05\u55AE\u4E2D\u7684\u6240\u6709\u92B7\u552E\u7BA1\u9053\u7686\u53EF\u7528",
  "Is available at one of the sales channels from the list": "\u5728\u6E05\u55AE\u4E2D\u7684\u5176\u4E2D\u4E00\u500B\u92B7\u552E\u6E20\u9053\u4E2D\u6709\u8CA8",
  "Is available at one of the sales channels in the list": "\u5728\u6E05\u55AE\u4E2D\u7684\u5176\u4E2D\u4E00\u500B\u92B7\u552E\u7BA1\u9053\u53EF\u7528",
  "Is before": "\u65E9\u65BC",
  "Is between": "\u4ECB\u65BC",
  "Is from a vendor in the list": "\u5C6C\u65BC\u6E05\u55AE\u4E2D\u7684\u5EE0\u5546",
  "Is from the list": "\u5728\u6E05\u55AE\u4E2D",
  "Is greater than": "\u5927\u65BC",
  "Is greater than or equals to": "\u5927\u65BC\u6216\u7B49\u65BC",
  "Is in a category from the list": "\u5C6C\u65BC\u6E05\u55AE\u4E2D\u7684\u4E00\u500B\u985E\u5225",
  "Is in a collection from the list": "\u5728\u6E05\u55AE\u4E2D\u7684\u4E00\u500B\u5546\u54C1\u7CFB\u5217\u4E2D",
  "Is less than": "\u5C0F\u65BC",
  "Is less than or equals to": "\u5C0F\u65BC\u6216\u7B49\u65BC",
  "Is not (exact code)": "\u4E0D\u662F (\u78BA\u5207\u4EE3\u78BC)",
  "Is not (exact email)": "\u4E0D\u662F (\u78BA\u5207\u96FB\u5B50\u90F5\u4EF6)",
  "Is not (exact sku)": "\u4E0D\u662F (\u78BA\u5207 SKU)",
  "Is not (exact title)": "\u4E0D\u662F (\u78BA\u5207\u6A19\u984C)",
  "Is not (exact variant name)": "\u4E0D\u662F (\u78BA\u5207\u5B50\u985E\u540D\u7A31)",
  "Is not available at all the sales channels from the list": "\u5728\u6E05\u55AE\u4E2D\u7684\u6240\u6709\u92B7\u552E\u6E20\u9053\u4E2D\u90FD\u7121\u8CA8",
  "Is not available at all the sales channels in the list": "\u4E26\u975E\u5728\u6E05\u55AE\u4E2D\u7684\u6240\u6709\u92B7\u552E\u7BA1\u9053\u7686\u53EF\u7528",
  "Is not available at one of the sales channels from the list": "\u5728\u6E05\u55AE\u4E2D\u7684\u5176\u4E2D\u4E00\u500B\u92B7\u552E\u6E20\u9053\u4E2D\u7121\u8CA8",
  "Is not available at one of the sales channels in the list": "\u5728\u6E05\u55AE\u4E2D\u7684\u4EFB\u4F55\u92B7\u552E\u7BA1\u9053\u7686\u4E0D\u53EF\u7528",
  "Is not between": "\u4E0D\u4ECB\u65BC",
  "Is not equal to": "\u4E0D\u7B49\u65BC",
  "Is not from a vendor in the list": "\u4E0D\u5C6C\u65BC\u6E05\u55AE\u4E2D\u7684\u5EE0\u5546",
  "Is not from the list": "\u4E0D\u5728\u6E05\u55AE\u4E2D",
  "Is not in a category from the list": "\u4E0D\u5C6C\u65BC\u6E05\u55AE\u4E2D\u7684\u4EFB\u4F55\u985E\u5225",
  "Is not in a collection from the list": "\u4E0D\u5728\u6E05\u55AE\u4E2D\u7684\u4EFB\u4F55\u5546\u54C1\u7CFB\u5217\u4E2D",
  "Is not of a type from the list": "\u4E0D\u5C6C\u65BC\u6E05\u55AE\u4E2D\u7684\u985E\u578B",
  "Is not on": "\u4E0D\u662F",
  "Is not one of the countries from the list": "\u4E0D\u662F\u6E05\u55AE\u4E2D\u7684\u4EFB\u4F55\u4E00\u500B\u570B\u5BB6",
  "Is not one of the customer segments from the list": "\u4E0D\u662F\u6E05\u55AE\u4E2D\u7684\u4EFB\u4F55\u4E00\u500B\u5BA2\u6236\u5340\u9694",
  "Is not one of the fulfillment statuses in the list": "\u4E0D\u662F\u6E05\u55AE\u4E2D\u7684\u4EFB\u4F55\u4E00\u7A2E\u5C65\u7D04\u72C0\u614B",
  "Is not one of the languages from the list": "\u4E0D\u662F\u6E05\u55AE\u4E2D\u7684\u4EFB\u4F55\u4E00\u7A2E\u8A9E\u8A00",
  "Is not one of the methods in the list": "\u4E0D\u662F\u6E05\u55AE\u4E2D\u7684\u65B9\u5F0F\u4E4B\u4E00",
  "Is not one of the payment statuses in the list": "\u4E0D\u662F\u6E05\u55AE\u4E2D\u7684\u4ED8\u6B3E\u72C0\u614B\u4E4B\u4E00",
  "Is not tagged with all the tags in the list": "\u672A\u6A19\u8A18\u6E05\u55AE\u4E2D\u7684\u6240\u6709\u6A19\u7C64",
  "Is not tagged with any of the tags in the list": "\u672A\u6A19\u8A18\u6E05\u55AE\u4E2D\u7684\u4EFB\u4F55\u6A19\u7C64",
  "Is not tagged with at least one of the tags in the list": "\u672A\u6A19\u8A18\u6E05\u55AE\u4E2D\u7684\u81F3\u5C11\u4E00\u500B\u6A19\u7C64",
  "Is of a type from the list": "\u5C6C\u65BC\u6E05\u55AE\u4E2D\u7684\u985E\u578B",
  "Is on": "\u662F",
  "Is one of the countries from the list": "\u662F\u6E05\u55AE\u4E2D\u7684\u4E00\u500B\u570B\u5BB6",
  "Is one of the customer segments from the list": "\u662F\u6E05\u55AE\u4E2D\u7684\u4E00\u500B\u5BA2\u6236\u5340\u9694",
  "Is one of the fulfillment statuses in the list": "\u662F\u6E05\u55AE\u4E2D\u7684\u4E00\u7A2E\u5C65\u7D04\u72C0\u614B",
  "Is one of the languages from the list": "\u662F\u6E05\u55AE\u4E2D\u7684\u4E00\u7A2E\u8A9E\u8A00",
  "Is one of the methods in the list": "\u662F\u6E05\u55AE\u4E2D\u7684\u65B9\u5F0F\u4E4B\u4E00",
  "Is one of the payment statuses in the list": "\u662F\u6E05\u55AE\u4E2D\u7684\u4ED8\u6B3E\u72C0\u614B\u4E4B\u4E00",
  "Is tagged with all the tags in the list": "\u6A19\u8A18\u4E86\u6E05\u55AE\u4E2D\u7684\u6240\u6709\u6A19\u7C64",
  "Is tagged with at least one of the tags in the list": "\u6A19\u8A18\u4E86\u6E05\u55AE\u4E2D\u81F3\u5C11\u4E00\u500B\u6A19\u7C64",
  "Item cost": "\u5546\u54C1\u6210\u672C",
  Language: "\u8A9E\u8A00",
  "Less than": "\u5C0F\u65BC",
  "Less than or equals to": "\u5C0F\u65BC\u6216\u7B49\u65BC",
  "Marketing consent": "\u884C\u92B7\u540C\u610F",
  Minutes: "\u5206\u9418",
  Months: "\u6708",
  "Number of orders": "\u8A02\u55AE\u6578\u91CF",
  "On all of the post purchase pages": "\u5728\u6240\u6709\u5B8C\u6210\u8CFC\u8CB7\u5F8C\u7684\u9801\u9762",
  "On one of the post purchase pages": "\u5728\u5176\u4E2D\u4E00\u500B\u5B8C\u6210\u8CFC\u8CB7\u5F8C\u7684\u9801\u9762",
  "On the checkout": "\u5728\u7D50\u5E33\u9801\u9762",
  "On the post purchase 1st page": "\u5728\u5B8C\u6210\u8CFC\u8CB7\u5F8C\u7684\u7B2C\u4E00\u9801",
  "On the post purchase 2nd page": "\u5728\u5B8C\u6210\u8CFC\u8CB7\u5F8C\u7684\u7B2C\u4E8C\u9801",
  "On the thank you page": "\u5728\u611F\u8B1D\u9801\u9762",
  "Order note": "\u8A02\u55AE\u5099\u8A3B",
  "Order tags": "\u8A02\u55AE\u6A19\u7C64",
  "Passed X time ago": "\u904E\u53BB X \u524D",
  "Payment method": "\u4ED8\u6B3E\u65B9\u5F0F",
  "please add cart or order value": "\u8ACB\u65B0\u589E\u8CFC\u7269\u8ECA\u6216\u8A02\u55AE\u50F9\u503C",
  "please add customer email": "\u8ACB\u65B0\u589E\u5BA2\u6236\u96FB\u5B50\u90F5\u4EF6",
  "please add customer number of orders": "\u8ACB\u65B0\u589E\u5BA2\u6236\u8A02\u55AE\u6578",
  "please add discount code": "\u8ACB\u65B0\u589E\u6298\u6263\u4EE3\u78BC",
  "please add item cost": "\u8ACB\u65B0\u589E\u5546\u54C1\u6210\u672C",
  "please add number of orders": "\u8ACB\u65B0\u589E\u8A02\u55AE\u6578\u91CF",
  "please add order note": "\u8ACB\u65B0\u589E\u8A02\u55AE\u5099\u8A3B",
  "please add product price": "\u8ACB\u65B0\u589E\u7522\u54C1\u50F9\u683C",
  "please add product sku": "\u8ACB\u65B0\u589E\u5546\u54C1 SKU",
  "please add product title": "\u8ACB\u65B0\u589E\u5546\u54C1\u6A19\u984C",
  "please add product variant name": "\u8ACB\u65B0\u589E\u5546\u54C1\u5B50\u985E\u540D\u7A31",
  "please add shipping value": "\u8ACB\u65B0\u589E\u904B\u8CBB",
  "please add time since last order": "\u8ACB\u65B0\u589E\u81EA\u4E0A\u6B21\u8A02\u55AE\u4EE5\u4F86\u7684\u6642\u9593",
  "please add total item count": "\u8ACB\u65B0\u589E\u7E3D\u5546\u54C1\u6578\u91CF",
  "please add value": "\u8ACB\u65B0\u589E\u503C",
  "please select collections": "\u8ACB\u9078\u64C7\u5546\u54C1\u7CFB\u5217",
  "please select customer birthday": "\u8ACB\u9078\u53D6\u5BA2\u6236\u751F\u65E5",
  "please select customer country": "\u8ACB\u9078\u64C7\u5BA2\u6236\u570B\u5BB6",
  "please select customer language": "\u8ACB\u9078\u64C7\u5BA2\u6236\u8A9E\u8A00",
  "please select customer segments": "\u8ACB\u9078\u64C7\u5BA2\u6236\u5340\u9694",
  "please select customer tag": "\u8ACB\u9078\u64C7\u5BA2\u6236\u6A19\u7C64",
  "please select customer tags": "\u8ACB\u9078\u64C7\u5BA2\u6236\u6A19\u7C64",
  "please select fulfillment statuses": "\u8ACB\u9078\u64C7\u5C65\u7D04\u72C0\u614B",
  "please select offer": "\u8ACB\u9078\u64C7\u512A\u60E0",
  "please select payment method": "\u8ACB\u9078\u64C7\u4ED8\u6B3E\u65B9\u5F0F",
  "please select payment statuses": "\u8ACB\u9078\u64C7\u4ED8\u6B3E\u72C0\u614B",
  "please select product type": "\u8ACB\u9078\u64C7\u7522\u54C1\u985E\u578B",
  "please select product vendor": "\u8ACB\u9078\u64C7\u7522\u54C1\u5EE0\u5546",
  "please select products": "\u8ACB\u9078\u64C7\u5546\u54C1",
  "please select sales channel": "\u8ACB\u9078\u64C7\u92B7\u552E\u6E20\u9053",
  "please select shipping methods": "\u8ACB\u9078\u64C7\u904B\u9001\u65B9\u5F0F",
  "please select tags": "\u8ACB\u9078\u64C7\u6A19\u7C64",
  "Previous page offer": "\u4E0A\u4E00\u9801\u7684\u512A\u60E0",
  product: "\u5546\u54C1",
  "Product recommendations": "\u5546\u54C1\u63A8\u85A6",
  "Product type": "\u7522\u54C1\u985E\u578B",
  "Product upsell": "\u5546\u54C1\u52A0\u50F9\u8CFC",
  products: "\u5546\u54C1",
  "Requires shipping": "\u9700\u8981\u904B\u9001",
  "Shipping method": "\u904B\u9001\u65B9\u5F0F",
  "Shipping value": "\u904B\u8CBB",
  "Starts with": "\u958B\u982D\u662F",
  Status: "\u72C0\u614B",
  "The displayed product": "\u986F\u793A\u7684\u5546\u54C1",
  "The displayed product SKU": "\u986F\u793A\u7684\u5546\u54C1 SKU",
  "The only product title in the cart": "\u8CFC\u7269\u8ECA\u4E2D\u552F\u4E00\u7684\u5546\u54C1\u6A19\u984C",
  "The only SKU in the cart": "\u8CFC\u7269\u8ECA\u4E2D\u552F\u4E00\u7684 SKU",
  "The SKU of all products in the cart": "\u8CFC\u7269\u8ECA\u4E2D\u6240\u6709\u5546\u54C1\u7684 SKU",
  "The SKU of at least one product in the cart": "\u8CFC\u7269\u8ECA\u4E2D\u81F3\u5C11\u4E00\u9805\u5546\u54C1\u7684 SKU",
  "The title of all products in the cart": "\u8CFC\u7269\u8ECA\u4E2D\u6240\u6709\u5546\u54C1\u7684\u6A19\u984C",
  "The title of at least one product in the cart": "\u8CFC\u7269\u8ECA\u4E2D\u81F3\u5C11\u4E00\u9805\u5546\u54C1\u7684\u6A19\u984C",
  "The title of the displayed product": "\u986F\u793A\u7684\u5546\u54C1\u6A19\u984C",
  "The variant of all products in the cart": "\u8CFC\u7269\u8ECA\u4E2D\u6240\u6709\u5546\u54C1\u7684\u5B50\u985E",
  "The variant of at least one product in the cart": "\u8CFC\u7269\u8ECA\u4E2D\u81F3\u5C11\u4E00\u9805\u5546\u54C1\u7684\u5B50\u985E",
  "The variant of only product in the cart": "\u8CFC\u7269\u8ECA\u4E2D\u552F\u4E00\u5546\u54C1\u7684\u5B50\u985E",
  "The variant of the displayed product": "\u986F\u793A\u7684\u5546\u54C1\u5B50\u985E",
  "Total item count": "\u7E3D\u5546\u54C1\u6578\u91CF",
  Weeks: "\u9031",
  Years: "\u5E74"
};

// src/lang/ja.json
var ja_default = {
  "An offer was accepted": "\u30AA\u30D5\u30A1\u30FC\u304C\u627F\u8A8D\u3055\u308C\u305F",
  "An offer was declined": "\u30AA\u30D5\u30A1\u30FC\u304C\u8F9E\u9000\u3055\u308C\u305F",
  and: "\u304A\u3088\u3073",
  "Announcement bar": "\u544A\u77E5\u30D0\u30FC",
  "Are available at all the sales channels from the list": "\u30EA\u30B9\u30C8\u306E\u3059\u3079\u3066\u306E\u8CA9\u58F2\u30C1\u30E3\u30CD\u30EB\u3067\u5229\u7528\u53EF\u80FD",
  "Are available at one of the sales channels from the list": "\u30EA\u30B9\u30C8\u306E\u3044\u305A\u308C\u304B\u306E\u8CA9\u58F2\u30C1\u30E3\u30CD\u30EB\u3067\u5229\u7528\u53EF\u80FD",
  "Are not available at all the sales channels from the list": "\u30EA\u30B9\u30C8\u306E\u3059\u3079\u3066\u306E\u8CA9\u58F2\u30C1\u30E3\u30CD\u30EB\u3067\u5229\u7528\u4E0D\u53EF",
  "Are not available at one of the sales channels from the list": "\u30EA\u30B9\u30C8\u306E\u3044\u305A\u308C\u304B\u306E\u8CA9\u58F2\u30C1\u30E3\u30CD\u30EB\u3067\u5229\u7528\u4E0D\u53EF",
  "At least one product in the cart": "\u30AB\u30FC\u30C8\u5185\u306E\u5546\u54C1\u306E\u3046\u3061\u5C11\u306A\u304F\u3068\u30821\u3064",
  Banner: "\u30D0\u30CA\u30FC",
  Between: "\u6B21\u306E\u7BC4\u56F2\u5185",
  Bundle: "\u30D0\u30F3\u30C9\u30EB",
  "Cart/Order value": "\u30AB\u30FC\u30C8/\u6CE8\u6587\u306E\u91D1\u984D",
  categories: "\u30AB\u30C6\u30B4\u30EA\u30FC",
  category: "\u30AB\u30C6\u30B4\u30EA\u30FC",
  collection: "\u30B3\u30EC\u30AF\u30B7\u30E7\u30F3",
  collections: "\u30B3\u30EC\u30AF\u30B7\u30E7\u30F3",
  Contains: "\uFF5E\u3092\u542B\u3080",
  "Customer accepted marketing": "\u9867\u5BA2\u304C\u30DE\u30FC\u30B1\u30C6\u30A3\u30F3\u30B0\u3092\u53D7\u3051\u5165\u308C\u307E\u3057\u305F",
  "Customer birthday": "\u9867\u5BA2\u306E\u8A95\u751F\u65E5",
  "Customer country": "\u9867\u5BA2\u306E\u56FD",
  "customer doesn't have all the tags from the list": "\u9867\u5BA2\u306B\u30EA\u30B9\u30C8\u306E\u3059\u3079\u3066\u306E\u30BF\u30B0\u304C\u4ED8\u3044\u3066\u3044\u306A\u3044",
  "customer doesn't have any of the tags from the list": "\u9867\u5BA2\u306B\u30EA\u30B9\u30C8\u306E\u3069\u306E\u30BF\u30B0\u3082\u4ED8\u3044\u3066\u3044\u306A\u3044",
  "Customer don't accepted marketing": "\u9867\u5BA2\u306F\u30DE\u30FC\u30B1\u30C6\u30A3\u30F3\u30B0\u3092\u53D7\u3051\u5165\u308C\u307E\u305B\u3093\u3067\u3057\u305F",
  "Customer email": "\u9867\u5BA2\u306E\u30E1\u30FC\u30EB\u30A2\u30C9\u30EC\u30B9",
  "customer has all the tags from the list": "\u9867\u5BA2\u306B\u30EA\u30B9\u30C8\u306E\u3059\u3079\u3066\u306E\u30BF\u30B0\u304C\u4ED8\u3044\u3066\u3044\u308B",
  "customer has at least one of the tags from the list ": "\u9867\u5BA2\u306B\u30EA\u30B9\u30C8\u306E\u30BF\u30B0\u304C\u5C11\u306A\u304F\u3068\u30821\u3064\u4ED8\u3044\u3066\u3044\u308B",
  "Customer number of orders": "\u9867\u5BA2\u306E\u6CE8\u6587\u6570",
  "Customer segments": "\u9867\u5BA2\u30BB\u30B0\u30E1\u30F3\u30C8",
  "Customer tag": "\u9867\u5BA2\u30BF\u30B0",
  Days: "\u65E5",
  "Discount code": "\u30C7\u30A3\u30B9\u30AB\u30A6\u30F3\u30C8\u30B3\u30FC\u30C9",
  "Does not require shipping": "\u914D\u9001\u306F\u4E0D\u8981",
  "Doesn't contain": "\uFF5E\u3092\u542B\u307E\u306A\u3044",
  "Doesn't end with": "\uFF5E\u3067\u7D42\u308F\u3089\u306A\u3044",
  "Doesn't have all the tags from the list": "\u30EA\u30B9\u30C8\u306E\u3059\u3079\u3066\u306E\u30BF\u30B0\u304C\u4ED8\u3044\u3066\u3044\u306A\u3044",
  "Doesn't have some of the tags from the list": "\u30EA\u30B9\u30C8\u306E\u4E00\u90E8\u306E\u30BF\u30B0\u304C\u4ED8\u3044\u3066\u3044\u306A\u3044",
  "Doesn't start with": "\uFF5E\u3067\u59CB\u307E\u3089\u306A\u3044",
  "Ends with": "\uFF5E\u3067\u7D42\u308F\u308B",
  "Equal to": "\u7B49\u3057\u3044",
  Equals: "\u7B49\u3057\u3044",
  "Every product in the cart": "\u30AB\u30FC\u30C8\u5185\u306E\u3059\u3079\u3066\u306E\u5546\u54C1",
  "Greater than": "\u3088\u308A\u5927\u304D\u3044",
  "Greater than or equals to": "\u4EE5\u4E0A",
  "Has all the tags from the list": "\u30EA\u30B9\u30C8\u306E\u3059\u3079\u3066\u306E\u30BF\u30B0\u304C\u4ED8\u3044\u3066\u3044\u308B",
  "Has at least one of the tags from the list": "\u30EA\u30B9\u30C8\u306E\u30BF\u30B0\u304C\u5C11\u306A\u304F\u3068\u30821\u3064\u4ED8\u3044\u3066\u3044\u308B",
  Hours: "\u6642\u9593",
  "in less than": "\u6B21\u3088\u308A\u77ED\u3044\u671F\u9593\u3067",
  "Is (exact code)": "\u6B21\u3068\u4E00\u81F4\u3059\u308B (\u5B8C\u5168\u306A\u30B3\u30FC\u30C9)",
  "Is (exact email)": "\u6B21\u3068\u4E00\u81F4\u3059\u308B (\u5B8C\u5168\u306A\u30E1\u30FC\u30EB\u30A2\u30C9\u30EC\u30B9)",
  "Is (exact sku)": "\u6B21\u3068\u4E00\u81F4\u3059\u308B (\u5B8C\u5168\u306ASKU)",
  "Is (exact title)": "\u6B21\u3068\u4E00\u81F4\u3059\u308B (\u5B8C\u5168\u306A\u30BF\u30A4\u30C8\u30EB)",
  "Is (exact variant name)": "\u6B21\u3068\u4E00\u81F4\u3059\u308B (\u5B8C\u5168\u306A\u30D0\u30EA\u30A2\u30F3\u30C8\u540D)",
  "Is after": "\u6B21\u306E\u65E5\u4ED8\u3088\u308A\u5F8C",
  "Is available at all the sales channels from the list": "\u30EA\u30B9\u30C8\u306E\u3059\u3079\u3066\u306E\u8CA9\u58F2\u30C1\u30E3\u30CD\u30EB\u3067\u5229\u7528\u53EF\u80FD",
  "Is available at all the sales channels in the list": "\u30EA\u30B9\u30C8\u306B\u3042\u308B\u3059\u3079\u3066\u306E\u8CA9\u58F2\u30C1\u30E3\u30CD\u30EB\u3067\u5229\u7528\u53EF\u80FD\u3067\u3059",
  "Is available at one of the sales channels from the list": "\u30EA\u30B9\u30C8\u306E\u3044\u305A\u308C\u304B\u306E\u8CA9\u58F2\u30C1\u30E3\u30CD\u30EB\u3067\u5229\u7528\u53EF\u80FD",
  "Is available at one of the sales channels in the list": "\u30EA\u30B9\u30C8\u306B\u3042\u308B\u8CA9\u58F2\u30C1\u30E3\u30CD\u30EB\u306E1\u3064\u3067\u5229\u7528\u53EF\u80FD\u3067\u3059",
  "Is before": "\u6B21\u306E\u65E5\u4ED8\u3088\u308A\u524D",
  "Is between": "\u306E\u9593",
  "Is from a vendor in the list": "\u30EA\u30B9\u30C8\u306B\u3042\u308B\u8CA9\u58F2\u5143\u306E\u3082\u306E\u3067\u3059",
  "Is from the list": "\u30EA\u30B9\u30C8\u306B\u542B\u307E\u308C\u308B",
  "Is greater than": "\u3088\u308A\u5927\u304D\u3044",
  "Is greater than or equals to": "\u4EE5\u4E0A",
  "Is in a category from the list": "\u30EA\u30B9\u30C8\u306E\u30AB\u30C6\u30B4\u30EA\u30FC\u306B\u542B\u307E\u308C\u308B",
  "Is in a collection from the list": "\u30EA\u30B9\u30C8\u306E\u30B3\u30EC\u30AF\u30B7\u30E7\u30F3\u306B\u542B\u307E\u308C\u308B",
  "Is less than": "\u3088\u308A\u5C0F\u3055\u3044",
  "Is less than or equals to": "\u4EE5\u4E0B",
  "Is not (exact code)": "\u6B21\u3068\u4E00\u81F4\u3057\u306A\u3044 (\u5B8C\u5168\u306A\u30B3\u30FC\u30C9)",
  "Is not (exact email)": "\u6B21\u3068\u4E00\u81F4\u3057\u306A\u3044 (\u5B8C\u5168\u306A\u30E1\u30FC\u30EB\u30A2\u30C9\u30EC\u30B9)",
  "Is not (exact sku)": "\u6B21\u3068\u4E00\u81F4\u3057\u306A\u3044 (\u5B8C\u5168\u306ASKU)",
  "Is not (exact title)": "\u6B21\u3068\u4E00\u81F4\u3057\u306A\u3044 (\u5B8C\u5168\u306A\u30BF\u30A4\u30C8\u30EB)",
  "Is not (exact variant name)": "\u6B21\u3068\u4E00\u81F4\u3057\u306A\u3044 (\u5B8C\u5168\u306A\u30D0\u30EA\u30A2\u30F3\u30C8\u540D)",
  "Is not available at all the sales channels from the list": "\u30EA\u30B9\u30C8\u306E\u3059\u3079\u3066\u306E\u8CA9\u58F2\u30C1\u30E3\u30CD\u30EB\u3067\u5229\u7528\u4E0D\u53EF",
  "Is not available at all the sales channels in the list": "\u30EA\u30B9\u30C8\u306B\u3042\u308B\u3059\u3079\u3066\u306E\u8CA9\u58F2\u30C1\u30E3\u30CD\u30EB\u3067\u5229\u7528\u3067\u304D\u308B\u308F\u3051\u3067\u306F\u3042\u308A\u307E\u305B\u3093",
  "Is not available at one of the sales channels from the list": "\u30EA\u30B9\u30C8\u306E\u3044\u305A\u308C\u304B\u306E\u8CA9\u58F2\u30C1\u30E3\u30CD\u30EB\u3067\u5229\u7528\u4E0D\u53EF",
  "Is not available at one of the sales channels in the list": "\u30EA\u30B9\u30C8\u306B\u3042\u308B\u8CA9\u58F2\u30C1\u30E3\u30CD\u30EB\u306E\u3044\u305A\u308C\u3067\u3082\u5229\u7528\u3067\u304D\u307E\u305B\u3093",
  "Is not between": "\u6B21\u306E\u7BC4\u56F2\u5916",
  "Is not equal to": "\u7B49\u3057\u304F\u306A\u3044",
  "Is not from a vendor in the list": "\u30EA\u30B9\u30C8\u306B\u3042\u308B\u8CA9\u58F2\u5143\u306E\u3082\u306E\u30FB\u3067\u306F\u3042\u308A\u307E\u305B\u3093",
  "Is not from the list": "\u30EA\u30B9\u30C8\u306B\u542B\u307E\u308C\u306A\u3044",
  "Is not in a category from the list": "\u30EA\u30B9\u30C8\u306E\u30AB\u30C6\u30B4\u30EA\u30FC\u306B\u542B\u307E\u308C\u306A\u3044",
  "Is not in a collection from the list": "\u30EA\u30B9\u30C8\u306E\u30B3\u30EC\u30AF\u30B7\u30E7\u30F3\u306B\u542B\u307E\u308C\u306A\u3044",
  "Is not of a type from the list": "\u30EA\u30B9\u30C8\u306B\u3042\u308B\u30BF\u30A4\u30D7\u306E1\u3064\u3067\u306F\u3042\u308A\u307E\u305B\u3093",
  "Is not on": "\u6B21\u306E\u65E5\u4ED8\u3067\u306F\u306A\u3044",
  "Is not one of the countries from the list": "\u30EA\u30B9\u30C8\u306E\u3069\u306E\u56FD\u3067\u3082\u306A\u3044",
  "Is not one of the customer segments from the list": "\u30EA\u30B9\u30C8\u306E\u3069\u306E\u9867\u5BA2\u30BB\u30B0\u30E1\u30F3\u30C8\u306B\u3082\u5C5E\u3055\u306A\u3044",
  "Is not one of the fulfillment statuses in the list": "\u30EA\u30B9\u30C8\u5185\u306E\u5C65\u884C\u72B6\u6CC1\u306E\u3044\u305A\u308C\u3067\u3082\u306A\u3044",
  "Is not one of the languages from the list": "\u30EA\u30B9\u30C8\u306E\u3069\u306E\u8A00\u8A9E\u3067\u3082\u306A\u3044",
  "Is not one of the methods in the list": "\u30EA\u30B9\u30C8\u306B\u3042\u308B\u65B9\u6CD5\u306E1\u3064\u3067\u306F\u3042\u308A\u307E\u305B\u3093",
  "Is not one of the payment statuses in the list": "\u30EA\u30B9\u30C8\u306B\u3042\u308B\u652F\u6255\u3044\u72B6\u6CC1\u306E1\u3064\u3067\u306F\u3042\u308A\u307E\u305B\u3093",
  "Is not tagged with all the tags in the list": "\u30EA\u30B9\u30C8\u5185\u306E\u3059\u3079\u3066\u306E\u30BF\u30B0\u304C\u4ED8\u4E0E\u3055\u308C\u3066\u3044\u307E\u305B\u3093",
  "Is not tagged with any of the tags in the list": "\u30EA\u30B9\u30C8\u5185\u306E\u30BF\u30B0\u306E\u3044\u305A\u308C\u3067\u3082\u30BF\u30B0\u4ED8\u3051\u3055\u308C\u3066\u3044\u306A\u3044",
  "Is not tagged with at least one of the tags in the list": "\u30EA\u30B9\u30C8\u5185\u306E\u30BF\u30B0\u306E\u5C11\u306A\u304F\u3068\u30821\u3064\u304C\u4ED8\u4E0E\u3055\u308C\u3066\u3044\u307E\u305B\u3093",
  "Is of a type from the list": "\u30EA\u30B9\u30C8\u306B\u3042\u308B\u30BF\u30A4\u30D7\u306E1\u3064\u3067\u3059",
  "Is on": "\u6B21\u306E\u65E5\u4ED8\u3067\u3042\u308B",
  "Is one of the countries from the list": "\u30EA\u30B9\u30C8\u306E\u3044\u305A\u308C\u304B\u306E\u56FD\u3067\u3042\u308B",
  "Is one of the customer segments from the list": "\u30EA\u30B9\u30C8\u306E\u3044\u305A\u308C\u304B\u306E\u9867\u5BA2\u30BB\u30B0\u30E1\u30F3\u30C8\u306B\u5C5E\u3059\u308B",
  "Is one of the fulfillment statuses in the list": "\u30EA\u30B9\u30C8\u5185\u306E\u5C65\u884C\u72B6\u6CC1\u306E\u3044\u305A\u308C\u304B\u3067\u3042\u308B",
  "Is one of the languages from the list": "\u30EA\u30B9\u30C8\u306E\u3044\u305A\u308C\u304B\u306E\u8A00\u8A9E\u3067\u3042\u308B",
  "Is one of the methods in the list": "\u30EA\u30B9\u30C8\u306B\u3042\u308B\u65B9\u6CD5\u306E1\u3064\u3067\u3059",
  "Is one of the payment statuses in the list": "\u30EA\u30B9\u30C8\u306B\u3042\u308B\u652F\u6255\u3044\u72B6\u6CC1\u306E1\u3064\u3067\u3059",
  "Is tagged with all the tags in the list": "\u30EA\u30B9\u30C8\u5185\u306E\u3059\u3079\u3066\u306E\u30BF\u30B0\u3067\u30BF\u30B0\u4ED8\u3051\u3055\u308C\u3066\u3044\u308B",
  "Is tagged with at least one of the tags in the list": "\u30EA\u30B9\u30C8\u5185\u306E\u5C11\u306A\u304F\u3068\u30821\u3064\u306E\u30BF\u30B0\u3067\u30BF\u30B0\u4ED8\u3051\u3055\u308C\u3066\u3044\u308B",
  "Item cost": "\u30A2\u30A4\u30C6\u30E0\u306E\u30B3\u30B9\u30C8",
  Language: "\u8A00\u8A9E",
  "Less than": "\u3088\u308A\u5C0F\u3055\u3044",
  "Less than or equals to": "\u4EE5\u4E0B",
  "Marketing consent": "\u30DE\u30FC\u30B1\u30C6\u30A3\u30F3\u30B0\u306E\u540C\u610F",
  Minutes: "\u5206",
  Months: "\u30F6\u6708",
  "Number of orders": "\u6CE8\u6587\u6570",
  "On all of the post purchase pages": "\u3059\u3079\u3066\u306E\u8CFC\u5165\u5F8C\u30DA\u30FC\u30B8",
  "On one of the post purchase pages": "\u3044\u305A\u308C\u304B\u306E\u8CFC\u5165\u5F8C\u30DA\u30FC\u30B8",
  "On the checkout": "\u30C1\u30A7\u30C3\u30AF\u30A2\u30A6\u30C8\u6642",
  "On the post purchase 1st page": "\u8CFC\u5165\u5F8C\u306E1\u30DA\u30FC\u30B8\u76EE",
  "On the post purchase 2nd page": "\u8CFC\u5165\u5F8C\u306E2\u30DA\u30FC\u30B8\u76EE",
  "On the thank you page": "\u30B5\u30F3\u30AD\u30E5\u30FC\u30DA\u30FC\u30B8",
  "Order note": "\u6CE8\u6587\u30E1\u30E2",
  "Order tags": "\u6CE8\u6587\u30BF\u30B0",
  "Passed X time ago": "X\u524D\u306B\u7D4C\u904E",
  "Payment method": "\u652F\u6255\u3044\u65B9\u6CD5",
  "please add cart or order value": "\u30AB\u30FC\u30C8\u307E\u305F\u306F\u6CE8\u6587\u306E\u91D1\u984D\u3092\u8FFD\u52A0\u3057\u3066\u304F\u3060\u3055\u3044",
  "please add customer email": "\u9867\u5BA2\u306E\u30E1\u30FC\u30EB\u30A2\u30C9\u30EC\u30B9\u3092\u8FFD\u52A0\u3057\u3066\u304F\u3060\u3055\u3044",
  "please add customer number of orders": "\u9867\u5BA2\u306E\u6CE8\u6587\u6570\u3092\u8FFD\u52A0\u3057\u3066\u304F\u3060\u3055\u3044",
  "please add discount code": "\u30C7\u30A3\u30B9\u30AB\u30A6\u30F3\u30C8\u30B3\u30FC\u30C9\u3092\u8FFD\u52A0\u3057\u3066\u304F\u3060\u3055\u3044",
  "please add item cost": "\u30A2\u30A4\u30C6\u30E0\u306E\u30B3\u30B9\u30C8\u3092\u8FFD\u52A0\u3057\u3066\u304F\u3060\u3055\u3044",
  "please add number of orders": "\u6CE8\u6587\u6570\u3092\u8FFD\u52A0\u3057\u3066\u304F\u3060\u3055\u3044",
  "please add order note": "\u6CE8\u6587\u30E1\u30E2\u3092\u8FFD\u52A0\u3057\u3066\u304F\u3060\u3055\u3044",
  "please add product price": "\u5546\u54C1\u4FA1\u683C\u3092\u8FFD\u52A0\u3057\u3066\u304F\u3060\u3055\u3044",
  "please add product sku": "\u5546\u54C1\u306ESKU\u3092\u8FFD\u52A0\u3057\u3066\u304F\u3060\u3055\u3044",
  "please add product title": "\u5546\u54C1\u30BF\u30A4\u30C8\u30EB\u3092\u8FFD\u52A0\u3057\u3066\u304F\u3060\u3055\u3044",
  "please add product variant name": "\u5546\u54C1\u306E\u30D0\u30EA\u30A2\u30F3\u30C8\u540D\u3092\u8FFD\u52A0\u3057\u3066\u304F\u3060\u3055\u3044",
  "please add shipping value": "\u914D\u9001\u6599\u3092\u8FFD\u52A0\u3057\u3066\u304F\u3060\u3055\u3044",
  "please add time since last order": "\u524D\u56DE\u306E\u6CE8\u6587\u304B\u3089\u306E\u6642\u9593\u3092\u8FFD\u52A0\u3057\u3066\u304F\u3060\u3055\u3044",
  "please add total item count": "\u30A2\u30A4\u30C6\u30E0\u306E\u7DCF\u6570\u3092\u8FFD\u52A0\u3057\u3066\u304F\u3060\u3055\u3044",
  "please add value": "\u5024\u3092\u8FFD\u52A0\u3057\u3066\u304F\u3060\u3055\u3044",
  "please select collections": "\u30B3\u30EC\u30AF\u30B7\u30E7\u30F3\u3092\u9078\u629E\u3057\u3066\u304F\u3060\u3055\u3044",
  "please select customer birthday": "\u9867\u5BA2\u306E\u8A95\u751F\u65E5\u3092\u9078\u629E\u3057\u3066\u304F\u3060\u3055\u3044",
  "please select customer country": "\u9867\u5BA2\u306E\u56FD\u3092\u9078\u629E\u3057\u3066\u304F\u3060\u3055\u3044",
  "please select customer language": "\u9867\u5BA2\u306E\u8A00\u8A9E\u3092\u9078\u629E\u3057\u3066\u304F\u3060\u3055\u3044",
  "please select customer segments": "\u9867\u5BA2\u30BB\u30B0\u30E1\u30F3\u30C8\u3092\u9078\u629E\u3057\u3066\u304F\u3060\u3055\u3044",
  "please select customer tag": "\u9867\u5BA2\u30BF\u30B0\u3092\u9078\u629E\u3057\u3066\u304F\u3060\u3055\u3044",
  "please select customer tags": "\u9867\u5BA2\u30BF\u30B0\u3092\u9078\u629E\u3057\u3066\u304F\u3060\u3055\u3044",
  "please select fulfillment statuses": "\u5C65\u884C\u72B6\u6CC1\u3092\u9078\u629E\u3057\u3066\u304F\u3060\u3055\u3044",
  "please select offer": "\u30AA\u30D5\u30A1\u30FC\u3092\u9078\u629E\u3057\u3066\u304F\u3060\u3055\u3044",
  "please select payment method": "\u652F\u6255\u3044\u65B9\u6CD5\u3092\u9078\u629E\u3057\u3066\u304F\u3060\u3055\u3044",
  "please select payment statuses": "\u652F\u6255\u3044\u72B6\u6CC1\u3092\u9078\u629E\u3057\u3066\u304F\u3060\u3055\u3044",
  "please select product type": "\u5546\u54C1\u30BF\u30A4\u30D7\u3092\u9078\u629E\u3057\u3066\u304F\u3060\u3055\u3044",
  "please select product vendor": "\u5546\u54C1\u306E\u8CA9\u58F2\u5143\u3092\u9078\u629E\u3057\u3066\u304F\u3060\u3055\u3044",
  "please select products": "\u5546\u54C1\u3092\u9078\u629E\u3057\u3066\u304F\u3060\u3055\u3044",
  "please select sales channel": "\u8CA9\u58F2\u30C1\u30E3\u30CD\u30EB\u3092\u9078\u629E\u3057\u3066\u304F\u3060\u3055\u3044",
  "please select shipping methods": "\u914D\u9001\u65B9\u6CD5\u3092\u9078\u629E\u3057\u3066\u304F\u3060\u3055\u3044",
  "please select tags": "\u30BF\u30B0\u3092\u9078\u629E\u3057\u3066\u304F\u3060\u3055\u3044",
  "Previous page offer": "\u524D\u306E\u30DA\u30FC\u30B8\u306E\u30AA\u30D5\u30A1\u30FC",
  product: "\u5546\u54C1",
  "Product recommendations": "\u304A\u3059\u3059\u3081\u5546\u54C1",
  "Product type": "\u5546\u54C1\u30BF\u30A4\u30D7",
  "Product upsell": "\u5546\u54C1\u306E\u30A2\u30C3\u30D7\u30BB\u30EB",
  products: "\u5546\u54C1",
  "Requires shipping": "\u914D\u9001\u304C\u5FC5\u8981",
  "Shipping method": "\u914D\u9001\u65B9\u6CD5",
  "Shipping value": "\u914D\u9001\u6599",
  "Starts with": "\uFF5E\u3067\u59CB\u307E\u308B",
  Status: "\u30B9\u30C6\u30FC\u30BF\u30B9",
  "The displayed product": "\u8868\u793A\u3055\u308C\u3066\u3044\u308B\u5546\u54C1",
  "The displayed product SKU": "\u8868\u793A\u3055\u308C\u3066\u3044\u308B\u5546\u54C1\u306ESKU",
  "The only product title in the cart": "\u30AB\u30FC\u30C8\u5185\u306E\u552F\u4E00\u306E\u5546\u54C1\u306E\u30BF\u30A4\u30C8\u30EB",
  "The only SKU in the cart": "\u30AB\u30FC\u30C8\u5185\u306E\u552F\u4E00\u306ESKU",
  "The SKU of all products in the cart": "\u30AB\u30FC\u30C8\u5185\u306E\u3059\u3079\u3066\u306E\u5546\u54C1\u306ESKU",
  "The SKU of at least one product in the cart": "\u30AB\u30FC\u30C8\u5185\u306E\u5C11\u306A\u304F\u3068\u30821\u3064\u306E\u5546\u54C1\u306ESKU",
  "The title of all products in the cart": "\u30AB\u30FC\u30C8\u5185\u306E\u3059\u3079\u3066\u306E\u5546\u54C1\u306E\u30BF\u30A4\u30C8\u30EB",
  "The title of at least one product in the cart": "\u30AB\u30FC\u30C8\u5185\u306E\u5C11\u306A\u304F\u3068\u30821\u3064\u306E\u5546\u54C1\u306E\u30BF\u30A4\u30C8\u30EB",
  "The title of the displayed product": "\u8868\u793A\u3055\u308C\u3066\u3044\u308B\u5546\u54C1\u306E\u30BF\u30A4\u30C8\u30EB",
  "The variant of all products in the cart": "\u30AB\u30FC\u30C8\u5185\u306E\u3059\u3079\u3066\u306E\u5546\u54C1\u306E\u30D0\u30EA\u30A2\u30F3\u30C8",
  "The variant of at least one product in the cart": "\u30AB\u30FC\u30C8\u5185\u306E\u5C11\u306A\u304F\u3068\u30821\u3064\u306E\u5546\u54C1\u306E\u30D0\u30EA\u30A2\u30F3\u30C8",
  "The variant of only product in the cart": "\u30AB\u30FC\u30C8\u5185\u306E\u552F\u4E00\u306E\u5546\u54C1\u306E\u30D0\u30EA\u30A2\u30F3\u30C8",
  "The variant of the displayed product": "\u8868\u793A\u3055\u308C\u3066\u3044\u308B\u5546\u54C1\u306E\u30D0\u30EA\u30A2\u30F3\u30C8",
  "Total item count": "\u30A2\u30A4\u30C6\u30E0\u7DCF\u6570",
  Weeks: "\u9031\u9593",
  Years: "\u5E74"
};

// src/lang/ko.json
var ko_default = {
  "An offer was accepted": "\uC81C\uC548\uC774 \uC218\uB77D\uB428",
  "An offer was declined": "\uC81C\uC548\uC774 \uAC70\uC808\uB428",
  and: "\uADF8\uB9AC\uACE0",
  "Announcement bar": "\uACF5\uC9C0 \uD45C\uC2DC\uC904",
  "Are available at all the sales channels from the list": "\uBAA9\uB85D\uC758 \uBAA8\uB4E0 \uD310\uB9E4 \uCC44\uB110\uC5D0\uC11C \uAD6C\uB9E4 \uAC00\uB2A5",
  "Are available at one of the sales channels from the list": "\uBAA9\uB85D\uC758 \uD310\uB9E4 \uCC44\uB110 \uC911 \uD558\uB098\uC5D0\uC11C \uAD6C\uB9E4 \uAC00\uB2A5",
  "Are not available at all the sales channels from the list": "\uBAA9\uB85D\uC758 \uBAA8\uB4E0 \uD310\uB9E4 \uCC44\uB110\uC5D0\uC11C \uAD6C\uB9E4 \uBD88\uAC00",
  "Are not available at one of the sales channels from the list": "\uBAA9\uB85D\uC758 \uD310\uB9E4 \uCC44\uB110 \uC911 \uD558\uB098\uC5D0\uC11C \uAD6C\uB9E4 \uBD88\uAC00",
  "At least one product in the cart": "\uC7A5\uBC14\uAD6C\uB2C8\uC5D0 \uD558\uB098 \uC774\uC0C1\uC758 \uC0C1\uD488\uC774 \uC788\uC74C",
  Banner: "\uBC30\uB108",
  Between: "~ \uC0AC\uC774\uC5D0 \uC788\uC74C",
  Bundle: "\uBC88\uB4E4",
  "Cart/Order value": "\uC7A5\uBC14\uAD6C\uB2C8/\uC8FC\uBB38 \uAE08\uC561",
  categories: "\uCE74\uD14C\uACE0\uB9AC",
  category: "\uCE74\uD14C\uACE0\uB9AC",
  collection: "\uCEEC\uB809\uC158",
  collections: "\uCEEC\uB809\uC158",
  Contains: "\uB2E4\uC74C\uC744 \uD3EC\uD568",
  "Customer accepted marketing": "\uACE0\uAC1D\uC774 \uB9C8\uCF00\uD305\uC744 \uC218\uB77D\uD568",
  "Customer birthday": "\uACE0\uAC1D \uC0DD\uC77C",
  "Customer country": "\uACE0\uAC1D \uAD6D\uAC00",
  "customer doesn't have all the tags from the list": "\uACE0\uAC1D\uC774 \uBAA9\uB85D\uC758 \uBAA8\uB4E0 \uD0DC\uADF8\uB97C \uAC00\uC9C0\uACE0 \uC788\uC9C0 \uC54A\uC74C",
  "customer doesn't have any of the tags from the list": "\uACE0\uAC1D\uC774 \uBAA9\uB85D\uC758 \uD0DC\uADF8\uB97C \uAC00\uC9C0\uACE0 \uC788\uC9C0 \uC54A\uC74C",
  "Customer don't accepted marketing": "\uACE0\uAC1D\uC774 \uB9C8\uCF00\uD305\uC744 \uC218\uB77D\uD558\uC9C0 \uC54A\uC74C",
  "Customer email": "\uACE0\uAC1D \uC774\uBA54\uC77C",
  "customer has all the tags from the list": "\uACE0\uAC1D\uC774 \uBAA9\uB85D\uC758 \uBAA8\uB4E0 \uD0DC\uADF8\uB97C \uAC00\uC9D0",
  "customer has at least one of the tags from the list ": "\uACE0\uAC1D\uC774 \uBAA9\uB85D\uC758 \uD0DC\uADF8 \uC911 \uD558\uB098 \uC774\uC0C1\uC744 \uAC00\uC9D0 ",
  "Customer number of orders": "\uACE0\uAC1D \uC8FC\uBB38 \uC218",
  "Customer segments": "\uACE0\uAC1D \uC138\uADF8\uBA3C\uD2B8",
  "Customer tag": "\uACE0\uAC1D \uD0DC\uADF8",
  Days: "\uC77C",
  "Discount code": "\uD560\uC778 \uCF54\uB4DC",
  "Does not require shipping": "\uBC30\uC1A1 \uBD88\uD544\uC694",
  "Doesn't contain": "\uB2E4\uC74C\uC744 \uD3EC\uD568\uD558\uC9C0 \uC54A\uC74C",
  "Doesn't end with": "\uB2E4\uC74C\uC73C\uB85C \uB05D\uB098\uC9C0 \uC54A\uC74C",
  "Doesn't have all the tags from the list": "\uBAA9\uB85D\uC758 \uBAA8\uB4E0 \uD0DC\uADF8\uB97C \uAC00\uC9C0\uACE0 \uC788\uC9C0 \uC54A\uC74C",
  "Doesn't have some of the tags from the list": "\uBAA9\uB85D\uC758 \uC77C\uBD80 \uD0DC\uADF8\uB97C \uAC00\uC9C0\uACE0 \uC788\uC9C0 \uC54A\uC74C",
  "Doesn't start with": "\uB2E4\uC74C\uC73C\uB85C \uC2DC\uC791\uD558\uC9C0 \uC54A\uC74C",
  "Ends with": "\uB2E4\uC74C\uC73C\uB85C \uB05D\uB0A8",
  "Equal to": "\uAC19\uC74C",
  Equals: "\uAC19\uC74C",
  "Every product in the cart": "\uC7A5\uBC14\uAD6C\uB2C8\uC758 \uBAA8\uB4E0 \uC0C1\uD488",
  "Greater than": "\uBCF4\uB2E4 \uD07C",
  "Greater than or equals to": "\uD06C\uAC70\uB098 \uAC19\uC74C",
  "Has all the tags from the list": "\uBAA9\uB85D\uC758 \uBAA8\uB4E0 \uD0DC\uADF8\uB97C \uAC00\uC9D0",
  "Has at least one of the tags from the list": "\uBAA9\uB85D\uC758 \uD0DC\uADF8 \uC911 \uD558\uB098 \uC774\uC0C1\uC744 \uAC00\uC9D0",
  Hours: "\uC2DC\uAC04",
  "in less than": "\uC774\uB0B4",
  "Is (exact code)": "\uB2E4\uC74C\uACFC \uAC19\uC74C (\uC815\uD655\uD55C \uCF54\uB4DC)",
  "Is (exact email)": "\uB2E4\uC74C\uACFC \uAC19\uC74C (\uC815\uD655\uD55C \uC774\uBA54\uC77C)",
  "Is (exact sku)": "\uB2E4\uC74C\uACFC \uAC19\uC74C (\uC815\uD655\uD55C SKU)",
  "Is (exact title)": "\uB2E4\uC74C\uACFC \uAC19\uC74C (\uC815\uD655\uD55C \uC81C\uBAA9)",
  "Is (exact variant name)": "\uB2E4\uC74C\uACFC \uAC19\uC74C (\uC815\uD655\uD55C \uC635\uC158\uBA85)",
  "Is after": "\uB0A0\uC9DC\uAC00 \uB2E4\uC74C \uC774\uD6C4\uC784",
  "Is available at all the sales channels from the list": "\uBAA9\uB85D\uC758 \uBAA8\uB4E0 \uD310\uB9E4 \uCC44\uB110\uC5D0\uC11C \uAD6C\uB9E4 \uAC00\uB2A5",
  "Is available at all the sales channels in the list": "\uBAA9\uB85D\uC5D0 \uC788\uB294 \uBAA8\uB4E0 \uD310\uB9E4 \uCC44\uB110\uC5D0\uC11C \uC0AC\uC6A9\uD560 \uC218 \uC788\uC74C",
  "Is available at one of the sales channels from the list": "\uBAA9\uB85D\uC758 \uD310\uB9E4 \uCC44\uB110 \uC911 \uD558\uB098\uC5D0\uC11C \uAD6C\uB9E4 \uAC00\uB2A5",
  "Is available at one of the sales channels in the list": "\uBAA9\uB85D\uC5D0 \uC788\uB294 \uD310\uB9E4 \uCC44\uB110 \uC911 \uD558\uB098\uC5D0\uC11C \uC0AC\uC6A9\uD560 \uC218 \uC788\uC74C",
  "Is before": "\uB0A0\uC9DC\uAC00 \uB2E4\uC74C \uC774\uC804\uC784",
  "Is between": "~\uC0AC\uC774",
  "Is from a vendor in the list": "\uBAA9\uB85D\uC5D0 \uC788\uB294 \uACF5\uAE09\uC5C5\uCCB4\uC758 \uC81C\uD488\uC784",
  "Is from the list": "\uBAA9\uB85D\uC5D0 \uC788\uC74C",
  "Is greater than": "~\uBCF4\uB2E4 \uD07C",
  "Is greater than or equals to": "~\uBCF4\uB2E4 \uD06C\uAC70\uB098 \uAC19\uC74C",
  "Is in a category from the list": "\uBAA9\uB85D\uC758 \uCE74\uD14C\uACE0\uB9AC\uC5D0 \uC788\uC74C",
  "Is in a collection from the list": "\uBAA9\uB85D\uC758 \uCEEC\uB809\uC158\uC5D0 \uC788\uC74C",
  "Is less than": "~\uBCF4\uB2E4 \uC791\uC74C",
  "Is less than or equals to": "~\uBCF4\uB2E4 \uC791\uAC70\uB098 \uAC19\uC74C",
  "Is not (exact code)": "\uB2E4\uC74C\uACFC \uB2E4\uB984 (\uC815\uD655\uD55C \uCF54\uB4DC)",
  "Is not (exact email)": "\uB2E4\uC74C\uACFC \uB2E4\uB984 (\uC815\uD655\uD55C \uC774\uBA54\uC77C)",
  "Is not (exact sku)": "\uB2E4\uC74C\uACFC \uB2E4\uB984 (\uC815\uD655\uD55C SKU)",
  "Is not (exact title)": "\uB2E4\uC74C\uACFC \uB2E4\uB984 (\uC815\uD655\uD55C \uC81C\uBAA9)",
  "Is not (exact variant name)": "\uB2E4\uC74C\uACFC \uB2E4\uB984 (\uC815\uD655\uD55C \uC635\uC158\uBA85)",
  "Is not available at all the sales channels from the list": "\uBAA9\uB85D\uC758 \uBAA8\uB4E0 \uD310\uB9E4 \uCC44\uB110\uC5D0\uC11C \uAD6C\uB9E4 \uBD88\uAC00",
  "Is not available at all the sales channels in the list": "\uBAA9\uB85D\uC5D0 \uC788\uB294 \uBAA8\uB4E0 \uD310\uB9E4 \uCC44\uB110\uC5D0\uC11C \uC0AC\uC6A9\uD560 \uC218 \uC788\uB294 \uAC83\uC740 \uC544\uB2D8",
  "Is not available at one of the sales channels from the list": "\uBAA9\uB85D\uC758 \uD310\uB9E4 \uCC44\uB110 \uC911 \uD558\uB098\uC5D0\uC11C \uAD6C\uB9E4 \uBD88\uAC00",
  "Is not available at one of the sales channels in the list": "\uBAA9\uB85D\uC5D0 \uC788\uB294 \uD310\uB9E4 \uCC44\uB110 \uC911 \uC5B4\uB290 \uACF3\uC5D0\uC11C\uB3C4 \uC0AC\uC6A9\uD560 \uC218 \uC5C6\uC74C",
  "Is not between": "~ \uC0AC\uC774\uC5D0 \uC5C6\uC74C",
  "Is not equal to": "\uAC19\uC9C0 \uC54A\uC74C",
  "Is not from a vendor in the list": "\uBAA9\uB85D\uC5D0 \uC788\uB294 \uACF5\uAE09\uC5C5\uCCB4\uC758 \uC81C\uD488\uC774 \uC544\uB2D8",
  "Is not from the list": "\uBAA9\uB85D\uC5D0 \uC5C6\uC74C",
  "Is not in a category from the list": "\uBAA9\uB85D\uC758 \uCE74\uD14C\uACE0\uB9AC\uC5D0 \uC5C6\uC74C",
  "Is not in a collection from the list": "\uBAA9\uB85D\uC758 \uCEEC\uB809\uC158\uC5D0 \uC5C6\uC74C",
  "Is not of a type from the list": "\uBAA9\uB85D\uC5D0 \uC788\uB294 \uC720\uD615\uC774 \uC544\uB2D8",
  "Is not on": "\uB0A0\uC9DC\uAC00 \uB2E4\uC74C\uACFC \uAC19\uC9C0 \uC54A\uC74C",
  "Is not one of the countries from the list": "\uBAA9\uB85D\uC758 \uAD6D\uAC00 \uC911 \uD558\uB098\uAC00 \uC544\uB2D8",
  "Is not one of the customer segments from the list": "\uBAA9\uB85D\uC758 \uACE0\uAC1D \uC138\uADF8\uBA3C\uD2B8 \uC911 \uD558\uB098\uAC00 \uC544\uB2D8",
  "Is not one of the fulfillment statuses in the list": "\uBAA9\uB85D\uC758 \uC774\uD589 \uC0C1\uD0DC \uC911 \uD558\uB098\uAC00 \uC544\uB2D8",
  "Is not one of the languages from the list": "\uBAA9\uB85D\uC758 \uC5B8\uC5B4 \uC911 \uD558\uB098\uAC00 \uC544\uB2D8",
  "Is not one of the methods in the list": "\uBAA9\uB85D\uC5D0 \uC788\uB294 \uBC29\uBC95 \uC911 \uD558\uB098\uAC00 \uC544\uB2D8",
  "Is not one of the payment statuses in the list": "\uBAA9\uB85D\uC5D0 \uC788\uB294 \uACB0\uC81C \uC0C1\uD0DC \uC911 \uD558\uB098\uAC00 \uC544\uB2D8",
  "Is not tagged with all the tags in the list": "\uBAA9\uB85D\uC758 \uBAA8\uB4E0 \uD0DC\uADF8\uB85C \uD0DC\uADF8 \uC9C0\uC815\uB418\uC9C0 \uC54A\uC74C",
  "Is not tagged with any of the tags in the list": "\uBAA9\uB85D\uC758 \uD0DC\uADF8 \uC911 \uC5B4\uB5A4 \uAC83\uB3C4 \uD0DC\uADF8\uB418\uC9C0 \uC54A\uC74C",
  "Is not tagged with at least one of the tags in the list": "\uBAA9\uB85D\uC758 \uD0DC\uADF8 \uC911 \uD558\uB098 \uC774\uC0C1\uC73C\uB85C \uD0DC\uADF8 \uC9C0\uC815\uB418\uC9C0 \uC54A\uC74C",
  "Is of a type from the list": "\uBAA9\uB85D\uC5D0 \uC788\uB294 \uC720\uD615\uC784",
  "Is on": "\uB0A0\uC9DC\uAC00 \uB2E4\uC74C\uACFC \uAC19\uC74C",
  "Is one of the countries from the list": "\uBAA9\uB85D\uC758 \uAD6D\uAC00 \uC911 \uD558\uB098\uC784",
  "Is one of the customer segments from the list": "\uBAA9\uB85D\uC758 \uACE0\uAC1D \uC138\uADF8\uBA3C\uD2B8 \uC911 \uD558\uB098\uC784",
  "Is one of the fulfillment statuses in the list": "\uBAA9\uB85D\uC758 \uC774\uD589 \uC0C1\uD0DC \uC911 \uD558\uB098\uC784",
  "Is one of the languages from the list": "\uBAA9\uB85D\uC758 \uC5B8\uC5B4 \uC911 \uD558\uB098\uC784",
  "Is one of the methods in the list": "\uBAA9\uB85D\uC5D0 \uC788\uB294 \uBC29\uBC95 \uC911 \uD558\uB098\uC784",
  "Is one of the payment statuses in the list": "\uBAA9\uB85D\uC5D0 \uC788\uB294 \uACB0\uC81C \uC0C1\uD0DC \uC911 \uD558\uB098\uC784",
  "Is tagged with all the tags in the list": "\uBAA9\uB85D\uC758 \uBAA8\uB4E0 \uD0DC\uADF8\uB85C \uD0DC\uADF8\uB428",
  "Is tagged with at least one of the tags in the list": "\uBAA9\uB85D\uC758 \uD0DC\uADF8 \uC911 \uCD5C\uC18C \uD558\uB098\uB85C \uD0DC\uADF8\uB428",
  "Item cost": "\uD56D\uBAA9 \uBE44\uC6A9",
  Language: "\uC5B8\uC5B4",
  "Less than": "\uBCF4\uB2E4 \uC791\uC74C",
  "Less than or equals to": "\uC791\uAC70\uB098 \uAC19\uC74C",
  "Marketing consent": "\uB9C8\uCF00\uD305 \uC218\uC2E0 \uB3D9\uC758",
  Minutes: "\uBD84",
  Months: "\uAC1C\uC6D4",
  "Number of orders": "\uC8FC\uBB38 \uC218",
  "On all of the post purchase pages": "\uBAA8\uB4E0 \uAD6C\uB9E4 \uD6C4 \uD398\uC774\uC9C0\uC5D0\uC11C",
  "On one of the post purchase pages": "\uAD6C\uB9E4 \uD6C4 \uD398\uC774\uC9C0 \uC911 \uD558\uB098\uC5D0\uC11C",
  "On the checkout": "\uACB0\uC81C \uD398\uC774\uC9C0\uC5D0\uC11C",
  "On the post purchase 1st page": "\uAD6C\uB9E4 \uD6C4 \uCCAB \uBC88\uC9F8 \uD398\uC774\uC9C0\uC5D0\uC11C",
  "On the post purchase 2nd page": "\uAD6C\uB9E4 \uD6C4 \uB450 \uBC88\uC9F8 \uD398\uC774\uC9C0\uC5D0\uC11C",
  "On the thank you page": "\uAC10\uC0AC \uD398\uC774\uC9C0\uC5D0\uC11C",
  "Order note": "\uC8FC\uBB38 \uBA54\uBAA8",
  "Order tags": "\uC8FC\uBB38 \uD0DC\uADF8",
  "Passed X time ago": "X \uC804\uC5D0 \uC9C0\uB0A8",
  "Payment method": "\uACB0\uC81C \uBC29\uBC95",
  "please add cart or order value": "\uC7A5\uBC14\uAD6C\uB2C8 \uB610\uB294 \uC8FC\uBB38 \uAE08\uC561\uC744 \uCD94\uAC00\uD574\uC8FC\uC138\uC694",
  "please add customer email": "\uACE0\uAC1D \uC774\uBA54\uC77C\uC744 \uCD94\uAC00\uD574\uC8FC\uC138\uC694",
  "please add customer number of orders": "\uACE0\uAC1D \uC8FC\uBB38 \uC218\uB97C \uCD94\uAC00\uD574\uC8FC\uC138\uC694",
  "please add discount code": "\uD560\uC778 \uCF54\uB4DC\uB97C \uCD94\uAC00\uD574\uC8FC\uC138\uC694",
  "please add item cost": "\uD56D\uBAA9 \uBE44\uC6A9\uC744 \uCD94\uAC00\uD574 \uC8FC\uC138\uC694",
  "please add number of orders": "\uC8FC\uBB38 \uC218\uB97C \uCD94\uAC00\uD574 \uC8FC\uC138\uC694",
  "please add order note": "\uC8FC\uBB38 \uBA54\uBAA8\uB97C \uCD94\uAC00\uD574\uC8FC\uC138\uC694",
  "please add product price": "\uC81C\uD488 \uAC00\uACA9\uC744 \uCD94\uAC00\uD574 \uC8FC\uC138\uC694",
  "please add product sku": "\uC0C1\uD488 SKU\uB97C \uCD94\uAC00\uD574\uC8FC\uC138\uC694",
  "please add product title": "\uC0C1\uD488\uBA85\uC744 \uCD94\uAC00\uD574\uC8FC\uC138\uC694",
  "please add product variant name": "\uC0C1\uD488 \uC635\uC158\uBA85\uC744 \uCD94\uAC00\uD574\uC8FC\uC138\uC694",
  "please add shipping value": "\uBC30\uC1A1 \uBE44\uC6A9\uC744 \uCD94\uAC00\uD574\uC8FC\uC138\uC694",
  "please add time since last order": "\uB9C8\uC9C0\uB9C9 \uC8FC\uBB38 \uC774\uD6C4\uC758 \uC2DC\uAC04\uC744 \uCD94\uAC00\uD558\uC2ED\uC2DC\uC624",
  "please add total item count": "\uCD1D \uD56D\uBAA9 \uC218\uB97C \uCD94\uAC00\uD574 \uC8FC\uC138\uC694",
  "please add value": "\uAC12\uC744 \uCD94\uAC00\uD574\uC8FC\uC138\uC694",
  "please select collections": "\uCEEC\uB809\uC158\uC744 \uC120\uD0DD\uD574\uC8FC\uC138\uC694",
  "please select customer birthday": "\uACE0\uAC1D \uC0DD\uC77C\uC744 \uC120\uD0DD\uD558\uC2ED\uC2DC\uC624",
  "please select customer country": "\uACE0\uAC1D \uAD6D\uAC00\uB97C \uC120\uD0DD\uD574\uC8FC\uC138\uC694",
  "please select customer language": "\uACE0\uAC1D \uC5B8\uC5B4\uB97C \uC120\uD0DD\uD574\uC8FC\uC138\uC694",
  "please select customer segments": "\uACE0\uAC1D \uC138\uADF8\uBA3C\uD2B8\uB97C \uC120\uD0DD\uD574\uC8FC\uC138\uC694",
  "please select customer tag": "\uACE0\uAC1D \uD0DC\uADF8\uB97C \uC120\uD0DD\uD574\uC8FC\uC138\uC694",
  "please select customer tags": "\uACE0\uAC1D \uD0DC\uADF8\uB97C \uC120\uD0DD\uD558\uC2ED\uC2DC\uC624",
  "please select fulfillment statuses": "\uC774\uD589 \uC0C1\uD0DC\uB97C \uC120\uD0DD\uD574\uC8FC\uC138\uC694",
  "please select offer": "\uC81C\uC548\uC744 \uC120\uD0DD\uD574\uC8FC\uC138\uC694",
  "please select payment method": "\uACB0\uC81C \uBC29\uBC95\uC744 \uC120\uD0DD\uD574 \uC8FC\uC138\uC694",
  "please select payment statuses": "\uACB0\uC81C \uC0C1\uD0DC\uB97C \uC120\uD0DD\uD574 \uC8FC\uC138\uC694",
  "please select product type": "\uC81C\uD488 \uC720\uD615\uC744 \uC120\uD0DD\uD574 \uC8FC\uC138\uC694",
  "please select product vendor": "\uC81C\uD488 \uACF5\uAE09\uC5C5\uCCB4\uB97C \uC120\uD0DD\uD574 \uC8FC\uC138\uC694",
  "please select products": "\uC0C1\uD488\uC744 \uC120\uD0DD\uD574\uC8FC\uC138\uC694",
  "please select sales channel": "\uD310\uB9E4 \uCC44\uB110\uC744 \uC120\uD0DD\uD574\uC8FC\uC138\uC694",
  "please select shipping methods": "\uBC30\uC1A1 \uBC29\uBC95\uC744 \uC120\uD0DD\uD574\uC8FC\uC138\uC694",
  "please select tags": "\uD0DC\uADF8\uB97C \uC120\uD0DD\uD574\uC8FC\uC138\uC694",
  "Previous page offer": "\uC774\uC804 \uD398\uC774\uC9C0 \uC81C\uC548",
  product: "\uC0C1\uD488",
  "Product recommendations": "\uCD94\uCC9C \uC0C1\uD488",
  "Product type": "\uC81C\uD488 \uC720\uD615",
  "Product upsell": "\uC0C1\uD488 \uC5C5\uC140",
  products: "\uC0C1\uD488",
  "Requires shipping": "\uBC30\uC1A1 \uD544\uC694",
  "Shipping method": "\uBC30\uC1A1 \uBC29\uBC95",
  "Shipping value": "\uBC30\uC1A1 \uBE44\uC6A9",
  "Starts with": "\uB2E4\uC74C\uC73C\uB85C \uC2DC\uC791",
  Status: "\uC0C1\uD0DC",
  "The displayed product": "\uD45C\uC2DC\uB41C \uC0C1\uD488",
  "The displayed product SKU": "\uD45C\uC2DC\uB41C \uC0C1\uD488 SKU",
  "The only product title in the cart": "\uC7A5\uBC14\uAD6C\uB2C8\uC5D0 \uC788\uB294 \uC720\uC77C\uD55C \uC0C1\uD488 \uC81C\uBAA9",
  "The only SKU in the cart": "\uC7A5\uBC14\uAD6C\uB2C8\uC5D0 \uC788\uB294 \uC720\uC77C\uD55C SKU",
  "The SKU of all products in the cart": "\uC7A5\uBC14\uAD6C\uB2C8\uC5D0 \uC788\uB294 \uBAA8\uB4E0 \uC0C1\uD488\uC758 SKU",
  "The SKU of at least one product in the cart": "\uC7A5\uBC14\uAD6C\uB2C8\uC5D0 \uC788\uB294 \uD558\uB098 \uC774\uC0C1 \uC0C1\uD488\uC758 SKU",
  "The title of all products in the cart": "\uC7A5\uBC14\uAD6C\uB2C8\uC5D0 \uC788\uB294 \uBAA8\uB4E0 \uC0C1\uD488\uC758 \uC81C\uBAA9",
  "The title of at least one product in the cart": "\uC7A5\uBC14\uAD6C\uB2C8\uC5D0 \uC788\uB294 \uD558\uB098 \uC774\uC0C1 \uC0C1\uD488\uC758 \uC81C\uBAA9",
  "The title of the displayed product": "\uD45C\uC2DC\uB41C \uC0C1\uD488\uC758 \uC81C\uBAA9",
  "The variant of all products in the cart": "\uC7A5\uBC14\uAD6C\uB2C8\uC5D0 \uC788\uB294 \uBAA8\uB4E0 \uC0C1\uD488\uC758 \uC635\uC158",
  "The variant of at least one product in the cart": "\uC7A5\uBC14\uAD6C\uB2C8\uC5D0 \uC788\uB294 \uD558\uB098 \uC774\uC0C1 \uC0C1\uD488\uC758 \uC635\uC158",
  "The variant of only product in the cart": "\uC7A5\uBC14\uAD6C\uB2C8\uC5D0 \uC788\uB294 \uC720\uC77C\uD55C \uC0C1\uD488\uC758 \uC635\uC158",
  "The variant of the displayed product": "\uD45C\uC2DC\uB41C \uC0C1\uD488\uC758 \uC635\uC158",
  "Total item count": "\uCD1D \uD56D\uBAA9 \uC218",
  Weeks: "\uC8FC",
  Years: "\uB144"
};

// src/lang/sv.json
var sv_default = {
  "An offer was accepted": "Ett erbjudande accepterades",
  "An offer was declined": "Ett erbjudande avb\xF6jdes",
  and: "och",
  "Announcement bar": "Meddelandef\xE4lt",
  "Are available at all the sales channels from the list": "\xC4r tillg\xE4ngliga p\xE5 alla s\xE4ljkanaler fr\xE5n listan",
  "Are available at one of the sales channels from the list": "\xC4r tillg\xE4ngliga p\xE5 en av s\xE4ljkanalerna fr\xE5n listan",
  "Are not available at all the sales channels from the list": "\xC4r inte tillg\xE4ngliga p\xE5 alla s\xE4ljkanaler fr\xE5n listan",
  "Are not available at one of the sales channels from the list": "\xC4r inte tillg\xE4ngliga p\xE5 en av s\xE4ljkanalerna fr\xE5n listan",
  "At least one product in the cart": "Minst en produkt i varukorgen",
  Banner: "Banner",
  Between: "Mellan",
  Bundle: "Paket",
  "Cart/Order value": "Varukorgs-/Orderv\xE4rde",
  categories: "kategorier",
  category: "kategori",
  collection: "kollektion",
  collections: "kollektioner",
  Contains: "Inneh\xE5ller",
  "Customer accepted marketing": "Kunden accepterade marknadsf\xF6ring",
  "Customer birthday": "Kundens f\xF6delsedag",
  "Customer country": "Kundens land",
  "customer doesn't have all the tags from the list": "kunden har inte alla taggar fr\xE5n listan",
  "customer doesn't have any of the tags from the list": "kunden har inga av taggarna fr\xE5n listan",
  "Customer don't accepted marketing": "Kunden accepterade inte marknadsf\xF6ring",
  "Customer email": "Kundens e-postadress",
  "customer has all the tags from the list": "kunden har alla taggar fr\xE5n listan",
  "customer has at least one of the tags from the list ": "kunden har minst en av taggarna fr\xE5n listan ",
  "Customer number of orders": "Kundens antal best\xE4llningar",
  "Customer segments": "Kundsegment",
  "Customer tag": "Kundtagg",
  Days: "Dagar",
  "Discount code": "Rabattkod",
  "Does not require shipping": "Kr\xE4ver inte frakt",
  "Doesn't contain": "Inneh\xE5ller inte",
  "Doesn't end with": "Slutar inte med",
  "Doesn't have all the tags from the list": "Har inte alla taggar fr\xE5n listan",
  "Doesn't have some of the tags from the list": "Har inte n\xE5gra av taggarna fr\xE5n listan",
  "Doesn't start with": "B\xF6rjar inte med",
  "Ends with": "Slutar med",
  "Equal to": "Lika med",
  Equals: "\xC4r lika med",
  "Every product in the cart": "Varje produkt i varukorgen",
  "Greater than": "St\xF6rre \xE4n",
  "Greater than or equals to": "St\xF6rre \xE4n eller lika med",
  "Has all the tags from the list": "Har alla taggar fr\xE5n listan",
  "Has at least one of the tags from the list": "Har minst en av taggarna fr\xE5n listan",
  Hours: "Timmar",
  "in less than": "om mindre \xE4n",
  "Is (exact code)": "\xC4r (exakt kod)",
  "Is (exact email)": "\xC4r (exakt e-postadress)",
  "Is (exact sku)": "\xC4r (exakt sku)",
  "Is (exact title)": "\xC4r (exakt titel)",
  "Is (exact variant name)": "\xC4r (exakt variantnamn)",
  "Is after": "\xC4r efter",
  "Is available at all the sales channels from the list": "\xC4r tillg\xE4nglig p\xE5 alla s\xE4ljkanaler fr\xE5n listan",
  "Is available at all the sales channels in the list": "\xC4r tillg\xE4nglig i alla f\xF6rs\xE4ljningskanalerna i listan",
  "Is available at one of the sales channels from the list": "\xC4r tillg\xE4nglig p\xE5 en av s\xE4ljkanalerna fr\xE5n listan",
  "Is available at one of the sales channels in the list": "\xC4r tillg\xE4nglig i en av f\xF6rs\xE4ljningskanalerna i listan",
  "Is before": "\xC4r f\xF6re",
  "Is between": "\xC4r mellan",
  "Is from a vendor in the list": "\xC4r fr\xE5n en leverant\xF6r i listan",
  "Is from the list": "\xC4r fr\xE5n listan",
  "Is greater than": "\xC4r st\xF6rre \xE4n",
  "Is greater than or equals to": "\xC4r st\xF6rre \xE4n eller lika med",
  "Is in a category from the list": "\xC4r i en kategori fr\xE5n listan",
  "Is in a collection from the list": "\xC4r i en kollektion fr\xE5n listan",
  "Is less than": "\xC4r mindre \xE4n",
  "Is less than or equals to": "\xC4r mindre \xE4n eller lika med",
  "Is not (exact code)": "\xC4r inte (exakt kod)",
  "Is not (exact email)": "\xC4r inte (exakt e-postadress)",
  "Is not (exact sku)": "\xC4r inte (exakt sku)",
  "Is not (exact title)": "\xC4r inte (exakt titel)",
  "Is not (exact variant name)": "\xC4r inte (exakt variantnamn)",
  "Is not available at all the sales channels from the list": "\xC4r inte tillg\xE4nglig p\xE5 alla s\xE4ljkanaler fr\xE5n listan",
  "Is not available at all the sales channels in the list": "\xC4r inte tillg\xE4nglig i alla f\xF6rs\xE4ljningskanalerna i listan",
  "Is not available at one of the sales channels from the list": "\xC4r inte tillg\xE4nglig p\xE5 en av s\xE4ljkanalerna fr\xE5n listan",
  "Is not available at one of the sales channels in the list": "\xC4r inte tillg\xE4nglig i n\xE5gon av f\xF6rs\xE4ljningskanalerna i listan",
  "Is not between": "\xC4r inte mellan",
  "Is not equal to": "\xC4r inte lika med",
  "Is not from a vendor in the list": "\xC4r inte fr\xE5n en leverant\xF6r i listan",
  "Is not from the list": "\xC4r inte fr\xE5n listan",
  "Is not in a category from the list": "\xC4r inte i en kategori fr\xE5n listan",
  "Is not in a collection from the list": "\xC4r inte i en kollektion fr\xE5n listan",
  "Is not of a type from the list": "\xC4r inte av en typ fr\xE5n listan",
  "Is not on": "\xC4r inte den",
  "Is not one of the countries from the list": "\xC4r inte ett av l\xE4nderna fr\xE5n listan",
  "Is not one of the customer segments from the list": "\xC4r inte ett av kundsegmenten fr\xE5n listan",
  "Is not one of the fulfillment statuses in the list": "\xC4r inte en av uppfyllelse statusarna i listan",
  "Is not one of the languages from the list": "\xC4r inte ett av spr\xE5ken fr\xE5n listan",
  "Is not one of the methods in the list": "\xC4r inte en av metoderna i listan",
  "Is not one of the payment statuses in the list": "\xC4r inte en av betalningsstatusarna i listan",
  "Is not tagged with all the tags in the list": "\xC4r inte taggad med alla taggar i listan",
  "Is not tagged with any of the tags in the list": "\xC4r inte m\xE4rkt med n\xE5gon av taggarna i listan",
  "Is not tagged with at least one of the tags in the list": "\xC4r inte taggad med minst en av taggarna i listan",
  "Is of a type from the list": "\xC4r av en typ fr\xE5n listan",
  "Is on": "\xC4r den",
  "Is one of the countries from the list": "\xC4r ett av l\xE4nderna fr\xE5n listan",
  "Is one of the customer segments from the list": "\xC4r ett av kundsegmenten fr\xE5n listan",
  "Is one of the fulfillment statuses in the list": "\xC4r en av uppfyllelse statusarna i listan",
  "Is one of the languages from the list": "\xC4r ett av spr\xE5ken fr\xE5n listan",
  "Is one of the methods in the list": "\xC4r en av metoderna i listan",
  "Is one of the payment statuses in the list": "\xC4r en av betalningsstatusarna i listan",
  "Is tagged with all the tags in the list": "\xC4r m\xE4rkt med alla taggar i listan",
  "Is tagged with at least one of the tags in the list": "\xC4r m\xE4rkt med minst en av taggarna i listan",
  "Item cost": "Artikelkostnad",
  Language: "Spr\xE5k",
  "Less than": "Mindre \xE4n",
  "Less than or equals to": "Mindre \xE4n eller lika med",
  "Marketing consent": "Samtycke till marknadsf\xF6ring",
  Minutes: "Minuter",
  Months: "M\xE5nader",
  "Number of orders": "Antal best\xE4llningar",
  "On all of the post purchase pages": "P\xE5 alla sidor efter k\xF6p",
  "On one of the post purchase pages": "P\xE5 en av sidorna efter k\xF6p",
  "On the checkout": "I kassan",
  "On the post purchase 1st page": "P\xE5 f\xF6rsta sidan efter k\xF6p",
  "On the post purchase 2nd page": "P\xE5 andra sidan efter k\xF6p",
  "On the thank you page": "P\xE5 tacksidan",
  "Order note": "Orderanteckning",
  "Order tags": "Ordertaggar",
  "Passed X time ago": "Passerades f\xF6r X sedan",
  "Payment method": "Betalningsmetod",
  "please add cart or order value": "v\xE4nligen l\xE4gg till varukorgs- eller orderv\xE4rde",
  "please add customer email": "v\xE4nligen l\xE4gg till kundens e-postadress",
  "please add customer number of orders": "v\xE4nligen l\xE4gg till kundens antal best\xE4llningar",
  "please add discount code": "v\xE4nligen l\xE4gg till rabattkod",
  "please add item cost": "V\xE4nligen l\xE4gg till artikelkostnad",
  "please add number of orders": "V\xE4nligen l\xE4gg till antal best\xE4llningar",
  "please add order note": "v\xE4nligen l\xE4gg till orderanteckning",
  "please add product price": "V\xE4nligen l\xE4gg till produktpris",
  "please add product sku": "v\xE4nligen l\xE4gg till produkt-SKU",
  "please add product title": "v\xE4nligen l\xE4gg till produkttitel",
  "please add product variant name": "v\xE4nligen l\xE4gg till produktvariantnamn",
  "please add shipping value": "v\xE4nligen l\xE4gg till fraktv\xE4rde",
  "please add time since last order": "V\xE4nligen l\xE4gg till tid sedan senaste best\xE4llning",
  "please add total item count": "V\xE4nligen l\xE4gg till totalt antal artiklar",
  "please add value": "v\xE4nligen l\xE4gg till v\xE4rde",
  "please select collections": "v\xE4nligen v\xE4lj kollektioner",
  "please select customer birthday": "V\xE4nligen v\xE4lj kundens f\xF6delsedag",
  "please select customer country": "v\xE4nligen v\xE4lj kundland",
  "please select customer language": "v\xE4nligen v\xE4lj kundspr\xE5k",
  "please select customer segments": "v\xE4nligen v\xE4lj kundsegment",
  "please select customer tag": "v\xE4nligen v\xE4lj kundtagg",
  "please select customer tags": "V\xE4nligen v\xE4lj kundtaggar",
  "please select fulfillment statuses": "v\xE4nligen v\xE4lj uppfyllelse statusar",
  "please select offer": "v\xE4nligen v\xE4lj erbjudande",
  "please select payment method": "V\xE4nligen v\xE4lj betalningsmetod",
  "please select payment statuses": "V\xE4nligen v\xE4lj betalningsstatusar",
  "please select product type": "V\xE4nligen v\xE4lj produkttyp",
  "please select product vendor": "V\xE4nligen v\xE4lj produktleverant\xF6r",
  "please select products": "v\xE4nligen v\xE4lj produkter",
  "please select sales channel": "v\xE4nligen v\xE4lj s\xE4ljkanal",
  "please select shipping methods": "v\xE4nligen v\xE4lj fraktmetoder",
  "please select tags": "v\xE4nligen v\xE4lj taggar",
  "Previous page offer": "F\xF6reg\xE5ende sidas erbjudande",
  product: "produkt",
  "Product recommendations": "Produktrekommendationer",
  "Product type": "Produkttyp",
  "Product upsell": "Produktmerf\xF6rs\xE4ljning",
  products: "produkter",
  "Requires shipping": "Kr\xE4ver frakt",
  "Shipping method": "Fraktmetod",
  "Shipping value": "Fraktv\xE4rde",
  "Starts with": "B\xF6rjar med",
  Status: "Status",
  "The displayed product": "Den visade produkten",
  "The displayed product SKU": "SKU f\xF6r den visade produkten",
  "The only product title in the cart": "Den enda produkttiteln i varukorgen",
  "The only SKU in the cart": "Endast SKU i varukorgen",
  "The SKU of all products in the cart": "SKU f\xF6r alla produkter i varukorgen",
  "The SKU of at least one product in the cart": "SKU f\xF6r minst en produkt i varukorgen",
  "The title of all products in the cart": "Titeln p\xE5 alla produkter i varukorgen",
  "The title of at least one product in the cart": "Titeln p\xE5 minst en produkt i varukorgen",
  "The title of the displayed product": "Titeln p\xE5 den visade produkten",
  "The variant of all products in the cart": "Varianten av alla produkter i varukorgen",
  "The variant of at least one product in the cart": "Varianten av minst en produkt i varukorgen",
  "The variant of only product in the cart": "Varianten av den enda produkten i varukorgen",
  "The variant of the displayed product": "Varianten av den visade produkten",
  "Total item count": "Totalt antal artiklar",
  Weeks: "Veckor",
  Years: "\xC5r"
};

// src/lang/pl.json
var pl_default = {
  "An offer was accepted": "Oferta zosta\u0142a zaakceptowana",
  "An offer was declined": "Oferta zosta\u0142a odrzucona",
  and: "i",
  "Announcement bar": "Pasek og\u0142osze\u0144",
  "Are available at all the sales channels from the list": "S\u0105 dost\u0119pne we wszystkich kana\u0142ach sprzeda\u017Cy z listy",
  "Are available at one of the sales channels from the list": "S\u0105 dost\u0119pne w jednym z kana\u0142\xF3w sprzeda\u017Cy z listy",
  "Are not available at all the sales channels from the list": "Nie s\u0105 dost\u0119pne we wszystkich kana\u0142ach sprzeda\u017Cy z listy",
  "Are not available at one of the sales channels from the list": "Nie s\u0105 dost\u0119pne w jednym z kana\u0142\xF3w sprzeda\u017Cy z listy",
  "At least one product in the cart": "Co najmniej jeden produkt w koszyku",
  Banner: "Baner",
  Between: "Pomi\u0119dzy",
  Bundle: "Zestaw",
  "Cart/Order value": "Warto\u015B\u0107 koszyka/zam\xF3wienia",
  categories: "kategorie",
  category: "kategoria",
  collection: "kolekcja",
  collections: "kolekcje",
  Contains: "Zawiera",
  "Customer accepted marketing": "Klient zaakceptowa\u0142 marketing",
  "Customer birthday": "Urodziny klienta",
  "Customer country": "Kraj klienta",
  "customer doesn't have all the tags from the list": "klient nie ma wszystkich tag\xF3w z listy",
  "customer doesn't have any of the tags from the list": "klient nie ma \u017Cadnego z tag\xF3w z listy",
  "Customer don't accepted marketing": "Klient nie zaakceptowa\u0142 marketingu",
  "Customer email": "E-mail klienta",
  "customer has all the tags from the list": "klient ma wszystkie tagi z listy",
  "customer has at least one of the tags from the list ": "klient ma co najmniej jeden z tag\xF3w z listy",
  "Customer number of orders": "Liczba zam\xF3wie\u0144 klienta",
  "Customer segments": "Segmenty klient\xF3w",
  "Customer tag": "Tag klienta",
  Days: "Dni",
  "Discount code": "Kod rabatowy",
  "Does not require shipping": "Nie wymaga wysy\u0142ki",
  "Doesn't contain": "Nie zawiera",
  "Doesn't end with": "Nie ko\u0144czy si\u0119 na",
  "Doesn't have all the tags from the list": "Nie ma wszystkich tag\xF3w z listy",
  "Doesn't have some of the tags from the list": "Nie ma niekt\xF3rych tag\xF3w z listy",
  "Doesn't start with": "Nie zaczyna si\u0119 od",
  "Ends with": "Ko\u0144czy si\u0119 na",
  "Equal to": "R\xF3wne",
  Equals: "R\xF3wna si\u0119",
  "Every product in the cart": "Ka\u017Cdy produkt w koszyku",
  "Greater than": "Wi\u0119ksze ni\u017C",
  "Greater than or equals to": "Wi\u0119ksze lub r\xF3wne",
  "Has all the tags from the list": "Ma wszystkie tagi z listy",
  "Has at least one of the tags from the list": "Ma co najmniej jeden z tag\xF3w z listy",
  Hours: "Godziny",
  "in less than": "w mniej ni\u017C",
  "Is (exact code)": "Jest (dok\u0142adny kod)",
  "Is (exact email)": "Jest (dok\u0142adny e-mail)",
  "Is (exact sku)": "Jest (dok\u0142adne SKU)",
  "Is (exact title)": "Jest (dok\u0142adny tytu\u0142)",
  "Is (exact variant name)": "Jest (dok\u0142adna nazwa wariantu)",
  "Is after": "Jest po",
  "Is available at all the sales channels from the list": "Jest dost\u0119pny we wszystkich kana\u0142ach sprzeda\u017Cy z listy",
  "Is available at all the sales channels in the list": "Jest dost\u0119pny we wszystkich kana\u0142ach sprzeda\u017Cy na li\u015Bcie",
  "Is available at one of the sales channels from the list": "Jest dost\u0119pny w jednym z kana\u0142\xF3w sprzeda\u017Cy z listy",
  "Is available at one of the sales channels in the list": "Jest dost\u0119pny w jednym z kana\u0142\xF3w sprzeda\u017Cy na li\u015Bcie",
  "Is before": "Jest przed",
  "Is between": "Jest pomi\u0119dzy",
  "Is from a vendor in the list": "Pochodzi od sprzedawcy z listy",
  "Is from the list": "Pochodzi z listy",
  "Is greater than": "Jest wi\u0119ksze ni\u017C",
  "Is greater than or equals to": "Jest wi\u0119ksze lub r\xF3wne",
  "Is in a category from the list": "Jest w kategorii z listy",
  "Is in a collection from the list": "Jest w kolekcji z listy",
  "Is less than": "Jest mniejsze ni\u017C",
  "Is less than or equals to": "Jest mniejsze lub r\xF3wne",
  "Is not (exact code)": "Nie jest (dok\u0142adny kod)",
  "Is not (exact email)": "Nie jest (dok\u0142adny e-mail)",
  "Is not (exact sku)": "Nie jest (dok\u0142adne SKU)",
  "Is not (exact title)": "Nie jest (dok\u0142adny tytu\u0142)",
  "Is not (exact variant name)": "Nie jest (dok\u0142adna nazwa wariantu)",
  "Is not available at all the sales channels from the list": "Nie jest dost\u0119pny we wszystkich kana\u0142ach sprzeda\u017Cy z listy",
  "Is not available at all the sales channels in the list": "Nie jest dost\u0119pny we wszystkich kana\u0142ach sprzeda\u017Cy na li\u015Bcie",
  "Is not available at one of the sales channels from the list": "Nie jest dost\u0119pny w jednym z kana\u0142\xF3w sprzeda\u017Cy z listy",
  "Is not available at one of the sales channels in the list": "Nie jest dost\u0119pny w \u017Cadnym z kana\u0142\xF3w sprzeda\u017Cy na li\u015Bcie",
  "Is not between": "Nie jest pomi\u0119dzy",
  "Is not equal to": "Nie jest r\xF3wne",
  "Is not from a vendor in the list": "Nie pochodzi od sprzedawcy z listy",
  "Is not from the list": "Nie pochodzi z listy",
  "Is not in a category from the list": "Nie jest w kategorii z listy",
  "Is not in a collection from the list": "Nie jest w kolekcji z listy",
  "Is not of a type from the list": "Nie jest typu z listy",
  "Is not on": "Nie jest w dniu",
  "Is not one of the countries from the list": "Nie jest jednym z kraj\xF3w z listy",
  "Is not one of the customer segments from the list": "Nie jest jednym z segment\xF3w klient\xF3w z listy",
  "Is not one of the fulfillment statuses in the list": "Nie jest jednym ze status\xF3w realizacji z listy",
  "Is not one of the languages from the list": "Nie jest jednym z j\u0119zyk\xF3w z listy",
  "Is not one of the methods in the list": "Nie jest jedn\u0105 z metod na li\u015Bcie",
  "Is not one of the payment statuses in the list": "Nie jest jednym ze status\xF3w p\u0142atno\u015Bci z listy",
  "Is not tagged with all the tags in the list": "Nie jest otagowany wszystkimi tagami z listy",
  "Is not tagged with any of the tags in the list": "Nie jest oznaczony \u017Cadnym z tag\xF3w na li\u015Bcie",
  "Is not tagged with at least one of the tags in the list": "Nie jest otagowany co najmniej jednym tagiem z listy",
  "Is of a type from the list": "Jest typu z listy",
  "Is on": "Jest w dniu",
  "Is one of the countries from the list": "Jest jednym z kraj\xF3w z listy",
  "Is one of the customer segments from the list": "Jest jednym z segment\xF3w klient\xF3w z listy",
  "Is one of the fulfillment statuses in the list": "Jest jednym ze status\xF3w realizacji z listy",
  "Is one of the languages from the list": "Jest jednym z j\u0119zyk\xF3w z listy",
  "Is one of the methods in the list": "Jest jedn\u0105 z metod na li\u015Bcie",
  "Is one of the payment statuses in the list": "Jest jednym ze status\xF3w p\u0142atno\u015Bci z listy",
  "Is tagged with all the tags in the list": "Jest oznaczony wszystkimi tagami z listy",
  "Is tagged with at least one of the tags in the list": "Jest oznaczony przynajmniej jednym z tag\xF3w z listy",
  "Item cost": "Koszt pozycji",
  Language: "J\u0119zyk",
  "Less than": "Mniejsze ni\u017C",
  "Less than or equals to": "Mniejsze lub r\xF3wne",
  "Marketing consent": "Zgoda na marketing",
  Minutes: "Minuty",
  Months: "Miesi\u0105ce",
  "Number of orders": "Liczba zam\xF3wie\u0144",
  "On all of the post purchase pages": "Na wszystkich stronach po zakupie",
  "On one of the post purchase pages": "Na jednej ze stron po zakupie",
  "On the checkout": "W kasie",
  "On the post purchase 1st page": "Na 1. stronie po zakupie",
  "On the post purchase 2nd page": "Na 2. stronie po zakupie",
  "On the thank you page": "Na stronie z podzi\u0119kowaniem",
  "Order note": "Notatka do zam\xF3wienia",
  "Order tags": "Tagi zam\xF3wienia",
  "Passed X time ago": "Min\u0119\u0142o X temu",
  "Payment method": "Metoda p\u0142atno\u015Bci",
  "please add cart or order value": "prosz\u0119 doda\u0107 warto\u015B\u0107 koszyka lub zam\xF3wienia",
  "please add customer email": "prosz\u0119 doda\u0107 e-mail klienta",
  "please add customer number of orders": "prosz\u0119 doda\u0107 liczb\u0119 zam\xF3wie\u0144 klienta",
  "please add discount code": "prosz\u0119 doda\u0107 kod rabatowy",
  "please add item cost": "prosz\u0119 doda\u0107 koszt pozycji",
  "please add number of orders": "Prosz\u0119 doda\u0107 liczb\u0119 zam\xF3wie\u0144",
  "please add order note": "prosz\u0119 doda\u0107 notatk\u0119 do zam\xF3wienia",
  "please add product price": "Prosz\u0119 doda\u0107 cen\u0119 produktu",
  "please add product sku": "prosz\u0119 doda\u0107 SKU produktu",
  "please add product title": "prosz\u0119 doda\u0107 tytu\u0142 produktu",
  "please add product variant name": "prosz\u0119 doda\u0107 nazw\u0119 wariantu produktu",
  "please add shipping value": "prosz\u0119 doda\u0107 warto\u015B\u0107 wysy\u0142ki",
  "please add time since last order": "Dodaj czas od ostatniego zam\xF3wienia",
  "please add total item count": "Prosz\u0119 doda\u0107 ca\u0142kowit\u0105 liczb\u0119 pozycji",
  "please add value": "prosz\u0119 doda\u0107 warto\u015B\u0107",
  "please select collections": "prosz\u0119 wybra\u0107 kolekcje",
  "please select customer birthday": "Wybierz urodziny klienta",
  "please select customer country": "prosz\u0119 wybra\u0107 kraj klienta",
  "please select customer language": "prosz\u0119 wybra\u0107 j\u0119zyk klienta",
  "please select customer segments": "prosz\u0119 wybra\u0107 segmenty klient\xF3w",
  "please select customer tag": "prosz\u0119 wybra\u0107 tag klienta",
  "please select customer tags": "Wybierz tagi klienta",
  "please select fulfillment statuses": "prosz\u0119 wybra\u0107 statusy realizacji",
  "please select offer": "prosz\u0119 wybra\u0107 ofert\u0119",
  "please select payment method": "Prosz\u0119 wybra\u0107 metod\u0119 p\u0142atno\u015Bci",
  "please select payment statuses": "Prosz\u0119 wybra\u0107 statusy p\u0142atno\u015Bci",
  "please select product type": "Prosz\u0119 wybra\u0107 typ produktu",
  "please select product vendor": "Prosz\u0119 wybra\u0107 sprzedawc\u0119 produktu",
  "please select products": "prosz\u0119 wybra\u0107 produkty",
  "please select sales channel": "prosz\u0119 wybra\u0107 kana\u0142 sprzeda\u017Cy",
  "please select shipping methods": "prosz\u0119 wybra\u0107 metody wysy\u0142ki",
  "please select tags": "prosz\u0119 wybra\u0107 tagi",
  "Previous page offer": "Oferta z poprzedniej strony",
  product: "produkt",
  "Product recommendations": "Rekomendacje produkt\xF3w",
  "Product type": "Typ produktu",
  "Product upsell": "Upsell produktu",
  products: "produkty",
  "Requires shipping": "Wymaga wysy\u0142ki",
  "Shipping method": "Metoda wysy\u0142ki",
  "Shipping value": "Warto\u015B\u0107 wysy\u0142ki",
  "Starts with": "Zaczyna si\u0119 od",
  Status: "Status",
  "The displayed product": "Wy\u015Bwietlany produkt",
  "The displayed product SKU": "SKU wy\u015Bwietlanego produktu",
  "The only product title in the cart": "Jedyny tytu\u0142 produktu w koszyku",
  "The only SKU in the cart": "Jedyne SKU w koszyku",
  "The SKU of all products in the cart": "SKU wszystkich produkt\xF3w w koszyku",
  "The SKU of at least one product in the cart": "SKU co najmniej jednego produktu w koszyku",
  "The title of all products in the cart": "Tytu\u0142 wszystkich produkt\xF3w w koszyku",
  "The title of at least one product in the cart": "Tytu\u0142 co najmniej jednego produktu w koszyku",
  "The title of the displayed product": "Tytu\u0142 wy\u015Bwietlanego produktu",
  "The variant of all products in the cart": "Wariant wszystkich produkt\xF3w w koszyku",
  "The variant of at least one product in the cart": "Wariant co najmniej jednego produktu w koszyku",
  "The variant of only product in the cart": "Wariant jedynego produktu w koszyku",
  "The variant of the displayed product": "Wariant wy\u015Bwietlanego produktu",
  "Total item count": "Ca\u0142kowita liczba pozycji",
  Weeks: "Tygodnie",
  Years: "Lata"
};

// src/lang/cs.json
var cs_default = {
  "An offer was accepted": "Nab\xEDdka byla p\u0159ijata",
  "An offer was declined": "Nab\xEDdka byla odm\xEDtnuta",
  and: "a",
  "Announcement bar": "Informa\u010Dn\xED li\u0161ta",
  "Are available at all the sales channels from the list": "Jsou k dispozici ve v\u0161ech prodejn\xEDch kan\xE1lech ze seznamu",
  "Are available at one of the sales channels from the list": "Jsou k dispozici v jednom z prodejn\xEDch kan\xE1l\u016F ze seznamu",
  "Are not available at all the sales channels from the list": "Nejsou k dispozici ve v\u0161ech prodejn\xEDch kan\xE1lech ze seznamu",
  "Are not available at one of the sales channels from the list": "Nejsou k dispozici v jednom z prodejn\xEDch kan\xE1l\u016F ze seznamu",
  "At least one product in the cart": "Alespo\u0148 jeden produkt v ko\u0161\xEDku",
  Banner: "Banner",
  Between: "Mezi",
  Bundle: "Bal\xED\u010Dek",
  "Cart/Order value": "Hodnota ko\u0161\xEDku/objedn\xE1vky",
  categories: "kategorie",
  category: "kategorie",
  collection: "kolekce",
  collections: "kolekce",
  Contains: "Obsahuje",
  "Customer accepted marketing": "Z\xE1kazn\xEDk p\u0159ijal marketing",
  "Customer birthday": "Narozeniny z\xE1kazn\xEDka",
  "Customer country": "Zem\u011B z\xE1kazn\xEDka",
  "customer doesn't have all the tags from the list": "z\xE1kazn\xEDk nem\xE1 v\u0161echny \u0161t\xEDtky ze seznamu",
  "customer doesn't have any of the tags from the list": "z\xE1kazn\xEDk nem\xE1 \u017E\xE1dn\xFD ze \u0161t\xEDtk\u016F ze seznamu",
  "Customer don't accepted marketing": "Z\xE1kazn\xEDk nep\u0159ijal marketing",
  "Customer email": "E-mail z\xE1kazn\xEDka",
  "customer has all the tags from the list": "z\xE1kazn\xEDk m\xE1 v\u0161echny \u0161t\xEDtky ze seznamu",
  "customer has at least one of the tags from the list ": "z\xE1kazn\xEDk m\xE1 alespo\u0148 jeden ze \u0161t\xEDtk\u016F ze seznamu ",
  "Customer number of orders": "Po\u010Det objedn\xE1vek z\xE1kazn\xEDka",
  "Customer segments": "Z\xE1kaznick\xE9 segmenty",
  "Customer tag": "\u0160t\xEDtek z\xE1kazn\xEDka",
  Days: "Dny",
  "Discount code": "Slevov\xFD k\xF3d",
  "Does not require shipping": "Nevy\u017Eaduje dopravu",
  "Doesn't contain": "Neobsahuje",
  "Doesn't end with": "Nekon\u010D\xED na",
  "Doesn't have all the tags from the list": "Nem\xE1 v\u0161echny \u0161t\xEDtky ze seznamu",
  "Doesn't have some of the tags from the list": "Nem\xE1 n\u011Bkter\xE9 ze \u0161t\xEDtk\u016F ze seznamu",
  "Doesn't start with": "Neza\u010D\xEDn\xE1 na",
  "Ends with": "Kon\u010D\xED na",
  "Equal to": "Rovn\xE1 se",
  Equals: "Rovn\xE1 se",
  "Every product in the cart": "Ka\u017Ed\xFD produkt v ko\u0161\xEDku",
  "Greater than": "V\u011Bt\u0161\xED ne\u017E",
  "Greater than or equals to": "V\u011Bt\u0161\xED ne\u017E nebo rovno",
  "Has all the tags from the list": "M\xE1 v\u0161echny \u0161t\xEDtky ze seznamu",
  "Has at least one of the tags from the list": "M\xE1 alespo\u0148 jeden ze \u0161t\xEDtk\u016F ze seznamu",
  Hours: "Hodiny",
  "in less than": "za m\xE9n\u011B ne\u017E",
  "Is (exact code)": "Je (p\u0159esn\xFD k\xF3d)",
  "Is (exact email)": "Je (p\u0159esn\xFD e-mail)",
  "Is (exact sku)": "Je (p\u0159esn\xE9 SKU)",
  "Is (exact title)": "Je (p\u0159esn\xFD n\xE1zev)",
  "Is (exact variant name)": "Je (p\u0159esn\xFD n\xE1zev varianty)",
  "Is after": "Je po",
  "Is available at all the sales channels from the list": "Je k dispozici ve v\u0161ech prodejn\xEDch kan\xE1lech ze seznamu",
  "Is available at all the sales channels in the list": "Je k dispozici ve v\u0161ech prodejn\xEDch kan\xE1lech v seznamu",
  "Is available at one of the sales channels from the list": "Je k dispozici v jednom z prodejn\xEDch kan\xE1l\u016F ze seznamu",
  "Is available at one of the sales channels in the list": "Je k dispozici v jednom z prodejn\xEDch kan\xE1l\u016F v seznamu",
  "Is before": "Je p\u0159ed",
  "Is between": "Je mezi",
  "Is from a vendor in the list": "Je od dodavatele ze seznamu",
  "Is from the list": "Je ze seznamu",
  "Is greater than": "Je v\u011Bt\u0161\xED ne\u017E",
  "Is greater than or equals to": "Je v\u011Bt\u0161\xED nebo rovno",
  "Is in a category from the list": "Je v kategorii ze seznamu",
  "Is in a collection from the list": "Je v kolekci ze seznamu",
  "Is less than": "Je men\u0161\xED ne\u017E",
  "Is less than or equals to": "Je men\u0161\xED nebo rovno",
  "Is not (exact code)": "Nen\xED (p\u0159esn\xFD k\xF3d)",
  "Is not (exact email)": "Nen\xED (p\u0159esn\xFD e-mail)",
  "Is not (exact sku)": "Nen\xED (p\u0159esn\xE9 SKU)",
  "Is not (exact title)": "Nen\xED (p\u0159esn\xFD n\xE1zev)",
  "Is not (exact variant name)": "Nen\xED (p\u0159esn\xFD n\xE1zev varianty)",
  "Is not available at all the sales channels from the list": "Nen\xED k dispozici ve v\u0161ech prodejn\xEDch kan\xE1lech ze seznamu",
  "Is not available at all the sales channels in the list": "Nen\xED k dispozici ve v\u0161ech prodejn\xEDch kan\xE1lech v seznamu",
  "Is not available at one of the sales channels from the list": "Nen\xED k dispozici v jednom z prodejn\xEDch kan\xE1l\u016F ze seznamu",
  "Is not available at one of the sales channels in the list": "Nen\xED k dispozici v \u017E\xE1dn\xE9m z prodejn\xEDch kan\xE1l\u016F v seznamu",
  "Is not between": "Nen\xED mezi",
  "Is not equal to": "Nerovn\xE1 se",
  "Is not from a vendor in the list": "Nen\xED od dodavatele ze seznamu",
  "Is not from the list": "Nen\xED ze seznamu",
  "Is not in a category from the list": "Nen\xED v kategorii ze seznamu",
  "Is not in a collection from the list": "Nen\xED v kolekci ze seznamu",
  "Is not of a type from the list": "Nen\xED typu ze seznamu",
  "Is not on": "Nen\xED",
  "Is not one of the countries from the list": "Nen\xED jednou ze zem\xED ze seznamu",
  "Is not one of the customer segments from the list": "Nen\xED jedn\xEDm ze z\xE1kaznick\xFDch segment\u016F ze seznamu",
  "Is not one of the fulfillment statuses in the list": "Nen\xED jedn\xEDm ze stav\u016F pln\u011Bn\xED v seznamu",
  "Is not one of the languages from the list": "Nen\xED jedn\xEDm z jazyk\u016F ze seznamu",
  "Is not one of the methods in the list": "Nen\xED jedna z metod v seznamu",
  "Is not one of the payment statuses in the list": "Nen\xED jedn\xEDm ze stav\u016F platby v seznamu",
  "Is not tagged with all the tags in the list": "Nen\xED ozna\u010Den v\u0161emi \u0161t\xEDtky v seznamu",
  "Is not tagged with any of the tags in the list": "Nen\xED ozna\u010Den \u017E\xE1dn\xFDm ze \u0161t\xEDtk\u016F v seznamu",
  "Is not tagged with at least one of the tags in the list": "Nen\xED ozna\u010Den alespo\u0148 jedn\xEDm ze \u0161t\xEDtk\u016F v seznamu",
  "Is of a type from the list": "Je typu ze seznamu",
  "Is on": "Je",
  "Is one of the countries from the list": "Je jednou ze zem\xED ze seznamu",
  "Is one of the customer segments from the list": "Je jedn\xEDm ze z\xE1kaznick\xFDch segment\u016F ze seznamu",
  "Is one of the fulfillment statuses in the list": "Je jedn\xEDm ze stav\u016F pln\u011Bn\xED v seznamu",
  "Is one of the languages from the list": "Je jedn\xEDm z jazyk\u016F ze seznamu",
  "Is one of the methods in the list": "Je jedna z metod v seznamu",
  "Is one of the payment statuses in the list": "Je jedn\xEDm ze stav\u016F platby v seznamu",
  "Is tagged with all the tags in the list": "Je ozna\u010Den v\u0161emi \u0161t\xEDtky v seznamu",
  "Is tagged with at least one of the tags in the list": "Je ozna\u010Den alespo\u0148 jedn\xEDm ze \u0161t\xEDtk\u016F v seznamu",
  "Item cost": "N\xE1klady na polo\u017Eku",
  Language: "Jazyk",
  "Less than": "Men\u0161\xED ne\u017E",
  "Less than or equals to": "Men\u0161\xED ne\u017E nebo rovno",
  "Marketing consent": "Souhlas s marketingem",
  Minutes: "Minuty",
  Months: "M\u011Bs\xEDce",
  "Number of orders": "Po\u010Det objedn\xE1vek",
  "On all of the post purchase pages": "Na v\u0161ech str\xE1nk\xE1ch po n\xE1kupu",
  "On one of the post purchase pages": "Na jedn\xE9 ze str\xE1nek po n\xE1kupu",
  "On the checkout": "V pokladn\u011B",
  "On the post purchase 1st page": "Na 1. str\xE1nce po n\xE1kupu",
  "On the post purchase 2nd page": "Na 2. str\xE1nce po n\xE1kupu",
  "On the thank you page": "Na d\u011Bkovac\xED str\xE1nce",
  "Order note": "Pozn\xE1mka k objedn\xE1vce",
  "Order tags": "\u0160t\xEDtky objedn\xE1vky",
  "Passed X time ago": "Uplynulo p\u0159ed X",
  "Payment method": "Zp\u016Fsob platby",
  "please add cart or order value": "p\u0159idejte pros\xEDm hodnotu ko\u0161\xEDku nebo objedn\xE1vky",
  "please add customer email": "p\u0159idejte pros\xEDm e-mail z\xE1kazn\xEDka",
  "please add customer number of orders": "p\u0159idejte pros\xEDm po\u010Det objedn\xE1vek z\xE1kazn\xEDka",
  "please add discount code": "p\u0159idejte pros\xEDm slevov\xFD k\xF3d",
  "please add item cost": "p\u0159idejte pros\xEDm n\xE1klady na polo\u017Eku",
  "please add number of orders": "P\u0159idejte pros\xEDm po\u010Det objedn\xE1vek",
  "please add order note": "p\u0159idejte pros\xEDm pozn\xE1mku k objedn\xE1vce",
  "please add product price": "P\u0159idejte pros\xEDm cenu produktu",
  "please add product sku": "p\u0159idejte pros\xEDm SKU produktu",
  "please add product title": "p\u0159idejte pros\xEDm n\xE1zev produktu",
  "please add product variant name": "p\u0159idejte pros\xEDm n\xE1zev varianty produktu",
  "please add shipping value": "p\u0159idejte pros\xEDm hodnotu dopravy",
  "please add time since last order": "Zadejte pros\xEDm \u010Das od posledn\xED objedn\xE1vky",
  "please add total item count": "P\u0159idejte pros\xEDm celkov\xFD po\u010Det polo\u017Eek",
  "please add value": "p\u0159idejte pros\xEDm hodnotu",
  "please select collections": "vyberte pros\xEDm kolekce",
  "please select customer birthday": "Vyberte pros\xEDm narozeniny z\xE1kazn\xEDka",
  "please select customer country": "vyberte pros\xEDm zemi z\xE1kazn\xEDka",
  "please select customer language": "vyberte pros\xEDm jazyk z\xE1kazn\xEDka",
  "please select customer segments": "vyberte pros\xEDm z\xE1kaznick\xE9 segmenty",
  "please select customer tag": "vyberte pros\xEDm \u0161t\xEDtek z\xE1kazn\xEDka",
  "please select customer tags": "Vyberte pros\xEDm \u0161t\xEDtky z\xE1kazn\xEDk\u016F",
  "please select fulfillment statuses": "vyberte pros\xEDm stavy pln\u011Bn\xED",
  "please select offer": "vyberte pros\xEDm nab\xEDdku",
  "please select payment method": "Vyberte pros\xEDm zp\u016Fsob platby",
  "please select payment statuses": "Vyberte pros\xEDm stavy platby",
  "please select product type": "Vyberte pros\xEDm typ produktu",
  "please select product vendor": "Vyberte pros\xEDm dodavatele produktu",
  "please select products": "vyberte pros\xEDm produkty",
  "please select sales channel": "vyberte pros\xEDm prodejn\xED kan\xE1l",
  "please select shipping methods": "vyberte pros\xEDm zp\u016Fsoby dopravy",
  "please select tags": "vyberte pros\xEDm \u0161t\xEDtky",
  "Previous page offer": "Nab\xEDdka na p\u0159edchoz\xED str\xE1nce",
  product: "produkt",
  "Product recommendations": "Doporu\u010Den\xED produkt\u016F",
  "Product type": "Typ produktu",
  "Product upsell": "Upsell produktu",
  products: "produkty",
  "Requires shipping": "Vy\u017Eaduje dopravu",
  "Shipping method": "Zp\u016Fsob dopravy",
  "Shipping value": "Hodnota dopravy",
  "Starts with": "Za\u010D\xEDn\xE1 na",
  Status: "Stav",
  "The displayed product": "Zobrazen\xFD produkt",
  "The displayed product SKU": "SKU zobrazen\xE9ho produktu",
  "The only product title in the cart": "Jedin\xFD n\xE1zev produktu v ko\u0161\xEDku",
  "The only SKU in the cart": "Jedin\xE9 SKU v ko\u0161\xEDku",
  "The SKU of all products in the cart": "SKU v\u0161ech produkt\u016F v ko\u0161\xEDku",
  "The SKU of at least one product in the cart": "SKU alespo\u0148 jednoho produktu v ko\u0161\xEDku",
  "The title of all products in the cart": "N\xE1zev v\u0161ech produkt\u016F v ko\u0161\xEDku",
  "The title of at least one product in the cart": "N\xE1zev alespo\u0148 jednoho produktu v ko\u0161\xEDku",
  "The title of the displayed product": "N\xE1zev zobrazen\xE9ho produktu",
  "The variant of all products in the cart": "Varianta v\u0161ech produkt\u016F v ko\u0161\xEDku",
  "The variant of at least one product in the cart": "Varianta alespo\u0148 jednoho produktu v ko\u0161\xEDku",
  "The variant of only product in the cart": "Varianta jedin\xE9ho produktu v ko\u0161\xEDku",
  "The variant of the displayed product": "Varianta zobrazen\xE9ho produktu",
  "Total item count": "Celkov\xFD po\u010Det polo\u017Eek",
  Weeks: "T\xFDdny",
  Years: "Roky"
};

// src/lang/da.json
var da_default = {
  "An offer was accepted": "Et tilbud blev accepteret",
  "An offer was declined": "Et tilbud blev afvist",
  and: "og",
  "Announcement bar": "Annonceringsbj\xE6lke",
  "Are available at all the sales channels from the list": "Er tilg\xE6ngelige p\xE5 alle salgskanalerne fra listen",
  "Are available at one of the sales channels from the list": "Er tilg\xE6ngelige p\xE5 en af salgskanalerne fra listen",
  "Are not available at all the sales channels from the list": "Er ikke tilg\xE6ngelige p\xE5 alle salgskanalerne fra listen",
  "Are not available at one of the sales channels from the list": "Er ikke tilg\xE6ngelige p\xE5 en af salgskanalerne fra listen",
  "At least one product in the cart": "Mindst \xE9t produkt i kurven",
  Banner: "Banner",
  Between: "Mellem",
  Bundle: "Bundle",
  "Cart/Order value": "Kurv-/ordrev\xE6rdi",
  categories: "kategorier",
  category: "kategori",
  collection: "kollektion",
  collections: "kollektioner",
  Contains: "Indeholder",
  "Customer accepted marketing": "Kunden accepterede markedsf\xF8ring",
  "Customer birthday": "Kundens f\xF8dselsdag",
  "Customer country": "Kundens land",
  "customer doesn't have all the tags from the list": "kunden har ikke alle tagsene fra listen",
  "customer doesn't have any of the tags from the list": "kunden har ingen af tagsene fra listen",
  "Customer don't accepted marketing": "Kunden accepterede ikke markedsf\xF8ring",
  "Customer email": "Kundens e-mail",
  "customer has all the tags from the list": "kunden har alle tagsene fra listen",
  "customer has at least one of the tags from the list ": "kunden har mindst \xE9t af tagsene fra listen ",
  "Customer number of orders": "Kundens antal ordrer",
  "Customer segments": "Kundesegmenter",
  "Customer tag": "Kundetag",
  Days: "Dage",
  "Discount code": "Rabatkode",
  "Does not require shipping": "Kr\xE6ver ikke forsendelse",
  "Doesn't contain": "Indeholder ikke",
  "Doesn't end with": "Slutter ikke med",
  "Doesn't have all the tags from the list": "Har ikke alle tagsene fra listen",
  "Doesn't have some of the tags from the list": "Har ikke nogle af tagsene fra listen",
  "Doesn't start with": "Starter ikke med",
  "Ends with": "Slutter med",
  "Equal to": "Er lig med",
  Equals: "Er lig med",
  "Every product in the cart": "Hvert produkt i kurven",
  "Greater than": "St\xF8rre end",
  "Greater than or equals to": "St\xF8rre end eller lig med",
  "Has all the tags from the list": "Har alle tagsene fra listen",
  "Has at least one of the tags from the list": "Har mindst \xE9t af tagsene fra listen",
  Hours: "Timer",
  "in less than": "om mindre end",
  "Is (exact code)": "Er (pr\xE6cis kode)",
  "Is (exact email)": "Er (pr\xE6cis e-mail)",
  "Is (exact sku)": "Er (pr\xE6cis sku)",
  "Is (exact title)": "Er (pr\xE6cis titel)",
  "Is (exact variant name)": "Er (pr\xE6cist variantnavn)",
  "Is after": "Er efter",
  "Is available at all the sales channels from the list": "Er tilg\xE6ngelig p\xE5 alle salgskanalerne fra listen",
  "Is available at all the sales channels in the list": "Er tilg\xE6ngelig p\xE5 alle salgskanalerne p\xE5 listen",
  "Is available at one of the sales channels from the list": "Er tilg\xE6ngelig p\xE5 en af salgskanalerne fra listen",
  "Is available at one of the sales channels in the list": "Er tilg\xE6ngelig p\xE5 en af salgskanalerne p\xE5 listen",
  "Is before": "Er f\xF8r",
  "Is between": "Er mellem",
  "Is from a vendor in the list": "Er fra en leverand\xF8r p\xE5 listen",
  "Is from the list": "Er fra listen",
  "Is greater than": "Er st\xF8rre end",
  "Is greater than or equals to": "Er st\xF8rre end eller lig med",
  "Is in a category from the list": "Er i en kategori fra listen",
  "Is in a collection from the list": "Er i en kollektion fra listen",
  "Is less than": "Er mindre end",
  "Is less than or equals to": "Er mindre end eller lig med",
  "Is not (exact code)": "Er ikke (pr\xE6cis kode)",
  "Is not (exact email)": "Er ikke (pr\xE6cis e-mail)",
  "Is not (exact sku)": "Er ikke (pr\xE6cis sku)",
  "Is not (exact title)": "Er ikke (pr\xE6cis titel)",
  "Is not (exact variant name)": "Er ikke (pr\xE6cist variantnavn)",
  "Is not available at all the sales channels from the list": "Er ikke tilg\xE6ngelig p\xE5 alle salgskanalerne fra listen",
  "Is not available at all the sales channels in the list": "Er ikke tilg\xE6ngelig p\xE5 alle salgskanalerne p\xE5 listen",
  "Is not available at one of the sales channels from the list": "Er ikke tilg\xE6ngelig p\xE5 en af salgskanalerne fra listen",
  "Is not available at one of the sales channels in the list": "Er ikke tilg\xE6ngelig p\xE5 nogen af salgskanalerne p\xE5 listen",
  "Is not between": "Er ikke mellem",
  "Is not equal to": "Er ikke lig med",
  "Is not from a vendor in the list": "Er ikke fra en leverand\xF8r p\xE5 listen",
  "Is not from the list": "Er ikke fra listen",
  "Is not in a category from the list": "Er ikke i en kategori fra listen",
  "Is not in a collection from the list": "Er ikke i en kollektion fra listen",
  "Is not of a type from the list": "Er ikke af en type fra listen",
  "Is not on": "Er ikke den",
  "Is not one of the countries from the list": "Er ikke et af landene fra listen",
  "Is not one of the customer segments from the list": "Er ikke et af kundesegmenterne fra listen",
  "Is not one of the fulfillment statuses in the list": "Er ikke en af opfyldelsesstatusene p\xE5 listen",
  "Is not one of the languages from the list": "Er ikke et af sprogene fra listen",
  "Is not one of the methods in the list": "Er ikke en af metoderne p\xE5 listen",
  "Is not one of the payment statuses in the list": "Er ikke en af betalingsstatusene p\xE5 listen",
  "Is not tagged with all the tags in the list": "Er ikke tagget med alle tags p\xE5 listen",
  "Is not tagged with any of the tags in the list": "Er ikke m\xE6rket med nogen af tagsene p\xE5 listen",
  "Is not tagged with at least one of the tags in the list": "Er ikke tagget med mindst et af tagsene p\xE5 listen",
  "Is of a type from the list": "Er af en type fra listen",
  "Is on": "Er den",
  "Is one of the countries from the list": "Er et af landene fra listen",
  "Is one of the customer segments from the list": "Er et af kundesegmenterne fra listen",
  "Is one of the fulfillment statuses in the list": "Er en af opfyldelsesstatusene p\xE5 listen",
  "Is one of the languages from the list": "Er et af sprogene fra listen",
  "Is one of the methods in the list": "Er en af metoderne p\xE5 listen",
  "Is one of the payment statuses in the list": "Er en af betalingsstatusene p\xE5 listen",
  "Is tagged with all the tags in the list": "Er m\xE6rket med alle tagsene p\xE5 listen",
  "Is tagged with at least one of the tags in the list": "Er m\xE6rket med mindst et af tagsene p\xE5 listen",
  "Item cost": "Vareomkostninger",
  Language: "Sprog",
  "Less than": "Mindre end",
  "Less than or equals to": "Mindre end eller lig med",
  "Marketing consent": "Markedsf\xF8ringssamtykke",
  Minutes: "Minutter",
  Months: "M\xE5neder",
  "Number of orders": "Antal ordrer",
  "On all of the post purchase pages": "P\xE5 alle siderne efter k\xF8b",
  "On one of the post purchase pages": "P\xE5 en af siderne efter k\xF8b",
  "On the checkout": "Ved checkout",
  "On the post purchase 1st page": "P\xE5 1. side efter k\xF8b",
  "On the post purchase 2nd page": "P\xE5 2. side efter k\xF8b",
  "On the thank you page": "P\xE5 takkesiden",
  "Order note": "Ordrenote",
  "Order tags": "Ordretags",
  "Passed X time ago": "Passerede for X siden",
  "Payment method": "Betalingsmetode",
  "please add cart or order value": "tilf\xF8j venligst kurv- eller ordrev\xE6rdi",
  "please add customer email": "tilf\xF8j venligst kundens e-mail",
  "please add customer number of orders": "tilf\xF8j venligst kundens antal ordrer",
  "please add discount code": "tilf\xF8j venligst rabatkode",
  "please add item cost": "tilf\xF8j venligst vareomkostninger",
  "please add number of orders": "Tilf\xF8j venligst antal ordrer",
  "please add order note": "tilf\xF8j venligst ordrenote",
  "please add product price": "Tilf\xF8j venligst produktpris",
  "please add product sku": "tilf\xF8j venligst produkt-sku",
  "please add product title": "tilf\xF8j venligst produkttitel",
  "please add product variant name": "tilf\xF8j venligst produktvariantnavn",
  "please add shipping value": "tilf\xF8j venligst forsendelsesv\xE6rdi",
  "please add time since last order": "Tilf\xF8j venligst tid siden sidste ordre",
  "please add total item count": "Tilf\xF8j venligst samlet antal varer",
  "please add value": "tilf\xF8j venligst v\xE6rdi",
  "please select collections": "v\xE6lg venligst kollektioner",
  "please select customer birthday": "V\xE6lg venligst kundens f\xF8dselsdag",
  "please select customer country": "v\xE6lg venligst kundens land",
  "please select customer language": "v\xE6lg venligst kundens sprog",
  "please select customer segments": "v\xE6lg venligst kundesegmenter",
  "please select customer tag": "v\xE6lg venligst kundens tag",
  "please select customer tags": "V\xE6lg venligst kundetags",
  "please select fulfillment statuses": "v\xE6lg venligst opfyldelsesstatus",
  "please select offer": "v\xE6lg venligst tilbud",
  "please select payment method": "V\xE6lg venligst betalingsmetode",
  "please select payment statuses": "V\xE6lg venligst betalingsstatus",
  "please select product type": "V\xE6lg venligst produkttype",
  "please select product vendor": "V\xE6lg venligst produktleverand\xF8r",
  "please select products": "v\xE6lg venligst produkter",
  "please select sales channel": "v\xE6lg venligst salgskanal",
  "please select shipping methods": "v\xE6lg venligst forsendelsesmetoder",
  "please select tags": "v\xE6lg venligst tags",
  "Previous page offer": "Tilbud p\xE5 forrige side",
  product: "produkt",
  "Product recommendations": "Produktanbefalinger",
  "Product type": "Produkttype",
  "Product upsell": "Produktmersalg",
  products: "produkter",
  "Requires shipping": "Kr\xE6ver forsendelse",
  "Shipping method": "Forsendelsesmetode",
  "Shipping value": "Forsendelsesv\xE6rdi",
  "Starts with": "Starter med",
  Status: "Status",
  "The displayed product": "Det viste produkt",
  "The displayed product SKU": "SKU for det viste produkt",
  "The only product title in the cart": "Den eneste produkttitel i kurven",
  "The only SKU in the cart": "Den eneste SKU i kurven",
  "The SKU of all products in the cart": "SKU'en for alle produkter i kurven",
  "The SKU of at least one product in the cart": "SKU'en for mindst \xE9t produkt i kurven",
  "The title of all products in the cart": "Titlen p\xE5 alle produkter i kurven",
  "The title of at least one product in the cart": "Titlen p\xE5 mindst \xE9t produkt i kurven",
  "The title of the displayed product": "Titlen p\xE5 det viste produkt",
  "The variant of all products in the cart": "Varianten af alle produkter i kurven",
  "The variant of at least one product in the cart": "Varianten af mindst \xE9t produkt i kurven",
  "The variant of only product in the cart": "Varianten af det eneste produkt i kurven",
  "The variant of the displayed product": "Varianten af det viste produkt",
  "Total item count": "Samlet antal varer",
  Weeks: "Uger",
  Years: "\xC5r"
};

// src/lang/id.json
var id_default = {
  "An offer was accepted": "Sebuah penawaran diterima",
  "An offer was declined": "Sebuah penawaran ditolak",
  and: "dan",
  "Announcement bar": "Bilah pengumuman",
  "Are available at all the sales channels from the list": "Tersedia di semua saluran penjualan dari daftar",
  "Are available at one of the sales channels from the list": "Tersedia di salah satu saluran penjualan dari daftar",
  "Are not available at all the sales channels from the list": "Tidak tersedia di semua saluran penjualan dari daftar",
  "Are not available at one of the sales channels from the list": "Tidak tersedia di salah satu saluran penjualan dari daftar",
  "At least one product in the cart": "Setidaknya satu produk di keranjang",
  Banner: "Banner",
  Between: "Antara",
  Bundle: "Bundel",
  "Cart/Order value": "Nilai Keranjang/Pesanan",
  categories: "kategori",
  category: "kategori",
  collection: "koleksi",
  collections: "koleksi",
  Contains: "Mengandung",
  "Customer accepted marketing": "Pelanggan menerima pemasaran",
  "Customer birthday": "Ulang tahun pelanggan",
  "Customer country": "Negara Pelanggan",
  "customer doesn't have all the tags from the list": "pelanggan tidak memiliki semua tag dari daftar",
  "customer doesn't have any of the tags from the list": "pelanggan tidak memiliki tag apa pun dari daftar",
  "Customer don't accepted marketing": "Pelanggan tidak menerima pemasaran",
  "Customer email": "Email Pelanggan",
  "customer has all the tags from the list": "pelanggan memiliki semua tag dari daftar",
  "customer has at least one of the tags from the list ": "pelanggan memiliki setidaknya satu tag dari daftar ",
  "Customer number of orders": "Jumlah pesanan pelanggan",
  "Customer segments": "Segmen pelanggan",
  "Customer tag": "Tag pelanggan",
  Days: "Hari",
  "Discount code": "Kode diskon",
  "Does not require shipping": "Tidak memerlukan pengiriman",
  "Doesn't contain": "Tidak mengandung",
  "Doesn't end with": "Tidak berakhir dengan",
  "Doesn't have all the tags from the list": "Tidak memiliki semua tag dari daftar",
  "Doesn't have some of the tags from the list": "Tidak memiliki beberapa tag dari daftar",
  "Doesn't start with": "Tidak dimulai dengan",
  "Ends with": "Berakhir dengan",
  "Equal to": "Sama dengan",
  Equals: "Sama dengan",
  "Every product in the cart": "Setiap produk di keranjang",
  "Greater than": "Lebih besar dari",
  "Greater than or equals to": "Lebih besar dari atau sama dengan",
  "Has all the tags from the list": "Memiliki semua tag dari daftar",
  "Has at least one of the tags from the list": "Memiliki setidaknya satu tag dari daftar",
  Hours: "Jam",
  "in less than": "dalam kurang dari",
  "Is (exact code)": "Adalah (kode persis)",
  "Is (exact email)": "Adalah (email persis)",
  "Is (exact sku)": "Adalah (sku persis)",
  "Is (exact title)": "Adalah (judul persis)",
  "Is (exact variant name)": "Adalah (nama varian persis)",
  "Is after": "Sesudah",
  "Is available at all the sales channels from the list": "Tersedia di semua saluran penjualan dari daftar",
  "Is available at all the sales channels in the list": "Tersedia di semua saluran penjualan dalam daftar",
  "Is available at one of the sales channels from the list": "Tersedia di salah satu saluran penjualan dari daftar",
  "Is available at one of the sales channels in the list": "Tersedia di salah satu saluran penjualan dalam daftar",
  "Is before": "Sebelum",
  "Is between": "Di antara",
  "Is from a vendor in the list": "Berasal dari vendor dalam daftar",
  "Is from the list": "Berasal dari daftar",
  "Is greater than": "Lebih besar dari",
  "Is greater than or equals to": "Lebih besar dari atau sama dengan",
  "Is in a category from the list": "Berada dalam kategori dari daftar",
  "Is in a collection from the list": "Berada dalam koleksi dari daftar",
  "Is less than": "Lebih kecil dari",
  "Is less than or equals to": "Lebih kecil dari atau sama dengan",
  "Is not (exact code)": "Bukan (kode persis)",
  "Is not (exact email)": "Bukan (email persis)",
  "Is not (exact sku)": "Bukan (sku persis)",
  "Is not (exact title)": "Bukan (judul persis)",
  "Is not (exact variant name)": "Bukan (nama varian persis)",
  "Is not available at all the sales channels from the list": "Tidak tersedia di semua saluran penjualan dari daftar",
  "Is not available at all the sales channels in the list": "Tidak tersedia di semua saluran penjualan dalam daftar",
  "Is not available at one of the sales channels from the list": "Tidak tersedia di salah satu saluran penjualan dari daftar",
  "Is not available at one of the sales channels in the list": "Tidak tersedia di salah satu saluran penjualan dalam daftar",
  "Is not between": "Tidak di antara",
  "Is not equal to": "Tidak sama dengan",
  "Is not from a vendor in the list": "Tidak berasal dari vendor dalam daftar",
  "Is not from the list": "Tidak berasal dari daftar",
  "Is not in a category from the list": "Tidak berada dalam kategori dari daftar",
  "Is not in a collection from the list": "Tidak berada dalam koleksi dari daftar",
  "Is not of a type from the list": "Bukan tipe dari daftar",
  "Is not on": "Bukan pada",
  "Is not one of the countries from the list": "Bukan salah satu negara dari daftar",
  "Is not one of the customer segments from the list": "Bukan salah satu segmen pelanggan dari daftar",
  "Is not one of the fulfillment statuses in the list": "Bukan salah satu status pemenuhan dalam daftar",
  "Is not one of the languages from the list": "Bukan salah satu bahasa dari daftar",
  "Is not one of the methods in the list": "Bukan salah satu metode dalam daftar",
  "Is not one of the payment statuses in the list": "Bukan salah satu status pembayaran dalam daftar",
  "Is not tagged with all the tags in the list": "Tidak ditandai dengan semua tag dalam daftar",
  "Is not tagged with any of the tags in the list": "Tidak ditandai dengan tag apa pun dalam daftar",
  "Is not tagged with at least one of the tags in the list": "Tidak ditandai dengan setidaknya satu tag dalam daftar",
  "Is of a type from the list": "Adalah tipe dari daftar",
  "Is on": "Pada",
  "Is one of the countries from the list": "Adalah salah satu negara dari daftar",
  "Is one of the customer segments from the list": "Adalah salah satu segmen pelanggan dari daftar",
  "Is one of the fulfillment statuses in the list": "Adalah salah satu status pemenuhan dalam daftar",
  "Is one of the languages from the list": "Adalah salah satu bahasa dari daftar",
  "Is one of the methods in the list": "Adalah salah satu metode dalam daftar",
  "Is one of the payment statuses in the list": "Adalah salah satu status pembayaran dalam daftar",
  "Is tagged with all the tags in the list": "Ditandai dengan semua tag dalam daftar",
  "Is tagged with at least one of the tags in the list": "Ditandai dengan setidaknya satu tag dalam daftar",
  "Item cost": "Biaya item",
  Language: "Bahasa",
  "Less than": "Lebih kecil dari",
  "Less than or equals to": "Lebih kecil dari atau sama dengan",
  "Marketing consent": "Izin pemasaran",
  Minutes: "Menit",
  Months: "Bulan",
  "Number of orders": "Jumlah pesanan",
  "On all of the post purchase pages": "Di semua halaman pasca-pembelian",
  "On one of the post purchase pages": "Di salah satu halaman pasca-pembelian",
  "On the checkout": "Saat checkout",
  "On the post purchase 1st page": "Di halaman pertama pasca-pembelian",
  "On the post purchase 2nd page": "Di halaman kedua pasca-pembelian",
  "On the thank you page": "Di halaman terima kasih",
  "Order note": "Catatan pesanan",
  "Order tags": "Tag pesanan",
  "Passed X time ago": "Berlalu X yang lalu",
  "Payment method": "Metode pembayaran",
  "please add cart or order value": "silakan tambahkan nilai keranjang atau pesanan",
  "please add customer email": "silakan tambahkan email pelanggan",
  "please add customer number of orders": "silakan tambahkan jumlah pesanan pelanggan",
  "please add discount code": "silakan tambahkan kode diskon",
  "please add item cost": "silakan tambahkan biaya item",
  "please add number of orders": "Harap tambahkan jumlah pesanan",
  "please add order note": "silakan tambahkan catatan pesanan",
  "please add product price": "Harap tambahkan harga produk",
  "please add product sku": "silakan tambahkan sku produk",
  "please add product title": "silakan tambahkan judul produk",
  "please add product variant name": "silakan tambahkan nama varian produk",
  "please add shipping value": "silakan tambahkan nilai pengiriman",
  "please add time since last order": "Silakan tambahkan waktu sejak pesanan terakhir",
  "please add total item count": "Harap tambahkan jumlah total item",
  "please add value": "silakan tambahkan nilai",
  "please select collections": "silakan pilih koleksi",
  "please select customer birthday": "Silakan pilih ulang tahun pelanggan",
  "please select customer country": "silakan pilih negara pelanggan",
  "please select customer language": "silakan pilih bahasa pelanggan",
  "please select customer segments": "silakan pilih segmen pelanggan",
  "please select customer tag": "silakan pilih tag pelanggan",
  "please select customer tags": "Silakan pilih tag pelanggan",
  "please select fulfillment statuses": "silakan pilih status pemenuhan",
  "please select offer": "silakan pilih penawaran",
  "please select payment method": "Harap pilih metode pembayaran",
  "please select payment statuses": "Harap pilih status pembayaran",
  "please select product type": "Harap pilih tipe produk",
  "please select product vendor": "Harap pilih vendor produk",
  "please select products": "silakan pilih produk",
  "please select sales channel": "silakan pilih saluran penjualan",
  "please select shipping methods": "silakan pilih metode pengiriman",
  "please select tags": "silakan pilih tag",
  "Previous page offer": "Penawaran halaman sebelumnya",
  product: "produk",
  "Product recommendations": "Rekomendasi produk",
  "Product type": "Tipe produk",
  "Product upsell": "Product upsell",
  products: "produk",
  "Requires shipping": "Memerlukan pengiriman",
  "Shipping method": "Metode pengiriman",
  "Shipping value": "Nilai pengiriman",
  "Starts with": "Dimulai dengan",
  Status: "Status",
  "The displayed product": "Produk yang ditampilkan",
  "The displayed product SKU": "SKU produk yang ditampilkan",
  "The only product title in the cart": "Satu-satunya judul produk di keranjang",
  "The only SKU in the cart": "Satu-satunya SKU di keranjang",
  "The SKU of all products in the cart": "SKU semua produk di keranjang",
  "The SKU of at least one product in the cart": "SKU setidaknya satu produk di keranjang",
  "The title of all products in the cart": "Judul semua produk di keranjang",
  "The title of at least one product in the cart": "Judul setidaknya satu produk di keranjang",
  "The title of the displayed product": "Judul produk yang ditampilkan",
  "The variant of all products in the cart": "Varian dari semua produk di keranjang",
  "The variant of at least one product in the cart": "Varian dari setidaknya satu produk di keranjang",
  "The variant of only product in the cart": "Varian dari satu-satunya produk di keranjang",
  "The variant of the displayed product": "Varian produk yang ditampilkan",
  "Total item count": "Jumlah total item",
  Weeks: "Minggu",
  Years: "Tahun"
};

// src/lang/lt.json
var lt_default = {
  "An offer was accepted": "Pasi\u016Blymas buvo priimtas",
  "An offer was declined": "Pasi\u016Blymas buvo atmestas",
  and: "ir",
  "Announcement bar": "Skelbim\u0173 juosta",
  "Are available at all the sales channels from the list": "Pasiekiami visuose pardavimo kanaluose i\u0161 s\u0105ra\u0161o",
  "Are available at one of the sales channels from the list": "Pasiekiami bent viename pardavimo kanale i\u0161 s\u0105ra\u0161o",
  "Are not available at all the sales channels from the list": "Nepasiekiami visuose pardavimo kanaluose i\u0161 s\u0105ra\u0161o",
  "Are not available at one of the sales channels from the list": "Nepasiekiami bent viename pardavimo kanale i\u0161 s\u0105ra\u0161o",
  "At least one product in the cart": "Bent vienas produktas krep\u0161elyje",
  Banner: "Reklamin\u0117 juosta",
  Between: "Tarp",
  Bundle: "Rinkinys",
  "Cart/Order value": "Krep\u0161elio/U\u017Esakymo vert\u0117",
  categories: "kategorijos",
  category: "kategorija",
  collection: "kolekcija",
  collections: "kolekcijos",
  Contains: "Turi savyje",
  "Customer accepted marketing": "Klientas sutiko su rinkodara",
  "Customer birthday": "Kliento gimtadienis",
  "Customer country": "Kliento \u0161alis",
  "customer doesn't have all the tags from the list": "klientas neturi vis\u0173 \u017Eym\u0173 i\u0161 s\u0105ra\u0161o",
  "customer doesn't have any of the tags from the list": "klientas neturi n\u0117 vienos \u017Eymos i\u0161 s\u0105ra\u0161o",
  "Customer don't accepted marketing": "Klientas nesutiko su rinkodara",
  "Customer email": "Kliento el. pa\u0161tas",
  "customer has all the tags from the list": "klientas turi visas \u017Eymas i\u0161 s\u0105ra\u0161o",
  "customer has at least one of the tags from the list ": "klientas turi bent vien\u0105 \u017Eym\u0105 i\u0161 s\u0105ra\u0161o ",
  "Customer number of orders": "Kliento u\u017Esakym\u0173 skai\u010Dius",
  "Customer segments": "Klient\u0173 segmentai",
  "Customer tag": "Kliento \u017Eyma",
  Days: "Dienos",
  "Discount code": "Nuolaidos kodas",
  "Does not require shipping": "Nereikalingas pristatymas",
  "Doesn't contain": "Neturi savyje",
  "Doesn't end with": "Nesibaigia su",
  "Doesn't have all the tags from the list": "Neturi vis\u0173 \u017Eym\u0173 i\u0161 s\u0105ra\u0161o",
  "Doesn't have some of the tags from the list": "Neturi kai kuri\u0173 \u017Eym\u0173 i\u0161 s\u0105ra\u0161o",
  "Doesn't start with": "Neprasideda su",
  "Ends with": "Baigiasi su",
  "Equal to": "Lygu",
  Equals: "Lygu",
  "Every product in the cart": "Kiekvienas produktas krep\u0161elyje",
  "Greater than": "Daugiau nei",
  "Greater than or equals to": "Daugiau arba lygu",
  "Has all the tags from the list": "Turi visas \u017Eymas i\u0161 s\u0105ra\u0161o",
  "Has at least one of the tags from the list": "Turi bent vien\u0105 \u017Eym\u0105 i\u0161 s\u0105ra\u0161o",
  Hours: "Valandos",
  "in less than": "per ma\u017Eiau nei",
  "Is (exact code)": "Yra (tiksus kodas)",
  "Is (exact email)": "Yra (tiksus el. pa\u0161tas)",
  "Is (exact sku)": "Yra (tiksus SKU)",
  "Is (exact title)": "Yra (tiksus pavadinimas)",
  "Is (exact variant name)": "Yra (tiksus varianto pavadinimas)",
  "Is after": "Yra po",
  "Is available at all the sales channels from the list": "Pasiekiamas visuose pardavimo kanaluose i\u0161 s\u0105ra\u0161o",
  "Is available at all the sales channels in the list": "Yra visuose pardavimo kanaluose s\u0105ra\u0161e",
  "Is available at one of the sales channels from the list": "Pasiekiamas bent viename pardavimo kanale i\u0161 s\u0105ra\u0161o",
  "Is available at one of the sales channels in the list": "Yra viename i\u0161 pardavimo kanal\u0173 s\u0105ra\u0161e",
  "Is before": "Yra prie\u0161",
  "Is between": "Yra tarp",
  "Is from a vendor in the list": "Yra i\u0161 pardav\u0117jo s\u0105ra\u0161e",
  "Is from the list": "Yra i\u0161 s\u0105ra\u0161o",
  "Is greater than": "Yra daugiau nei",
  "Is greater than or equals to": "Yra daugiau nei arba lygu",
  "Is in a category from the list": "Yra kategorijoje i\u0161 s\u0105ra\u0161o",
  "Is in a collection from the list": "Yra kolekcijoje i\u0161 s\u0105ra\u0161o",
  "Is less than": "Yra ma\u017Eiau nei",
  "Is less than or equals to": "Yra ma\u017Eiau nei arba lygu",
  "Is not (exact code)": "N\u0117ra (tiksus kodas)",
  "Is not (exact email)": "N\u0117ra (tiksus el. pa\u0161tas)",
  "Is not (exact sku)": "N\u0117ra (tiksus SKU)",
  "Is not (exact title)": "N\u0117ra (tiksus pavadinimas)",
  "Is not (exact variant name)": "N\u0117ra (tiksus varianto pavadinimas)",
  "Is not available at all the sales channels from the list": "Nepasiekiamas visuose pardavimo kanaluose i\u0161 s\u0105ra\u0161o",
  "Is not available at all the sales channels in the list": "N\u0117ra visuose pardavimo kanaluose s\u0105ra\u0161e",
  "Is not available at one of the sales channels from the list": "Nepasiekiamas bent viename pardavimo kanale i\u0161 s\u0105ra\u0161o",
  "Is not available at one of the sales channels in the list": "N\u0117ra jokiame i\u0161 pardavimo kanal\u0173 s\u0105ra\u0161e",
  "Is not between": "N\u0117ra tarp",
  "Is not equal to": "Nelygu",
  "Is not from a vendor in the list": "N\u0117ra i\u0161 pardav\u0117jo s\u0105ra\u0161e",
  "Is not from the list": "N\u0117ra i\u0161 s\u0105ra\u0161o",
  "Is not in a category from the list": "N\u0117ra kategorijoje i\u0161 s\u0105ra\u0161o",
  "Is not in a collection from the list": "N\u0117ra kolekcijoje i\u0161 s\u0105ra\u0161o",
  "Is not of a type from the list": "N\u0117ra tipo i\u0161 s\u0105ra\u0161o",
  "Is not on": "N\u0117ra",
  "Is not one of the countries from the list": "N\u0117ra viena i\u0161 \u0161ali\u0173 s\u0105ra\u0161e",
  "Is not one of the customer segments from the list": "N\u0117ra vienas i\u0161 klient\u0173 segment\u0173 s\u0105ra\u0161e",
  "Is not one of the fulfillment statuses in the list": "N\u0117ra viena i\u0161 \u012Fvykdymo b\u016Bsen\u0173 s\u0105ra\u0161e",
  "Is not one of the languages from the list": "N\u0117ra viena i\u0161 kalb\u0173 s\u0105ra\u0161e",
  "Is not one of the methods in the list": "N\u0117ra vienas i\u0161 s\u0105ra\u0161o b\u016Bd\u0173",
  "Is not one of the payment statuses in the list": "N\u0117ra viena i\u0161 mok\u0117jimo b\u016Bsen\u0173 s\u0105ra\u0161e",
  "Is not tagged with all the tags in the list": "Ne\u017Eym\u0117tas visomis s\u0105ra\u0161e esan\u010Diomis \u017Eymomis",
  "Is not tagged with any of the tags in the list": "N\u0117ra pa\u017Eym\u0117ta jokiu s\u0105ra\u0161o \u017Eenklu",
  "Is not tagged with at least one of the tags in the list": "Ne\u017Eym\u0117tas bent viena i\u0161 s\u0105ra\u0161e esan\u010Di\u0173 \u017Eym\u0173",
  "Is of a type from the list": "Yra tipo i\u0161 s\u0105ra\u0161o",
  "Is on": "Yra",
  "Is one of the countries from the list": "Yra viena i\u0161 \u0161ali\u0173 s\u0105ra\u0161e",
  "Is one of the customer segments from the list": "Yra vienas i\u0161 klient\u0173 segment\u0173 s\u0105ra\u0161e",
  "Is one of the fulfillment statuses in the list": "Yra viena i\u0161 \u012Fvykdymo b\u016Bsen\u0173 s\u0105ra\u0161e",
  "Is one of the languages from the list": "Yra viena i\u0161 kalb\u0173 s\u0105ra\u0161e",
  "Is one of the methods in the list": "Yra vienas i\u0161 s\u0105ra\u0161o b\u016Bd\u0173",
  "Is one of the payment statuses in the list": "Yra viena i\u0161 mok\u0117jimo b\u016Bsen\u0173 s\u0105ra\u0161e",
  "Is tagged with all the tags in the list": "Pa\u017Eym\u0117ta visais s\u0105ra\u0161o \u017Eenklais",
  "Is tagged with at least one of the tags in the list": "Pa\u017Eym\u0117ta bent vienu s\u0105ra\u0161o \u017Eenklu",
  "Item cost": "Prek\u0117s kaina",
  Language: "Kalba",
  "Less than": "Ma\u017Eiau nei",
  "Less than or equals to": "Ma\u017Eiau arba lygu",
  "Marketing consent": "Rinkodaros sutikimas",
  Minutes: "Minut\u0117s",
  Months: "M\u0117nesiai",
  "Number of orders": "U\u017Esakym\u0173 skai\u010Dius",
  "On all of the post purchase pages": "Visuose puslapiuose po pirkimo",
  "On one of the post purchase pages": "Viename i\u0161 puslapi\u0173 po pirkimo",
  "On the checkout": "Atsiskaitymo puslapyje",
  "On the post purchase 1st page": "Pirmajame puslapyje po pirkimo",
  "On the post purchase 2nd page": "Antrajame puslapyje po pirkimo",
  "On the thank you page": "Pad\u0117kos puslapyje",
  "Order note": "U\u017Esakymo pastaba",
  "Order tags": "U\u017Esakymo \u017Eenklai",
  "Passed X time ago": "Pra\u0117jo prie\u0161 X",
  "Payment method": "Mok\u0117jimo b\u016Bdas",
  "please add cart or order value": "prid\u0117kite krep\u0161elio ar u\u017Esakymo vert\u0119",
  "please add customer email": "prid\u0117kite kliento el. pa\u0161t\u0105",
  "please add customer number of orders": "prid\u0117kite kliento u\u017Esakym\u0173 skai\u010Di\u0173",
  "please add discount code": "prid\u0117kite nuolaidos kod\u0105",
  "please add item cost": "Pra\u0161ome prid\u0117ti prek\u0117s kain\u0105",
  "please add number of orders": "Pra\u0161ome prid\u0117ti u\u017Esakym\u0173 skai\u010Di\u0173",
  "please add order note": "prid\u0117kite u\u017Esakymo pastab\u0105",
  "please add product price": "Pra\u0161ome prid\u0117ti produkto kain\u0105",
  "please add product sku": "prid\u0117kite produkto SKU",
  "please add product title": "prid\u0117kite produkto pavadinim\u0105",
  "please add product variant name": "prid\u0117kite produkto varianto pavadinim\u0105",
  "please add shipping value": "prid\u0117kite pristatymo vert\u0119",
  "please add time since last order": "Prid\u0117kite laik\u0105 nuo paskutinio u\u017Esakymo",
  "please add total item count": "Pra\u0161ome prid\u0117ti bendr\u0105 preki\u0173 skai\u010Di\u0173",
  "please add value": "prid\u0117kite vert\u0119",
  "please select collections": "pasirinkite kolekcijas",
  "please select customer birthday": "Pasirinkite kliento gimtadien\u012F",
  "please select customer country": "pasirinkite kliento \u0161al\u012F",
  "please select customer language": "pasirinkite kliento kalb\u0105",
  "please select customer segments": "pasirinkite klient\u0173 segmentus",
  "please select customer tag": "pasirinkite kliento \u017Eym\u0105",
  "please select customer tags": "Pasirinkite klient\u0173 \u017Eymas",
  "please select fulfillment statuses": "pasirinkite \u012Fvykdymo b\u016Bsenas",
  "please select offer": "pasirinkite pasi\u016Blym\u0105",
  "please select payment method": "Pra\u0161ome pasirinkti mok\u0117jimo b\u016Bd\u0105",
  "please select payment statuses": "Pra\u0161ome pasirinkti mok\u0117jimo b\u016Bsenas",
  "please select product type": "Pra\u0161ome pasirinkti produkto tip\u0105",
  "please select product vendor": "Pra\u0161ome pasirinkti produkto pardav\u0117j\u0105",
  "please select products": "pasirinkite produktus",
  "please select sales channel": "pasirinkite pardavimo kanal\u0105",
  "please select shipping methods": "pasirinkite pristatymo b\u016Bdus",
  "please select tags": "pasirinkite \u017Eymas",
  "Previous page offer": "Ankstesnio puslapio pasi\u016Blymas",
  product: "produktas",
  "Product recommendations": "Produkt\u0173 rekomendacijos",
  "Product type": "Produkto tipas",
  "Product upsell": "Produkto papildomas pardavimas",
  products: "produktai",
  "Requires shipping": "Reikalingas pristatymas",
  "Shipping method": "Pristatymo b\u016Bdas",
  "Shipping value": "Pristatymo vert\u0117",
  "Starts with": "Prasideda su",
  Status: "B\u016Bsena",
  "The displayed product": "Rodomas produktas",
  "The displayed product SKU": "Rodomo produkto SKU",
  "The only product title in the cart": "Vienintelio produkto pavadinimas krep\u0161elyje",
  "The only SKU in the cart": "Vienintelis SKU krep\u0161elyje",
  "The SKU of all products in the cart": "Vis\u0173 produkt\u0173 SKU krep\u0161elyje",
  "The SKU of at least one product in the cart": "Bent vieno produkto SKU krep\u0161elyje",
  "The title of all products in the cart": "Vis\u0173 produkt\u0173 pavadinimas krep\u0161elyje",
  "The title of at least one product in the cart": "Bent vieno produkto pavadinimas krep\u0161elyje",
  "The title of the displayed product": "Rodomo produkto pavadinimas",
  "The variant of all products in the cart": "Vis\u0173 produkt\u0173 variantas krep\u0161elyje",
  "The variant of at least one product in the cart": "Bent vieno produkto variantas krep\u0161elyje",
  "The variant of only product in the cart": "Vienintelio produkto variantas krep\u0161elyje",
  "The variant of the displayed product": "Rodomo produkto variantas",
  "Total item count": "Bendras preki\u0173 skai\u010Dius",
  Weeks: "Savait\u0117s",
  Years: "Metai"
};

// src/lang/hu.json
var hu_default = {
  "An offer was accepted": "Egy aj\xE1nlatot elfogadtak",
  "An offer was declined": "Egy aj\xE1nlatot elutas\xEDtottak",
  and: "\xE9s",
  "Announcement bar": "Hirdet\u0151s\xE1v",
  "Are available at all the sales channels from the list": "El\xE9rhet\u0151k a list\xE1n szerepl\u0151 \xF6sszes \xE9rt\xE9kes\xEDt\xE9si csatorn\xE1n",
  "Are available at one of the sales channels from the list": "El\xE9rhet\u0151k a list\xE1n szerepl\u0151 \xE9rt\xE9kes\xEDt\xE9si csatorn\xE1k egyik\xE9n",
  "Are not available at all the sales channels from the list": "Nem \xE9rhet\u0151k el a list\xE1n szerepl\u0151 \xF6sszes \xE9rt\xE9kes\xEDt\xE9si csatorn\xE1n",
  "Are not available at one of the sales channels from the list": "Nem \xE9rhet\u0151k el a list\xE1n szerepl\u0151 \xE9rt\xE9kes\xEDt\xE9si csatorn\xE1k egyik\xE9n",
  "At least one product in the cart": "Legal\xE1bb egy term\xE9k a kos\xE1rban",
  Banner: "Banner",
  Between: "K\xF6z\xF6tte",
  Bundle: "Csomag",
  "Cart/Order value": "Kos\xE1r/Rendel\xE9s \xE9rt\xE9ke",
  categories: "kateg\xF3ri\xE1k",
  category: "kateg\xF3ria",
  collection: "kollekci\xF3",
  collections: "kollekci\xF3k",
  Contains: "Tartalmazza",
  "Customer accepted marketing": "Az \xFCgyf\xE9l elfogadta a marketinget",
  "Customer birthday": "\xDCgyf\xE9l sz\xFClet\xE9snapja",
  "Customer country": "V\xE1s\xE1rl\xF3 orsz\xE1ga",
  "customer doesn't have all the tags from the list": "a v\xE1s\xE1rl\xF3 nem rendelkezik az \xF6sszes c\xEDmk\xE9vel a list\xE1r\xF3l",
  "customer doesn't have any of the tags from the list": "a v\xE1s\xE1rl\xF3 nem rendelkezik egyetlen c\xEDmk\xE9vel sem a list\xE1r\xF3l",
  "Customer don't accepted marketing": "Az \xFCgyf\xE9l nem fogadta el a marketinget",
  "Customer email": "V\xE1s\xE1rl\xF3 e-mail c\xEDme",
  "customer has all the tags from the list": "a v\xE1s\xE1rl\xF3 rendelkezik az \xF6sszes c\xEDmk\xE9vel a list\xE1r\xF3l",
  "customer has at least one of the tags from the list ": "a v\xE1s\xE1rl\xF3 rendelkezik legal\xE1bb egy c\xEDmk\xE9vel a list\xE1r\xF3l ",
  "Customer number of orders": "V\xE1s\xE1rl\xF3 rendel\xE9seinek sz\xE1ma",
  "Customer segments": "V\xE1s\xE1rl\xF3i szegmensek",
  "Customer tag": "\xDCgyf\xE9lc\xEDmke",
  Days: "Napok",
  "Discount code": "Kedvezm\xE9nyk\xF3d",
  "Does not require shipping": "Nem ig\xE9nyel sz\xE1ll\xEDt\xE1st",
  "Doesn't contain": "Nem tartalmazza",
  "Doesn't end with": "Nem erre v\xE9gz\u0151dik",
  "Doesn't have all the tags from the list": "Nem rendelkezik az \xF6sszes c\xEDmk\xE9vel a list\xE1r\xF3l",
  "Doesn't have some of the tags from the list": "Nem rendelkezik n\xE9h\xE1ny c\xEDmk\xE9vel a list\xE1r\xF3l",
  "Doesn't start with": "Nem ezzel kezd\u0151dik",
  "Ends with": "Erre v\xE9gz\u0151dik",
  "Equal to": "Egyenl\u0151",
  Equals: "Egyenl\u0151",
  "Every product in the cart": "Minden term\xE9k a kos\xE1rban",
  "Greater than": "Nagyobb, mint",
  "Greater than or equals to": "Nagyobb vagy egyenl\u0151",
  "Has all the tags from the list": "Rendelkezik az \xF6sszes c\xEDmk\xE9vel a list\xE1r\xF3l",
  "Has at least one of the tags from the list": "Rendelkezik legal\xE1bb egy c\xEDmk\xE9vel a list\xE1r\xF3l",
  Hours: "\xD3r\xE1k",
  "in less than": "kevesebb mint",
  "Is (exact code)": "Pontosan ez (k\xF3d)",
  "Is (exact email)": "Pontosan ez (e-mail)",
  "Is (exact sku)": "Pontosan ez (SKU)",
  "Is (exact title)": "Pontosan ez (c\xEDm)",
  "Is (exact variant name)": "Pontosan ez (v\xE1ltozat neve)",
  "Is after": "Ut\xE1na van",
  "Is available at all the sales channels from the list": "El\xE9rhet\u0151 a list\xE1n szerepl\u0151 \xF6sszes \xE9rt\xE9kes\xEDt\xE9si csatorn\xE1n",
  "Is available at all the sales channels in the list": "El\xE9rhet\u0151 a list\xE1ban szerepl\u0151 \xF6sszes \xE9rt\xE9kes\xEDt\xE9si csatorn\xE1n",
  "Is available at one of the sales channels from the list": "El\xE9rhet\u0151 a list\xE1n szerepl\u0151 \xE9rt\xE9kes\xEDt\xE9si csatorn\xE1k egyik\xE9n",
  "Is available at one of the sales channels in the list": "El\xE9rhet\u0151 a list\xE1ban szerepl\u0151 \xE9rt\xE9kes\xEDt\xE9si csatorn\xE1k egyik\xE9n",
  "Is before": "El\u0151tte van",
  "Is between": "K\xF6z\xF6tt van",
  "Is from a vendor in the list": "A list\xE1ban szerepl\u0151 egyik gy\xE1rt\xF3t\xF3l sz\xE1rmazik",
  "Is from the list": "A list\xE1n szerepel",
  "Is greater than": "Nagyobb, mint",
  "Is greater than or equals to": "Nagyobb vagy egyenl\u0151",
  "Is in a category from the list": "A list\xE1n szerepl\u0151 kateg\xF3ri\xE1ban van",
  "Is in a collection from the list": "A list\xE1n szerepl\u0151 kollekci\xF3ban van",
  "Is less than": "Kisebb, mint",
  "Is less than or equals to": "Kisebb vagy egyenl\u0151",
  "Is not (exact code)": "Nem ez (k\xF3d)",
  "Is not (exact email)": "Nem ez (e-mail)",
  "Is not (exact sku)": "Nem ez (SKU)",
  "Is not (exact title)": "Nem ez (c\xEDm)",
  "Is not (exact variant name)": "Nem ez (v\xE1ltozat neve)",
  "Is not available at all the sales channels from the list": "Nem \xE9rhet\u0151 el a list\xE1n szerepl\u0151 \xF6sszes \xE9rt\xE9kes\xEDt\xE9si csatorn\xE1n",
  "Is not available at all the sales channels in the list": "Nem el\xE9rhet\u0151 a list\xE1ban szerepl\u0151 \xF6sszes \xE9rt\xE9kes\xEDt\xE9si csatorn\xE1n",
  "Is not available at one of the sales channels from the list": "Nem \xE9rhet\u0151 el a list\xE1n szerepl\u0151 \xE9rt\xE9kes\xEDt\xE9si csatorn\xE1k egyik\xE9n",
  "Is not available at one of the sales channels in the list": "Nem el\xE9rhet\u0151 a list\xE1ban szerepl\u0151 \xE9rt\xE9kes\xEDt\xE9si csatorn\xE1k egyik\xE9n sem",
  "Is not between": "Nincs k\xF6z\xF6tte",
  "Is not equal to": "Nem egyenl\u0151",
  "Is not from a vendor in the list": "Nem a list\xE1ban szerepl\u0151 egyik gy\xE1rt\xF3t\xF3l sz\xE1rmazik",
  "Is not from the list": "Nincs a list\xE1n",
  "Is not in a category from the list": "Nincs a list\xE1n szerepl\u0151 kateg\xF3ri\xE1ban",
  "Is not in a collection from the list": "Nincs a list\xE1n szerepl\u0151 kollekci\xF3ban",
  "Is not of a type from the list": "Nem a list\xE1ban szerepl\u0151 t\xEDpusok egyike",
  "Is not on": "Nem ekkor van:",
  "Is not one of the countries from the list": "Nem a list\xE1n szerepl\u0151 orsz\xE1gok egyike",
  "Is not one of the customer segments from the list": "Nem a list\xE1n szerepl\u0151 v\xE1s\xE1rl\xF3i szegmensek egyike",
  "Is not one of the fulfillment statuses in the list": "Nem a list\xE1n szerepl\u0151 teljes\xEDt\xE9si \xE1llapotok egyike",
  "Is not one of the languages from the list": "Nem a list\xE1n szerepl\u0151 nyelvek egyike",
  "Is not one of the methods in the list": "Nem a list\xE1ban szerepl\u0151 m\xF3dok egyike",
  "Is not one of the payment statuses in the list": "Nem a list\xE1ban szerepl\u0151 fizet\xE9si \xE1llapotok egyike",
  "Is not tagged with all the tags in the list": "Nincs megjel\xF6lve a list\xE1ban szerepl\u0151 \xF6sszes c\xEDmk\xE9vel",
  "Is not tagged with any of the tags in the list": "Nincs c\xEDmk\xE9zve a lista egyetlen c\xEDmk\xE9j\xE9vel sem",
  "Is not tagged with at least one of the tags in the list": "Nincs megjel\xF6lve a list\xE1ban szerepl\u0151 legal\xE1bb egy c\xEDmk\xE9vel",
  "Is of a type from the list": "A list\xE1ban szerepl\u0151 t\xEDpusok egyike",
  "Is on": "Ekkor van:",
  "Is one of the countries from the list": "A list\xE1n szerepl\u0151 orsz\xE1gok egyike",
  "Is one of the customer segments from the list": "A list\xE1n szerepl\u0151 v\xE1s\xE1rl\xF3i szegmensek egyike",
  "Is one of the fulfillment statuses in the list": "A list\xE1n szerepl\u0151 teljes\xEDt\xE9si \xE1llapotok egyike",
  "Is one of the languages from the list": "A list\xE1n szerepl\u0151 nyelvek egyike",
  "Is one of the methods in the list": "A list\xE1ban szerepl\u0151 m\xF3dok egyike",
  "Is one of the payment statuses in the list": "A list\xE1ban szerepl\u0151 fizet\xE9si \xE1llapotok egyike",
  "Is tagged with all the tags in the list": "C\xEDmk\xE9zve van a lista \xF6sszes c\xEDmk\xE9j\xE9vel",
  "Is tagged with at least one of the tags in the list": "C\xEDmk\xE9zve van a lista legal\xE1bb egy c\xEDmk\xE9j\xE9vel",
  "Item cost": "T\xE9tel k\xF6lts\xE9ge",
  Language: "Nyelv",
  "Less than": "Kisebb, mint",
  "Less than or equals to": "Kisebb vagy egyenl\u0151",
  "Marketing consent": "Marketing hozz\xE1j\xE1rul\xE1s",
  Minutes: "Percek",
  Months: "H\xF3napok",
  "Number of orders": "Rendel\xE9sek sz\xE1ma",
  "On all of the post purchase pages": "A v\xE1s\xE1rl\xE1s ut\xE1ni oldalak mindegyik\xE9n",
  "On one of the post purchase pages": "A v\xE1s\xE1rl\xE1s ut\xE1ni oldalak egyik\xE9n",
  "On the checkout": "A p\xE9nzt\xE1rban",
  "On the post purchase 1st page": "A v\xE1s\xE1rl\xE1s ut\xE1ni 1. oldalon",
  "On the post purchase 2nd page": "A v\xE1s\xE1rl\xE1s ut\xE1ni 2. oldalon",
  "On the thank you page": "A k\xF6sz\xF6n\u0151 oldalon",
  "Order note": "Rendel\xE9si megjegyz\xE9s",
  "Order tags": "Rendel\xE9si c\xEDmk\xE9k",
  "Passed X time ago": "X ideje telt el",
  "Payment method": "Fizet\xE9si m\xF3d",
  "please add cart or order value": "k\xE9rj\xFCk, adja meg a kos\xE1r vagy rendel\xE9s \xE9rt\xE9k\xE9t",
  "please add customer email": "k\xE9rj\xFCk, adja meg a v\xE1s\xE1rl\xF3 e-mail c\xEDm\xE9t",
  "please add customer number of orders": "k\xE9rj\xFCk, adja meg a v\xE1s\xE1rl\xF3 rendel\xE9seinek sz\xE1m\xE1t",
  "please add discount code": "k\xE9rj\xFCk, adjon meg kedvezm\xE9nyk\xF3dot",
  "please add item cost": "k\xE9rj\xFCk, adja meg a t\xE9tel k\xF6lts\xE9g\xE9t",
  "please add number of orders": "K\xE9rj\xFCk, adja meg a rendel\xE9sek sz\xE1m\xE1t",
  "please add order note": "k\xE9rj\xFCk, adjon hozz\xE1 rendel\xE9si megjegyz\xE9st",
  "please add product price": "K\xE9rj\xFCk, adja meg a term\xE9k \xE1r\xE1t",
  "please add product sku": "k\xE9rj\xFCk, adja meg a term\xE9k SKU-j\xE1t",
  "please add product title": "k\xE9rj\xFCk, adja meg a term\xE9k c\xEDm\xE9t",
  "please add product variant name": "k\xE9rj\xFCk, adja meg a term\xE9kv\xE1ltozat nev\xE9t",
  "please add shipping value": "k\xE9rj\xFCk, adjon hozz\xE1 sz\xE1ll\xEDt\xE1si \xE9rt\xE9ket",
  "please add time since last order": "K\xE9rj\xFCk, adja meg az utols\xF3 rendel\xE9s \xF3ta eltelt id\u0151t",
  "please add total item count": "K\xE9rj\xFCk, adja meg a t\xE9telek teljes sz\xE1m\xE1t",
  "please add value": "k\xE9rj\xFCk, adjon meg \xE9rt\xE9ket",
  "please select collections": "k\xE9rj\xFCk, v\xE1lasszon kollekci\xF3kat",
  "please select customer birthday": "K\xE9rj\xFCk, v\xE1lassza ki az \xFCgyf\xE9l sz\xFClet\xE9snapj\xE1t",
  "please select customer country": "k\xE9rj\xFCk, v\xE1lassza ki a v\xE1s\xE1rl\xF3 orsz\xE1g\xE1t",
  "please select customer language": "k\xE9rj\xFCk, v\xE1lassza ki a v\xE1s\xE1rl\xF3 nyelv\xE9t",
  "please select customer segments": "k\xE9rj\xFCk, v\xE1lasszon v\xE1s\xE1rl\xF3i szegmenseket",
  "please select customer tag": "k\xE9rj\xFCk, v\xE1lasszon v\xE1s\xE1rl\xF3i c\xEDmk\xE9t",
  "please select customer tags": "K\xE9rj\xFCk, v\xE1lasszon \xFCgyf\xE9lc\xEDmk\xE9ket",
  "please select fulfillment statuses": "k\xE9rj\xFCk, v\xE1lasszon teljes\xEDt\xE9si \xE1llapotokat",
  "please select offer": "k\xE9rj\xFCk, v\xE1lasszon aj\xE1nlatot",
  "please select payment method": "K\xE9rj\xFCk, v\xE1lasszon fizet\xE9si m\xF3dot",
  "please select payment statuses": "K\xE9rj\xFCk, v\xE1lasszon fizet\xE9si \xE1llapotokat",
  "please select product type": "K\xE9rj\xFCk, v\xE1lasszon term\xE9kt\xEDpust",
  "please select product vendor": "K\xE9rj\xFCk, v\xE1lasszon term\xE9kgy\xE1rt\xF3t",
  "please select products": "k\xE9rj\xFCk, v\xE1lasszon term\xE9keket",
  "please select sales channel": "k\xE9rj\xFCk, v\xE1lasszon \xE9rt\xE9kes\xEDt\xE9si csatorn\xE1t",
  "please select shipping methods": "k\xE9rj\xFCk, v\xE1lasszon sz\xE1ll\xEDt\xE1si m\xF3dszereket",
  "please select tags": "k\xE9rj\xFCk, v\xE1lasszon c\xEDmk\xE9ket",
  "Previous page offer": "El\u0151z\u0151 oldali aj\xE1nlat",
  product: "term\xE9k",
  "Product recommendations": "Term\xE9kaj\xE1nl\xE1sok",
  "Product type": "Term\xE9kt\xEDpus",
  "Product upsell": "Term\xE9k upsell",
  products: "term\xE9kek",
  "Requires shipping": "Sz\xE1ll\xEDt\xE1st ig\xE9nyel",
  "Shipping method": "Sz\xE1ll\xEDt\xE1si m\xF3dszer",
  "Shipping value": "Sz\xE1ll\xEDt\xE1si \xE9rt\xE9k",
  "Starts with": "Ezzel kezd\u0151dik",
  Status: "\xC1llapot",
  "The displayed product": "A megjelen\xEDtett term\xE9k",
  "The displayed product SKU": "A megjelen\xEDtett term\xE9k SKU-ja",
  "The only product title in the cart": "Az egyetlen term\xE9k c\xEDme a kos\xE1rban",
  "The only SKU in the cart": "Az egyetlen SKU a kos\xE1rban",
  "The SKU of all products in the cart": "Az \xF6sszes term\xE9k SKU-ja a kos\xE1rban",
  "The SKU of at least one product in the cart": "Legal\xE1bb egy term\xE9k SKU-ja a kos\xE1rban",
  "The title of all products in the cart": "Az \xF6sszes term\xE9k c\xEDme a kos\xE1rban",
  "The title of at least one product in the cart": "Legal\xE1bb egy term\xE9k c\xEDme a kos\xE1rban",
  "The title of the displayed product": "A megjelen\xEDtett term\xE9k c\xEDme",
  "The variant of all products in the cart": "Az \xF6sszes term\xE9k v\xE1ltozata a kos\xE1rban",
  "The variant of at least one product in the cart": "Legal\xE1bb egy term\xE9k v\xE1ltozata a kos\xE1rban",
  "The variant of only product in the cart": "Az egyetlen term\xE9k v\xE1ltozata a kos\xE1rban",
  "The variant of the displayed product": "A megjelen\xEDtett term\xE9k v\xE1ltozata",
  "Total item count": "T\xE9telek teljes sz\xE1ma",
  Weeks: "Hetek",
  Years: "\xC9vek"
};

// src/lang/nl.json
var nl_default = {
  "An offer was accepted": "Een aanbod werd geaccepteerd",
  "An offer was declined": "Een aanbod werd afgewezen",
  and: "en",
  "Announcement bar": "Aankondigingsbalk",
  "Are available at all the sales channels from the list": "Zijn beschikbaar op alle verkoopkanalen uit de lijst",
  "Are available at one of the sales channels from the list": "Zijn beschikbaar op een van de verkoopkanalen uit de lijst",
  "Are not available at all the sales channels from the list": "Zijn niet beschikbaar op alle verkoopkanalen uit de lijst",
  "Are not available at one of the sales channels from the list": "Zijn niet beschikbaar op een van de verkoopkanalen uit de lijst",
  "At least one product in the cart": "Minstens \xE9\xE9n product in de winkelwagen",
  Banner: "Banner",
  Between: "Tussen",
  Bundle: "Bundel",
  "Cart/Order value": "Winkelwagen-/Bestelwaarde",
  categories: "categorie\xEBn",
  category: "categorie",
  collection: "collectie",
  collections: "collecties",
  Contains: "Bevat",
  "Customer accepted marketing": "Klant heeft marketing geaccepteerd",
  "Customer birthday": "Verjaardag klant",
  "Customer country": "Land van de klant",
  "customer doesn't have all the tags from the list": "klant heeft niet alle tags uit de lijst",
  "customer doesn't have any of the tags from the list": "klant heeft geen van de tags uit de lijst",
  "Customer don't accepted marketing": "Klant heeft marketing niet geaccepteerd",
  "Customer email": "E-mailadres van de klant",
  "customer has all the tags from the list": "klant heeft alle tags uit de lijst",
  "customer has at least one of the tags from the list ": "klant heeft ten minste \xE9\xE9n van de tags uit de lijst ",
  "Customer number of orders": "Aantal bestellingen van de klant",
  "Customer segments": "Klantsegmenten",
  "Customer tag": "Klanttag",
  Days: "Dagen",
  "Discount code": "Kortingscode",
  "Does not require shipping": "Geen verzending vereist",
  "Doesn't contain": "Bevat niet",
  "Doesn't end with": "Eindigt niet met",
  "Doesn't have all the tags from the list": "Heeft niet alle tags uit de lijst",
  "Doesn't have some of the tags from the list": "Heeft enkele van de tags uit de lijst niet",
  "Doesn't start with": "Begint niet met",
  "Ends with": "Eindigt met",
  "Equal to": "Gelijk aan",
  Equals: "Is gelijk aan",
  "Every product in the cart": "Elk product in de winkelwagen",
  "Greater than": "Groter dan",
  "Greater than or equals to": "Groter dan of gelijk aan",
  "Has all the tags from the list": "Heeft alle tags uit de lijst",
  "Has at least one of the tags from the list": "Heeft ten minste \xE9\xE9n van de tags uit de lijst",
  Hours: "Uren",
  "in less than": "in minder dan",
  "Is (exact code)": "Is (exacte code)",
  "Is (exact email)": "Is (exact e-mailadres)",
  "Is (exact sku)": "Is (exacte SKU)",
  "Is (exact title)": "Is (exacte titel)",
  "Is (exact variant name)": "Is (exacte variantnaam)",
  "Is after": "Is na",
  "Is available at all the sales channels from the list": "Is beschikbaar op alle verkoopkanalen uit de lijst",
  "Is available at all the sales channels in the list": "Is beschikbaar via alle verkoopkanalen in de lijst",
  "Is available at one of the sales channels from the list": "Is beschikbaar op een van de verkoopkanalen uit de lijst",
  "Is available at one of the sales channels in the list": "Is beschikbaar via een van de verkoopkanalen in de lijst",
  "Is before": "Is voor",
  "Is between": "Is tussen",
  "Is from a vendor in the list": "Is van een leverancier uit de lijst",
  "Is from the list": "Staat in de lijst",
  "Is greater than": "Is groter dan",
  "Is greater than or equals to": "Is groter dan of gelijk aan",
  "Is in a category from the list": "Is in een categorie uit de lijst",
  "Is in a collection from the list": "Is in een collectie uit de lijst",
  "Is less than": "Is kleiner dan",
  "Is less than or equals to": "Is kleiner dan of gelijk aan",
  "Is not (exact code)": "Is niet (exacte code)",
  "Is not (exact email)": "Is niet (exact e-mailadres)",
  "Is not (exact sku)": "Is niet (exacte SKU)",
  "Is not (exact title)": "Is niet (exacte titel)",
  "Is not (exact variant name)": "Is niet (exacte variantnaam)",
  "Is not available at all the sales channels from the list": "Is niet beschikbaar op alle verkoopkanalen uit de lijst",
  "Is not available at all the sales channels in the list": "Is niet beschikbaar via alle verkoopkanalen in de lijst",
  "Is not available at one of the sales channels from the list": "Is niet beschikbaar op een van de verkoopkanalen uit de lijst",
  "Is not available at one of the sales channels in the list": "Is niet beschikbaar via een van de verkoopkanalen in de lijst",
  "Is not between": "Is niet tussen",
  "Is not equal to": "Is niet gelijk aan",
  "Is not from a vendor in the list": "Is niet van een leverancier uit de lijst",
  "Is not from the list": "Staat niet in de lijst",
  "Is not in a category from the list": "Is niet in een categorie uit de lijst",
  "Is not in a collection from the list": "Is niet in een collectie uit de lijst",
  "Is not of a type from the list": "Is niet van een type uit de lijst",
  "Is not on": "Is niet op",
  "Is not one of the countries from the list": "Is niet een van de landen uit de lijst",
  "Is not one of the customer segments from the list": "Is niet een van de klantsegmenten uit de lijst",
  "Is not one of the fulfillment statuses in the list": "Is niet een van de uitvoeringsstatussen in de lijst",
  "Is not one of the languages from the list": "Is niet een van de talen uit de lijst",
  "Is not one of the methods in the list": "Is niet een van de methoden in de lijst",
  "Is not one of the payment statuses in the list": "Is niet een van de betalingsstatussen in de lijst",
  "Is not tagged with all the tags in the list": "Is niet getagd met alle tags in de lijst",
  "Is not tagged with any of the tags in the list": "Is niet gelabeld met een van de tags in de lijst",
  "Is not tagged with at least one of the tags in the list": "Is niet getagd met ten minste een van de tags in de lijst",
  "Is of a type from the list": "Is van een type uit de lijst",
  "Is on": "Is op",
  "Is one of the countries from the list": "Is een van de landen uit de lijst",
  "Is one of the customer segments from the list": "Is een van de klantsegmenten uit de lijst",
  "Is one of the fulfillment statuses in the list": "Is een van de uitvoeringsstatussen in de lijst",
  "Is one of the languages from the list": "Is een van de talen uit de lijst",
  "Is one of the methods in the list": "Is een van de methoden in de lijst",
  "Is one of the payment statuses in the list": "Is een van de betalingsstatussen in de lijst",
  "Is tagged with all the tags in the list": "Is gelabeld met alle tags in de lijst",
  "Is tagged with at least one of the tags in the list": "Is gelabeld met ten minste een van de tags in de lijst",
  "Item cost": "Artikelkosten",
  Language: "Taal",
  "Less than": "Kleiner dan",
  "Less than or equals to": "Kleiner dan of gelijk aan",
  "Marketing consent": "Marketingtoestemming",
  Minutes: "Minuten",
  Months: "Maanden",
  "Number of orders": "Aantal bestellingen",
  "On all of the post purchase pages": "Op alle pagina's na aankoop",
  "On one of the post purchase pages": "Op een van de pagina's na aankoop",
  "On the checkout": "Bij de checkout",
  "On the post purchase 1st page": "Op de 1e pagina na aankoop",
  "On the post purchase 2nd page": "Op de 2e pagina na aankoop",
  "On the thank you page": "Op de bedankpagina",
  "Order note": "Bestelnotitie",
  "Order tags": "Besteltags",
  "Passed X time ago": "X geleden gepasseerd",
  "Payment method": "Betaalmethode",
  "please add cart or order value": "voeg winkelwagen- of bestelwaarde toe",
  "please add customer email": "voeg e-mailadres van klant toe",
  "please add customer number of orders": "voeg aantal bestellingen van klant toe",
  "please add discount code": "voeg kortingscode toe",
  "please add item cost": "voeg artikelkosten toe",
  "please add number of orders": "Voeg het aantal bestellingen toe",
  "please add order note": "voeg bestelnotitie toe",
  "please add product price": "Voeg de productprijs toe",
  "please add product sku": "voeg product-SKU toe",
  "please add product title": "voeg producttitel toe",
  "please add product variant name": "voeg naam productvariant toe",
  "please add shipping value": "voeg verzendwaarde toe",
  "please add time since last order": "Voeg tijd sinds laatste bestelling toe",
  "please add total item count": "Voeg het totale aantal artikelen toe",
  "please add value": "voeg waarde toe",
  "please select collections": "selecteer collecties",
  "please select customer birthday": "Selecteer de verjaardag van de klant",
  "please select customer country": "selecteer land van de klant",
  "please select customer language": "selecteer taal van de klant",
  "please select customer segments": "selecteer klantsegmenten",
  "please select customer tag": "selecteer klanttag",
  "please select customer tags": "Selecteer klanttags",
  "please select fulfillment statuses": "selecteer uitvoeringsstatussen",
  "please select offer": "selecteer aanbod",
  "please select payment method": "Selecteer een betaalmethode",
  "please select payment statuses": "Selecteer betalingsstatussen",
  "please select product type": "Selecteer een producttype",
  "please select product vendor": "Selecteer een productleverancier",
  "please select products": "selecteer producten",
  "please select sales channel": "selecteer verkoopkanaal",
  "please select shipping methods": "selecteer verzendmethoden",
  "please select tags": "selecteer tags",
  "Previous page offer": "Aanbod vorige pagina",
  product: "product",
  "Product recommendations": "Productaanbevelingen",
  "Product type": "Producttype",
  "Product upsell": "Product-upsell",
  products: "producten",
  "Requires shipping": "Verzending vereist",
  "Shipping method": "Verzendmethode",
  "Shipping value": "Verzendwaarde",
  "Starts with": "Begint met",
  Status: "Status",
  "The displayed product": "Het weergegeven product",
  "The displayed product SKU": "De SKU van het weergegeven product",
  "The only product title in the cart": "De enige producttitel in de winkelwagen",
  "The only SKU in the cart": "De enige SKU in de winkelwagen",
  "The SKU of all products in the cart": "De SKU van alle producten in de winkelwagen",
  "The SKU of at least one product in the cart": "De SKU van ten minste \xE9\xE9n product in de winkelwagen",
  "The title of all products in the cart": "De titel van alle producten in de winkelwagen",
  "The title of at least one product in the cart": "De titel van ten minste \xE9\xE9n product in de winkelwagen",
  "The title of the displayed product": "De titel van het weergegeven product",
  "The variant of all products in the cart": "De variant van alle producten in de winkelwagen",
  "The variant of at least one product in the cart": "De variant van ten minste \xE9\xE9n product in de winkelwagen",
  "The variant of only product in the cart": "De variant van het enige product in de winkelwagen",
  "The variant of the displayed product": "De variant van het weergegeven product",
  "Total item count": "Totaal aantal artikelen",
  Weeks: "Weken",
  Years: "Jaren"
};

// src/lang/no.json
var no_default = {
  "An offer was accepted": "Et tilbud ble godtatt",
  "An offer was declined": "Et tilbud ble avsl\xE5tt",
  and: "og",
  "Announcement bar": "Kunngj\xF8ringslinje",
  "Are available at all the sales channels from the list": "Er tilgjengelige i alle salgskanalene fra listen",
  "Are available at one of the sales channels from the list": "Er tilgjengelige i \xE9n av salgskanalene fra listen",
  "Are not available at all the sales channels from the list": "Er ikke tilgjengelige i alle salgskanalene fra listen",
  "Are not available at one of the sales channels from the list": "Er ikke tilgjengelige i \xE9n av salgskanalene fra listen",
  "At least one product in the cart": "Minst ett produkt i handlevognen",
  Banner: "Banner",
  Between: "Mellom",
  Bundle: "Bundle",
  "Cart/Order value": "Verdi p\xE5 handlevogn/ordre",
  categories: "kategorier",
  category: "kategori",
  collection: "samling",
  collections: "samlinger",
  Contains: "Inneholder",
  "Customer accepted marketing": "Kunden godtok markedsf\xF8ring",
  "Customer birthday": "Kundens f\xF8dselsdag",
  "Customer country": "Kundens land",
  "customer doesn't have all the tags from the list": "kunden har ikke alle taggene fra listen",
  "customer doesn't have any of the tags from the list": "kunden har ingen av taggene fra listen",
  "Customer don't accepted marketing": "Kunden godtok ikke markedsf\xF8ring",
  "Customer email": "Kundens e-post",
  "customer has all the tags from the list": "kunden har alle taggene fra listen",
  "customer has at least one of the tags from the list ": "kunden har minst \xE9n av taggene fra listen",
  "Customer number of orders": "Kundens antall ordrer",
  "Customer segments": "Kundesegmenter",
  "Customer tag": "Kundetagg",
  Days: "Dager",
  "Discount code": "Rabattkode",
  "Does not require shipping": "Krever ikke frakt",
  "Doesn't contain": "Inneholder ikke",
  "Doesn't end with": "Slutter ikke med",
  "Doesn't have all the tags from the list": "Har ikke alle taggene fra listen",
  "Doesn't have some of the tags from the list": "Har ikke noen av taggene fra listen",
  "Doesn't start with": "Starter ikke med",
  "Ends with": "Slutter med",
  "Equal to": "Lik",
  Equals: "Er lik",
  "Every product in the cart": "Hvert produkt i handlevognen",
  "Greater than": "St\xF8rre enn",
  "Greater than or equals to": "St\xF8rre enn eller lik",
  "Has all the tags from the list": "Har alle taggene fra listen",
  "Has at least one of the tags from the list": "Har minst \xE9n av taggene fra listen",
  Hours: "Timer",
  "in less than": "om mindre enn",
  "Is (exact code)": "Er (n\xF8yaktig kode)",
  "Is (exact email)": "Er (n\xF8yaktig e-post)",
  "Is (exact sku)": "Er (n\xF8yaktig SKU)",
  "Is (exact title)": "Er (n\xF8yaktig tittel)",
  "Is (exact variant name)": "Er (n\xF8yaktig variantnavn)",
  "Is after": "Er etter",
  "Is available at all the sales channels from the list": "Er tilgjengelig i alle salgskanalene fra listen",
  "Is available at all the sales channels in the list": "Er tilgjengelig i alle salgskanalene i listen",
  "Is available at one of the sales channels from the list": "Er tilgjengelig i \xE9n av salgskanalene fra listen",
  "Is available at one of the sales channels in the list": "Er tilgjengelig i en av salgskanalene i listen",
  "Is before": "Er f\xF8r",
  "Is between": "Er mellom",
  "Is from a vendor in the list": "Er fra en leverand\xF8r i listen",
  "Is from the list": "Er fra listen",
  "Is greater than": "Er st\xF8rre enn",
  "Is greater than or equals to": "Er st\xF8rre enn eller lik",
  "Is in a category from the list": "Er i en kategori fra listen",
  "Is in a collection from the list": "Er i en samling fra listen",
  "Is less than": "Er mindre enn",
  "Is less than or equals to": "Er mindre enn eller lik",
  "Is not (exact code)": "Er ikke (n\xF8yaktig kode)",
  "Is not (exact email)": "Er ikke (n\xF8yaktig e-post)",
  "Is not (exact sku)": "Er ikke (n\xF8yaktig SKU)",
  "Is not (exact title)": "Er ikke (n\xF8yaktig tittel)",
  "Is not (exact variant name)": "Er ikke (n\xF8yaktig variantnavn)",
  "Is not available at all the sales channels from the list": "Er ikke tilgjengelig i alle salgskanalene fra listen",
  "Is not available at all the sales channels in the list": "Er ikke tilgjengelig i alle salgskanalene i listen",
  "Is not available at one of the sales channels from the list": "Er ikke tilgjengelig i \xE9n av salgskanalene fra listen",
  "Is not available at one of the sales channels in the list": "Er ikke tilgjengelig i noen av salgskanalene i listen",
  "Is not between": "Er ikke mellom",
  "Is not equal to": "Er ikke lik",
  "Is not from a vendor in the list": "Er ikke fra en leverand\xF8r i listen",
  "Is not from the list": "Er ikke fra listen",
  "Is not in a category from the list": "Er ikke i en kategori fra listen",
  "Is not in a collection from the list": "Er ikke i en samling fra listen",
  "Is not of a type from the list": "Er ikke av en type fra listen",
  "Is not on": "Er ikke p\xE5",
  "Is not one of the countries from the list": "Er ikke ett av landene fra listen",
  "Is not one of the customer segments from the list": "Er ikke ett av kundesegmentene fra listen",
  "Is not one of the fulfillment statuses in the list": "Er ikke en av oppfyllelsesstatusene i listen",
  "Is not one of the languages from the list": "Er ikke ett av spr\xE5kene fra listen",
  "Is not one of the methods in the list": "Er ikke en av metodene i listen",
  "Is not one of the payment statuses in the list": "Er ikke en av betalingsstatusene i listen",
  "Is not tagged with all the tags in the list": "Er ikke merket med alle taggene i listen",
  "Is not tagged with any of the tags in the list": "Er ikke merket med noen av taggene i listen",
  "Is not tagged with at least one of the tags in the list": "Er ikke merket med minst \xE9n av taggene i listen",
  "Is of a type from the list": "Er av en type fra listen",
  "Is on": "Er p\xE5",
  "Is one of the countries from the list": "Er ett av landene fra listen",
  "Is one of the customer segments from the list": "Er ett av kundesegmentene fra listen",
  "Is one of the fulfillment statuses in the list": "Er en av oppfyllelsesstatusene i listen",
  "Is one of the languages from the list": "Er ett av spr\xE5kene fra listen",
  "Is one of the methods in the list": "Er en av metodene i listen",
  "Is one of the payment statuses in the list": "Er en av betalingsstatusene i listen",
  "Is tagged with all the tags in the list": "Er merket med alle taggene i listen",
  "Is tagged with at least one of the tags in the list": "Er merket med minst ett av taggene i listen",
  "Item cost": "Varekostnad",
  Language: "Spr\xE5k",
  "Less than": "Mindre enn",
  "Less than or equals to": "Mindre enn eller lik",
  "Marketing consent": "Samtykke til markedsf\xF8ring",
  Minutes: "Minutter",
  Months: "M\xE5neder",
  "Number of orders": "Antall bestillinger",
  "On all of the post purchase pages": "P\xE5 alle sidene etter kj\xF8p",
  "On one of the post purchase pages": "P\xE5 en av sidene etter kj\xF8p",
  "On the checkout": "I kassen",
  "On the post purchase 1st page": "P\xE5 f\xF8rste side etter kj\xF8p",
  "On the post purchase 2nd page": "P\xE5 andre side etter kj\xF8p",
  "On the thank you page": "P\xE5 takkesiden",
  "Order note": "Ordrenotat",
  "Order tags": "Ordretagger",
  "Passed X time ago": "Passerte for X siden",
  "Payment method": "Betalingsmetode",
  "please add cart or order value": "Legg til verdi for handlevogn eller ordre",
  "please add customer email": "Legg til kundens e-post",
  "please add customer number of orders": "Legg til kundens antall ordrer",
  "please add discount code": "Legg til rabattkode",
  "please add item cost": "Vennligst legg til varekostnad",
  "please add number of orders": "Vennligst legg til antall bestillinger",
  "please add order note": "Legg til ordrenotat",
  "please add product price": "Vennligst legg til produktpris",
  "please add product sku": "Legg til produkt-SKU",
  "please add product title": "Legg til produkttittel",
  "please add product variant name": "Legg til produktvariantnavn",
  "please add shipping value": "Legg til fraktverdi",
  "please add time since last order": "Vennligst legg til tid siden forrige bestilling",
  "please add total item count": "Vennligst legg til totalt antall varer",
  "please add value": "Legg til verdi",
  "please select collections": "Velg samlinger",
  "please select customer birthday": "Vennligst velg kundens f\xF8dselsdag",
  "please select customer country": "Velg kundens land",
  "please select customer language": "Velg kundespr\xE5k",
  "please select customer segments": "Velg kundesegmenter",
  "please select customer tag": "Velg kundetagg",
  "please select customer tags": "Velg kundetagger",
  "please select fulfillment statuses": "Velg oppfyllelsesstatus",
  "please select offer": "Velg tilbud",
  "please select payment method": "Vennligst velg betalingsmetode",
  "please select payment statuses": "Vennligst velg betalingsstatus",
  "please select product type": "Vennligst velg produkttype",
  "please select product vendor": "Vennligst velg produktleverand\xF8r",
  "please select products": "Velg produkter",
  "please select sales channel": "Velg salgskanal",
  "please select shipping methods": "Velg fraktmetoder",
  "please select tags": "Velg tagger",
  "Previous page offer": "Tilbud p\xE5 forrige side",
  product: "produkt",
  "Product recommendations": "Produktanbefalinger",
  "Product type": "Produkttype",
  "Product upsell": "Mersalg av produkt",
  products: "produkter",
  "Requires shipping": "Krever frakt",
  "Shipping method": "Fraktmetode",
  "Shipping value": "Fraktverdi",
  "Starts with": "Starter med",
  Status: "Status",
  "The displayed product": "Det viste produktet",
  "The displayed product SKU": "SKU for det viste produktet",
  "The only product title in the cart": "Den eneste produkttittelen i handlevognen",
  "The only SKU in the cart": "Den eneste SKU-en i handlevognen",
  "The SKU of all products in the cart": "SKU for alle produkter i handlevognen",
  "The SKU of at least one product in the cart": "SKU for minst ett produkt i handlevognen",
  "The title of all products in the cart": "Tittelen p\xE5 alle produkter i handlevognen",
  "The title of at least one product in the cart": "Tittelen p\xE5 minst ett produkt i handlevognen",
  "The title of the displayed product": "Tittelen p\xE5 det viste produktet",
  "The variant of all products in the cart": "Varianten av alle produkter i handlevognen",
  "The variant of at least one product in the cart": "Varianten av minst ett produkt i handlevognen",
  "The variant of only product in the cart": "Varianten av det eneste produktet i handlevognen",
  "The variant of the displayed product": "Varianten av det viste produktet",
  "Total item count": "Totalt antall varer",
  Weeks: "Uker",
  Years: "\xC5r"
};

// src/lang/ro.json
var ro_default = {
  "An offer was accepted": "O ofert\u0103 a fost acceptat\u0103",
  "An offer was declined": "O ofert\u0103 a fost refuzat\u0103",
  and: "\u0219i",
  "Announcement bar": "Bar\u0103 de anun\u021Buri",
  "Are available at all the sales channels from the list": "Sunt disponibile pe toate canalele de v\xE2nzare din list\u0103",
  "Are available at one of the sales channels from the list": "Sunt disponibile pe unul dintre canalele de v\xE2nzare din list\u0103",
  "Are not available at all the sales channels from the list": "Nu sunt disponibile pe toate canalele de v\xE2nzare din list\u0103",
  "Are not available at one of the sales channels from the list": "Nu sunt disponibile pe unul dintre canalele de v\xE2nzare din list\u0103",
  "At least one product in the cart": "Cel pu\u021Bin un produs \xEEn co\u0219",
  Banner: "Banner",
  Between: "\xCEntre",
  Bundle: "Pachet",
  "Cart/Order value": "Valoarea Co\u0219ului/Comenzii",
  categories: "categorii",
  category: "categorie",
  collection: "colec\u021Bie",
  collections: "colec\u021Bii",
  Contains: "Con\u021Bine",
  "Customer accepted marketing": "Clientul a acceptat marketingul",
  "Customer birthday": "Ziua de na\u0219tere a clientului",
  "Customer country": "\u021Aara Clientului",
  "customer doesn't have all the tags from the list": "clientul nu are toate etichetele din list\u0103",
  "customer doesn't have any of the tags from the list": "clientul nu are niciuna dintre etichetele din list\u0103",
  "Customer don't accepted marketing": "Clientul nu a acceptat marketingul",
  "Customer email": "E-mail Client",
  "customer has all the tags from the list": "clientul are toate etichetele din list\u0103",
  "customer has at least one of the tags from the list ": "clientul are cel pu\u021Bin una dintre etichetele din list\u0103",
  "Customer number of orders": "Num\u0103rul de Comenzi al Clientului",
  "Customer segments": "Segmente de Clien\u021Bi",
  "Customer tag": "Etichet\u0103 client",
  Days: "Zile",
  "Discount code": "Cod de Reducere",
  "Does not require shipping": "Nu necesit\u0103 livrare",
  "Doesn't contain": "Nu con\u021Bine",
  "Doesn't end with": "Nu se termin\u0103 cu",
  "Doesn't have all the tags from the list": "Nu are toate etichetele din list\u0103",
  "Doesn't have some of the tags from the list": "Nu are unele dintre etichetele din list\u0103",
  "Doesn't start with": "Nu \xEEncepe cu",
  "Ends with": "Se termin\u0103 cu",
  "Equal to": "Egal cu",
  Equals: "Este egal cu",
  "Every product in the cart": "Fiecare produs din co\u0219",
  "Greater than": "Mai mare dec\xE2t",
  "Greater than or equals to": "Mai mare sau egal cu",
  "Has all the tags from the list": "Are toate etichetele din list\u0103",
  "Has at least one of the tags from the list": "Are cel pu\u021Bin una dintre etichetele din list\u0103",
  Hours: "Ore",
  "in less than": "\xEEn mai pu\u021Bin de",
  "Is (exact code)": "Este (cod exact)",
  "Is (exact email)": "Este (e-mail exact)",
  "Is (exact sku)": "Este (sku exact)",
  "Is (exact title)": "Este (titlu exact)",
  "Is (exact variant name)": "Este (nume exact variant\u0103)",
  "Is after": "Este dup\u0103",
  "Is available at all the sales channels from the list": "Este disponibil pe toate canalele de v\xE2nzare din list\u0103",
  "Is available at all the sales channels in the list": "Este disponibil pe toate canalele de v\xE2nz\u0103ri din list\u0103",
  "Is available at one of the sales channels from the list": "Este disponibil pe unul dintre canalele de v\xE2nzare din list\u0103",
  "Is available at one of the sales channels in the list": "Este disponibil pe unul dintre canalele de v\xE2nz\u0103ri din list\u0103",
  "Is before": "Este \xEEnainte de",
  "Is between": "Este \xEEntre",
  "Is from a vendor in the list": "Este de la un furnizor din list\u0103",
  "Is from the list": "Este din list\u0103",
  "Is greater than": "Este mai mare dec\xE2t",
  "Is greater than or equals to": "Este mai mare sau egal cu",
  "Is in a category from the list": "Este \xEEntr-o categorie din list\u0103",
  "Is in a collection from the list": "Este \xEEntr-o colec\u021Bie din list\u0103",
  "Is less than": "Este mai mic dec\xE2t",
  "Is less than or equals to": "Este mai mic sau egal cu",
  "Is not (exact code)": "Nu este (cod exact)",
  "Is not (exact email)": "Nu este (e-mail exact)",
  "Is not (exact sku)": "Nu este (sku exact)",
  "Is not (exact title)": "Nu este (titlu exact)",
  "Is not (exact variant name)": "Nu este (nume exact variant\u0103)",
  "Is not available at all the sales channels from the list": "Nu este disponibil pe toate canalele de v\xE2nzare din list\u0103",
  "Is not available at all the sales channels in the list": "Nu este disponibil pe toate canalele de v\xE2nz\u0103ri din list\u0103",
  "Is not available at one of the sales channels from the list": "Nu este disponibil pe unul dintre canalele de v\xE2nzare din list\u0103",
  "Is not available at one of the sales channels in the list": "Nu este disponibil pe niciunul dintre canalele de v\xE2nz\u0103ri din list\u0103",
  "Is not between": "Nu este \xEEntre",
  "Is not equal to": "Nu este egal cu",
  "Is not from a vendor in the list": "Nu este de la un furnizor din list\u0103",
  "Is not from the list": "Nu este din list\u0103",
  "Is not in a category from the list": "Nu este \xEEntr-o categorie din list\u0103",
  "Is not in a collection from the list": "Nu este \xEEntr-o colec\u021Bie din list\u0103",
  "Is not of a type from the list": "Nu este de un tip din list\u0103",
  "Is not on": "Nu este pe",
  "Is not one of the countries from the list": "Nu este una dintre \u021B\u0103rile din list\u0103",
  "Is not one of the customer segments from the list": "Nu este unul dintre segmentele de clien\u021Bi din list\u0103",
  "Is not one of the fulfillment statuses in the list": "Nu este una dintre st\u0103rile de \xEEndeplinire din list\u0103",
  "Is not one of the languages from the list": "Nu este una dintre limbile din list\u0103",
  "Is not one of the methods in the list": "Nu este una dintre metodele din list\u0103",
  "Is not one of the payment statuses in the list": "Nu este una dintre st\u0103rile de plat\u0103 din list\u0103",
  "Is not tagged with all the tags in the list": "Nu este etichetat cu toate etichetele din list\u0103",
  "Is not tagged with any of the tags in the list": "Nu este etichetat cu niciunul dintre tagurile din list\u0103",
  "Is not tagged with at least one of the tags in the list": "Nu este etichetat cu cel pu\u021Bin una dintre etichetele din list\u0103",
  "Is of a type from the list": "Este de un tip din list\u0103",
  "Is on": "Este pe",
  "Is one of the countries from the list": "Este una dintre \u021B\u0103rile din list\u0103",
  "Is one of the customer segments from the list": "Este unul dintre segmentele de clien\u021Bi din list\u0103",
  "Is one of the fulfillment statuses in the list": "Este una dintre st\u0103rile de \xEEndeplinire din list\u0103",
  "Is one of the languages from the list": "Este una dintre limbile din list\u0103",
  "Is one of the methods in the list": "Este una dintre metodele din list\u0103",
  "Is one of the payment statuses in the list": "Este una dintre st\u0103rile de plat\u0103 din list\u0103",
  "Is tagged with all the tags in the list": "Este etichetat cu toate tagurile din list\u0103",
  "Is tagged with at least one of the tags in the list": "Este etichetat cu cel pu\u021Bin unul dintre tagurile din list\u0103",
  "Item cost": "Costul articolului",
  Language: "Limb\u0103",
  "Less than": "Mai mic dec\xE2t",
  "Less than or equals to": "Mai mic sau egal cu",
  "Marketing consent": "Acord de marketing",
  Minutes: "Minute",
  Months: "Luni",
  "Number of orders": "Num\u0103rul de comenzi",
  "On all of the post purchase pages": "Pe toate paginile post-cump\u0103rare",
  "On one of the post purchase pages": "Pe una dintre paginile post-cump\u0103rare",
  "On the checkout": "La finalizarea comenzii",
  "On the post purchase 1st page": "Pe prima pagin\u0103 post-cump\u0103rare",
  "On the post purchase 2nd page": "Pe a doua pagin\u0103 post-cump\u0103rare",
  "On the thank you page": "Pe pagina de mul\u021Bumire",
  "Order note": "Not\u0103 comand\u0103",
  "Order tags": "Etichete comand\u0103",
  "Passed X time ago": "A trecut acum X",
  "Payment method": "Metod\u0103 de plat\u0103",
  "please add cart or order value": "te rug\u0103m s\u0103 adaugi valoarea co\u0219ului sau a comenzii",
  "please add customer email": "te rug\u0103m s\u0103 adaugi e-mailul clientului",
  "please add customer number of orders": "te rug\u0103m s\u0103 adaugi num\u0103rul de comenzi al clientului",
  "please add discount code": "te rug\u0103m s\u0103 adaugi codul de reducere",
  "please add item cost": "V\u0103 rug\u0103m s\u0103 ad\u0103uga\u021Bi costul articolului",
  "please add number of orders": "V\u0103 rug\u0103m s\u0103 ad\u0103uga\u021Bi num\u0103rul de comenzi",
  "please add order note": "te rug\u0103m s\u0103 adaugi nota comenzii",
  "please add product price": "V\u0103 rug\u0103m s\u0103 ad\u0103uga\u021Bi pre\u021Bul produsului",
  "please add product sku": "te rug\u0103m s\u0103 adaugi SKU-ul produsului",
  "please add product title": "te rug\u0103m s\u0103 adaugi titlul produsului",
  "please add product variant name": "te rug\u0103m s\u0103 adaugi numele variantei produsului",
  "please add shipping value": "te rug\u0103m s\u0103 adaugi valoarea livr\u0103rii",
  "please add time since last order": "V\u0103 rug\u0103m s\u0103 ad\u0103uga\u021Bi timpul de la ultima comand\u0103",
  "please add total item count": "V\u0103 rug\u0103m s\u0103 ad\u0103uga\u021Bi num\u0103rul total de articole",
  "please add value": "te rug\u0103m s\u0103 adaugi valoarea",
  "please select collections": "te rug\u0103m s\u0103 selectezi colec\u021Biile",
  "please select customer birthday": "V\u0103 rug\u0103m s\u0103 selecta\u021Bi ziua de na\u0219tere a clientului",
  "please select customer country": "te rug\u0103m s\u0103 selectezi \u021Bara clientului",
  "please select customer language": "te rug\u0103m s\u0103 selectezi limba clientului",
  "please select customer segments": "te rug\u0103m s\u0103 selectezi segmentele de clien\u021Bi",
  "please select customer tag": "te rug\u0103m s\u0103 selectezi eticheta clientului",
  "please select customer tags": "V\u0103 rug\u0103m s\u0103 selecta\u021Bi etichetele clien\u021Bilor",
  "please select fulfillment statuses": "te rug\u0103m s\u0103 selectezi st\u0103rile de \xEEndeplinire",
  "please select offer": "te rug\u0103m s\u0103 selectezi oferta",
  "please select payment method": "V\u0103 rug\u0103m s\u0103 selecta\u021Bi metoda de plat\u0103",
  "please select payment statuses": "V\u0103 rug\u0103m s\u0103 selecta\u021Bi st\u0103rile de plat\u0103",
  "please select product type": "V\u0103 rug\u0103m s\u0103 selecta\u021Bi tipul de produs",
  "please select product vendor": "V\u0103 rug\u0103m s\u0103 selecta\u021Bi furnizorul produsului",
  "please select products": "te rug\u0103m s\u0103 selectezi produsele",
  "please select sales channel": "te rug\u0103m s\u0103 selectezi canalul de v\xE2nzare",
  "please select shipping methods": "te rug\u0103m s\u0103 selectezi metodele de livrare",
  "please select tags": "te rug\u0103m s\u0103 selectezi etichetele",
  "Previous page offer": "Oferta de pe Pagina Anterioar\u0103",
  product: "produs",
  "Product recommendations": "Recomand\u0103ri de produse",
  "Product type": "Tip produs",
  "Product upsell": "Upsell de produs",
  products: "produse",
  "Requires shipping": "Necesit\u0103 livrare",
  "Shipping method": "Metod\u0103 de livrare",
  "Shipping value": "Valoarea livr\u0103rii",
  "Starts with": "\xCEncepe cu",
  Status: "Stare",
  "The displayed product": "Produsul afi\u0219at",
  "The displayed product SKU": "SKU-ul produsului afi\u0219at",
  "The only product title in the cart": "Singurul titlu de produs din co\u0219",
  "The only SKU in the cart": "Singurul SKU din co\u0219",
  "The SKU of all products in the cart": "SKU-ul tuturor produselor din co\u0219",
  "The SKU of at least one product in the cart": "SKU-ul a cel pu\u021Bin unui produs din co\u0219",
  "The title of all products in the cart": "Titlul tuturor produselor din co\u0219",
  "The title of at least one product in the cart": "Titlul a cel pu\u021Bin unui produs din co\u0219",
  "The title of the displayed product": "Titlul produsului afi\u0219at",
  "The variant of all products in the cart": "Varianta tuturor produselor din co\u0219",
  "The variant of at least one product in the cart": "Varianta a cel pu\u021Bin unui produs din co\u0219",
  "The variant of only product in the cart": "Varianta singurului produs din co\u0219",
  "The variant of the displayed product": "Varianta produsului afi\u0219at",
  "Total item count": "Num\u0103r total de articole",
  Weeks: "S\u0103pt\u0103m\xE2ni",
  Years: "Ani"
};

// src/lang/fi.json
var fi_default = {
  "An offer was accepted": "Tarjous hyv\xE4ksyttiin",
  "An offer was declined": "Tarjous hyl\xE4ttiin",
  and: "ja",
  "Announcement bar": "Ilmoituspalkki",
  "Are available at all the sales channels from the list": "Ovat saatavilla kaikilla myyntikanavilla luettelosta",
  "Are available at one of the sales channels from the list": "Ovat saatavilla yhdell\xE4 myyntikanavista luettelosta",
  "Are not available at all the sales channels from the list": "Eiv\xE4t ole saatavilla kaikilla myyntikanavilla luettelosta",
  "Are not available at one of the sales channels from the list": "Eiv\xE4t ole saatavilla yhdell\xE4 myyntikanavista luettelosta",
  "At least one product in the cart": "V\xE4hint\xE4\xE4n yksi tuote ostoskorissa",
  Banner: "Banneri",
  Between: "V\xE4lill\xE4",
  Bundle: "Paketti",
  "Cart/Order value": "Ostoskorin/Tilauksen arvo",
  categories: "kategoriat",
  category: "kategoria",
  collection: "kokoelma",
  collections: "kokoelmat",
  Contains: "Sis\xE4lt\xE4\xE4",
  "Customer accepted marketing": "Asiakas hyv\xE4ksyi markkinoinnin",
  "Customer birthday": "Asiakkaan syntym\xE4p\xE4iv\xE4",
  "Customer country": "Asiakkaan maa",
  "customer doesn't have all the tags from the list": "asiakkaalla ei ole kaikkia tunnisteita luettelosta",
  "customer doesn't have any of the tags from the list": "asiakkaalla ei ole yht\xE4\xE4n tunnistetta luettelosta",
  "Customer don't accepted marketing": "Asiakas ei hyv\xE4ksynyt markkinointia",
  "Customer email": "Asiakkaan s\xE4hk\xF6posti",
  "customer has all the tags from the list": "asiakkaalla on kaikki tunnisteet luettelosta",
  "customer has at least one of the tags from the list ": "asiakkaalla on v\xE4hint\xE4\xE4n yksi tunniste luettelosta",
  "Customer number of orders": "Asiakkaan tilausten m\xE4\xE4r\xE4",
  "Customer segments": "Asiakassegmentit",
  "Customer tag": "Asiakastunniste",
  Days: "P\xE4iv\xE4t",
  "Discount code": "Alennuskoodi",
  "Does not require shipping": "Ei vaadi toimitusta",
  "Doesn't contain": "Ei sis\xE4ll\xE4",
  "Doesn't end with": "Ei p\xE4\xE4ty",
  "Doesn't have all the tags from the list": "Ei sis\xE4ll\xE4 kaikkia tunnisteita luettelosta",
  "Doesn't have some of the tags from the list": "Ei sis\xE4ll\xE4 joitain tunnisteita luettelosta",
  "Doesn't start with": "Ei ala",
  "Ends with": "P\xE4\xE4ttyy",
  "Equal to": "Yht\xE4 suuri kuin",
  Equals: "On yht\xE4 suuri kuin",
  "Every product in the cart": "Jokainen tuote ostoskorissa",
  "Greater than": "Suurempi kuin",
  "Greater than or equals to": "Suurempi tai yht\xE4 suuri kuin",
  "Has all the tags from the list": "Sis\xE4lt\xE4\xE4 kaikki tunnisteet luettelosta",
  "Has at least one of the tags from the list": "Sis\xE4lt\xE4\xE4 v\xE4hint\xE4\xE4n yhden tunnisteen luettelosta",
  Hours: "Tunnit",
  "in less than": "alle",
  "Is (exact code)": "On (tarkka koodi)",
  "Is (exact email)": "On (tarkka s\xE4hk\xF6posti)",
  "Is (exact sku)": "On (tarkka SKU)",
  "Is (exact title)": "On (tarkka nimi)",
  "Is (exact variant name)": "On (tarkka variantin nimi)",
  "Is after": "On j\xE4lkeen",
  "Is available at all the sales channels from the list": "On saatavilla kaikilla myyntikanavilla luettelosta",
  "Is available at all the sales channels in the list": "On saatavilla kaikissa luettelon myyntikanavissa",
  "Is available at one of the sales channels from the list": "On saatavilla yhdell\xE4 myyntikanavista luettelosta",
  "Is available at one of the sales channels in the list": "On saatavilla yhdess\xE4 luettelon myyntikanavista",
  "Is before": "On ennen",
  "Is between": "On v\xE4lill\xE4",
  "Is from a vendor in the list": "On luettelon myyj\xE4lt\xE4",
  "Is from the list": "On luettelosta",
  "Is greater than": "On suurempi kuin",
  "Is greater than or equals to": "On suurempi tai yht\xE4 suuri kuin",
  "Is in a category from the list": "On kategoriassa luettelosta",
  "Is in a collection from the list": "On kokoelmassa luettelosta",
  "Is less than": "On pienempi kuin",
  "Is less than or equals to": "On pienempi tai yht\xE4 suuri kuin",
  "Is not (exact code)": "Ei ole (tarkka koodi)",
  "Is not (exact email)": "Ei ole (tarkka s\xE4hk\xF6posti)",
  "Is not (exact sku)": "Ei ole (tarkka SKU)",
  "Is not (exact title)": "Ei ole (tarkka nimi)",
  "Is not (exact variant name)": "Ei ole (tarkka variantin nimi)",
  "Is not available at all the sales channels from the list": "Ei ole saatavilla kaikilla myyntikanavilla luettelosta",
  "Is not available at all the sales channels in the list": "Ei ole saatavilla kaikissa luettelon myyntikanavissa",
  "Is not available at one of the sales channels from the list": "Ei ole saatavilla yhdell\xE4 myyntikanavista luettelosta",
  "Is not available at one of the sales channels in the list": "Ei ole saatavilla miss\xE4\xE4n luettelon myyntikanavista",
  "Is not between": "Ei ole v\xE4lill\xE4",
  "Is not equal to": "Ei ole yht\xE4 suuri kuin",
  "Is not from a vendor in the list": "Ei ole luettelon myyj\xE4lt\xE4",
  "Is not from the list": "Ei ole luettelosta",
  "Is not in a category from the list": "Ei ole kategoriassa luettelosta",
  "Is not in a collection from the list": "Ei ole kokoelmassa luettelosta",
  "Is not of a type from the list": "Ei kuulu luettelon tyyppeihin",
  "Is not on": "Ei ole",
  "Is not one of the countries from the list": "Ei ole yksi maista luettelosta",
  "Is not one of the customer segments from the list": "Ei ole yksi asiakassegmenteist\xE4 luettelosta",
  "Is not one of the fulfillment statuses in the list": "Ei ole yksi t\xE4yt\xE4nt\xF6\xF6npanotiloista luettelossa",
  "Is not one of the languages from the list": "Ei ole yksi kielist\xE4 luettelosta",
  "Is not one of the methods in the list": "Ei ole yksi luettelon menetelmist\xE4",
  "Is not one of the payment statuses in the list": "Ei ole yksi maksutiloista luettelossa",
  "Is not tagged with all the tags in the list": "Ei ole merkitty kaikilla luettelon tunnisteilla",
  "Is not tagged with any of the tags in the list": "Ei ole merkitty mill\xE4\xE4n luettelon tunnisteella",
  "Is not tagged with at least one of the tags in the list": "Ei ole merkitty v\xE4hint\xE4\xE4n yhdell\xE4 luettelon tunnisteista",
  "Is of a type from the list": "Kuuluu luettelon tyyppeihin",
  "Is on": "On",
  "Is one of the countries from the list": "On yksi maista luettelosta",
  "Is one of the customer segments from the list": "On yksi asiakassegmenteist\xE4 luettelosta",
  "Is one of the fulfillment statuses in the list": "On yksi t\xE4yt\xE4nt\xF6\xF6npanotiloista luettelossa",
  "Is one of the languages from the list": "On yksi kielist\xE4 luettelosta",
  "Is one of the methods in the list": "On yksi luettelon menetelmist\xE4",
  "Is one of the payment statuses in the list": "On yksi maksutiloista luettelossa",
  "Is tagged with all the tags in the list": "On merkitty kaikilla luettelon tunnisteilla",
  "Is tagged with at least one of the tags in the list": "On merkitty v\xE4hint\xE4\xE4n yhdell\xE4 luettelon tunnisteella",
  "Item cost": "Tuotteen hinta",
  Language: "Kieli",
  "Less than": "Pienempi kuin",
  "Less than or equals to": "Pienempi tai yht\xE4 suuri kuin",
  "Marketing consent": "Markkinointilupa",
  Minutes: "Minuutit",
  Months: "Kuukaudet",
  "Number of orders": "Tilausten m\xE4\xE4r\xE4",
  "On all of the post purchase pages": "Kaikilla oston j\xE4lkeisill\xE4 sivuilla",
  "On one of the post purchase pages": "Yhdell\xE4 oston j\xE4lkeisist\xE4 sivuista",
  "On the checkout": "Kassalla",
  "On the post purchase 1st page": "Oston j\xE4lkeisell\xE4 1. sivulla",
  "On the post purchase 2nd page": "Oston j\xE4lkeisell\xE4 2. sivulla",
  "On the thank you page": "Kiitossivulla",
  "Order note": "Tilaushuomautus",
  "Order tags": "Tilauksen tunnisteet",
  "Passed X time ago": "Meni X sitten",
  "Payment method": "Maksutapa",
  "please add cart or order value": "lis\xE4\xE4 ostoskorin tai tilauksen arvo",
  "please add customer email": "lis\xE4\xE4 asiakkaan s\xE4hk\xF6posti",
  "please add customer number of orders": "lis\xE4\xE4 asiakkaan tilausten m\xE4\xE4r\xE4",
  "please add discount code": "lis\xE4\xE4 alennuskoodi",
  "please add item cost": "lis\xE4\xE4 tuotteen hinta",
  "please add number of orders": "Lis\xE4\xE4 tilausten m\xE4\xE4r\xE4",
  "please add order note": "lis\xE4\xE4 tilaushuomautus",
  "please add product price": "Lis\xE4\xE4 tuotteen hinta",
  "please add product sku": "lis\xE4\xE4 tuotteen SKU",
  "please add product title": "lis\xE4\xE4 tuotteen nimi",
  "please add product variant name": "lis\xE4\xE4 tuotevariantin nimi",
  "please add shipping value": "lis\xE4\xE4 toimituksen arvo",
  "please add time since last order": "Lis\xE4\xE4 aika viimeisest\xE4 tilauksesta",
  "please add total item count": "Lis\xE4\xE4 tuotteiden kokonaism\xE4\xE4r\xE4",
  "please add value": "lis\xE4\xE4 arvo",
  "please select collections": "valitse kokoelmat",
  "please select customer birthday": "Valitse asiakkaan syntym\xE4p\xE4iv\xE4",
  "please select customer country": "valitse asiakkaan maa",
  "please select customer language": "valitse asiakkaan kieli",
  "please select customer segments": "valitse asiakassegmentit",
  "please select customer tag": "valitse asiakkaan tunniste",
  "please select customer tags": "Valitse asiakastunnisteet",
  "please select fulfillment statuses": "valitse t\xE4yt\xE4nt\xF6\xF6npanotilat",
  "please select offer": "valitse tarjous",
  "please select payment method": "Valitse maksutapa",
  "please select payment statuses": "Valitse maksutilat",
  "please select product type": "Valitse tuotetyyppi",
  "please select product vendor": "Valitse tuotteen myyj\xE4",
  "please select products": "valitse tuotteet",
  "please select sales channel": "valitse myyntikanava",
  "please select shipping methods": "valitse toimitusmenetelm\xE4t",
  "please select tags": "valitse tunnisteet",
  "Previous page offer": "Edellisen sivun tarjous",
  product: "tuote",
  "Product recommendations": "Tuotesuositukset",
  "Product type": "Tuotetyyppi",
  "Product upsell": "Tuotteen lis\xE4myynti",
  products: "tuotteet",
  "Requires shipping": "Vaatii toimituksen",
  "Shipping method": "Toimitusmenetelm\xE4",
  "Shipping value": "Toimituksen arvo",
  "Starts with": "Alkaa",
  Status: "Tila",
  "The displayed product": "N\xE4ytetty tuote",
  "The displayed product SKU": "N\xE4ytetyn tuotteen SKU",
  "The only product title in the cart": "Ainoan ostoskorissa olevan tuotteen nimi",
  "The only SKU in the cart": "Ainoan ostoskorissa olevan tuotteen SKU",
  "The SKU of all products in the cart": "Kaikkien ostoskorissa olevien tuotteiden SKU",
  "The SKU of at least one product in the cart": "V\xE4hint\xE4\xE4n yhden ostoskorissa olevan tuotteen SKU",
  "The title of all products in the cart": "Kaikkien ostoskorissa olevien tuotteiden nimi",
  "The title of at least one product in the cart": "V\xE4hint\xE4\xE4n yhden ostoskorissa olevan tuotteen nimi",
  "The title of the displayed product": "N\xE4ytetyn tuotteen nimi",
  "The variant of all products in the cart": "Kaikkien ostoskorissa olevien tuotteiden variantti",
  "The variant of at least one product in the cart": "V\xE4hint\xE4\xE4n yhden ostoskorissa olevan tuotteen variantti",
  "The variant of only product in the cart": "Ainoan ostoskorissa olevan tuotteen variantti",
  "The variant of the displayed product": "N\xE4ytetyn tuotteen variantti",
  "Total item count": "Tuotteiden kokonaism\xE4\xE4r\xE4",
  Weeks: "Viikot",
  Years: "Vuodet"
};

// src/lang/tr.json
var tr_default = {
  "An offer was accepted": "Bir teklif kabul edildi",
  "An offer was declined": "Bir teklif reddedildi",
  and: "ve",
  "Announcement bar": "Duyuru \xE7ubu\u011Fu",
  "Are available at all the sales channels from the list": "Listedeki t\xFCm sat\u0131\u015F kanallar\u0131nda mevcut",
  "Are available at one of the sales channels from the list": "Listedeki sat\u0131\u015F kanallar\u0131ndan birinde mevcut",
  "Are not available at all the sales channels from the list": "Listedeki t\xFCm sat\u0131\u015F kanallar\u0131nda mevcut de\u011Fil",
  "Are not available at one of the sales channels from the list": "Listedeki sat\u0131\u015F kanallar\u0131ndan birinde mevcut de\u011Fil",
  "At least one product in the cart": "Sepetteki \xFCr\xFCnlerden en az biri",
  Banner: "Banner",
  Between: "Aras\u0131nda",
  Bundle: "Paket",
  "Cart/Order value": "Sepet/Sipari\u015F de\u011Feri",
  categories: "kategoriler",
  category: "kategori",
  collection: "koleksiyon",
  collections: "koleksiyonlar",
  Contains: "\u0130\xE7erir",
  "Customer accepted marketing": "M\xFC\u015Fteri pazarlamay\u0131 kabul etti",
  "Customer birthday": "M\xFC\u015Fteri do\u011Fum g\xFCn\xFC",
  "Customer country": "M\xFC\u015Fteri \xFClkesi",
  "customer doesn't have all the tags from the list": "m\xFC\u015Fteri listedeki etiketlerin t\xFCm\xFCne sahip de\u011Fil",
  "customer doesn't have any of the tags from the list": "m\xFC\u015Fteri listedeki etiketlerden hi\xE7birine sahip de\u011Fil",
  "Customer don't accepted marketing": "M\xFC\u015Fteri pazarlamay\u0131 kabul etmedi",
  "Customer email": "M\xFC\u015Fteri e-postas\u0131",
  "customer has all the tags from the list": "m\xFC\u015Fteri listedeki etiketlerin t\xFCm\xFCne sahip",
  "customer has at least one of the tags from the list ": "m\xFC\u015Fteri listedeki etiketlerden en az birine sahip ",
  "Customer number of orders": "M\xFC\u015Fteri sipari\u015F say\u0131s\u0131",
  "Customer segments": "M\xFC\u015Fteri segmentleri",
  "Customer tag": "M\xFC\u015Fteri etiketi",
  Days: "G\xFCn",
  "Discount code": "\u0130ndirim kodu",
  "Does not require shipping": "Kargo gerektirmiyor",
  "Doesn't contain": "\u0130\xE7ermez",
  "Doesn't end with": "\u0130le bitmez",
  "Doesn't have all the tags from the list": "Listedeki etiketlerin t\xFCm\xFCne sahip de\u011Fil",
  "Doesn't have some of the tags from the list": "Listedeki baz\u0131 etiketlere sahip de\u011Fil",
  "Doesn't start with": "\u0130le ba\u015Flamaz",
  "Ends with": "\u0130le biter",
  "Equal to": "E\u015Fittir",
  Equals: "E\u015Fittir",
  "Every product in the cart": "Sepetteki her \xFCr\xFCn",
  "Greater than": "B\xFCy\xFCkt\xFCr",
  "Greater than or equals to": "B\xFCy\xFCk veya e\u015Fittir",
  "Has all the tags from the list": "Listedeki etiketlerin t\xFCm\xFCne sahip",
  "Has at least one of the tags from the list": "Listedeki etiketlerden en az birine sahip",
  Hours: "Saat",
  "in less than": "\u015Fundan daha k\u0131sa s\xFCrede:",
  "Is (exact code)": "Tam olarak (kod)",
  "Is (exact email)": "Tam olarak (e-posta)",
  "Is (exact sku)": "Tam olarak (sku)",
  "Is (exact title)": "Tam olarak (ba\u015Fl\u0131k)",
  "Is (exact variant name)": "Tam olarak (varyant ad\u0131)",
  "Is after": "\u015Eu tarihten sonra:",
  "Is available at all the sales channels from the list": "Listedeki t\xFCm sat\u0131\u015F kanallar\u0131nda mevcut",
  "Is available at all the sales channels in the list": "Listedeki t\xFCm sat\u0131\u015F kanallar\u0131nda mevcut",
  "Is available at one of the sales channels from the list": "Listedeki sat\u0131\u015F kanallar\u0131ndan birinde mevcut",
  "Is available at one of the sales channels in the list": "Listedeki sat\u0131\u015F kanallar\u0131ndan birinde mevcut",
  "Is before": "\u015Eu tarihten \xF6nce:",
  "Is between": "Aras\u0131ndad\u0131r",
  "Is from a vendor in the list": "Listedeki bir sat\u0131c\u0131dand\u0131r",
  "Is from the list": "Listeden",
  "Is greater than": "B\xFCy\xFCkt\xFCr",
  "Is greater than or equals to": "B\xFCy\xFCkt\xFCr veya e\u015Fittir",
  "Is in a category from the list": "Listedeki bir kategoride",
  "Is in a collection from the list": "Listedeki bir koleksiyonda",
  "Is less than": "K\xFC\xE7\xFCkt\xFCr",
  "Is less than or equals to": "K\xFC\xE7\xFCkt\xFCr veya e\u015Fittir",
  "Is not (exact code)": "Tam olarak de\u011Fil (kod)",
  "Is not (exact email)": "Tam olarak de\u011Fil (e-posta)",
  "Is not (exact sku)": "Tam olarak de\u011Fil (sku)",
  "Is not (exact title)": "Tam olarak de\u011Fil (ba\u015Fl\u0131k)",
  "Is not (exact variant name)": "Tam olarak de\u011Fil (varyant ad\u0131)",
  "Is not available at all the sales channels from the list": "Listedeki t\xFCm sat\u0131\u015F kanallar\u0131nda mevcut de\u011Fil",
  "Is not available at all the sales channels in the list": "Listedeki t\xFCm sat\u0131\u015F kanallar\u0131nda mevcut de\u011Fil",
  "Is not available at one of the sales channels from the list": "Listedeki sat\u0131\u015F kanallar\u0131ndan birinde mevcut de\u011Fil",
  "Is not available at one of the sales channels in the list": "Listedeki sat\u0131\u015F kanallar\u0131n\u0131n hi\xE7birinde mevcut de\u011Fil",
  "Is not between": "Aras\u0131nda de\u011Fil",
  "Is not equal to": "E\u015Fit de\u011Fildir",
  "Is not from a vendor in the list": "Listedeki bir sat\u0131c\u0131dan de\u011Fildir",
  "Is not from the list": "Listeden de\u011Fil",
  "Is not in a category from the list": "Listedeki bir kategoride de\u011Fil",
  "Is not in a collection from the list": "Listedeki bir koleksiyonda de\u011Fil",
  "Is not of a type from the list": "Listedeki bir t\xFCrden de\u011Fildir",
  "Is not on": "\u015Eu tarihte de\u011Fil:",
  "Is not one of the countries from the list": "Listedeki \xFClkelerden biri de\u011Fil",
  "Is not one of the customer segments from the list": "Listedeki m\xFC\u015Fteri segmentlerinden biri de\u011Fil",
  "Is not one of the fulfillment statuses in the list": "Listedeki yerine getirme durumlar\u0131ndan biri de\u011Fil",
  "Is not one of the languages from the list": "Listedeki dillerden biri de\u011Fil",
  "Is not one of the methods in the list": "Listedeki y\xF6ntemlerden biri de\u011Fildir",
  "Is not one of the payment statuses in the list": "Listedeki \xF6deme durumlar\u0131ndan biri de\u011Fildir",
  "Is not tagged with all the tags in the list": "Listedeki t\xFCm etiketlerle etiketlenmemi\u015F",
  "Is not tagged with any of the tags in the list": "Listedeki etiketlerden hi\xE7biriyle etiketlenmemi\u015F",
  "Is not tagged with at least one of the tags in the list": "Listedeki etiketlerden en az biriyle etiketlenmemi\u015F",
  "Is of a type from the list": "Listedeki bir t\xFCrdendir",
  "Is on": "\u015Eu tarihte:",
  "Is one of the countries from the list": "Listedeki \xFClkelerden biri",
  "Is one of the customer segments from the list": "Listedeki m\xFC\u015Fteri segmentlerinden biri",
  "Is one of the fulfillment statuses in the list": "Listedeki yerine getirme durumlar\u0131ndan biri",
  "Is one of the languages from the list": "Listedeki dillerden biri",
  "Is one of the methods in the list": "Listedeki y\xF6ntemlerden biridir",
  "Is one of the payment statuses in the list": "Listedeki \xF6deme durumlar\u0131ndan biridir",
  "Is tagged with all the tags in the list": "Listedeki t\xFCm etiketlerle etiketlenmi\u015F",
  "Is tagged with at least one of the tags in the list": "Listedeki etiketlerden en az biriyle etiketlenmi\u015F",
  "Item cost": "\xD6\u011Fe maliyeti",
  Language: "Dil",
  "Less than": "K\xFC\xE7\xFCkt\xFCr",
  "Less than or equals to": "K\xFC\xE7\xFCk veya e\u015Fittir",
  "Marketing consent": "Pazarlama onay\u0131",
  Minutes: "Dakika",
  Months: "Ay",
  "Number of orders": "Sipari\u015F say\u0131s\u0131",
  "On all of the post purchase pages": "T\xFCm sat\u0131n alma sonras\u0131 sayfalar\u0131nda",
  "On one of the post purchase pages": "Sat\u0131n alma sonras\u0131 sayfalar\u0131ndan birinde",
  "On the checkout": "\xD6deme sayfas\u0131nda",
  "On the post purchase 1st page": "Sat\u0131n alma sonras\u0131 1. sayfada",
  "On the post purchase 2nd page": "Sat\u0131n alma sonras\u0131 2. sayfada",
  "On the thank you page": "Te\u015Fekk\xFCr sayfas\u0131nda",
  "Order note": "Sipari\u015F notu",
  "Order tags": "Sipari\u015F etiketleri",
  "Passed X time ago": "X s\xFCre \xF6nce ge\xE7ti",
  "Payment method": "\xD6deme y\xF6ntemi",
  "please add cart or order value": "l\xFCtfen sepet veya sipari\u015F de\u011Feri ekleyin",
  "please add customer email": "l\xFCtfen m\xFC\u015Fteri e-postas\u0131n\u0131 ekleyin",
  "please add customer number of orders": "l\xFCtfen m\xFC\u015Fteri sipari\u015F say\u0131s\u0131n\u0131 ekleyin",
  "please add discount code": "l\xFCtfen indirim kodu ekleyin",
  "please add item cost": "L\xFCtfen \xF6\u011Fe maliyetini ekleyin",
  "please add number of orders": "L\xFCtfen sipari\u015F say\u0131s\u0131n\u0131 ekleyin",
  "please add order note": "l\xFCtfen sipari\u015F notu ekleyin",
  "please add product price": "L\xFCtfen \xFCr\xFCn fiyat\u0131n\u0131 ekleyin",
  "please add product sku": "l\xFCtfen \xFCr\xFCn SKU'su ekleyin",
  "please add product title": "l\xFCtfen \xFCr\xFCn ba\u015Fl\u0131\u011F\u0131 ekleyin",
  "please add product variant name": "l\xFCtfen \xFCr\xFCn varyant\u0131 ad\u0131 ekleyin",
  "please add shipping value": "l\xFCtfen kargo de\u011Feri ekleyin",
  "please add time since last order": "L\xFCtfen son sipari\u015Ften bu yana ge\xE7en s\xFCreyi ekleyin",
  "please add total item count": "L\xFCtfen toplam \xFCr\xFCn say\u0131s\u0131n\u0131 ekleyin",
  "please add value": "l\xFCtfen de\u011Fer ekleyin",
  "please select collections": "l\xFCtfen koleksiyonlar\u0131 se\xE7in",
  "please select customer birthday": "L\xFCtfen m\xFC\u015Fteri do\u011Fum g\xFCn\xFCn\xFC se\xE7in",
  "please select customer country": "l\xFCtfen m\xFC\u015Fteri \xFClkesini se\xE7in",
  "please select customer language": "l\xFCtfen m\xFC\u015Fteri dilini se\xE7in",
  "please select customer segments": "l\xFCtfen m\xFC\u015Fteri segmentlerini se\xE7in",
  "please select customer tag": "l\xFCtfen m\xFC\u015Fteri etiketini se\xE7in",
  "please select customer tags": "L\xFCtfen m\xFC\u015Fteri etiketlerini se\xE7in",
  "please select fulfillment statuses": "l\xFCtfen yerine getirme durumlar\u0131n\u0131 se\xE7in",
  "please select offer": "l\xFCtfen teklif se\xE7in",
  "please select payment method": "L\xFCtfen \xF6deme y\xF6ntemini se\xE7in",
  "please select payment statuses": "L\xFCtfen \xF6deme durumlar\u0131n\u0131 se\xE7in",
  "please select product type": "L\xFCtfen \xFCr\xFCn t\xFCr\xFCn\xFC se\xE7in",
  "please select product vendor": "L\xFCtfen \xFCr\xFCn sat\u0131c\u0131s\u0131n\u0131 se\xE7in",
  "please select products": "l\xFCtfen \xFCr\xFCnleri se\xE7in",
  "please select sales channel": "l\xFCtfen sat\u0131\u015F kanal\u0131 se\xE7in",
  "please select shipping methods": "l\xFCtfen kargo y\xF6ntemlerini se\xE7in",
  "please select tags": "l\xFCtfen etiketleri se\xE7in",
  "Previous page offer": "\xD6nceki sayfa teklifi",
  product: "\xFCr\xFCn",
  "Product recommendations": "\xDCr\xFCn \xF6nerileri",
  "Product type": "\xDCr\xFCn t\xFCr\xFC",
  "Product upsell": "\xDCr\xFCn ek sat\u0131\u015F\u0131",
  products: "\xFCr\xFCnler",
  "Requires shipping": "Kargo gerektiriyor",
  "Shipping method": "Kargo y\xF6ntemi",
  "Shipping value": "Kargo de\u011Feri",
  "Starts with": "\u0130le ba\u015Flar",
  Status: "Durum",
  "The displayed product": "G\xF6r\xFCnt\xFClenen \xFCr\xFCn",
  "The displayed product SKU": "G\xF6r\xFCnt\xFClenen \xFCr\xFCn\xFCn SKU'su",
  "The only product title in the cart": "Sepetteki tek \xFCr\xFCn\xFCn ba\u015Fl\u0131\u011F\u0131",
  "The only SKU in the cart": "Sepetteki tek SKU",
  "The SKU of all products in the cart": "Sepetteki t\xFCm \xFCr\xFCnlerin SKU'su",
  "The SKU of at least one product in the cart": "Sepetteki \xFCr\xFCnlerden en az birinin SKU'su",
  "The title of all products in the cart": "Sepetteki t\xFCm \xFCr\xFCnlerin ba\u015Fl\u0131\u011F\u0131",
  "The title of at least one product in the cart": "Sepetteki \xFCr\xFCnlerden en az birinin ba\u015Fl\u0131\u011F\u0131",
  "The title of the displayed product": "G\xF6r\xFCnt\xFClenen \xFCr\xFCn\xFCn ba\u015Fl\u0131\u011F\u0131",
  "The variant of all products in the cart": "Sepetteki t\xFCm \xFCr\xFCnlerin varyant\u0131",
  "The variant of at least one product in the cart": "Sepetteki \xFCr\xFCnlerden en az birinin varyant\u0131",
  "The variant of only product in the cart": "Sepetteki tek \xFCr\xFCn\xFCn varyant\u0131",
  "The variant of the displayed product": "G\xF6r\xFCnt\xFClenen \xFCr\xFCn\xFCn varyant\u0131",
  "Total item count": "Toplam \xFCr\xFCn say\u0131s\u0131",
  Weeks: "Hafta",
  Years: "Y\u0131l"
};

// src/lang/el.json
var el_default = {
  "An offer was accepted": "\u039C\u03B9\u03B1 \u03C0\u03C1\u03BF\u03C3\u03C6\u03BF\u03C1\u03AC \u03AD\u03B3\u03B9\u03BD\u03B5 \u03B1\u03C0\u03BF\u03B4\u03B5\u03BA\u03C4\u03AE",
  "An offer was declined": "\u039C\u03B9\u03B1 \u03C0\u03C1\u03BF\u03C3\u03C6\u03BF\u03C1\u03AC \u03B1\u03C0\u03BF\u03C1\u03C1\u03AF\u03C6\u03B8\u03B7\u03BA\u03B5",
  and: "\u03BA\u03B1\u03B9",
  "Announcement bar": "\u0393\u03C1\u03B1\u03BC\u03BC\u03AE \u03B1\u03BD\u03B1\u03BA\u03BF\u03B9\u03BD\u03CE\u03C3\u03B5\u03C9\u03BD",
  "Are available at all the sales channels from the list": "\u0395\u03AF\u03BD\u03B1\u03B9 \u03B4\u03B9\u03B1\u03B8\u03AD\u03C3\u03B9\u03BC\u03B1 \u03C3\u03B5 \u03CC\u03BB\u03B1 \u03C4\u03B1 \u03BA\u03B1\u03BD\u03AC\u03BB\u03B9\u03B1 \u03C0\u03C9\u03BB\u03AE\u03C3\u03B5\u03C9\u03BD \u03C4\u03B7\u03C2 \u03BB\u03AF\u03C3\u03C4\u03B1\u03C2",
  "Are available at one of the sales channels from the list": "\u0395\u03AF\u03BD\u03B1\u03B9 \u03B4\u03B9\u03B1\u03B8\u03AD\u03C3\u03B9\u03BC\u03B1 \u03C3\u03B5 \u03AD\u03BD\u03B1 \u03B1\u03C0\u03CC \u03C4\u03B1 \u03BA\u03B1\u03BD\u03AC\u03BB\u03B9\u03B1 \u03C0\u03C9\u03BB\u03AE\u03C3\u03B5\u03C9\u03BD \u03C4\u03B7\u03C2 \u03BB\u03AF\u03C3\u03C4\u03B1\u03C2",
  "Are not available at all the sales channels from the list": "\u0394\u03B5\u03BD \u03B5\u03AF\u03BD\u03B1\u03B9 \u03B4\u03B9\u03B1\u03B8\u03AD\u03C3\u03B9\u03BC\u03B1 \u03C3\u03B5 \u03BA\u03B1\u03BD\u03AD\u03BD\u03B1 \u03B1\u03C0\u03CC \u03C4\u03B1 \u03BA\u03B1\u03BD\u03AC\u03BB\u03B9\u03B1 \u03C0\u03C9\u03BB\u03AE\u03C3\u03B5\u03C9\u03BD \u03C4\u03B7\u03C2 \u03BB\u03AF\u03C3\u03C4\u03B1\u03C2",
  "Are not available at one of the sales channels from the list": "\u0394\u03B5\u03BD \u03B5\u03AF\u03BD\u03B1\u03B9 \u03B4\u03B9\u03B1\u03B8\u03AD\u03C3\u03B9\u03BC\u03B1 \u03C3\u03B5 \u03AD\u03BD\u03B1 \u03B1\u03C0\u03CC \u03C4\u03B1 \u03BA\u03B1\u03BD\u03AC\u03BB\u03B9\u03B1 \u03C0\u03C9\u03BB\u03AE\u03C3\u03B5\u03C9\u03BD \u03C4\u03B7\u03C2 \u03BB\u03AF\u03C3\u03C4\u03B1\u03C2",
  "At least one product in the cart": "\u03A4\u03BF\u03C5\u03BB\u03AC\u03C7\u03B9\u03C3\u03C4\u03BF\u03BD \u03AD\u03BD\u03B1 \u03C0\u03C1\u03BF\u03CA\u03CC\u03BD \u03C3\u03C4\u03BF \u03BA\u03B1\u03BB\u03AC\u03B8\u03B9",
  Banner: "Banner",
  Between: "\u039C\u03B5\u03C4\u03B1\u03BE\u03CD",
  Bundle: "\u03A0\u03B1\u03BA\u03AD\u03C4\u03BF",
  "Cart/Order value": "\u0391\u03BE\u03AF\u03B1 \u03BA\u03B1\u03BB\u03B1\u03B8\u03B9\u03BF\u03CD/\u03C0\u03B1\u03C1\u03B1\u03B3\u03B3\u03B5\u03BB\u03AF\u03B1\u03C2",
  categories: "\u03BA\u03B1\u03C4\u03B7\u03B3\u03BF\u03C1\u03AF\u03B5\u03C2",
  category: "\u03BA\u03B1\u03C4\u03B7\u03B3\u03BF\u03C1\u03AF\u03B1",
  collection: "\u03C3\u03C5\u03BB\u03BB\u03BF\u03B3\u03AE",
  collections: "\u03C3\u03C5\u03BB\u03BB\u03BF\u03B3\u03AD\u03C2",
  Contains: "\u03A0\u03B5\u03C1\u03B9\u03AD\u03C7\u03B5\u03B9",
  "Customer accepted marketing": "\u039F \u03C0\u03B5\u03BB\u03AC\u03C4\u03B7\u03C2 \u03B1\u03C0\u03BF\u03B4\u03AD\u03C7\u03C4\u03B7\u03BA\u03B5 \u03C4\u03BF \u03BC\u03AC\u03C1\u03BA\u03B5\u03C4\u03B9\u03BD\u03B3\u03BA",
  "Customer birthday": "\u0393\u03B5\u03BD\u03AD\u03B8\u03BB\u03B9\u03B1 \u03C0\u03B5\u03BB\u03AC\u03C4\u03B7",
  "Customer country": "\u03A7\u03CE\u03C1\u03B1 \u03C0\u03B5\u03BB\u03AC\u03C4\u03B7",
  "customer doesn't have all the tags from the list": "\u03BF \u03C0\u03B5\u03BB\u03AC\u03C4\u03B7\u03C2 \u03B4\u03B5\u03BD \u03AD\u03C7\u03B5\u03B9 \u03CC\u03BB\u03B5\u03C2 \u03C4\u03B9\u03C2 \u03B5\u03C4\u03B9\u03BA\u03AD\u03C4\u03B5\u03C2 \u03B1\u03C0\u03CC \u03C4\u03B7 \u03BB\u03AF\u03C3\u03C4\u03B1",
  "customer doesn't have any of the tags from the list": "\u03BF \u03C0\u03B5\u03BB\u03AC\u03C4\u03B7\u03C2 \u03B4\u03B5\u03BD \u03AD\u03C7\u03B5\u03B9 \u03BA\u03B1\u03BC\u03AF\u03B1 \u03B1\u03C0\u03CC \u03C4\u03B9\u03C2 \u03B5\u03C4\u03B9\u03BA\u03AD\u03C4\u03B5\u03C2 \u03C4\u03B7\u03C2 \u03BB\u03AF\u03C3\u03C4\u03B1\u03C2",
  "Customer don't accepted marketing": "\u039F \u03C0\u03B5\u03BB\u03AC\u03C4\u03B7\u03C2 \u03B4\u03B5\u03BD \u03B1\u03C0\u03BF\u03B4\u03AD\u03C7\u03C4\u03B7\u03BA\u03B5 \u03C4\u03BF \u03BC\u03AC\u03C1\u03BA\u03B5\u03C4\u03B9\u03BD\u03B3\u03BA",
  "Customer email": "Email \u03C0\u03B5\u03BB\u03AC\u03C4\u03B7",
  "customer has all the tags from the list": "\u03BF \u03C0\u03B5\u03BB\u03AC\u03C4\u03B7\u03C2 \u03AD\u03C7\u03B5\u03B9 \u03CC\u03BB\u03B5\u03C2 \u03C4\u03B9\u03C2 \u03B5\u03C4\u03B9\u03BA\u03AD\u03C4\u03B5\u03C2 \u03B1\u03C0\u03CC \u03C4\u03B7 \u03BB\u03AF\u03C3\u03C4\u03B1",
  "customer has at least one of the tags from the list ": "\u03BF \u03C0\u03B5\u03BB\u03AC\u03C4\u03B7\u03C2 \u03AD\u03C7\u03B5\u03B9 \u03C4\u03BF\u03C5\u03BB\u03AC\u03C7\u03B9\u03C3\u03C4\u03BF\u03BD \u03BC\u03AF\u03B1 \u03B1\u03C0\u03CC \u03C4\u03B9\u03C2 \u03B5\u03C4\u03B9\u03BA\u03AD\u03C4\u03B5\u03C2 \u03C4\u03B7\u03C2 \u03BB\u03AF\u03C3\u03C4\u03B1\u03C2",
  "Customer number of orders": "\u0391\u03C1\u03B9\u03B8\u03BC\u03CC\u03C2 \u03C0\u03B1\u03C1\u03B1\u03B3\u03B3\u03B5\u03BB\u03B9\u03CE\u03BD \u03C0\u03B5\u03BB\u03AC\u03C4\u03B7",
  "Customer segments": "\u03A4\u03BC\u03AE\u03BC\u03B1\u03C4\u03B1 \u03C0\u03B5\u03BB\u03B1\u03C4\u03CE\u03BD",
  "Customer tag": "\u0395\u03C4\u03B9\u03BA\u03AD\u03C4\u03B1 \u03C0\u03B5\u03BB\u03AC\u03C4\u03B7",
  Days: "\u0397\u03BC\u03AD\u03C1\u03B5\u03C2",
  "Discount code": "\u0395\u03BA\u03C0\u03C4\u03C9\u03C4\u03B9\u03BA\u03CC\u03C2 \u03BA\u03C9\u03B4\u03B9\u03BA\u03CC\u03C2",
  "Does not require shipping": "\u0394\u03B5\u03BD \u03B1\u03C0\u03B1\u03B9\u03C4\u03B5\u03AF \u03B1\u03C0\u03BF\u03C3\u03C4\u03BF\u03BB\u03AE",
  "Doesn't contain": "\u0394\u03B5\u03BD \u03C0\u03B5\u03C1\u03B9\u03AD\u03C7\u03B5\u03B9",
  "Doesn't end with": "\u0394\u03B5\u03BD \u03C4\u03B5\u03BB\u03B5\u03B9\u03CE\u03BD\u03B5\u03B9 \u03BC\u03B5",
  "Doesn't have all the tags from the list": "\u0394\u03B5\u03BD \u03AD\u03C7\u03B5\u03B9 \u03CC\u03BB\u03B5\u03C2 \u03C4\u03B9\u03C2 \u03B5\u03C4\u03B9\u03BA\u03AD\u03C4\u03B5\u03C2 \u03B1\u03C0\u03CC \u03C4\u03B7 \u03BB\u03AF\u03C3\u03C4\u03B1",
  "Doesn't have some of the tags from the list": "\u0394\u03B5\u03BD \u03AD\u03C7\u03B5\u03B9 \u03BC\u03B5\u03C1\u03B9\u03BA\u03AD\u03C2 \u03B1\u03C0\u03CC \u03C4\u03B9\u03C2 \u03B5\u03C4\u03B9\u03BA\u03AD\u03C4\u03B5\u03C2 \u03B1\u03C0\u03CC \u03C4\u03B7 \u03BB\u03AF\u03C3\u03C4\u03B1",
  "Doesn't start with": "\u0394\u03B5\u03BD \u03BE\u03B5\u03BA\u03B9\u03BD\u03AC\u03B5\u03B9 \u03BC\u03B5",
  "Ends with": "\u03A4\u03B5\u03BB\u03B5\u03B9\u03CE\u03BD\u03B5\u03B9 \u03BC\u03B5",
  "Equal to": "\u038A\u03C3\u03BF \u03BC\u03B5",
  Equals: "\u0399\u03C3\u03BF\u03CD\u03C4\u03B1\u03B9 \u03BC\u03B5",
  "Every product in the cart": "\u039A\u03AC\u03B8\u03B5 \u03C0\u03C1\u03BF\u03CA\u03CC\u03BD \u03C3\u03C4\u03BF \u03BA\u03B1\u03BB\u03AC\u03B8\u03B9",
  "Greater than": "\u039C\u03B5\u03B3\u03B1\u03BB\u03CD\u03C4\u03B5\u03C1\u03BF \u03B1\u03C0\u03CC",
  "Greater than or equals to": "\u039C\u03B5\u03B3\u03B1\u03BB\u03CD\u03C4\u03B5\u03C1\u03BF \u03AE \u03AF\u03C3\u03BF \u03BC\u03B5",
  "Has all the tags from the list": "\u0388\u03C7\u03B5\u03B9 \u03CC\u03BB\u03B5\u03C2 \u03C4\u03B9\u03C2 \u03B5\u03C4\u03B9\u03BA\u03AD\u03C4\u03B5\u03C2 \u03B1\u03C0\u03CC \u03C4\u03B7 \u03BB\u03AF\u03C3\u03C4\u03B1",
  "Has at least one of the tags from the list": "\u0388\u03C7\u03B5\u03B9 \u03C4\u03BF\u03C5\u03BB\u03AC\u03C7\u03B9\u03C3\u03C4\u03BF\u03BD \u03BC\u03AF\u03B1 \u03B1\u03C0\u03CC \u03C4\u03B9\u03C2 \u03B5\u03C4\u03B9\u03BA\u03AD\u03C4\u03B5\u03C2 \u03B1\u03C0\u03CC \u03C4\u03B7 \u03BB\u03AF\u03C3\u03C4\u03B1",
  Hours: "\u038F\u03C1\u03B5\u03C2",
  "in less than": "\u03C3\u03B5 \u03BB\u03B9\u03B3\u03CC\u03C4\u03B5\u03C1\u03BF \u03B1\u03C0\u03CC",
  "Is (exact code)": "\u0395\u03AF\u03BD\u03B1\u03B9 (\u03B1\u03BA\u03C1\u03B9\u03B2\u03AE\u03C2 \u03BA\u03C9\u03B4\u03B9\u03BA\u03CC\u03C2)",
  "Is (exact email)": "\u0395\u03AF\u03BD\u03B1\u03B9 (\u03B1\u03BA\u03C1\u03B9\u03B2\u03AD\u03C2 email)",
  "Is (exact sku)": "\u0395\u03AF\u03BD\u03B1\u03B9 (\u03B1\u03BA\u03C1\u03B9\u03B2\u03AD\u03C2 SKU)",
  "Is (exact title)": "\u0395\u03AF\u03BD\u03B1\u03B9 (\u03B1\u03BA\u03C1\u03B9\u03B2\u03AE\u03C2 \u03C4\u03AF\u03C4\u03BB\u03BF\u03C2)",
  "Is (exact variant name)": "\u0395\u03AF\u03BD\u03B1\u03B9 (\u03B1\u03BA\u03C1\u03B9\u03B2\u03AD\u03C2 \u03CC\u03BD\u03BF\u03BC\u03B1 \u03C0\u03B1\u03C1\u03B1\u03BB\u03BB\u03B1\u03B3\u03AE\u03C2)",
  "Is after": "\u0395\u03AF\u03BD\u03B1\u03B9 \u03BC\u03B5\u03C4\u03AC",
  "Is available at all the sales channels from the list": "\u0395\u03AF\u03BD\u03B1\u03B9 \u03B4\u03B9\u03B1\u03B8\u03AD\u03C3\u03B9\u03BC\u03BF \u03C3\u03B5 \u03CC\u03BB\u03B1 \u03C4\u03B1 \u03BA\u03B1\u03BD\u03AC\u03BB\u03B9\u03B1 \u03C0\u03C9\u03BB\u03AE\u03C3\u03B5\u03C9\u03BD \u03C4\u03B7\u03C2 \u03BB\u03AF\u03C3\u03C4\u03B1\u03C2",
  "Is available at all the sales channels in the list": "\u0395\u03AF\u03BD\u03B1\u03B9 \u03B4\u03B9\u03B1\u03B8\u03AD\u03C3\u03B9\u03BC\u03BF \u03C3\u03B5 \u03CC\u03BB\u03B1 \u03C4\u03B1 \u03BA\u03B1\u03BD\u03AC\u03BB\u03B9\u03B1 \u03C0\u03C9\u03BB\u03AE\u03C3\u03B5\u03C9\u03BD \u03C3\u03C4\u03B7 \u03BB\u03AF\u03C3\u03C4\u03B1",
  "Is available at one of the sales channels from the list": "\u0395\u03AF\u03BD\u03B1\u03B9 \u03B4\u03B9\u03B1\u03B8\u03AD\u03C3\u03B9\u03BC\u03BF \u03C3\u03B5 \u03AD\u03BD\u03B1 \u03B1\u03C0\u03CC \u03C4\u03B1 \u03BA\u03B1\u03BD\u03AC\u03BB\u03B9\u03B1 \u03C0\u03C9\u03BB\u03AE\u03C3\u03B5\u03C9\u03BD \u03C4\u03B7\u03C2 \u03BB\u03AF\u03C3\u03C4\u03B1\u03C2",
  "Is available at one of the sales channels in the list": "\u0395\u03AF\u03BD\u03B1\u03B9 \u03B4\u03B9\u03B1\u03B8\u03AD\u03C3\u03B9\u03BC\u03BF \u03C3\u03B5 \u03AD\u03BD\u03B1 \u03B1\u03C0\u03CC \u03C4\u03B1 \u03BA\u03B1\u03BD\u03AC\u03BB\u03B9\u03B1 \u03C0\u03C9\u03BB\u03AE\u03C3\u03B5\u03C9\u03BD \u03C3\u03C4\u03B7 \u03BB\u03AF\u03C3\u03C4\u03B1",
  "Is before": "\u0395\u03AF\u03BD\u03B1\u03B9 \u03C0\u03C1\u03B9\u03BD",
  "Is between": "\u0395\u03AF\u03BD\u03B1\u03B9 \u03BC\u03B5\u03C4\u03B1\u03BE\u03CD",
  "Is from a vendor in the list": "\u03A0\u03C1\u03BF\u03AD\u03C1\u03C7\u03B5\u03C4\u03B1\u03B9 \u03B1\u03C0\u03CC \u03C0\u03C1\u03BF\u03BC\u03B7\u03B8\u03B5\u03C5\u03C4\u03AE \u03C3\u03C4\u03B7 \u03BB\u03AF\u03C3\u03C4\u03B1",
  "Is from the list": "\u0395\u03AF\u03BD\u03B1\u03B9 \u03B1\u03C0\u03CC \u03C4\u03B7 \u03BB\u03AF\u03C3\u03C4\u03B1",
  "Is greater than": "\u0395\u03AF\u03BD\u03B1\u03B9 \u03BC\u03B5\u03B3\u03B1\u03BB\u03CD\u03C4\u03B5\u03C1\u03BF \u03B1\u03C0\u03CC",
  "Is greater than or equals to": "\u0395\u03AF\u03BD\u03B1\u03B9 \u03BC\u03B5\u03B3\u03B1\u03BB\u03CD\u03C4\u03B5\u03C1\u03BF \u03AE \u03AF\u03C3\u03BF \u03BC\u03B5",
  "Is in a category from the list": "\u0391\u03BD\u03AE\u03BA\u03B5\u03B9 \u03C3\u03B5 \u03BC\u03B9\u03B1 \u03BA\u03B1\u03C4\u03B7\u03B3\u03BF\u03C1\u03AF\u03B1 \u03B1\u03C0\u03CC \u03C4\u03B7 \u03BB\u03AF\u03C3\u03C4\u03B1",
  "Is in a collection from the list": "\u0391\u03BD\u03AE\u03BA\u03B5\u03B9 \u03C3\u03B5 \u03BC\u03B9\u03B1 \u03C3\u03C5\u03BB\u03BB\u03BF\u03B3\u03AE \u03B1\u03C0\u03CC \u03C4\u03B7 \u03BB\u03AF\u03C3\u03C4\u03B1",
  "Is less than": "\u0395\u03AF\u03BD\u03B1\u03B9 \u03BC\u03B9\u03BA\u03C1\u03CC\u03C4\u03B5\u03C1\u03BF \u03B1\u03C0\u03CC",
  "Is less than or equals to": "\u0395\u03AF\u03BD\u03B1\u03B9 \u03BC\u03B9\u03BA\u03C1\u03CC\u03C4\u03B5\u03C1\u03BF \u03AE \u03AF\u03C3\u03BF \u03BC\u03B5",
  "Is not (exact code)": "\u0394\u03B5\u03BD \u03B5\u03AF\u03BD\u03B1\u03B9 (\u03B1\u03BA\u03C1\u03B9\u03B2\u03AE\u03C2 \u03BA\u03C9\u03B4\u03B9\u03BA\u03CC\u03C2)",
  "Is not (exact email)": "\u0394\u03B5\u03BD \u03B5\u03AF\u03BD\u03B1\u03B9 (\u03B1\u03BA\u03C1\u03B9\u03B2\u03AD\u03C2 email)",
  "Is not (exact sku)": "\u0394\u03B5\u03BD \u03B5\u03AF\u03BD\u03B1\u03B9 (\u03B1\u03BA\u03C1\u03B9\u03B2\u03AD\u03C2 SKU)",
  "Is not (exact title)": "\u0394\u03B5\u03BD \u03B5\u03AF\u03BD\u03B1\u03B9 (\u03B1\u03BA\u03C1\u03B9\u03B2\u03AE\u03C2 \u03C4\u03AF\u03C4\u03BB\u03BF\u03C2)",
  "Is not (exact variant name)": "\u0394\u03B5\u03BD \u03B5\u03AF\u03BD\u03B1\u03B9 (\u03B1\u03BA\u03C1\u03B9\u03B2\u03AD\u03C2 \u03CC\u03BD\u03BF\u03BC\u03B1 \u03C0\u03B1\u03C1\u03B1\u03BB\u03BB\u03B1\u03B3\u03AE\u03C2)",
  "Is not available at all the sales channels from the list": "\u0394\u03B5\u03BD \u03B5\u03AF\u03BD\u03B1\u03B9 \u03B4\u03B9\u03B1\u03B8\u03AD\u03C3\u03B9\u03BC\u03BF \u03C3\u03B5 \u03BA\u03B1\u03BD\u03AD\u03BD\u03B1 \u03B1\u03C0\u03CC \u03C4\u03B1 \u03BA\u03B1\u03BD\u03AC\u03BB\u03B9\u03B1 \u03C0\u03C9\u03BB\u03AE\u03C3\u03B5\u03C9\u03BD \u03C4\u03B7\u03C2 \u03BB\u03AF\u03C3\u03C4\u03B1\u03C2",
  "Is not available at all the sales channels in the list": "\u0394\u03B5\u03BD \u03B5\u03AF\u03BD\u03B1\u03B9 \u03B4\u03B9\u03B1\u03B8\u03AD\u03C3\u03B9\u03BC\u03BF \u03C3\u03B5 \u03CC\u03BB\u03B1 \u03C4\u03B1 \u03BA\u03B1\u03BD\u03AC\u03BB\u03B9\u03B1 \u03C0\u03C9\u03BB\u03AE\u03C3\u03B5\u03C9\u03BD \u03C3\u03C4\u03B7 \u03BB\u03AF\u03C3\u03C4\u03B1",
  "Is not available at one of the sales channels from the list": "\u0394\u03B5\u03BD \u03B5\u03AF\u03BD\u03B1\u03B9 \u03B4\u03B9\u03B1\u03B8\u03AD\u03C3\u03B9\u03BC\u03BF \u03C3\u03B5 \u03AD\u03BD\u03B1 \u03B1\u03C0\u03CC \u03C4\u03B1 \u03BA\u03B1\u03BD\u03AC\u03BB\u03B9\u03B1 \u03C0\u03C9\u03BB\u03AE\u03C3\u03B5\u03C9\u03BD \u03C4\u03B7\u03C2 \u03BB\u03AF\u03C3\u03C4\u03B1\u03C2",
  "Is not available at one of the sales channels in the list": "\u0394\u03B5\u03BD \u03B5\u03AF\u03BD\u03B1\u03B9 \u03B4\u03B9\u03B1\u03B8\u03AD\u03C3\u03B9\u03BC\u03BF \u03C3\u03B5 \u03BA\u03B1\u03BD\u03AD\u03BD\u03B1 \u03B1\u03C0\u03CC \u03C4\u03B1 \u03BA\u03B1\u03BD\u03AC\u03BB\u03B9\u03B1 \u03C0\u03C9\u03BB\u03AE\u03C3\u03B5\u03C9\u03BD \u03C3\u03C4\u03B7 \u03BB\u03AF\u03C3\u03C4\u03B1",
  "Is not between": "\u0394\u03B5\u03BD \u03B5\u03AF\u03BD\u03B1\u03B9 \u03BC\u03B5\u03C4\u03B1\u03BE\u03CD",
  "Is not equal to": "\u0394\u03B5\u03BD \u03B5\u03AF\u03BD\u03B1\u03B9 \u03AF\u03C3\u03BF \u03BC\u03B5",
  "Is not from a vendor in the list": "\u0394\u03B5\u03BD \u03C0\u03C1\u03BF\u03AD\u03C1\u03C7\u03B5\u03C4\u03B1\u03B9 \u03B1\u03C0\u03CC \u03C0\u03C1\u03BF\u03BC\u03B7\u03B8\u03B5\u03C5\u03C4\u03AE \u03C3\u03C4\u03B7 \u03BB\u03AF\u03C3\u03C4\u03B1",
  "Is not from the list": "\u0394\u03B5\u03BD \u03B5\u03AF\u03BD\u03B1\u03B9 \u03B1\u03C0\u03CC \u03C4\u03B7 \u03BB\u03AF\u03C3\u03C4\u03B1",
  "Is not in a category from the list": "\u0394\u03B5\u03BD \u03B1\u03BD\u03AE\u03BA\u03B5\u03B9 \u03C3\u03B5 \u03BA\u03B1\u03BC\u03AF\u03B1 \u03BA\u03B1\u03C4\u03B7\u03B3\u03BF\u03C1\u03AF\u03B1 \u03B1\u03C0\u03CC \u03C4\u03B7 \u03BB\u03AF\u03C3\u03C4\u03B1",
  "Is not in a collection from the list": "\u0394\u03B5\u03BD \u03B1\u03BD\u03AE\u03BA\u03B5\u03B9 \u03C3\u03B5 \u03BA\u03B1\u03BC\u03AF\u03B1 \u03C3\u03C5\u03BB\u03BB\u03BF\u03B3\u03AE \u03B1\u03C0\u03CC \u03C4\u03B7 \u03BB\u03AF\u03C3\u03C4\u03B1",
  "Is not of a type from the list": "\u0394\u03B5\u03BD \u03B5\u03AF\u03BD\u03B1\u03B9 \u03C4\u03CD\u03C0\u03BF\u03C5 \u03B1\u03C0\u03CC \u03C4\u03B7 \u03BB\u03AF\u03C3\u03C4\u03B1",
  "Is not on": "\u0394\u03B5\u03BD \u03B5\u03AF\u03BD\u03B1\u03B9 \u03C3\u03C4\u03B9\u03C2",
  "Is not one of the countries from the list": "\u0394\u03B5\u03BD \u03B5\u03AF\u03BD\u03B1\u03B9 \u03BA\u03B1\u03BC\u03AF\u03B1 \u03B1\u03C0\u03CC \u03C4\u03B9\u03C2 \u03C7\u03CE\u03C1\u03B5\u03C2 \u03C4\u03B7\u03C2 \u03BB\u03AF\u03C3\u03C4\u03B1\u03C2",
  "Is not one of the customer segments from the list": "\u0394\u03B5\u03BD \u03B5\u03AF\u03BD\u03B1\u03B9 \u03BA\u03B1\u03BD\u03AD\u03BD\u03B1 \u03B1\u03C0\u03CC \u03C4\u03B1 \u03C4\u03BC\u03AE\u03BC\u03B1\u03C4\u03B1 \u03C0\u03B5\u03BB\u03B1\u03C4\u03CE\u03BD \u03B1\u03C0\u03CC \u03C4\u03B7 \u03BB\u03AF\u03C3\u03C4\u03B1",
  "Is not one of the fulfillment statuses in the list": "\u0394\u03B5\u03BD \u03B5\u03AF\u03BD\u03B1\u03B9 \u03BC\u03AF\u03B1 \u03B1\u03C0\u03CC \u03C4\u03B9\u03C2 \u03BA\u03B1\u03C4\u03B1\u03C3\u03C4\u03AC\u03C3\u03B5\u03B9\u03C2 \u03B5\u03BA\u03C0\u03BB\u03AE\u03C1\u03C9\u03C3\u03B7\u03C2 \u03C3\u03C4\u03B7 \u03BB\u03AF\u03C3\u03C4\u03B1",
  "Is not one of the languages from the list": "\u0394\u03B5\u03BD \u03B5\u03AF\u03BD\u03B1\u03B9 \u03BA\u03B1\u03BC\u03AF\u03B1 \u03B1\u03C0\u03CC \u03C4\u03B9\u03C2 \u03B3\u03BB\u03CE\u03C3\u03C3\u03B5\u03C2 \u03C4\u03B7\u03C2 \u03BB\u03AF\u03C3\u03C4\u03B1\u03C2",
  "Is not one of the methods in the list": "\u0394\u03B5\u03BD \u03B5\u03AF\u03BD\u03B1\u03B9 \u03BC\u03AF\u03B1 \u03B1\u03C0\u03CC \u03C4\u03B9\u03C2 \u03BC\u03B5\u03B8\u03CC\u03B4\u03BF\u03C5\u03C2 \u03C3\u03C4\u03B7 \u03BB\u03AF\u03C3\u03C4\u03B1",
  "Is not one of the payment statuses in the list": "\u0394\u03B5\u03BD \u03B5\u03AF\u03BD\u03B1\u03B9 \u03BC\u03AF\u03B1 \u03B1\u03C0\u03CC \u03C4\u03B9\u03C2 \u03BA\u03B1\u03C4\u03B1\u03C3\u03C4\u03AC\u03C3\u03B5\u03B9\u03C2 \u03C0\u03BB\u03B7\u03C1\u03C9\u03BC\u03AE\u03C2 \u03C3\u03C4\u03B7 \u03BB\u03AF\u03C3\u03C4\u03B1",
  "Is not tagged with all the tags in the list": "\u0394\u03B5\u03BD \u03AD\u03C7\u03B5\u03B9 \u03B5\u03C0\u03B9\u03C3\u03B7\u03BC\u03B1\u03BD\u03B8\u03B5\u03AF \u03BC\u03B5 \u03CC\u03BB\u03B5\u03C2 \u03C4\u03B9\u03C2 \u03B5\u03C4\u03B9\u03BA\u03AD\u03C4\u03B5\u03C2 \u03C3\u03C4\u03B7 \u03BB\u03AF\u03C3\u03C4\u03B1",
  "Is not tagged with any of the tags in the list": "\u0394\u03B5\u03BD \u03B5\u03AF\u03BD\u03B1\u03B9 \u03B5\u03C0\u03B9\u03C3\u03B7\u03BC\u03B1\u03C3\u03BC\u03AD\u03BD\u03BF \u03BC\u03B5 \u03BA\u03B1\u03BC\u03AF\u03B1 \u03B1\u03C0\u03CC \u03C4\u03B9\u03C2 \u03B5\u03C4\u03B9\u03BA\u03AD\u03C4\u03B5\u03C2 \u03C3\u03C4\u03B7 \u03BB\u03AF\u03C3\u03C4\u03B1",
  "Is not tagged with at least one of the tags in the list": "\u0394\u03B5\u03BD \u03AD\u03C7\u03B5\u03B9 \u03B5\u03C0\u03B9\u03C3\u03B7\u03BC\u03B1\u03BD\u03B8\u03B5\u03AF \u03BC\u03B5 \u03C4\u03BF\u03C5\u03BB\u03AC\u03C7\u03B9\u03C3\u03C4\u03BF\u03BD \u03BC\u03AF\u03B1 \u03B1\u03C0\u03CC \u03C4\u03B9\u03C2 \u03B5\u03C4\u03B9\u03BA\u03AD\u03C4\u03B5\u03C2 \u03C3\u03C4\u03B7 \u03BB\u03AF\u03C3\u03C4\u03B1",
  "Is of a type from the list": "\u0395\u03AF\u03BD\u03B1\u03B9 \u03C4\u03CD\u03C0\u03BF\u03C5 \u03B1\u03C0\u03CC \u03C4\u03B7 \u03BB\u03AF\u03C3\u03C4\u03B1",
  "Is on": "\u0395\u03AF\u03BD\u03B1\u03B9 \u03C3\u03C4\u03B9\u03C2",
  "Is one of the countries from the list": "\u0395\u03AF\u03BD\u03B1\u03B9 \u03BC\u03AF\u03B1 \u03B1\u03C0\u03CC \u03C4\u03B9\u03C2 \u03C7\u03CE\u03C1\u03B5\u03C2 \u03C4\u03B7\u03C2 \u03BB\u03AF\u03C3\u03C4\u03B1\u03C2",
  "Is one of the customer segments from the list": "\u0395\u03AF\u03BD\u03B1\u03B9 \u03AD\u03BD\u03B1 \u03B1\u03C0\u03CC \u03C4\u03B1 \u03C4\u03BC\u03AE\u03BC\u03B1\u03C4\u03B1 \u03C0\u03B5\u03BB\u03B1\u03C4\u03CE\u03BD \u03B1\u03C0\u03CC \u03C4\u03B7 \u03BB\u03AF\u03C3\u03C4\u03B1",
  "Is one of the fulfillment statuses in the list": "\u0395\u03AF\u03BD\u03B1\u03B9 \u03BC\u03AF\u03B1 \u03B1\u03C0\u03CC \u03C4\u03B9\u03C2 \u03BA\u03B1\u03C4\u03B1\u03C3\u03C4\u03AC\u03C3\u03B5\u03B9\u03C2 \u03B5\u03BA\u03C0\u03BB\u03AE\u03C1\u03C9\u03C3\u03B7\u03C2 \u03C3\u03C4\u03B7 \u03BB\u03AF\u03C3\u03C4\u03B1",
  "Is one of the languages from the list": "\u0395\u03AF\u03BD\u03B1\u03B9 \u03BC\u03AF\u03B1 \u03B1\u03C0\u03CC \u03C4\u03B9\u03C2 \u03B3\u03BB\u03CE\u03C3\u03C3\u03B5\u03C2 \u03C4\u03B7\u03C2 \u03BB\u03AF\u03C3\u03C4\u03B1\u03C2",
  "Is one of the methods in the list": "\u0395\u03AF\u03BD\u03B1\u03B9 \u03BC\u03AF\u03B1 \u03B1\u03C0\u03CC \u03C4\u03B9\u03C2 \u03BC\u03B5\u03B8\u03CC\u03B4\u03BF\u03C5\u03C2 \u03C3\u03C4\u03B7 \u03BB\u03AF\u03C3\u03C4\u03B1",
  "Is one of the payment statuses in the list": "\u0395\u03AF\u03BD\u03B1\u03B9 \u03BC\u03AF\u03B1 \u03B1\u03C0\u03CC \u03C4\u03B9\u03C2 \u03BA\u03B1\u03C4\u03B1\u03C3\u03C4\u03AC\u03C3\u03B5\u03B9\u03C2 \u03C0\u03BB\u03B7\u03C1\u03C9\u03BC\u03AE\u03C2 \u03C3\u03C4\u03B7 \u03BB\u03AF\u03C3\u03C4\u03B1",
  "Is tagged with all the tags in the list": "\u0395\u03AF\u03BD\u03B1\u03B9 \u03B5\u03C0\u03B9\u03C3\u03B7\u03BC\u03B1\u03C3\u03BC\u03AD\u03BD\u03BF \u03BC\u03B5 \u03CC\u03BB\u03B5\u03C2 \u03C4\u03B9\u03C2 \u03B5\u03C4\u03B9\u03BA\u03AD\u03C4\u03B5\u03C2 \u03C3\u03C4\u03B7 \u03BB\u03AF\u03C3\u03C4\u03B1",
  "Is tagged with at least one of the tags in the list": "\u0395\u03AF\u03BD\u03B1\u03B9 \u03B5\u03C0\u03B9\u03C3\u03B7\u03BC\u03B1\u03C3\u03BC\u03AD\u03BD\u03BF \u03BC\u03B5 \u03C4\u03BF\u03C5\u03BB\u03AC\u03C7\u03B9\u03C3\u03C4\u03BF\u03BD \u03BC\u03AF\u03B1 \u03B1\u03C0\u03CC \u03C4\u03B9\u03C2 \u03B5\u03C4\u03B9\u03BA\u03AD\u03C4\u03B5\u03C2 \u03C3\u03C4\u03B7 \u03BB\u03AF\u03C3\u03C4\u03B1",
  "Item cost": "\u039A\u03CC\u03C3\u03C4\u03BF\u03C2 \u03B1\u03BD\u03C4\u03B9\u03BA\u03B5\u03B9\u03BC\u03AD\u03BD\u03BF\u03C5",
  Language: "\u0393\u03BB\u03CE\u03C3\u03C3\u03B1",
  "Less than": "\u039C\u03B9\u03BA\u03C1\u03CC\u03C4\u03B5\u03C1\u03BF \u03B1\u03C0\u03CC",
  "Less than or equals to": "\u039C\u03B9\u03BA\u03C1\u03CC\u03C4\u03B5\u03C1\u03BF \u03AE \u03AF\u03C3\u03BF \u03BC\u03B5",
  "Marketing consent": "\u03A3\u03C5\u03B3\u03BA\u03B1\u03C4\u03AC\u03B8\u03B5\u03C3\u03B7 \u03BC\u03AC\u03C1\u03BA\u03B5\u03C4\u03B9\u03BD\u03B3\u03BA",
  Minutes: "\u039B\u03B5\u03C0\u03C4\u03AC",
  Months: "\u039C\u03AE\u03BD\u03B5\u03C2",
  "Number of orders": "\u0391\u03C1\u03B9\u03B8\u03BC\u03CC\u03C2 \u03C0\u03B1\u03C1\u03B1\u03B3\u03B3\u03B5\u03BB\u03B9\u03CE\u03BD",
  "On all of the post purchase pages": "\u03A3\u03B5 \u03CC\u03BB\u03B5\u03C2 \u03C4\u03B9\u03C2 \u03C3\u03B5\u03BB\u03AF\u03B4\u03B5\u03C2 \u03BC\u03B5\u03C4\u03AC \u03C4\u03B7\u03BD \u03B1\u03B3\u03BF\u03C1\u03AC",
  "On one of the post purchase pages": "\u03A3\u03B5 \u03BC\u03AF\u03B1 \u03B1\u03C0\u03CC \u03C4\u03B9\u03C2 \u03C3\u03B5\u03BB\u03AF\u03B4\u03B5\u03C2 \u03BC\u03B5\u03C4\u03AC \u03C4\u03B7\u03BD \u03B1\u03B3\u03BF\u03C1\u03AC",
  "On the checkout": "\u03A3\u03C4\u03BF \u03C4\u03B1\u03BC\u03B5\u03AF\u03BF",
  "On the post purchase 1st page": "\u03A3\u03C4\u03B7\u03BD 1\u03B7 \u03C3\u03B5\u03BB\u03AF\u03B4\u03B1 \u03BC\u03B5\u03C4\u03AC \u03C4\u03B7\u03BD \u03B1\u03B3\u03BF\u03C1\u03AC",
  "On the post purchase 2nd page": "\u03A3\u03C4\u03B7 2\u03B7 \u03C3\u03B5\u03BB\u03AF\u03B4\u03B1 \u03BC\u03B5\u03C4\u03AC \u03C4\u03B7\u03BD \u03B1\u03B3\u03BF\u03C1\u03AC",
  "On the thank you page": "\u03A3\u03C4\u03B7 \u03C3\u03B5\u03BB\u03AF\u03B4\u03B1 \u03B5\u03C5\u03C7\u03B1\u03C1\u03B9\u03C3\u03C4\u03B9\u03CE\u03BD",
  "Order note": "\u03A3\u03B7\u03BC\u03B5\u03AF\u03C9\u03C3\u03B7 \u03C0\u03B1\u03C1\u03B1\u03B3\u03B3\u03B5\u03BB\u03AF\u03B1\u03C2",
  "Order tags": "\u0395\u03C4\u03B9\u03BA\u03AD\u03C4\u03B5\u03C2 \u03C0\u03B1\u03C1\u03B1\u03B3\u03B3\u03B5\u03BB\u03AF\u03B1\u03C2",
  "Passed X time ago": "\u03A0\u03AD\u03C1\u03B1\u03C3\u03B5 \u03C0\u03C1\u03B9\u03BD \u03B1\u03C0\u03CC X",
  "Payment method": "\u039C\u03AD\u03B8\u03BF\u03B4\u03BF\u03C2 \u03C0\u03BB\u03B7\u03C1\u03C9\u03BC\u03AE\u03C2",
  "please add cart or order value": "\u03C0\u03B1\u03C1\u03B1\u03BA\u03B1\u03BB\u03CE \u03C0\u03C1\u03BF\u03C3\u03B8\u03AD\u03C3\u03C4\u03B5 \u03B1\u03BE\u03AF\u03B1 \u03BA\u03B1\u03BB\u03B1\u03B8\u03B9\u03BF\u03CD \u03AE \u03C0\u03B1\u03C1\u03B1\u03B3\u03B3\u03B5\u03BB\u03AF\u03B1\u03C2",
  "please add customer email": "\u03C0\u03B1\u03C1\u03B1\u03BA\u03B1\u03BB\u03CE \u03C0\u03C1\u03BF\u03C3\u03B8\u03AD\u03C3\u03C4\u03B5 \u03C4\u03BF email \u03C4\u03BF\u03C5 \u03C0\u03B5\u03BB\u03AC\u03C4\u03B7",
  "please add customer number of orders": "\u03C0\u03B1\u03C1\u03B1\u03BA\u03B1\u03BB\u03CE \u03C0\u03C1\u03BF\u03C3\u03B8\u03AD\u03C3\u03C4\u03B5 \u03C4\u03BF\u03BD \u03B1\u03C1\u03B9\u03B8\u03BC\u03CC \u03C0\u03B1\u03C1\u03B1\u03B3\u03B3\u03B5\u03BB\u03B9\u03CE\u03BD \u03C4\u03BF\u03C5 \u03C0\u03B5\u03BB\u03AC\u03C4\u03B7",
  "please add discount code": "\u03C0\u03B1\u03C1\u03B1\u03BA\u03B1\u03BB\u03CE \u03C0\u03C1\u03BF\u03C3\u03B8\u03AD\u03C3\u03C4\u03B5 \u03B5\u03BA\u03C0\u03C4\u03C9\u03C4\u03B9\u03BA\u03CC \u03BA\u03C9\u03B4\u03B9\u03BA\u03CC",
  "please add item cost": "\u03C0\u03B1\u03C1\u03B1\u03BA\u03B1\u03BB\u03CE \u03C0\u03C1\u03BF\u03C3\u03B8\u03AD\u03C3\u03C4\u03B5 \u03BA\u03CC\u03C3\u03C4\u03BF\u03C2 \u03B1\u03BD\u03C4\u03B9\u03BA\u03B5\u03B9\u03BC\u03AD\u03BD\u03BF\u03C5",
  "please add number of orders": "\u03A0\u03B1\u03C1\u03B1\u03BA\u03B1\u03BB\u03CE \u03C0\u03C1\u03BF\u03C3\u03B8\u03AD\u03C3\u03C4\u03B5 \u03B1\u03C1\u03B9\u03B8\u03BC\u03CC \u03C0\u03B1\u03C1\u03B1\u03B3\u03B3\u03B5\u03BB\u03B9\u03CE\u03BD",
  "please add order note": "\u03C0\u03B1\u03C1\u03B1\u03BA\u03B1\u03BB\u03CE \u03C0\u03C1\u03BF\u03C3\u03B8\u03AD\u03C3\u03C4\u03B5 \u03C3\u03B7\u03BC\u03B5\u03AF\u03C9\u03C3\u03B7 \u03C0\u03B1\u03C1\u03B1\u03B3\u03B3\u03B5\u03BB\u03AF\u03B1\u03C2",
  "please add product price": "\u03A0\u03B1\u03C1\u03B1\u03BA\u03B1\u03BB\u03CE \u03C0\u03C1\u03BF\u03C3\u03B8\u03AD\u03C3\u03C4\u03B5 \u03C4\u03B9\u03BC\u03AE \u03C0\u03C1\u03BF\u03CA\u03CC\u03BD\u03C4\u03BF\u03C2",
  "please add product sku": "\u03C0\u03B1\u03C1\u03B1\u03BA\u03B1\u03BB\u03CE \u03C0\u03C1\u03BF\u03C3\u03B8\u03AD\u03C3\u03C4\u03B5 SKU \u03C0\u03C1\u03BF\u03CA\u03CC\u03BD\u03C4\u03BF\u03C2",
  "please add product title": "\u03C0\u03B1\u03C1\u03B1\u03BA\u03B1\u03BB\u03CE \u03C0\u03C1\u03BF\u03C3\u03B8\u03AD\u03C3\u03C4\u03B5 \u03C4\u03AF\u03C4\u03BB\u03BF \u03C0\u03C1\u03BF\u03CA\u03CC\u03BD\u03C4\u03BF\u03C2",
  "please add product variant name": "\u03C0\u03B1\u03C1\u03B1\u03BA\u03B1\u03BB\u03CE \u03C0\u03C1\u03BF\u03C3\u03B8\u03AD\u03C3\u03C4\u03B5 \u03CC\u03BD\u03BF\u03BC\u03B1 \u03C0\u03B1\u03C1\u03B1\u03BB\u03BB\u03B1\u03B3\u03AE\u03C2 \u03C0\u03C1\u03BF\u03CA\u03CC\u03BD\u03C4\u03BF\u03C2",
  "please add shipping value": "\u03C0\u03B1\u03C1\u03B1\u03BA\u03B1\u03BB\u03CE \u03C0\u03C1\u03BF\u03C3\u03B8\u03AD\u03C3\u03C4\u03B5 \u03B1\u03BE\u03AF\u03B1 \u03B1\u03C0\u03BF\u03C3\u03C4\u03BF\u03BB\u03AE\u03C2",
  "please add time since last order": "\u03A0\u03B1\u03C1\u03B1\u03BA\u03B1\u03BB\u03CE \u03C0\u03C1\u03BF\u03C3\u03B8\u03AD\u03C3\u03C4\u03B5 \u03C7\u03C1\u03CC\u03BD\u03BF \u03B1\u03C0\u03CC \u03C4\u03B7\u03BD \u03C4\u03B5\u03BB\u03B5\u03C5\u03C4\u03B1\u03AF\u03B1 \u03C0\u03B1\u03C1\u03B1\u03B3\u03B3\u03B5\u03BB\u03AF\u03B1",
  "please add total item count": "\u03A0\u03B1\u03C1\u03B1\u03BA\u03B1\u03BB\u03CE \u03C0\u03C1\u03BF\u03C3\u03B8\u03AD\u03C3\u03C4\u03B5 \u03C4\u03BF \u03C3\u03C5\u03BD\u03BF\u03BB\u03B9\u03BA\u03CC \u03B1\u03C1\u03B9\u03B8\u03BC\u03CC \u03B5\u03B9\u03B4\u03CE\u03BD",
  "please add value": "\u03C0\u03B1\u03C1\u03B1\u03BA\u03B1\u03BB\u03CE \u03C0\u03C1\u03BF\u03C3\u03B8\u03AD\u03C3\u03C4\u03B5 \u03B1\u03BE\u03AF\u03B1",
  "please select collections": "\u03C0\u03B1\u03C1\u03B1\u03BA\u03B1\u03BB\u03CE \u03B5\u03C0\u03B9\u03BB\u03AD\u03BE\u03C4\u03B5 \u03C3\u03C5\u03BB\u03BB\u03BF\u03B3\u03AD\u03C2",
  "please select customer birthday": "\u03A0\u03B1\u03C1\u03B1\u03BA\u03B1\u03BB\u03CE \u03B5\u03C0\u03B9\u03BB\u03AD\u03BE\u03C4\u03B5 \u03B3\u03B5\u03BD\u03AD\u03B8\u03BB\u03B9\u03B1 \u03C0\u03B5\u03BB\u03AC\u03C4\u03B7",
  "please select customer country": "\u03C0\u03B1\u03C1\u03B1\u03BA\u03B1\u03BB\u03CE \u03B5\u03C0\u03B9\u03BB\u03AD\u03BE\u03C4\u03B5 \u03C7\u03CE\u03C1\u03B1 \u03C0\u03B5\u03BB\u03AC\u03C4\u03B7",
  "please select customer language": "\u03C0\u03B1\u03C1\u03B1\u03BA\u03B1\u03BB\u03CE \u03B5\u03C0\u03B9\u03BB\u03AD\u03BE\u03C4\u03B5 \u03B3\u03BB\u03CE\u03C3\u03C3\u03B1 \u03C0\u03B5\u03BB\u03AC\u03C4\u03B7",
  "please select customer segments": "\u03C0\u03B1\u03C1\u03B1\u03BA\u03B1\u03BB\u03CE \u03B5\u03C0\u03B9\u03BB\u03AD\u03BE\u03C4\u03B5 \u03C4\u03BC\u03AE\u03BC\u03B1\u03C4\u03B1 \u03C0\u03B5\u03BB\u03B1\u03C4\u03CE\u03BD",
  "please select customer tag": "\u03C0\u03B1\u03C1\u03B1\u03BA\u03B1\u03BB\u03CE \u03B5\u03C0\u03B9\u03BB\u03AD\u03BE\u03C4\u03B5 \u03B5\u03C4\u03B9\u03BA\u03AD\u03C4\u03B1 \u03C0\u03B5\u03BB\u03AC\u03C4\u03B7",
  "please select customer tags": "\u03A0\u03B1\u03C1\u03B1\u03BA\u03B1\u03BB\u03CE \u03B5\u03C0\u03B9\u03BB\u03AD\u03BE\u03C4\u03B5 \u03B5\u03C4\u03B9\u03BA\u03AD\u03C4\u03B5\u03C2 \u03C0\u03B5\u03BB\u03B1\u03C4\u03CE\u03BD",
  "please select fulfillment statuses": "\u03C0\u03B1\u03C1\u03B1\u03BA\u03B1\u03BB\u03CE \u03B5\u03C0\u03B9\u03BB\u03AD\u03BE\u03C4\u03B5 \u03BA\u03B1\u03C4\u03B1\u03C3\u03C4\u03AC\u03C3\u03B5\u03B9\u03C2 \u03B5\u03BA\u03C0\u03BB\u03AE\u03C1\u03C9\u03C3\u03B7\u03C2",
  "please select offer": "\u03C0\u03B1\u03C1\u03B1\u03BA\u03B1\u03BB\u03CE \u03B5\u03C0\u03B9\u03BB\u03AD\u03BE\u03C4\u03B5 \u03C0\u03C1\u03BF\u03C3\u03C6\u03BF\u03C1\u03AC",
  "please select payment method": "\u03A0\u03B1\u03C1\u03B1\u03BA\u03B1\u03BB\u03CE \u03B5\u03C0\u03B9\u03BB\u03AD\u03BE\u03C4\u03B5 \u03BC\u03AD\u03B8\u03BF\u03B4\u03BF \u03C0\u03BB\u03B7\u03C1\u03C9\u03BC\u03AE\u03C2",
  "please select payment statuses": "\u03A0\u03B1\u03C1\u03B1\u03BA\u03B1\u03BB\u03CE \u03B5\u03C0\u03B9\u03BB\u03AD\u03BE\u03C4\u03B5 \u03BA\u03B1\u03C4\u03B1\u03C3\u03C4\u03AC\u03C3\u03B5\u03B9\u03C2 \u03C0\u03BB\u03B7\u03C1\u03C9\u03BC\u03AE\u03C2",
  "please select product type": "\u03A0\u03B1\u03C1\u03B1\u03BA\u03B1\u03BB\u03CE \u03B5\u03C0\u03B9\u03BB\u03AD\u03BE\u03C4\u03B5 \u03C4\u03CD\u03C0\u03BF \u03C0\u03C1\u03BF\u03CA\u03CC\u03BD\u03C4\u03BF\u03C2",
  "please select product vendor": "\u03A0\u03B1\u03C1\u03B1\u03BA\u03B1\u03BB\u03CE \u03B5\u03C0\u03B9\u03BB\u03AD\u03BE\u03C4\u03B5 \u03C0\u03C1\u03BF\u03BC\u03B7\u03B8\u03B5\u03C5\u03C4\u03AE \u03C0\u03C1\u03BF\u03CA\u03CC\u03BD\u03C4\u03BF\u03C2",
  "please select products": "\u03C0\u03B1\u03C1\u03B1\u03BA\u03B1\u03BB\u03CE \u03B5\u03C0\u03B9\u03BB\u03AD\u03BE\u03C4\u03B5 \u03C0\u03C1\u03BF\u03CA\u03CC\u03BD\u03C4\u03B1",
  "please select sales channel": "\u03C0\u03B1\u03C1\u03B1\u03BA\u03B1\u03BB\u03CE \u03B5\u03C0\u03B9\u03BB\u03AD\u03BE\u03C4\u03B5 \u03BA\u03B1\u03BD\u03AC\u03BB\u03B9 \u03C0\u03C9\u03BB\u03AE\u03C3\u03B5\u03C9\u03BD",
  "please select shipping methods": "\u03C0\u03B1\u03C1\u03B1\u03BA\u03B1\u03BB\u03CE \u03B5\u03C0\u03B9\u03BB\u03AD\u03BE\u03C4\u03B5 \u03BC\u03B5\u03B8\u03CC\u03B4\u03BF\u03C5\u03C2 \u03B1\u03C0\u03BF\u03C3\u03C4\u03BF\u03BB\u03AE\u03C2",
  "please select tags": "\u03C0\u03B1\u03C1\u03B1\u03BA\u03B1\u03BB\u03CE \u03B5\u03C0\u03B9\u03BB\u03AD\u03BE\u03C4\u03B5 \u03B5\u03C4\u03B9\u03BA\u03AD\u03C4\u03B5\u03C2",
  "Previous page offer": "\u03A0\u03C1\u03BF\u03C3\u03C6\u03BF\u03C1\u03AC \u03C0\u03C1\u03BF\u03B7\u03B3\u03BF\u03CD\u03BC\u03B5\u03BD\u03B7\u03C2 \u03C3\u03B5\u03BB\u03AF\u03B4\u03B1\u03C2",
  product: "\u03C0\u03C1\u03BF\u03CA\u03CC\u03BD",
  "Product recommendations": "\u03A0\u03C1\u03BF\u03C4\u03AC\u03C3\u03B5\u03B9\u03C2 \u03C0\u03C1\u03BF\u03CA\u03CC\u03BD\u03C4\u03C9\u03BD",
  "Product type": "\u03A4\u03CD\u03C0\u03BF\u03C2 \u03C0\u03C1\u03BF\u03CA\u03CC\u03BD\u03C4\u03BF\u03C2",
  "Product upsell": "Product upsell",
  products: "\u03C0\u03C1\u03BF\u03CA\u03CC\u03BD\u03C4\u03B1",
  "Requires shipping": "\u0391\u03C0\u03B1\u03B9\u03C4\u03B5\u03AF \u03B1\u03C0\u03BF\u03C3\u03C4\u03BF\u03BB\u03AE",
  "Shipping method": "\u039C\u03AD\u03B8\u03BF\u03B4\u03BF\u03C2 \u03B1\u03C0\u03BF\u03C3\u03C4\u03BF\u03BB\u03AE\u03C2",
  "Shipping value": "\u0391\u03BE\u03AF\u03B1 \u03B1\u03C0\u03BF\u03C3\u03C4\u03BF\u03BB\u03AE\u03C2",
  "Starts with": "\u039E\u03B5\u03BA\u03B9\u03BD\u03AC\u03B5\u03B9 \u03BC\u03B5",
  Status: "\u039A\u03B1\u03C4\u03AC\u03C3\u03C4\u03B1\u03C3\u03B7",
  "The displayed product": "\u03A4\u03BF \u03B5\u03BC\u03C6\u03B1\u03BD\u03B9\u03B6\u03CC\u03BC\u03B5\u03BD\u03BF \u03C0\u03C1\u03BF\u03CA\u03CC\u03BD",
  "The displayed product SKU": "\u03A4\u03BF SKU \u03C4\u03BF\u03C5 \u03B5\u03BC\u03C6\u03B1\u03BD\u03B9\u03B6\u03CC\u03BC\u03B5\u03BD\u03BF\u03C5 \u03C0\u03C1\u03BF\u03CA\u03CC\u03BD\u03C4\u03BF\u03C2",
  "The only product title in the cart": "\u039F \u03BC\u03BF\u03BD\u03B1\u03B4\u03B9\u03BA\u03CC\u03C2 \u03C4\u03AF\u03C4\u03BB\u03BF\u03C2 \u03C0\u03C1\u03BF\u03CA\u03CC\u03BD\u03C4\u03BF\u03C2 \u03C3\u03C4\u03BF \u03BA\u03B1\u03BB\u03AC\u03B8\u03B9",
  "The only SKU in the cart": "\u03A4\u03BF \u03BC\u03BF\u03BD\u03B1\u03B4\u03B9\u03BA\u03CC SKU \u03C3\u03C4\u03BF \u03BA\u03B1\u03BB\u03AC\u03B8\u03B9",
  "The SKU of all products in the cart": "\u03A4\u03BF SKU \u03CC\u03BB\u03C9\u03BD \u03C4\u03C9\u03BD \u03C0\u03C1\u03BF\u03CA\u03CC\u03BD\u03C4\u03C9\u03BD \u03C3\u03C4\u03BF \u03BA\u03B1\u03BB\u03AC\u03B8\u03B9",
  "The SKU of at least one product in the cart": "\u03A4\u03BF SKU \u03C4\u03BF\u03C5\u03BB\u03AC\u03C7\u03B9\u03C3\u03C4\u03BF\u03BD \u03B5\u03BD\u03CC\u03C2 \u03C0\u03C1\u03BF\u03CA\u03CC\u03BD\u03C4\u03BF\u03C2 \u03C3\u03C4\u03BF \u03BA\u03B1\u03BB\u03AC\u03B8\u03B9",
  "The title of all products in the cart": "\u039F \u03C4\u03AF\u03C4\u03BB\u03BF\u03C2 \u03CC\u03BB\u03C9\u03BD \u03C4\u03C9\u03BD \u03C0\u03C1\u03BF\u03CA\u03CC\u03BD\u03C4\u03C9\u03BD \u03C3\u03C4\u03BF \u03BA\u03B1\u03BB\u03AC\u03B8\u03B9",
  "The title of at least one product in the cart": "\u039F \u03C4\u03AF\u03C4\u03BB\u03BF\u03C2 \u03C4\u03BF\u03C5\u03BB\u03AC\u03C7\u03B9\u03C3\u03C4\u03BF\u03BD \u03B5\u03BD\u03CC\u03C2 \u03C0\u03C1\u03BF\u03CA\u03CC\u03BD\u03C4\u03BF\u03C2 \u03C3\u03C4\u03BF \u03BA\u03B1\u03BB\u03AC\u03B8\u03B9",
  "The title of the displayed product": "\u039F \u03C4\u03AF\u03C4\u03BB\u03BF\u03C2 \u03C4\u03BF\u03C5 \u03B5\u03BC\u03C6\u03B1\u03BD\u03B9\u03B6\u03CC\u03BC\u03B5\u03BD\u03BF\u03C5 \u03C0\u03C1\u03BF\u03CA\u03CC\u03BD\u03C4\u03BF\u03C2",
  "The variant of all products in the cart": "\u0397 \u03C0\u03B1\u03C1\u03B1\u03BB\u03BB\u03B1\u03B3\u03AE \u03CC\u03BB\u03C9\u03BD \u03C4\u03C9\u03BD \u03C0\u03C1\u03BF\u03CA\u03CC\u03BD\u03C4\u03C9\u03BD \u03C3\u03C4\u03BF \u03BA\u03B1\u03BB\u03AC\u03B8\u03B9",
  "The variant of at least one product in the cart": "\u0397 \u03C0\u03B1\u03C1\u03B1\u03BB\u03BB\u03B1\u03B3\u03AE \u03C4\u03BF\u03C5\u03BB\u03AC\u03C7\u03B9\u03C3\u03C4\u03BF\u03BD \u03B5\u03BD\u03CC\u03C2 \u03C0\u03C1\u03BF\u03CA\u03CC\u03BD\u03C4\u03BF\u03C2 \u03C3\u03C4\u03BF \u03BA\u03B1\u03BB\u03AC\u03B8\u03B9",
  "The variant of only product in the cart": "\u0397 \u03C0\u03B1\u03C1\u03B1\u03BB\u03BB\u03B1\u03B3\u03AE \u03C4\u03BF\u03C5 \u03BC\u03BF\u03BD\u03B1\u03B4\u03B9\u03BA\u03BF\u03CD \u03C0\u03C1\u03BF\u03CA\u03CC\u03BD\u03C4\u03BF\u03C2 \u03C3\u03C4\u03BF \u03BA\u03B1\u03BB\u03AC\u03B8\u03B9",
  "The variant of the displayed product": "\u0397 \u03C0\u03B1\u03C1\u03B1\u03BB\u03BB\u03B1\u03B3\u03AE \u03C4\u03BF\u03C5 \u03B5\u03BC\u03C6\u03B1\u03BD\u03B9\u03B6\u03CC\u03BC\u03B5\u03BD\u03BF\u03C5 \u03C0\u03C1\u03BF\u03CA\u03CC\u03BD\u03C4\u03BF\u03C2",
  "Total item count": "\u03A3\u03C5\u03BD\u03BF\u03BB\u03B9\u03BA\u03CC\u03C2 \u03B1\u03C1\u03B9\u03B8\u03BC\u03CC\u03C2 \u03B5\u03B9\u03B4\u03CE\u03BD",
  Weeks: "\u0395\u03B2\u03B4\u03BF\u03BC\u03AC\u03B4\u03B5\u03C2",
  Years: "\u0388\u03C4\u03B7"
};

// src/lang/ru.json
var ru_default = {
  "An offer was accepted": "\u041F\u0440\u0435\u0434\u043B\u043E\u0436\u0435\u043D\u0438\u0435 \u0431\u044B\u043B\u043E \u043F\u0440\u0438\u043D\u044F\u0442\u043E",
  "An offer was declined": "\u041F\u0440\u0435\u0434\u043B\u043E\u0436\u0435\u043D\u0438\u0435 \u0431\u044B\u043B\u043E \u043E\u0442\u043A\u043B\u043E\u043D\u0435\u043D\u043E",
  and: "\u0438",
  "Announcement bar": "\u041F\u0430\u043D\u0435\u043B\u044C \u043E\u0431\u044A\u044F\u0432\u043B\u0435\u043D\u0438\u0439",
  "Are available at all the sales channels from the list": "\u0414\u043E\u0441\u0442\u0443\u043F\u043D\u044B \u0432\u043E \u0432\u0441\u0435\u0445 \u043A\u0430\u043D\u0430\u043B\u0430\u0445 \u043F\u0440\u043E\u0434\u0430\u0436 \u0438\u0437 \u0441\u043F\u0438\u0441\u043A\u0430",
  "Are available at one of the sales channels from the list": "\u0414\u043E\u0441\u0442\u0443\u043F\u043D\u044B \u0432 \u043E\u0434\u043D\u043E\u043C \u0438\u0437 \u043A\u0430\u043D\u0430\u043B\u043E\u0432 \u043F\u0440\u043E\u0434\u0430\u0436 \u0438\u0437 \u0441\u043F\u0438\u0441\u043A\u0430",
  "Are not available at all the sales channels from the list": "\u041D\u0435\u0434\u043E\u0441\u0442\u0443\u043F\u043D\u044B \u0432\u043E \u0432\u0441\u0435\u0445 \u043A\u0430\u043D\u0430\u043B\u0430\u0445 \u043F\u0440\u043E\u0434\u0430\u0436 \u0438\u0437 \u0441\u043F\u0438\u0441\u043A\u0430",
  "Are not available at one of the sales channels from the list": "\u041D\u0435\u0434\u043E\u0441\u0442\u0443\u043F\u043D\u044B \u0432 \u043E\u0434\u043D\u043E\u043C \u0438\u0437 \u043A\u0430\u043D\u0430\u043B\u043E\u0432 \u043F\u0440\u043E\u0434\u0430\u0436 \u0438\u0437 \u0441\u043F\u0438\u0441\u043A\u0430",
  "At least one product in the cart": "\u0425\u043E\u0442\u044F \u0431\u044B \u043E\u0434\u0438\u043D \u0442\u043E\u0432\u0430\u0440 \u0432 \u043A\u043E\u0440\u0437\u0438\u043D\u0435",
  Banner: "\u0411\u0430\u043D\u043D\u0435\u0440",
  Between: "\u041C\u0435\u0436\u0434\u0443",
  Bundle: "\u041D\u0430\u0431\u043E\u0440",
  "Cart/Order value": "\u0421\u0442\u043E\u0438\u043C\u043E\u0441\u0442\u044C \u043A\u043E\u0440\u0437\u0438\u043D\u044B/\u0437\u0430\u043A\u0430\u0437\u0430",
  categories: "\u043A\u0430\u0442\u0435\u0433\u043E\u0440\u0438\u0438",
  category: "\u043A\u0430\u0442\u0435\u0433\u043E\u0440\u0438\u044F",
  collection: "\u043A\u043E\u043B\u043B\u0435\u043A\u0446\u0438\u044F",
  collections: "\u043A\u043E\u043B\u043B\u0435\u043A\u0446\u0438\u0438",
  Contains: "\u0421\u043E\u0434\u0435\u0440\u0436\u0438\u0442",
  "Customer accepted marketing": "\u041A\u043B\u0438\u0435\u043D\u0442 \u0441\u043E\u0433\u043B\u0430\u0441\u0438\u043B\u0441\u044F \u043D\u0430 \u043C\u0430\u0440\u043A\u0435\u0442\u0438\u043D\u0433",
  "Customer birthday": "\u0414\u0435\u043D\u044C \u0440\u043E\u0436\u0434\u0435\u043D\u0438\u044F \u043A\u043B\u0438\u0435\u043D\u0442\u0430",
  "Customer country": "\u0421\u0442\u0440\u0430\u043D\u0430 \u043A\u043B\u0438\u0435\u043D\u0442\u0430",
  "customer doesn't have all the tags from the list": "\u043A\u043B\u0438\u0435\u043D\u0442 \u043D\u0435 \u0438\u043C\u0435\u0435\u0442 \u0432\u0441\u0435\u0445 \u0442\u0435\u0433\u043E\u0432 \u0438\u0437 \u0441\u043F\u0438\u0441\u043A\u0430",
  "customer doesn't have any of the tags from the list": "\u043A\u043B\u0438\u0435\u043D\u0442 \u043D\u0435 \u0438\u043C\u0435\u0435\u0442 \u043D\u0438 \u043E\u0434\u043D\u043E\u0433\u043E \u0438\u0437 \u0442\u0435\u0433\u043E\u0432 \u0432 \u0441\u043F\u0438\u0441\u043A\u0435",
  "Customer don't accepted marketing": "\u041A\u043B\u0438\u0435\u043D\u0442 \u043D\u0435 \u0441\u043E\u0433\u043B\u0430\u0441\u0438\u043B\u0441\u044F \u043D\u0430 \u043C\u0430\u0440\u043A\u0435\u0442\u0438\u043D\u0433",
  "Customer email": "Email \u043A\u043B\u0438\u0435\u043D\u0442\u0430",
  "customer has all the tags from the list": "\u043A\u043B\u0438\u0435\u043D\u0442 \u0438\u043C\u0435\u0435\u0442 \u0432\u0441\u0435 \u0442\u0435\u0433\u0438 \u0438\u0437 \u0441\u043F\u0438\u0441\u043A\u0430",
  "customer has at least one of the tags from the list ": "\u043A\u043B\u0438\u0435\u043D\u0442 \u0438\u043C\u0435\u0435\u0442 \u0445\u043E\u0442\u044F \u0431\u044B \u043E\u0434\u0438\u043D \u0438\u0437 \u0442\u0435\u0433\u043E\u0432 \u0432 \u0441\u043F\u0438\u0441\u043A\u0435",
  "Customer number of orders": "\u041A\u043E\u043B\u0438\u0447\u0435\u0441\u0442\u0432\u043E \u0437\u0430\u043A\u0430\u0437\u043E\u0432 \u043A\u043B\u0438\u0435\u043D\u0442\u0430",
  "Customer segments": "\u0421\u0435\u0433\u043C\u0435\u043D\u0442\u044B \u043A\u043B\u0438\u0435\u043D\u0442\u043E\u0432",
  "Customer tag": "\u0422\u0435\u0433 \u043A\u043B\u0438\u0435\u043D\u0442\u0430",
  Days: "\u0414\u043D\u0438",
  "Discount code": "\u041F\u0440\u043E\u043C\u043E\u043A\u043E\u0434",
  "Does not require shipping": "\u041D\u0435 \u0442\u0440\u0435\u0431\u0443\u0435\u0442 \u0434\u043E\u0441\u0442\u0430\u0432\u043A\u0438",
  "Doesn't contain": "\u041D\u0435 \u0441\u043E\u0434\u0435\u0440\u0436\u0438\u0442",
  "Doesn't end with": "\u041D\u0435 \u0437\u0430\u043A\u0430\u043D\u0447\u0438\u0432\u0430\u0435\u0442\u0441\u044F \u043D\u0430",
  "Doesn't have all the tags from the list": "\u041D\u0435 \u0438\u043C\u0435\u0435\u0442 \u0432\u0441\u0435\u0445 \u0442\u0435\u0433\u043E\u0432 \u0438\u0437 \u0441\u043F\u0438\u0441\u043A\u0430",
  "Doesn't have some of the tags from the list": "\u041D\u0435 \u0438\u043C\u0435\u0435\u0442 \u043D\u0435\u043A\u043E\u0442\u043E\u0440\u044B\u0445 \u0442\u0435\u0433\u043E\u0432 \u0438\u0437 \u0441\u043F\u0438\u0441\u043A\u0430",
  "Doesn't start with": "\u041D\u0435 \u043D\u0430\u0447\u0438\u043D\u0430\u0435\u0442\u0441\u044F \u0441",
  "Ends with": "\u0417\u0430\u043A\u0430\u043D\u0447\u0438\u0432\u0430\u0435\u0442\u0441\u044F \u043D\u0430",
  "Equal to": "\u0420\u0430\u0432\u043D\u043E",
  Equals: "\u0420\u0430\u0432\u043D\u043E",
  "Every product in the cart": "\u041A\u0430\u0436\u0434\u044B\u0439 \u0442\u043E\u0432\u0430\u0440 \u0432 \u043A\u043E\u0440\u0437\u0438\u043D\u0435",
  "Greater than": "\u0411\u043E\u043B\u044C\u0448\u0435 \u0447\u0435\u043C",
  "Greater than or equals to": "\u0411\u043E\u043B\u044C\u0448\u0435 \u0438\u043B\u0438 \u0440\u0430\u0432\u043D\u043E",
  "Has all the tags from the list": "\u0418\u043C\u0435\u0435\u0442 \u0432\u0441\u0435 \u0442\u0435\u0433\u0438 \u0438\u0437 \u0441\u043F\u0438\u0441\u043A\u0430",
  "Has at least one of the tags from the list": "\u0418\u043C\u0435\u0435\u0442 \u0445\u043E\u0442\u044F \u0431\u044B \u043E\u0434\u0438\u043D \u0438\u0437 \u0442\u0435\u0433\u043E\u0432 \u0432 \u0441\u043F\u0438\u0441\u043A\u0435",
  Hours: "\u0427\u0430\u0441\u044B",
  "in less than": "\u043C\u0435\u043D\u0435\u0435 \u0447\u0435\u043C \u0447\u0435\u0440\u0435\u0437",
  "Is (exact code)": "\u0421\u043E\u0432\u043F\u0430\u0434\u0430\u0435\u0442 \u0441 (\u0442\u043E\u0447\u043D\u044B\u0439 \u043A\u043E\u0434)",
  "Is (exact email)": "\u0421\u043E\u0432\u043F\u0430\u0434\u0430\u0435\u0442 \u0441 (\u0442\u043E\u0447\u043D\u044B\u0439 email)",
  "Is (exact sku)": "\u0421\u043E\u0432\u043F\u0430\u0434\u0430\u0435\u0442 \u0441 (\u0442\u043E\u0447\u043D\u044B\u0439 \u0430\u0440\u0442\u0438\u043A\u0443\u043B)",
  "Is (exact title)": "\u0421\u043E\u0432\u043F\u0430\u0434\u0430\u0435\u0442 \u0441 (\u0442\u043E\u0447\u043D\u043E\u0435 \u043D\u0430\u0437\u0432\u0430\u043D\u0438\u0435)",
  "Is (exact variant name)": "\u0421\u043E\u0432\u043F\u0430\u0434\u0430\u0435\u0442 \u0441 (\u0442\u043E\u0447\u043D\u043E\u0435 \u043D\u0430\u0437\u0432\u0430\u043D\u0438\u0435 \u0432\u0430\u0440\u0438\u0430\u043D\u0442\u0430)",
  "Is after": "\u041F\u043E\u0437\u0434\u043D\u0435\u0435",
  "Is available at all the sales channels from the list": "\u0414\u043E\u0441\u0442\u0443\u043F\u0435\u043D \u0432\u043E \u0432\u0441\u0435\u0445 \u043A\u0430\u043D\u0430\u043B\u0430\u0445 \u043F\u0440\u043E\u0434\u0430\u0436 \u0438\u0437 \u0441\u043F\u0438\u0441\u043A\u0430",
  "Is available at all the sales channels in the list": "\u0414\u043E\u0441\u0442\u0443\u043F\u0435\u043D \u0432\u043E \u0432\u0441\u0435\u0445 \u043A\u0430\u043D\u0430\u043B\u0430\u0445 \u043F\u0440\u043E\u0434\u0430\u0436 \u0432 \u0441\u043F\u0438\u0441\u043A\u0435",
  "Is available at one of the sales channels from the list": "\u0414\u043E\u0441\u0442\u0443\u043F\u0435\u043D \u0432 \u043E\u0434\u043D\u043E\u043C \u0438\u0437 \u043A\u0430\u043D\u0430\u043B\u043E\u0432 \u043F\u0440\u043E\u0434\u0430\u0436 \u0438\u0437 \u0441\u043F\u0438\u0441\u043A\u0430",
  "Is available at one of the sales channels in the list": "\u0414\u043E\u0441\u0442\u0443\u043F\u0435\u043D \u0432 \u043E\u0434\u043D\u043E\u043C \u0438\u0437 \u043A\u0430\u043D\u0430\u043B\u043E\u0432 \u043F\u0440\u043E\u0434\u0430\u0436 \u0432 \u0441\u043F\u0438\u0441\u043A\u0435",
  "Is before": "\u0420\u0430\u043D\u0435\u0435",
  "Is between": "\u041C\u0435\u0436\u0434\u0443",
  "Is from a vendor in the list": "\u041E\u0442 \u043F\u043E\u0441\u0442\u0430\u0432\u0449\u0438\u043A\u0430 \u0438\u0437 \u0441\u043F\u0438\u0441\u043A\u0430",
  "Is from the list": "\u0418\u0437 \u0441\u043F\u0438\u0441\u043A\u0430",
  "Is greater than": "\u0411\u043E\u043B\u044C\u0448\u0435 \u0447\u0435\u043C",
  "Is greater than or equals to": "\u0411\u043E\u043B\u044C\u0448\u0435 \u0438\u043B\u0438 \u0440\u0430\u0432\u043D\u043E",
  "Is in a category from the list": "\u041D\u0430\u0445\u043E\u0434\u0438\u0442\u0441\u044F \u0432 \u043A\u0430\u0442\u0435\u0433\u043E\u0440\u0438\u0438 \u0438\u0437 \u0441\u043F\u0438\u0441\u043A\u0430",
  "Is in a collection from the list": "\u041D\u0430\u0445\u043E\u0434\u0438\u0442\u0441\u044F \u0432 \u043A\u043E\u043B\u043B\u0435\u043A\u0446\u0438\u0438 \u0438\u0437 \u0441\u043F\u0438\u0441\u043A\u0430",
  "Is less than": "\u041C\u0435\u043D\u044C\u0448\u0435 \u0447\u0435\u043C",
  "Is less than or equals to": "\u041C\u0435\u043D\u044C\u0448\u0435 \u0438\u043B\u0438 \u0440\u0430\u0432\u043D\u043E",
  "Is not (exact code)": "\u041D\u0435 \u0441\u043E\u0432\u043F\u0430\u0434\u0430\u0435\u0442 \u0441 (\u0442\u043E\u0447\u043D\u044B\u0439 \u043A\u043E\u0434)",
  "Is not (exact email)": "\u041D\u0435 \u0441\u043E\u0432\u043F\u0430\u0434\u0430\u0435\u0442 \u0441 (\u0442\u043E\u0447\u043D\u044B\u0439 email)",
  "Is not (exact sku)": "\u041D\u0435 \u0441\u043E\u0432\u043F\u0430\u0434\u0430\u0435\u0442 \u0441 (\u0442\u043E\u0447\u043D\u044B\u0439 \u0430\u0440\u0442\u0438\u043A\u0443\u043B)",
  "Is not (exact title)": "\u041D\u0435 \u0441\u043E\u0432\u043F\u0430\u0434\u0430\u0435\u0442 \u0441 (\u0442\u043E\u0447\u043D\u043E\u0435 \u043D\u0430\u0437\u0432\u0430\u043D\u0438\u0435)",
  "Is not (exact variant name)": "\u041D\u0435 \u0441\u043E\u0432\u043F\u0430\u0434\u0430\u0435\u0442 \u0441 (\u0442\u043E\u0447\u043D\u043E\u0435 \u043D\u0430\u0437\u0432\u0430\u043D\u0438\u0435 \u0432\u0430\u0440\u0438\u0430\u043D\u0442\u0430)",
  "Is not available at all the sales channels from the list": "\u041D\u0435\u0434\u043E\u0441\u0442\u0443\u043F\u0435\u043D \u0432\u043E \u0432\u0441\u0435\u0445 \u043A\u0430\u043D\u0430\u043B\u0430\u0445 \u043F\u0440\u043E\u0434\u0430\u0436 \u0438\u0437 \u0441\u043F\u0438\u0441\u043A\u0430",
  "Is not available at all the sales channels in the list": "\u041D\u0435\u0434\u043E\u0441\u0442\u0443\u043F\u0435\u043D \u0432\u043E \u0432\u0441\u0435\u0445 \u043A\u0430\u043D\u0430\u043B\u0430\u0445 \u043F\u0440\u043E\u0434\u0430\u0436 \u0432 \u0441\u043F\u0438\u0441\u043A\u0435",
  "Is not available at one of the sales channels from the list": "\u041D\u0435\u0434\u043E\u0441\u0442\u0443\u043F\u0435\u043D \u0432 \u043E\u0434\u043D\u043E\u043C \u0438\u0437 \u043A\u0430\u043D\u0430\u043B\u043E\u0432 \u043F\u0440\u043E\u0434\u0430\u0436 \u0438\u0437 \u0441\u043F\u0438\u0441\u043A\u0430",
  "Is not available at one of the sales channels in the list": "\u041D\u0435\u0434\u043E\u0441\u0442\u0443\u043F\u0435\u043D \u043D\u0438 \u0432 \u043E\u0434\u043D\u043E\u043C \u0438\u0437 \u043A\u0430\u043D\u0430\u043B\u043E\u0432 \u043F\u0440\u043E\u0434\u0430\u0436 \u0432 \u0441\u043F\u0438\u0441\u043A\u0435",
  "Is not between": "\u041D\u0435 \u043C\u0435\u0436\u0434\u0443",
  "Is not equal to": "\u041D\u0435 \u0440\u0430\u0432\u043D\u043E",
  "Is not from a vendor in the list": "\u041D\u0435 \u043E\u0442 \u043F\u043E\u0441\u0442\u0430\u0432\u0449\u0438\u043A\u0430 \u0438\u0437 \u0441\u043F\u0438\u0441\u043A\u0430",
  "Is not from the list": "\u041D\u0435 \u0438\u0437 \u0441\u043F\u0438\u0441\u043A\u0430",
  "Is not in a category from the list": "\u041D\u0435 \u043D\u0430\u0445\u043E\u0434\u0438\u0442\u0441\u044F \u0432 \u043A\u0430\u0442\u0435\u0433\u043E\u0440\u0438\u0438 \u0438\u0437 \u0441\u043F\u0438\u0441\u043A\u0430",
  "Is not in a collection from the list": "\u041D\u0435 \u043D\u0430\u0445\u043E\u0434\u0438\u0442\u0441\u044F \u0432 \u043A\u043E\u043B\u043B\u0435\u043A\u0446\u0438\u0438 \u0438\u0437 \u0441\u043F\u0438\u0441\u043A\u0430",
  "Is not of a type from the list": "\u0422\u0438\u043F \u043D\u0435 \u0438\u0437 \u0441\u043F\u0438\u0441\u043A\u0430",
  "Is not on": "\u041D\u0435 \u043D\u0430\u0441\u0442\u0443\u043F\u0430\u0435\u0442",
  "Is not one of the countries from the list": "\u041D\u0435 \u044F\u0432\u043B\u044F\u0435\u0442\u0441\u044F \u043E\u0434\u043D\u043E\u0439 \u0438\u0437 \u0441\u0442\u0440\u0430\u043D \u0432 \u0441\u043F\u0438\u0441\u043A\u0435",
  "Is not one of the customer segments from the list": "\u041D\u0435 \u044F\u0432\u043B\u044F\u0435\u0442\u0441\u044F \u043E\u0434\u043D\u0438\u043C \u0438\u0437 \u0441\u0435\u0433\u043C\u0435\u043D\u0442\u043E\u0432 \u043A\u043B\u0438\u0435\u043D\u0442\u043E\u0432 \u0432 \u0441\u043F\u0438\u0441\u043A\u0435",
  "Is not one of the fulfillment statuses in the list": "\u041D\u0435 \u044F\u0432\u043B\u044F\u0435\u0442\u0441\u044F \u043E\u0434\u043D\u0438\u043C \u0438\u0437 \u0441\u0442\u0430\u0442\u0443\u0441\u043E\u0432 \u0432\u044B\u043F\u043E\u043B\u043D\u0435\u043D\u0438\u044F \u0432 \u0441\u043F\u0438\u0441\u043A\u0435",
  "Is not one of the languages from the list": "\u041D\u0435 \u044F\u0432\u043B\u044F\u0435\u0442\u0441\u044F \u043E\u0434\u043D\u0438\u043C \u0438\u0437 \u044F\u0437\u044B\u043A\u043E\u0432 \u0432 \u0441\u043F\u0438\u0441\u043A\u0435",
  "Is not one of the methods in the list": "\u041D\u0435 \u044F\u0432\u043B\u044F\u0435\u0442\u0441\u044F \u043E\u0434\u043D\u0438\u043C \u0438\u0437 \u0441\u043F\u043E\u0441\u043E\u0431\u043E\u0432 \u0432 \u0441\u043F\u0438\u0441\u043A\u0435",
  "Is not one of the payment statuses in the list": "\u041D\u0435 \u044F\u0432\u043B\u044F\u0435\u0442\u0441\u044F \u043E\u0434\u043D\u0438\u043C \u0438\u0437 \u0441\u0442\u0430\u0442\u0443\u0441\u043E\u0432 \u043E\u043F\u043B\u0430\u0442\u044B \u0432 \u0441\u043F\u0438\u0441\u043A\u0435",
  "Is not tagged with all the tags in the list": "\u041D\u0435 \u043E\u0442\u043C\u0435\u0447\u0435\u043D \u0432\u0441\u0435\u043C\u0438 \u0442\u0435\u0433\u0430\u043C\u0438 \u0438\u0437 \u0441\u043F\u0438\u0441\u043A\u0430",
  "Is not tagged with any of the tags in the list": "\u041D\u0435 \u043F\u043E\u043C\u0435\u0447\u0435\u043D \u043D\u0438 \u043E\u0434\u043D\u0438\u043C \u0438\u0437 \u0442\u0435\u0433\u043E\u0432 \u0432 \u0441\u043F\u0438\u0441\u043A\u0435",
  "Is not tagged with at least one of the tags in the list": "\u041D\u0435 \u043E\u0442\u043C\u0435\u0447\u0435\u043D \u0445\u043E\u0442\u044F \u0431\u044B \u043E\u0434\u043D\u0438\u043C \u0442\u0435\u0433\u043E\u043C \u0438\u0437 \u0441\u043F\u0438\u0441\u043A\u0430",
  "Is of a type from the list": "\u0422\u0438\u043F \u0438\u0437 \u0441\u043F\u0438\u0441\u043A\u0430",
  "Is on": "\u041D\u0430\u0441\u0442\u0443\u043F\u0430\u0435\u0442",
  "Is one of the countries from the list": "\u041E\u0434\u043D\u0430 \u0438\u0437 \u0441\u0442\u0440\u0430\u043D \u0432 \u0441\u043F\u0438\u0441\u043A\u0435",
  "Is one of the customer segments from the list": "\u041E\u0434\u0438\u043D \u0438\u0437 \u0441\u0435\u0433\u043C\u0435\u043D\u0442\u043E\u0432 \u043A\u043B\u0438\u0435\u043D\u0442\u043E\u0432 \u0432 \u0441\u043F\u0438\u0441\u043A\u0435",
  "Is one of the fulfillment statuses in the list": "\u041E\u0434\u0438\u043D \u0438\u0437 \u0441\u0442\u0430\u0442\u0443\u0441\u043E\u0432 \u0432\u044B\u043F\u043E\u043B\u043D\u0435\u043D\u0438\u044F \u0432 \u0441\u043F\u0438\u0441\u043A\u0435",
  "Is one of the languages from the list": "\u041E\u0434\u0438\u043D \u0438\u0437 \u044F\u0437\u044B\u043A\u043E\u0432 \u0432 \u0441\u043F\u0438\u0441\u043A\u0435",
  "Is one of the methods in the list": "\u042F\u0432\u043B\u044F\u0435\u0442\u0441\u044F \u043E\u0434\u043D\u0438\u043C \u0438\u0437 \u0441\u043F\u043E\u0441\u043E\u0431\u043E\u0432 \u0432 \u0441\u043F\u0438\u0441\u043A\u0435",
  "Is one of the payment statuses in the list": "\u042F\u0432\u043B\u044F\u0435\u0442\u0441\u044F \u043E\u0434\u043D\u0438\u043C \u0438\u0437 \u0441\u0442\u0430\u0442\u0443\u0441\u043E\u0432 \u043E\u043F\u043B\u0430\u0442\u044B \u0432 \u0441\u043F\u0438\u0441\u043A\u0435",
  "Is tagged with all the tags in the list": "\u041F\u043E\u043C\u0435\u0447\u0435\u043D \u0432\u0441\u0435\u043C\u0438 \u0442\u0435\u0433\u0430\u043C\u0438 \u0432 \u0441\u043F\u0438\u0441\u043A\u0435",
  "Is tagged with at least one of the tags in the list": "\u041F\u043E\u043C\u0435\u0447\u0435\u043D \u0445\u043E\u0442\u044F \u0431\u044B \u043E\u0434\u043D\u0438\u043C \u0438\u0437 \u0442\u0435\u0433\u043E\u0432 \u0432 \u0441\u043F\u0438\u0441\u043A\u0435",
  "Item cost": "\u0421\u0442\u043E\u0438\u043C\u043E\u0441\u0442\u044C \u0442\u043E\u0432\u0430\u0440\u0430",
  Language: "\u042F\u0437\u044B\u043A",
  "Less than": "\u041C\u0435\u043D\u044C\u0448\u0435 \u0447\u0435\u043C",
  "Less than or equals to": "\u041C\u0435\u043D\u044C\u0448\u0435 \u0438\u043B\u0438 \u0440\u0430\u0432\u043D\u043E",
  "Marketing consent": "\u0421\u043E\u0433\u043B\u0430\u0441\u0438\u0435 \u043D\u0430 \u043C\u0430\u0440\u043A\u0435\u0442\u0438\u043D\u0433",
  Minutes: "\u041C\u0438\u043D\u0443\u0442\u044B",
  Months: "\u041C\u0435\u0441\u044F\u0446\u044B",
  "Number of orders": "\u041A\u043E\u043B\u0438\u0447\u0435\u0441\u0442\u0432\u043E \u0437\u0430\u043A\u0430\u0437\u043E\u0432",
  "On all of the post purchase pages": "\u041D\u0430 \u0432\u0441\u0435\u0445 \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u0430\u0445 \u043F\u043E\u0441\u043B\u0435 \u043F\u043E\u043A\u0443\u043F\u043A\u0438",
  "On one of the post purchase pages": "\u041D\u0430 \u043E\u0434\u043D\u043E\u0439 \u0438\u0437 \u0441\u0442\u0440\u0430\u043D\u0438\u0446 \u043F\u043E\u0441\u043B\u0435 \u043F\u043E\u043A\u0443\u043F\u043A\u0438",
  "On the checkout": "\u041D\u0430 \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u0435 \u043E\u0444\u043E\u0440\u043C\u043B\u0435\u043D\u0438\u044F \u0437\u0430\u043A\u0430\u0437\u0430",
  "On the post purchase 1st page": "\u041D\u0430 1-\u0439 \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u0435 \u043F\u043E\u0441\u043B\u0435 \u043F\u043E\u043A\u0443\u043F\u043A\u0438",
  "On the post purchase 2nd page": "\u041D\u0430 2-\u0439 \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u0435 \u043F\u043E\u0441\u043B\u0435 \u043F\u043E\u043A\u0443\u043F\u043A\u0438",
  "On the thank you page": "\u041D\u0430 \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u0435 \u0431\u043B\u0430\u0433\u043E\u0434\u0430\u0440\u043D\u043E\u0441\u0442\u0438",
  "Order note": "\u041F\u0440\u0438\u043C\u0435\u0447\u0430\u043D\u0438\u0435 \u043A \u0437\u0430\u043A\u0430\u0437\u0443",
  "Order tags": "\u0422\u0435\u0433\u0438 \u0437\u0430\u043A\u0430\u0437\u0430",
  "Passed X time ago": "\u041F\u0440\u043E\u0448\u043B\u043E X \u043D\u0430\u0437\u0430\u0434",
  "Payment method": "\u0421\u043F\u043E\u0441\u043E\u0431 \u043E\u043F\u043B\u0430\u0442\u044B",
  "please add cart or order value": "\u043F\u043E\u0436\u0430\u043B\u0443\u0439\u0441\u0442\u0430, \u0434\u043E\u0431\u0430\u0432\u044C\u0442\u0435 \u0441\u0442\u043E\u0438\u043C\u043E\u0441\u0442\u044C \u043A\u043E\u0440\u0437\u0438\u043D\u044B \u0438\u043B\u0438 \u0437\u0430\u043A\u0430\u0437\u0430",
  "please add customer email": "\u043F\u043E\u0436\u0430\u043B\u0443\u0439\u0441\u0442\u0430, \u0434\u043E\u0431\u0430\u0432\u044C\u0442\u0435 email \u043A\u043B\u0438\u0435\u043D\u0442\u0430",
  "please add customer number of orders": "\u043F\u043E\u0436\u0430\u043B\u0443\u0439\u0441\u0442\u0430, \u0434\u043E\u0431\u0430\u0432\u044C\u0442\u0435 \u043A\u043E\u043B\u0438\u0447\u0435\u0441\u0442\u0432\u043E \u0437\u0430\u043A\u0430\u0437\u043E\u0432 \u043A\u043B\u0438\u0435\u043D\u0442\u0430",
  "please add discount code": "\u043F\u043E\u0436\u0430\u043B\u0443\u0439\u0441\u0442\u0430, \u0434\u043E\u0431\u0430\u0432\u044C\u0442\u0435 \u043F\u0440\u043E\u043C\u043E\u043A\u043E\u0434",
  "please add item cost": "\u041F\u043E\u0436\u0430\u043B\u0443\u0439\u0441\u0442\u0430, \u0434\u043E\u0431\u0430\u0432\u044C\u0442\u0435 \u0441\u0442\u043E\u0438\u043C\u043E\u0441\u0442\u044C \u0442\u043E\u0432\u0430\u0440\u0430",
  "please add number of orders": "\u041F\u043E\u0436\u0430\u043B\u0443\u0439\u0441\u0442\u0430, \u0434\u043E\u0431\u0430\u0432\u044C\u0442\u0435 \u043A\u043E\u043B\u0438\u0447\u0435\u0441\u0442\u0432\u043E \u0437\u0430\u043A\u0430\u0437\u043E\u0432",
  "please add order note": "\u043F\u043E\u0436\u0430\u043B\u0443\u0439\u0441\u0442\u0430, \u0434\u043E\u0431\u0430\u0432\u044C\u0442\u0435 \u043F\u0440\u0438\u043C\u0435\u0447\u0430\u043D\u0438\u0435 \u043A \u0437\u0430\u043A\u0430\u0437\u0443",
  "please add product price": "\u041F\u043E\u0436\u0430\u043B\u0443\u0439\u0441\u0442\u0430, \u0434\u043E\u0431\u0430\u0432\u044C\u0442\u0435 \u0446\u0435\u043D\u0443 \u0442\u043E\u0432\u0430\u0440\u0430",
  "please add product sku": "\u043F\u043E\u0436\u0430\u043B\u0443\u0439\u0441\u0442\u0430, \u0434\u043E\u0431\u0430\u0432\u044C\u0442\u0435 \u0430\u0440\u0442\u0438\u043A\u0443\u043B \u0442\u043E\u0432\u0430\u0440\u0430",
  "please add product title": "\u043F\u043E\u0436\u0430\u043B\u0443\u0439\u0441\u0442\u0430, \u0434\u043E\u0431\u0430\u0432\u044C\u0442\u0435 \u043D\u0430\u0437\u0432\u0430\u043D\u0438\u0435 \u0442\u043E\u0432\u0430\u0440\u0430",
  "please add product variant name": "\u043F\u043E\u0436\u0430\u043B\u0443\u0439\u0441\u0442\u0430, \u0434\u043E\u0431\u0430\u0432\u044C\u0442\u0435 \u043D\u0430\u0437\u0432\u0430\u043D\u0438\u0435 \u0432\u0430\u0440\u0438\u0430\u043D\u0442\u0430 \u0442\u043E\u0432\u0430\u0440\u0430",
  "please add shipping value": "\u043F\u043E\u0436\u0430\u043B\u0443\u0439\u0441\u0442\u0430, \u0434\u043E\u0431\u0430\u0432\u044C\u0442\u0435 \u0441\u0442\u043E\u0438\u043C\u043E\u0441\u0442\u044C \u0434\u043E\u0441\u0442\u0430\u0432\u043A\u0438",
  "please add time since last order": "\u041F\u043E\u0436\u0430\u043B\u0443\u0439\u0441\u0442\u0430, \u0443\u043A\u0430\u0436\u0438\u0442\u0435 \u0432\u0440\u0435\u043C\u044F \u0441 \u043C\u043E\u043C\u0435\u043D\u0442\u0430 \u043F\u043E\u0441\u043B\u0435\u0434\u043D\u0435\u0433\u043E \u0437\u0430\u043A\u0430\u0437\u0430",
  "please add total item count": "\u041F\u043E\u0436\u0430\u043B\u0443\u0439\u0441\u0442\u0430, \u0434\u043E\u0431\u0430\u0432\u044C\u0442\u0435 \u043E\u0431\u0449\u0435\u0435 \u043A\u043E\u043B\u0438\u0447\u0435\u0441\u0442\u0432\u043E \u0442\u043E\u0432\u0430\u0440\u043E\u0432",
  "please add value": "\u043F\u043E\u0436\u0430\u043B\u0443\u0439\u0441\u0442\u0430, \u0434\u043E\u0431\u0430\u0432\u044C\u0442\u0435 \u0437\u043D\u0430\u0447\u0435\u043D\u0438\u0435",
  "please select collections": "\u043F\u043E\u0436\u0430\u043B\u0443\u0439\u0441\u0442\u0430, \u0432\u044B\u0431\u0435\u0440\u0438\u0442\u0435 \u043A\u043E\u043B\u043B\u0435\u043A\u0446\u0438\u0438",
  "please select customer birthday": "\u041F\u043E\u0436\u0430\u043B\u0443\u0439\u0441\u0442\u0430, \u0432\u044B\u0431\u0435\u0440\u0438\u0442\u0435 \u0434\u0435\u043D\u044C \u0440\u043E\u0436\u0434\u0435\u043D\u0438\u044F \u043A\u043B\u0438\u0435\u043D\u0442\u0430",
  "please select customer country": "\u043F\u043E\u0436\u0430\u043B\u0443\u0439\u0441\u0442\u0430, \u0432\u044B\u0431\u0435\u0440\u0438\u0442\u0435 \u0441\u0442\u0440\u0430\u043D\u0443 \u043A\u043B\u0438\u0435\u043D\u0442\u0430",
  "please select customer language": "\u043F\u043E\u0436\u0430\u043B\u0443\u0439\u0441\u0442\u0430, \u0432\u044B\u0431\u0435\u0440\u0438\u0442\u0435 \u044F\u0437\u044B\u043A \u043A\u043B\u0438\u0435\u043D\u0442\u0430",
  "please select customer segments": "\u043F\u043E\u0436\u0430\u043B\u0443\u0439\u0441\u0442\u0430, \u0432\u044B\u0431\u0435\u0440\u0438\u0442\u0435 \u0441\u0435\u0433\u043C\u0435\u043D\u0442\u044B \u043A\u043B\u0438\u0435\u043D\u0442\u043E\u0432",
  "please select customer tag": "\u043F\u043E\u0436\u0430\u043B\u0443\u0439\u0441\u0442\u0430, \u0432\u044B\u0431\u0435\u0440\u0438\u0442\u0435 \u0442\u0435\u0433 \u043A\u043B\u0438\u0435\u043D\u0442\u0430",
  "please select customer tags": "\u041F\u043E\u0436\u0430\u043B\u0443\u0439\u0441\u0442\u0430, \u0432\u044B\u0431\u0435\u0440\u0438\u0442\u0435 \u0442\u0435\u0433\u0438 \u043A\u043B\u0438\u0435\u043D\u0442\u043E\u0432",
  "please select fulfillment statuses": "\u043F\u043E\u0436\u0430\u043B\u0443\u0439\u0441\u0442\u0430, \u0432\u044B\u0431\u0435\u0440\u0438\u0442\u0435 \u0441\u0442\u0430\u0442\u0443\u0441\u044B \u0432\u044B\u043F\u043E\u043B\u043D\u0435\u043D\u0438\u044F",
  "please select offer": "\u043F\u043E\u0436\u0430\u043B\u0443\u0439\u0441\u0442\u0430, \u0432\u044B\u0431\u0435\u0440\u0438\u0442\u0435 \u043F\u0440\u0435\u0434\u043B\u043E\u0436\u0435\u043D\u0438\u0435",
  "please select payment method": "\u041F\u043E\u0436\u0430\u043B\u0443\u0439\u0441\u0442\u0430, \u0432\u044B\u0431\u0435\u0440\u0438\u0442\u0435 \u0441\u043F\u043E\u0441\u043E\u0431 \u043E\u043F\u043B\u0430\u0442\u044B",
  "please select payment statuses": "\u041F\u043E\u0436\u0430\u043B\u0443\u0439\u0441\u0442\u0430, \u0432\u044B\u0431\u0435\u0440\u0438\u0442\u0435 \u0441\u0442\u0430\u0442\u0443\u0441\u044B \u043E\u043F\u043B\u0430\u0442\u044B",
  "please select product type": "\u041F\u043E\u0436\u0430\u043B\u0443\u0439\u0441\u0442\u0430, \u0432\u044B\u0431\u0435\u0440\u0438\u0442\u0435 \u0442\u0438\u043F \u0442\u043E\u0432\u0430\u0440\u0430",
  "please select product vendor": "\u041F\u043E\u0436\u0430\u043B\u0443\u0439\u0441\u0442\u0430, \u0432\u044B\u0431\u0435\u0440\u0438\u0442\u0435 \u043F\u043E\u0441\u0442\u0430\u0432\u0449\u0438\u043A\u0430 \u0442\u043E\u0432\u0430\u0440\u0430",
  "please select products": "\u043F\u043E\u0436\u0430\u043B\u0443\u0439\u0441\u0442\u0430, \u0432\u044B\u0431\u0435\u0440\u0438\u0442\u0435 \u0442\u043E\u0432\u0430\u0440\u044B",
  "please select sales channel": "\u043F\u043E\u0436\u0430\u043B\u0443\u0439\u0441\u0442\u0430, \u0432\u044B\u0431\u0435\u0440\u0438\u0442\u0435 \u043A\u0430\u043D\u0430\u043B \u043F\u0440\u043E\u0434\u0430\u0436",
  "please select shipping methods": "\u043F\u043E\u0436\u0430\u043B\u0443\u0439\u0441\u0442\u0430, \u0432\u044B\u0431\u0435\u0440\u0438\u0442\u0435 \u0441\u043F\u043E\u0441\u043E\u0431\u044B \u0434\u043E\u0441\u0442\u0430\u0432\u043A\u0438",
  "please select tags": "\u043F\u043E\u0436\u0430\u043B\u0443\u0439\u0441\u0442\u0430, \u0432\u044B\u0431\u0435\u0440\u0438\u0442\u0435 \u0442\u0435\u0433\u0438",
  "Previous page offer": "\u041F\u0440\u0435\u0434\u043B\u043E\u0436\u0435\u043D\u0438\u0435 \u0441 \u043F\u0440\u0435\u0434\u044B\u0434\u0443\u0449\u0435\u0439 \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u044B",
  product: "\u0442\u043E\u0432\u0430\u0440",
  "Product recommendations": "\u0420\u0435\u043A\u043E\u043C\u0435\u043D\u0434\u0430\u0446\u0438\u0438 \u0442\u043E\u0432\u0430\u0440\u043E\u0432",
  "Product type": "\u0422\u0438\u043F \u0442\u043E\u0432\u0430\u0440\u0430",
  "Product upsell": "\u0410\u043F\u0441\u0435\u043B\u043B \u0442\u043E\u0432\u0430\u0440\u0430",
  products: "\u0442\u043E\u0432\u0430\u0440\u044B",
  "Requires shipping": "\u0422\u0440\u0435\u0431\u0443\u0435\u0442 \u0434\u043E\u0441\u0442\u0430\u0432\u043A\u0438",
  "Shipping method": "\u0421\u043F\u043E\u0441\u043E\u0431 \u0434\u043E\u0441\u0442\u0430\u0432\u043A\u0438",
  "Shipping value": "\u0421\u0442\u043E\u0438\u043C\u043E\u0441\u0442\u044C \u0434\u043E\u0441\u0442\u0430\u0432\u043A\u0438",
  "Starts with": "\u041D\u0430\u0447\u0438\u043D\u0430\u0435\u0442\u0441\u044F \u0441",
  Status: "\u0421\u0442\u0430\u0442\u0443\u0441",
  "The displayed product": "\u041E\u0442\u043E\u0431\u0440\u0430\u0436\u0430\u0435\u043C\u044B\u0439 \u0442\u043E\u0432\u0430\u0440",
  "The displayed product SKU": "\u0410\u0440\u0442\u0438\u043A\u0443\u043B \u043E\u0442\u043E\u0431\u0440\u0430\u0436\u0430\u0435\u043C\u043E\u0433\u043E \u0442\u043E\u0432\u0430\u0440\u0430",
  "The only product title in the cart": "\u0415\u0434\u0438\u043D\u0441\u0442\u0432\u0435\u043D\u043D\u043E\u0435 \u043D\u0430\u0437\u0432\u0430\u043D\u0438\u0435 \u0442\u043E\u0432\u0430\u0440\u0430 \u0432 \u043A\u043E\u0440\u0437\u0438\u043D\u0435",
  "The only SKU in the cart": "\u0415\u0434\u0438\u043D\u0441\u0442\u0432\u0435\u043D\u043D\u044B\u0439 \u0430\u0440\u0442\u0438\u043A\u0443\u043B \u0432 \u043A\u043E\u0440\u0437\u0438\u043D\u0435",
  "The SKU of all products in the cart": "\u0410\u0440\u0442\u0438\u043A\u0443\u043B\u044B \u0432\u0441\u0435\u0445 \u0442\u043E\u0432\u0430\u0440\u043E\u0432 \u0432 \u043A\u043E\u0440\u0437\u0438\u043D\u0435",
  "The SKU of at least one product in the cart": "\u0410\u0440\u0442\u0438\u043A\u0443\u043B \u0445\u043E\u0442\u044F \u0431\u044B \u043E\u0434\u043D\u043E\u0433\u043E \u0442\u043E\u0432\u0430\u0440\u0430 \u0432 \u043A\u043E\u0440\u0437\u0438\u043D\u0435",
  "The title of all products in the cart": "\u041D\u0430\u0437\u0432\u0430\u043D\u0438\u044F \u0432\u0441\u0435\u0445 \u0442\u043E\u0432\u0430\u0440\u043E\u0432 \u0432 \u043A\u043E\u0440\u0437\u0438\u043D\u0435",
  "The title of at least one product in the cart": "\u041D\u0430\u0437\u0432\u0430\u043D\u0438\u0435 \u0445\u043E\u0442\u044F \u0431\u044B \u043E\u0434\u043D\u043E\u0433\u043E \u0442\u043E\u0432\u0430\u0440\u0430 \u0432 \u043A\u043E\u0440\u0437\u0438\u043D\u0435",
  "The title of the displayed product": "\u041D\u0430\u0437\u0432\u0430\u043D\u0438\u0435 \u043E\u0442\u043E\u0431\u0440\u0430\u0436\u0430\u0435\u043C\u043E\u0433\u043E \u0442\u043E\u0432\u0430\u0440\u0430",
  "The variant of all products in the cart": "\u0412\u0430\u0440\u0438\u0430\u043D\u0442\u044B \u0432\u0441\u0435\u0445 \u0442\u043E\u0432\u0430\u0440\u043E\u0432 \u0432 \u043A\u043E\u0440\u0437\u0438\u043D\u0435",
  "The variant of at least one product in the cart": "\u0412\u0430\u0440\u0438\u0430\u043D\u0442 \u0445\u043E\u0442\u044F \u0431\u044B \u043E\u0434\u043D\u043E\u0433\u043E \u0442\u043E\u0432\u0430\u0440\u0430 \u0432 \u043A\u043E\u0440\u0437\u0438\u043D\u0435",
  "The variant of only product in the cart": "\u0412\u0430\u0440\u0438\u0430\u043D\u0442 \u0435\u0434\u0438\u043D\u0441\u0442\u0432\u0435\u043D\u043D\u043E\u0433\u043E \u0442\u043E\u0432\u0430\u0440\u0430 \u0432 \u043A\u043E\u0440\u0437\u0438\u043D\u0435",
  "The variant of the displayed product": "\u0412\u0430\u0440\u0438\u0430\u043D\u0442 \u043E\u0442\u043E\u0431\u0440\u0430\u0436\u0430\u0435\u043C\u043E\u0433\u043E \u0442\u043E\u0432\u0430\u0440\u0430",
  "Total item count": "\u041E\u0431\u0449\u0435\u0435 \u043A\u043E\u043B\u0438\u0447\u0435\u0441\u0442\u0432\u043E \u0442\u043E\u0432\u0430\u0440\u043E\u0432",
  Weeks: "\u041D\u0435\u0434\u0435\u043B\u0438",
  Years: "\u0413\u043E\u0434\u044B"
};

// src/lang/bg.json
var bg_default = {
  "An offer was accepted": "\u041E\u0444\u0435\u0440\u0442\u0430\u0442\u0430 \u0431\u0435\u0448\u0435 \u043F\u0440\u0438\u0435\u0442\u0430",
  "An offer was declined": "\u041E\u0444\u0435\u0440\u0442\u0430\u0442\u0430 \u0431\u0435\u0448\u0435 \u043E\u0442\u043A\u0430\u0437\u0430\u043D\u0430",
  and: "\u0438",
  "Announcement bar": "\u041B\u0435\u043D\u0442\u0430 \u0437\u0430 \u0441\u044A\u043E\u0431\u0449\u0435\u043D\u0438\u044F",
  "Are available at all the sales channels from the list": "\u041D\u0430\u043B\u0438\u0447\u043D\u0438 \u0441\u0430 \u0432\u044A\u0432 \u0432\u0441\u0438\u0447\u043A\u0438 \u043A\u0430\u043D\u0430\u043B\u0438 \u0437\u0430 \u043F\u0440\u043E\u0434\u0430\u0436\u0431\u0430 \u0432 \u0441\u043F\u0438\u0441\u044A\u043A\u0430",
  "Are available at one of the sales channels from the list": "\u041D\u0430\u043B\u0438\u0447\u043D\u0438 \u0441\u0430 \u0432 \u0435\u0434\u0438\u043D \u043E\u0442 \u043A\u0430\u043D\u0430\u043B\u0438\u0442\u0435 \u0437\u0430 \u043F\u0440\u043E\u0434\u0430\u0436\u0431\u0430 \u0432 \u0441\u043F\u0438\u0441\u044A\u043A\u0430",
  "Are not available at all the sales channels from the list": "\u041D\u0435 \u0441\u0430 \u043D\u0430\u043B\u0438\u0447\u043D\u0438 \u0432\u044A\u0432 \u0432\u0441\u0438\u0447\u043A\u0438 \u043A\u0430\u043D\u0430\u043B\u0438 \u0437\u0430 \u043F\u0440\u043E\u0434\u0430\u0436\u0431\u0430 \u0432 \u0441\u043F\u0438\u0441\u044A\u043A\u0430",
  "Are not available at one of the sales channels from the list": "\u041D\u0435 \u0441\u0430 \u043D\u0430\u043B\u0438\u0447\u043D\u0438 \u0432 \u0435\u0434\u0438\u043D \u043E\u0442 \u043A\u0430\u043D\u0430\u043B\u0438\u0442\u0435 \u0437\u0430 \u043F\u0440\u043E\u0434\u0430\u0436\u0431\u0430 \u0432 \u0441\u043F\u0438\u0441\u044A\u043A\u0430",
  "At least one product in the cart": "\u041F\u043E\u043D\u0435 \u0435\u0434\u0438\u043D \u043F\u0440\u043E\u0434\u0443\u043A\u0442 \u0432 \u043A\u043E\u043B\u0438\u0447\u043A\u0430\u0442\u0430",
  Banner: "\u0411\u0430\u043D\u0435\u0440",
  Between: "\u041C\u0435\u0436\u0434\u0443",
  Bundle: "\u041F\u0430\u043A\u0435\u0442",
  "Cart/Order value": "\u0421\u0442\u043E\u0439\u043D\u043E\u0441\u0442 \u043D\u0430 \u043A\u043E\u043B\u0438\u0447\u043A\u0430\u0442\u0430/\u043F\u043E\u0440\u044A\u0447\u043A\u0430\u0442\u0430",
  categories: "\u043A\u0430\u0442\u0435\u0433\u043E\u0440\u0438\u0438",
  category: "\u043A\u0430\u0442\u0435\u0433\u043E\u0440\u0438\u044F",
  collection: "\u043A\u043E\u043B\u0435\u043A\u0446\u0438\u044F",
  collections: "\u043A\u043E\u043B\u0435\u043A\u0446\u0438\u0438",
  Contains: "\u0421\u044A\u0434\u044A\u0440\u0436\u0430",
  "Customer accepted marketing": "\u041A\u043B\u0438\u0435\u043D\u0442\u044A\u0442 \u043F\u0440\u0438\u0435 \u043C\u0430\u0440\u043A\u0435\u0442\u0438\u043D\u0433\u0430",
  "Customer birthday": "\u0420\u043E\u0436\u0434\u0435\u043D \u0434\u0435\u043D \u043D\u0430 \u043A\u043B\u0438\u0435\u043D\u0442\u0430",
  "Customer country": "\u0414\u044A\u0440\u0436\u0430\u0432\u0430 \u043D\u0430 \u043A\u043B\u0438\u0435\u043D\u0442\u0430",
  "customer doesn't have all the tags from the list": "\u043A\u043B\u0438\u0435\u043D\u0442\u044A\u0442 \u043D\u044F\u043C\u0430 \u0432\u0441\u0438\u0447\u043A\u0438 \u0442\u0430\u0433\u043E\u0432\u0435 \u043E\u0442 \u0441\u043F\u0438\u0441\u044A\u043A\u0430",
  "customer doesn't have any of the tags from the list": "\u043A\u043B\u0438\u0435\u043D\u0442\u044A\u0442 \u043D\u044F\u043C\u0430 \u043D\u0438\u0442\u043E \u0435\u0434\u0438\u043D \u043E\u0442 \u0442\u0430\u0433\u043E\u0432\u0435\u0442\u0435 \u0432 \u0441\u043F\u0438\u0441\u044A\u043A\u0430",
  "Customer don't accepted marketing": "\u041A\u043B\u0438\u0435\u043D\u0442\u044A\u0442 \u043D\u0435 \u043F\u0440\u0438\u0435 \u043C\u0430\u0440\u043A\u0435\u0442\u0438\u043D\u0433\u0430",
  "Customer email": "\u0418\u043C\u0435\u0439\u043B \u043D\u0430 \u043A\u043B\u0438\u0435\u043D\u0442\u0430",
  "customer has all the tags from the list": "\u043A\u043B\u0438\u0435\u043D\u0442\u044A\u0442 \u0438\u043C\u0430 \u0432\u0441\u0438\u0447\u043A\u0438 \u0442\u0430\u0433\u043E\u0432\u0435 \u043E\u0442 \u0441\u043F\u0438\u0441\u044A\u043A\u0430",
  "customer has at least one of the tags from the list ": "\u043A\u043B\u0438\u0435\u043D\u0442\u044A\u0442 \u0438\u043C\u0430 \u043F\u043E\u043D\u0435 \u0435\u0434\u0438\u043D \u043E\u0442 \u0442\u0430\u0433\u043E\u0432\u0435\u0442\u0435 \u0432 \u0441\u043F\u0438\u0441\u044A\u043A\u0430 ",
  "Customer number of orders": "\u0411\u0440\u043E\u0439 \u043F\u043E\u0440\u044A\u0447\u043A\u0438 \u043D\u0430 \u043A\u043B\u0438\u0435\u043D\u0442\u0430",
  "Customer segments": "\u041A\u043B\u0438\u0435\u043D\u0442\u0441\u043A\u0438 \u0441\u0435\u0433\u043C\u0435\u043D\u0442\u0438",
  "Customer tag": "\u0415\u0442\u0438\u043A\u0435\u0442 \u043D\u0430 \u043A\u043B\u0438\u0435\u043D\u0442",
  Days: "\u0414\u043D\u0438",
  "Discount code": "\u041A\u043E\u0434 \u0437\u0430 \u043E\u0442\u0441\u0442\u044A\u043F\u043A\u0430",
  "Does not require shipping": "\u041D\u0435 \u0438\u0437\u0438\u0441\u043A\u0432\u0430 \u0434\u043E\u0441\u0442\u0430\u0432\u043A\u0430",
  "Doesn't contain": "\u041D\u0435 \u0441\u044A\u0434\u044A\u0440\u0436\u0430",
  "Doesn't end with": "\u041D\u0435 \u0437\u0430\u0432\u044A\u0440\u0448\u0432\u0430 \u0441",
  "Doesn't have all the tags from the list": "\u041D\u044F\u043C\u0430 \u0432\u0441\u0438\u0447\u043A\u0438 \u0442\u0430\u0433\u043E\u0432\u0435 \u043E\u0442 \u0441\u043F\u0438\u0441\u044A\u043A\u0430",
  "Doesn't have some of the tags from the list": "\u041D\u044F\u043C\u0430 \u043D\u044F\u043A\u043E\u0438 \u043E\u0442 \u0442\u0430\u0433\u043E\u0432\u0435\u0442\u0435 \u0432 \u0441\u043F\u0438\u0441\u044A\u043A\u0430",
  "Doesn't start with": "\u041D\u0435 \u0437\u0430\u043F\u043E\u0447\u0432\u0430 \u0441",
  "Ends with": "\u0417\u0430\u0432\u044A\u0440\u0448\u0432\u0430 \u0441",
  "Equal to": "\u0420\u0430\u0432\u043D\u043E \u043D\u0430",
  Equals: "\u0420\u0430\u0432\u043D\u043E \u043D\u0430",
  "Every product in the cart": "\u0412\u0441\u0435\u043A\u0438 \u043F\u0440\u043E\u0434\u0443\u043A\u0442 \u0432 \u043A\u043E\u043B\u0438\u0447\u043A\u0430\u0442\u0430",
  "Greater than": "\u041F\u043E-\u0433\u043E\u043B\u044F\u043C\u043E \u043E\u0442",
  "Greater than or equals to": "\u041F\u043E-\u0433\u043E\u043B\u044F\u043C\u043E \u0438\u043B\u0438 \u0440\u0430\u0432\u043D\u043E \u043D\u0430",
  "Has all the tags from the list": "\u0418\u043C\u0430 \u0432\u0441\u0438\u0447\u043A\u0438 \u0442\u0430\u0433\u043E\u0432\u0435 \u043E\u0442 \u0441\u043F\u0438\u0441\u044A\u043A\u0430",
  "Has at least one of the tags from the list": "\u0418\u043C\u0430 \u043F\u043E\u043D\u0435 \u0435\u0434\u0438\u043D \u043E\u0442 \u0442\u0430\u0433\u043E\u0432\u0435\u0442\u0435 \u0432 \u0441\u043F\u0438\u0441\u044A\u043A\u0430",
  Hours: "\u0427\u0430\u0441\u043E\u0432\u0435",
  "in less than": "\u0441\u043B\u0435\u0434 \u043F\u043E-\u043C\u0430\u043B\u043A\u043E \u043E\u0442",
  "Is (exact code)": "\u0415 (\u0442\u043E\u0447\u0435\u043D \u043A\u043E\u0434)",
  "Is (exact email)": "\u0415 (\u0442\u043E\u0447\u0435\u043D \u0438\u043C\u0435\u0439\u043B)",
  "Is (exact sku)": "\u0415 (\u0442\u043E\u0447\u0435\u043D SKU)",
  "Is (exact title)": "\u0415 (\u0442\u043E\u0447\u043D\u043E \u0438\u043C\u0435)",
  "Is (exact variant name)": "\u0415 (\u0442\u043E\u0447\u043D\u043E \u0438\u043C\u0435 \u043D\u0430 \u0432\u0430\u0440\u0438\u0430\u043D\u0442)",
  "Is after": "\u0415 \u0441\u043B\u0435\u0434",
  "Is available at all the sales channels from the list": "\u041D\u0430\u043B\u0438\u0447\u0435\u043D \u0435 \u0432\u044A\u0432 \u0432\u0441\u0438\u0447\u043A\u0438 \u043A\u0430\u043D\u0430\u043B\u0438 \u0437\u0430 \u043F\u0440\u043E\u0434\u0430\u0436\u0431\u0430 \u0432 \u0441\u043F\u0438\u0441\u044A\u043A\u0430",
  "Is available at all the sales channels in the list": "\u0415 \u043D\u0430\u043B\u0438\u0447\u0435\u043D \u0432\u044A\u0432 \u0432\u0441\u0438\u0447\u043A\u0438 \u043A\u0430\u043D\u0430\u043B\u0438 \u0437\u0430 \u043F\u0440\u043E\u0434\u0430\u0436\u0431\u0430 \u0432 \u0441\u043F\u0438\u0441\u044A\u043A\u0430",
  "Is available at one of the sales channels from the list": "\u041D\u0430\u043B\u0438\u0447\u0435\u043D \u0435 \u0432 \u0435\u0434\u0438\u043D \u043E\u0442 \u043A\u0430\u043D\u0430\u043B\u0438\u0442\u0435 \u0437\u0430 \u043F\u0440\u043E\u0434\u0430\u0436\u0431\u0430 \u0432 \u0441\u043F\u0438\u0441\u044A\u043A\u0430",
  "Is available at one of the sales channels in the list": "\u0415 \u043D\u0430\u043B\u0438\u0447\u0435\u043D \u0432 \u0435\u0434\u0438\u043D \u043E\u0442 \u043A\u0430\u043D\u0430\u043B\u0438\u0442\u0435 \u0437\u0430 \u043F\u0440\u043E\u0434\u0430\u0436\u0431\u0430 \u0432 \u0441\u043F\u0438\u0441\u044A\u043A\u0430",
  "Is before": "\u0415 \u043F\u0440\u0435\u0434\u0438",
  "Is between": "\u0415 \u043C\u0435\u0436\u0434\u0443",
  "Is from a vendor in the list": "\u0415 \u043E\u0442 \u0434\u043E\u0441\u0442\u0430\u0432\u0447\u0438\u043A \u043E\u0442 \u0441\u043F\u0438\u0441\u044A\u043A\u0430",
  "Is from the list": "\u0415 \u043E\u0442 \u0441\u043F\u0438\u0441\u044A\u043A\u0430",
  "Is greater than": "\u0415 \u043F\u043E-\u0433\u043E\u043B\u044F\u043C\u043E \u043E\u0442",
  "Is greater than or equals to": "\u0415 \u043F\u043E-\u0433\u043E\u043B\u044F\u043C\u043E \u0438\u043B\u0438 \u0440\u0430\u0432\u043D\u043E \u043D\u0430",
  "Is in a category from the list": "\u0415 \u0432 \u043A\u0430\u0442\u0435\u0433\u043E\u0440\u0438\u044F \u043E\u0442 \u0441\u043F\u0438\u0441\u044A\u043A\u0430",
  "Is in a collection from the list": "\u0415 \u0432 \u043A\u043E\u043B\u0435\u043A\u0446\u0438\u044F \u043E\u0442 \u0441\u043F\u0438\u0441\u044A\u043A\u0430",
  "Is less than": "\u0415 \u043F\u043E-\u043C\u0430\u043B\u043A\u043E \u043E\u0442",
  "Is less than or equals to": "\u0415 \u043F\u043E-\u043C\u0430\u043B\u043A\u043E \u0438\u043B\u0438 \u0440\u0430\u0432\u043D\u043E \u043D\u0430",
  "Is not (exact code)": "\u041D\u0435 \u0435 (\u0442\u043E\u0447\u0435\u043D \u043A\u043E\u0434)",
  "Is not (exact email)": "\u041D\u0435 \u0435 (\u0442\u043E\u0447\u0435\u043D \u0438\u043C\u0435\u0439\u043B)",
  "Is not (exact sku)": "\u041D\u0435 \u0435 (\u0442\u043E\u0447\u0435\u043D SKU)",
  "Is not (exact title)": "\u041D\u0435 \u0435 (\u0442\u043E\u0447\u043D\u043E \u0438\u043C\u0435)",
  "Is not (exact variant name)": "\u041D\u0435 \u0435 (\u0442\u043E\u0447\u043D\u043E \u0438\u043C\u0435 \u043D\u0430 \u0432\u0430\u0440\u0438\u0430\u043D\u0442)",
  "Is not available at all the sales channels from the list": "\u041D\u0435 \u0435 \u043D\u0430\u043B\u0438\u0447\u0435\u043D \u0432\u044A\u0432 \u0432\u0441\u0438\u0447\u043A\u0438 \u043A\u0430\u043D\u0430\u043B\u0438 \u0437\u0430 \u043F\u0440\u043E\u0434\u0430\u0436\u0431\u0430 \u0432 \u0441\u043F\u0438\u0441\u044A\u043A\u0430",
  "Is not available at all the sales channels in the list": "\u041D\u0435 \u0435 \u043D\u0430\u043B\u0438\u0447\u0435\u043D \u0432\u044A\u0432 \u0432\u0441\u0438\u0447\u043A\u0438 \u043A\u0430\u043D\u0430\u043B\u0438 \u0437\u0430 \u043F\u0440\u043E\u0434\u0430\u0436\u0431\u0430 \u0432 \u0441\u043F\u0438\u0441\u044A\u043A\u0430",
  "Is not available at one of the sales channels from the list": "\u041D\u0435 \u0435 \u043D\u0430\u043B\u0438\u0447\u0435\u043D \u0432 \u0435\u0434\u0438\u043D \u043E\u0442 \u043A\u0430\u043D\u0430\u043B\u0438\u0442\u0435 \u0437\u0430 \u043F\u0440\u043E\u0434\u0430\u0436\u0431\u0430 \u0432 \u0441\u043F\u0438\u0441\u044A\u043A\u0430",
  "Is not available at one of the sales channels in the list": "\u041D\u0435 \u0435 \u043D\u0430\u043B\u0438\u0447\u0435\u043D \u0432 \u043D\u0438\u0442\u043E \u0435\u0434\u0438\u043D \u043E\u0442 \u043A\u0430\u043D\u0430\u043B\u0438\u0442\u0435 \u0437\u0430 \u043F\u0440\u043E\u0434\u0430\u0436\u0431\u0430 \u0432 \u0441\u043F\u0438\u0441\u044A\u043A\u0430",
  "Is not between": "\u041D\u0435 \u0435 \u043C\u0435\u0436\u0434\u0443",
  "Is not equal to": "\u041D\u0435 \u0435 \u0440\u0430\u0432\u043D\u043E \u043D\u0430",
  "Is not from a vendor in the list": "\u041D\u0435 \u0435 \u043E\u0442 \u0434\u043E\u0441\u0442\u0430\u0432\u0447\u0438\u043A \u043E\u0442 \u0441\u043F\u0438\u0441\u044A\u043A\u0430",
  "Is not from the list": "\u041D\u0435 \u0435 \u043E\u0442 \u0441\u043F\u0438\u0441\u044A\u043A\u0430",
  "Is not in a category from the list": "\u041D\u0435 \u0435 \u0432 \u043A\u0430\u0442\u0435\u0433\u043E\u0440\u0438\u044F \u043E\u0442 \u0441\u043F\u0438\u0441\u044A\u043A\u0430",
  "Is not in a collection from the list": "\u041D\u0435 \u0435 \u0432 \u043A\u043E\u043B\u0435\u043A\u0446\u0438\u044F \u043E\u0442 \u0441\u043F\u0438\u0441\u044A\u043A\u0430",
  "Is not of a type from the list": "\u041D\u0435 \u0435 \u043E\u0442 \u0442\u0438\u043F \u043E\u0442 \u0441\u043F\u0438\u0441\u044A\u043A\u0430",
  "Is not on": "\u041D\u0435 \u0435 \u043D\u0430",
  "Is not one of the countries from the list": "\u041D\u0435 \u0435 \u0435\u0434\u043D\u0430 \u043E\u0442 \u0434\u044A\u0440\u0436\u0430\u0432\u0438\u0442\u0435 \u0432 \u0441\u043F\u0438\u0441\u044A\u043A\u0430",
  "Is not one of the customer segments from the list": "\u041D\u0435 \u0435 \u0435\u0434\u0438\u043D \u043E\u0442 \u043A\u043B\u0438\u0435\u043D\u0442\u0441\u043A\u0438\u0442\u0435 \u0441\u0435\u0433\u043C\u0435\u043D\u0442\u0438 \u0432 \u0441\u043F\u0438\u0441\u044A\u043A\u0430",
  "Is not one of the fulfillment statuses in the list": "\u041D\u0435 \u0435 \u0435\u0434\u0438\u043D \u043E\u0442 \u0441\u0442\u0430\u0442\u0443\u0441\u0438\u0442\u0435 \u043D\u0430 \u0438\u0437\u043F\u044A\u043B\u043D\u0435\u043D\u0438\u0435 \u0432 \u0441\u043F\u0438\u0441\u044A\u043A\u0430",
  "Is not one of the languages from the list": "\u041D\u0435 \u0435 \u0435\u0434\u0438\u043D \u043E\u0442 \u0435\u0437\u0438\u0446\u0438\u0442\u0435 \u0432 \u0441\u043F\u0438\u0441\u044A\u043A\u0430",
  "Is not one of the methods in the list": "\u041D\u0435 \u0435 \u0435\u0434\u0438\u043D \u043E\u0442 \u043C\u0435\u0442\u043E\u0434\u0438\u0442\u0435 \u0432 \u0441\u043F\u0438\u0441\u044A\u043A\u0430",
  "Is not one of the payment statuses in the list": "\u041D\u0435 \u0435 \u0435\u0434\u0438\u043D \u043E\u0442 \u0441\u0442\u0430\u0442\u0443\u0441\u0438\u0442\u0435 \u043D\u0430 \u043F\u043B\u0430\u0449\u0430\u043D\u0435 \u0432 \u0441\u043F\u0438\u0441\u044A\u043A\u0430",
  "Is not tagged with all the tags in the list": "\u041D\u0435 \u0435 \u043C\u0430\u0440\u043A\u0438\u0440\u0430\u043D \u0441 \u0432\u0441\u0438\u0447\u043A\u0438 \u0435\u0442\u0438\u043A\u0435\u0442\u0438 \u043E\u0442 \u0441\u043F\u0438\u0441\u044A\u043A\u0430",
  "Is not tagged with any of the tags in the list": "\u041D\u0435 \u0435 \u043C\u0430\u0440\u043A\u0438\u0440\u0430\u043D \u0441 \u043D\u0438\u0442\u043E \u0435\u0434\u0438\u043D \u043E\u0442 \u0442\u0430\u0433\u043E\u0432\u0435\u0442\u0435 \u0432 \u0441\u043F\u0438\u0441\u044A\u043A\u0430",
  "Is not tagged with at least one of the tags in the list": "\u041D\u0435 \u0435 \u043C\u0430\u0440\u043A\u0438\u0440\u0430\u043D \u0441 \u043F\u043E\u043D\u0435 \u0435\u0434\u0438\u043D \u043E\u0442 \u0435\u0442\u0438\u043A\u0435\u0442\u0438\u0442\u0435 \u0432 \u0441\u043F\u0438\u0441\u044A\u043A\u0430",
  "Is of a type from the list": "\u0415 \u043E\u0442 \u0442\u0438\u043F \u043E\u0442 \u0441\u043F\u0438\u0441\u044A\u043A\u0430",
  "Is on": "\u0415 \u043D\u0430",
  "Is one of the countries from the list": "\u0415 \u0435\u0434\u043D\u0430 \u043E\u0442 \u0434\u044A\u0440\u0436\u0430\u0432\u0438\u0442\u0435 \u0432 \u0441\u043F\u0438\u0441\u044A\u043A\u0430",
  "Is one of the customer segments from the list": "\u0415 \u0435\u0434\u0438\u043D \u043E\u0442 \u043A\u043B\u0438\u0435\u043D\u0442\u0441\u043A\u0438\u0442\u0435 \u0441\u0435\u0433\u043C\u0435\u043D\u0442\u0438 \u0432 \u0441\u043F\u0438\u0441\u044A\u043A\u0430",
  "Is one of the fulfillment statuses in the list": "\u0415 \u0435\u0434\u0438\u043D \u043E\u0442 \u0441\u0442\u0430\u0442\u0443\u0441\u0438\u0442\u0435 \u043D\u0430 \u0438\u0437\u043F\u044A\u043B\u043D\u0435\u043D\u0438\u0435 \u0432 \u0441\u043F\u0438\u0441\u044A\u043A\u0430",
  "Is one of the languages from the list": "\u0415 \u0435\u0434\u0438\u043D \u043E\u0442 \u0435\u0437\u0438\u0446\u0438\u0442\u0435 \u0432 \u0441\u043F\u0438\u0441\u044A\u043A\u0430",
  "Is one of the methods in the list": "\u0415 \u0435\u0434\u0438\u043D \u043E\u0442 \u043C\u0435\u0442\u043E\u0434\u0438\u0442\u0435 \u0432 \u0441\u043F\u0438\u0441\u044A\u043A\u0430",
  "Is one of the payment statuses in the list": "\u0415 \u0435\u0434\u0438\u043D \u043E\u0442 \u0441\u0442\u0430\u0442\u0443\u0441\u0438\u0442\u0435 \u043D\u0430 \u043F\u043B\u0430\u0449\u0430\u043D\u0435 \u0432 \u0441\u043F\u0438\u0441\u044A\u043A\u0430",
  "Is tagged with all the tags in the list": "\u0415 \u043C\u0430\u0440\u043A\u0438\u0440\u0430\u043D \u0441 \u0432\u0441\u0438\u0447\u043A\u0438 \u0442\u0430\u0433\u043E\u0432\u0435 \u0432 \u0441\u043F\u0438\u0441\u044A\u043A\u0430",
  "Is tagged with at least one of the tags in the list": "\u0415 \u043C\u0430\u0440\u043A\u0438\u0440\u0430\u043D \u0441 \u043F\u043E\u043D\u0435 \u0435\u0434\u0438\u043D \u043E\u0442 \u0442\u0430\u0433\u043E\u0432\u0435\u0442\u0435 \u0432 \u0441\u043F\u0438\u0441\u044A\u043A\u0430",
  "Item cost": "\u0421\u0442\u043E\u0439\u043D\u043E\u0441\u0442 \u043D\u0430 \u0430\u0440\u0442\u0438\u043A\u0443\u043B\u0430",
  Language: "\u0415\u0437\u0438\u043A",
  "Less than": "\u041F\u043E-\u043C\u0430\u043B\u043A\u043E \u043E\u0442",
  "Less than or equals to": "\u041F\u043E-\u043C\u0430\u043B\u043A\u043E \u0438\u043B\u0438 \u0440\u0430\u0432\u043D\u043E \u043D\u0430",
  "Marketing consent": "\u041C\u0430\u0440\u043A\u0435\u0442\u0438\u043D\u0433\u043E\u0432\u043E \u0441\u044A\u0433\u043B\u0430\u0441\u0438\u0435",
  Minutes: "\u041C\u0438\u043D\u0443\u0442\u0438",
  Months: "\u041C\u0435\u0441\u0435\u0446\u0438",
  "Number of orders": "\u0411\u0440\u043E\u0439 \u043F\u043E\u0440\u044A\u0447\u043A\u0438",
  "On all of the post purchase pages": "\u041D\u0430 \u0432\u0441\u0438\u0447\u043A\u0438 \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u0438 \u0441\u043B\u0435\u0434 \u043F\u043E\u043A\u0443\u043F\u043A\u0430",
  "On one of the post purchase pages": "\u041D\u0430 \u0435\u0434\u043D\u0430 \u043E\u0442 \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u0438\u0442\u0435 \u0441\u043B\u0435\u0434 \u043F\u043E\u043A\u0443\u043F\u043A\u0430",
  "On the checkout": "\u041D\u0430 \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u0430\u0442\u0430 \u0437\u0430 \u043F\u043B\u0430\u0449\u0430\u043D\u0435",
  "On the post purchase 1st page": "\u041D\u0430 1-\u0432\u0430 \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u0430 \u0441\u043B\u0435\u0434 \u043F\u043E\u043A\u0443\u043F\u043A\u0430",
  "On the post purchase 2nd page": "\u041D\u0430 2-\u0440\u0430 \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u0430 \u0441\u043B\u0435\u0434 \u043F\u043E\u043A\u0443\u043F\u043A\u0430",
  "On the thank you page": "\u041D\u0430 \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u0430\u0442\u0430 \u0437\u0430 \u0431\u043B\u0430\u0433\u043E\u0434\u0430\u0440\u043D\u043E\u0441\u0442",
  "Order note": "\u0411\u0435\u043B\u0435\u0436\u043A\u0430 \u043A\u044A\u043C \u043F\u043E\u0440\u044A\u0447\u043A\u0430\u0442\u0430",
  "Order tags": "\u0422\u0430\u0433\u043E\u0432\u0435 \u043D\u0430 \u043F\u043E\u0440\u044A\u0447\u043A\u0430\u0442\u0430",
  "Passed X time ago": "\u041C\u0438\u043D\u0430 \u043F\u0440\u0435\u0434\u0438 X",
  "Payment method": "\u041C\u0435\u0442\u043E\u0434 \u043D\u0430 \u043F\u043B\u0430\u0449\u0430\u043D\u0435",
  "please add cart or order value": "\u043C\u043E\u043B\u044F, \u0434\u043E\u0431\u0430\u0432\u0435\u0442\u0435 \u0441\u0442\u043E\u0439\u043D\u043E\u0441\u0442 \u043D\u0430 \u043A\u043E\u043B\u0438\u0447\u043A\u0430\u0442\u0430 \u0438\u043B\u0438 \u043F\u043E\u0440\u044A\u0447\u043A\u0430\u0442\u0430",
  "please add customer email": "\u043C\u043E\u043B\u044F, \u0434\u043E\u0431\u0430\u0432\u0435\u0442\u0435 \u0438\u043C\u0435\u0439\u043B \u043D\u0430 \u043A\u043B\u0438\u0435\u043D\u0442\u0430",
  "please add customer number of orders": "\u043C\u043E\u043B\u044F, \u0434\u043E\u0431\u0430\u0432\u0435\u0442\u0435 \u0431\u0440\u043E\u044F \u043F\u043E\u0440\u044A\u0447\u043A\u0438 \u043D\u0430 \u043A\u043B\u0438\u0435\u043D\u0442\u0430",
  "please add discount code": "\u043C\u043E\u043B\u044F, \u0434\u043E\u0431\u0430\u0432\u0435\u0442\u0435 \u043A\u043E\u0434 \u0437\u0430 \u043E\u0442\u0441\u0442\u044A\u043F\u043A\u0430",
  "please add item cost": "\u043C\u043E\u043B\u044F, \u0434\u043E\u0431\u0430\u0432\u0435\u0442\u0435 \u0441\u0442\u043E\u0439\u043D\u043E\u0441\u0442 \u043D\u0430 \u0430\u0440\u0442\u0438\u043A\u0443\u043B\u0430",
  "please add number of orders": "\u041C\u043E\u043B\u044F, \u0434\u043E\u0431\u0430\u0432\u0435\u0442\u0435 \u0431\u0440\u043E\u0439 \u043F\u043E\u0440\u044A\u0447\u043A\u0438",
  "please add order note": "\u043C\u043E\u043B\u044F, \u0434\u043E\u0431\u0430\u0432\u0435\u0442\u0435 \u0431\u0435\u043B\u0435\u0436\u043A\u0430 \u043A\u044A\u043C \u043F\u043E\u0440\u044A\u0447\u043A\u0430\u0442\u0430",
  "please add product price": "\u041C\u043E\u043B\u044F, \u0434\u043E\u0431\u0430\u0432\u0435\u0442\u0435 \u0446\u0435\u043D\u0430 \u043D\u0430 \u043F\u0440\u043E\u0434\u0443\u043A\u0442\u0430",
  "please add product sku": "\u043C\u043E\u043B\u044F, \u0434\u043E\u0431\u0430\u0432\u0435\u0442\u0435 SKU \u043D\u0430 \u043F\u0440\u043E\u0434\u0443\u043A\u0442\u0430",
  "please add product title": "\u043C\u043E\u043B\u044F, \u0434\u043E\u0431\u0430\u0432\u0435\u0442\u0435 \u0438\u043C\u0435 \u043D\u0430 \u043F\u0440\u043E\u0434\u0443\u043A\u0442\u0430",
  "please add product variant name": "\u043C\u043E\u043B\u044F, \u0434\u043E\u0431\u0430\u0432\u0435\u0442\u0435 \u0438\u043C\u0435 \u043D\u0430 \u0432\u0430\u0440\u0438\u0430\u043D\u0442 \u043D\u0430 \u043F\u0440\u043E\u0434\u0443\u043A\u0442\u0430",
  "please add shipping value": "\u043C\u043E\u043B\u044F, \u0434\u043E\u0431\u0430\u0432\u0435\u0442\u0435 \u0441\u0442\u043E\u0439\u043D\u043E\u0441\u0442 \u043D\u0430 \u0434\u043E\u0441\u0442\u0430\u0432\u043A\u0430\u0442\u0430",
  "please add time since last order": "\u041C\u043E\u043B\u044F, \u0434\u043E\u0431\u0430\u0432\u0435\u0442\u0435 \u0432\u0440\u0435\u043C\u0435 \u043E\u0442 \u043F\u043E\u0441\u043B\u0435\u0434\u043D\u0430\u0442\u0430 \u043F\u043E\u0440\u044A\u0447\u043A\u0430",
  "please add total item count": "\u041C\u043E\u043B\u044F, \u0434\u043E\u0431\u0430\u0432\u0435\u0442\u0435 \u043E\u0431\u0449\u0438\u044F \u0431\u0440\u043E\u0439 \u0430\u0440\u0442\u0438\u043A\u0443\u043B\u0438",
  "please add value": "\u043C\u043E\u043B\u044F, \u0434\u043E\u0431\u0430\u0432\u0435\u0442\u0435 \u0441\u0442\u043E\u0439\u043D\u043E\u0441\u0442",
  "please select collections": "\u043C\u043E\u043B\u044F, \u0438\u0437\u0431\u0435\u0440\u0435\u0442\u0435 \u043A\u043E\u043B\u0435\u043A\u0446\u0438\u0438",
  "please select customer birthday": "\u041C\u043E\u043B\u044F, \u0438\u0437\u0431\u0435\u0440\u0435\u0442\u0435 \u0440\u043E\u0436\u0434\u0435\u043D \u0434\u0435\u043D \u043D\u0430 \u043A\u043B\u0438\u0435\u043D\u0442\u0430",
  "please select customer country": "\u043C\u043E\u043B\u044F, \u0438\u0437\u0431\u0435\u0440\u0435\u0442\u0435 \u0434\u044A\u0440\u0436\u0430\u0432\u0430 \u043D\u0430 \u043A\u043B\u0438\u0435\u043D\u0442\u0430",
  "please select customer language": "\u043C\u043E\u043B\u044F, \u0438\u0437\u0431\u0435\u0440\u0435\u0442\u0435 \u0435\u0437\u0438\u043A \u043D\u0430 \u043A\u043B\u0438\u0435\u043D\u0442\u0430",
  "please select customer segments": "\u043C\u043E\u043B\u044F, \u0438\u0437\u0431\u0435\u0440\u0435\u0442\u0435 \u043A\u043B\u0438\u0435\u043D\u0442\u0441\u043A\u0438 \u0441\u0435\u0433\u043C\u0435\u043D\u0442\u0438",
  "please select customer tag": "\u043C\u043E\u043B\u044F, \u0438\u0437\u0431\u0435\u0440\u0435\u0442\u0435 \u0442\u0430\u0433 \u043D\u0430 \u043A\u043B\u0438\u0435\u043D\u0442\u0430",
  "please select customer tags": "\u041C\u043E\u043B\u044F, \u0438\u0437\u0431\u0435\u0440\u0435\u0442\u0435 \u0435\u0442\u0438\u043A\u0435\u0442\u0438 \u043D\u0430 \u043A\u043B\u0438\u0435\u043D\u0442\u0438",
  "please select fulfillment statuses": "\u043C\u043E\u043B\u044F, \u0438\u0437\u0431\u0435\u0440\u0435\u0442\u0435 \u0441\u0442\u0430\u0442\u0443\u0441\u0438 \u043D\u0430 \u0438\u0437\u043F\u044A\u043B\u043D\u0435\u043D\u0438\u0435",
  "please select offer": "\u043C\u043E\u043B\u044F, \u0438\u0437\u0431\u0435\u0440\u0435\u0442\u0435 \u043E\u0444\u0435\u0440\u0442\u0430",
  "please select payment method": "\u041C\u043E\u043B\u044F, \u0438\u0437\u0431\u0435\u0440\u0435\u0442\u0435 \u043C\u0435\u0442\u043E\u0434 \u043D\u0430 \u043F\u043B\u0430\u0449\u0430\u043D\u0435",
  "please select payment statuses": "\u041C\u043E\u043B\u044F, \u0438\u0437\u0431\u0435\u0440\u0435\u0442\u0435 \u0441\u0442\u0430\u0442\u0443\u0441\u0438 \u043D\u0430 \u043F\u043B\u0430\u0449\u0430\u043D\u0435",
  "please select product type": "\u041C\u043E\u043B\u044F, \u0438\u0437\u0431\u0435\u0440\u0435\u0442\u0435 \u0442\u0438\u043F \u043F\u0440\u043E\u0434\u0443\u043A\u0442",
  "please select product vendor": "\u041C\u043E\u043B\u044F, \u0438\u0437\u0431\u0435\u0440\u0435\u0442\u0435 \u0434\u043E\u0441\u0442\u0430\u0432\u0447\u0438\u043A \u043D\u0430 \u043F\u0440\u043E\u0434\u0443\u043A\u0442",
  "please select products": "\u043C\u043E\u043B\u044F, \u0438\u0437\u0431\u0435\u0440\u0435\u0442\u0435 \u043F\u0440\u043E\u0434\u0443\u043A\u0442\u0438",
  "please select sales channel": "\u043C\u043E\u043B\u044F, \u0438\u0437\u0431\u0435\u0440\u0435\u0442\u0435 \u043A\u0430\u043D\u0430\u043B \u0437\u0430 \u043F\u0440\u043E\u0434\u0430\u0436\u0431\u0430",
  "please select shipping methods": "\u043C\u043E\u043B\u044F, \u0438\u0437\u0431\u0435\u0440\u0435\u0442\u0435 \u043C\u0435\u0442\u043E\u0434\u0438 \u0437\u0430 \u0434\u043E\u0441\u0442\u0430\u0432\u043A\u0430",
  "please select tags": "\u043C\u043E\u043B\u044F, \u0438\u0437\u0431\u0435\u0440\u0435\u0442\u0435 \u0442\u0430\u0433\u043E\u0432\u0435",
  "Previous page offer": "\u041E\u0444\u0435\u0440\u0442\u0430 \u043E\u0442 \u043F\u0440\u0435\u0434\u0438\u0448\u043D\u0430 \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u0430",
  product: "\u043F\u0440\u043E\u0434\u0443\u043A\u0442",
  "Product recommendations": "\u041F\u0440\u0435\u043F\u043E\u0440\u044A\u0447\u0430\u043D\u0438 \u043F\u0440\u043E\u0434\u0443\u043A\u0442\u0438",
  "Product type": "\u0422\u0438\u043F \u043F\u0440\u043E\u0434\u0443\u043A\u0442",
  "Product upsell": "\u041F\u0440\u043E\u0434\u0443\u043A\u0442\u043E\u0432 \u044A\u043F\u0441\u0435\u043B",
  products: "\u043F\u0440\u043E\u0434\u0443\u043A\u0442\u0438",
  "Requires shipping": "\u0418\u0437\u0438\u0441\u043A\u0432\u0430 \u0434\u043E\u0441\u0442\u0430\u0432\u043A\u0430",
  "Shipping method": "\u041C\u0435\u0442\u043E\u0434 \u043D\u0430 \u0434\u043E\u0441\u0442\u0430\u0432\u043A\u0430",
  "Shipping value": "\u0421\u0442\u043E\u0439\u043D\u043E\u0441\u0442 \u043D\u0430 \u0434\u043E\u0441\u0442\u0430\u0432\u043A\u0430\u0442\u0430",
  "Starts with": "\u0417\u0430\u043F\u043E\u0447\u0432\u0430 \u0441",
  Status: "\u0421\u0442\u0430\u0442\u0443\u0441",
  "The displayed product": "\u041F\u043E\u043A\u0430\u0437\u0432\u0430\u043D\u0438\u044F\u0442 \u043F\u0440\u043E\u0434\u0443\u043A\u0442",
  "The displayed product SKU": "SKU \u043D\u0430 \u043F\u043E\u043A\u0430\u0437\u0432\u0430\u043D\u0438\u044F \u043F\u0440\u043E\u0434\u0443\u043A\u0442",
  "The only product title in the cart": "\u0415\u0434\u0438\u043D\u0441\u0442\u0432\u0435\u043D\u043E\u0442\u043E \u0438\u043C\u0435 \u043D\u0430 \u043F\u0440\u043E\u0434\u0443\u043A\u0442 \u0432 \u043A\u043E\u043B\u0438\u0447\u043A\u0430\u0442\u0430",
  "The only SKU in the cart": "\u0415\u0434\u0438\u043D\u0441\u0442\u0432\u0435\u043D\u0438\u044F\u0442 SKU \u0432 \u043A\u043E\u043B\u0438\u0447\u043A\u0430\u0442\u0430",
  "The SKU of all products in the cart": "SKU \u043D\u0430 \u0432\u0441\u0438\u0447\u043A\u0438 \u043F\u0440\u043E\u0434\u0443\u043A\u0442\u0438 \u0432 \u043A\u043E\u043B\u0438\u0447\u043A\u0430\u0442\u0430",
  "The SKU of at least one product in the cart": "SKU \u043D\u0430 \u043F\u043E\u043D\u0435 \u0435\u0434\u0438\u043D \u043F\u0440\u043E\u0434\u0443\u043A\u0442 \u0432 \u043A\u043E\u043B\u0438\u0447\u043A\u0430\u0442\u0430",
  "The title of all products in the cart": "\u0418\u043C\u0435\u0442\u043E \u043D\u0430 \u0432\u0441\u0438\u0447\u043A\u0438 \u043F\u0440\u043E\u0434\u0443\u043A\u0442\u0438 \u0432 \u043A\u043E\u043B\u0438\u0447\u043A\u0430\u0442\u0430",
  "The title of at least one product in the cart": "\u0418\u043C\u0435\u0442\u043E \u043D\u0430 \u043F\u043E\u043D\u0435 \u0435\u0434\u0438\u043D \u043F\u0440\u043E\u0434\u0443\u043A\u0442 \u0432 \u043A\u043E\u043B\u0438\u0447\u043A\u0430\u0442\u0430",
  "The title of the displayed product": "\u0418\u043C\u0435\u0442\u043E \u043D\u0430 \u043F\u043E\u043A\u0430\u0437\u0432\u0430\u043D\u0438\u044F \u043F\u0440\u043E\u0434\u0443\u043A\u0442",
  "The variant of all products in the cart": "\u0412\u0430\u0440\u0438\u0430\u043D\u0442\u044A\u0442 \u043D\u0430 \u0432\u0441\u0438\u0447\u043A\u0438 \u043F\u0440\u043E\u0434\u0443\u043A\u0442\u0438 \u0432 \u043A\u043E\u043B\u0438\u0447\u043A\u0430\u0442\u0430",
  "The variant of at least one product in the cart": "\u0412\u0430\u0440\u0438\u0430\u043D\u0442\u044A\u0442 \u043D\u0430 \u043F\u043E\u043D\u0435 \u0435\u0434\u0438\u043D \u043F\u0440\u043E\u0434\u0443\u043A\u0442 \u0432 \u043A\u043E\u043B\u0438\u0447\u043A\u0430\u0442\u0430",
  "The variant of only product in the cart": "\u0412\u0430\u0440\u0438\u0430\u043D\u0442\u044A\u0442 \u043D\u0430 \u0435\u0434\u0438\u043D\u0441\u0442\u0432\u0435\u043D\u0438\u044F \u043F\u0440\u043E\u0434\u0443\u043A\u0442 \u0432 \u043A\u043E\u043B\u0438\u0447\u043A\u0430\u0442\u0430",
  "The variant of the displayed product": "\u0412\u0430\u0440\u0438\u0430\u043D\u0442\u044A\u0442 \u043D\u0430 \u043F\u043E\u043A\u0430\u0437\u0432\u0430\u043D\u0438\u044F \u043F\u0440\u043E\u0434\u0443\u043A\u0442",
  "Total item count": "\u041E\u0431\u0449 \u0431\u0440\u043E\u0439 \u0430\u0440\u0442\u0438\u043A\u0443\u043B\u0438",
  Weeks: "\u0421\u0435\u0434\u043C\u0438\u0446\u0438",
  Years: "\u0413\u043E\u0434\u0438\u043D\u0438"
};

// src/lang/hi.json
var hi_default = {
  "An offer was accepted": "\u090F\u0915 \u0911\u092B\u093C\u0930 \u0938\u094D\u0935\u0940\u0915\u093E\u0930 \u0915\u093F\u092F\u093E \u0917\u092F\u093E \u0925\u093E",
  "An offer was declined": "\u090F\u0915 \u0911\u092B\u093C\u0930 \u0905\u0938\u094D\u0935\u0940\u0915\u093E\u0930 \u0915\u0930 \u0926\u093F\u092F\u093E \u0917\u092F\u093E \u0925\u093E",
  and: "\u0914\u0930",
  "Announcement bar": "\u0918\u094B\u0937\u0923\u093E \u092C\u093E\u0930",
  "Are available at all the sales channels from the list": "\u0938\u0942\u091A\u0940 \u0938\u0947 \u0938\u092D\u0940 \u092C\u093F\u0915\u094D\u0930\u0940 \u091A\u0948\u0928\u0932\u094B\u0902 \u092A\u0930 \u0909\u092A\u0932\u092C\u094D\u0927 \u0939\u0948\u0902",
  "Are available at one of the sales channels from the list": "\u0938\u0942\u091A\u0940 \u0938\u0947 \u0915\u093F\u0938\u0940 \u090F\u0915 \u092C\u093F\u0915\u094D\u0930\u0940 \u091A\u0948\u0928\u0932 \u092A\u0930 \u0909\u092A\u0932\u092C\u094D\u0927 \u0939\u0948\u0902",
  "Are not available at all the sales channels from the list": "\u0938\u0942\u091A\u0940 \u0938\u0947 \u0938\u092D\u0940 \u092C\u093F\u0915\u094D\u0930\u0940 \u091A\u0948\u0928\u0932\u094B\u0902 \u092A\u0930 \u0909\u092A\u0932\u092C\u094D\u0927 \u0928\u0939\u0940\u0902 \u0939\u0948\u0902",
  "Are not available at one of the sales channels from the list": "\u0938\u0942\u091A\u0940 \u0938\u0947 \u0915\u093F\u0938\u0940 \u090F\u0915 \u092C\u093F\u0915\u094D\u0930\u0940 \u091A\u0948\u0928\u0932 \u092A\u0930 \u0909\u092A\u0932\u092C\u094D\u0927 \u0928\u0939\u0940\u0902 \u0939\u0948\u0902",
  "At least one product in the cart": "\u0915\u093E\u0930\u094D\u091F \u092E\u0947\u0902 \u0915\u092E \u0938\u0947 \u0915\u092E \u090F\u0915 \u092A\u094D\u0930\u094B\u0921\u0915\u094D\u091F",
  Banner: "\u092C\u0948\u0928\u0930",
  Between: "\u0915\u0947 \u092C\u0940\u091A",
  Bundle: "\u092C\u0902\u0921\u0932",
  "Cart/Order value": "\u0915\u093E\u0930\u094D\u091F/\u0911\u0930\u094D\u0921\u0930 \u092E\u0942\u0932\u094D\u092F",
  categories: "\u0936\u094D\u0930\u0947\u0923\u093F\u092F\u093E\u0901",
  category: "\u0936\u094D\u0930\u0947\u0923\u0940",
  collection: "\u0915\u0932\u0947\u0915\u094D\u0936\u0928",
  collections: "\u0915\u0932\u0947\u0915\u094D\u0936\u0928",
  Contains: "\u0936\u093E\u092E\u093F\u0932 \u0939\u0948",
  "Customer accepted marketing": "\u0917\u094D\u0930\u093E\u0939\u0915 \u0928\u0947 \u092E\u093E\u0930\u094D\u0915\u0947\u091F\u093F\u0902\u0917 \u0938\u094D\u0935\u0940\u0915\u093E\u0930 \u0915\u0940",
  "Customer birthday": "\u0917\u094D\u0930\u093E\u0939\u0915 \u0915\u093E \u091C\u0928\u094D\u092E\u0926\u093F\u0928",
  "Customer country": "\u0917\u094D\u0930\u093E\u0939\u0915 \u0915\u093E \u0926\u0947\u0936",
  "customer doesn't have all the tags from the list": "\u0917\u094D\u0930\u093E\u0939\u0915 \u0915\u0947 \u092A\u093E\u0938 \u0938\u0942\u091A\u0940 \u0938\u0947 \u0938\u092D\u0940 \u091F\u0948\u0917 \u0928\u0939\u0940\u0902 \u0939\u0948\u0902",
  "customer doesn't have any of the tags from the list": "\u0917\u094D\u0930\u093E\u0939\u0915 \u0915\u0947 \u092A\u093E\u0938 \u0938\u0942\u091A\u0940 \u0938\u0947 \u0915\u094B\u0908 \u092D\u0940 \u091F\u0948\u0917 \u0928\u0939\u0940\u0902 \u0939\u0948",
  "Customer don't accepted marketing": "\u0917\u094D\u0930\u093E\u0939\u0915 \u0928\u0947 \u092E\u093E\u0930\u094D\u0915\u0947\u091F\u093F\u0902\u0917 \u0938\u094D\u0935\u0940\u0915\u093E\u0930 \u0928\u0939\u0940\u0902 \u0915\u0940",
  "Customer email": "\u0917\u094D\u0930\u093E\u0939\u0915 \u0915\u093E \u0908\u092E\u0947\u0932",
  "customer has all the tags from the list": "\u0917\u094D\u0930\u093E\u0939\u0915 \u0915\u0947 \u092A\u093E\u0938 \u0938\u0942\u091A\u0940 \u0938\u0947 \u0938\u092D\u0940 \u091F\u0948\u0917 \u0939\u0948\u0902",
  "customer has at least one of the tags from the list ": "\u0917\u094D\u0930\u093E\u0939\u0915 \u0915\u0947 \u092A\u093E\u0938 \u0938\u0942\u091A\u0940 \u0938\u0947 \u0915\u092E \u0938\u0947 \u0915\u092E \u090F\u0915 \u091F\u0948\u0917 \u0939\u0948 ",
  "Customer number of orders": "\u0917\u094D\u0930\u093E\u0939\u0915 \u0915\u0947 \u0911\u0930\u094D\u0921\u0930 \u0915\u0940 \u0938\u0902\u0916\u094D\u092F\u093E",
  "Customer segments": "\u0917\u094D\u0930\u093E\u0939\u0915 \u0916\u0902\u0921",
  "Customer tag": "\u0917\u094D\u0930\u093E\u0939\u0915 \u091F\u0948\u0917",
  Days: "\u0926\u093F\u0928",
  "Discount code": "\u091B\u0942\u091F \u0915\u094B\u0921",
  "Does not require shipping": "\u0936\u093F\u092A\u093F\u0902\u0917 \u0906\u0935\u0936\u094D\u092F\u0915 \u0928\u0939\u0940\u0902 \u0939\u0948",
  "Doesn't contain": "\u0936\u093E\u092E\u093F\u0932 \u0928\u0939\u0940\u0902 \u0939\u0948",
  "Doesn't end with": "\u0907\u0938\u0938\u0947 \u0938\u092E\u093E\u092A\u094D\u0924 \u0928\u0939\u0940\u0902 \u0939\u094B\u0924\u093E \u0939\u0948",
  "Doesn't have all the tags from the list": "\u0938\u0942\u091A\u0940 \u0938\u0947 \u0938\u092D\u0940 \u091F\u0948\u0917 \u0928\u0939\u0940\u0902 \u0939\u0948\u0902",
  "Doesn't have some of the tags from the list": "\u0938\u0942\u091A\u0940 \u0938\u0947 \u0915\u0941\u091B \u091F\u0948\u0917 \u0928\u0939\u0940\u0902 \u0939\u0948\u0902",
  "Doesn't start with": "\u0907\u0938\u0938\u0947 \u0936\u0941\u0930\u0942 \u0928\u0939\u0940\u0902 \u0939\u094B\u0924\u093E \u0939\u0948",
  "Ends with": "\u0907\u0938\u0938\u0947 \u0938\u092E\u093E\u092A\u094D\u0924 \u0939\u094B\u0924\u093E \u0939\u0948",
  "Equal to": "\u0907\u0938\u0915\u0947 \u092C\u0930\u093E\u092C\u0930",
  Equals: "\u092C\u0930\u093E\u092C\u0930 \u0939\u0948",
  "Every product in the cart": "\u0915\u093E\u0930\u094D\u091F \u092E\u0947\u0902 \u0939\u0930 \u092A\u094D\u0930\u094B\u0921\u0915\u094D\u091F",
  "Greater than": "\u0907\u0938\u0938\u0947 \u091C\u093C\u094D\u092F\u093E\u0926\u093E",
  "Greater than or equals to": "\u0907\u0938\u0938\u0947 \u091C\u093C\u094D\u092F\u093E\u0926\u093E \u092F\u093E \u0907\u0938\u0915\u0947 \u092C\u0930\u093E\u092C\u0930",
  "Has all the tags from the list": "\u0938\u0942\u091A\u0940 \u0938\u0947 \u0938\u092D\u0940 \u091F\u0948\u0917 \u0939\u0948\u0902",
  "Has at least one of the tags from the list": "\u0938\u0942\u091A\u0940 \u0938\u0947 \u0915\u092E \u0938\u0947 \u0915\u092E \u090F\u0915 \u091F\u0948\u0917 \u0939\u0948",
  Hours: "\u0918\u0902\u091F\u0947",
  "in less than": "\u0938\u0947 \u0915\u092E \u092E\u0947\u0902",
  "Is (exact code)": "\u0939\u0948 (\u0938\u091F\u0940\u0915 \u0915\u094B\u0921)",
  "Is (exact email)": "\u0939\u0948 (\u0938\u091F\u0940\u0915 \u0908\u092E\u0947\u0932)",
  "Is (exact sku)": "\u0939\u0948 (\u0938\u091F\u0940\u0915 SKU)",
  "Is (exact title)": "\u0939\u0948 (\u0938\u091F\u0940\u0915 \u0936\u0940\u0930\u094D\u0937\u0915)",
  "Is (exact variant name)": "\u0939\u0948 (\u0938\u091F\u0940\u0915 \u0935\u0947\u0930\u093F\u090F\u0902\u091F \u0915\u093E \u0928\u093E\u092E)",
  "Is after": "\u0915\u0947 \u092C\u093E\u0926 \u0939\u0948",
  "Is available at all the sales channels from the list": "\u0938\u0942\u091A\u0940 \u0938\u0947 \u0938\u092D\u0940 \u092C\u093F\u0915\u094D\u0930\u0940 \u091A\u0948\u0928\u0932\u094B\u0902 \u092A\u0930 \u0909\u092A\u0932\u092C\u094D\u0927 \u0939\u0948",
  "Is available at all the sales channels in the list": "\u0938\u0942\u091A\u0940 \u092E\u0947\u0902 \u0938\u092D\u0940 \u092C\u093F\u0915\u094D\u0930\u0940 \u091A\u0948\u0928\u0932\u094B\u0902 \u092A\u0930 \u0909\u092A\u0932\u092C\u094D\u0927 \u0939\u0948",
  "Is available at one of the sales channels from the list": "\u0938\u0942\u091A\u0940 \u0938\u0947 \u0915\u093F\u0938\u0940 \u090F\u0915 \u092C\u093F\u0915\u094D\u0930\u0940 \u091A\u0948\u0928\u0932 \u092A\u0930 \u0909\u092A\u0932\u092C\u094D\u0927 \u0939\u0948",
  "Is available at one of the sales channels in the list": "\u0938\u0942\u091A\u0940 \u092E\u0947\u0902 \u092C\u093F\u0915\u094D\u0930\u0940 \u091A\u0948\u0928\u0932\u094B\u0902 \u092E\u0947\u0902 \u0938\u0947 \u090F\u0915 \u092A\u0930 \u0909\u092A\u0932\u092C\u094D\u0927 \u0939\u0948",
  "Is before": "\u0938\u0947 \u092A\u0939\u0932\u0947 \u0939\u0948",
  "Is between": "\u0915\u0947 \u092C\u0940\u091A \u0939\u0948",
  "Is from a vendor in the list": "\u0938\u0942\u091A\u0940 \u092E\u0947\u0902 \u0926\u093F\u090F \u0917\u090F \u0935\u093F\u0915\u094D\u0930\u0947\u0924\u093E \u0915\u093E \u0939\u0948",
  "Is from the list": "\u0938\u0942\u091A\u0940 \u0938\u0947 \u0939\u0948",
  "Is greater than": "\u0907\u0938\u0938\u0947 \u092C\u0921\u093C\u093E \u0939\u0948",
  "Is greater than or equals to": "\u0907\u0938\u0938\u0947 \u092C\u0921\u093C\u093E \u092F\u093E \u092C\u0930\u093E\u092C\u0930 \u0939\u0948",
  "Is in a category from the list": "\u0938\u0942\u091A\u0940 \u0938\u0947 \u090F\u0915 \u0936\u094D\u0930\u0947\u0923\u0940 \u092E\u0947\u0902 \u0939\u0948",
  "Is in a collection from the list": "\u0938\u0942\u091A\u0940 \u0938\u0947 \u090F\u0915 \u0915\u0932\u0947\u0915\u094D\u0936\u0928 \u092E\u0947\u0902 \u0939\u0948",
  "Is less than": "\u0907\u0938\u0938\u0947 \u0915\u092E \u0939\u0948",
  "Is less than or equals to": "\u0907\u0938\u0938\u0947 \u0915\u092E \u092F\u093E \u092C\u0930\u093E\u092C\u0930 \u0939\u0948",
  "Is not (exact code)": "\u0928\u0939\u0940\u0902 \u0939\u0948 (\u0938\u091F\u0940\u0915 \u0915\u094B\u0921)",
  "Is not (exact email)": "\u0928\u0939\u0940\u0902 \u0939\u0948 (\u0938\u091F\u0940\u0915 \u0908\u092E\u0947\u0932)",
  "Is not (exact sku)": "\u0928\u0939\u0940\u0902 \u0939\u0948 (\u0938\u091F\u0940\u0915 SKU)",
  "Is not (exact title)": "\u0928\u0939\u0940\u0902 \u0939\u0948 (\u0938\u091F\u0940\u0915 \u0936\u0940\u0930\u094D\u0937\u0915)",
  "Is not (exact variant name)": "\u0928\u0939\u0940\u0902 \u0939\u0948 (\u0938\u091F\u0940\u0915 \u0935\u0947\u0930\u093F\u090F\u0902\u091F \u0915\u093E \u0928\u093E\u092E)",
  "Is not available at all the sales channels from the list": "\u0938\u0942\u091A\u0940 \u0938\u0947 \u0938\u092D\u0940 \u092C\u093F\u0915\u094D\u0930\u0940 \u091A\u0948\u0928\u0932\u094B\u0902 \u092A\u0930 \u0909\u092A\u0932\u092C\u094D\u0927 \u0928\u0939\u0940\u0902 \u0939\u0948",
  "Is not available at all the sales channels in the list": "\u0938\u0942\u091A\u0940 \u092E\u0947\u0902 \u0938\u092D\u0940 \u092C\u093F\u0915\u094D\u0930\u0940 \u091A\u0948\u0928\u0932\u094B\u0902 \u092A\u0930 \u0909\u092A\u0932\u092C\u094D\u0927 \u0928\u0939\u0940\u0902 \u0939\u0948",
  "Is not available at one of the sales channels from the list": "\u0938\u0942\u091A\u0940 \u0938\u0947 \u0915\u093F\u0938\u0940 \u090F\u0915 \u092C\u093F\u0915\u094D\u0930\u0940 \u091A\u0948\u0928\u0932 \u092A\u0930 \u0909\u092A\u0932\u092C\u094D\u0927 \u0928\u0939\u0940\u0902 \u0939\u0948",
  "Is not available at one of the sales channels in the list": "\u0938\u0942\u091A\u0940 \u092E\u0947\u0902 \u092C\u093F\u0915\u094D\u0930\u0940 \u091A\u0948\u0928\u0932\u094B\u0902 \u092E\u0947\u0902 \u0938\u0947 \u0915\u093F\u0938\u0940 \u092A\u0930 \u092D\u0940 \u0909\u092A\u0932\u092C\u094D\u0927 \u0928\u0939\u0940\u0902 \u0939\u0948",
  "Is not between": "\u0915\u0947 \u092C\u0940\u091A \u0928\u0939\u0940\u0902 \u0939\u0948",
  "Is not equal to": "\u0907\u0938\u0915\u0947 \u092C\u0930\u093E\u092C\u0930 \u0928\u0939\u0940\u0902 \u0939\u0948",
  "Is not from a vendor in the list": "\u0938\u0942\u091A\u0940 \u092E\u0947\u0902 \u0926\u093F\u090F \u0917\u090F \u0935\u093F\u0915\u094D\u0930\u0947\u0924\u093E \u0915\u093E \u0928\u0939\u0940\u0902 \u0939\u0948",
  "Is not from the list": "\u0938\u0942\u091A\u0940 \u0938\u0947 \u0928\u0939\u0940\u0902 \u0939\u0948",
  "Is not in a category from the list": "\u0938\u0942\u091A\u0940 \u0938\u0947 \u090F\u0915 \u0936\u094D\u0930\u0947\u0923\u0940 \u092E\u0947\u0902 \u0928\u0939\u0940\u0902 \u0939\u0948",
  "Is not in a collection from the list": "\u0938\u0942\u091A\u0940 \u0938\u0947 \u090F\u0915 \u0915\u0932\u0947\u0915\u094D\u0936\u0928 \u092E\u0947\u0902 \u0928\u0939\u0940\u0902 \u0939\u0948",
  "Is not of a type from the list": "\u0938\u0942\u091A\u0940 \u092E\u0947\u0902 \u0938\u0947 \u090F\u0915 \u092A\u094D\u0930\u0915\u093E\u0930 \u0915\u093E \u0928\u0939\u0940\u0902 \u0939\u0948",
  "Is not on": "\u0915\u094B \u0928\u0939\u0940\u0902 \u0939\u0948",
  "Is not one of the countries from the list": "\u0938\u0942\u091A\u0940 \u0938\u0947 \u0926\u0947\u0936\u094B\u0902 \u092E\u0947\u0902 \u0938\u0947 \u090F\u0915 \u0928\u0939\u0940\u0902 \u0939\u0948",
  "Is not one of the customer segments from the list": "\u0938\u0942\u091A\u0940 \u0938\u0947 \u0917\u094D\u0930\u093E\u0939\u0915 \u0916\u0902\u0921\u094B\u0902 \u092E\u0947\u0902 \u0938\u0947 \u090F\u0915 \u0928\u0939\u0940\u0902 \u0939\u0948",
  "Is not one of the fulfillment statuses in the list": "\u0938\u0942\u091A\u0940 \u092E\u0947\u0902 \u092A\u0942\u0930\u094D\u0924\u093F \u0938\u094D\u0925\u093F\u0924\u093F\u092F\u094B\u0902 \u092E\u0947\u0902 \u0938\u0947 \u090F\u0915 \u0928\u0939\u0940\u0902 \u0939\u0948",
  "Is not one of the languages from the list": "\u0938\u0942\u091A\u0940 \u0938\u0947 \u092D\u093E\u0937\u093E\u0913\u0902 \u092E\u0947\u0902 \u0938\u0947 \u090F\u0915 \u0928\u0939\u0940\u0902 \u0939\u0948",
  "Is not one of the methods in the list": "\u0938\u0942\u091A\u0940 \u092E\u0947\u0902 \u0926\u0940 \u0917\u0908 \u0935\u093F\u0927\u093F\u092F\u094B\u0902 \u092E\u0947\u0902 \u0938\u0947 \u090F\u0915 \u0928\u0939\u0940\u0902 \u0939\u0948",
  "Is not one of the payment statuses in the list": "\u0938\u0942\u091A\u0940 \u092E\u0947\u0902 \u092D\u0941\u0917\u0924\u093E\u0928 \u0938\u094D\u0925\u093F\u0924\u093F\u092F\u094B\u0902 \u092E\u0947\u0902 \u0938\u0947 \u090F\u0915 \u0928\u0939\u0940\u0902 \u0939\u0948",
  "Is not tagged with all the tags in the list": "\u0938\u0942\u091A\u0940 \u0915\u0947 \u0938\u092D\u0940 \u091F\u0948\u0917 \u0915\u0947 \u0938\u093E\u0925 \u091F\u0948\u0917 \u0928\u0939\u0940\u0902 \u0915\u093F\u092F\u093E \u0917\u092F\u093E \u0939\u0948",
  "Is not tagged with any of the tags in the list": "\u0938\u0942\u091A\u0940 \u092E\u0947\u0902 \u0915\u093F\u0938\u0940 \u092D\u0940 \u091F\u0948\u0917 \u0938\u0947 \u091F\u0948\u0917 \u0928\u0939\u0940\u0902 \u0915\u093F\u092F\u093E \u0917\u092F\u093E \u0939\u0948",
  "Is not tagged with at least one of the tags in the list": "\u0938\u0942\u091A\u0940 \u0915\u0947 \u0915\u092E \u0938\u0947 \u0915\u092E \u090F\u0915 \u091F\u0948\u0917 \u0915\u0947 \u0938\u093E\u0925 \u091F\u0948\u0917 \u0928\u0939\u0940\u0902 \u0915\u093F\u092F\u093E \u0917\u092F\u093E \u0939\u0948",
  "Is of a type from the list": "\u0938\u0942\u091A\u0940 \u092E\u0947\u0902 \u0938\u0947 \u090F\u0915 \u092A\u094D\u0930\u0915\u093E\u0930 \u0915\u093E \u0939\u0948",
  "Is on": "\u0915\u094B \u0939\u0948",
  "Is one of the countries from the list": "\u0938\u0942\u091A\u0940 \u0938\u0947 \u0926\u0947\u0936\u094B\u0902 \u092E\u0947\u0902 \u0938\u0947 \u090F\u0915 \u0939\u0948",
  "Is one of the customer segments from the list": "\u0938\u0942\u091A\u0940 \u0938\u0947 \u0917\u094D\u0930\u093E\u0939\u0915 \u0916\u0902\u0921\u094B\u0902 \u092E\u0947\u0902 \u0938\u0947 \u090F\u0915 \u0939\u0948",
  "Is one of the fulfillment statuses in the list": "\u0938\u0942\u091A\u0940 \u092E\u0947\u0902 \u092A\u0942\u0930\u094D\u0924\u093F \u0938\u094D\u0925\u093F\u0924\u093F\u092F\u094B\u0902 \u092E\u0947\u0902 \u0938\u0947 \u090F\u0915 \u0939\u0948",
  "Is one of the languages from the list": "\u0938\u0942\u091A\u0940 \u0938\u0947 \u092D\u093E\u0937\u093E\u0913\u0902 \u092E\u0947\u0902 \u0938\u0947 \u090F\u0915 \u0939\u0948",
  "Is one of the methods in the list": "\u0938\u0942\u091A\u0940 \u092E\u0947\u0902 \u0926\u0940 \u0917\u0908 \u0935\u093F\u0927\u093F\u092F\u094B\u0902 \u092E\u0947\u0902 \u0938\u0947 \u090F\u0915 \u0939\u0948",
  "Is one of the payment statuses in the list": "\u0938\u0942\u091A\u0940 \u092E\u0947\u0902 \u092D\u0941\u0917\u0924\u093E\u0928 \u0938\u094D\u0925\u093F\u0924\u093F\u092F\u094B\u0902 \u092E\u0947\u0902 \u0938\u0947 \u090F\u0915 \u0939\u0948",
  "Is tagged with all the tags in the list": "\u0938\u0942\u091A\u0940 \u092E\u0947\u0902 \u0938\u092D\u0940 \u091F\u0948\u0917 \u0938\u0947 \u091F\u0948\u0917 \u0915\u093F\u092F\u093E \u0917\u092F\u093E \u0939\u0948",
  "Is tagged with at least one of the tags in the list": "\u0938\u0942\u091A\u0940 \u092E\u0947\u0902 \u0915\u092E \u0938\u0947 \u0915\u092E \u090F\u0915 \u091F\u0948\u0917 \u0938\u0947 \u091F\u0948\u0917 \u0915\u093F\u092F\u093E \u0917\u092F\u093E \u0939\u0948",
  "Item cost": "\u0906\u0907\u091F\u092E \u0932\u093E\u0917\u0924",
  Language: "\u092D\u093E\u0937\u093E",
  "Less than": "\u0907\u0938\u0938\u0947 \u0915\u092E",
  "Less than or equals to": "\u0907\u0938\u0938\u0947 \u0915\u092E \u092F\u093E \u0907\u0938\u0915\u0947 \u092C\u0930\u093E\u092C\u0930",
  "Marketing consent": "\u092E\u093E\u0930\u094D\u0915\u0947\u091F\u093F\u0902\u0917 \u0915\u0940 \u0938\u0939\u092E\u0924\u093F",
  Minutes: "\u092E\u093F\u0928\u091F",
  Months: "\u092E\u0939\u0940\u0928\u0947",
  "Number of orders": "\u0911\u0930\u094D\u0921\u0930 \u0915\u0940 \u0938\u0902\u0916\u094D\u092F\u093E",
  "On all of the post purchase pages": "\u0938\u092D\u0940 \u092A\u094B\u0938\u094D\u091F \u092A\u0930\u091A\u0947\u091C \u092A\u0947\u091C\u094B\u0902 \u092A\u0930",
  "On one of the post purchase pages": "\u092A\u094B\u0938\u094D\u091F \u092A\u0930\u091A\u0947\u091C \u092A\u0947\u091C\u094B\u0902 \u092E\u0947\u0902 \u0938\u0947 \u090F\u0915 \u092A\u0930",
  "On the checkout": "\u091A\u0947\u0915\u0906\u0909\u091F \u092A\u0930",
  "On the post purchase 1st page": "\u092A\u094B\u0938\u094D\u091F \u092A\u0930\u091A\u0947\u091C \u0915\u0947 \u092A\u0939\u0932\u0947 \u092A\u0947\u091C \u092A\u0930",
  "On the post purchase 2nd page": "\u092A\u094B\u0938\u094D\u091F \u092A\u0930\u091A\u0947\u091C \u0915\u0947 \u0926\u0942\u0938\u0930\u0947 \u092A\u0947\u091C \u092A\u0930",
  "On the thank you page": "\u0927\u0928\u094D\u092F\u0935\u093E\u0926 \u092A\u0947\u091C \u092A\u0930",
  "Order note": "\u0911\u0930\u094D\u0921\u0930 \u0928\u094B\u091F",
  "Order tags": "\u0911\u0930\u094D\u0921\u0930 \u091F\u0948\u0917",
  "Passed X time ago": "X \u092A\u0939\u0932\u0947 \u092C\u0940\u0924 \u091A\u0941\u0915\u093E \u0939\u0948",
  "Payment method": "\u092D\u0941\u0917\u0924\u093E\u0928 \u0935\u093F\u0927\u093F",
  "please add cart or order value": "\u0915\u0943\u092A\u092F\u093E \u0915\u093E\u0930\u094D\u091F \u092F\u093E \u0911\u0930\u094D\u0921\u0930 \u0915\u093E \u092E\u093E\u0928 \u091C\u094B\u0921\u093C\u0947\u0902",
  "please add customer email": "\u0915\u0943\u092A\u092F\u093E \u0917\u094D\u0930\u093E\u0939\u0915 \u0915\u093E \u0908\u092E\u0947\u0932 \u091C\u094B\u0921\u093C\u0947\u0902",
  "please add customer number of orders": "\u0915\u0943\u092A\u092F\u093E \u0917\u094D\u0930\u093E\u0939\u0915 \u0915\u0947 \u0911\u0930\u094D\u0921\u0930 \u0915\u0940 \u0938\u0902\u0916\u094D\u092F\u093E \u091C\u094B\u0921\u093C\u0947\u0902",
  "please add discount code": "\u0915\u0943\u092A\u092F\u093E \u091B\u0942\u091F \u0915\u094B\u0921 \u091C\u094B\u0921\u093C\u0947\u0902",
  "please add item cost": "\u0915\u0943\u092A\u092F\u093E \u0906\u0907\u091F\u092E \u0932\u093E\u0917\u0924 \u091C\u094B\u0921\u093C\u0947\u0902",
  "please add number of orders": "\u0915\u0943\u092A\u092F\u093E \u0911\u0930\u094D\u0921\u0930 \u0915\u0940 \u0938\u0902\u0916\u094D\u092F\u093E \u091C\u094B\u0921\u093C\u0947\u0902",
  "please add order note": "\u0915\u0943\u092A\u092F\u093E \u0911\u0930\u094D\u0921\u0930 \u0928\u094B\u091F \u091C\u094B\u0921\u093C\u0947\u0902",
  "please add product price": "\u0915\u0943\u092A\u092F\u093E \u0909\u0924\u094D\u092A\u093E\u0926 \u092E\u0942\u0932\u094D\u092F \u091C\u094B\u0921\u093C\u0947\u0902",
  "please add product sku": "\u0915\u0943\u092A\u092F\u093E \u092A\u094D\u0930\u094B\u0921\u0915\u094D\u091F \u0915\u093E SKU \u091C\u094B\u0921\u093C\u0947\u0902",
  "please add product title": "\u0915\u0943\u092A\u092F\u093E \u092A\u094D\u0930\u094B\u0921\u0915\u094D\u091F \u0915\u093E \u0936\u0940\u0930\u094D\u0937\u0915 \u091C\u094B\u0921\u093C\u0947\u0902",
  "please add product variant name": "\u0915\u0943\u092A\u092F\u093E \u092A\u094D\u0930\u094B\u0921\u0915\u094D\u091F \u0915\u0947 \u0935\u0947\u0930\u093F\u090F\u0902\u091F \u0915\u093E \u0928\u093E\u092E \u091C\u094B\u0921\u093C\u0947\u0902",
  "please add shipping value": "\u0915\u0943\u092A\u092F\u093E \u0936\u093F\u092A\u093F\u0902\u0917 \u092E\u0942\u0932\u094D\u092F \u091C\u094B\u0921\u093C\u0947\u0902",
  "please add time since last order": "\u0915\u0943\u092A\u092F\u093E \u092A\u093F\u091B\u0932\u0947 \u0911\u0930\u094D\u0921\u0930 \u0915\u0947 \u092C\u093E\u0926 \u0915\u093E \u0938\u092E\u092F \u091C\u094B\u0921\u093C\u0947\u0902",
  "please add total item count": "\u0915\u0943\u092A\u092F\u093E \u0915\u0941\u0932 \u0906\u0907\u091F\u092E \u0915\u0940 \u0938\u0902\u0916\u094D\u092F\u093E \u091C\u094B\u0921\u093C\u0947\u0902",
  "please add value": "\u0915\u0943\u092A\u092F\u093E \u092E\u093E\u0928 \u091C\u094B\u0921\u093C\u0947\u0902",
  "please select collections": "\u0915\u0943\u092A\u092F\u093E \u0915\u0932\u0947\u0915\u094D\u0936\u0928 \u091A\u0941\u0928\u0947\u0902",
  "please select customer birthday": "\u0915\u0943\u092A\u092F\u093E \u0917\u094D\u0930\u093E\u0939\u0915 \u0915\u093E \u091C\u0928\u094D\u092E\u0926\u093F\u0928 \u091A\u0941\u0928\u0947\u0902",
  "please select customer country": "\u0915\u0943\u092A\u092F\u093E \u0917\u094D\u0930\u093E\u0939\u0915 \u0915\u093E \u0926\u0947\u0936 \u091A\u0941\u0928\u0947\u0902",
  "please select customer language": "\u0915\u0943\u092A\u092F\u093E \u0917\u094D\u0930\u093E\u0939\u0915 \u0915\u0940 \u092D\u093E\u0937\u093E \u091A\u0941\u0928\u0947\u0902",
  "please select customer segments": "\u0915\u0943\u092A\u092F\u093E \u0917\u094D\u0930\u093E\u0939\u0915 \u0916\u0902\u0921 \u091A\u0941\u0928\u0947\u0902",
  "please select customer tag": "\u0915\u0943\u092A\u092F\u093E \u0917\u094D\u0930\u093E\u0939\u0915 \u0915\u093E \u091F\u0948\u0917 \u091A\u0941\u0928\u0947\u0902",
  "please select customer tags": "\u0915\u0943\u092A\u092F\u093E \u0917\u094D\u0930\u093E\u0939\u0915 \u091F\u0948\u0917 \u091A\u0941\u0928\u0947\u0902",
  "please select fulfillment statuses": "\u0915\u0943\u092A\u092F\u093E \u092A\u0942\u0930\u094D\u0924\u093F \u0938\u094D\u0925\u093F\u0924\u093F\u092F\u093E\u0901 \u091A\u0941\u0928\u0947\u0902",
  "please select offer": "\u0915\u0943\u092A\u092F\u093E \u0911\u092B\u093C\u0930 \u091A\u0941\u0928\u0947\u0902",
  "please select payment method": "\u0915\u0943\u092A\u092F\u093E \u092D\u0941\u0917\u0924\u093E\u0928 \u0935\u093F\u0927\u093F \u091A\u0941\u0928\u0947\u0902",
  "please select payment statuses": "\u0915\u0943\u092A\u092F\u093E \u092D\u0941\u0917\u0924\u093E\u0928 \u0938\u094D\u0925\u093F\u0924\u093F\u092F\u093E\u0901 \u091A\u0941\u0928\u0947\u0902",
  "please select product type": "\u0915\u0943\u092A\u092F\u093E \u0909\u0924\u094D\u092A\u093E\u0926 \u092A\u094D\u0930\u0915\u093E\u0930 \u091A\u0941\u0928\u0947\u0902",
  "please select product vendor": "\u0915\u0943\u092A\u092F\u093E \u0909\u0924\u094D\u092A\u093E\u0926 \u0935\u093F\u0915\u094D\u0930\u0947\u0924\u093E \u091A\u0941\u0928\u0947\u0902",
  "please select products": "\u0915\u0943\u092A\u092F\u093E \u092A\u094D\u0930\u094B\u0921\u0915\u094D\u091F \u091A\u0941\u0928\u0947\u0902",
  "please select sales channel": "\u0915\u0943\u092A\u092F\u093E \u092C\u093F\u0915\u094D\u0930\u0940 \u091A\u0948\u0928\u0932 \u091A\u0941\u0928\u0947\u0902",
  "please select shipping methods": "\u0915\u0943\u092A\u092F\u093E \u0936\u093F\u092A\u093F\u0902\u0917 \u0924\u0930\u0940\u0915\u0947 \u091A\u0941\u0928\u0947\u0902",
  "please select tags": "\u0915\u0943\u092A\u092F\u093E \u091F\u0948\u0917 \u091A\u0941\u0928\u0947\u0902",
  "Previous page offer": "\u092A\u093F\u091B\u0932\u0947 \u092A\u0947\u091C \u0915\u093E \u0911\u092B\u093C\u0930",
  product: "\u092A\u094D\u0930\u094B\u0921\u0915\u094D\u091F",
  "Product recommendations": "\u092A\u094D\u0930\u094B\u0921\u0915\u094D\u091F \u0938\u0941\u091D\u093E\u0935",
  "Product type": "\u0909\u0924\u094D\u092A\u093E\u0926 \u092A\u094D\u0930\u0915\u093E\u0930",
  "Product upsell": "\u092A\u094D\u0930\u094B\u0921\u0915\u094D\u091F \u0905\u092A\u0938\u0947\u0932",
  products: "\u092A\u094D\u0930\u094B\u0921\u0915\u094D\u091F",
  "Requires shipping": "\u0936\u093F\u092A\u093F\u0902\u0917 \u0906\u0935\u0936\u094D\u092F\u0915 \u0939\u0948",
  "Shipping method": "\u0936\u093F\u092A\u093F\u0902\u0917 \u0924\u0930\u0940\u0915\u093E",
  "Shipping value": "\u0936\u093F\u092A\u093F\u0902\u0917 \u092E\u0942\u0932\u094D\u092F",
  "Starts with": "\u0907\u0938\u0938\u0947 \u0936\u0941\u0930\u0942 \u0939\u094B\u0924\u093E \u0939\u0948",
  Status: "\u0938\u094D\u0925\u093F\u0924\u093F",
  "The displayed product": "\u092A\u094D\u0930\u0926\u0930\u094D\u0936\u093F\u0924 \u092A\u094D\u0930\u094B\u0921\u0915\u094D\u091F",
  "The displayed product SKU": "\u092A\u094D\u0930\u0926\u0930\u094D\u0936\u093F\u0924 \u092A\u094D\u0930\u094B\u0921\u0915\u094D\u091F \u0915\u093E SKU",
  "The only product title in the cart": "\u0915\u093E\u0930\u094D\u091F \u092E\u0947\u0902 \u090F\u0915\u092E\u093E\u0924\u094D\u0930 \u092A\u094D\u0930\u094B\u0921\u0915\u094D\u091F \u0915\u093E \u0936\u0940\u0930\u094D\u0937\u0915",
  "The only SKU in the cart": "\u0915\u093E\u0930\u094D\u091F \u092E\u0947\u0902 \u090F\u0915\u092E\u093E\u0924\u094D\u0930 SKU",
  "The SKU of all products in the cart": "\u0915\u093E\u0930\u094D\u091F \u092E\u0947\u0902 \u0938\u092D\u0940 \u092A\u094D\u0930\u094B\u0921\u0915\u094D\u091F \u0915\u093E SKU",
  "The SKU of at least one product in the cart": "\u0915\u093E\u0930\u094D\u091F \u092E\u0947\u0902 \u0915\u092E \u0938\u0947 \u0915\u092E \u090F\u0915 \u092A\u094D\u0930\u094B\u0921\u0915\u094D\u091F \u0915\u093E SKU",
  "The title of all products in the cart": "\u0915\u093E\u0930\u094D\u091F \u092E\u0947\u0902 \u0938\u092D\u0940 \u092A\u094D\u0930\u094B\u0921\u0915\u094D\u091F \u0915\u093E \u0936\u0940\u0930\u094D\u0937\u0915",
  "The title of at least one product in the cart": "\u0915\u093E\u0930\u094D\u091F \u092E\u0947\u0902 \u0915\u092E \u0938\u0947 \u0915\u092E \u090F\u0915 \u092A\u094D\u0930\u094B\u0921\u0915\u094D\u091F \u0915\u093E \u0936\u0940\u0930\u094D\u0937\u0915",
  "The title of the displayed product": "\u092A\u094D\u0930\u0926\u0930\u094D\u0936\u093F\u0924 \u092A\u094D\u0930\u094B\u0921\u0915\u094D\u091F \u0915\u093E \u0936\u0940\u0930\u094D\u0937\u0915",
  "The variant of all products in the cart": "\u0915\u093E\u0930\u094D\u091F \u092E\u0947\u0902 \u0938\u092D\u0940 \u092A\u094D\u0930\u094B\u0921\u0915\u094D\u091F \u0915\u093E \u0935\u0947\u0930\u093F\u090F\u0902\u091F",
  "The variant of at least one product in the cart": "\u0915\u093E\u0930\u094D\u091F \u092E\u0947\u0902 \u0915\u092E \u0938\u0947 \u0915\u092E \u090F\u0915 \u092A\u094D\u0930\u094B\u0921\u0915\u094D\u091F \u0915\u093E \u0935\u0947\u0930\u093F\u090F\u0902\u091F",
  "The variant of only product in the cart": "\u0915\u093E\u0930\u094D\u091F \u092E\u0947\u0902 \u090F\u0915\u092E\u093E\u0924\u094D\u0930 \u092A\u094D\u0930\u094B\u0921\u0915\u094D\u091F \u0915\u093E \u0935\u0947\u0930\u093F\u090F\u0902\u091F",
  "The variant of the displayed product": "\u092A\u094D\u0930\u0926\u0930\u094D\u0936\u093F\u0924 \u092A\u094D\u0930\u094B\u0921\u0915\u094D\u091F \u0915\u093E \u0935\u0947\u0930\u093F\u090F\u0902\u091F",
  "Total item count": "\u0915\u0941\u0932 \u0906\u0907\u091F\u092E \u0915\u0940 \u0938\u0902\u0916\u094D\u092F\u093E",
  Weeks: "\u0938\u092A\u094D\u0924\u093E\u0939",
  Years: "\u0935\u0930\u094D\u0937"
};

// src/lang/th.json
var th_default = {
  "An offer was accepted": "\u0E02\u0E49\u0E2D\u0E40\u0E2A\u0E19\u0E2D\u0E44\u0E14\u0E49\u0E23\u0E31\u0E1A\u0E01\u0E32\u0E23\u0E22\u0E2D\u0E21\u0E23\u0E31\u0E1A",
  "An offer was declined": "\u0E02\u0E49\u0E2D\u0E40\u0E2A\u0E19\u0E2D\u0E16\u0E39\u0E01\u0E1B\u0E0F\u0E34\u0E40\u0E2A\u0E18",
  and: "\u0E41\u0E25\u0E30",
  "Announcement bar": "\u0E41\u0E16\u0E1A\u0E1B\u0E23\u0E30\u0E01\u0E32\u0E28",
  "Are available at all the sales channels from the list": "\u0E21\u0E35\u0E08\u0E33\u0E2B\u0E19\u0E48\u0E32\u0E22\u0E43\u0E19\u0E17\u0E38\u0E01\u0E0A\u0E48\u0E2D\u0E07\u0E17\u0E32\u0E07\u0E01\u0E32\u0E23\u0E02\u0E32\u0E22\u0E08\u0E32\u0E01\u0E23\u0E32\u0E22\u0E01\u0E32\u0E23",
  "Are available at one of the sales channels from the list": "\u0E21\u0E35\u0E08\u0E33\u0E2B\u0E19\u0E48\u0E32\u0E22\u0E43\u0E19\u0E0A\u0E48\u0E2D\u0E07\u0E17\u0E32\u0E07\u0E01\u0E32\u0E23\u0E02\u0E32\u0E22\u0E2D\u0E22\u0E48\u0E32\u0E07\u0E19\u0E49\u0E2D\u0E22\u0E2B\u0E19\u0E36\u0E48\u0E07\u0E0A\u0E48\u0E2D\u0E07\u0E17\u0E32\u0E07\u0E08\u0E32\u0E01\u0E23\u0E32\u0E22\u0E01\u0E32\u0E23",
  "Are not available at all the sales channels from the list": "\u0E44\u0E21\u0E48\u0E21\u0E35\u0E08\u0E33\u0E2B\u0E19\u0E48\u0E32\u0E22\u0E43\u0E19\u0E17\u0E38\u0E01\u0E0A\u0E48\u0E2D\u0E07\u0E17\u0E32\u0E07\u0E01\u0E32\u0E23\u0E02\u0E32\u0E22\u0E08\u0E32\u0E01\u0E23\u0E32\u0E22\u0E01\u0E32\u0E23",
  "Are not available at one of the sales channels from the list": "\u0E44\u0E21\u0E48\u0E21\u0E35\u0E08\u0E33\u0E2B\u0E19\u0E48\u0E32\u0E22\u0E43\u0E19\u0E0A\u0E48\u0E2D\u0E07\u0E17\u0E32\u0E07\u0E01\u0E32\u0E23\u0E02\u0E32\u0E22\u0E2D\u0E22\u0E48\u0E32\u0E07\u0E19\u0E49\u0E2D\u0E22\u0E2B\u0E19\u0E36\u0E48\u0E07\u0E0A\u0E48\u0E2D\u0E07\u0E17\u0E32\u0E07\u0E08\u0E32\u0E01\u0E23\u0E32\u0E22\u0E01\u0E32\u0E23",
  "At least one product in the cart": "\u0E21\u0E35\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32\u0E2D\u0E22\u0E48\u0E32\u0E07\u0E19\u0E49\u0E2D\u0E22\u0E2B\u0E19\u0E36\u0E48\u0E07\u0E23\u0E32\u0E22\u0E01\u0E32\u0E23\u0E43\u0E19\u0E15\u0E30\u0E01\u0E23\u0E49\u0E32",
  Banner: "\u0E41\u0E1A\u0E19\u0E40\u0E19\u0E2D\u0E23\u0E4C",
  Between: "\u0E23\u0E30\u0E2B\u0E27\u0E48\u0E32\u0E07",
  Bundle: "\u0E0A\u0E38\u0E14\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32",
  "Cart/Order value": "\u0E21\u0E39\u0E25\u0E04\u0E48\u0E32\u0E15\u0E30\u0E01\u0E23\u0E49\u0E32/\u0E04\u0E33\u0E2A\u0E31\u0E48\u0E07\u0E0B\u0E37\u0E49\u0E2D",
  categories: "\u0E2B\u0E21\u0E27\u0E14\u0E2B\u0E21\u0E39\u0E48",
  category: "\u0E2B\u0E21\u0E27\u0E14\u0E2B\u0E21\u0E39\u0E48",
  collection: "\u0E04\u0E2D\u0E25\u0E40\u0E25\u0E01\u0E0A\u0E31\u0E19",
  collections: "\u0E04\u0E2D\u0E25\u0E40\u0E25\u0E01\u0E0A\u0E31\u0E19",
  Contains: "\u0E21\u0E35",
  "Customer accepted marketing": "\u0E25\u0E39\u0E01\u0E04\u0E49\u0E32\u0E22\u0E2D\u0E21\u0E23\u0E31\u0E1A\u0E01\u0E32\u0E23\u0E17\u0E33\u0E01\u0E32\u0E23\u0E15\u0E25\u0E32\u0E14",
  "Customer birthday": "\u0E27\u0E31\u0E19\u0E40\u0E01\u0E34\u0E14\u0E25\u0E39\u0E01\u0E04\u0E49\u0E32",
  "Customer country": "\u0E1B\u0E23\u0E30\u0E40\u0E17\u0E28\u0E02\u0E2D\u0E07\u0E25\u0E39\u0E01\u0E04\u0E49\u0E32",
  "customer doesn't have all the tags from the list": "\u0E25\u0E39\u0E01\u0E04\u0E49\u0E32\u0E44\u0E21\u0E48\u0E21\u0E35\u0E41\u0E17\u0E47\u0E01\u0E17\u0E31\u0E49\u0E07\u0E2B\u0E21\u0E14\u0E08\u0E32\u0E01\u0E43\u0E19\u0E25\u0E34\u0E2A\u0E15\u0E4C",
  "customer doesn't have any of the tags from the list": "\u0E25\u0E39\u0E01\u0E04\u0E49\u0E32\u0E44\u0E21\u0E48\u0E21\u0E35\u0E41\u0E17\u0E47\u0E01\u0E43\u0E14\u0E46 \u0E08\u0E32\u0E01\u0E43\u0E19\u0E25\u0E34\u0E2A\u0E15\u0E4C",
  "Customer don't accepted marketing": "\u0E25\u0E39\u0E01\u0E04\u0E49\u0E32\u0E44\u0E21\u0E48\u0E22\u0E2D\u0E21\u0E23\u0E31\u0E1A\u0E01\u0E32\u0E23\u0E17\u0E33\u0E01\u0E32\u0E23\u0E15\u0E25\u0E32\u0E14",
  "Customer email": "\u0E2D\u0E35\u0E40\u0E21\u0E25\u0E25\u0E39\u0E01\u0E04\u0E49\u0E32",
  "customer has all the tags from the list": "\u0E25\u0E39\u0E01\u0E04\u0E49\u0E32\u0E21\u0E35\u0E41\u0E17\u0E47\u0E01\u0E17\u0E31\u0E49\u0E07\u0E2B\u0E21\u0E14\u0E08\u0E32\u0E01\u0E43\u0E19\u0E25\u0E34\u0E2A\u0E15\u0E4C",
  "customer has at least one of the tags from the list ": "\u0E25\u0E39\u0E01\u0E04\u0E49\u0E32\u0E21\u0E35\u0E41\u0E17\u0E47\u0E01\u0E2D\u0E22\u0E48\u0E32\u0E07\u0E19\u0E49\u0E2D\u0E22\u0E2B\u0E19\u0E36\u0E48\u0E07\u0E23\u0E32\u0E22\u0E01\u0E32\u0E23\u0E08\u0E32\u0E01\u0E43\u0E19\u0E25\u0E34\u0E2A\u0E15\u0E4C ",
  "Customer number of orders": "\u0E08\u0E33\u0E19\u0E27\u0E19\u0E04\u0E33\u0E2A\u0E31\u0E48\u0E07\u0E0B\u0E37\u0E49\u0E2D\u0E02\u0E2D\u0E07\u0E25\u0E39\u0E01\u0E04\u0E49\u0E32",
  "Customer segments": "\u0E01\u0E25\u0E38\u0E48\u0E21\u0E25\u0E39\u0E01\u0E04\u0E49\u0E32",
  "Customer tag": "\u0E41\u0E17\u0E47\u0E01\u0E25\u0E39\u0E01\u0E04\u0E49\u0E32",
  Days: "\u0E27\u0E31\u0E19",
  "Discount code": "\u0E42\u0E04\u0E49\u0E14\u0E2A\u0E48\u0E27\u0E19\u0E25\u0E14",
  "Does not require shipping": "\u0E44\u0E21\u0E48\u0E15\u0E49\u0E2D\u0E07\u0E21\u0E35\u0E01\u0E32\u0E23\u0E08\u0E31\u0E14\u0E2A\u0E48\u0E07",
  "Doesn't contain": "\u0E44\u0E21\u0E48\u0E21\u0E35",
  "Doesn't end with": "\u0E44\u0E21\u0E48\u0E44\u0E14\u0E49\u0E25\u0E07\u0E17\u0E49\u0E32\u0E22\u0E14\u0E49\u0E27\u0E22",
  "Doesn't have all the tags from the list": "\u0E44\u0E21\u0E48\u0E21\u0E35\u0E41\u0E17\u0E47\u0E01\u0E17\u0E31\u0E49\u0E07\u0E2B\u0E21\u0E14\u0E08\u0E32\u0E01\u0E43\u0E19\u0E25\u0E34\u0E2A\u0E15\u0E4C",
  "Doesn't have some of the tags from the list": "\u0E44\u0E21\u0E48\u0E21\u0E35\u0E41\u0E17\u0E47\u0E01\u0E1A\u0E32\u0E07\u0E23\u0E32\u0E22\u0E01\u0E32\u0E23\u0E08\u0E32\u0E01\u0E43\u0E19\u0E25\u0E34\u0E2A\u0E15\u0E4C",
  "Doesn't start with": "\u0E44\u0E21\u0E48\u0E44\u0E14\u0E49\u0E40\u0E23\u0E34\u0E48\u0E21\u0E15\u0E49\u0E19\u0E14\u0E49\u0E27\u0E22",
  "Ends with": "\u0E25\u0E07\u0E17\u0E49\u0E32\u0E22\u0E14\u0E49\u0E27\u0E22",
  "Equal to": "\u0E40\u0E17\u0E48\u0E32\u0E01\u0E31\u0E1A",
  Equals: "\u0E40\u0E17\u0E48\u0E32\u0E01\u0E31\u0E1A",
  "Every product in the cart": "\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32\u0E17\u0E38\u0E01\u0E23\u0E32\u0E22\u0E01\u0E32\u0E23\u0E43\u0E19\u0E15\u0E30\u0E01\u0E23\u0E49\u0E32",
  "Greater than": "\u0E21\u0E32\u0E01\u0E01\u0E27\u0E48\u0E32",
  "Greater than or equals to": "\u0E21\u0E32\u0E01\u0E01\u0E27\u0E48\u0E32\u0E2B\u0E23\u0E37\u0E2D\u0E40\u0E17\u0E48\u0E32\u0E01\u0E31\u0E1A",
  "Has all the tags from the list": "\u0E21\u0E35\u0E41\u0E17\u0E47\u0E01\u0E17\u0E31\u0E49\u0E07\u0E2B\u0E21\u0E14\u0E08\u0E32\u0E01\u0E43\u0E19\u0E25\u0E34\u0E2A\u0E15\u0E4C",
  "Has at least one of the tags from the list": "\u0E21\u0E35\u0E41\u0E17\u0E47\u0E01\u0E2D\u0E22\u0E48\u0E32\u0E07\u0E19\u0E49\u0E2D\u0E22\u0E2B\u0E19\u0E36\u0E48\u0E07\u0E23\u0E32\u0E22\u0E01\u0E32\u0E23\u0E08\u0E32\u0E01\u0E43\u0E19\u0E25\u0E34\u0E2A\u0E15\u0E4C",
  Hours: "\u0E0A\u0E31\u0E48\u0E27\u0E42\u0E21\u0E07",
  "in less than": "\u0E43\u0E19\u0E19\u0E49\u0E2D\u0E22\u0E01\u0E27\u0E48\u0E32",
  "Is (exact code)": "\u0E04\u0E37\u0E2D (\u0E42\u0E04\u0E49\u0E14\u0E17\u0E35\u0E48\u0E15\u0E23\u0E07\u0E01\u0E31\u0E19)",
  "Is (exact email)": "\u0E04\u0E37\u0E2D (\u0E2D\u0E35\u0E40\u0E21\u0E25\u0E17\u0E35\u0E48\u0E15\u0E23\u0E07\u0E01\u0E31\u0E19)",
  "Is (exact sku)": "\u0E04\u0E37\u0E2D (SKU \u0E17\u0E35\u0E48\u0E15\u0E23\u0E07\u0E01\u0E31\u0E19)",
  "Is (exact title)": "\u0E04\u0E37\u0E2D (\u0E0A\u0E37\u0E48\u0E2D\u0E17\u0E35\u0E48\u0E15\u0E23\u0E07\u0E01\u0E31\u0E19)",
  "Is (exact variant name)": "\u0E04\u0E37\u0E2D (\u0E0A\u0E37\u0E48\u0E2D\u0E15\u0E31\u0E27\u0E40\u0E25\u0E37\u0E2D\u0E01\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32\u0E17\u0E35\u0E48\u0E15\u0E23\u0E07\u0E01\u0E31\u0E19)",
  "Is after": "\u0E2B\u0E25\u0E31\u0E07\u0E27\u0E31\u0E19\u0E17\u0E35\u0E48",
  "Is available at all the sales channels from the list": "\u0E21\u0E35\u0E08\u0E33\u0E2B\u0E19\u0E48\u0E32\u0E22\u0E43\u0E19\u0E17\u0E38\u0E01\u0E0A\u0E48\u0E2D\u0E07\u0E17\u0E32\u0E07\u0E01\u0E32\u0E23\u0E02\u0E32\u0E22\u0E08\u0E32\u0E01\u0E23\u0E32\u0E22\u0E01\u0E32\u0E23",
  "Is available at all the sales channels in the list": "\u0E21\u0E35\u0E08\u0E33\u0E2B\u0E19\u0E48\u0E32\u0E22\u0E17\u0E35\u0E48\u0E17\u0E38\u0E01\u0E0A\u0E48\u0E2D\u0E07\u0E17\u0E32\u0E07\u0E01\u0E32\u0E23\u0E02\u0E32\u0E22\u0E43\u0E19\u0E23\u0E32\u0E22\u0E01\u0E32\u0E23",
  "Is available at one of the sales channels from the list": "\u0E21\u0E35\u0E08\u0E33\u0E2B\u0E19\u0E48\u0E32\u0E22\u0E43\u0E19\u0E0A\u0E48\u0E2D\u0E07\u0E17\u0E32\u0E07\u0E01\u0E32\u0E23\u0E02\u0E32\u0E22\u0E2D\u0E22\u0E48\u0E32\u0E07\u0E19\u0E49\u0E2D\u0E22\u0E2B\u0E19\u0E36\u0E48\u0E07\u0E0A\u0E48\u0E2D\u0E07\u0E17\u0E32\u0E07\u0E08\u0E32\u0E01\u0E23\u0E32\u0E22\u0E01\u0E32\u0E23",
  "Is available at one of the sales channels in the list": "\u0E21\u0E35\u0E08\u0E33\u0E2B\u0E19\u0E48\u0E32\u0E22\u0E17\u0E35\u0E48\u0E2B\u0E19\u0E36\u0E48\u0E07\u0E43\u0E19\u0E0A\u0E48\u0E2D\u0E07\u0E17\u0E32\u0E07\u0E01\u0E32\u0E23\u0E02\u0E32\u0E22\u0E43\u0E19\u0E23\u0E32\u0E22\u0E01\u0E32\u0E23",
  "Is before": "\u0E01\u0E48\u0E2D\u0E19\u0E27\u0E31\u0E19\u0E17\u0E35\u0E48",
  "Is between": "\u0E2D\u0E22\u0E39\u0E48\u0E23\u0E30\u0E2B\u0E27\u0E48\u0E32\u0E07",
  "Is from a vendor in the list": "\u0E21\u0E32\u0E08\u0E32\u0E01\u0E1C\u0E39\u0E49\u0E02\u0E32\u0E22\u0E43\u0E19\u0E23\u0E32\u0E22\u0E01\u0E32\u0E23",
  "Is from the list": "\u0E21\u0E32\u0E08\u0E32\u0E01\u0E23\u0E32\u0E22\u0E01\u0E32\u0E23",
  "Is greater than": "\u0E21\u0E32\u0E01\u0E01\u0E27\u0E48\u0E32",
  "Is greater than or equals to": "\u0E21\u0E32\u0E01\u0E01\u0E27\u0E48\u0E32\u0E2B\u0E23\u0E37\u0E2D\u0E40\u0E17\u0E48\u0E32\u0E01\u0E31\u0E1A",
  "Is in a category from the list": "\u0E2D\u0E22\u0E39\u0E48\u0E43\u0E19\u0E2B\u0E21\u0E27\u0E14\u0E2B\u0E21\u0E39\u0E48\u0E08\u0E32\u0E01\u0E23\u0E32\u0E22\u0E01\u0E32\u0E23",
  "Is in a collection from the list": "\u0E2D\u0E22\u0E39\u0E48\u0E43\u0E19\u0E04\u0E2D\u0E25\u0E40\u0E25\u0E01\u0E0A\u0E31\u0E19\u0E08\u0E32\u0E01\u0E23\u0E32\u0E22\u0E01\u0E32\u0E23",
  "Is less than": "\u0E19\u0E49\u0E2D\u0E22\u0E01\u0E27\u0E48\u0E32",
  "Is less than or equals to": "\u0E19\u0E49\u0E2D\u0E22\u0E01\u0E27\u0E48\u0E32\u0E2B\u0E23\u0E37\u0E2D\u0E40\u0E17\u0E48\u0E32\u0E01\u0E31\u0E1A",
  "Is not (exact code)": "\u0E44\u0E21\u0E48\u0E43\u0E0A\u0E48 (\u0E42\u0E04\u0E49\u0E14\u0E17\u0E35\u0E48\u0E15\u0E23\u0E07\u0E01\u0E31\u0E19)",
  "Is not (exact email)": "\u0E44\u0E21\u0E48\u0E43\u0E0A\u0E48 (\u0E2D\u0E35\u0E40\u0E21\u0E25\u0E17\u0E35\u0E48\u0E15\u0E23\u0E07\u0E01\u0E31\u0E19)",
  "Is not (exact sku)": "\u0E44\u0E21\u0E48\u0E43\u0E0A\u0E48 (SKU \u0E17\u0E35\u0E48\u0E15\u0E23\u0E07\u0E01\u0E31\u0E19)",
  "Is not (exact title)": "\u0E44\u0E21\u0E48\u0E43\u0E0A\u0E48 (\u0E0A\u0E37\u0E48\u0E2D\u0E17\u0E35\u0E48\u0E15\u0E23\u0E07\u0E01\u0E31\u0E19)",
  "Is not (exact variant name)": "\u0E44\u0E21\u0E48\u0E43\u0E0A\u0E48 (\u0E0A\u0E37\u0E48\u0E2D\u0E15\u0E31\u0E27\u0E40\u0E25\u0E37\u0E2D\u0E01\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32\u0E17\u0E35\u0E48\u0E15\u0E23\u0E07\u0E01\u0E31\u0E19)",
  "Is not available at all the sales channels from the list": "\u0E44\u0E21\u0E48\u0E21\u0E35\u0E08\u0E33\u0E2B\u0E19\u0E48\u0E32\u0E22\u0E43\u0E19\u0E17\u0E38\u0E01\u0E0A\u0E48\u0E2D\u0E07\u0E17\u0E32\u0E07\u0E01\u0E32\u0E23\u0E02\u0E32\u0E22\u0E08\u0E32\u0E01\u0E23\u0E32\u0E22\u0E01\u0E32\u0E23",
  "Is not available at all the sales channels in the list": "\u0E44\u0E21\u0E48\u0E44\u0E14\u0E49\u0E21\u0E35\u0E08\u0E33\u0E2B\u0E19\u0E48\u0E32\u0E22\u0E17\u0E35\u0E48\u0E17\u0E38\u0E01\u0E0A\u0E48\u0E2D\u0E07\u0E17\u0E32\u0E07\u0E01\u0E32\u0E23\u0E02\u0E32\u0E22\u0E43\u0E19\u0E23\u0E32\u0E22\u0E01\u0E32\u0E23",
  "Is not available at one of the sales channels from the list": "\u0E44\u0E21\u0E48\u0E21\u0E35\u0E08\u0E33\u0E2B\u0E19\u0E48\u0E32\u0E22\u0E43\u0E19\u0E0A\u0E48\u0E2D\u0E07\u0E17\u0E32\u0E07\u0E01\u0E32\u0E23\u0E02\u0E32\u0E22\u0E2D\u0E22\u0E48\u0E32\u0E07\u0E19\u0E49\u0E2D\u0E22\u0E2B\u0E19\u0E36\u0E48\u0E07\u0E0A\u0E48\u0E2D\u0E07\u0E17\u0E32\u0E07\u0E08\u0E32\u0E01\u0E23\u0E32\u0E22\u0E01\u0E32\u0E23",
  "Is not available at one of the sales channels in the list": "\u0E44\u0E21\u0E48\u0E21\u0E35\u0E08\u0E33\u0E2B\u0E19\u0E48\u0E32\u0E22\u0E17\u0E35\u0E48\u0E0A\u0E48\u0E2D\u0E07\u0E17\u0E32\u0E07\u0E01\u0E32\u0E23\u0E02\u0E32\u0E22\u0E43\u0E14\u0E46 \u0E43\u0E19\u0E23\u0E32\u0E22\u0E01\u0E32\u0E23",
  "Is not between": "\u0E44\u0E21\u0E48\u0E44\u0E14\u0E49\u0E2D\u0E22\u0E39\u0E48\u0E23\u0E30\u0E2B\u0E27\u0E48\u0E32\u0E07",
  "Is not equal to": "\u0E44\u0E21\u0E48\u0E40\u0E17\u0E48\u0E32\u0E01\u0E31\u0E1A",
  "Is not from a vendor in the list": "\u0E44\u0E21\u0E48\u0E44\u0E14\u0E49\u0E21\u0E32\u0E08\u0E32\u0E01\u0E1C\u0E39\u0E49\u0E02\u0E32\u0E22\u0E43\u0E19\u0E23\u0E32\u0E22\u0E01\u0E32\u0E23",
  "Is not from the list": "\u0E44\u0E21\u0E48\u0E44\u0E14\u0E49\u0E21\u0E32\u0E08\u0E32\u0E01\u0E23\u0E32\u0E22\u0E01\u0E32\u0E23",
  "Is not in a category from the list": "\u0E44\u0E21\u0E48\u0E44\u0E14\u0E49\u0E2D\u0E22\u0E39\u0E48\u0E43\u0E19\u0E2B\u0E21\u0E27\u0E14\u0E2B\u0E21\u0E39\u0E48\u0E08\u0E32\u0E01\u0E23\u0E32\u0E22\u0E01\u0E32\u0E23",
  "Is not in a collection from the list": "\u0E44\u0E21\u0E48\u0E44\u0E14\u0E49\u0E2D\u0E22\u0E39\u0E48\u0E43\u0E19\u0E04\u0E2D\u0E25\u0E40\u0E25\u0E01\u0E0A\u0E31\u0E19\u0E08\u0E32\u0E01\u0E23\u0E32\u0E22\u0E01\u0E32\u0E23",
  "Is not of a type from the list": "\u0E44\u0E21\u0E48\u0E43\u0E0A\u0E48\u0E1B\u0E23\u0E30\u0E40\u0E20\u0E17\u0E08\u0E32\u0E01\u0E23\u0E32\u0E22\u0E01\u0E32\u0E23",
  "Is not on": "\u0E44\u0E21\u0E48\u0E43\u0E0A\u0E48\u0E27\u0E31\u0E19\u0E17\u0E35\u0E48",
  "Is not one of the countries from the list": "\u0E44\u0E21\u0E48\u0E43\u0E0A\u0E48\u0E2B\u0E19\u0E36\u0E48\u0E07\u0E43\u0E19\u0E1B\u0E23\u0E30\u0E40\u0E17\u0E28\u0E08\u0E32\u0E01\u0E23\u0E32\u0E22\u0E01\u0E32\u0E23",
  "Is not one of the customer segments from the list": "\u0E44\u0E21\u0E48\u0E43\u0E0A\u0E48\u0E2B\u0E19\u0E36\u0E48\u0E07\u0E43\u0E19\u0E01\u0E25\u0E38\u0E48\u0E21\u0E25\u0E39\u0E01\u0E04\u0E49\u0E32\u0E08\u0E32\u0E01\u0E23\u0E32\u0E22\u0E01\u0E32\u0E23",
  "Is not one of the fulfillment statuses in the list": "\u0E44\u0E21\u0E48\u0E43\u0E0A\u0E48\u0E2B\u0E19\u0E36\u0E48\u0E07\u0E43\u0E19\u0E2A\u0E16\u0E32\u0E19\u0E30\u0E01\u0E32\u0E23\u0E1B\u0E0F\u0E34\u0E1A\u0E31\u0E15\u0E34\u0E15\u0E32\u0E21\u0E43\u0E19\u0E23\u0E32\u0E22\u0E01\u0E32\u0E23",
  "Is not one of the languages from the list": "\u0E44\u0E21\u0E48\u0E43\u0E0A\u0E48\u0E2B\u0E19\u0E36\u0E48\u0E07\u0E43\u0E19\u0E20\u0E32\u0E29\u0E32\u0E08\u0E32\u0E01\u0E23\u0E32\u0E22\u0E01\u0E32\u0E23",
  "Is not one of the methods in the list": "\u0E44\u0E21\u0E48\u0E43\u0E0A\u0E48\u0E2B\u0E19\u0E36\u0E48\u0E07\u0E43\u0E19\u0E27\u0E34\u0E18\u0E35\u0E01\u0E32\u0E23\u0E43\u0E19\u0E23\u0E32\u0E22\u0E01\u0E32\u0E23",
  "Is not one of the payment statuses in the list": "\u0E44\u0E21\u0E48\u0E43\u0E0A\u0E48\u0E2B\u0E19\u0E36\u0E48\u0E07\u0E43\u0E19\u0E2A\u0E16\u0E32\u0E19\u0E30\u0E01\u0E32\u0E23\u0E0A\u0E33\u0E23\u0E30\u0E40\u0E07\u0E34\u0E19\u0E43\u0E19\u0E23\u0E32\u0E22\u0E01\u0E32\u0E23",
  "Is not tagged with all the tags in the list": "\u0E44\u0E21\u0E48\u0E44\u0E14\u0E49\u0E41\u0E17\u0E47\u0E01\u0E14\u0E49\u0E27\u0E22\u0E41\u0E17\u0E47\u0E01\u0E17\u0E31\u0E49\u0E07\u0E2B\u0E21\u0E14\u0E43\u0E19\u0E23\u0E32\u0E22\u0E01\u0E32\u0E23",
  "Is not tagged with any of the tags in the list": "\u0E44\u0E21\u0E48\u0E44\u0E14\u0E49\u0E15\u0E34\u0E14\u0E41\u0E17\u0E47\u0E01\u0E14\u0E49\u0E27\u0E22\u0E41\u0E17\u0E47\u0E01\u0E43\u0E14\u0E46 \u0E43\u0E19\u0E23\u0E32\u0E22\u0E01\u0E32\u0E23",
  "Is not tagged with at least one of the tags in the list": "\u0E44\u0E21\u0E48\u0E44\u0E14\u0E49\u0E41\u0E17\u0E47\u0E01\u0E14\u0E49\u0E27\u0E22\u0E41\u0E17\u0E47\u0E01\u0E2D\u0E22\u0E48\u0E32\u0E07\u0E19\u0E49\u0E2D\u0E22\u0E2B\u0E19\u0E36\u0E48\u0E07\u0E41\u0E17\u0E47\u0E01\u0E43\u0E19\u0E23\u0E32\u0E22\u0E01\u0E32\u0E23",
  "Is of a type from the list": "\u0E40\u0E1B\u0E47\u0E19\u0E1B\u0E23\u0E30\u0E40\u0E20\u0E17\u0E08\u0E32\u0E01\u0E23\u0E32\u0E22\u0E01\u0E32\u0E23",
  "Is on": "\u0E04\u0E37\u0E2D\u0E27\u0E31\u0E19\u0E17\u0E35\u0E48",
  "Is one of the countries from the list": "\u0E40\u0E1B\u0E47\u0E19\u0E2B\u0E19\u0E36\u0E48\u0E07\u0E43\u0E19\u0E1B\u0E23\u0E30\u0E40\u0E17\u0E28\u0E08\u0E32\u0E01\u0E23\u0E32\u0E22\u0E01\u0E32\u0E23",
  "Is one of the customer segments from the list": "\u0E40\u0E1B\u0E47\u0E19\u0E2B\u0E19\u0E36\u0E48\u0E07\u0E43\u0E19\u0E01\u0E25\u0E38\u0E48\u0E21\u0E25\u0E39\u0E01\u0E04\u0E49\u0E32\u0E08\u0E32\u0E01\u0E23\u0E32\u0E22\u0E01\u0E32\u0E23",
  "Is one of the fulfillment statuses in the list": "\u0E40\u0E1B\u0E47\u0E19\u0E2B\u0E19\u0E36\u0E48\u0E07\u0E43\u0E19\u0E2A\u0E16\u0E32\u0E19\u0E30\u0E01\u0E32\u0E23\u0E1B\u0E0F\u0E34\u0E1A\u0E31\u0E15\u0E34\u0E15\u0E32\u0E21\u0E43\u0E19\u0E23\u0E32\u0E22\u0E01\u0E32\u0E23",
  "Is one of the languages from the list": "\u0E40\u0E1B\u0E47\u0E19\u0E2B\u0E19\u0E36\u0E48\u0E07\u0E43\u0E19\u0E20\u0E32\u0E29\u0E32\u0E08\u0E32\u0E01\u0E23\u0E32\u0E22\u0E01\u0E32\u0E23",
  "Is one of the methods in the list": "\u0E40\u0E1B\u0E47\u0E19\u0E2B\u0E19\u0E36\u0E48\u0E07\u0E43\u0E19\u0E27\u0E34\u0E18\u0E35\u0E01\u0E32\u0E23\u0E43\u0E19\u0E23\u0E32\u0E22\u0E01\u0E32\u0E23",
  "Is one of the payment statuses in the list": "\u0E40\u0E1B\u0E47\u0E19\u0E2B\u0E19\u0E36\u0E48\u0E07\u0E43\u0E19\u0E2A\u0E16\u0E32\u0E19\u0E30\u0E01\u0E32\u0E23\u0E0A\u0E33\u0E23\u0E30\u0E40\u0E07\u0E34\u0E19\u0E43\u0E19\u0E23\u0E32\u0E22\u0E01\u0E32\u0E23",
  "Is tagged with all the tags in the list": "\u0E15\u0E34\u0E14\u0E41\u0E17\u0E47\u0E01\u0E14\u0E49\u0E27\u0E22\u0E41\u0E17\u0E47\u0E01\u0E17\u0E31\u0E49\u0E07\u0E2B\u0E21\u0E14\u0E43\u0E19\u0E23\u0E32\u0E22\u0E01\u0E32\u0E23",
  "Is tagged with at least one of the tags in the list": "\u0E15\u0E34\u0E14\u0E41\u0E17\u0E47\u0E01\u0E14\u0E49\u0E27\u0E22\u0E2D\u0E22\u0E48\u0E32\u0E07\u0E19\u0E49\u0E2D\u0E22\u0E2B\u0E19\u0E36\u0E48\u0E07\u0E41\u0E17\u0E47\u0E01\u0E43\u0E19\u0E23\u0E32\u0E22\u0E01\u0E32\u0E23",
  "Item cost": "\u0E15\u0E49\u0E19\u0E17\u0E38\u0E19\u0E23\u0E32\u0E22\u0E01\u0E32\u0E23",
  Language: "\u0E20\u0E32\u0E29\u0E32",
  "Less than": "\u0E19\u0E49\u0E2D\u0E22\u0E01\u0E27\u0E48\u0E32",
  "Less than or equals to": "\u0E19\u0E49\u0E2D\u0E22\u0E01\u0E27\u0E48\u0E32\u0E2B\u0E23\u0E37\u0E2D\u0E40\u0E17\u0E48\u0E32\u0E01\u0E31\u0E1A",
  "Marketing consent": "\u0E04\u0E27\u0E32\u0E21\u0E22\u0E34\u0E19\u0E22\u0E2D\u0E21\u0E17\u0E32\u0E07\u0E01\u0E32\u0E23\u0E15\u0E25\u0E32\u0E14",
  Minutes: "\u0E19\u0E32\u0E17\u0E35",
  Months: "\u0E40\u0E14\u0E37\u0E2D\u0E19",
  "Number of orders": "\u0E08\u0E33\u0E19\u0E27\u0E19\u0E04\u0E33\u0E2A\u0E31\u0E48\u0E07\u0E0B\u0E37\u0E49\u0E2D",
  "On all of the post purchase pages": "\u0E17\u0E35\u0E48\u0E17\u0E38\u0E01\u0E2B\u0E19\u0E49\u0E32\u0E2B\u0E25\u0E31\u0E07\u0E01\u0E32\u0E23\u0E0B\u0E37\u0E49\u0E2D",
  "On one of the post purchase pages": "\u0E17\u0E35\u0E48\u0E2B\u0E19\u0E36\u0E48\u0E07\u0E43\u0E19\u0E2B\u0E19\u0E49\u0E32\u0E2B\u0E25\u0E31\u0E07\u0E01\u0E32\u0E23\u0E0B\u0E37\u0E49\u0E2D",
  "On the checkout": "\u0E17\u0E35\u0E48\u0E2B\u0E19\u0E49\u0E32\u0E0A\u0E33\u0E23\u0E30\u0E40\u0E07\u0E34\u0E19",
  "On the post purchase 1st page": "\u0E17\u0E35\u0E48\u0E2B\u0E19\u0E49\u0E32\u0E2B\u0E25\u0E31\u0E07\u0E01\u0E32\u0E23\u0E0B\u0E37\u0E49\u0E2D\u0E2B\u0E19\u0E49\u0E32\u0E17\u0E35\u0E48 1",
  "On the post purchase 2nd page": "\u0E17\u0E35\u0E48\u0E2B\u0E19\u0E49\u0E32\u0E2B\u0E25\u0E31\u0E07\u0E01\u0E32\u0E23\u0E0B\u0E37\u0E49\u0E2D\u0E2B\u0E19\u0E49\u0E32\u0E17\u0E35\u0E48 2",
  "On the thank you page": "\u0E17\u0E35\u0E48\u0E2B\u0E19\u0E49\u0E32\u0E02\u0E2D\u0E1A\u0E04\u0E38\u0E13",
  "Order note": "\u0E2B\u0E21\u0E32\u0E22\u0E40\u0E2B\u0E15\u0E38\u0E04\u0E33\u0E2A\u0E31\u0E48\u0E07\u0E0B\u0E37\u0E49\u0E2D",
  "Order tags": "\u0E41\u0E17\u0E47\u0E01\u0E04\u0E33\u0E2A\u0E31\u0E48\u0E07\u0E0B\u0E37\u0E49\u0E2D",
  "Passed X time ago": "\u0E1C\u0E48\u0E32\u0E19\u0E44\u0E1B\u0E41\u0E25\u0E49\u0E27 X \u0E17\u0E35\u0E48\u0E1C\u0E48\u0E32\u0E19\u0E21\u0E32",
  "Payment method": "\u0E27\u0E34\u0E18\u0E35\u0E01\u0E32\u0E23\u0E0A\u0E33\u0E23\u0E30\u0E40\u0E07\u0E34\u0E19",
  "please add cart or order value": "\u0E42\u0E1B\u0E23\u0E14\u0E40\u0E1E\u0E34\u0E48\u0E21\u0E21\u0E39\u0E25\u0E04\u0E48\u0E32\u0E15\u0E30\u0E01\u0E23\u0E49\u0E32\u0E2B\u0E23\u0E37\u0E2D\u0E04\u0E33\u0E2A\u0E31\u0E48\u0E07\u0E0B\u0E37\u0E49\u0E2D",
  "please add customer email": "\u0E42\u0E1B\u0E23\u0E14\u0E40\u0E1E\u0E34\u0E48\u0E21\u0E2D\u0E35\u0E40\u0E21\u0E25\u0E25\u0E39\u0E01\u0E04\u0E49\u0E32",
  "please add customer number of orders": "\u0E42\u0E1B\u0E23\u0E14\u0E40\u0E1E\u0E34\u0E48\u0E21\u0E08\u0E33\u0E19\u0E27\u0E19\u0E04\u0E33\u0E2A\u0E31\u0E48\u0E07\u0E0B\u0E37\u0E49\u0E2D\u0E02\u0E2D\u0E07\u0E25\u0E39\u0E01\u0E04\u0E49\u0E32",
  "please add discount code": "\u0E42\u0E1B\u0E23\u0E14\u0E40\u0E1E\u0E34\u0E48\u0E21\u0E42\u0E04\u0E49\u0E14\u0E2A\u0E48\u0E27\u0E19\u0E25\u0E14",
  "please add item cost": "\u0E01\u0E23\u0E38\u0E13\u0E32\u0E40\u0E1E\u0E34\u0E48\u0E21\u0E15\u0E49\u0E19\u0E17\u0E38\u0E19\u0E23\u0E32\u0E22\u0E01\u0E32\u0E23",
  "please add number of orders": "\u0E01\u0E23\u0E38\u0E13\u0E32\u0E40\u0E1E\u0E34\u0E48\u0E21\u0E08\u0E33\u0E19\u0E27\u0E19\u0E04\u0E33\u0E2A\u0E31\u0E48\u0E07\u0E0B\u0E37\u0E49\u0E2D",
  "please add order note": "\u0E42\u0E1B\u0E23\u0E14\u0E40\u0E1E\u0E34\u0E48\u0E21\u0E2B\u0E21\u0E32\u0E22\u0E40\u0E2B\u0E15\u0E38\u0E04\u0E33\u0E2A\u0E31\u0E48\u0E07\u0E0B\u0E37\u0E49\u0E2D",
  "please add product price": "\u0E01\u0E23\u0E38\u0E13\u0E32\u0E40\u0E1E\u0E34\u0E48\u0E21\u0E23\u0E32\u0E04\u0E32\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32",
  "please add product sku": "\u0E42\u0E1B\u0E23\u0E14\u0E40\u0E1E\u0E34\u0E48\u0E21 SKU \u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32",
  "please add product title": "\u0E42\u0E1B\u0E23\u0E14\u0E40\u0E1E\u0E34\u0E48\u0E21\u0E0A\u0E37\u0E48\u0E2D\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32",
  "please add product variant name": "\u0E42\u0E1B\u0E23\u0E14\u0E40\u0E1E\u0E34\u0E48\u0E21\u0E0A\u0E37\u0E48\u0E2D\u0E15\u0E31\u0E27\u0E40\u0E25\u0E37\u0E2D\u0E01\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32",
  "please add shipping value": "\u0E42\u0E1B\u0E23\u0E14\u0E40\u0E1E\u0E34\u0E48\u0E21\u0E04\u0E48\u0E32\u0E08\u0E31\u0E14\u0E2A\u0E48\u0E07",
  "please add time since last order": "\u0E01\u0E23\u0E38\u0E13\u0E32\u0E40\u0E1E\u0E34\u0E48\u0E21\u0E40\u0E27\u0E25\u0E32\u0E15\u0E31\u0E49\u0E07\u0E41\u0E15\u0E48\u0E04\u0E33\u0E2A\u0E31\u0E48\u0E07\u0E0B\u0E37\u0E49\u0E2D\u0E25\u0E48\u0E32\u0E2A\u0E38\u0E14",
  "please add total item count": "\u0E01\u0E23\u0E38\u0E13\u0E32\u0E40\u0E1E\u0E34\u0E48\u0E21\u0E08\u0E33\u0E19\u0E27\u0E19\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32\u0E17\u0E31\u0E49\u0E07\u0E2B\u0E21\u0E14",
  "please add value": "\u0E42\u0E1B\u0E23\u0E14\u0E40\u0E1E\u0E34\u0E48\u0E21\u0E04\u0E48\u0E32",
  "please select collections": "\u0E42\u0E1B\u0E23\u0E14\u0E40\u0E25\u0E37\u0E2D\u0E01\u0E04\u0E2D\u0E25\u0E40\u0E25\u0E01\u0E0A\u0E31\u0E19",
  "please select customer birthday": "\u0E01\u0E23\u0E38\u0E13\u0E32\u0E40\u0E25\u0E37\u0E2D\u0E01\u0E27\u0E31\u0E19\u0E40\u0E01\u0E34\u0E14\u0E25\u0E39\u0E01\u0E04\u0E49\u0E32",
  "please select customer country": "\u0E42\u0E1B\u0E23\u0E14\u0E40\u0E25\u0E37\u0E2D\u0E01\u0E1B\u0E23\u0E30\u0E40\u0E17\u0E28\u0E02\u0E2D\u0E07\u0E25\u0E39\u0E01\u0E04\u0E49\u0E32",
  "please select customer language": "\u0E42\u0E1B\u0E23\u0E14\u0E40\u0E25\u0E37\u0E2D\u0E01\u0E20\u0E32\u0E29\u0E32\u0E02\u0E2D\u0E07\u0E25\u0E39\u0E01\u0E04\u0E49\u0E32",
  "please select customer segments": "\u0E42\u0E1B\u0E23\u0E14\u0E40\u0E25\u0E37\u0E2D\u0E01\u0E01\u0E25\u0E38\u0E48\u0E21\u0E25\u0E39\u0E01\u0E04\u0E49\u0E32",
  "please select customer tag": "\u0E42\u0E1B\u0E23\u0E14\u0E40\u0E25\u0E37\u0E2D\u0E01\u0E41\u0E17\u0E47\u0E01\u0E25\u0E39\u0E01\u0E04\u0E49\u0E32",
  "please select customer tags": "\u0E01\u0E23\u0E38\u0E13\u0E32\u0E40\u0E25\u0E37\u0E2D\u0E01\u0E41\u0E17\u0E47\u0E01\u0E25\u0E39\u0E01\u0E04\u0E49\u0E32",
  "please select fulfillment statuses": "\u0E42\u0E1B\u0E23\u0E14\u0E40\u0E25\u0E37\u0E2D\u0E01\u0E2A\u0E16\u0E32\u0E19\u0E30\u0E01\u0E32\u0E23\u0E1B\u0E0F\u0E34\u0E1A\u0E31\u0E15\u0E34\u0E15\u0E32\u0E21",
  "please select offer": "\u0E42\u0E1B\u0E23\u0E14\u0E40\u0E25\u0E37\u0E2D\u0E01\u0E02\u0E49\u0E2D\u0E40\u0E2A\u0E19\u0E2D",
  "please select payment method": "\u0E01\u0E23\u0E38\u0E13\u0E32\u0E40\u0E25\u0E37\u0E2D\u0E01\u0E27\u0E34\u0E18\u0E35\u0E01\u0E32\u0E23\u0E0A\u0E33\u0E23\u0E30\u0E40\u0E07\u0E34\u0E19",
  "please select payment statuses": "\u0E01\u0E23\u0E38\u0E13\u0E32\u0E40\u0E25\u0E37\u0E2D\u0E01\u0E2A\u0E16\u0E32\u0E19\u0E30\u0E01\u0E32\u0E23\u0E0A\u0E33\u0E23\u0E30\u0E40\u0E07\u0E34\u0E19",
  "please select product type": "\u0E01\u0E23\u0E38\u0E13\u0E32\u0E40\u0E25\u0E37\u0E2D\u0E01\u0E1B\u0E23\u0E30\u0E40\u0E20\u0E17\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32",
  "please select product vendor": "\u0E01\u0E23\u0E38\u0E13\u0E32\u0E40\u0E25\u0E37\u0E2D\u0E01\u0E1C\u0E39\u0E49\u0E02\u0E32\u0E22\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32",
  "please select products": "\u0E42\u0E1B\u0E23\u0E14\u0E40\u0E25\u0E37\u0E2D\u0E01\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32",
  "please select sales channel": "\u0E42\u0E1B\u0E23\u0E14\u0E40\u0E25\u0E37\u0E2D\u0E01\u0E0A\u0E48\u0E2D\u0E07\u0E17\u0E32\u0E07\u0E01\u0E32\u0E23\u0E02\u0E32\u0E22",
  "please select shipping methods": "\u0E42\u0E1B\u0E23\u0E14\u0E40\u0E25\u0E37\u0E2D\u0E01\u0E27\u0E34\u0E18\u0E35\u0E01\u0E32\u0E23\u0E08\u0E31\u0E14\u0E2A\u0E48\u0E07",
  "please select tags": "\u0E42\u0E1B\u0E23\u0E14\u0E40\u0E25\u0E37\u0E2D\u0E01\u0E41\u0E17\u0E47\u0E01",
  "Previous page offer": "\u0E02\u0E49\u0E2D\u0E40\u0E2A\u0E19\u0E2D\u0E08\u0E32\u0E01\u0E2B\u0E19\u0E49\u0E32\u0E01\u0E48\u0E2D\u0E19\u0E2B\u0E19\u0E49\u0E32",
  product: "\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32",
  "Product recommendations": "\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32\u0E41\u0E19\u0E30\u0E19\u0E33",
  "Product type": "\u0E1B\u0E23\u0E30\u0E40\u0E20\u0E17\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32",
  "Product upsell": "\u0E2D\u0E31\u0E1B\u0E40\u0E0B\u0E25\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32",
  products: "\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32",
  "Requires shipping": "\u0E15\u0E49\u0E2D\u0E07\u0E21\u0E35\u0E01\u0E32\u0E23\u0E08\u0E31\u0E14\u0E2A\u0E48\u0E07",
  "Shipping method": "\u0E27\u0E34\u0E18\u0E35\u0E01\u0E32\u0E23\u0E08\u0E31\u0E14\u0E2A\u0E48\u0E07",
  "Shipping value": "\u0E04\u0E48\u0E32\u0E08\u0E31\u0E14\u0E2A\u0E48\u0E07",
  "Starts with": "\u0E40\u0E23\u0E34\u0E48\u0E21\u0E15\u0E49\u0E19\u0E14\u0E49\u0E27\u0E22",
  Status: "\u0E2A\u0E16\u0E32\u0E19\u0E30",
  "The displayed product": "\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32\u0E17\u0E35\u0E48\u0E41\u0E2A\u0E14\u0E07",
  "The displayed product SKU": "SKU \u0E02\u0E2D\u0E07\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32\u0E17\u0E35\u0E48\u0E41\u0E2A\u0E14\u0E07",
  "The only product title in the cart": "\u0E0A\u0E37\u0E48\u0E2D\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32\u0E40\u0E1E\u0E35\u0E22\u0E07\u0E23\u0E32\u0E22\u0E01\u0E32\u0E23\u0E40\u0E14\u0E35\u0E22\u0E27\u0E43\u0E19\u0E15\u0E30\u0E01\u0E23\u0E49\u0E32",
  "The only SKU in the cart": "SKU \u0E40\u0E1E\u0E35\u0E22\u0E07\u0E23\u0E32\u0E22\u0E01\u0E32\u0E23\u0E40\u0E14\u0E35\u0E22\u0E27\u0E43\u0E19\u0E15\u0E30\u0E01\u0E23\u0E49\u0E32",
  "The SKU of all products in the cart": "SKU \u0E02\u0E2D\u0E07\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32\u0E17\u0E38\u0E01\u0E23\u0E32\u0E22\u0E01\u0E32\u0E23\u0E43\u0E19\u0E15\u0E30\u0E01\u0E23\u0E49\u0E32",
  "The SKU of at least one product in the cart": "SKU \u0E02\u0E2D\u0E07\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32\u0E2D\u0E22\u0E48\u0E32\u0E07\u0E19\u0E49\u0E2D\u0E22\u0E2B\u0E19\u0E36\u0E48\u0E07\u0E23\u0E32\u0E22\u0E01\u0E32\u0E23\u0E43\u0E19\u0E15\u0E30\u0E01\u0E23\u0E49\u0E32",
  "The title of all products in the cart": "\u0E0A\u0E37\u0E48\u0E2D\u0E02\u0E2D\u0E07\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32\u0E17\u0E38\u0E01\u0E23\u0E32\u0E22\u0E01\u0E32\u0E23\u0E43\u0E19\u0E15\u0E30\u0E01\u0E23\u0E49\u0E32",
  "The title of at least one product in the cart": "\u0E0A\u0E37\u0E48\u0E2D\u0E02\u0E2D\u0E07\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32\u0E2D\u0E22\u0E48\u0E32\u0E07\u0E19\u0E49\u0E2D\u0E22\u0E2B\u0E19\u0E36\u0E48\u0E07\u0E23\u0E32\u0E22\u0E01\u0E32\u0E23\u0E43\u0E19\u0E15\u0E30\u0E01\u0E23\u0E49\u0E32",
  "The title of the displayed product": "\u0E0A\u0E37\u0E48\u0E2D\u0E02\u0E2D\u0E07\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32\u0E17\u0E35\u0E48\u0E41\u0E2A\u0E14\u0E07",
  "The variant of all products in the cart": "\u0E15\u0E31\u0E27\u0E40\u0E25\u0E37\u0E2D\u0E01\u0E02\u0E2D\u0E07\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32\u0E17\u0E38\u0E01\u0E23\u0E32\u0E22\u0E01\u0E32\u0E23\u0E43\u0E19\u0E15\u0E30\u0E01\u0E23\u0E49\u0E32",
  "The variant of at least one product in the cart": "\u0E15\u0E31\u0E27\u0E40\u0E25\u0E37\u0E2D\u0E01\u0E02\u0E2D\u0E07\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32\u0E2D\u0E22\u0E48\u0E32\u0E07\u0E19\u0E49\u0E2D\u0E22\u0E2B\u0E19\u0E36\u0E48\u0E07\u0E23\u0E32\u0E22\u0E01\u0E32\u0E23\u0E43\u0E19\u0E15\u0E30\u0E01\u0E23\u0E49\u0E32",
  "The variant of only product in the cart": "\u0E15\u0E31\u0E27\u0E40\u0E25\u0E37\u0E2D\u0E01\u0E02\u0E2D\u0E07\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32\u0E40\u0E1E\u0E35\u0E22\u0E07\u0E23\u0E32\u0E22\u0E01\u0E32\u0E23\u0E40\u0E14\u0E35\u0E22\u0E27\u0E43\u0E19\u0E15\u0E30\u0E01\u0E23\u0E49\u0E32",
  "The variant of the displayed product": "\u0E15\u0E31\u0E27\u0E40\u0E25\u0E37\u0E2D\u0E01\u0E02\u0E2D\u0E07\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32\u0E17\u0E35\u0E48\u0E41\u0E2A\u0E14\u0E07",
  "Total item count": "\u0E08\u0E33\u0E19\u0E27\u0E19\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32\u0E17\u0E31\u0E49\u0E07\u0E2B\u0E21\u0E14",
  Weeks: "\u0E2A\u0E31\u0E1B\u0E14\u0E32\u0E2B\u0E4C",
  Years: "\u0E1B\u0E35"
};

// src/utils/i18n.ts
var initI18n = async (language = "en") => {
  if (i18next.isInitialized) {
    i18next.changeLanguage(language);
    return i18next;
  }
  await i18next.use(HttpBackend).init({
    lng: language,
    fallbackLng: "en",
    resources: {
      en: {
        translation: en_default
      },
      es: {
        translation: es_default
      },
      "he_IL": {
        translation: he_IL_default
      },
      "pt-BR": {
        translation: pt_BR_default
      },
      de: {
        translation: de_default
      },
      fr: {
        translation: fr_default
      },
      it: {
        translation: it_default
      },
      "zh-CN": {
        translation: zh_CN_default
      },
      "zh-TW": {
        translation: zh_TW_default
      },
      "ja": {
        translation: ja_default
      },
      "ko": {
        translation: ko_default
      },
      "sv": {
        translation: sv_default
      },
      "pl": {
        translation: pl_default
      },
      "cs": {
        translation: cs_default
      },
      "da": {
        translation: da_default
      },
      "id": {
        translation: id_default
      },
      "lt": {
        translation: lt_default
      },
      "hu": {
        translation: hu_default
      },
      "nl": {
        translation: nl_default
      },
      "no": {
        translation: no_default
      },
      "ro": {
        translation: ro_default
      },
      "fi": {
        translation: fi_default
      },
      "tr": {
        translation: tr_default
      },
      "el": {
        translation: el_default
      },
      "ru": {
        translation: ru_default
      },
      "bg": {
        translation: bg_default
      },
      "hi": {
        translation: hi_default
      },
      "th": {
        translation: th_default
      }
    },
    interpolation: {
      escapeValue: false
    }
  });
  return i18next;
};
var t = (key, options) => {
  return i18next.t(key, options);
};

// src/flow/getConditionText.ts
var getConditionsMetaData = (platform) => {
  return {
    ["SPECIFIC_PRODUCT" /* SPECIFIC_PRODUCT */]: {
      operatorOne: [
        {
          value: "atLeastOneProduct",
          label: t("At least one product in the cart")
        },
        {
          value: "entireOrder",
          label: t("Every product in the cart")
        },
        {
          value: "entireProduct",
          label: t("The displayed product")
        }
      ],
      operatorTwo: [
        {
          value: "is",
          label: t("Is from the list")
        },
        {
          value: "isNot",
          label: t("Is not from the list")
        }
      ]
    },
    ["PRODUCT_COLLECTION" /* PRODUCT_COLLECTION */]: {
      operatorOne: [
        {
          value: "atLeastOneProduct",
          label: t("At least one product in the cart")
        },
        {
          value: "entireOrder",
          label: t("Every product in the cart")
        },
        {
          value: "entireProduct",
          label: t("The displayed product")
        }
      ],
      operatorTwo: [
        {
          value: "is",
          label: platform && platform === "wix" /* WIX */ ? t("Is in a category from the list") : t("Is in a collection from the list")
        },
        {
          value: "isNot",
          label: platform && platform === "wix" /* WIX */ ? t("Is not in a category from the list") : t("Is not in a collection from the list")
        }
      ]
    },
    ["PRODUCT_TAGS" /* PRODUCT_TAGS */]: {
      operatorOne: [
        {
          value: "atLeastOneProduct",
          label: t("At least one product in the cart")
        },
        {
          value: "entireOrder",
          label: t("Every product in the cart")
        },
        {
          value: "entireProduct",
          label: t("The displayed product")
        }
      ],
      operatorTwo: [
        {
          value: "hasAtLeastOne",
          label: t("Has at least one of the tags from the list")
        },
        {
          value: "hasAll",
          label: t("Has all the tags from the list")
        },
        {
          value: "notHaveAnyOne",
          label: t("Doesn't have some of the tags from the list")
        },
        {
          value: "notHaveAll",
          label: t("Doesn't have all the tags from the list")
        }
      ]
    },
    ["PRODUCT_TITLE" /* PRODUCT_TITLE */]: {
      operatorOne: [
        {
          value: "atLeastOneProduct",
          label: t("The title of at least one product in the cart")
        },
        {
          value: "entireOrder",
          label: t("The title of all products in the cart")
        },
        {
          value: "onlyProduct",
          label: t("The only product title in the cart")
        },
        {
          value: "entireProduct",
          label: t("The title of the displayed product")
        }
      ],
      operatorTwo: [
        {
          value: "startWith",
          label: t("Starts with")
        },
        {
          value: "notStartWith",
          label: t("Doesn't start with")
        },
        {
          value: "endWith",
          label: t("Ends with")
        },
        {
          value: "notEndWith",
          label: t("Doesn't end with")
        },
        {
          value: "contains",
          label: t("Contains")
        },
        {
          value: "notContains",
          label: t("Doesn't contain")
        },
        {
          value: "isExactSame",
          label: t("Is (exact title)")
        },
        {
          value: "isNotExactSame",
          label: t("Is not (exact title)")
        }
      ]
    },
    ["DISCOUNT_CODE" /* DISCOUNT_CODE */]: {
      operatorOne: [],
      operatorTwo: [
        {
          value: "startWith",
          label: t("Starts with")
        },
        {
          value: "notStartWith",
          label: t("Doesn't start with")
        },
        {
          value: "endWith",
          label: t("Ends with")
        },
        {
          value: "notEndWith",
          label: t("Doesn't end with")
        },
        {
          value: "contains",
          label: t("Contains")
        },
        {
          value: "notContains",
          label: t("Doesn't contain")
        },
        {
          value: "isExactSame",
          label: t("Is (exact code)")
        },
        {
          value: "isNotExactSame",
          label: t("Is not (exact code)")
        }
      ]
    },
    ["PRODUCT_SKU" /* PRODUCT_SKU */]: {
      operatorOne: [
        {
          value: "atLeastOneProduct",
          label: t("The SKU of at least one product in the cart")
        },
        {
          value: "entireOrder",
          label: t("The SKU of all products in the cart")
        },
        {
          value: "onlyProduct",
          label: t("The only SKU in the cart")
        },
        {
          value: "entireProduct",
          label: t("The displayed product SKU")
        }
      ],
      operatorTwo: [
        {
          value: "startWith",
          label: t("Starts with")
        },
        {
          value: "notStartWith",
          label: t("Doesn't start with")
        },
        {
          value: "endWith",
          label: t("Ends with")
        },
        {
          value: "notEndWith",
          label: t("Doesn't end with")
        },
        {
          value: "contains",
          label: t("Contains")
        },
        {
          value: "notContains",
          label: t("Doesn't contain")
        },
        {
          value: "isExactSame",
          label: t("Is (exact sku)")
        },
        {
          value: "isNotExactSame",
          label: t("Is not (exact sku)")
        }
      ]
    },
    ["CART_OR_ORDER_VALUE" /* CART_OR_ORDER_VALUE */]: {
      operatorOne: [],
      operatorTwo: [
        {
          value: "eql",
          label: t("Equal to")
        },
        {
          value: "notEql",
          label: t("Is not equal to")
        },
        {
          value: "grtThan",
          label: t("Greater than")
        },
        {
          value: "grtOrEql",
          label: t("Greater than or equals to")
        },
        {
          value: "ls",
          label: t("Less than")
        },
        {
          value: "lsOrEql",
          label: t("Less than or equals to")
        },
        {
          value: "between",
          label: t("Between")
        },
        {
          value: "notBetween",
          label: t("Is not between")
        }
      ]
    },
    ["PRODUCT_VARIANT_NAME" /* PRODUCT_VARIANT_NAME */]: {
      operatorOne: [
        {
          value: "atLeastOneProduct",
          label: t("The variant of at least one product in the cart")
        },
        {
          value: "entireOrder",
          label: t("The variant of all products in the cart")
        },
        {
          value: "onlyProduct",
          label: t("The variant of only product in the cart")
        },
        {
          value: "entireProduct",
          label: t("The variant of the displayed product")
        }
      ],
      operatorTwo: [
        {
          value: "startWith",
          label: t("Starts with")
        },
        {
          value: "notStartWith",
          label: t("Doesn't start with")
        },
        {
          value: "endWith",
          label: t("Ends with")
        },
        {
          value: "notEndWith",
          label: t("Doesn't end with")
        },
        {
          value: "contains",
          label: t("Contains")
        },
        {
          value: "notContains",
          label: t("Doesn't contain")
        },
        {
          value: "isExactSame",
          label: t("Is (exact variant name)")
        },
        {
          value: "isNotExactSame",
          label: t("Is not (exact variant name)")
        }
      ]
    },
    ["PRODUCT_SALES_CHANNEL" /* PRODUCT_SALES_CHANNEL */]: {
      operatorOne: [
        {
          value: "atLeastOneProduct",
          label: t("At least one product in the cart")
        },
        {
          value: "entireOrder",
          label: t("All products in the cart")
        }
      ],
      operatorTwo: [
        {
          value: "isAvailableAtOneOfTheSalesChannelsFromTheList",
          label: t("Is available at one of the sales channels from the list")
        },
        {
          value: "isAvailableAtAllTheSalesChannelsFromTheList",
          label: t("Is available at all the sales channels from the list")
        },
        {
          value: "isNotAvailableAtOneOfTheSalesChannelsFromTheList",
          label: t("Is not available at one of the sales channels from the list")
        },
        {
          value: "isNotAvailableAtAllTheSalesChannelsFromTheList",
          label: t("Is not available at all the sales channels from the list")
        },
        {
          value: "areAvailableAtOneOfTheSalesChannelsFromTheList",
          label: t("Are available at one of the sales channels from the list")
        },
        {
          value: "areAvailableAtAllTheSalesChannelsFromTheList",
          label: t("Are available at all the sales channels from the list")
        },
        {
          value: "areNotAvailableAtOneOfTheSalesChannelsFromTheList",
          label: t("Are not available at one of the sales channels from the list")
        },
        {
          value: "areNotAvailableAtAllTheSalesChannelsFromTheList",
          label: t("Are not available at all the sales channels from the list")
        }
      ]
    },
    ["PRODUCT_PRICE" /* PRODUCT_PRICE */]: {
      operatorOne: [
        {
          value: "atLeastOneProduct",
          label: t("At least one product in the cart")
        },
        {
          value: "entireOrder",
          label: t("Every product in the cart")
        }
      ],
      operatorTwo: [
        {
          value: "eql",
          label: t("Equals")
        },
        {
          value: "notEql",
          label: t("Is not equal to")
        },
        {
          value: "grtThan",
          label: t("Is greater than")
        },
        {
          value: "grtOrEql",
          label: t("Is greater than or equals to")
        },
        {
          value: "ls",
          label: t("Is less than")
        },
        {
          value: "lsOrEql",
          label: t("Is less than or equals to")
        },
        {
          value: "between",
          label: t("Is between")
        },
        {
          value: "notBetween",
          label: t("Is not between")
        }
      ]
    },
    ["CUSTOMER_LANGUAGE" /* CUSTOMER_LANGUAGE */]: {
      operatorOne: [],
      operatorTwo: [
        {
          value: "containsAtLeastOne",
          label: t("Is one of the languages from the list")
        },
        {
          value: "notContainsAtLeastOne",
          label: t("Is not one of the languages from the list")
        }
      ]
    },
    ["CUSTOMER_COUNTRY" /* CUSTOMER_COUNTRY */]: {
      operatorOne: [],
      operatorTwo: [
        {
          value: "containsAtLeastOne",
          label: t("Is one of the countries from the list")
        },
        {
          value: "notContainsAtLeastOne",
          label: t("Is not one of the countries from the list")
        }
      ]
    },
    ["PREV_PAGE_OFFER" /* PREV_PAGE_OFFER */]: {
      operatorOne: [
        {
          value: "accepted",
          label: t("An offer was accepted")
        },
        {
          value: "declined",
          label: t("An offer was declined")
        }
      ],
      operatorTwo: [
        {
          value: PageType?.CHECKOUT,
          label: t("On the checkout")
        },
        {
          value: PageType?.POST_PURCHASE_PAGE1,
          label: t("On the post purchase 1st page")
        },
        {
          value: PageType?.POST_PURCHASE_PAGE2,
          label: t("On the post purchase 2nd page")
        },
        {
          value: `${PageType?.POST_PURCHASE_PAGE1}-${PageType?.POST_PURCHASE_PAGE2}`,
          label: t("On one of the post purchase pages")
        },
        {
          value: `${PageType?.POST_PURCHASE_PAGE1}&${PageType?.POST_PURCHASE_PAGE2}`,
          label: t("On all of the post purchase pages")
        },
        {
          value: PageType?.THANK_YOU_PAGE,
          label: t("On the thank you page")
        }
      ]
    },
    ["CUSTOMER_EMAIL" /* CUSTOMER_EMAIL */]: {
      operatorOne: [],
      operatorTwo: [
        {
          value: "startWith",
          label: t("Starts with")
        },
        {
          value: "notStartWith",
          label: t("Doesn't start with")
        },
        {
          value: "endWith",
          label: t("Ends with")
        },
        {
          value: "notEndWith",
          label: t("Doesn't end with")
        },
        {
          value: "contains",
          label: t("Contains")
        },
        {
          value: "notContains",
          label: t("Doesn't contain")
        },
        {
          value: "isExactSame",
          label: t("Is (exact email)")
        },
        {
          value: "isNotExactSame",
          label: t("Is not (exact email)")
        }
      ]
    },
    ["CUSTOMER_NUMBER_OF_ORDERS" /* CUSTOMER_NUMBER_OF_ORDERS */]: {
      operatorOne: [],
      operatorTwo: [
        {
          value: "eql",
          label: t("Equal to")
        },
        {
          value: "notEql",
          label: t("Is not equal to")
        },
        {
          value: "grtThan",
          label: t("Greater than")
        },
        {
          value: "grtOrEql",
          label: t("Greater than or equals to")
        },
        {
          value: "ls",
          label: t("Less than")
        },
        {
          value: "lsOrEql",
          label: t("Less than or equals to")
        },
        {
          value: "between",
          label: t("Between")
        },
        {
          value: "notBetween",
          label: t("Is not between")
        }
      ]
    },
    ["CUSTOMER_TAG" /* CUSTOMER_TAG */]: {
      operatorOne: [],
      operatorTwo: [
        {
          value: "containsAtLeastOneWithAtLeastOneTag",
          label: t("customer has at least one of the tags from the list ")
        },
        {
          value: "containsAtLeastOneWithAllTags",
          label: t("customer has all the tags from the list")
        },
        {
          value: "containsAtLeastOneWithoutAnyTag",
          label: t("customer doesn\u2019t have any of the tags from the list")
        },
        {
          value: "containsAtLeastOneWithoutAllTags",
          label: t("customer doesn\u2019t have all the tags from the list")
        }
      ]
    },
    ["CUSTOMER_SEGMENTS" /* CUSTOMER_SEGMENTS */]: {
      operatorOne: [],
      operatorTwo: [
        {
          value: "containsAtLeastOne",
          label: t("Is one of the customer segments from the list")
        },
        {
          value: "notContainsAtLeastOne",
          label: t("Is not one of the customer segments from the list")
        }
      ]
    },
    ["MARKETING_CONSENT" /* MARKETING_CONSENT */]: {
      operatorOne: [],
      operatorTwo: [
        {
          value: "is",
          label: t("Customer accepted marketing")
        },
        {
          value: "isNot",
          label: t("Customer don't accepted marketing")
        }
      ]
    },
    ["TOTAL_ITEM_COUNT" /* TOTAL_ITEM_COUNT */]: {
      operatorOne: [],
      operatorTwo: [
        {
          value: "eql",
          label: t("Equals")
        },
        {
          value: "notEql",
          label: t("Is not equal to")
        },
        {
          value: "grtThan",
          label: t("Is greater than")
        },
        {
          value: "grtOrEql",
          label: t("Is greater than or equal to")
        },
        {
          value: "ls",
          label: t("Is less than")
        },
        {
          value: "lsOrEql",
          label: t("Is less than or equal to")
        },
        {
          value: "between",
          label: t("Is between")
        },
        {
          value: "notBetween",
          label: t("Is not between")
        }
      ]
    },
    ["PHYSICAL_PRODUCT_OR_REQUIRE_SHIPPING" /* PHYSICAL_PRODUCT_OR_REQUIRE_SHIPPING */]: {
      operatorOne: [
        {
          value: "atLeastOneProduct",
          label: t("At least one product in the cart")
        },
        {
          value: "entireOrder",
          label: t("Every product in the cart")
        }
      ],
      operatorTwo: [
        {
          value: "is",
          label: t("Requires shipping")
        },
        {
          value: "isNot",
          label: t("Does not require shipping")
        }
      ]
    },
    ["SHIPPING_VALUE" /* SHIPPING_VALUE */]: {
      operatorOne: [],
      operatorTwo: [
        {
          value: "eql",
          label: t("Equals")
        },
        {
          value: "notEql",
          label: t("Is not equal to")
        },
        {
          value: "grtThan",
          label: t("Is greater than")
        },
        {
          value: "grtOrEql",
          label: t("Is greater than or equals to")
        },
        {
          value: "ls",
          label: t("Is less than")
        },
        {
          value: "lsOrEql",
          label: t("Is less than or equals to")
        },
        {
          value: "between",
          label: t("Is between")
        },
        {
          value: "notBetween",
          label: t("Is not between")
        }
      ]
    },
    ["ORDER_NOTE" /* ORDER_NOTE */]: {
      operatorOne: [],
      operatorTwo: [
        {
          value: "startWith",
          label: t("Starts with")
        },
        {
          value: "notStartWith",
          label: t("Doesn't start with")
        },
        {
          value: "endWith",
          label: t("Ends with")
        },
        {
          value: "notEndWith",
          label: t("Doesn't end with")
        },
        {
          value: "contains",
          label: t("Contains")
        },
        {
          value: "notContains",
          label: t("Doesn't contain")
        },
        {
          value: "isExactSame",
          label: t("Is (exact code)")
        },
        {
          value: "isNotExactSame",
          label: t("Is not (exact code)")
        }
      ]
    },
    ["PAYMENT_METHOD" /* PAYMENT_METHOD */]: {
      operatorOne: [],
      operatorTwo: [
        {
          value: "containsAtLeastOne",
          label: t("Is one of the methods in the list")
        },
        {
          value: "notContainsAtLeastOne",
          label: t("Is not one of the methods in the list")
        }
      ]
    },
    ["PRODUCT_TYPE" /* PRODUCT_TYPE */]: {
      operatorOne: [
        {
          value: "atLeastOneProduct",
          label: t("At least one product in the cart")
        },
        {
          value: "entireOrder",
          label: t("Every product in the cart")
        }
      ],
      operatorTwo: [
        {
          value: "is",
          label: t("Is of a type from the list")
        },
        {
          value: "isNot",
          label: t("Is not of a type from the list")
        }
      ]
    },
    ["PRODUCT_VENDOR" /* PRODUCT_VENDOR */]: {
      operatorOne: [
        {
          value: "atLeastOneProduct",
          label: t("At least one product in the cart")
        },
        {
          value: "entireOrder",
          label: t("Every product in the cart")
        }
      ],
      operatorTwo: [
        {
          value: "is",
          label: t("Is from a vendor in the list")
        },
        {
          value: "isNot",
          label: t("Is not from a vendor in the list")
        }
      ]
    },
    ["PRODUCT_IS_AVAILABLE_AT_SALES_CHANNEL" /* PRODUCT_IS_AVAILABLE_AT_SALES_CHANNEL */]: {
      operatorOne: [
        {
          value: "atLeastOneProduct",
          label: t("At least one product in the cart")
        },
        {
          value: "entireOrder",
          label: t("Every product in the cart")
        }
      ],
      operatorTwo: [
        {
          value: "isAvailableAtOneOfTheSalesChannelsFromTheList",
          label: t("Is available at one of the sales channels in the list")
        },
        {
          value: "isNotAvailableAtOneOfTheSalesChannelsFromTheList",
          label: t("Is not available at one of the sales channels in the list")
        },
        {
          value: "isAvailableAtAllTheSalesChannelsFromTheList",
          label: t("Is available at all the sales channels in the list")
        },
        {
          value: "isNotAvailableAtAllTheSalesChannelsFromTheList",
          label: t("Is not available at all the sales channels in the list")
        }
      ]
    },
    ["FULFILLMENT_STATUS" /* FULFILLMENT_STATUS */]: {
      operatorOne: [],
      operatorTwo: [
        {
          value: "containsAtLeastOne",
          label: t("Is one of the fulfillment statuses in the list")
        },
        {
          value: "notContainsAtLeastOne",
          label: t("Is not one of the fulfillment statuses in the list")
        }
      ]
    },
    ["PAYMENT_STATUS" /* PAYMENT_STATUS */]: {
      operatorOne: [],
      operatorTwo: [
        {
          value: "containsAtLeastOne",
          label: t("Is one of the payment statuses in the list")
        },
        {
          value: "notContainsAtLeastOne",
          label: t("Is not one of the payment statuses in the list")
        }
      ]
    },
    ["SHIPPING_METHOD" /* SHIPPING_METHOD */]: {
      operatorOne: [],
      operatorTwo: [
        {
          value: "containsAtLeastOne",
          label: t("Is one of the methods in the list")
        },
        {
          value: "notContainsAtLeastOne",
          label: t("Is not one of the methods in the list")
        }
      ]
    },
    ["ORDER_TAGS" /* ORDER_TAGS */]: {
      operatorOne: [],
      operatorTwo: [
        {
          value: "hasAtLeastOne",
          label: t("Is tagged with at least one of the tags in the list")
        },
        {
          value: "hasAll",
          label: t("Is tagged with all the tags in the list")
        },
        {
          value: "notHaveAll",
          label: t("Is not tagged with any of the tags in the list")
        }
      ]
    },
    ["PRODUCT_ITEM_COST" /* PRODUCT_ITEM_COST */]: {
      operatorOne: [
        {
          value: "atLeastOneProduct",
          label: t("At least one product in the cart")
        },
        {
          value: "entireOrder",
          label: t("Every product in the cart")
        }
      ],
      operatorTwo: [
        {
          value: "eql",
          label: t("Equals")
        },
        {
          value: "notEql",
          label: t("Is not equal to")
        },
        {
          value: "grtThan",
          label: t("Is greater than")
        },
        {
          value: "grtOrEql",
          label: t("Is greater than or equals to")
        },
        {
          value: "ls",
          label: t("Is less than")
        },
        {
          value: "lsOrEql",
          label: t("Is less than or equals to")
        },
        {
          value: "between",
          label: t("Is between")
        },
        {
          value: "notBetween",
          label: t("Is not between")
        }
      ]
    },
    ["CUSTOMER_TAGS" /* CUSTOMER_TAGS */]: {
      operatorOne: [],
      operatorTwo: [
        {
          value: "hasAtLeastOne",
          label: t("Is tagged with at least one of the tags in the list")
        },
        {
          value: "hasAll",
          label: t("Is tagged with all the tags in the list")
        },
        {
          value: "notHaveAtLeastOne",
          label: t("Is not tagged with at least one of the tags in the list")
        },
        {
          value: "notHaveAll",
          label: t("Is not tagged with all the tags in the list")
        }
      ]
    },
    ["CUSTOMER_TIME_SINCE_LAST_ORDER" /* CUSTOMER_TIME_SINCE_LAST_ORDER */]: {
      operatorOne: [
        {
          value: "grtThan",
          label: t("Greater than")
        },
        {
          value: "ls",
          label: t("Less than")
        },
        {
          value: "between",
          label: t("Between")
        },
        {
          value: "notBetween",
          label: t("Is not between")
        }
      ],
      operatorTwo: [
        {
          value: "MINUTES",
          label: t("Minutes")
        },
        {
          value: "HOURS",
          label: t("Hours")
        },
        {
          value: "DAYS",
          label: t("Days")
        },
        {
          value: "WEEKS",
          label: t("Weeks")
        },
        {
          value: "MONTHS",
          label: t("Months")
        },
        {
          value: "YEARS",
          label: t("Years")
        }
      ]
    },
    ["CUSTOMER_BIRTHDAY" /* CUSTOMER_BIRTHDAY */]: {
      operatorOne: [
        {
          value: "on",
          label: t("Is on")
        },
        {
          value: "notOn",
          label: t("Is not on")
        },
        {
          value: "before",
          label: t("Is before")
        },
        {
          value: "after",
          label: t("Is after")
        },
        {
          value: "between",
          label: t("Between")
        },
        {
          value: "notBetween",
          label: t("Not between")
        },
        {
          value: "lessThan",
          label: t("in less than")
        },
        {
          value: "elapsed",
          label: t("Passed X time ago")
        }
      ],
      operatorTwo: [
        {
          value: "DAYS",
          label: t("Days")
        },
        {
          value: "WEEKS",
          label: t("Weeks")
        },
        {
          value: "MONTHS",
          label: t("Months")
        }
      ]
    }
  };
};
var getConditionText = (conditionRule, currencyFormatter, platform, options) => {
  const showEmptyValueMessage = options?.showEmptyValueMessage ?? false;
  const showEmptyValueMessageWithAnnotation = options?.showEmptyValueMessageWithAnnotation ?? false;
  const showSpecificProductNames = options?.showSpecificProductNames ?? false;
  const withAnnotation = options?.withAnnotation ?? false;
  const hideProductAndCollectionCount = options?.hideProductAndCollectionCount ?? false;
  const conditionKey = conditionRule?.fact;
  const value = conditionRule?.value;
  const extraFields = conditionRule?.extraFields;
  const conditionMetaData = getConditionsMetaData(platform);
  const operatorOne = conditionMetaData[conditionKey]?.operatorOne?.find(
    (val) => val?.value === conditionRule?.extraFields?.condition
  )?.label;
  const operatorOneValue = conditionMetaData[conditionKey]?.operatorOne?.find(
    (val) => val?.value === conditionRule?.extraFields?.condition
  )?.value;
  const operatorTwo = conditionMetaData[conditionKey]?.operatorTwo?.find(
    (val) => val?.value === conditionRule?.extraFields?.operatorValue
  )?.label?.toLocaleLowerCase();
  const joinItems = (items) => items?.join(", ") || "";
  const formatValue = (val) => withAnnotation ? `<span style="font-weight: 600;">${val}</span>` : val;
  const hasSpecificProductIds = conditionRule?.fact === "SPECIFIC_PRODUCT" /* SPECIFIC_PRODUCT */ && Array.isArray(conditionRule?.extraFields?.productIds) && conditionRule.extraFields.productIds.length > 0;
  if (showEmptyValueMessage && (!conditionRule?.value || conditionRule?.value?.length === 0) && !hasSpecificProductIds) {
    return `${EmptyValueMessage(conditionRule?.fact, operatorOne, operatorTwo, showEmptyValueMessageWithAnnotation)}`;
  }
  const conditionMessages = {
    ["SPECIFIC_PRODUCT" /* SPECIFIC_PRODUCT */]: () => {
      const productCount = extraFields?.productIds?.length || 0;
      if (hideProductAndCollectionCount) {
        return `${operatorOne} ${operatorTwo}`;
      }
      return showSpecificProductNames ? `${operatorOne} ${operatorTwo}  ${formatValue(joinItems(extraFields?.itemsInfo))}` : `${operatorOne} ${operatorTwo} ${formatValue(`${productCount} ${productCount !== 1 ? t("products") : t("product")}`)}`;
    },
    ["PRODUCT_COLLECTION" /* PRODUCT_COLLECTION */]: () => {
      const collectionCount = extraFields?.productCollections?.length || 0;
      if (hideProductAndCollectionCount) {
        return `${operatorOne} ${operatorTwo}`;
      }
      return showSpecificProductNames ? `${operatorOne} ${operatorTwo} ${formatValue(joinItems(extraFields?.itemsInfo))}` : `${operatorOne} ${operatorTwo} ${formatValue(
        `${collectionCount} ${platform && platform === "wix" /* WIX */ ? collectionCount > 1 ? t("categories") : t("category") : `${collectionCount !== 1 ? t("collections") : t("collection")}`}`
      )}`;
    },
    ["PRODUCT_TAGS" /* PRODUCT_TAGS */]: () => `${operatorOne} ${operatorTwo} ${formatValue(joinItems(extraFields?.itemsInfo))}`,
    ["PRODUCT_TITLE" /* PRODUCT_TITLE */]: () => `${operatorOne} ${operatorTwo} ${formatValue(value)}`,
    ["PRODUCT_SKU" /* PRODUCT_SKU */]: () => `${operatorOne} ${operatorTwo} ${formatValue(value)}`,
    ["PRODUCT_VARIANT_NAME" /* PRODUCT_VARIANT_NAME */]: () => `${operatorOne} ${operatorTwo} ${formatValue(value)}`,
    ["PRODUCT_SALES_CHANNEL" /* PRODUCT_SALES_CHANNEL */]: () => `${operatorOne} ${operatorTwo} ${formatValue(value)}`,
    ["PRODUCT_PRICE" /* PRODUCT_PRICE */]: () => {
      const formattedValue = value?.length ? `${currencyFormatter(value[0])} ${t("and")} ${currencyFormatter(value[1])}` : `${currencyFormatter(value)}`;
      return `${operatorOne} ${operatorTwo} ${formatValue(formattedValue)}`;
    },
    ["CART_OR_ORDER_VALUE" /* CART_OR_ORDER_VALUE */]: () => {
      const formattedValue = value?.length > 0 ? `${currencyFormatter(value[0])} ${t("and")} ${currencyFormatter(value[1])}` : `${currencyFormatter(value)}`;
      return `${t("Cart/Order value")} ${operatorTwo} ${formatValue(formattedValue)}`;
    },
    ["CUSTOMER_COUNTRY" /* CUSTOMER_COUNTRY */]: () => `${t("Customer country")} ${operatorTwo} ${formatValue(joinItems(extraFields?.itemsInfo))}`,
    ["CUSTOMER_SEGMENTS" /* CUSTOMER_SEGMENTS */]: () => `${t("Customer segments")} ${operatorTwo} ${formatValue(joinItems(extraFields?.itemsInfo))}`,
    ["CUSTOMER_LANGUAGE" /* CUSTOMER_LANGUAGE */]: () => `${t("Language")} ${operatorTwo} ${formatValue(joinItems(extraFields?.itemsInfo))}`,
    ["DISCOUNT_CODE" /* DISCOUNT_CODE */]: () => `${t("Discount code")} ${operatorTwo} ${formatValue(value)}`,
    ["PREV_PAGE_OFFER" /* PREV_PAGE_OFFER */]: () => `${operatorOne} ${operatorTwo}`,
    ["CUSTOMER_EMAIL" /* CUSTOMER_EMAIL */]: () => `${t("Customer email")} ${operatorTwo} ${formatValue(value)}`,
    ["CUSTOMER_NUMBER_OF_ORDERS" /* CUSTOMER_NUMBER_OF_ORDERS */]: () => {
      const formattedValue = value?.length > 0 ? `${formatValue(value[0])} and ${formatValue(value[1])}` : `${formatValue(value)}`;
      return `${t("Number of orders")} ${operatorTwo} ${formatValue(formattedValue)}`;
    },
    ["CUSTOMER_TAG" /* CUSTOMER_TAG */]: () => `${t("Customer tag")} ${operatorTwo} ${formatValue(value)}`,
    ["MARKETING_CONSENT" /* MARKETING_CONSENT */]: () => `${t("Marketing consent")} ${operatorTwo}`,
    ["TOTAL_ITEM_COUNT" /* TOTAL_ITEM_COUNT */]: () => {
      const formattedValue = value?.length > 0 ? `${formatValue(value[0])} ${t("and")} ${formatValue(value[1])}` : `${formatValue(value)}`;
      return `${t("Total item count")} ${operatorTwo} ${formatValue(formattedValue)}`;
    },
    ["PHYSICAL_PRODUCT_OR_REQUIRE_SHIPPING" /* PHYSICAL_PRODUCT_OR_REQUIRE_SHIPPING */]: () => `${operatorOne} ${operatorTwo}`,
    ["SHIPPING_VALUE" /* SHIPPING_VALUE */]: () => {
      const formattedValue = value?.length > 0 ? `${currencyFormatter(value[0])} ${t("and")} ${currencyFormatter(value[1])}` : `${currencyFormatter(value)}`;
      return `${t("Shipping value")} ${operatorTwo} ${formatValue(formattedValue)}`;
    },
    ["ORDER_NOTE" /* ORDER_NOTE */]: () => `${t("Order note")} ${operatorTwo} ${formatValue(value)}`,
    ["PAYMENT_METHOD" /* PAYMENT_METHOD */]: () => `${t("Payment method")} ${operatorTwo} ${formatValue(joinItems(extraFields?.itemsInfo))}`,
    ["PRODUCT_TYPE" /* PRODUCT_TYPE */]: () => `${operatorOne} ${operatorTwo} ${formatValue(joinItems(extraFields?.itemsInfo))}`,
    ["PRODUCT_VENDOR" /* PRODUCT_VENDOR */]: () => `${operatorOne} ${operatorTwo} ${formatValue(joinItems(extraFields?.itemsInfo))}`,
    ["PRODUCT_IS_AVAILABLE_AT_SALES_CHANNEL" /* PRODUCT_IS_AVAILABLE_AT_SALES_CHANNEL */]: () => `${operatorOne} ${operatorTwo} ${formatValue(joinItems(extraFields?.itemsInfo))}`,
    ["FULFILLMENT_STATUS" /* FULFILLMENT_STATUS */]: () => `${t("Status")} ${operatorTwo} ${formatValue(joinItems(extraFields?.itemsInfo))}`,
    ["PAYMENT_STATUS" /* PAYMENT_STATUS */]: () => `${t("Status")} ${operatorTwo} ${formatValue(joinItems(extraFields?.itemsInfo))}`,
    ["SHIPPING_METHOD" /* SHIPPING_METHOD */]: () => `${t("Shipping method")} ${operatorTwo} ${formatValue(joinItems(extraFields?.itemsInfo))}`,
    ["ORDER_TAGS" /* ORDER_TAGS */]: () => `${t("Order tags")} ${operatorTwo} ${formatValue(joinItems(extraFields?.itemsInfo))}`,
    ["PRODUCT_ITEM_COST" /* PRODUCT_ITEM_COST */]: () => {
      const formattedValue = value?.length ? `${currencyFormatter(value[0])} ${t("and")} ${currencyFormatter(value[1])}` : `${currencyFormatter(value)}`;
      return `${operatorOne} ${operatorTwo} ${formatValue(formattedValue)}`;
    },
    ["CUSTOMER_TAGS" /* CUSTOMER_TAGS */]: () => `${t("Customer tag")} ${operatorTwo} ${formatValue(joinItems(extraFields?.itemsInfo))}`,
    ["CUSTOMER_TIME_SINCE_LAST_ORDER" /* CUSTOMER_TIME_SINCE_LAST_ORDER */]: () => {
      const extractNumber = (val) => parseInt(val?.split("_")[0] || "0", 10);
      const formattedValue = Array.isArray(value) && value.length ? `${extractNumber(value?.[0])} ${t("and")} ${extractNumber(value?.[1])}` : `${extractNumber(value)}`;
      return `${operatorOne} ${operatorTwo} ${formattedValue}`;
    },
    ["CUSTOMER_BIRTHDAY" /* CUSTOMER_BIRTHDAY */]: () => {
      console.log("operatorOne", operatorOne, operatorOneValue);
      switch (operatorOneValue) {
        case "lessThan":
        case "elapsed":
          const extractNumber = (val) => parseInt(val?.split("_")[0] || "0", 10);
          const formattedValue = Array.isArray(value) && value.length ? `${extractNumber(value?.[0])} ${t("and")} ${extractNumber(value?.[1])}` : `${extractNumber(value)}`;
          return `${t("Customer birthday")} ${operatorOne} ${operatorTwo} ${formatValue(formattedValue)}`;
        default:
          const formatDate = (timestamp) => {
            const date = new Date(timestamp);
            return date.toLocaleDateString("en-US", { year: "numeric", month: "short", day: "numeric" });
          };
          const formattedDate = Array.isArray(value) && value.length ? `${formatDate(value[0])} ${t("and")} ${formatDate(value[1])}` : formatDate(value);
          return `${t("Customer birthday")} ${operatorOne} ${formatValue(formattedDate)}`;
      }
    }
  };
  return conditionMessages[conditionKey]?.() || `${operatorOne} ${formatValue(value)}`;
};
var EmptyValueMessage = (conditionFact, operatorOne, operatorTwo, showEmptyValueMessageWithAnnotation) => {
  switch (conditionFact) {
    case "SPECIFIC_PRODUCT" /* SPECIFIC_PRODUCT */:
      return showEmptyValueMessageWithAnnotation ? `${operatorOne} ${operatorTwo} <span style="font-style: italic; text-decoration: underline;">${t("please select products")}</span>` : `${operatorOne} ${operatorTwo} ${t("please select products")}`;
    case "PRODUCT_COLLECTION" /* PRODUCT_COLLECTION */:
      return showEmptyValueMessageWithAnnotation ? `${operatorOne} ${operatorTwo} <span style="font-style: italic; text-decoration: underline;">${t("please select collections")}</span>` : `${operatorOne} ${operatorTwo} ${t("please select collections")}`;
    case "PRODUCT_TAGS" /* PRODUCT_TAGS */:
      return showEmptyValueMessageWithAnnotation ? `${operatorOne} ${operatorTwo} <span style="font-style: italic; text-decoration: underline;">${t("please select tags")}</span>` : `${operatorOne} ${operatorTwo} ${t("please select tags")}`;
    case "PRODUCT_TITLE" /* PRODUCT_TITLE */:
      return showEmptyValueMessageWithAnnotation ? `${operatorOne} ${operatorTwo} <span style="font-style: italic; text-decoration: underline;">${t("please add product title")}</span>` : `${operatorOne} ${operatorTwo} ${t("please add product title")}`;
    case "PRODUCT_SKU" /* PRODUCT_SKU */:
      return showEmptyValueMessageWithAnnotation ? `${operatorOne} ${operatorTwo} <span style="font-style: italic; text-decoration: underline;">${t("please add product sku")}</span>` : `${operatorOne} ${operatorTwo} ${t("please add product sku")}`;
    case "PRODUCT_VARIANT_NAME" /* PRODUCT_VARIANT_NAME */:
      return showEmptyValueMessageWithAnnotation ? `${operatorOne} ${operatorTwo} <span style="font-style: italic; text-decoration: underline;">${t("please add product variant name")}</span>` : `${operatorOne} ${operatorTwo} ${t("please add product variant name")}`;
    case "PRODUCT_SALES_CHANNEL" /* PRODUCT_SALES_CHANNEL */:
    case "PRODUCT_IS_AVAILABLE_AT_SALES_CHANNEL" /* PRODUCT_IS_AVAILABLE_AT_SALES_CHANNEL */:
      return showEmptyValueMessageWithAnnotation ? `${operatorOne} ${operatorTwo} <span style="font-style: italic; text-decoration: underline;">${t("please select sales channel")}</span>` : `${operatorOne} ${operatorTwo} ${t("please select sales channel")}`;
    case "PRODUCT_PRICE" /* PRODUCT_PRICE */:
      return showEmptyValueMessageWithAnnotation ? `${operatorOne} ${operatorTwo} <span style="font-style: italic; text-decoration: underline;">${t("please add product price")}</span>` : `${operatorOne} ${operatorTwo} ${t("please add product price")}`;
    case "CART_OR_ORDER_VALUE" /* CART_OR_ORDER_VALUE */:
      return showEmptyValueMessageWithAnnotation ? ` ${t("Cart/Order value")} ${operatorTwo} <span style="font-style: italic; text-decoration: underline;">${t("please add cart or order value")}</span>` : ` ${t("Cart/Order value")} ${operatorTwo} ${t("please add cart or order value")}`;
    case "CUSTOMER_COUNTRY" /* CUSTOMER_COUNTRY */:
      return showEmptyValueMessageWithAnnotation ? `${t("Customer country")} ${operatorTwo} <span style="font-style: italic; text-decoration: underline;">${t("please select customer country")}</span>` : `${t("Customer country")} ${operatorTwo} ${t("please select customer country")}`;
    case "CUSTOMER_SEGMENTS" /* CUSTOMER_SEGMENTS */:
      return showEmptyValueMessageWithAnnotation ? `${t("Customer segments")} ${operatorTwo} <span style="font-style: italic; text-decoration: underline;">${t("please select customer segments")}</span>` : `${t("Customer segments")} ${operatorTwo} ${t("please select customer segments")}`;
    case "CUSTOMER_LANGUAGE" /* CUSTOMER_LANGUAGE */:
      return showEmptyValueMessageWithAnnotation ? `${t("Language")} ${operatorTwo} <span style="font-style: italic; text-decoration: underline;">${t("please select customer language")}</span>` : `${t("Language")} ${operatorTwo} ${t("please select customer language")}`;
    case "CUSTOMER_EMAIL" /* CUSTOMER_EMAIL */:
      return showEmptyValueMessageWithAnnotation ? `${t("Customer email")} ${operatorTwo} <span style="font-style: italic; text-decoration: underline;">${t("please add customer email")}</span>` : `${t("Customer email")} ${operatorTwo} ${t("please add customer email")}`;
    case "CUSTOMER_NUMBER_OF_ORDERS" /* CUSTOMER_NUMBER_OF_ORDERS */:
      return showEmptyValueMessageWithAnnotation ? `${t("Number of orders")} ${operatorTwo} <span style="font-style: italic; text-decoration: underline;">${t("please add number of orders")}</span>` : `${t("Number of orders")} ${operatorTwo} ${t("please add number of orders")}`;
    case "CUSTOMER_TAG" /* CUSTOMER_TAG */:
      return showEmptyValueMessageWithAnnotation ? `${t("Customer tag")} ${operatorTwo} <span style="font-style: italic; text-decoration: underline;">${t("please select customer tag")}</span>` : `${t("Customer tag")} ${operatorTwo} ${t("please select customer tag")}`;
    case "PREV_PAGE_OFFER" /* PREV_PAGE_OFFER */:
      return showEmptyValueMessageWithAnnotation ? `${t("Previous page offer")} ${operatorTwo} <span style="font-style: italic; text-decoration: underline;">${t("please select offer")}</span>` : `${t("Previous page offer")} ${operatorTwo} ${t("please select offer")}`;
    case "DISCOUNT_CODE" /* DISCOUNT_CODE */:
      return showEmptyValueMessageWithAnnotation ? `${t("Discount code")} ${operatorTwo} <span style="font-style: italic; text-decoration: underline;">${t("please add discount code")}</span>` : `${t("Discount code")} ${operatorTwo} ${t("please add discount code")}`;
    case "MARKETING_CONSENT" /* MARKETING_CONSENT */:
      return `${t("Marketing consent")} ${operatorTwo}`;
    case "TOTAL_ITEM_COUNT" /* TOTAL_ITEM_COUNT */:
      return showEmptyValueMessageWithAnnotation ? `${t("Total item count")} ${operatorTwo} <span style="font-style: italic; text-decoration: underline;">${t("please add total item count")}</span>` : `${t("Total item count")} ${operatorTwo} ${t("please add total item count")}`;
    case "PHYSICAL_PRODUCT_OR_REQUIRE_SHIPPING" /* PHYSICAL_PRODUCT_OR_REQUIRE_SHIPPING */:
      return `${operatorOne} ${operatorTwo}`;
    case "SHIPPING_VALUE" /* SHIPPING_VALUE */:
      return showEmptyValueMessageWithAnnotation ? ` ${t("Shipping value")} ${operatorTwo} <span style="font-style: italic; text-decoration: underline;">${t("please add shipping value")}</span>` : ` ${t("Shipping value")} ${operatorTwo} ${t("please add shipping value")}`;
    case "ORDER_NOTE" /* ORDER_NOTE */:
      return showEmptyValueMessageWithAnnotation ? `${t("Order note")} ${operatorTwo} <span style="font-style: italic; text-decoration: underline;">${t("please add order note")}</span>` : `${t("Order note")} ${operatorTwo} ${t("please add order note")}`;
    case "PAYMENT_METHOD" /* PAYMENT_METHOD */:
      return showEmptyValueMessageWithAnnotation ? `${t("Payment method")} ${operatorTwo} <span style="font-style: italic; text-decoration: underline;">${t("please select payment method")}</span>` : `${t("Payment method")} ${operatorTwo} ${t("please select payment method")}`;
    case "PRODUCT_TYPE" /* PRODUCT_TYPE */:
      return showEmptyValueMessageWithAnnotation ? `${t("Product type")} ${operatorTwo} <span style="font-style: italic; text-decoration: underline;">${t("please select product type")}</span>` : `${t("Product type")} ${operatorTwo} ${t("please select product type")}`;
    case "PRODUCT_VENDOR" /* PRODUCT_VENDOR */:
      return showEmptyValueMessageWithAnnotation ? `${t("Product vendor")} ${operatorTwo} <span style="font-style: italic; text-decoration: underline;">${t("please select product vendor")}</span>` : `${t("Product vendor")} ${operatorTwo} ${t("please select product vendor")}`;
    case "FULFILLMENT_STATUS" /* FULFILLMENT_STATUS */:
      return showEmptyValueMessageWithAnnotation ? `${t("Status")} ${operatorTwo} <span style="font-style: italic; text-decoration: underline;">${t("please select fulfillment statuses")}</span>` : `${t("Status")} ${operatorTwo} ${t("please select fulfillment statuses")}`;
    case "PAYMENT_STATUS" /* PAYMENT_STATUS */:
      return showEmptyValueMessageWithAnnotation ? `${t("Status")} ${operatorTwo} <span style="font-style: italic; text-decoration: underline;">${t("please select payment statuses")}</span>` : `${t("Status")} ${operatorTwo} ${t("please select payment statuses")}`;
    case "SHIPPING_METHOD" /* SHIPPING_METHOD */:
      return showEmptyValueMessageWithAnnotation ? `${t("Shipping method")} ${operatorTwo} <span style="font-style: italic; text-decoration: underline;">${t("please select shipping methods")}</span>` : `${t("Shipping method")} ${operatorTwo} ${t("please select shipping methods")}`;
    case "ORDER_TAGS" /* ORDER_TAGS */:
      return showEmptyValueMessageWithAnnotation ? `${t("Order tags")} ${operatorTwo} <span style="font-style: italic; text-decoration: underline;">${t("please select tags")}</span>` : `${t("Order tags")} ${operatorTwo} ${t("please select tags")}`;
    case "PRODUCT_ITEM_COST" /* PRODUCT_ITEM_COST */:
      return showEmptyValueMessageWithAnnotation ? `${operatorOne} ${operatorTwo} <span style="font-style: italic; text-decoration: underline;">${t("please add item cost")}</span>` : `${operatorOne} ${operatorTwo} ${t("please add item cost")}`;
    case "CUSTOMER_TAGS" /* CUSTOMER_TAGS */:
      return showEmptyValueMessageWithAnnotation ? `${t("Customer tag")} ${operatorTwo} <span style="font-style: italic; text-decoration: underline;">${t("please select customer tags")}</span>` : `${t("Customer tag")} ${operatorTwo} ${t("please select customer tags")}`;
    case "CUSTOMER_TIME_SINCE_LAST_ORDER" /* CUSTOMER_TIME_SINCE_LAST_ORDER */:
      return showEmptyValueMessageWithAnnotation ? `${operatorOne} ${operatorTwo} <span style="font-style: italic; text-decoration: underline;">${t("please add time since last order")}</span>` : `${operatorOne} ${operatorTwo} ${t("please add time since last order")}`;
    case "CUSTOMER_BIRTHDAY" /* CUSTOMER_BIRTHDAY */:
      return showEmptyValueMessageWithAnnotation ? `${t("Customer birthday")} ${operatorOne} <span style="font-style: italic; text-decoration: underline;">${t("please select customer birthday")}</span>` : `${t("Customer birthday")} ${operatorOne} ${t("please select customer birthday")}`;
    default:
      return showEmptyValueMessageWithAnnotation ? `${operatorOne} ${operatorTwo} <span style="font-style: italic; text-decoration: underline;">${t("please add value")}</span>` : `${operatorOne} ${operatorTwo} ${t("please add value")}`;
  }
};

// src/flow/getConditionTextBasedOnRule.ts
var getConditionTextBasedOnRule = (conditionRule, currencyFormatter, platform, options) => {
  let conditionText = "";
  if (conditionRule?.any?.length) {
    const flattenedCondition = conditionRule?.any?.flatMap(
      (item) => item?.all
    );
    const conditionsText = flattenedCondition?.map(
      (item, index) => {
        return `${getConditionText(item, currencyFormatter, platform, { ...options })} ${flattenedCondition[index + 1]?.conditionType ? flattenedCondition[index + 1]?.conditionType : ""} `;
      }
    );
    conditionsText?.forEach((item) => {
      conditionText += item;
    });
    return conditionText;
  } else {
    const conditionInfo = conditionRule?.all[0];
    conditionText = getConditionText(
      conditionInfo,
      currencyFormatter,
      platform,
      { ...options }
    );
    return conditionText;
  }
};

// src/flow/templateSlot.ts
var PreMadeTemplateSlotMapping = {
  ["PRODUCT_UPSELL" /* PRODUCT_UPSELL */]: {
    slotNo: 7,
    title: () => t("Product upsell"),
    slotNoInTemplate: 1
  },
  ["PRODUCT_RECOMMENDATION" /* PRODUCT_RECOMMENDATION */]: {
    slotNo: 8,
    title: () => t("Product recommendations"),
    slotNoInTemplate: 2
  },
  ["BUNDLE" /* BUNDLE */]: {
    slotNo: 9,
    title: () => t("Bundle"),
    slotNoInTemplate: 3
  },
  ["BANNER" /* BANNER */]: {
    slotNo: 10,
    title: () => t("Banner"),
    slotNoInTemplate: 4
  },
  ["ANNOUNCEMENT_BAR" /* ANNOUNCEMENT_BAR */]: {
    slotNo: -1,
    title: () => t("Announcement bar"),
    slotNoInTemplate: 5
  }
};
var MAX_CUSTOM_SLOT = Math.min(...Object.values(PreMadeTemplateSlotMapping).filter((a) => a.slotNo !== -1).map((a) => a.slotNo)) - 1;
var SlotTypeMapping = {
  [1]: "CUSTOM_SLOT" /* CUSTOM_SLOT */,
  [2]: "CUSTOM_SLOT" /* CUSTOM_SLOT */,
  [3]: "CUSTOM_SLOT" /* CUSTOM_SLOT */,
  [4]: "CUSTOM_SLOT" /* CUSTOM_SLOT */,
  [5]: "CUSTOM_SLOT" /* CUSTOM_SLOT */,
  [6]: "CUSTOM_SLOT" /* CUSTOM_SLOT */,
  [7]: "PRODUCT_UPSELL" /* PRODUCT_UPSELL */,
  [8]: "PRODUCT_RECOMMENDATION" /* PRODUCT_RECOMMENDATION */,
  [9]: "BUNDLE" /* BUNDLE */,
  [10]: "BANNER" /* BANNER */,
  [-1]: "ANNOUNCEMENT_BAR" /* ANNOUNCEMENT_BAR */
};
var SlotNameMapping = {
  [1]: "Custom Slot 1" /* CUSTOM_SLOT_1 */,
  [2]: "Custom Slot 2" /* CUSTOM_SLOT_2 */,
  [3]: "Custom Slot 3" /* CUSTOM_SLOT_3 */,
  [4]: "Custom Slot 4" /* CUSTOM_SLOT_4 */,
  [5]: "Custom Slot 5" /* CUSTOM_SLOT_5 */,
  [6]: "Custom Slot 6" /* CUSTOM_SLOT_6 */,
  [7]: "Product upsell" /* PRODUCT_UPSELL */,
  [8]: "Product recommendations" /* PRODUCT_RECOMMENDATION */,
  [9]: "Product bundle" /* BUNDLE */,
  [10]: "Banner" /* BANNER */,
  [-1]: "Announcement bar" /* ANNOUNCEMENT_BAR */
};
var EDITOR_CONFIG = {
  CHECKOUT: { type: "information", collection: "checkout" },
  THANK_YOU_PAGE: { type: "thank-you", collection: "thank-you-page" },
  ORDER_STATUS_PAGE: { type: "order-status", collection: "order-status-page" }
};
var getSlotType = (widgetType) => {
  const slotMapping = {
    "MULTI_PRODUCT_UPSELL": "/product-upsell",
    "PRODUCT_UPSELL": "/product-upsell",
    "BUNDLE": "/bundle",
    "RECOMMENDATIONS": "/product-recommendations",
    "PRODUCT_RECOMMENDATION": "/product-recommendations",
    "BANNER": "/banner",
    "ANNOUNCEMENT_BAR": "/announcement-bar",
    "CUSTOM_SLOT": "/slot",
    "DUPLICATE_SLOT": "/slot"
  };
  return slotMapping[widgetType] || "/slot";
};
var getEditorRedirectionUrl = (pageType, shopifyApiKey, platformStoreId, checkoutProfileId, shopifyAppId, slotWidgetType) => {
  const storeName = platformStoreId?.replace(".myshopify.com", "");
  const slotType = getSlotType(slotWidgetType);
  if (pageType === "PRE_PURCHASE_CART_DRAWER_PAGE" /* PRE_PURCHASE_CART_DRAWER_PAGE */ || pageType === "PRE_PURCHASE_CART_PAGE" /* PRE_PURCHASE_CART_PAGE */ || pageType === "PRE_PURCHASE_PRODUCT_PAGE" /* PRE_PURCHASE_PRODUCT_PAGE */ || pageType === "POST_PURCHASE_PAGE1" /* POST_PURCHASE_PAGE1 */) {
    const encodedURI = encodeURIComponent(shopifyApiKey + slotType);
    const prePurchaseBaseUrl = `https://${platformStoreId}/admin/themes/current/editor`;
    const urlMapping = {
      ["PRE_PURCHASE_CART_DRAWER_PAGE" /* PRE_PURCHASE_CART_DRAWER_PAGE */]: `${prePurchaseBaseUrl}?context=apps&template=product&activateAppId=${shopifyApiKey}/cart-drawer`,
      ["PRE_PURCHASE_CART_PAGE" /* PRE_PURCHASE_CART_PAGE */]: `${prePurchaseBaseUrl}?addAppBlockId=${encodedURI}&template=cart&target=sectionId`,
      ["PRE_PURCHASE_PRODUCT_PAGE" /* PRE_PURCHASE_PRODUCT_PAGE */]: `${prePurchaseBaseUrl}?addAppBlockId=${encodedURI}&template=product&target=sectionId`,
      ["POST_PURCHASE_PAGE1" /* POST_PURCHASE_PAGE1 */]: `https://admin.shopify.com/store/${storeName}/settings/checkout#post-purchase-page`
    };
    return urlMapping[pageType] || "";
  }
  const config = EDITOR_CONFIG[pageType];
  if (config) {
    const queryParams = `?context=apps&collection=${config.collection}&page=${config.type}&app=${shopifyAppId}`;
    if (checkoutProfileId) {
      return `https://admin.shopify.com/store/${storeName}/settings/checkout/editor/profiles/${checkoutProfileId}${queryParams}`;
    } else {
      return `https://${platformStoreId}/admin/settings/checkout/editor${queryParams}`;
    }
  }
  return "";
};

// src/flow/utils.ts
var SlotLocations = [
  "THANK_YOU_PAGE" /* THANK_YOU_PAGE */,
  "ORDER_STATUS_PAGE" /* ORDER_STATUS_PAGE */,
  "CHECKOUT" /* CHECKOUT */,
  "PRE_PURCHASE_CART_DRAWER_PAGE" /* PRE_PURCHASE_CART_DRAWER_PAGE */,
  "PRE_PURCHASE_CART_PAGE" /* PRE_PURCHASE_CART_PAGE */,
  "PRE_PURCHASE_PRODUCT_PAGE" /* PRE_PURCHASE_PRODUCT_PAGE */
];
var PageLocations = [
  "POST_PURCHASE_PAGE1" /* POST_PURCHASE_PAGE1 */,
  "POST_PURCHASE_PAGE2" /* POST_PURCHASE_PAGE2 */
];
function isPostPurchase(pageType) {
  return PageLocations.includes(pageType);
}
var PagesWithAds = [
  "THANK_YOU_PAGE" /* THANK_YOU_PAGE */
];

// src/defaultWidgetsValue/checkout_default_values.json
var checkout_default_values_default = {
  defaultValues: [
    {
      type: "DIVIDER",
      category: "INFORMATIONAL",
      isVisible: true,
      name: "Divider (1)",
      dividerText: {
        enabled: false,
        value: "Title",
        translatableField: ["value"]
      }
    },
    {
      type: "TEXT",
      category: "INFORMATIONAL",
      isVisible: true,
      text: "<p>You may also like this product</p>",
      name: "Text (1)",
      translatableField: ["text"]
    },
    {
      type: "BANNER",
      category: "INFORMATIONAL",
      isVisible: true,
      status: "INFO",
      dismissible: true,
      name: "Banner (1)",
      content: {
        title: "Title",
        description: "",
        collapsible: true,
        translatableField: ["title", "description"]
      },
      button: {
        display: false,
        type: "PRIMARY",
        color: "DEFAULT",
        text: "Button text",
        link: "",
        translatableField: ["text"]
      }
    },
    {
      type: "UPSELL",
      category: "CONVERTING",
      parentType: "MULTI_PRODUCT_UPSELL",
      isVisible: true,
      text: "You may also like this product",
      translatableField: ["text"],
      name: "Product (1)",
      upsellInfo: {
        type: "SHOPIFY_RECOMMENDATIONS",
        noOfProducts: 1,
        productsPerRow: 3,
        sliderConfig: {
          hint: "PILL",
          hintText: "Scroll",
          translatableField: ["hintText"]
        },
        location: "CART",
        layout: "SMALL_LAYOUT_ONE",
        subLayout: "SMALL_LAYOUT_ONE",
        settings: {
          SPECIFIC_PRODUCT: [
            {
              productInfo: {},
              optionsIfAlreadyInLocation: {
                value: "display_featured_product_anyway",
                alternateProduct: {}
              },
              defaultSelected: true,
              mandatory: false
            }
          ],
          SHOPIFY_RECOMMENDATIONS: {
            hideIfAlreadyInLocation: false,
            excludeTagsOptions: {
              enabled: true,
              tags: []
            },
            recommendationIntent: "related"
          },
          MOST_EXPENSIVE: {
            excludeTagsOptions: {
              enabled: false,
              tags: [],
              alternateOption: "use_shopify_recommendation",
              alternateProduct: {}
            }
          },
          LEAST_EXPENSIVE: {
            excludeTagsOptions: {
              enabled: false,
              tags: [],
              alternateOption: "use_shopify_recommendation",
              alternateProduct: {}
            }
          },
          PERSONALIZED_RECOMMENDATIONS: {
            excludeTagsOptions: {
              enabled: false,
              tags: []
            },
            hideIfAlreadyInLocation: false
          },
          RECOMATIC_RECOMMENDATIONS: {
            excludeTagsOptions: {
              enabled: false,
              tags: []
            }
          },
          SPECIFIC_COLLECTION: []
        }
      },
      blocks: [
        {
          type: "SUBSCRIPTION",
          isVisible: true,
          isSubscriptionEnabled: false,
          subscriptionOptionDisplay: "SHOW_ALL_SUBSCRIPTION_OPTIONS",
          displaySellingOptions: true,
          sellingPlanToApply: "",
          productOption: "SUBSCRIPTION",
          purchaseOptionsTitle: "Purchase options",
          offerSubscriptionOptionOnly: false,
          showSubscriptionBadge: false,
          subscriptionBadgeText: "Subscription",
          showSavingsDetailsBadge: false,
          savingsDetailsBadgeText: "Save up to {{subscription discount}}",
          replaceExistingOneTimeProduct: true,
          translatableField: ["purchaseOptionsTitle", "subscriptionBadgeText", "savingsDetailsBadgeText"]
        },
        {
          type: "IMAGE",
          isVisible: true,
          imageFit: "CONTAIN",
          imageToDisplay: "MAIN_PRODUCT",
          imageURL: "",
          showImageAccordingToVariant: true,
          linkToProduct: false,
          imageBorderRadius: "BASE",
          imageBorderStyle: "BASE"
        },
        {
          type: "PRODUCT_TITLE",
          isVisible: true,
          customTitle: {
            enabled: false,
            value: "Product title",
            translatableField: ["value"]
          }
        },
        {
          type: "STAR_RATING",
          isVisible: true,
          blockSettings: {
            starColor: "#F4C430",
            layout: "MINIMALISTIC",
            showAmountOfReviews: true,
            showRatingValue: true,
            reviewsLabel: "reviews",
            integrationError: false,
            translatableField: ["reviewsLabel"]
          }
        },
        {
          type: "PRODUCT_DETAILS",
          isVisible: true,
          subtitle: {
            selection: "VARIANT_NAME",
            textStyle: "UPPER_CASE",
            customText: "Text",
            translatableField: ["customText"]
          }
        },
        {
          type: "DESCRIPTION",
          isVisible: true,
          displayProductDescription: true,
          customText: {
            enabled: false,
            value: "text text text text",
            translatableField: ["value"]
          },
          collapsible: {
            enabled: true,
            defaultState: "COLLAPSED",
            buttonText: "Description",
            translatableField: ["buttonText"]
          }
        },
        {
          type: "PRICE_AND_DISCOUNT",
          isVisible: true,
          price: {
            samePriceForAll: true,
            priceToDisplay: "DISPLAY_HIGHEST_LOWEST_PRICE",
            totalPriceText: "Total Price",
            translatableField: ["totalPriceText"],
            displayComparision: {
              dontDisplayComparePrice: false,
              enabled: true,
              size: "DEFAULT",
              color: "CRITICAL"
            },
            displayOriginal: {
              enabled: true,
              size: "DEFAULT",
              color: "CRITICAL"
            },
            displayAfterDiscount: {
              enabled: true,
              size: "DEFAULT",
              color: "INFO"
            }
          },
          discount: {
            enabled: true,
            onlyForOrdersOverValue: {
              enabled: false,
              minimumOrderValue: 0
            },
            type: "PERCENTAGE",
            name: "",
            breakPoint: [
              {
                minimumItemGetDiscount: 1,
                value: 0
              }
            ],
            discountValue: 0,
            minItemsDiscount: 1,
            maxItemsDiscount: 100,
            onlyForProductsOverValue: {
              enabled: false,
              minimumProductPrice: 100
            }
          }
        },
        {
          type: "BUTTON",
          isVisible: true,
          buttonType: "SECONDARY",
          buttonText: "{{add to cart}}",
          subscriptionButtonTextForOneTimePurchase: "{{add to cart}}",
          subscriptionButtonText: "Subscribe now",
          translatableField: ["buttonText", "subscriptionButtonTextForOneTimePurchase", "subscriptionButtonText"]
        },
        {
          type: "VARIANT_PICKER",
          isVisible: true,
          displayVariantPicker: true,
          label: "Variant",
          preselectedVariant: "DEFAULT_PRODUCT_VARIANT",
          selectedSpecificVariantId: "",
          combineAllOptionsIntoOneDropdown: true,
          showPriceInDropdown: true,
          translatableField: ["label", "errorMessage"]
        },
        {
          type: "QUANTITY_SELECTOR",
          isVisible: true,
          displayQuantitySelector: true,
          label: "Quantity",
          translatableField: ["label"],
          defaultQuantity: 1,
          minQuantity: {
            enabled: false,
            value: 1
          },
          maxQuantity: {
            enabled: false,
            value: 10
          }
        },
        {
          type: "SUCCESS_ERROR_BANNER",
          isVisible: true,
          successBanner: {
            enabled: true,
            type: "SUCCESS",
            text: "Added to cart.",
            dismissible: true,
            translatableField: ["text"],
            undoButton: {
              enabled: true,
              text: "Undo",
              translatableField: ["text"]
            }
          },
          errorBanner: {
            enabled: true,
            type: "CRITICAL",
            dismissible: true,
            staticText: {
              enabled: true,
              value: "Unable to add product/s to cart.",
              translatableField: ["value"]
            }
          }
        }
      ]
    },
    {
      type: "TOTAL_PRICE",
      isVisible: true,
      priceToDisplay: "HIGHEST_LOWEST_PRICE",
      dontDisplayCompareTotalPrice: false,
      isDisplayCompareToPrice: true,
      text: "{{total price}} {{pricing}}",
      displayComparisionFontColor: "CRITICAL",
      displayOriginalFontColor: "CRITICAL",
      displayAfterDiscountFontColor: "INFO",
      translatableField: ["text"]
    },
    {
      type: "BUTTON",
      isVisible: true,
      buttonType: "SECONDARY",
      buttonText: "Add {{item count}} Items",
      translatableField: ["buttonText"]
    },
    {
      type: "SUCCESS_ERROR_BANNER",
      isVisible: true,
      successBanner: {
        enabled: true,
        type: "SUCCESS",
        text: "Added to cart.",
        dismissible: true,
        translatableField: ["text"]
      },
      errorBanner: {
        enabled: true,
        type: "CRITICAL",
        dismissible: true,
        staticText: {
          enabled: true,
          value: "Unable to add product/s to cart.",
          translatableField: ["value"]
        }
      }
    },
    {
      type: "TIMER",
      category: "INFORMATIONAL",
      isVisible: true,
      name: "Timer (1)",
      blocks: [
        {
          type: "TIMER_TEXT",
          description: '<h2 style="text-align: center; font-size: 16px; font-weight: 600; margin-bottom: 0px;">Offer expires in:</h2>',
          translatableField: ["description"],
          frameBorderRadius: "LARGE",
          frameBorder: "BASE",
          textInframe: false,
          textBackground: "SUBDUED",
          timerExpiredSetting: {
            replaceWhenTimerRunOut: true,
            timerExpiredText: '<h2 style="text-align: center; font-size: 16px; font-weight: 600; margin-bottom: 0px;">Offer expired</h2>',
            translatableField: ["timerExpiredText"],
            preview: false
          }
        },
        {
          type: "CLOCK",
          background: "BASE",
          digitColor: "CRITICAL",
          showTitle: false,
          title: "",
          clockFrame: "INDIVIDUAL_FRAMES",
          frameBorder: "BASE",
          frameBorderRadius: "BASE",
          showTimeSeparator: true,
          showTimeUnitLabels: true,
          timeUnitLabels: {
            days: "",
            hours: "",
            minutes: "Minutes",
            seconds: "Seconds"
          },
          showUnitLabelsInFrame: false,
          unitLabelsPosition: "BELOW_DIGITS",
          timerExpiredSetting: {
            whenTimeRunsOut: "REPLACE_CLOCK_WITH_TEXT",
            timerExpiredText: "",
            preview: false,
            translatableField: ["timerExpiredText"]
          }
        },
        {
          type: "PROGRESS_BAR",
          showProgressBar: true,
          progressBarColor: "AUTO",
          timerExpiredSetting: {
            timerRunsOut: "CHANGE_PROGRESS_BAR_COLOR",
            progressBarColor: "CRITICAL",
            preview: false
          }
        }
      ],
      upsellInfo: {
        settings: {
          displayTimer: "ONCE_PER_SESSION",
          timerEffect: "ALL_WIDGETS_ON_THIS_PAGE",
          timerRunsOut: "DO_NOTHING",
          selectedWidgets: []
        },
        duration: {
          count: "TIME_PASSED",
          startCounting: "ON_FIRST_IMPRESSION",
          dateAndTime: "",
          duration: {
            days: 0,
            hours: 0,
            minutes: 10,
            seconds: 0
          }
        },
        designConfig: {
          timerStyle: "PROMOTIONAL",
          backgroundColor: "SUBDUED",
          desktopLayout: "HORIZONTAL",
          bannerType: "INFO",
          timerBorder: "BASE",
          timerBorderRadius: "LARGE"
        },
        expiredMessageConfig: {
          changeBannerTypeOnTimerRunOut: false,
          bannerTypeOnTimerRunOut: "CRITICAL",
          isDisplayMessage: true,
          backgroundColor: "RED",
          preview: false
        }
      }
    },
    {
      type: "MULTI_PRODUCT_UPSELL",
      category: "CONTAINER",
      isVisible: true,
      text: "You may also like this product",
      translatableField: ["text"],
      name: "Product upsell (1)",
      postAcceptOption: "HIDE_PRODUCT",
      ifNoProductsToShowBlocksShould: "HIDE",
      widgets: [
        {
          type: "DIVIDER"
        },
        {
          type: "TEXT"
        },
        {
          type: "UPSELL",
          layout: "SMALL_LAYOUT_TWO"
        }
      ]
    },
    {
      type: "RECOMMENDATIONS",
      category: "CONTAINER",
      isVisible: true,
      text: "You may also like this product",
      translatableField: ["text"],
      name: "Product recommendations (1)",
      postAcceptOption: "HIDE_PRODUCT",
      ifNoProductsToShowBlocksShould: "HIDE",
      widgets: [
        {
          type: "TEXT",
          text: '<h2 style="text-align: left; font-size: 16px; font-weight: 600; margin-bottom: 0px;">You may also like these products</h2>',
          translatableField: ["text"]
        },
        {
          type: "UPSELL",
          noOfProducts: 8,
          layout: "SLIDER",
          removeBlocks: [
            "SUBSCRIPTION"
          ],
          removeBlockKeys: [
            {
              type: "BUTTON",
              keys: ["subscriptionButtonText", "subscriptionButtonTextForOneTimePurchase"]
            }
          ],
          optionalBlocks: [
            "PRODUCT_DETAILS"
          ],
          blocksDefaultValue: [
            {
              type: "SUCCESS_ERROR_BANNER",
              text: "Added to cart! ",
              translatableField: ["text"]
            },
            {
              type: "DESCRIPTION",
              displayProductDescription: false
            }
          ]
        }
      ]
    },
    {
      type: "BUNDLE",
      category: "CONTAINER",
      isVisible: true,
      text: "You may also like this product",
      translatableField: ["text"],
      name: "Bundle(1)",
      noOfProducts: 3,
      productsPerRow: 3,
      sliderConfig: {
        hint: "PILL",
        hintText: "Scroll",
        translatableField: ["hintText"]
      },
      layout: "GRID",
      allowSeparateQuantitySelection: true,
      postAcceptOption: "HIDE_BUNDLE",
      ifNoProductsToShowBlocksShould: "HIDE",
      widgets: [
        {
          type: "TEXT",
          text: '<p><span style="font-size: 14px;"><strong>Frequently bought together</strong></span></p>',
          displayOrder: 0,
          translatableField: ["text"]
        },
        {
          type: "UPSELL",
          displayOrder: 1,
          layout: "LIST",
          subLayout: "SMALL_LAYOUT_ONE",
          removeBlocks: [
            "BUTTON",
            "SUCCESS_ERROR_BANNER",
            "SUBSCRIPTION"
          ],
          removeBlockKeys: [
            {
              type: "BUTTON",
              keys: ["subscriptionButtonText", "subscriptionButtonTextForOneTimePurchase"]
            }
          ],
          blocksDefaultValue: [
            {
              type: "PRICE_AND_DISCOUNT",
              priceToDisplay: "ONLY_HIGHEST_PRICE",
              displayComparision: {
                color: "INFO"
              }
            },
            {
              type: "BUTTON",
              buttonText: "Add {{item count}} Items",
              translatableField: ["buttonText"]
            }
          ]
        },
        {
          type: "UPSELL",
          displayOrder: 2,
          layout: "LIST",
          subLayout: "SMALL_LAYOUT_ONE",
          removeBlocks: [
            "BUTTON",
            "SUCCESS_ERROR_BANNER",
            "SUBSCRIPTION"
          ],
          removeBlockKeys: [
            {
              type: "BUTTON",
              keys: ["subscriptionButtonText", "subscriptionButtonTextForOneTimePurchase"]
            }
          ],
          blocksDefaultValue: [
            {
              type: "PRICE_AND_DISCOUNT",
              priceToDisplay: "ONLY_HIGHEST_PRICE",
              displayComparision: {
                color: "INFO"
              }
            },
            {
              type: "BUTTON",
              buttonText: "Add {{item count}} Items",
              translatableField: ["buttonText"]
            }
          ]
        },
        {
          type: "UPSELL",
          displayOrder: 3,
          layout: "LIST",
          subLayout: "SMALL_LAYOUT_ONE",
          removeBlocks: [
            "BUTTON",
            "SUCCESS_ERROR_BANNER",
            "SUBSCRIPTION"
          ],
          removeBlockKeys: [
            {
              type: "BUTTON",
              keys: ["subscriptionButtonText", "subscriptionButtonTextForOneTimePurchase"]
            }
          ],
          blocksDefaultValue: [
            {
              type: "PRICE_AND_DISCOUNT",
              priceToDisplay: "ONLY_HIGHEST_PRICE",
              displayComparision: {
                color: "INFO"
              }
            },
            {
              type: "BUTTON",
              buttonText: "Add {{item count}} Items",
              translatableField: ["buttonText"]
            }
          ]
        }
      ],
      blocks: [
        {
          type: "TOTAL_PRICE",
          displayOrder: 4
        },
        {
          type: "BUTTON",
          displayOrder: 5,
          buttonText: "Add {{item count}} Items",
          translatableField: ["buttonText"]
        },
        {
          type: "SUCCESS_ERROR_BANNER",
          displayOrder: 6
        }
      ]
    },
    {
      type: "DATE_PICKER",
      isVisible: true,
      configuration: {
        fieldName: "Birthday",
        title: false,
        titleText: "",
        label: "Your birthday (YYYY-MM-DD)",
        dateFormat: "YYYY-MM-DD",
        required: true,
        errorText: "Birthday is required",
        translatableField: ["label", "errorText"]
      },
      dataCollection: {
        customerMetafield: {
          enabled: true,
          keyName: "Birthday"
        },
        orderMetafield: {
          enabled: true,
          keyName: "Birthday"
        }
      }
    },
    {
      type: "TEXT_AREA",
      isVisible: true,
      configuration: {
        fieldName: "Text area",
        title: true,
        titleText: "",
        label: "Text placeholder",
        required: true,
        errorText: "This field is Required",
        translatableField: ["label", "errorText", "titleText"]
      },
      dataCollection: {
        customerMetafield: {
          enabled: true,
          keyName: "Text area 1"
        },
        orderMetafield: {
          enabled: true,
          keyName: "Text area 1"
        }
      }
    },
    {
      type: "TEXT_FIELD",
      isVisible: true,
      configuration: {
        fieldName: "Text field",
        title: true,
        titleText: "",
        label: "Text placeholder",
        required: true,
        errorText: "This field is Required",
        translatableField: ["label", "errorText", "titleText"]
      },
      dataCollection: {
        customerMetafield: {
          enabled: true,
          keyName: "Text field 1"
        },
        orderMetafield: {
          enabled: true,
          keyName: "Text field 1"
        }
      }
    },
    {
      type: "MULTIPLE_CHOICE",
      isVisible: true,
      configuration: {
        fieldName: "Multiple choice question",
        label: "",
        type: "MULTIPLE_CHOICE_SINGLE_ANSWER",
        title: true,
        titleText: "",
        required: true,
        errorText: "You must choose an answer",
        translatableField: ["label", "errorText", "titleText"]
      },
      answer: {
        defaultAnswer: "NOT_SELECTED",
        options: [
          {
            option: "Option 1"
          }
        ]
      },
      dataCollection: {
        customerMetafield: {
          enabled: true,
          keyName: "Multiple choice 1"
        },
        orderMetafield: {
          enabled: true,
          keyName: "Multiple choice 1"
        }
      }
    },
    {
      type: "FORM_WIDGET",
      category: "CONTAINER",
      isVisible: true,
      name: "Form",
      errorText: "The form is required",
      translatableField: ["errorText"],
      widgets: [],
      blocks: [
        {
          type: "BUTTON",
          displayOrder: 0,
          location: "STEP_A",
          buttonType: "PRIMARY",
          buttonText: "Submit",
          translatableField: ["buttonText"]
        }
      ]
    },
    {
      type: "IMAGE_WIDGET",
      category: "INFORMATIONAL",
      isVisible: true,
      name: "Image (1)",
      image: {
        src: null,
        altText: "",
        translatableField: ["altText"]
      },
      link: {
        addLink: false,
        destinationURL: "",
        openInNewTabDesktop: true,
        openInNewTabMobile: true
      },
      layout: {
        height: "AUTO",
        fit: "COVER",
        aspectRatio: "AUTO",
        alignment: "CENTER",
        cornerRadius: "BASE",
        borderStyle: "BASE",
        padding: "BASE"
      }
    }
  ]
};

// src/defaultWidgetsValue/order_status_page_default_values.json
var order_status_page_default_values_default = {
  defaultValues: [
    {
      type: "DIVIDER",
      category: "INFORMATIONAL",
      isVisible: true,
      name: "Divider (1)",
      dividerText: {
        enabled: false,
        value: "Title",
        translatableField: ["value"]
      }
    },
    {
      type: "TEXT",
      category: "INFORMATIONAL",
      isVisible: true,
      text: "<p>You may also like this product</p>",
      name: "Text (1)",
      translatableField: ["text"]
    },
    {
      type: "UPSELL",
      category: "CONVERTING",
      parentType: "MULTI_PRODUCT_UPSELL",
      isVisible: true,
      text: "You may also like this product",
      name: "Product (1)",
      translatableField: ["text"],
      upsellInfo: {
        type: "SHOPIFY_RECOMMENDATIONS",
        noOfProducts: 1,
        productsPerRow: 3,
        location: "ORDER",
        layout: "SMALL_LAYOUT_ONE",
        subLayout: "SMALL_LAYOUT_ONE",
        sliderConfig: {
          hint: "PILL",
          hintText: "Scroll",
          translatableField: ["hintText"]
        },
        settings: {
          SPECIFIC_PRODUCT: [
            {
              productInfo: {},
              optionsIfAlreadyInLocation: {
                value: "display_featured_product_anyway",
                alternateProduct: {}
              },
              defaultSelected: true,
              mandatory: false
            }
          ],
          SHOPIFY_RECOMMENDATIONS: {
            hideIfAlreadyInLocation: false,
            excludeTagsOptions: {
              enabled: false,
              tags: []
            },
            recommendationIntent: "related"
          },
          MOST_EXPENSIVE: {
            excludeTagsOptions: {
              enabled: false,
              tags: [],
              alternateOption: "use_shopify_recommendation",
              alternateProduct: {}
            }
          },
          LEAST_EXPENSIVE: {
            excludeTagsOptions: {
              enabled: false,
              tags: [],
              alternateOption: "use_shopify_recommendation",
              alternateProduct: {}
            }
          },
          PERSONALIZED_RECOMMENDATIONS: {
            excludeTagsOptions: {
              enabled: false,
              tags: []
            },
            hideIfAlreadyInLocation: false
          },
          RECOMATIC_RECOMMENDATIONS: {
            excludeTagsOptions: {
              enabled: false,
              tags: []
            }
          },
          SPECIFIC_COLLECTION: []
        }
      },
      blocks: [
        {
          type: "IMAGE",
          isVisible: true,
          imageFit: "CONTAIN",
          imageToDisplay: "MAIN_PRODUCT",
          imageURL: "",
          showImageAccordingToVariant: true,
          linkToProduct: false,
          imageBorderRadius: "BASE",
          imageBorderStyle: "BASE"
        },
        {
          type: "PRODUCT_TITLE",
          isVisible: true,
          customTitle: {
            enabled: false,
            value: "Product title",
            translatableField: ["value"]
          }
        },
        {
          type: "STAR_RATING",
          isVisible: true,
          blockSettings: {
            starColor: "#F4C430",
            layout: "MINIMALISTIC",
            showAmountOfReviews: true,
            showRatingValue: true,
            reviewsLabel: "reviews",
            integrationError: false,
            translatableField: ["reviewsLabel"]
          }
        },
        {
          type: "PRODUCT_DETAILS",
          isVisible: true,
          subtitle: {
            selection: "VARIANT_NAME",
            textStyle: "UPPER_CASE",
            customText: "Text",
            translatableField: ["customText"]
          }
        },
        {
          type: "DESCRIPTION",
          isVisible: true,
          displayProductDescription: true,
          customText: {
            enabled: false,
            value: "text text text text",
            translatableField: ["value"]
          },
          collapsible: {
            enabled: true,
            defaultState: "COLLAPSED",
            buttonText: "Description",
            translatableField: ["buttonText"]
          }
        },
        {
          type: "PRICE_AND_DISCOUNT",
          isVisible: true,
          price: {
            samePriceForAll: true,
            priceToDisplay: "DISPLAY_HIGHEST_LOWEST_PRICE",
            totalPriceText: "Total Price",
            translatableField: ["totalPriceText"],
            displayComparision: {
              dontDisplayComparePrice: false,
              enabled: true,
              size: "DEFAULT",
              color: "CRITICAL"
            },
            displayOriginal: {
              enabled: true,
              size: "DEFAULT",
              color: "CRITICAL"
            },
            displayAfterDiscount: {
              enabled: true,
              size: "DEFAULT",
              color: "INFO"
            }
          },
          discount: {
            enabled: true,
            onlyForOrdersOverValue: {
              enabled: false,
              minimumOrderValue: 0
            },
            type: "PERCENTAGE",
            name: "",
            breakPoint: [
              {
                minimumItemGetDiscount: 1,
                value: 0
              }
            ],
            discountValue: 0,
            minItemsDiscount: 1,
            maxItemsDiscount: 100,
            onlyForProductsOverValue: {
              enabled: false,
              minimumProductPrice: 100
            }
          },
          shippingDetails: {
            type: "FREE",
            rate: 0,
            title: "Shipping",
            freeShippingName: "Free",
            fallbackRate: 0,
            translatableField: ["title", "freeShippingName"]
          }
        },
        {
          type: "BUTTON",
          isVisible: true,
          buttonType: "PRIMARY",
          buttonText: "{{buy now}}",
          translatableField: ["buttonText"]
        },
        {
          type: "VARIANT_PICKER",
          isVisible: true,
          displayVariantPicker: true,
          label: "Variant",
          preselectedVariant: "DEFAULT_PRODUCT_VARIANT",
          selectedSpecificVariantId: "",
          combineAllOptionsIntoOneDropdown: true,
          showPriceInDropdown: true,
          translatableField: ["label", "errorMessage"]
        },
        {
          type: "QUANTITY_SELECTOR",
          isVisible: true,
          displayQuantitySelector: true,
          label: "Quantity",
          defaultQuantity: 1,
          minQuantity: {
            enabled: false,
            value: 1
          },
          maxQuantity: {
            enabled: false,
            value: 10
          },
          translatableField: ["label"]
        },
        {
          type: "SUCCESS_ERROR_BANNER",
          isVisible: true,
          successBanner: {
            enabled: true,
            type: "SUCCESS",
            text: "Added to cart.",
            dismissible: true,
            translatableField: ["text"]
          },
          errorBanner: {
            enabled: true,
            type: "CRITICAL",
            dismissible: true,
            staticText: {
              enabled: true,
              value: "Unable to add product/s to cart.",
              translatableField: ["value"]
            }
          }
        }
      ]
    },
    {
      type: "TOTAL_PRICE",
      isVisible: true,
      priceToDisplay: "HIGHEST_LOWEST_PRICE",
      dontDisplayCompareTotalPrice: false,
      isDisplayCompareToPrice: true,
      text: "{{total price}} {{pricing}}",
      displayComparisionFontColor: "CRITICAL",
      displayOriginalFontColor: "CRITICAL",
      displayAfterDiscountFontColor: "INFO",
      translatableField: ["text"]
    },
    {
      type: "BUTTON",
      isVisible: true,
      buttonType: "PRIMARY",
      buttonText: "Add {{item count}} Items",
      translatableField: ["buttonText"]
    },
    {
      type: "SUCCESS_ERROR_BANNER",
      isVisible: true,
      successBanner: {
        enabled: true,
        type: "SUCCESS",
        text: "The item successfully added to the cart.",
        dismissible: true,
        translatableField: ["text"]
      },
      errorBanner: {
        enabled: true,
        type: "CRITICAL",
        dismissible: true,
        staticText: {
          enabled: true,
          value: "Unable to add product/s to cart.",
          translatableField: ["value"]
        }
      }
    },
    {
      type: "TIMER",
      category: "INFORMATIONAL",
      isVisible: true,
      name: "Timer (1)",
      blocks: [
        {
          type: "TIMER_TEXT",
          description: '<h2 style="text-align: center; font-size: 16px; font-weight: 600; margin-bottom: 0px;">Offer expires in:</h2>',
          frameBorderRadius: "BASE",
          frameBorder: "BASE",
          textInframe: false,
          textBackground: "SUBDUED",
          translatableField: ["description"],
          timerExpiredSetting: {
            replaceWhenTimerRunOut: true,
            timerExpiredText: '<h2 style="text-align: center; font-size: 16px; font-weight: 600; margin-bottom: 0px;">Offer expired</h2>',
            preview: false,
            translatableField: ["timerExpiredText"]
          }
        },
        {
          type: "CLOCK",
          background: "BASE",
          digitColor: "CRITICAL",
          showTitle: false,
          title: '<h2 style="text-align: center; font-size: 16px; font-weight: 600; margin-bottom: 0px;">Hurry up!</h2>',
          translatableField: ["title"],
          clockFrame: "INDIVIDUAL_FRAMES",
          frameBorder: "BASE",
          frameBorderRadius: "BASE",
          showTimeSeparator: true,
          showTimeUnitLabels: true,
          timeUnitLabels: {
            days: "",
            hours: "",
            minutes: "",
            seconds: "",
            translatableField: ["days", "hours", "minutes", "seconds"]
          },
          showUnitLabelsInFrame: false,
          unitLabelsPosition: "BELOW_DIGITS",
          timerExpiredSetting: {
            whenTimeRunsOut: "REPLACE_CLOCK_WITH_TEXT",
            timerExpiredText: "",
            preview: false,
            translatableField: ["timerExpiredText"]
          }
        },
        {
          type: "PROGRESS_BAR",
          showProgressBar: true,
          progressBarColor: "AUTO",
          timerExpiredSetting: {
            timerRunsOut: "CHANGE_PROGRESS_BAR_COLOR",
            progressBarColor: "CRITICAL",
            preview: false
          }
        }
      ],
      upsellInfo: {
        settings: {
          displayTimer: "ONCE_PER_ORDER",
          timerEffect: "ALL_WIDGETS_ON_THIS_PAGE",
          timerRunsOut: "DO_NOTHING",
          selectedWidgets: []
        },
        duration: {
          count: "TIME_PASSED",
          startCounting: "ON_FIRST_IMPRESSION",
          dateAndTime: "",
          duration: {
            days: 0,
            hours: 0,
            minutes: 7,
            seconds: 0
          }
        },
        designConfig: {
          timerStyle: "PROMOTIONAL",
          backgroundColor: "SUBDUED",
          desktopLayout: "HORIZONTAL",
          bannerType: "INFO",
          timerBorder: "BASE",
          timerBorderRadius: "LARGE"
        },
        expiredMessageConfig: {
          changeBannerTypeOnTimerRunOut: false,
          bannerTypeOnTimerRunOut: "CRITICAL",
          isDisplayMessage: true,
          backgroundColor: "RED",
          preview: false
        }
      }
    },
    {
      type: "BANNER",
      category: "INFORMATIONAL",
      isVisible: true,
      status: "INFO",
      dismissible: true,
      name: "Banner (1)",
      content: {
        title: "Title",
        description: "",
        collapsible: true,
        translatableField: ["title", "description"]
      },
      button: {
        display: false,
        type: "PRIMARY",
        color: "DEFAULT",
        text: "Button text",
        link: "",
        translatableField: ["text"]
      }
    },
    {
      type: "MULTI_PRODUCT_UPSELL",
      category: "CONTAINER",
      isVisible: true,
      text: "You may also like this product",
      translatableField: ["text"],
      name: "Product upsell (1)",
      postAcceptOption: "HIDE_PRODUCT",
      ifNoProductsToShowBlocksShould: "HIDE",
      widgets: [
        {
          type: "DIVIDER"
        },
        {
          type: "TEXT"
        },
        {
          type: "UPSELL",
          layout: "SMALL_LAYOUT_TWO"
        }
      ]
    },
    {
      type: "RECOMMENDATIONS",
      category: "CONTAINER",
      isVisible: true,
      text: "You may also like this product",
      name: "Product recommendations (1)",
      postAcceptOption: "HIDE_PRODUCT",
      ifNoProductsToShowBlocksShould: "HIDE",
      translatableField: ["text"],
      widgets: [
        {
          type: "TEXT",
          text: '<h2 style="text-align: left; font-size: 16px; font-weight: 600; margin-bottom: 0px;">You may also like these products</h2>',
          translatableField: ["text"]
        },
        {
          type: "UPSELL",
          noOfProducts: 8,
          layout: "SLIDER",
          optionalBlocks: [
            "PRODUCT_DETAILS",
            "SUCCESS_ERROR_BANNER"
          ],
          blocksDefaultValue: [
            {
              type: "DESCRIPTION",
              displayProductDescription: false
            }
          ]
        }
      ]
    },
    {
      type: "BUNDLE",
      category: "CONTAINER",
      isVisible: true,
      text: "You may also like this product",
      translatableField: ["text"],
      name: "Bundle(1)",
      noOfProducts: 3,
      productsPerRow: 3,
      sliderConfig: {
        hint: "PILL",
        hintText: "Scroll",
        translatableField: ["hintText"]
      },
      layout: "GRID",
      allowSeparateQuantitySelection: true,
      postAcceptOption: "HIDE_BUNDLE",
      ifNoProductsToShowBlocksShould: "HIDE",
      shippingDetails: {
        type: "FREE",
        rate: 0,
        title: "Shipping",
        freeShippingName: "Free",
        translatableField: ["title", "freeShippingName"]
      },
      widgets: [
        {
          type: "TEXT",
          text: '<p><span style="font-size: 14px;"><strong>Frequently bought together</strong></span></p>',
          displayOrder: 0,
          translatableField: ["text"]
        },
        {
          type: "UPSELL",
          displayOrder: 1,
          layout: "LIST",
          subLayout: "SMALL_LAYOUT_ONE",
          removeBlocks: [
            "BUTTON",
            "SUCCESS_ERROR_BANNER"
          ],
          blocksDefaultValue: [
            {
              type: "PRICE_AND_DISCOUNT",
              priceToDisplay: "ONLY_HIGHEST_PRICE",
              displayComparision: {
                color: "INFO"
              }
            },
            {
              type: "BUTTON",
              buttonText: "Buy now {{item count}} Items",
              translatableField: ["buttonText"]
            }
          ]
        },
        {
          type: "UPSELL",
          displayOrder: 2,
          layout: "LIST",
          subLayout: "SMALL_LAYOUT_ONE",
          removeBlocks: [
            "BUTTON",
            "SUCCESS_ERROR_BANNER"
          ],
          blocksDefaultValue: [
            {
              type: "PRICE_AND_DISCOUNT",
              priceToDisplay: "ONLY_HIGHEST_PRICE",
              displayComparision: {
                color: "INFO"
              }
            },
            {
              type: "BUTTON",
              buttonText: "Buy now {{item count}} Items",
              translatableField: ["buttonText"]
            }
          ]
        },
        {
          type: "UPSELL",
          displayOrder: 3,
          layout: "LIST",
          subLayout: "SMALL_LAYOUT_ONE",
          removeBlocks: [
            "BUTTON",
            "SUCCESS_ERROR_BANNER"
          ],
          blocksDefaultValue: [
            {
              type: "PRICE_AND_DISCOUNT",
              priceToDisplay: "ONLY_HIGHEST_PRICE",
              displayComparision: {
                color: "INFO"
              }
            },
            {
              type: "BUTTON",
              buttonText: "Buy now {{item count}} Items",
              translatableField: ["buttonText"]
            }
          ]
        }
      ],
      blocks: [
        {
          type: "TOTAL_PRICE",
          displayOrder: 4
        },
        {
          type: "BUTTON",
          displayOrder: 5,
          buttonText: "Add {{item count}} Items",
          translatableField: ["buttonText"]
        },
        {
          type: "SUCCESS_ERROR_BANNER",
          displayOrder: 6
        }
      ]
    },
    {
      type: "DATE_PICKER",
      isVisible: true,
      configuration: {
        fieldName: "Birthday",
        title: false,
        titleText: "",
        label: "Your birthday (YYYY-MM-DD)",
        dateFormat: "YYYY-MM-DD",
        required: true,
        errorText: "Birthday is required",
        translatableField: ["label", "errorText", "titleText"]
      },
      dataCollection: {
        customerMetafield: {
          enabled: true,
          keyName: "Birthday"
        },
        orderMetafield: {
          enabled: true,
          keyName: "Birthday"
        }
      }
    },
    {
      type: "TEXT_AREA",
      isVisible: true,
      configuration: {
        fieldName: "Text area",
        title: true,
        titleText: "",
        label: "Text placeholder",
        required: true,
        errorText: "This field is Required",
        translatableField: ["label", "errorText", "titleText"]
      },
      dataCollection: {
        customerMetafield: {
          enabled: true,
          keyName: "Text area 1"
        },
        orderMetafield: {
          enabled: true,
          keyName: "Text area 1"
        }
      }
    },
    {
      type: "TEXT_FIELD",
      isVisible: true,
      configuration: {
        fieldName: "Text field",
        title: true,
        titleText: "",
        label: "Text placeholder",
        required: true,
        errorText: "This field is Required",
        translatableField: ["label", "errorText", "titleText"]
      },
      dataCollection: {
        customerMetafield: {
          enabled: true,
          keyName: "Text field 1"
        },
        orderMetafield: {
          enabled: true,
          keyName: "Text field 1"
        }
      }
    },
    {
      type: "MULTIPLE_CHOICE",
      isVisible: true,
      configuration: {
        fieldName: "Multiple choice question",
        label: "",
        type: "MULTIPLE_CHOICE_SINGLE_ANSWER",
        title: true,
        titleText: "",
        required: true,
        errorText: "You must choose an answer",
        translatableField: ["label", "errorText", "titleText"]
      },
      answer: {
        defaultAnswer: "NOT_SELECTED",
        options: [
          {
            option: "Option 1"
          }
        ]
      },
      dataCollection: {
        customerMetafield: {
          enabled: true,
          keyName: "Multiple choice 1"
        },
        orderMetafield: {
          enabled: true,
          keyName: "Multiple choice 1"
        }
      }
    },
    {
      type: "FORM_WIDGET",
      category: "CONTAINER",
      isVisible: true,
      name: "Form",
      errorText: "The form is required",
      translatableField: ["errorText"],
      widgets: [],
      blocks: [
        {
          type: "BUTTON",
          displayOrder: 0,
          location: "STEP_A",
          buttonType: "PRIMARY",
          buttonText: "Submit"
        }
      ]
    },
    {
      type: "ORDER_STATUS_PAGE_BAR",
      displayOrder: 1,
      isVisible: true,
      category: "INFORMATIONAL",
      parentType: "DISCOUNT_TIMER",
      name: "Order Status Page Bar",
      blocks: [
        {
          type: "TIMER_TEXT",
          name: "Timer Text",
          parentType: "ORDER_STATUS_PAGE_BAR",
          description: '<h2 style="font-size: 16px; font-weight: 600; margin-bottom: 0px;">One-Time Offer!</h2><p>For the next 20 minutes only, get 10% OFF EVERYTHING!</p>',
          mobileDescription: '<h2 style="font-size: 16px; font-weight: 600; margin-bottom: 0px;">Limited offer</h2>\n<p>30% Off Site-wide, GO.</p>',
          translatableField: ["description", "mobileDescription"],
          timerExpiredSetting: {
            replaceWhenTimerRunOut: true,
            timerExpiredText: '<h2 style="text-align: center; font-size: 16px; font-weight: 600; margin-bottom: 0px;">Offer expired</h2>',
            mobileTimerExpiredText: '<h2 style="text-align: center; font-size: 16px; font-weight: 600; margin-bottom: 0px;">Offer expired</h2>',
            preview: false,
            translatableField: ["timerExpiredText", "mobileTimerExpiredText"]
          }
        },
        {
          type: "CLOCK",
          name: "Clock",
          parentType: "ORDER_STATUS_PAGE_BAR",
          background: "SUBDUED",
          digitColor: "WARNING",
          showTitle: false,
          title: "",
          clockFrame: "INDIVIDUAL_FRAMES",
          frameBorder: "BASE",
          frameBorderRadius: "BASE",
          showTimeSeparator: true,
          showTimeUnitLabels: true,
          timeUnitLabels: {
            days: "",
            hours: "",
            minutes: "",
            seconds: "",
            translatableField: ["days", "hours", "minutes", "seconds"]
          },
          showUnitLabelsInFrame: true,
          unitLabelsPosition: "BELOW_DIGITS",
          timerExpiredSetting: {
            whenTimeRunsOut: "REMOVE_CLOCK",
            timerExpiredText: "",
            mobileTimerExpiredText: "",
            preview: false,
            translatableField: ["timerExpiredText", "mobileTimerExpiredText"]
          }
        },
        {
          type: "ACCEPT_BUTTON",
          parentType: "ORDER_STATUS_PAGE_BAR",
          buttonType: "PRIMARY",
          name: "Accept Button",
          buttonText: "Shop Now",
          mobileButtonText: "Accept offer",
          helpText: "The link in the store the button directs to. Only use a relative link, no need for full URL. Example: For the URL: store.com/collections/best-sellers  Write: '/collections/best-sellers'",
          displayOrder: 0,
          isVisible: true,
          translatableField: ["buttonText", "mobileButtonText", "helpText"]
        },
        {
          type: "DECLINE_BUTTON",
          parentType: "ORDER_STATUS_PAGE_BAR",
          buttonType: "SECONDARY",
          name: "Decline Button",
          showCloseButton: true,
          buttonText: "Maybe later",
          isVisible: true,
          translatableField: ["buttonText"]
        }
      ]
    },
    {
      type: "ONLINE_STORE_BAR",
      name: "Online Store Bar",
      displayOrder: 2,
      isVisible: true,
      category: "INFORMATIONAL",
      parentType: "DISCOUNT_TIMER",
      blocks: [
        {
          type: "TIMER_TEXT",
          name: "Timer Text",
          parentType: "ONLINE_STORE_BAR",
          description: '<h2 style="font-size: 16px; font-weight: 600; margin-bottom: 0px;">One-Time Offer!</h2><p>For the next 20 minutes only, get 10% OFF EVERYTHING!</p>',
          mobileDescription: '<h2 style="font-size: 16px; font-weight: 600; margin-bottom: 0px;">Limited offer</h2>\n<p>30% Off Site-wide, GO.</p>',
          translatableField: ["description", "mobileDescription"],
          timerExpiredSetting: {
            replaceWhenTimerRunOut: true,
            timerExpiredText: '<h2 style="text-align: center; font-size: 16px; font-weight: 600; margin-bottom: 0px;">Offer expired</h2>',
            mobileTimerExpiredText: '<h2 style="text-align: center; font-size: 16px; font-weight: 600; margin-bottom: 0px;">Offer expired</h2>',
            preview: false,
            translatableField: ["timerExpiredText", "mobileTimerExpiredText"]
          },
          displayOrder: 0,
          isVisible: true
        },
        {
          type: "CLOCK",
          name: "Clock",
          parentType: "ONLINE_STORE_BAR",
          background: "SUBDUED",
          digitColor: "WARNING",
          clockFrame: "INDIVIDUAL_FRAMES",
          frameBorder: "BASE",
          frameBorderRadius: "BASE",
          showTimeSeparator: true,
          showTimeUnitLabels: true,
          timeUnitLabels: {
            days: "",
            hours: "",
            minutes: "",
            seconds: "",
            translatableField: ["days", "hours", "minutes", "seconds"]
          },
          showUnitLabelsInFrame: true,
          unitLabelsPosition: "BELOW_DIGITS",
          timerExpiredSetting: {
            whenTimeRunsOut: "REMOVE_CLOCK",
            timerExpiredText: "",
            mobileTimerExpiredText: "",
            preview: false,
            translatableField: ["timerExpiredText", "mobileTimerExpiredText"]
          }
        }
      ]
    },
    {
      type: "DISCOUNT_TIMER",
      name: "Discount Timer",
      category: "CONVERTING",
      isVisible: true,
      startTimer: "ONCE_PER_ORDER",
      count: "TIME_PASSED",
      startCounting: "ON_FIRST_IMPRESSION",
      dateAndTime: "",
      duration: {
        days: 0,
        hours: 0,
        minutes: 20,
        seconds: 0
      },
      whenTimerRunOut: "CLOSE_ANNOUNCEMENT_BAR",
      previewExpiredOffer: true,
      discountSettings: {
        applyDiscount: false,
        discountType: "PERCENTAGE",
        discountValue: "10%",
        discountPrefix: "Upsell.com"
      },
      widgets: [
        {
          type: "ORDER_STATUS_PAGE_BAR"
        },
        {
          type: "ONLINE_STORE_BAR"
        }
      ]
    },
    {
      type: "IMAGE_WIDGET",
      category: "INFORMATIONAL",
      isVisible: true,
      name: "Image (1)",
      image: {
        src: null,
        altText: "",
        translatableField: ["altText"]
      },
      link: {
        addLink: false,
        destinationURL: "",
        openInNewTabDesktop: true,
        openInNewTabMobile: true
      },
      layout: {
        height: "AUTO",
        fit: "COVER",
        aspectRatio: "AUTO",
        alignment: "CENTER",
        cornerRadius: "BASE",
        borderStyle: "BASE",
        padding: "BASE"
      }
    }
  ]
};

// src/defaultWidgetsValue/post_purchase_default_values.json
var post_purchase_default_values_default = {
  defaultValues: [
    {
      type: "TEXT",
      category: "INFORMATIONAL",
      isVisible: true,
      text: "<p>You may also like this product</p>",
      name: "Text (1)",
      translatableField: ["text"]
    },
    {
      type: "DIVIDER",
      category: "INFORMATIONAL",
      isVisible: true,
      name: "Divider (1)"
    },
    {
      type: "BANNER",
      category: "INFORMATIONAL",
      isVisible: true,
      status: "INFO",
      dismissible: false,
      name: "Banner (1)",
      content: {
        title: "Banner title",
        description: "",
        collapsible: true,
        translatableField: ["title", "description"]
      },
      button: {
        display: false,
        type: "PRIMARY",
        color: "DEFAULT",
        text: "Button text",
        link: "",
        translatableField: ["text"]
      }
    },
    {
      type: "TIMER",
      category: "INFORMATIONAL",
      isVisible: true,
      text: "Offer expires in:",
      name: "Timer (1)",
      translatableField: ["text"],
      upsellInfo: {
        settings: {
          displayTimer: "ON_EVERY_PAGE_LOAD",
          timerRunsOut: "MOVE_TO_NEXT_PAGE",
          duration: {
            days: 0,
            hours: 0,
            minutes: 5,
            seconds: 0
          },
          labels: {
            days: "",
            hours: "",
            minutes: "",
            seconds: "",
            translatableField: ["days", "hours", "minutes", "seconds"]
          }
        },
        designConfig: {
          backgroundColor: "BLUE",
          desktopLayout: "HORIZONTAL",
          desktopTextPosition: "LEFT_TO_TIMER"
        },
        expiredMessageConfig: {
          isDisplayMessage: true,
          backgroundColor: "RED",
          preview: false,
          message: '<p style="text-align: center;">Offer expired</p>',
          translatableField: ["message"]
        }
      }
    },
    {
      type: "UPSELL",
      category: "CONVERTING",
      parentType: "UPSELL",
      isVisible: true,
      text: "You may also like this product",
      name: "Product (1)",
      translatableField: ["text"],
      upsellInfo: {
        noOfProducts: 1,
        productsPerRow: 4,
        location: "ORDER",
        layout: "TWO_COLUMN",
        subLayout: "SMALL_LAYOUT_ONE",
        isVisibleLeftColumnsBlocks: true,
        isVisibleRightColumnsBlocks: true,
        isVisibleBottomColumnsBlocks: true,
        type: "SHOPIFY_RECOMMENDATIONS",
        variantSelector: false,
        settings: {
          SPECIFIC_PRODUCT: [
            {
              productInfo: {},
              optionsIfAlreadyInLocation: {
                value: "display_featured_product_anyway",
                alternateProduct: {}
              },
              defaultSelected: true,
              mandatory: false
            }
          ],
          MOST_EXPENSIVE: {
            excludeTagsOptions: {
              enabled: false,
              tags: [],
              alternateOption: "use_shopify_recommendation",
              alternateProduct: {},
              specificProductEnabled: false,
              specificProductTags: []
            }
          },
          LEAST_EXPENSIVE: {
            excludeTagsOptions: {
              enabled: false,
              tags: [],
              alternateOption: "use_shopify_recommendation",
              alternateProduct: {},
              specificProductEnabled: false,
              specificProductTags: []
            }
          },
          SHOPIFY_RECOMMENDATIONS: {
            hideIfAlreadyInLocation: false,
            excludeTagsOptions: {
              enabled: false,
              tags: [],
              specificProductEnabled: false,
              specificProductTags: []
            },
            recommendationIntent: "related"
          },
          PERSONALIZED_RECOMMENDATIONS: {
            hideIfAlreadyInLocation: false,
            excludeTagsOptions: {
              enabled: false,
              tags: [],
              specificProductEnabled: false,
              specificProductTags: []
            }
          },
          RECOMATIC_RECOMMENDATIONS: {
            excludeTagsOptions: {
              enabled: false,
              tags: [],
              specificProductEnabled: false,
              specificProductTags: []
            }
          },
          SPECIFIC_COLLECTION: []
        }
      },
      blocks: [
        {
          type: "SUBSCRIPTION",
          location: 0,
          isVisible: true,
          isDraggable: true,
          isSubscriptionEnabled: false,
          subscriptionOptionDisplay: "SHOW_ALL_SUBSCRIPTION_OPTIONS",
          displaySellingOptions: true,
          sellingPlanToApply: "",
          productOption: "SUBSCRIPTION",
          showSubscriptionPlanDescription: true,
          subscriptionPlanDescription: "<p>[frequency], save [discount %]&nbsp;</p><p>auto-renews, cancel anytime</p>",
          displayOrder: 0,
          purchaseOptionsTitle: "Purchase options",
          offerSubscriptionOptionOnly: false,
          showSubscriptionBadge: false,
          subscriptionBadgeText: "Subscription",
          showSavingsDetailsBadge: false,
          savingsDetailsBadgeText: "Save up to {{subscription discount}}",
          translatableField: ["purchaseOptionsTitle", "subscriptionBadgeText", "savingsDetailsBadgeText", "subscriptionPlanDescription"]
        },
        {
          type: "IMAGE",
          location: 1,
          isVisible: true,
          imageCarrouselStyle: "IMAGE_CARROUSEL",
          imageQty: 3,
          imageFit: "CONTAIN",
          imageToDisplay: "MAIN_PRODUCT",
          imageURL: "",
          showImageAccordingToVariant: true,
          linkToProduct: false,
          imageBorderRadius: "BASE",
          imageBorderStyle: "BASE",
          displayOrder: 1
        },
        {
          type: "PRODUCT_TITLE",
          location: 2,
          isVisible: true,
          customTitle: {
            enabled: false,
            value: "Product title",
            translatableField: ["value"]
          },
          displayOrder: 2
        },
        {
          type: "STAR_RATING",
          isVisible: true,
          blockSettings: {
            starColor: "#F4C430",
            layout: "MINIMALISTIC",
            showAmountOfReviews: true,
            showRatingValue: true,
            reviewsLabel: "reviews",
            integrationError: false,
            translatableField: ["reviewsLabel"]
          }
        },
        {
          type: "PRODUCT_DETAILS",
          location: 2,
          isVisible: true,
          subtitle: {
            selection: "VARIANT_NAME",
            customText: "Text",
            textStyle: "UPPER_CASE",
            translatableField: ["customText"]
          },
          displayOrder: 3
        },
        {
          type: "PRICE_AND_DISCOUNT",
          location: 2,
          isVisible: true,
          price: {
            samePriceForAll: true,
            priceToDisplay: "DISPLAY_HIGHEST_LOWEST_PRICE",
            totalPriceText: "Total Price",
            translatableField: ["totalPriceText"],
            displayComparision: {
              dontDisplayComparePrice: false,
              enabled: true,
              size: "DEFAULT",
              color: "CRITICAL"
            },
            displayOriginal: {
              enabled: true,
              size: "DEFAULT",
              color: "CRITICAL"
            },
            displayAfterDiscount: {
              enabled: true,
              size: "DEFAULT",
              color: "SUBDUED"
            }
          },
          discount: {
            enabled: true,
            onlyForOrdersOverValue: {
              enabled: false,
              minimumOrderValue: 0
            },
            type: "PERCENTAGE",
            name: "",
            breakPoint: [
              {
                minimumItemGetDiscount: 1,
                value: 0
              }
            ],
            discountValue: 0,
            minItemsDiscount: 1,
            maxItemsDiscount: 100,
            onlyForProductsOverValue: {
              enabled: false,
              minimumProductPrice: 100
            }
          },
          shippingDetails: {
            type: "FREE",
            rate: 0,
            title: "Shipping",
            freeShippingName: "Free",
            translatableField: ["title", "freeShippingName"]
          },
          displayOrder: 4
        },
        {
          type: "VARIANT_PICKER",
          location: 2,
          isVisible: true,
          displayVariantPicker: true,
          label: "Variant",
          preselectedVariant: "DEFAULT_PRODUCT_VARIANT",
          selectedSpecificVariantId: 0,
          combineAllOptionsIntoOneDropdown: false,
          showPriceInDropdown: true,
          errorMessage: "Please select variant",
          displayOrder: 5,
          translatableField: ["label", "errorMessage"]
        },
        {
          type: "QUANTITY_SELECTOR",
          location: 2,
          isVisible: true,
          displayQuantitySelector: true,
          label: "Quantity",
          translatableField: ["label"],
          defaultQuantity: 1,
          quantity: 1,
          minQuantity: {
            enabled: false,
            value: 1
          },
          maxQuantity: {
            enabled: false,
            value: 10
          },
          displayOrder: 6
        },
        {
          type: "ORDER_SUMMARY",
          location: 2,
          isVisible: true,
          displayOrderSummary: true,
          subtotalText: "Subtotal",
          discountText: "Discount",
          shippingText: "Shipping",
          taxesText: "Taxes",
          totalText: "Total",
          taxLine: "Including {{ amount }} in taxes",
          displayOrder: 7,
          isVisibleRecurringSubtotalTooltip: false,
          recurringSubtotalTooltipText: "<p><strong>Does not include shipping, tax, duties, or any applicable discounts</strong></p>",
          recurringSubtotalText: "Recurring subtotal",
          translatableField: ["subtotalText", "discountText", "shippingText", "taxesText", "totalText", "taxLine", "recurringSubtotalTooltipText", "recurringSubtotalText"]
        },
        {
          type: "DESCRIPTION",
          location: 3,
          isVisible: true,
          isPrimary: true,
          displayProductDescription: true,
          customText: {
            enabled: false,
            value: "text text text text",
            translatableField: ["value"]
          },
          collapsible: {
            enabled: true,
            defaultState: "COLLAPSED",
            buttonText: "Description",
            translatableField: ["buttonText"]
          },
          displayOrder: 8
        },
        {
          type: "ACCEPT_BUTTON",
          location: 2,
          isVisible: true,
          buttonType: "PRIMARY",
          buttonText: "Pay now {{total added price}}",
          subscriptionButtonText: "Subscribe",
          subscriptionPoliciesConsent: "I understand that I am agreeing to a subscription, which will automatically renew at the listed price and frequency until it is canceled or ends test",
          secondClick: false,
          confirmButtonText: "Confirm and pay now",
          subscriptionButtonTextForOneTimePurchase: "Pay now",
          displayOrder: 9,
          translatableField: ["confirmButtonText", "subscriptionPoliciesConsent", "subscriptionButtonTextForOneTimePurchase"]
        },
        {
          type: "DECLINE_BUTTON",
          location: 2,
          isVisible: true,
          buttonType: "SECONDARY",
          buttonText: "Decline offer",
          secondClick: false,
          confirmButtonText: "Are you sure you want to decline this offer?",
          displayOrder: 10,
          translatableField: ["confirmButtonText"]
        }
      ]
    },
    {
      type: "TOTAL_PRICE",
      isVisible: true,
      priceToDisplay: "HIGHEST_LOWEST_PRICE",
      dontDisplayCompareTotalPrice: false,
      isDisplayCompareToPrice: true,
      text: "{{total price}} {{pricing}}",
      displayComparisionFontColor: "CRITICAL",
      displayOriginalFontColor: "CRITICAL",
      displayAfterDiscountFontColor: "SUBDUED",
      translatableField: ["text"]
    },
    {
      type: "ORDER_SUMMARY",
      location: 2,
      isVisible: true,
      displayOrderSummary: true,
      subtotalText: "Subtotal",
      discountText: "Discount",
      shippingText: "Shipping",
      taxesText: "Taxes",
      totalText: "Total",
      taxLine: "Including {{ amount }} in taxes",
      translatableField: ["subtotalText", "discountText", "shippingText", "taxesText", "totalText", "taxLine"]
    },
    {
      type: "ACCEPT_BUTTON",
      location: 2,
      isVisible: true,
      buttonType: "PRIMARY",
      buttonText: "Pay now {{total added price}} ({{item count}} Items)",
      subscriptionButtonText: "Subscribe",
      subscriptionPoliciesConsent: "I understand that I am agreeing to a subscription, which will automatically renew at the listed price and frequency until it is canceled or ends",
      secondClick: false,
      confirmButtonText: "Confirm and pay now",
      translatableField: ["confirmButtonText", "subscriptionPoliciesConsent"]
    },
    {
      type: "DECLINE_BUTTON",
      location: 2,
      isVisible: true,
      buttonType: "SECONDARY",
      buttonText: "Decline offer",
      secondClick: false,
      confirmButtonText: "Are you sure you want to decline this offer?",
      translatableField: ["confirmButtonText"]
    },
    {
      type: "RECOMMENDATIONS",
      category: "CONTAINER",
      isVisible: true,
      text: "You may also like this product",
      name: "Product recommendations (1)",
      ifNoProductsToShowBlocksShould: "HIDE",
      translatableField: ["text"],
      widgets: [
        {
          type: "TEXT",
          text: '<p style="text-align: left;"><span style="font-size: 24px;">You may also like these products</span></p>',
          translatableField: ["text"]
        },
        {
          type: "UPSELL",
          noOfProducts: 4,
          layout: "GRID",
          removeBlocks: [
            "SUBSCRIPTION"
          ],
          optionalBlocks: [
            "PRODUCT_DETAILS",
            "ORDER_SUMMARY",
            "SUCCESS_ERROR_BANNER"
          ],
          blocksDefaultValue: [
            {
              type: "DESCRIPTION",
              displayProductDescription: false,
              displayOrder: 4
            },
            {
              type: "PRICE_AND_DISCOUNT",
              displayOrder: 5
            },
            {
              type: "VARIANT_PICKER",
              displayOrder: 6
            },
            {
              type: "QUANTITY_SELECTOR",
              displayOrder: 7
            },
            {
              type: "ORDER_SUMMARY",
              displayOrder: 8
            },
            {
              type: "ACCEPT_BUTTON",
              displayOrder: 9
            },
            {
              type: "DECLINE_BUTTON",
              secondClick: true,
              displayOrder: 10
            }
          ]
        }
      ]
    },
    {
      type: "BUNDLE",
      category: "CONTAINER",
      isVisible: true,
      text: "You may also like this product",
      translatableField: ["text"],
      name: "Bundle(1)",
      noOfProducts: 3,
      productsPerRow: 3,
      layout: "GRID",
      allowSeparateQuantitySelection: true,
      ifNoProductsToShowBlocksShould: "HIDE",
      shippingDetails: {
        type: "FREE",
        rate: 0,
        title: "Shipping",
        freeShippingName: "Free",
        translatableField: ["title", "freeShippingName"]
      },
      widgets: [
        {
          type: "TEXT",
          text: '<p><span style="font-size: 16px;"><strong>Frequently bought together</strong></span></p>',
          displayOrder: 0,
          translatableField: ["text"]
        },
        {
          type: "UPSELL",
          displayOrder: 1,
          layout: "LIST",
          subLayout: "SMALL_LAYOUT_ONE",
          removeBlocks: [
            "SUBSCRIPTION",
            "ORDER_SUMMARY",
            "ACCEPT_BUTTON",
            "DECLINE_BUTTON"
          ],
          blocksDefaultValue: [
            {
              type: "DESCRIPTION",
              collapsible: {
                enabled: false
              },
              displayOrder: 4
            },
            {
              type: "PRICE_AND_DISCOUNT",
              priceToDisplay: "ONLY_HIGHEST_PRICE",
              displayOrder: 5,
              displayComparision: {
                color: "SUBDUED"
              }
            },
            {
              type: "VARIANT_PICKER",
              displayOrder: 6
            },
            {
              type: "QUANTITY_SELECTOR",
              displayOrder: 7
            }
          ]
        },
        {
          type: "UPSELL",
          displayOrder: 2,
          layout: "LIST",
          subLayout: "SMALL_LAYOUT_ONE",
          removeBlocks: [
            "SUBSCRIPTION",
            "ORDER_SUMMARY",
            "ACCEPT_BUTTON",
            "DECLINE_BUTTON"
          ],
          blocksDefaultValue: [
            {
              type: "DESCRIPTION",
              collapsible: {
                enabled: false
              },
              displayOrder: 3
            },
            {
              type: "PRICE_AND_DISCOUNT",
              priceToDisplay: "ONLY_HIGHEST_PRICE",
              displayOrder: 4,
              displayComparision: {
                color: "SUBDUED"
              }
            },
            {
              type: "VARIANT_PICKER",
              displayOrder: 5
            },
            {
              type: "QUANTITY_SELECTOR",
              displayOrder: 6
            }
          ]
        },
        {
          type: "UPSELL",
          displayOrder: 3,
          layout: "LIST",
          subLayout: "SMALL_LAYOUT_ONE",
          removeBlocks: [
            "ORDER_SUMMARY",
            "ACCEPT_BUTTON",
            "DECLINE_BUTTON",
            "SUBSCRIPTION"
          ],
          blocksDefaultValue: [
            {
              type: "DESCRIPTION",
              collapsible: {
                enabled: false
              },
              displayOrder: 3
            },
            {
              type: "PRICE_AND_DISCOUNT",
              priceToDisplay: "ONLY_HIGHEST_PRICE",
              displayOrder: 4,
              displayComparision: {
                color: "SUBDUED"
              }
            },
            {
              type: "VARIANT_PICKER",
              displayOrder: 5
            },
            {
              type: "QUANTITY_SELECTOR",
              displayOrder: 6
            }
          ]
        }
      ],
      blocks: [
        {
          type: "TOTAL_PRICE",
          displayOrder: 4
        },
        {
          type: "ORDER_SUMMARY",
          displayOrder: 5,
          translatableField: ["subtotalText", "discountText", "shippingText", "taxesText", "totalText", "taxLine"]
        },
        {
          type: "ACCEPT_BUTTON",
          displayOrder: 6,
          buttonText: "Pay now {{total added price}} ({{item count}} Items)",
          translatableField: []
        },
        {
          type: "DECLINE_BUTTON",
          displayOrder: 7,
          translatableField: []
        }
      ]
    },
    {
      type: "IMAGE_WIDGET",
      category: "INFORMATIONAL",
      isVisible: true,
      name: "Image (1)",
      image: {
        src: null,
        altText: "",
        translatableField: ["altText"]
      },
      link: {
        addLink: false,
        destinationURL: "",
        openInNewTabDesktop: true,
        openInNewTabMobile: true
      },
      layout: {
        height: "AUTO",
        fit: "COVER",
        aspectRatio: "AUTO",
        alignment: "CENTER",
        cornerRadius: "NONE",
        borderStyle: "NONE",
        padding: "BASE"
      }
    }
  ]
};

// src/defaultWidgetsValue/pre_purchase_default_values.json
var pre_purchase_default_values_default = {
  defaultValues: [
    {
      type: "TEXT",
      category: "INFORMATIONAL",
      isVisible: true,
      text: "<p>You may also like this product</p>",
      name: "Text (1)",
      translatableField: ["text"]
    },
    {
      type: "BANNER",
      category: "INFORMATIONAL",
      isVisible: true,
      status: "INFO",
      dismissible: true,
      name: "Banner (1)",
      content: {
        title: "Title",
        description: "",
        collapsible: true,
        translatableField: ["title", "description"]
      },
      button: {
        display: false,
        type: "PRIMARY",
        color: "DEFAULT",
        text: "Button text",
        link: "",
        translatableField: ["text"]
      }
    },
    {
      type: "DIVIDER",
      category: "INFORMATIONAL",
      isVisible: true,
      name: "Divider (1)",
      dividerText: {
        enabled: false,
        value: "Title",
        translatableField: ["value"]
      }
    },
    {
      type: "UPSELL",
      category: "CONVERTING",
      parentType: "MULTI_PRODUCT_UPSELL",
      isVisible: true,
      text: "You may also like this product",
      translatableField: ["text"],
      name: "Product (1)",
      upsellInfo: {
        type: "SHOPIFY_RECOMMENDATIONS",
        noOfProducts: 1,
        productsPerRow: 3,
        sliderConfig: {
          hint: "PILL",
          hintText: "Scroll",
          translatableField: ["hintText"]
        },
        location: "CART",
        layout: "SMALL_LAYOUT_TWO",
        subLayout: "SMALL_LAYOUT_TWO",
        settings: {
          SPECIFIC_PRODUCT: [
            {
              productInfo: {},
              optionsIfAlreadyInLocation: {
                value: "display_featured_product_anyway",
                alternateProduct: {}
              },
              defaultSelected: true,
              mandatory: false
            }
          ],
          SHOPIFY_RECOMMENDATIONS: {
            hideIfAlreadyInLocation: false,
            excludeTagsOptions: {
              enabled: true,
              tags: []
            },
            recommendationIntent: "related"
          },
          MOST_EXPENSIVE: {
            excludeTagsOptions: {
              enabled: false,
              tags: [],
              alternateOption: "use_shopify_recommendation",
              alternateProduct: {}
            }
          },
          LEAST_EXPENSIVE: {
            excludeTagsOptions: {
              enabled: false,
              tags: [],
              alternateOption: "use_shopify_recommendation",
              alternateProduct: {}
            }
          },
          PERSONALIZED_RECOMMENDATIONS: {
            excludeTagsOptions: {
              enabled: false,
              tags: []
            },
            hideIfAlreadyInLocation: false
          },
          RECOMATIC_RECOMMENDATIONS: {
            excludeTagsOptions: {
              enabled: false,
              tags: []
            }
          },
          SPECIFIC_COLLECTION: []
        }
      },
      blocks: [
        {
          type: "SUBSCRIPTION",
          isVisible: true,
          isSubscriptionEnabled: false,
          subscriptionOptionDisplay: "SHOW_ALL_SUBSCRIPTION_OPTIONS",
          displaySellingOptions: true,
          sellingPlanToApply: "",
          productOption: "SUBSCRIPTION",
          purchaseOptionsTitle: "Purchase options",
          offerSubscriptionOptionOnly: false,
          showSubscriptionBadge: false,
          subscriptionBadgeText: "Subscription",
          showSavingsDetailsBadge: false,
          savingsDetailsBadgeText: "Save up to {{subscription discount}}",
          replaceExistingOneTimeProduct: true,
          translatableField: ["purchaseOptionsTitle", "subscriptionBadgeText", "savingsDetailsBadgeText"]
        },
        {
          type: "IMAGE",
          isVisible: true,
          imageFit: "CONTAIN",
          imageToDisplay: "MAIN_PRODUCT",
          imageURL: "",
          showImageAccordingToVariant: true,
          linkToProduct: true,
          imageBorderRadius: "BASE",
          imageBorderStyle: "BASE"
        },
        {
          type: "PRODUCT_TITLE",
          isVisible: true,
          customTitle: {
            enabled: false,
            value: "Product title",
            translatableField: ["value"]
          }
        },
        {
          type: "STAR_RATING",
          isVisible: true,
          blockSettings: {
            starColor: "#F4C430",
            layout: "MINIMALISTIC",
            showAmountOfReviews: true,
            showRatingValue: true,
            reviewsLabel: "reviews",
            integrationError: false,
            translatableField: ["reviewsLabel"]
          }
        },
        {
          type: "PRODUCT_DETAILS",
          isVisible: true,
          subtitle: {
            selection: "VARIANT_NAME",
            textStyle: "UPPER_CASE",
            customText: "Text",
            translatableField: ["customText"]
          }
        },
        {
          type: "DESCRIPTION",
          isVisible: true,
          displayProductDescription: true,
          customText: {
            enabled: false,
            value: "text text text text",
            translatableField: ["value"]
          },
          collapsible: {
            enabled: true,
            defaultState: "COLLAPSED",
            buttonText: "Description",
            translatableField: ["buttonText"]
          }
        },
        {
          type: "PRICE_AND_DISCOUNT",
          isVisible: true,
          price: {
            samePriceForAll: true,
            priceToDisplay: "DISPLAY_HIGHEST_LOWEST_PRICE",
            totalPriceText: "Total Price",
            translatableField: ["totalPriceText"],
            displayComparision: {
              dontDisplayComparePrice: false,
              enabled: true,
              size: "DEFAULT",
              color: ""
            },
            displayOriginal: {
              enabled: true,
              size: "DEFAULT",
              color: ""
            },
            displayAfterDiscount: {
              enabled: true,
              size: "DEFAULT",
              color: ""
            }
          },
          discount: {
            enabled: true,
            onlyForOrdersOverValue: {
              enabled: false,
              minimumOrderValue: 0
            },
            type: "PERCENTAGE",
            name: "",
            breakPoint: [
              {
                minimumItemGetDiscount: 1,
                value: 0
              }
            ],
            discountValue: 0,
            minItemsDiscount: 1,
            maxItemsDiscount: 100,
            onlyForProductsOverValue: {
              enabled: false,
              minimumProductPrice: 100
            }
          }
        },
        {
          type: "BUTTON",
          isVisible: true,
          buttonType: "SECONDARY",
          buttonText: "{{add to cart}}",
          subscriptionButtonTextForOneTimePurchase: "{{add to cart}}",
          subscriptionButtonText: "Add subscription",
          translatableField: ["buttonText", "subscriptionButtonText", "subscriptionButtonTextForOneTimePurchase"]
        },
        {
          type: "VARIANT_PICKER",
          isVisible: true,
          displayVariantPicker: true,
          label: "Variant",
          preselectedVariant: "DEFAULT_PRODUCT_VARIANT",
          selectedSpecificVariantId: "",
          combineAllOptionsIntoOneDropdown: true,
          showPriceInDropdown: true,
          translatableField: ["label", "errorMessage"]
        },
        {
          type: "QUANTITY_SELECTOR",
          isVisible: true,
          displayQuantitySelector: true,
          label: "Quantity",
          defaultQuantity: 1,
          translatableField: ["label"],
          minQuantity: {
            enabled: false,
            value: 1
          },
          maxQuantity: {
            enabled: false,
            value: 10
          }
        },
        {
          type: "SUCCESS_ERROR_BANNER",
          isVisible: true,
          successBanner: {
            enabled: true,
            type: "SUCCESS",
            text: "Added to cart.",
            dismissible: true,
            translatableField: ["text"],
            undoButton: {
              enabled: true,
              text: "Undo",
              translatableField: ["text"]
            }
          },
          errorBanner: {
            enabled: true,
            type: "CRITICAL",
            dismissible: true,
            staticText: {
              enabled: true,
              value: "Unable to add product/s to cart.",
              translatableField: ["value"]
            }
          }
        }
      ]
    },
    {
      type: "TOTAL_PRICE",
      isVisible: true,
      priceToDisplay: "HIGHEST_LOWEST_PRICE",
      dontDisplayCompareTotalPrice: false,
      isDisplayCompareToPrice: true,
      text: "{{total price}} {{pricing}}",
      displayComparisionFontColor: "",
      displayOriginalFontColor: "",
      displayAfterDiscountFontColor: "",
      translatableField: ["text"]
    },
    {
      type: "BUTTON",
      isVisible: true,
      buttonType: "SECONDARY",
      buttonText: "Add {{item count}} Items",
      translatableField: ["buttonText"]
    },
    {
      type: "SUCCESS_ERROR_BANNER",
      isVisible: true,
      successBanner: {
        enabled: true,
        type: "SUCCESS",
        text: "Added to cart.",
        dismissible: true,
        translatableField: ["text"]
      },
      errorBanner: {
        enabled: true,
        type: "CRITICAL",
        dismissible: true,
        staticText: {
          enabled: true,
          value: "Unable to add product/s to cart.",
          translatableField: ["value"]
        }
      }
    },
    {
      type: "TIMER",
      category: "INFORMATIONAL",
      isVisible: true,
      name: "Timer (1)",
      blocks: [
        {
          type: "CLOCK",
          isVisible: true,
          background: "SUBDUED",
          digitColor: "WARNING",
          showTitle: false,
          title: "",
          clockFrame: "NO_FRAME",
          frameBorder: "BASE",
          frameBorderRadius: "BASE",
          showTimeSeparator: true,
          showTimeUnitLabels: true,
          timeUnitLabels: {
            days: "",
            hours: "",
            minutes: "",
            seconds: ""
          },
          showUnitLabels: false,
          unitLabelsPosition: "",
          timerExpiredSetting: {
            whenTimeRunsOut: "REPLACE_CLOCK_WITH_TEXT",
            timerExpiredText: "",
            preview: false
          }
        },
        {
          type: "TIMER_TEXT",
          isVisible: true,
          description: "",
          frameBorderRadius: "BASE",
          frameBorder: "BASE",
          textInframe: false,
          textBackground: "BASE",
          timerExpiredSetting: {
            replaceWhenTimerRunOut: true,
            timerExpiredText: "",
            preview: false
          }
        },
        {
          type: "PROGRESS_BAR",
          isVisible: true,
          showProgressBar: true,
          progressBarColor: "CRITICAL"
        }
      ],
      upsellInfo: {
        settings: {
          displayTimer: "ONCE_PER_SESSION",
          timerEffect: "THIS_WIDGETS",
          timerRunsOut: "DO_NOTHING",
          selectedWidgets: []
        },
        duration: {
          count: "TIME_PASSED",
          startCounting: "ON_FIRST_IMPRESSION",
          dateAndTime: "",
          duration: {
            days: 0,
            hours: 0,
            minutes: 5,
            seconds: 0
          }
        },
        designConfig: {
          timerStyle: "BANNER",
          backgroundColor: "BASE",
          desktopLayout: "HORIZONTAL",
          bannerType: "INFO",
          timerBorder: "NONE",
          timerBorderRadius: "BASE"
        },
        expiredMessageConfig: {
          changeBannerTypeOnTimerRunOut: false,
          BannerTypeOnTimerRunOut: "CRITICAL",
          hideWidgetOnTimerRunOut: false,
          isDisplayMessage: true,
          backgroundColor: "RED",
          preview: false
        }
      }
    },
    {
      type: "MULTI_PRODUCT_UPSELL",
      category: "CONTAINER",
      isVisible: true,
      text: "You may also like this product",
      name: "Product upsell (1)",
      postAcceptOption: "HIDE_PRODUCT",
      ifNoProductsToShowBlocksShould: "HIDE",
      translatableField: ["text"],
      widgets: [
        {
          type: "DIVIDER"
        },
        {
          type: "TEXT",
          translatableField: ["text"]
        },
        {
          type: "UPSELL",
          layout: "SMALL_LAYOUT_TWO"
        }
      ]
    },
    {
      type: "RECOMMENDATIONS",
      category: "CONTAINER",
      isVisible: true,
      text: "You may also like this product",
      name: "Product recommendations (1)",
      postAcceptOption: "HIDE_PRODUCT",
      ifNoProductsToShowBlocksShould: "HIDE",
      translatableField: ["text"],
      widgets: [
        {
          type: "TEXT",
          text: '<p style="text-align: left;"><span style="font-size: 19px;">You may also like these products</span></p>',
          translatableField: ["text"]
        },
        {
          type: "UPSELL",
          noOfProducts: 8,
          layout: "SLIDER",
          removeBlocks: [
            "SUBSCRIPTION"
          ],
          removeBlockKeys: [
            {
              type: "BUTTON",
              keys: ["subscriptionButtonText", "subscriptionButtonTextForOneTimePurchase"]
            }
          ],
          blocksDefaultValue: [
            {
              type: "DESCRIPTION",
              displayProductDescription: false
            }
          ]
        }
      ]
    },
    {
      type: "BUNDLE",
      category: "CONTAINER",
      isVisible: true,
      text: "You may also like this product",
      translatableField: ["text"],
      name: "Bundle(1)",
      noOfProducts: 3,
      productsPerRow: 3,
      sliderConfig: {
        hint: "PILL",
        hintText: "Scroll",
        translatableField: ["hintText"]
      },
      layout: "GRID",
      allowSeparateQuantitySelection: true,
      postAcceptOption: "HIDE_BUNDLE",
      ifNoProductsToShowBlocksShould: "HIDE",
      widgets: [
        {
          type: "TEXT",
          text: '<p><span style="font-size: 16px;"><strong>Frequently bought together</strong></span></p>',
          displayOrder: 0,
          translatableField: ["text"]
        },
        {
          type: "UPSELL",
          displayOrder: 1,
          layout: "LIST",
          subLayout: "SMALL_LAYOUT_ONE",
          removeBlocks: [
            "BUTTON",
            "SUCCESS_ERROR_BANNER",
            "SUBSCRIPTION"
          ],
          removeBlockKeys: [
            {
              type: "BUTTON",
              keys: ["subscriptionButtonText", "subscriptionButtonTextForOneTimePurchase"]
            }
          ],
          blocksDefaultValue: [
            {
              type: "PRICE_AND_DISCOUNT",
              priceToDisplay: "ONLY_HIGHEST_PRICE"
            },
            {
              type: "BUTTON",
              buttonText: "Add {{item count}} Items",
              translatableField: ["buttonText"]
            }
          ]
        },
        {
          type: "UPSELL",
          displayOrder: 2,
          layout: "LIST",
          subLayout: "SMALL_LAYOUT_ONE",
          removeBlocks: [
            "BUTTON",
            "SUCCESS_ERROR_BANNER",
            "SUBSCRIPTION"
          ],
          removeBlockKeys: [
            {
              type: "BUTTON",
              keys: ["subscriptionButtonText", "subscriptionButtonTextForOneTimePurchase"]
            }
          ],
          blocksDefaultValue: [
            {
              type: "PRICE_AND_DISCOUNT",
              priceToDisplay: "ONLY_HIGHEST_PRICE"
            },
            {
              type: "BUTTON",
              buttonText: "Add {{item count}} Items",
              translatableField: ["buttonText"]
            }
          ]
        },
        {
          type: "UPSELL",
          displayOrder: 3,
          layout: "LIST",
          subLayout: "SMALL_LAYOUT_ONE",
          removeBlocks: [
            "BUTTON",
            "SUCCESS_ERROR_BANNER",
            "SUBSCRIPTION"
          ],
          removeBlockKeys: [
            {
              type: "BUTTON",
              keys: ["subscriptionButtonText", "subscriptionButtonTextForOneTimePurchase"]
            }
          ],
          blocksDefaultValue: [
            {
              type: "PRICE_AND_DISCOUNT",
              priceToDisplay: "ONLY_HIGHEST_PRICE"
            },
            {
              type: "BUTTON",
              buttonText: "Add {{item count}} Items",
              translatableField: ["buttonText"]
            }
          ]
        }
      ],
      blocks: [
        {
          type: "TOTAL_PRICE",
          displayOrder: 4
        },
        {
          type: "BUTTON",
          displayOrder: 5,
          buttonText: "Add {{item count}} Items",
          translatableField: ["buttonText"]
        },
        {
          type: "SUCCESS_ERROR_BANNER",
          displayOrder: 6
        }
      ]
    },
    {
      type: "IMAGE_WIDGET",
      category: "INFORMATIONAL",
      isVisible: true,
      name: "Image (1)",
      image: {
        src: null,
        altText: "",
        translatableField: ["altText"]
      },
      link: {
        addLink: false,
        destinationURL: "",
        openInNewTabDesktop: true,
        openInNewTabMobile: true
      },
      layout: {
        height: "AUTO",
        fit: "COVER",
        aspectRatio: "AUTO",
        alignment: "CENTER",
        cornerRadius: "BASE",
        borderStyle: "BASE",
        padding: "BASE"
      }
    }
  ]
};

// src/defaultWidgetsValue/pre_purchase_cart_drawer_default_values.json
var pre_purchase_cart_drawer_default_values_default = {
  defaultValues: [
    {
      type: "DIVIDER",
      category: "INFORMATIONAL",
      isVisible: true,
      location: "BODY",
      subLocation: "POST_PRODUCT",
      name: "Divider (1)",
      dividerText: {
        enabled: false,
        value: "Title",
        translatableField: ["value"]
      }
    },
    {
      type: "TEXT",
      category: "INFORMATIONAL",
      isVisible: true,
      location: "BODY",
      subLocation: "POST_PRODUCT",
      text: "<p>You may also like this product</p>",
      name: "Text (1)",
      translatableField: ["text"]
    },
    {
      type: "UPSELL",
      category: "CONVERTING",
      parentType: "MULTI_PRODUCT_UPSELL",
      isVisible: true,
      location: "BODY",
      subLocation: "POST_PRODUCT",
      text: "You may also like this product",
      name: "Product (1)",
      upsellInfo: {
        type: "SHOPIFY_RECOMMENDATIONS",
        noOfProducts: 1,
        productsPerRow: 2,
        location: "ORDER",
        layout: "SMALL_LAYOUT_ONE",
        subLayout: "SMALL_LAYOUT_ONE",
        sliderConfig: {
          hint: "PILL",
          hintText: "Scroll",
          translatableField: ["hintText"]
        },
        settings: {
          SPECIFIC_PRODUCT: [
            {
              productInfo: {},
              optionsIfAlreadyInLocation: {
                value: "display_featured_product_anyway",
                alternateProduct: {}
              },
              defaultSelected: true,
              mandatory: false
            }
          ],
          SHOPIFY_RECOMMENDATIONS: {
            hideIfAlreadyInLocation: false,
            excludeTagsOptions: {
              enabled: false,
              tags: []
            },
            recommendationIntent: "related"
          },
          MOST_EXPENSIVE: {
            excludeTagsOptions: {
              enabled: false,
              tags: [],
              alternateOption: "use_shopify_recommendation",
              alternateProduct: {}
            }
          },
          LEAST_EXPENSIVE: {
            excludeTagsOptions: {
              enabled: false,
              tags: [],
              alternateOption: "use_shopify_recommendation",
              alternateProduct: {}
            }
          },
          WISER_RECOMMENDATIONS: {
            excludeTagsOptions: {
              enabled: false,
              tags: []
            },
            hideIfAlreadyInLocation: false
          },
          PERSONALIZED_RECOMMENDATIONS: {
            excludeTagsOptions: {
              enabled: false,
              tags: []
            },
            hideIfAlreadyInLocation: false
          },
          RECOMATIC_RECOMMENDATIONS: {
            excludeTagsOptions: {
              enabled: false,
              tags: []
            }
          },
          SPECIFIC_COLLECTION: []
        }
      },
      blocks: [
        {
          type: "SUBSCRIPTION",
          isVisible: true,
          isSubscriptionEnabled: false,
          subscriptionOptionDisplay: "SHOW_ALL_SUBSCRIPTION_OPTIONS",
          displaySellingOptions: true,
          sellingPlanToApply: "",
          productOption: "SUBSCRIPTION",
          purchaseOptionsTitle: "Purchase options",
          offerSubscriptionOptionOnly: false,
          showSubscriptionBadge: false,
          subscriptionBadgeText: "Subscription",
          showSavingsDetailsBadge: false,
          savingsDetailsBadgeText: "Save up to {{subscription discount}}",
          replaceExistingOneTimeProduct: true,
          translatableField: ["purchaseOptionsTitle", "subscriptionBadgeText", "savingsDetailsBadgeText"]
        },
        {
          type: "IMAGE",
          isVisible: true,
          imageFit: "CONTAIN",
          imageToDisplay: "MAIN_PRODUCT",
          imageURL: "",
          showImageAccordingToVariant: true,
          linkToProduct: true,
          imageBorderRadius: "BASE",
          imageBorderStyle: "BASE"
        },
        {
          type: "PRODUCT_TITLE",
          isVisible: true,
          customTitle: {
            enabled: false,
            value: "Product title",
            translatableField: ["value"]
          }
        },
        {
          type: "STAR_RATING",
          isVisible: true,
          blockSettings: {
            starColor: "#F4C430",
            layout: "MINIMALISTIC",
            showAmountOfReviews: true,
            showRatingValue: true,
            reviewsLabel: "reviews",
            integrationError: false,
            translatableField: ["reviewsLabel"]
          }
        },
        {
          type: "PRODUCT_DETAILS",
          isVisible: true,
          subtitle: {
            selection: "VARIANT_NAME",
            textStyle: "UPPER_CASE",
            customText: "Text",
            translatableField: ["customText"]
          }
        },
        {
          type: "DESCRIPTION",
          isVisible: true,
          displayProductDescription: true,
          customText: {
            enabled: false,
            value: "text text text text",
            translatableField: ["value"]
          },
          collapsible: {
            enabled: true,
            defaultState: "COLLAPSED",
            buttonText: "Description",
            translatableField: ["buttonText"]
          }
        },
        {
          type: "PRICE_AND_DISCOUNT",
          isVisible: true,
          price: {
            samePriceForAll: true,
            priceToDisplay: "DISPLAY_HIGHEST_LOWEST_PRICE",
            displayComparision: {
              dontDisplayComparePrice: false,
              enabled: true,
              size: "DEFAULT",
              color: ""
            },
            displayOriginal: {
              enabled: true,
              size: "DEFAULT",
              color: ""
            },
            displayAfterDiscount: {
              enabled: true,
              size: "DEFAULT",
              color: ""
            }
          },
          discount: {
            enabled: true,
            totalPriceText: "Total Price",
            translatableField: ["totalPriceText"],
            onlyForOrdersOverValue: {
              enabled: false,
              minimumOrderValue: 0
            },
            type: "PERCENTAGE",
            name: "",
            breakPoint: [
              {
                minimumItemGetDiscount: 1,
                value: 0
              }
            ],
            discountValue: 0,
            minItemsDiscount: 1,
            maxItemsDiscount: 100,
            onlyForProductsOverValue: {
              enabled: false,
              minimumProductPrice: 100
            }
          },
          shippingDetails: {
            type: "FREE",
            rate: 0,
            title: "Shipping",
            freeShippingName: "Free",
            fallbackRate: 0,
            translatableField: ["title", "freeShippingName"]
          }
        },
        {
          type: "BUTTON",
          isVisible: true,
          buttonType: "PRIMARY",
          buttonText: "{{buy now}}",
          subscriptionButtonTextForOneTimePurchase: "{{add to cart}}",
          subscriptionButtonText: "Add subscription",
          translatableField: ["buttonText", "subscriptionButtonTextForOneTimePurchase", "subscriptionButtonText"]
        },
        {
          type: "VARIANT_PICKER",
          isVisible: true,
          displayVariantPicker: true,
          label: "Variant",
          preselectedVariant: "DEFAULT_PRODUCT_VARIANT",
          selectedSpecificVariantId: "",
          combineAllOptionsIntoOneDropdown: true,
          showPriceInDropdown: true,
          translatableField: ["label", "errorMessage"]
        },
        {
          type: "QUANTITY_SELECTOR",
          isVisible: true,
          displayQuantitySelector: true,
          label: "Quantity",
          defaultQuantity: 1,
          minQuantity: {
            enabled: false,
            value: 1
          },
          maxQuantity: {
            enabled: false,
            value: 10
          },
          translatableField: ["label"]
        },
        {
          type: "SUCCESS_ERROR_BANNER",
          isVisible: true,
          successBanner: {
            enabled: true,
            type: "SUCCESS",
            text: "Added to cart.",
            dismissible: true,
            translatableField: ["text"]
          },
          errorBanner: {
            enabled: true,
            type: "CRITICAL",
            dismissible: true,
            staticText: {
              enabled: true,
              value: "Unable to add product/s to cart.",
              translatableField: ["value"]
            }
          }
        }
      ]
    },
    {
      type: "TOTAL_PRICE",
      priceToDisplay: "HIGHEST_LOWEST_PRICE",
      dontDisplayCompareTotalPrice: false,
      isDisplayCompareToPrice: true,
      text: "{{total price}} {{pricing}}",
      displayComparisionFontColor: "",
      displayOriginalFontColor: "",
      displayAfterDiscountFontColor: "",
      translatableField: ["text"]
    },
    {
      type: "BUTTON",
      isVisible: true,
      buttonType: "PRIMARY",
      buttonText: "Add {{item count}} Items",
      translatableField: ["buttonText"]
    },
    {
      type: "SUCCESS_ERROR_BANNER",
      isVisible: true,
      successBanner: {
        enabled: true,
        type: "SUCCESS",
        text: "The item successfully added to the cart.",
        dismissible: true,
        translatableField: ["text"]
      },
      errorBanner: {
        enabled: true,
        type: "CRITICAL",
        dismissible: true,
        staticText: {
          enabled: true,
          value: "Unable to add product/s to cart.",
          translatableField: ["value"]
        }
      }
    },
    {
      type: "BANNER",
      category: "INFORMATIONAL",
      isVisible: true,
      location: "BODY",
      subLocation: "POST_PRODUCT",
      status: "INFO",
      dismissible: true,
      name: "Banner (1)",
      content: {
        title: "Title",
        description: "",
        collapsible: true,
        translatableField: ["title", "description"]
      },
      button: {
        display: false,
        type: "PRIMARY",
        color: "DEFAULT",
        text: "Button text",
        link: "",
        translatableField: ["text"]
      }
    },
    {
      type: "MULTI_PRODUCT_UPSELL",
      category: "CONTAINER",
      isVisible: true,
      location: "BODY",
      subLocation: "POST_PRODUCT",
      text: "You may also like this product",
      name: "Product upsell (1)",
      postAcceptOption: "HIDE_PRODUCT",
      ifNoProductsToShowBlocksShould: "HIDE",
      translatableField: ["text"],
      widgets: [
        {
          type: "DIVIDER"
        },
        {
          type: "TEXT",
          translatableField: ["text"]
        },
        {
          type: "UPSELL",
          layout: "SMALL_LAYOUT_TWO"
        }
      ]
    },
    {
      type: "RECOMMENDATIONS",
      category: "CONTAINER",
      isVisible: true,
      location: "BODY",
      subLocation: "POST_PRODUCT",
      text: "You may also like this product",
      name: "Product recommendations (1)",
      postAcceptOption: "HIDE_PRODUCT",
      ifNoProductsToShowBlocksShould: "HIDE",
      translatableField: ["text"],
      widgets: [
        {
          type: "TEXT",
          text: '<p style="text-align: left;"><span style="font-size: 19px;">You may also like these products</span></p>',
          translatableField: ["text"]
        },
        {
          type: "UPSELL",
          noOfProducts: 8,
          layout: "SLIDER",
          removeBlocks: [
            "SUBSCRIPTION"
          ],
          removeBlockKeys: [
            {
              type: "BUTTON",
              keys: ["subscriptionButtonText", "subscriptionButtonTextForOneTimePurchase"]
            }
          ],
          blocksDefaultValue: [
            {
              type: "DESCRIPTION",
              displayProductDescription: false
            }
          ]
        }
      ]
    },
    {
      type: "BUNDLE",
      category: "CONTAINER",
      isVisible: true,
      location: "BODY",
      subLocation: "POST_PRODUCT",
      text: "You may also like this product",
      translatableField: ["text"],
      name: "Bundle(1)",
      noOfProducts: 3,
      productsPerRow: 2,
      sliderConfig: {
        hint: "PILL",
        hintText: "Scroll",
        translatableField: ["hintText"]
      },
      layout: "GRID",
      allowSeparateQuantitySelection: true,
      postAcceptOption: "HIDE_BUNDLE",
      ifNoProductsToShowBlocksShould: "HIDE",
      shippingDetails: {
        type: "FREE",
        rate: 0,
        title: "Shipping",
        freeShippingName: "Free",
        translatableField: ["title", "freeShippingName"]
      },
      widgets: [
        {
          type: "TEXT",
          text: '<p><span style="font-size: 16px;"><strong>Frequently bought together</strong></span></p>',
          displayOrder: 0,
          translatableField: ["text"]
        },
        {
          type: "UPSELL",
          displayOrder: 1,
          layout: "LIST",
          subLayout: "SMALL_LAYOUT_ONE",
          removeBlocks: [
            "BUTTON",
            "SUCCESS_ERROR_BANNER",
            "SUBSCRIPTION"
          ],
          removeBlockKeys: [
            {
              type: "BUTTON",
              keys: ["subscriptionButtonText", "subscriptionButtonTextForOneTimePurchase"]
            }
          ],
          blocksDefaultValue: [
            {
              type: "PRICE_AND_DISCOUNT",
              priceToDisplay: "ONLY_HIGHEST_PRICE"
            },
            {
              type: "BUTTON",
              buttonText: "Add {{item count}} Items",
              translatableField: ["buttonText"]
            }
          ]
        },
        {
          type: "UPSELL",
          displayOrder: 2,
          layout: "LIST",
          subLayout: "SMALL_LAYOUT_ONE",
          removeBlocks: [
            "BUTTON",
            "SUCCESS_ERROR_BANNER",
            "SUBSCRIPTION"
          ],
          blocksDefaultValue: [
            {
              type: "PRICE_AND_DISCOUNT",
              priceToDisplay: "ONLY_HIGHEST_PRICE"
            },
            {
              type: "BUTTON",
              buttonText: "Add {{item count}} Items",
              translatableField: ["buttonText"]
            }
          ]
        },
        {
          type: "UPSELL",
          displayOrder: 3,
          layout: "LIST",
          subLayout: "SMALL_LAYOUT_ONE",
          removeBlocks: [
            "BUTTON",
            "SUCCESS_ERROR_BANNER",
            "SUBSCRIPTION"
          ],
          blocksDefaultValue: [
            {
              type: "PRICE_AND_DISCOUNT",
              priceToDisplay: "ONLY_HIGHEST_PRICE"
            },
            {
              type: "BUTTON",
              buttonText: "Add {{item count}} Items",
              translatableField: ["buttonText"]
            }
          ]
        }
      ],
      blocks: [
        {
          type: "TOTAL_PRICE",
          displayOrder: 4
        },
        {
          type: "BUTTON",
          displayOrder: 5,
          buttonText: "Buy now {{item count}} Items",
          translatableField: ["buttonText"]
        },
        {
          type: "SUCCESS_ERROR_BANNER",
          displayOrder: 6
        }
      ]
    },
    {
      type: "IMAGE_WIDGET",
      category: "INFORMATIONAL",
      isVisible: true,
      location: "BODY",
      subLocation: "POST_PRODUCT",
      name: "Image (1)",
      image: {
        src: null,
        altText: "",
        translatableField: ["altText"]
      },
      link: {
        addLink: false,
        destinationURL: "",
        openInNewTabDesktop: true,
        openInNewTabMobile: true
      },
      layout: {
        height: "AUTO",
        fit: "COVER",
        aspectRatio: "AUTO",
        alignment: "CENTER",
        cornerRadius: "BASE",
        borderStyle: "BASE",
        padding: "BASE"
      }
    }
  ]
};

// src/defaultWidgetsValue/thank_you_page_default_values.json
var thank_you_page_default_values_default = {
  defaultValues: [
    {
      type: "DIVIDER",
      category: "INFORMATIONAL",
      isVisible: true,
      name: "Divider (1)",
      dividerText: {
        enabled: false,
        value: "Title",
        translatableField: ["value"]
      }
    },
    {
      type: "TEXT",
      category: "INFORMATIONAL",
      isVisible: true,
      text: "<p>You may also like this product</p>",
      name: "Text (1)",
      translatableField: ["text"]
    },
    {
      type: "UPSELL",
      category: "CONVERTING",
      parentType: "MULTI_PRODUCT_UPSELL",
      isVisible: true,
      text: "You may also like this product",
      name: "Product (1)",
      translatableField: ["text"],
      upsellInfo: {
        type: "SHOPIFY_RECOMMENDATIONS",
        noOfProducts: 1,
        productsPerRow: 3,
        location: "ORDER",
        layout: "SMALL_LAYOUT_ONE",
        subLayout: "SMALL_LAYOUT_ONE",
        sliderConfig: {
          hint: "PILL",
          hintText: "Scroll",
          translatableField: ["hintText"]
        },
        settings: {
          SPECIFIC_PRODUCT: [
            {
              productInfo: {},
              optionsIfAlreadyInLocation: {
                value: "display_featured_product_anyway",
                alternateProduct: {}
              },
              defaultSelected: true,
              mandatory: false
            }
          ],
          SHOPIFY_RECOMMENDATIONS: {
            hideIfAlreadyInLocation: false,
            excludeTagsOptions: {
              enabled: false,
              tags: []
            },
            recommendationIntent: "related"
          },
          MOST_EXPENSIVE: {
            excludeTagsOptions: {
              enabled: false,
              tags: [],
              alternateOption: "use_shopify_recommendation",
              alternateProduct: {}
            }
          },
          LEAST_EXPENSIVE: {
            excludeTagsOptions: {
              enabled: false,
              tags: [],
              alternateOption: "use_shopify_recommendation",
              alternateProduct: {}
            }
          },
          PERSONALIZED_RECOMMENDATIONS: {
            excludeTagsOptions: {
              enabled: false,
              tags: []
            },
            hideIfAlreadyInLocation: false
          },
          RECOMATIC_RECOMMENDATIONS: {
            excludeTagsOptions: {
              enabled: false,
              tags: []
            }
          },
          SPECIFIC_COLLECTION: []
        }
      },
      blocks: [
        {
          type: "IMAGE",
          isVisible: true,
          imageFit: "CONTAIN",
          imageToDisplay: "MAIN_PRODUCT",
          imageURL: "",
          showImageAccordingToVariant: true,
          linkToProduct: false,
          imageBorderRadius: "BASE",
          imageBorderStyle: "BASE"
        },
        {
          type: "PRODUCT_TITLE",
          isVisible: true,
          customTitle: {
            enabled: false,
            value: "Product title",
            translatableField: ["value"]
          }
        },
        {
          type: "STAR_RATING",
          isVisible: true,
          blockSettings: {
            starColor: "#F4C430",
            layout: "MINIMALISTIC",
            showAmountOfReviews: true,
            showRatingValue: true,
            reviewsLabel: "reviews",
            integrationError: false,
            translatableField: ["reviewsLabel"]
          }
        },
        {
          type: "PRODUCT_DETAILS",
          isVisible: true,
          subtitle: {
            selection: "VARIANT_NAME",
            textStyle: "UPPER_CASE",
            customText: "Text",
            translatableField: ["customText"]
          }
        },
        {
          type: "DESCRIPTION",
          isVisible: true,
          displayProductDescription: true,
          customText: {
            enabled: false,
            value: "text text text text",
            translatableField: ["value"]
          },
          collapsible: {
            enabled: true,
            defaultState: "COLLAPSED",
            buttonText: "Description",
            translatableField: ["buttonText"]
          }
        },
        {
          type: "PRICE_AND_DISCOUNT",
          isVisible: true,
          price: {
            samePriceForAll: true,
            priceToDisplay: "DISPLAY_HIGHEST_LOWEST_PRICE",
            displayComparision: {
              dontDisplayComparePrice: false,
              enabled: true,
              size: "DEFAULT",
              color: "CRITICAL"
            },
            displayOriginal: {
              enabled: true,
              size: "DEFAULT",
              color: "CRITICAL"
            },
            displayAfterDiscount: {
              enabled: true,
              size: "DEFAULT",
              color: "INFO"
            }
          },
          discount: {
            enabled: true,
            totalPriceText: "Total Price",
            translatableField: ["totalPriceText"],
            onlyForOrdersOverValue: {
              enabled: false,
              minimumOrderValue: 0
            },
            type: "PERCENTAGE",
            name: "",
            breakPoint: [
              {
                minimumItemGetDiscount: 1,
                value: 0
              }
            ],
            discountValue: 0,
            minItemsDiscount: 1,
            maxItemsDiscount: 100,
            onlyForProductsOverValue: {
              enabled: false,
              minimumProductPrice: 100
            }
          },
          shippingDetails: {
            type: "FREE",
            rate: 0,
            title: "Shipping",
            freeShippingName: "Free",
            fallbackRate: 0,
            translatableField: ["title", "freeShippingName"]
          }
        },
        {
          type: "BUTTON",
          isVisible: true,
          buttonType: "PRIMARY",
          buttonText: "{{buy now}}",
          translatableField: ["buttonText"]
        },
        {
          type: "VARIANT_PICKER",
          isVisible: true,
          displayVariantPicker: true,
          label: "Variant",
          preselectedVariant: "DEFAULT_PRODUCT_VARIANT",
          selectedSpecificVariantId: "",
          combineAllOptionsIntoOneDropdown: true,
          showPriceInDropdown: true,
          translatableField: ["label", "errorMessage"]
        },
        {
          type: "QUANTITY_SELECTOR",
          isVisible: true,
          displayQuantitySelector: true,
          label: "Quantity",
          translatableField: ["label"],
          defaultQuantity: 1,
          minQuantity: {
            enabled: false,
            value: 1
          },
          maxQuantity: {
            enabled: false,
            value: 10
          }
        },
        {
          type: "SUCCESS_ERROR_BANNER",
          isVisible: true,
          successBanner: {
            enabled: true,
            type: "SUCCESS",
            text: "Added to cart.",
            dismissible: true,
            translatableField: ["text"]
          },
          errorBanner: {
            enabled: true,
            type: "CRITICAL",
            dismissible: true,
            staticText: {
              enabled: true,
              value: "Unable to add product/s to cart.",
              translatableField: ["value"]
            }
          }
        }
      ]
    },
    {
      type: "TOTAL_PRICE",
      isVisible: true,
      priceToDisplay: "HIGHEST_LOWEST_PRICE",
      dontDisplayCompareTotalPrice: false,
      isDisplayCompareToPrice: true,
      text: "{{total price}}",
      displayComparisionFontColor: "CRITICAL",
      displayOriginalFontColor: "CRITICAL",
      displayAfterDiscountFontColor: "INFO",
      translatableField: ["text"]
    },
    {
      type: "BUTTON",
      isVisible: true,
      buttonType: "PRIMARY",
      buttonText: "Add {{item count}} Items",
      translatableField: ["buttonText"]
    },
    {
      type: "SUCCESS_ERROR_BANNER",
      isVisible: true,
      successBanner: {
        enabled: true,
        type: "SUCCESS",
        text: "The item successfully added to the cart.",
        dismissible: true,
        translatableField: ["text"]
      },
      errorBanner: {
        enabled: true,
        type: "CRITICAL",
        dismissible: true,
        staticText: {
          enabled: true,
          value: "Unable to add product/s to cart.",
          translatableField: ["value"]
        }
      }
    },
    {
      type: "TIMER",
      category: "INFORMATIONAL",
      isVisible: true,
      name: "Timer (1)",
      blocks: [
        {
          type: "TIMER_TEXT",
          description: '<h2 style="text-align: center; font-size: 16px; font-weight: 600; margin-bottom: 0px;">Offer expires in:</h2>',
          frameBorderRadius: "BASE",
          frameBorder: "BASE",
          textInframe: false,
          textBackground: "SUBDUED",
          translatableField: ["description"],
          timerExpiredSetting: {
            replaceWhenTimerRunOut: true,
            timerExpiredText: '<h2 style="text-align: center; font-size: 16px; font-weight: 600; margin-bottom: 0px;">Offer expired</h2>',
            preview: false,
            translatableField: ["timerExpiredText"]
          }
        },
        {
          type: "CLOCK",
          background: "BASE",
          digitColor: "CRITICAL",
          showTitle: false,
          title: "",
          clockFrame: "INDIVIDUAL_FRAMES",
          frameBorder: "BASE",
          frameBorderRadius: "BASE",
          showTimeSeparator: true,
          showTimeUnitLabels: false,
          translatableField: ["title"],
          timeUnitLabels: {
            days: "",
            hours: "",
            minutes: "",
            seconds: "Seconds",
            translatableField: ["days", "hours", "minutes", "seconds"]
          },
          showUnitLabelsInFrame: false,
          unitLabelsPosition: "BELOW_DIGITS",
          timerExpiredSetting: {
            whenTimeRunsOut: "REPLACE_CLOCK_WITH_TEXT",
            timerExpiredText: "",
            preview: false,
            translatableField: ["timerExpiredText"]
          }
        },
        {
          type: "PROGRESS_BAR",
          showProgressBar: true,
          progressBarColor: "AUTO",
          timerExpiredSetting: {
            timerRunsOut: "CHANGE_PROGRESS_BAR_COLOR",
            progressBarColor: "CRITICAL",
            preview: false
          }
        }
      ],
      upsellInfo: {
        settings: {
          displayTimer: "ONCE_PER_ORDER",
          timerEffect: "ALL_WIDGETS_ON_THIS_PAGE",
          timerRunsOut: "DO_NOTHING",
          selectedWidgets: []
        },
        duration: {
          count: "TIME_PASSED",
          startCounting: "ON_FIRST_IMPRESSION",
          dateAndTime: "",
          duration: {
            days: 0,
            hours: 0,
            minutes: 7,
            seconds: 0
          }
        },
        designConfig: {
          timerStyle: "PROMOTIONAL",
          backgroundColor: "SUBDUED",
          desktopLayout: "HORIZONTAL",
          bannerType: "INFO",
          timerBorder: "BASE",
          timerBorderRadius: "LARGE"
        },
        expiredMessageConfig: {
          changeBannerTypeOnTimerRunOut: false,
          bannerTypeOnTimerRunOut: "CRITICAL",
          isDisplayMessage: true,
          backgroundColor: "RED",
          preview: false
        }
      }
    },
    {
      type: "BANNER",
      category: "INFORMATIONAL",
      isVisible: true,
      status: "INFO",
      dismissible: true,
      name: "Banner (1)",
      content: {
        title: "Title",
        description: "",
        collapsible: true,
        translatableField: ["title", "description"]
      },
      button: {
        display: false,
        type: "PRIMARY",
        color: "DEFAULT",
        text: "Button text",
        link: "",
        translatableField: ["text"]
      }
    },
    {
      type: "MULTI_PRODUCT_UPSELL",
      category: "CONTAINER",
      isVisible: true,
      text: "You may also like this product",
      name: "Product upsell (1)",
      postAcceptOption: "HIDE_PRODUCT",
      ifNoProductsToShowBlocksShould: "HIDE",
      translatableField: ["text"],
      widgets: [
        {
          type: "DIVIDER"
        },
        {
          type: "TEXT"
        },
        {
          type: "UPSELL",
          layout: "SMALL_LAYOUT_TWO"
        }
      ]
    },
    {
      type: "RECOMMENDATIONS",
      category: "CONTAINER",
      isVisible: true,
      text: "You may also like this product",
      name: "Product recommendations (1)",
      postAcceptOption: "HIDE_PRODUCT",
      ifNoProductsToShowBlocksShould: "HIDE",
      translatableField: ["text"],
      widgets: [
        {
          type: "TEXT",
          text: '<h2 style="text-align: left; font-size: 16px; font-weight: 600; margin-bottom: 0px;">You may also like these products</h2>',
          translatableField: ["text"]
        },
        {
          type: "UPSELL",
          noOfProducts: 8,
          layout: "SLIDER",
          optionalBlocks: [
            "PRODUCT_DETAILS",
            "SUCCESS_ERROR_BANNER"
          ],
          blocksDefaultValue: [
            {
              type: "DESCRIPTION",
              displayProductDescription: false
            }
          ]
        }
      ]
    },
    {
      type: "BUNDLE",
      category: "CONTAINER",
      isVisible: true,
      text: "You may also like this product",
      translatableField: ["text"],
      name: "Bundle(1)",
      noOfProducts: 3,
      productsPerRow: 3,
      sliderConfig: {
        hint: "PILL",
        hintText: "Scroll",
        translatableField: ["hintText"]
      },
      layout: "GRID",
      allowSeparateQuantitySelection: true,
      postAcceptOption: "HIDE_BUNDLE",
      ifNoProductsToShowBlocksShould: "HIDE",
      shippingDetails: {
        type: "FREE",
        rate: 0,
        title: "Shipping",
        freeShippingName: "Free",
        translatableField: ["title", "freeShippingName"]
      },
      widgets: [
        {
          type: "TEXT",
          text: '<p><span style="font-size: 14px;"><strong>Frequently bought together</strong></span></p>',
          displayOrder: 0,
          translatableField: ["text"]
        },
        {
          type: "UPSELL",
          displayOrder: 1,
          layout: "LIST",
          subLayout: "SMALL_LAYOUT_ONE",
          removeBlocks: [
            "BUTTON",
            "SUCCESS_ERROR_BANNER"
          ],
          blocksDefaultValue: [
            {
              type: "PRICE_AND_DISCOUNT",
              priceToDisplay: "ONLY_HIGHEST_PRICE",
              displayComparision: {
                color: "INFO"
              }
            },
            {
              type: "BUTTON",
              buttonText: "Buy now {{item count}} Items",
              translatableField: ["buttonText"]
            }
          ]
        },
        {
          type: "UPSELL",
          displayOrder: 2,
          layout: "LIST",
          subLayout: "SMALL_LAYOUT_ONE",
          removeBlocks: [
            "BUTTON",
            "SUCCESS_ERROR_BANNER"
          ],
          blocksDefaultValue: [
            {
              type: "PRICE_AND_DISCOUNT",
              priceToDisplay: "ONLY_HIGHEST_PRICE",
              displayComparision: {
                color: "INFO"
              }
            },
            {
              type: "BUTTON",
              buttonText: "Buy now {{item count}} Items",
              translatableField: ["buttonText"]
            }
          ]
        },
        {
          type: "UPSELL",
          displayOrder: 3,
          layout: "LIST",
          subLayout: "SMALL_LAYOUT_ONE",
          removeBlocks: [
            "BUTTON",
            "SUCCESS_ERROR_BANNER"
          ],
          blocksDefaultValue: [
            {
              type: "PRICE_AND_DISCOUNT",
              priceToDisplay: "ONLY_HIGHEST_PRICE",
              displayComparision: {
                color: "INFO"
              }
            },
            {
              type: "BUTTON",
              buttonText: "Buy now {{item count}} Items",
              translatableField: ["buttonText"]
            }
          ]
        }
      ],
      blocks: [
        {
          type: "TOTAL_PRICE",
          displayOrder: 4
        },
        {
          type: "BUTTON",
          displayOrder: 5,
          buttonText: "Buy now {{item count}} Items",
          translatableField: ["buttonText"]
        },
        {
          type: "SUCCESS_ERROR_BANNER",
          displayOrder: 6
        }
      ]
    },
    {
      type: "DATE_PICKER",
      isVisible: true,
      configuration: {
        fieldName: "Birthday",
        title: false,
        titleText: "",
        label: "Your birthday (YYYY-MM-DD)",
        dateFormat: "YYYY-MM-DD",
        required: true,
        errorText: "Birthday is required",
        translatableField: ["label", "errorText"]
      },
      dataCollection: {
        customerMetafield: {
          enabled: true,
          keyName: "Birthday"
        },
        orderMetafield: {
          enabled: true,
          keyName: "Birthday"
        }
      }
    },
    {
      type: "TEXT_AREA",
      isVisible: true,
      configuration: {
        fieldName: "Text area",
        title: true,
        titleText: "",
        label: "Text placeholder",
        required: true,
        errorText: "This field is Required",
        translatableField: ["label", "errorText", "titleText"]
      },
      dataCollection: {
        customerMetafield: {
          enabled: true,
          keyName: "Text area 1"
        },
        orderMetafield: {
          enabled: true,
          keyName: "Text area 1"
        }
      }
    },
    {
      type: "TEXT_FIELD",
      isVisible: true,
      configuration: {
        fieldName: "Text field",
        title: true,
        titleText: "",
        label: "Text placeholder",
        required: true,
        errorText: "This field is Required",
        translatableField: ["label", "errorText", "titleText"]
      },
      dataCollection: {
        customerMetafield: {
          enabled: true,
          keyName: "Text field 1"
        },
        orderMetafield: {
          enabled: true,
          keyName: "Text field 1"
        }
      }
    },
    {
      type: "MULTIPLE_CHOICE",
      isVisible: true,
      configuration: {
        fieldName: "Multiple choice question",
        label: "",
        type: "MULTIPLE_CHOICE_SINGLE_ANSWER",
        title: true,
        titleText: "",
        required: true,
        errorText: "You must choose an answer",
        translatableField: ["label", "errorText", "titleText"]
      },
      answer: {
        defaultAnswer: "NOT_SELECTED",
        options: [
          {
            option: "Option 1"
          }
        ]
      },
      dataCollection: {
        customerMetafield: {
          enabled: true,
          keyName: "Multiple choice 1"
        },
        orderMetafield: {
          enabled: true,
          keyName: "Multiple choice 1"
        }
      }
    },
    {
      type: "FORM_WIDGET",
      category: "CONTAINER",
      isVisible: true,
      name: "Form",
      errorText: "The form is required",
      translatableField: ["errorText"],
      widgets: [],
      blocks: [
        {
          type: "BUTTON",
          displayOrder: 0,
          location: "STEP_A",
          buttonType: "PRIMARY",
          buttonText: "Submit",
          translatableField: ["buttonText"]
        }
      ]
    },
    {
      type: "THANK_YOU_PAGE_BAR",
      category: "INFORMATIONAL",
      name: "Thank You Page Bar",
      displayOrder: 1,
      isVisible: true,
      parentType: "DISCOUNT_TIMER",
      blocks: [
        {
          type: "TIMER_TEXT",
          name: "Timer Text",
          parentType: "THANK_YOU_PAGE_BAR",
          description: '<h2 style="font-size: 16px; font-weight: 600; margin-bottom: 0px;">One-Time Offer!</h2><p>For the next 20 minutes only, get 10% OFF EVERYTHING!</p>',
          mobileDescription: '<h2 style="font-size: 16px; font-weight: 600; margin-bottom: 0px;">Limited offer</h2>\n<p>30% Off Site-wide, GO.</p>',
          translatableField: ["description", "mobileDescription"],
          timerExpiredSetting: {
            replaceWhenTimerRunOut: true,
            timerExpiredText: '<h2 style="text-align: center; font-size: 16px; font-weight: 600; margin-bottom: 0px;">Offer expired</h2>',
            mobileTimerExpiredText: '<h2 style="text-align: center; font-size: 16px; font-weight: 600; margin-bottom: 0px;">Offer expired</h2>',
            preview: false,
            translatableField: ["timerExpiredText", "mobileTimerExpiredText"]
          }
        },
        {
          type: "CLOCK",
          name: "Clock",
          parentType: "THANK_YOU_PAGE_BAR",
          background: "SUBDUED",
          digitColor: "WARNING",
          clockFrame: "INDIVIDUAL_FRAMES",
          frameBorder: "BASE",
          frameBorderRadius: "BASE",
          showTimeSeparator: true,
          showTimeUnitLabels: true,
          timeUnitLabels: {
            days: "",
            hours: "",
            minutes: "",
            seconds: "",
            translatableField: ["days", "hours", "minutes", "seconds"]
          },
          showUnitLabelsInFrame: true,
          unitLabelsPosition: "BELOW_DIGITS",
          timerExpiredSetting: {
            whenTimeRunsOut: "REMOVE_CLOCK",
            timerExpiredText: "",
            mobileTimerExpiredText: "",
            preview: false,
            translatableField: ["timerExpiredText", "mobileTimerExpiredText"]
          }
        },
        {
          type: "ACCEPT_BUTTON",
          parentType: "THANK_YOU_PAGE_BAR",
          name: "Accept Button",
          buttonType: "PRIMARY",
          buttonText: "Shop Now",
          mobileButtonText: "Accept offer",
          helpText: "The link in the store the button directs to. Only use a relative link, no need for full URL. Example: For the URL: store.com/collections/best-sellers  Write: '/collections/best-sellers'",
          displayOrder: 0,
          isVisible: true,
          translatableField: ["buttonText", "mobileButtonText", "helpText"]
        },
        {
          type: "DECLINE_BUTTON",
          parentType: "THANK_YOU_PAGE_BAR",
          name: "Decline Button",
          buttonType: "SECONDARY",
          showCloseButton: true,
          buttonText: "Maybe later",
          isVisible: true,
          translatableField: ["buttonText"]
        }
      ]
    },
    {
      type: "ONLINE_STORE_BAR",
      name: "Online Store Bar",
      displayOrder: 2,
      category: "INFORMATIONAL",
      isVisible: true,
      parentType: "DISCOUNT_TIMER",
      blocks: [
        {
          type: "TIMER_TEXT",
          name: "Timer Text",
          parentType: "ONLINE_STORE_BAR",
          description: '<h2 style="font-size: 16px; font-weight: 600; margin-bottom: 0px;">One-Time Offer!</h2><p>For the next 20 minutes only, get 10% OFF EVERYTHING!</p>',
          mobileDescription: '<h2 style="font-size: 16px; font-weight: 600; margin-bottom: 0px;">Limited offer</h2>\n<p>30% Off Site-wide, GO.</p>',
          translatableField: ["description", "mobileDescription"],
          timerExpiredSetting: {
            replaceWhenTimerRunOut: true,
            timerExpiredText: '<h2 style="text-align: center; font-size: 16px; font-weight: 600; margin-bottom: 0px;">Offer expired</h2>',
            mobileTimerExpiredText: '<h2 style="text-align: center; font-size: 16px; font-weight: 600; margin-bottom: 0px;">Offer expired</h2>',
            preview: false,
            translatableField: ["timerExpiredText", "mobileTimerExpiredText"]
          },
          displayOrder: 0,
          isVisible: true
        },
        {
          type: "CLOCK",
          name: "Clock",
          parentType: "ONLINE_STORE_BAR",
          background: "SUBDUED",
          digitColor: "WARNING",
          clockFrame: "INDIVIDUAL_FRAMES",
          frameBorder: "BASE",
          frameBorderRadius: "BASE",
          showTimeSeparator: true,
          showTimeUnitLabels: true,
          timeUnitLabels: {
            days: "",
            hours: "",
            minutes: "",
            seconds: "",
            translatableField: ["days", "hours", "minutes", "seconds"]
          },
          showUnitLabelsInFrame: true,
          unitLabelsPosition: "BELOW_DIGITS",
          timerExpiredSetting: {
            whenTimeRunsOut: "REMOVE_CLOCK",
            timerExpiredText: "",
            mobileTimerExpiredText: "",
            preview: false,
            translatableField: ["timerExpiredText", "mobileTimerExpiredText"]
          }
        }
      ]
    },
    {
      type: "DISCOUNT_TIMER",
      name: "Discount Timer",
      category: "CONVERTING",
      isVisible: true,
      startTimer: "ONCE_PER_ORDER",
      count: "TIME_PASSED",
      startCounting: "ON_FIRST_IMPRESSION",
      dateAndTime: "",
      duration: {
        days: 0,
        hours: 0,
        minutes: 20,
        seconds: 0
      },
      whenTimerRunOut: "CLOSE_ANNOUNCEMENT_BAR",
      previewExpiredOffer: true,
      discountSettings: {
        applyDiscount: false,
        discountType: "PERCENTAGE",
        discountValue: "10%",
        discountPrefix: "Upsell.com"
      },
      widgets: [
        {
          type: "THANK_YOU_PAGE_BAR"
        },
        {
          type: "ONLINE_STORE_BAR"
        }
      ]
    },
    {
      type: "IMAGE_WIDGET",
      category: "INFORMATIONAL",
      isVisible: true,
      name: "Image (1)",
      image: {
        src: null,
        altText: "",
        translatableField: ["altText"]
      },
      link: {
        addLink: false,
        destinationURL: "",
        openInNewTabDesktop: true,
        openInNewTabMobile: true
      },
      layout: {
        height: "AUTO",
        fit: "COVER",
        aspectRatio: "AUTO",
        alignment: "CENTER",
        cornerRadius: "BASE",
        borderStyle: "BASE",
        padding: "BASE"
      }
    }
  ]
};

// src/defaultWidgetsValue/checkout_wix_default_value.json
var checkout_wix_default_value_default = {
  defaultValues: [
    {
      type: "DIVIDER",
      category: "INFORMATIONAL",
      isVisible: true,
      name: "Divider (1)"
    },
    {
      type: "TEXT",
      category: "INFORMATIONAL",
      isVisible: true,
      text: "<p>You may also like this product</p>",
      name: "Text (1)",
      fontFamily: "Wix Madefor Text"
    },
    {
      type: "UPSELL",
      category: "CONVERTING",
      isVisible: true,
      text: "You may also like this product",
      name: "Product (1)",
      upsellInfo: {
        type: "SAME_CATEGORIES",
        noOfProducts: 1,
        location: "CART",
        layout: "SMALL",
        settings: {
          SPECIFIC_PRODUCT: [
            {
              productInfo: {},
              optionsIfAlreadyInLocation: {
                value: "display_featured_product_anyway",
                alternateProduct: {}
              },
              defaultSelected: true,
              mandatory: false
            }
          ],
          MOST_EXPENSIVE: {
            excludeTagsOptions: {
              enabled: false,
              tags: [],
              alternateOption: "display_alternative_product",
              alternateProduct: {},
              category: [
                "00000000-000000-000000-000000000001"
              ]
            }
          },
          LEAST_EXPENSIVE: {
            excludeTagsOptions: {
              enabled: false,
              tags: [],
              alternateOption: "display_alternative_product",
              alternateProduct: {},
              category: [
                "00000000-000000-000000-000000000001"
              ]
            }
          },
          BEST_SELLERS: {
            excludeTagsOptions: {
              enabled: false,
              tags: [],
              alternateOption: "display_random_product",
              alternateProduct: {},
              category: []
            }
          },
          FREQUENTLY_VIEWED_TOGETHER: {
            excludeTagsOptions: {
              enabled: false,
              tags: [],
              alternateOption: "display_random_product",
              alternateProduct: {},
              category: []
            }
          },
          FREQUNTLY_BOUGHT_TOGETHER: {
            excludeTagsOptions: {
              enabled: false,
              tags: [],
              alternateOption: "display_random_product",
              alternateProduct: {},
              category: []
            }
          },
          SAME_CATEGORIES: {
            excludeTagsOptions: {
              enabled: false,
              tags: [],
              alternateOption: "display_random_product",
              alternateProduct: {},
              category: []
            }
          }
        }
      },
      blocks: [
        {
          type: "IMAGE",
          isVisible: true,
          imageFit: "CONTAIN",
          imageToDisplay: "MAIN_PRODUCT",
          imageURL: "",
          showImageAccordingToVariant: true
        },
        {
          type: "PRODUCT_TITLE",
          isVisible: true,
          customTitle: {
            enabled: false,
            value: "Product title"
          },
          fontFamily: "Wix Madefor Text"
        },
        {
          type: "PRODUCT_DETAILS",
          isVisible: true,
          subtitle: {
            selection: "OPTION_NAME",
            customText: "Text",
            fontFamily: "Wix Madefor Text"
          }
        },
        {
          type: "DESCRIPTION",
          isVisible: true,
          displayProductDescription: true,
          customText: {
            enabled: false,
            value: "text text text text"
          },
          collapsible: {
            enabled: true,
            defaultState: "COLLAPSED",
            buttonText: "Description"
          },
          fontFamily: "Wix Madefor Text"
        },
        {
          type: "PRICE_AND_DISCOUNT",
          isVisible: true,
          price: {
            showHighLowPrice: {
              enabled: true,
              highestPriceFontSize: "MEDIUM",
              lowestPriceFontSize: "MEDIUM",
              fontFamily: "Wix Madefor Text"
            },
            displayComparision: {
              enabled: false,
              size: "MEDIUM"
            },
            displayOriginal: {
              enabled: true,
              size: "MEDIUM"
            },
            displayAfterDiscount: {
              enabled: true,
              size: "MEDIUM"
            }
          },
          discount: {
            enabled: false,
            onlyForOrdersOverValue: {
              enabled: false,
              minimumOrderValue: 0
            },
            type: "PERCENTAGE",
            discountValue: 10,
            discountConflictsOption: "NO_DISCOUNT",
            onlyForProductsOverValue: {
              enabled: false,
              minimumProductPrice: 100
            }
          }
        },
        {
          type: "BUTTON",
          isVisible: true,
          buttonType: "SECONDARY",
          buttonText: "Add",
          buttonFont: "Wix Madefor Text"
        },
        {
          type: "VARIANT_PICKER",
          isVisible: true,
          displayVariantPicker: true,
          label: "Choose variant",
          defaultSelectedVariant: "first_option",
          errorMessage: "Please select option",
          buttonFont: "Wix Madefor Text"
        },
        {
          type: "QUANTITY_SELECTOR",
          isVisible: true,
          displayQuantitySelector: true,
          label: "Quantity",
          defaultQuantity: 1,
          minQuantity: {
            enabled: false,
            value: 1
          },
          maxQuantity: {
            enabled: false,
            value: 10
          },
          fontFamily: "Wix Madefor Text"
        },
        {
          type: "SUCCESS_ERROR_BANNER",
          isVisible: true,
          successBanner: {
            enabled: true,
            type: "SUCCESS",
            text: "Item successfully added to cart",
            reconvertDiscountAppliedText: "Good news! the offer discount is higher than the one you previously had in the order, so we replaced them",
            otherDiscountAppliedText: " The existing discount in your order is higher than the one offered for the offer, so we kept it for you instead!",
            existingDiscountText: "To apply the offer discount we had to remove the previous one you had in your order",
            dismissible: true,
            undoButton: {
              enabled: true,
              text: "Undo"
            },
            fontFamily: "Wix Madefor Text"
          },
          errorBanner: {
            enabled: true,
            type: "CRITICAL",
            dismissible: true,
            staticText: {
              enabled: true,
              value: "Error occurred. Please try again."
            },
            fontFamily: "Wix Madefor Text"
          }
        }
      ]
    },
    {
      type: "MULTI_PRODUCT_UPSELL",
      category: "CONTAINER",
      isVisible: true,
      text: "You may also like this product",
      name: "Product upsell (1)",
      widgets: [
        {
          type: "DIVIDER"
        },
        {
          type: "TEXT"
        },
        {
          type: "UPSELL"
        }
      ]
    }
  ]
};

// src/defaultWidgetsValue/advance_timer_default_value.json
var advance_timer_default_value_default = {
  defaultValues: [
    {
      type: "TIMER",
      category: "INFORMATIONAL",
      isVisible: true,
      name: "Timer (1)",
      blocks: [
        {
          type: "CLOCK",
          background: "SUBDUED",
          digitColor: "WARNING",
          showTitle: false,
          title: "",
          clockFrame: "NO_FRAME",
          frameBorder: "BASE",
          frameBorderRadius: "BASE",
          showTimeSeparator: true,
          showTimeUnitLabels: true,
          timeUnitLabels: {
            days: "",
            hours: "",
            minutes: "",
            seconds: ""
          },
          showUnitLabelsInFrame: false,
          unitLabelsPosition: "LEFT_TO_DIGITS",
          timerExpiredSetting: {
            whenTimeRunsOut: "REPLACE_CLOCK_WITH_TEXT",
            timerExpiredText: "",
            preview: false
          }
        },
        {
          type: "TIMER_TEXT",
          description: "",
          frameBorderRadius: "BASE",
          frameBorder: "BASE",
          textInframe: false,
          textBackground: "BASE",
          timerExpiredSetting: {
            replaceWhenTimerRunOut: true,
            timerExpiredText: "",
            preview: false
          }
        },
        {
          type: "PROGRESS_BAR",
          showProgressBar: true,
          progressBarColor: "AUTO",
          timerExpiredSetting: {
            timerRunsOut: "CHANGE_PROGRESS_BAR_COLOR",
            progressBarColor: "CRITICAL"
          }
        }
      ],
      upsellInfo: {
        settings: {
          displayTimer: "ONCE_PER_SESSION",
          timerEffect: "ALL_WIDGETS_ON_THIS_PAGE",
          timerRunsOut: "DO_NOTHING",
          selectedWidgets: []
        },
        duration: {
          count: "TIME_PASSED",
          startCounting: "ON_FIRST_IMPRESSION",
          dateAndTime: "",
          duration: {
            days: 0,
            hours: 0,
            minutes: 5,
            seconds: 0
          }
        },
        designConfig: {
          timerStyle: "BANNER",
          backgroundColor: "BASE",
          desktopLayout: "HORIZONTAL",
          bannerType: "INFO",
          timerBorder: "NONE",
          timerBorderRadius: "BASE"
        },
        expiredMessageConfig: {
          changeBannerTypeOnTimerRunOut: false,
          bannerTypeOnTimerRunOut: "CRITICAL",
          isDisplayMessage: true,
          backgroundColor: "RED",
          preview: false
        }
      }
    }
  ]
};

// src/defaultWidgetsValue/pre_purchase_wix_default_value.json
var pre_purchase_wix_default_value_default = {
  defaultValues: [
    {
      type: "DIVIDER",
      category: "INFORMATIONAL",
      isVisible: true,
      name: "Divider (1)",
      showDivider: true
    },
    {
      type: "TEXT",
      category: "INFORMATIONAL",
      isVisible: true,
      text: "<p>You may also like this product</p>",
      name: "Text (1)",
      fontFamily: "Wix Madefor Text"
    },
    {
      type: "UPSELL",
      category: "CONVERTING",
      isVisible: true,
      text: "You may also like this product",
      name: "Product (1)",
      upsellInfo: {
        type: "SAME_CATEGORIES",
        noOfProducts: 1,
        location: "CART",
        layout: "SMALL",
        settings: {
          SPECIFIC_PRODUCT: [
            {
              productInfo: {},
              optionsIfAlreadyInLocation: {
                value: "display_featured_product_anyway",
                alternateProduct: {}
              },
              defaultSelected: true,
              mandatory: false
            }
          ],
          MOST_EXPENSIVE: {
            excludeTagsOptions: {
              enabled: false,
              tags: [],
              alternateOption: "display_alternative_product",
              alternateProduct: {},
              category: [
                "00000000-000000-000000-000000000001"
              ]
            }
          },
          LEAST_EXPENSIVE: {
            excludeTagsOptions: {
              enabled: false,
              tags: [],
              alternateOption: "display_alternative_product",
              alternateProduct: {},
              category: [
                "00000000-000000-000000-000000000001"
              ]
            }
          },
          BEST_SELLERS: {
            excludeTagsOptions: {
              enabled: false,
              tags: [],
              alternateOption: "display_random_product",
              alternateProduct: {},
              category: []
            }
          },
          FREQUENTLY_VIEWED_TOGETHER: {
            excludeTagsOptions: {
              enabled: false,
              tags: [],
              alternateOption: "display_random_product",
              alternateProduct: {},
              category: []
            }
          },
          FREQUNTLY_BOUGHT_TOGETHER: {
            excludeTagsOptions: {
              enabled: false,
              tags: [],
              alternateOption: "display_random_product",
              alternateProduct: {},
              category: []
            }
          },
          SAME_CATEGORIES: {
            excludeTagsOptions: {
              enabled: false,
              tags: [],
              alternateOption: "display_random_product",
              alternateProduct: {},
              category: []
            }
          }
        }
      },
      blocks: [
        {
          type: "IMAGE",
          isVisible: true,
          imageFit: "CONTAIN",
          imageToDisplay: "MAIN_PRODUCT",
          imageURL: "",
          showImageAccordingToVariant: true
        },
        {
          type: "PRODUCT_TITLE",
          isVisible: true,
          customTitle: {
            enabled: false,
            value: "Product title"
          },
          fontFamily: "Wix Madefor Text",
          fontColor: "#121417"
        },
        {
          type: "PRODUCT_DETAILS",
          isVisible: true,
          subtitle: {
            selection: "OPTION_NAME",
            customText: "Text",
            fontFamily: "Wix Madefor Text",
            fontColor: "#121417"
          }
        },
        {
          type: "DESCRIPTION",
          isVisible: true,
          displayProductDescription: "DISPLAY_PRODUCT_DESCRIPTION",
          customText: {
            enabled: false,
            value: "text text text text"
          },
          collapsible: {
            enabled: true,
            defaultState: "COLLAPSED",
            buttonText: "Description"
          },
          fontFamily: "Wix Madefor Text",
          fontColor: "#121417"
        },
        {
          type: "PRICE_AND_DISCOUNT",
          isVisible: true,
          price: {
            showHighLowPrice: {
              enabled: true,
              highestPriceFontSize: "MEDIUM",
              lowestPriceFontSize: "MEDIUM",
              highestPriceFontColor: "#121417",
              lowestPriceFontColor: "#121417",
              fontFamily: "Wix Madefor Text"
            },
            displayComparision: {
              enabled: false,
              size: "MEDIUM"
            },
            displayOriginal: {
              enabled: true,
              size: "MEDIUM"
            },
            displayAfterDiscount: {
              enabled: true,
              size: "MEDIUM"
            }
          },
          discount: {
            enabled: false,
            onlyForOrdersOverValue: {
              enabled: false,
              minimumOrderValue: 0
            },
            type: "PERCENTAGE",
            discountValue: 10,
            discountConflictsOption: "NO_DISCOUNT",
            onlyForProductsOverValue: {
              enabled: false,
              minimumProductPrice: 100
            }
          }
        },
        {
          type: "BUTTON",
          isVisible: true,
          buttonType: "SECONDARY",
          buttonText: "Add",
          buttonColor: "#ffffff",
          buttonFont: "Wix Madefor Text",
          fontColor: "#121417"
        },
        {
          type: "VARIANT_PICKER",
          isVisible: true,
          displayVariantPicker: true,
          label: "Choose variant",
          defaultSelectedVariant: "first_option",
          errorMessage: "Please select option",
          fontFamily: "Wix Madefor Text",
          fontColor: "#121417"
        },
        {
          type: "QUANTITY_SELECTOR",
          isVisible: true,
          displayQuantitySelector: true,
          label: "Quantity",
          defaultQuantity: 1,
          minQuantity: {
            enabled: false,
            value: 1
          },
          maxQuantity: {
            enabled: false,
            value: 10
          },
          fontFamily: "Wix Madefor Text",
          fontColor: "#121417"
        },
        {
          type: "SUCCESS_ERROR_BANNER",
          isVisible: true,
          successBanner: {
            enabled: true,
            type: "SUCCESS",
            text: "Item successfully added to cart",
            reconvertDiscountAppliedText: "Good news! the offer discount is higher than the one you previously had in the order, so we replaced them",
            otherDiscountAppliedText: " The existing discount in your order is higher than the one offered for the offer, so we kept it for you instead!",
            existingDiscountText: "To apply the offer discount we had to remove the previous one you had in your order",
            dismissible: true,
            undoButton: {
              enabled: true,
              text: "Undo"
            },
            fontFamily: "Wix Madefor Text",
            fontColor: "#121417"
          },
          errorBanner: {
            enabled: true,
            type: "CRITICAL",
            dismissible: true,
            staticText: {
              enabled: true,
              value: "Error occurred. Please try again."
            },
            fontFamily: "Wix Madefor Text",
            fontColor: "#121417"
          }
        }
      ]
    },
    {
      type: "MULTI_PRODUCT_UPSELL",
      category: "CONTAINER",
      isVisible: true,
      text: "You may also like this product",
      name: "Product upsell (1)",
      widgets: [
        {
          type: "DIVIDER"
        },
        {
          type: "TEXT"
        },
        {
          type: "UPSELL"
        }
      ]
    }
  ]
};

// src/defaultWidgetsValue/form_editor_default_value.json
var form_editor_default_value_default = {
  defaultValues: [
    {
      type: "DIVIDER",
      category: "INFORMATIONAL",
      isVisible: true,
      name: "Divider (1)",
      dividerText: {
        enabled: false,
        value: "Title",
        translatableField: ["value"]
      }
    },
    {
      type: "TEXT",
      category: "INFORMATIONAL",
      isVisible: true,
      text: "<p>You may also like this product</p>",
      name: "Text (1)",
      translatableField: ["text"]
    },
    {
      type: "BANNER",
      category: "INFORMATIONAL",
      isVisible: true,
      status: "INFO",
      dismissible: true,
      name: "Banner (1)",
      content: {
        title: "Title",
        description: "",
        collapsible: true,
        translatableField: ["title", "description"]
      },
      button: {
        display: false,
        type: "PRIMARY",
        color: "DEFAULT",
        text: "Button text",
        link: "",
        translatableField: ["text"]
      }
    },
    {
      type: "UPSELL",
      category: "CONVERTING",
      parentType: "MULTI_PRODUCT_UPSELL",
      isVisible: true,
      text: "You may also like this product",
      name: "Product (1)",
      translatableField: ["text"],
      upsellInfo: {
        type: "SHOPIFY_RECOMMENDATIONS",
        noOfProducts: 1,
        productsPerRow: 3,
        sliderConfig: {
          hint: "PILL",
          hintText: "Scroll",
          translatableField: ["hintText"]
        },
        location: "CART",
        layout: "SMALL_LAYOUT_ONE",
        subLayout: "SMALL_LAYOUT_ONE",
        settings: {
          SPECIFIC_PRODUCT: [
            {
              productInfo: {},
              optionsIfAlreadyInLocation: {
                value: "display_featured_product_anyway",
                alternateProduct: {}
              },
              defaultSelected: true,
              mandatory: false
            }
          ],
          SHOPIFY_RECOMMENDATIONS: {
            hideIfAlreadyInLocation: false,
            excludeTagsOptions: {
              enabled: true,
              tags: []
            },
            recommendationIntent: "related"
          },
          MOST_EXPENSIVE: {
            excludeTagsOptions: {
              enabled: false,
              tags: [],
              alternateOption: "use_shopify_recommendation",
              alternateProduct: {}
            }
          },
          LEAST_EXPENSIVE: {
            excludeTagsOptions: {
              enabled: false,
              tags: [],
              alternateOption: "use_shopify_recommendation",
              alternateProduct: {}
            }
          },
          PERSONALIZED_RECOMMENDATIONS: {
            excludeTagsOptions: {
              enabled: false,
              tags: []
            },
            hideIfAlreadyInLocation: false
          },
          RECOMATIC_RECOMMENDATIONS: {
            excludeTagsOptions: {
              enabled: false,
              tags: []
            }
          },
          SPECIFIC_COLLECTION: []
        }
      },
      blocks: [
        {
          type: "IMAGE",
          isVisible: true,
          imageFit: "CONTAIN",
          imageToDisplay: "MAIN_PRODUCT",
          imageURL: "",
          showImageAccordingToVariant: true,
          linkToProduct: false,
          imageBorderRadius: "BASE",
          imageBorderStyle: "BASE"
        },
        {
          type: "PRODUCT_TITLE",
          isVisible: true,
          customTitle: {
            enabled: false,
            value: "Product title",
            translatableField: ["value"]
          }
        },
        {
          type: "STAR_RATING",
          isVisible: true,
          blockSettings: {
            starColor: "#F4C430",
            layout: "MINIMALISTIC",
            showAmountOfReviews: true,
            showRatingValue: true,
            reviewsLabel: "reviews",
            integrationError: false,
            translatableField: ["reviewsLabel"]
          }
        },
        {
          type: "PRODUCT_DETAILS",
          isVisible: true,
          subtitle: {
            selection: "VARIANT_NAME",
            textStyle: "UPPER_CASE",
            customText: "Text",
            translatableField: ["customText"]
          }
        },
        {
          type: "DESCRIPTION",
          isVisible: true,
          displayProductDescription: true,
          customText: {
            enabled: false,
            value: "text text text text",
            translatableField: ["value"]
          },
          collapsible: {
            enabled: true,
            defaultState: "COLLAPSED",
            buttonText: "Description",
            translatableField: ["buttonText"]
          }
        },
        {
          type: "PRICE_AND_DISCOUNT",
          isVisible: true,
          price: {
            samePriceForAll: true,
            priceToDisplay: "DISPLAY_HIGHEST_LOWEST_PRICE",
            totalPriceText: "Total Price",
            translatableField: ["totalPriceText"],
            displayComparision: {
              dontDisplayComparePrice: false,
              enabled: true,
              size: "DEFAULT",
              color: "CRITICAL"
            },
            displayOriginal: {
              enabled: true,
              size: "DEFAULT",
              color: "CRITICAL"
            },
            displayAfterDiscount: {
              enabled: true,
              size: "DEFAULT",
              color: "INFO"
            }
          },
          discount: {
            enabled: true,
            onlyForOrdersOverValue: {
              enabled: false,
              minimumOrderValue: 0
            },
            type: "PERCENTAGE",
            name: "",
            breakPoint: [
              {
                minimumItemGetDiscount: 1,
                value: 0
              }
            ],
            discountValue: 0,
            minItemsDiscount: 1,
            maxItemsDiscount: 100,
            onlyForProductsOverValue: {
              enabled: false,
              minimumProductPrice: 100
            }
          }
        },
        {
          type: "BUTTON",
          isVisible: true,
          buttonType: "SECONDARY",
          buttonText: "{{add to cart}}",
          translatableField: ["buttonText"]
        },
        {
          type: "VARIANT_PICKER",
          isVisible: true,
          displayVariantPicker: true,
          label: "Variant",
          preselectedVariant: "DEFAULT_PRODUCT_VARIANT",
          selectedSpecificVariantId: "",
          combineAllOptionsIntoOneDropdown: true,
          showPriceInDropdown: true,
          translatableField: ["label"]
        },
        {
          type: "QUANTITY_SELECTOR",
          isVisible: true,
          displayQuantitySelector: true,
          label: "Quantity",
          defaultQuantity: 1,
          minQuantity: {
            enabled: false,
            value: 1
          },
          maxQuantity: {
            enabled: false,
            value: 10
          },
          translatableField: ["label"]
        },
        {
          type: "SUCCESS_ERROR_BANNER",
          isVisible: true,
          successBanner: {
            enabled: true,
            type: "SUCCESS",
            text: "Added to cart.",
            dismissible: true,
            translatableField: ["text"],
            undoButton: {
              enabled: true,
              text: "Undo",
              translatableField: ["text"]
            }
          },
          errorBanner: {
            enabled: true,
            type: "CRITICAL",
            dismissible: true,
            staticText: {
              enabled: true,
              value: "Unable to add product/s to cart.",
              translatableField: ["value"]
            }
          }
        }
      ]
    },
    {
      type: "TOTAL_PRICE",
      isVisible: true,
      priceToDisplay: "HIGHEST_LOWEST_PRICE",
      dontDisplayCompareTotalPrice: false,
      isDisplayCompareToPrice: true,
      text: "{{total price}} {{pricing}}",
      displayComparisionFontColor: "CRITICAL",
      displayOriginalFontColor: "CRITICAL",
      displayAfterDiscountFontColor: "INFO",
      translatableField: ["text"]
    },
    {
      type: "BUTTON",
      isVisible: true,
      buttonType: "SECONDARY",
      buttonText: "Add {{item count}} Items",
      translatableField: ["buttonText"]
    },
    {
      type: "SUCCESS_ERROR_BANNER",
      isVisible: true,
      successBanner: {
        enabled: true,
        type: "SUCCESS",
        text: "Added to cart.",
        dismissible: true,
        translatableField: ["text"]
      },
      errorBanner: {
        enabled: true,
        type: "CRITICAL",
        dismissible: true,
        staticText: {
          enabled: true,
          value: "Unable to add product/s to cart.",
          translatableField: ["value"]
        }
      }
    },
    {
      type: "TIMER",
      category: "INFORMATIONAL",
      isVisible: true,
      name: "Timer (1)",
      blocks: [
        {
          type: "TIMER_TEXT",
          description: '<h2 style="text-align: center; font-size: 16px; font-weight: 600; margin-bottom: 0px;">Offer expires in:</h2>',
          frameBorderRadius: "LARGE",
          frameBorder: "BASE",
          textInframe: false,
          textBackground: "SUBDUED",
          translatableField: ["description"],
          timerExpiredSetting: {
            replaceWhenTimerRunOut: true,
            timerExpiredText: '<h2 style="text-align: center; font-size: 16px; font-weight: 600; margin-bottom: 0px;">Offer expired</h2>',
            preview: false,
            translatableField: ["timerExpiredText"]
          }
        },
        {
          type: "CLOCK",
          background: "BASE",
          digitColor: "CRITICAL",
          showTitle: false,
          title: "",
          clockFrame: "INDIVIDUAL_FRAMES",
          frameBorder: "BASE",
          frameBorderRadius: "BASE",
          showTimeSeparator: true,
          showTimeUnitLabels: true,
          timeUnitLabels: {
            days: "",
            hours: "",
            minutes: "Minutes",
            seconds: "Seconds",
            translatableField: ["days", "hours", "minutes", "seconds"]
          },
          showUnitLabelsInFrame: false,
          unitLabelsPosition: "BELOW_DIGITS",
          timerExpiredSetting: {
            whenTimeRunsOut: "REPLACE_CLOCK_WITH_TEXT",
            timerExpiredText: "",
            preview: false,
            translatableField: ["timerExpiredText"]
          }
        },
        {
          type: "PROGRESS_BAR",
          showProgressBar: true,
          progressBarColor: "AUTO",
          timerExpiredSetting: {
            timerRunsOut: "CHANGE_PROGRESS_BAR_COLOR",
            progressBarColor: "CRITICAL",
            preview: false
          }
        }
      ],
      upsellInfo: {
        settings: {
          displayTimer: "ONCE_PER_SESSION",
          timerEffect: "ALL_WIDGETS_ON_THIS_PAGE",
          timerRunsOut: "DO_NOTHING",
          selectedWidgets: []
        },
        duration: {
          count: "TIME_PASSED",
          startCounting: "ON_FIRST_IMPRESSION",
          dateAndTime: "",
          duration: {
            days: 0,
            hours: 0,
            minutes: 10,
            seconds: 0
          }
        },
        designConfig: {
          timerStyle: "PROMOTIONAL",
          backgroundColor: "SUBDUED",
          desktopLayout: "HORIZONTAL",
          bannerType: "INFO",
          timerBorder: "BASE",
          timerBorderRadius: "LARGE"
        },
        expiredMessageConfig: {
          changeBannerTypeOnTimerRunOut: false,
          bannerTypeOnTimerRunOut: "CRITICAL",
          isDisplayMessage: true,
          backgroundColor: "RED",
          preview: false
        }
      }
    },
    {
      type: "MULTI_PRODUCT_UPSELL",
      category: "CONTAINER",
      isVisible: true,
      text: "You may also like this product",
      name: "Product upsell (1)",
      postAcceptOption: "HIDE_PRODUCT",
      ifNoProductsToShowBlocksShould: "HIDE",
      widgets: [
        {
          type: "DIVIDER"
        },
        {
          type: "TEXT"
        },
        {
          type: "UPSELL",
          layout: "SMALL_LAYOUT_TWO"
        }
      ]
    },
    {
      type: "RECOMMENDATIONS",
      category: "CONTAINER",
      isVisible: true,
      text: "You may also like this product",
      name: "Product recommendations (1)",
      postAcceptOption: "HIDE_PRODUCT",
      ifNoProductsToShowBlocksShould: "HIDE",
      translatableField: ["text"],
      widgets: [
        {
          type: "TEXT",
          text: '<h2 style="text-align: left; font-size: 16px; font-weight: 600; margin-bottom: 0px;">You may also like these products</h2>',
          translatableField: ["text"]
        },
        {
          type: "UPSELL",
          noOfProducts: 8,
          layout: "SLIDER",
          optionalBlocks: [
            "PRODUCT_DETAILS"
          ],
          blocksDefaultValue: [
            {
              type: "SUCCESS_ERROR_BANNER",
              text: "Added to cart! ",
              translatableField: ["text"]
            },
            {
              type: "DESCRIPTION",
              displayProductDescription: false
            }
          ]
        }
      ]
    },
    {
      type: "BUNDLE",
      category: "CONTAINER",
      isVisible: true,
      text: "You may also like this product",
      name: "Bundle(1)",
      noOfProducts: 3,
      productsPerRow: 3,
      translatableField: ["text"],
      sliderConfig: {
        hint: "PILL",
        hintText: "Scroll",
        translatableField: ["hintText"]
      },
      layout: "GRID",
      allowSeparateQuantitySelection: true,
      postAcceptOption: "HIDE_BUNDLE",
      ifNoProductsToShowBlocksShould: "HIDE",
      widgets: [
        {
          type: "TEXT",
          text: '<p><span style="font-size: 14px;"><strong>Frequently bought together</strong></span></p>',
          displayOrder: 0,
          translatableField: ["text"]
        },
        {
          type: "UPSELL",
          displayOrder: 1,
          layout: "LIST",
          subLayout: "SMALL_LAYOUT_ONE",
          removeBlocks: [
            "BUTTON",
            "SUCCESS_ERROR_BANNER"
          ],
          blocksDefaultValue: [
            {
              type: "PRICE_AND_DISCOUNT",
              priceToDisplay: "ONLY_HIGHEST_PRICE",
              displayComparision: {
                color: "INFO"
              }
            },
            {
              type: "BUTTON",
              buttonText: "Add {{item count}} Items",
              translatableField: ["buttonText"]
            }
          ]
        },
        {
          type: "UPSELL",
          displayOrder: 2,
          layout: "LIST",
          subLayout: "SMALL_LAYOUT_ONE",
          removeBlocks: [
            "BUTTON",
            "SUCCESS_ERROR_BANNER"
          ],
          blocksDefaultValue: [
            {
              type: "PRICE_AND_DISCOUNT",
              priceToDisplay: "ONLY_HIGHEST_PRICE",
              displayComparision: {
                color: "INFO"
              }
            },
            {
              type: "BUTTON",
              buttonText: "Add {{item count}} Items",
              translatableField: ["buttonText"]
            }
          ]
        },
        {
          type: "UPSELL",
          displayOrder: 3,
          layout: "LIST",
          subLayout: "SMALL_LAYOUT_ONE",
          removeBlocks: [
            "BUTTON",
            "SUCCESS_ERROR_BANNER"
          ],
          blocksDefaultValue: [
            {
              type: "PRICE_AND_DISCOUNT",
              priceToDisplay: "ONLY_HIGHEST_PRICE",
              displayComparision: {
                color: "INFO"
              }
            },
            {
              type: "BUTTON",
              buttonText: "Add {{item count}} Items",
              translatableField: ["buttonText"]
            }
          ]
        }
      ],
      blocks: [
        {
          type: "TOTAL_PRICE",
          displayOrder: 4
        },
        {
          type: "BUTTON",
          displayOrder: 5,
          buttonText: "Add {{item count}} Items",
          translatableField: ["buttonText"]
        },
        {
          type: "SUCCESS_ERROR_BANNER",
          displayOrder: 6
        }
      ]
    },
    {
      type: "DATE_PICKER",
      isVisible: true,
      configuration: {
        fieldName: "Birthday",
        title: false,
        titleText: "",
        label: "Your birthday (YYYY-MM-DD)",
        dateFormat: "YYYY-MM-DD",
        required: true,
        errorText: "Birthday is required",
        translatableField: ["label", "errorText", "titleText"]
      },
      dataCollection: {
        customerMetafield: {
          enabled: true,
          keyName: "Birthday"
        },
        orderMetafield: {
          enabled: true,
          keyName: "Birthday"
        }
      }
    },
    {
      type: "TEXT_AREA",
      isVisible: true,
      configuration: {
        fieldName: "Text area",
        title: true,
        titleText: "",
        label: "Text placeholder",
        required: true,
        errorText: "This field is Required",
        translatableField: ["label", "errorText", "titleText"]
      },
      dataCollection: {
        customerMetafield: {
          enabled: true,
          keyName: "Text area 1"
        },
        orderMetafield: {
          enabled: true,
          keyName: "Text area 1"
        }
      }
    },
    {
      type: "TEXT_FIELD",
      isVisible: true,
      configuration: {
        fieldName: "Text field",
        title: true,
        titleText: "",
        label: "Text placeholder",
        required: true,
        errorText: "This field is Required",
        translatableField: ["label", "errorText", "titleText"]
      },
      dataCollection: {
        customerMetafield: {
          enabled: true,
          keyName: "Text field 1"
        },
        orderMetafield: {
          enabled: true,
          keyName: "Text field 1"
        }
      }
    },
    {
      type: "MULTIPLE_CHOICE",
      isVisible: true,
      configuration: {
        fieldName: "Multiple choice question",
        label: "",
        type: "MULTIPLE_CHOICE_SINGLE_ANSWER",
        title: true,
        titleText: "",
        required: true,
        errorText: "You must choose an answer",
        translatableField: ["label", "errorText", "titleText"]
      },
      answer: {
        defaultAnswer: "NOT_SELECTED",
        options: [
          {
            option: "Option 1",
            translatableField: ["option"]
          }
        ]
      },
      dataCollection: {
        customerMetafield: {
          enabled: true,
          keyName: "Multiple choice 1"
        },
        orderMetafield: {
          enabled: true,
          keyName: "Multiple choice 1"
        }
      }
    },
    {
      type: "FORM_WIDGET",
      category: "CONTAINER",
      isVisible: true,
      name: "Form",
      errorText: "The form is required",
      translatableField: ["errorText"],
      widgets: [],
      blocks: [
        {
          type: "BUTTON",
          displayOrder: 0,
          location: "STEP_A",
          buttonType: "PRIMARY",
          buttonText: "Submit",
          translatableField: ["buttonText"]
        }
      ]
    },
    {
      type: "IMAGE_WIDGET",
      category: "INFORMATIONAL",
      isVisible: true,
      name: "Image (1)",
      image: {
        src: null,
        altText: "",
        translatableField: ["altText"]
      },
      link: {
        addLink: false,
        destinationURL: "",
        openInNewTabDesktop: true,
        openInNewTabMobile: true
      },
      layout: {
        height: "AUTO",
        fit: "COVER",
        aspectRatio: "AUTO",
        alignment: "CENTER",
        cornerRadius: "BASE",
        borderStyle: "BASE",
        padding: "BASE"
      }
    }
  ]
};

// src/flow/getDefaultWigetValue.ts
import lodash from "lodash";
import { v4 as uuidv4 } from "uuid";
var MultiProduct = [
  "MULTI_PRODUCT_UPSELL" /* MultiProductUpsell */,
  "BUNDLE" /* Bundle */,
  "RECOMMENDATIONS" /* Recommendations */,
  "FORM_WIDGET" /* FormWidget */,
  "DISCOUNT_TIMER" /* DiscountTimer */,
  "THANK_YOU_PAGE_BAR" /* ThankYouPageBar */,
  "ONLINE_STORE_BAR" /* OnlineStoreBar */,
  "ORDER_STATUS_PAGE_BAR" /* OrderStatusPageBar */
];
var Layouts = {
  ["ONE_COLUMN" /* ONE_COLUMN */]: "ONE_COLUMN" /* ONE_COLUMN */,
  ["TWO_COLUMN" /* TWO_COLUMN */]: "TWO_COLUMN" /* TWO_COLUMN */,
  ["THREE_COLUMN" /* THREE_COLUMN */]: "THREE_COLUMN" /* THREE_COLUMN */,
  ["SMALL_LAYOUT_ONE" /* SMALL_LAYOUT_ONE */]: "SMALL_LAYOUT_ONE" /* SMALL_LAYOUT_ONE */,
  ["SMALL_LAYOUT_TWO" /* SMALL_LAYOUT_TWO */]: "SMALL_LAYOUT_TWO" /* SMALL_LAYOUT_TWO */,
  ["LIST" /* LIST */]: "LIST" /* LIST */,
  ["SLIDER" /* SLIDER */]: "SLIDER" /* SLIDER */,
  ["GRID" /* GRID */]: "GRID" /* GRID */
};
var TwoSectionLayout = ["LEFT" /* LEFT */, "RIGHT" /* RIGHT */];
var ThreeSectionLayout = [
  "LEFT" /* LEFT */,
  "RIGHT" /* RIGHT */,
  "BOTTOM" /* BOTTOM */
];
var ThreeSectionLayoutVisible = {
  ["LEFT" /* LEFT */]: "isVisibleLeftColumnsBlocks",
  ["RIGHT" /* RIGHT */]: "isVisibleRightColumnsBlocks",
  ["BOTTOM" /* BOTTOM */]: "isVisibleBottomColumnsBlocks"
};
var PlatformType = {
  Shopify: "shopify",
  Wix: "wix"
};
var setting = {
  isDraggable: false,
  condition: "isVisible",
  isVisible: true,
  sectionSettings: [],
  maxCount: 1,
  count: 0,
  minCount: 1
};
var ThreeSectionLayoutSettings = {
  ["LEFT" /* LEFT */]: {
    sectionName: "left_column",
    type: "LEFT" /* LEFT */,
    icon: "left.svg",
    target: "widgets.[id:{TOP_WIDGET_ID}].upsellInfo.isVisibleLeftColumnsBlocks",
    ...setting
  },
  ["RIGHT" /* RIGHT */]: {
    sectionName: "right_column",
    type: "RIGHT" /* RIGHT */,
    icon: "right.svg",
    target: "widgets.[id:{TOP_WIDGET_ID}].upsellInfo.isVisibleRightColumnsBlocks",
    ...setting
  },
  ["BOTTOM" /* BOTTOM */]: {
    sectionName: "bottom",
    type: "BOTTOM" /* BOTTOM */,
    icon: "bottom.svg",
    target: "widgets.[id:{TOP_WIDGET_ID}].upsellInfo.isVisibleBottomColumnsBlocks",
    ...setting
  },
  ["ROOT" /* ROOT */]: {
    sectionName: "root",
    type: "ROOT" /* ROOT */,
    icon: "root.svg",
    target: "widgets.[id:{TOP_WIDGET_ID}].upsellInfo.isVisibleRootColumnsBlocks",
    ...setting
  }
};
function Ids() {
  return uuidv4();
}
var defaultData = {
  [PlatformType.Shopify]: {
    ["CHECKOUT" /* CHECKOUT */]: checkout_default_values_default,
    ["THANK_YOU_PAGE" /* THANK_YOU_PAGE */]: thank_you_page_default_values_default,
    ["ORDER_STATUS_PAGE" /* ORDER_STATUS_PAGE */]: order_status_page_default_values_default,
    ["POST_PURCHASE_PAGE1" /* POST_PURCHASE_PAGE1 */]: post_purchase_default_values_default,
    ["POST_PURCHASE_PAGE2" /* POST_PURCHASE_PAGE2 */]: post_purchase_default_values_default,
    ["PRE_PURCHASE_PRODUCT_PAGE" /* PRE_PURCHASE_PRODUCT_PAGE */]: pre_purchase_default_values_default,
    ["PRE_PURCHASE_CART_PAGE" /* PRE_PURCHASE_CART_PAGE */]: pre_purchase_default_values_default,
    ["PRE_PURCHASE_CART_DRAWER_PAGE" /* PRE_PURCHASE_CART_DRAWER_PAGE */]: pre_purchase_cart_drawer_default_values_default,
    ["FORM_EDITOR" /* FORM_EDITOR */]: form_editor_default_value_default
  },
  [PlatformType.Wix]: {
    ["CHECKOUT" /* CHECKOUT */]: checkout_wix_default_value_default,
    ["PRE_PURCHASE_PRODUCT_PAGE" /* PRE_PURCHASE_PRODUCT_PAGE */]: pre_purchase_wix_default_value_default
  }
};
var advancedTimerData = {
  [PlatformType.Shopify]: {
    ["POST_PURCHASE_PAGE1" /* POST_PURCHASE_PAGE1 */]: advance_timer_default_value_default,
    ["POST_PURCHASE_PAGE2" /* POST_PURCHASE_PAGE2 */]: advance_timer_default_value_default
  }
};
var updateValue = (defaultData2, key, value) => {
  for (let nestedKey in defaultData2) {
    if (typeof defaultData2[nestedKey] === "object") {
      if (typeof value === "object" && nestedKey === key) {
        Object.entries(value).forEach(([key2, value2]) => {
          updateValue(defaultData2[nestedKey], key2, value2);
        });
      } else {
        updateValue(defaultData2[nestedKey], key, value);
      }
    } else if (nestedKey === key) {
      defaultData2[nestedKey] = value;
      break;
    }
  }
};
var replaceBlock = (block, defaultValue) => {
  Object.entries(defaultValue).forEach(([key, value]) => {
    if (key === "type") {
      return;
    }
    updateValue(block, key, value);
  });
};
var replaceBlocksDefaultValues = (widget, defaultDataClone) => {
  if (widget?.blocksDefaultValue?.length) {
    defaultDataClone.blocks.forEach((block) => {
      const defaultValue = widget.blocksDefaultValue.find(
        (b) => b.type === block.type
      );
      if (defaultValue) {
        replaceBlock(block, defaultValue);
      }
    });
  }
};
var getGroupData = (defaultWidgets, widgets, parentType) => {
  const groupData = [];
  if (!widgets?.length) {
    return groupData;
  }
  widgets.forEach((widget) => {
    const defaultData2 = defaultWidgets.find(
      (dWidget) => dWidget.type === widget.type
    );
    if (!defaultData2) {
      return;
    }
    let defaultDataClone = lodash.cloneDeep(defaultData2);
    if (defaultDataClone.type === "UPSELL" /* Upsell */) {
      if (parentType === "BUNDLE" /* Bundle */) {
        delete defaultDataClone.upsellInfo.noOfProducts;
        delete defaultDataClone.upsellInfo.layout;
      }
      if (!defaultDataClone.blocks) {
        defaultDataClone.blocks = [];
      }
    }
    if (["BUNDLE" /* Bundle */, "FORM_WIDGET" /* FormWidget */].includes(parentType)) {
      defaultDataClone.displayOrder = widget.displayOrder ?? defaultDataClone.displayOrder;
    }
    if (["FORM_WIDGET" /* FormWidget */].includes(parentType)) {
      defaultDataClone.location = widget.location ?? defaultDataClone.location;
    }
    if (widget.removeBlocks?.length) {
      widget.removeBlocks?.forEach((rBlockType) => {
        defaultDataClone.blocks = defaultDataClone?.blocks?.filter(
          (block) => rBlockType !== block.type
        );
      });
    }
    if (widget.removeBlockKeys?.length) {
      widget.removeBlockKeys?.forEach((rBlockKey) => {
        const key = rBlockKey.type;
        const blockValue = defaultDataClone?.blocks?.find((block) => block.type === key);
        key && rBlockKey.keys?.forEach((value) => {
          if (blockValue && blockValue[value]) {
            delete blockValue[value];
          }
        });
      });
    }
    if (widget.optionalBlocks?.length) {
      widget.optionalBlocks?.forEach((rBlockType) => {
        defaultDataClone.blocks = defaultDataClone?.blocks?.filter(
          (block) => rBlockType !== block.type
        );
      });
    }
    defaultDataClone.blocks = defaultDataClone?.blocks?.map((block) => ({
      ...block,
      id: Ids()
    }));
    replaceBlocksDefaultValues(widget, defaultDataClone);
    defaultDataClone.blocks = defaultDataClone?.blocks?.sort((a, b) => a.displayOrder - b.displayOrder);
    if (defaultDataClone.type === "UPSELL" /* Upsell */ && defaultDataClone.upsellInfo && parentType !== "BUNDLE" /* Bundle */) {
      if (widget.layout !== void 0) {
        defaultDataClone.upsellInfo.layout = widget.layout;
      }
    }
    Object.entries(widget).forEach(([key, value]) => {
      if (key === "type") {
        return;
      }
      if (defaultDataClone.type === "UPSELL" /* Upsell */ && ["layout"].includes(key)) {
        return;
      }
      updateValue(defaultDataClone, key, value);
    });
    defaultDataClone.parentType = parentType;
    defaultDataClone.id = Ids();
    if (defaultDataClone.widgets?.length) {
      defaultDataClone.widgets = getGroupData(defaultWidgets, widget.widgets, defaultDataClone.type);
    }
    groupData.push(defaultDataClone);
  });
  return groupData;
};
var getSectionsByList = (layout, list, selectedWidget) => {
  const widgetArray = [];
  layout.forEach((key) => {
    const widget = {
      ...ThreeSectionLayoutSettings[key],
      id: Ids(),
      blocks: list[key],
      isVisible: selectedWidget.upsellInfo?.[ThreeSectionLayoutVisible[key]],
      parentType: selectedWidget.type
    };
    widgetArray.push(widget);
  });
  return widgetArray;
};
var changeLayout = (widget, newLayout, oldLayout, isSubscriptionEnabled = false) => {
  try {
    let blockArray = [];
    if ([
      Layouts.ONE_COLUMN,
      Layouts.SMALL_LAYOUT_ONE,
      Layouts.SMALL_LAYOUT_TWO
    ].includes(oldLayout)) {
      blockArray = widget?.blocks;
    } else if (oldLayout === Layouts.TWO_COLUMN || oldLayout === Layouts.THREE_COLUMN) {
      if (widget?.widgets?.length > 0) {
        widget?.widgets.forEach((widget2) => {
          if (widget2?.blocks?.length > 0) {
            blockArray = blockArray.concat(widget2.blocks);
          }
        });
      }
    }
    if ([
      Layouts.ONE_COLUMN,
      Layouts.SMALL_LAYOUT_ONE,
      Layouts.SMALL_LAYOUT_TWO
    ].includes(newLayout)) {
      delete widget?.widgets;
      widget.blocks = blockArray;
    } else if (newLayout === Layouts.TWO_COLUMN || newLayout === Layouts.THREE_COLUMN) {
      if (blockArray.length > 0) {
        let layout = newLayout === Layouts.THREE_COLUMN ? [...ThreeSectionLayout] : [...TwoSectionLayout];
        let listBlocks = {};
        if (isSubscriptionEnabled) {
          layout.unshift("ROOT" /* ROOT */);
        }
        layout.forEach((key) => listBlocks[key] = []);
        blockArray?.forEach((block) => {
          if (block.location === 1) {
            listBlocks.LEFT.push(block);
          } else if (block.location === 2) {
            listBlocks.RIGHT.push(block);
          } else if (block.location === 0) {
            listBlocks.ROOT.push(block);
          } else {
            if (newLayout === Layouts.THREE_COLUMN) {
              listBlocks.BOTTOM.push(block);
            } else {
              listBlocks.RIGHT.push(block);
            }
          }
        });
        blockArray = getSectionsByList(layout, listBlocks, widget);
      }
      delete widget?.blocks;
      widget.widgets = blockArray;
    }
    return widget;
  } catch (err) {
    console.warn("err", err);
  }
};
var getWidgetsData = (defaultValues, widgetData) => {
  if (widgetData.widgets?.length) {
    widgetData.widgets = getGroupData(defaultValues, widgetData.widgets, widgetData.type);
  }
  if (widgetData.blocks) {
    const blocks = getGroupData(defaultValues, widgetData.blocks, widgetData.type);
    widgetData.blocks = blocks?.length ? blocks : widgetData.blocks.map((block) => ({ ...block, id: Ids() }));
  }
  return widgetData;
};
var getDefaultWidget = (platform, pageType, widgetType, parentWidgetType, slotId, variantId, isPostPurchaseAdvancedTimer = false, isSubscriptionEnabled = false) => {
  const data = lodash.cloneDeep(defaultData[platform]?.[pageType]);
  if (data && !isSubscriptionEnabled) {
    const updatedDefaultValues = lodash.cloneDeep(data?.defaultValues)?.map((a) => {
      if (a.type === "UPSELL" /* Upsell */) {
        a.blocks = a.blocks?.filter((b) => !["SUBSCRIPTION"].includes(b.type));
        if (a.blocks?.length) {
          a.blocks.forEach((block) => {
            if (block.type === "BUTTON") {
              delete block.subscriptionButtonTextForOneTimePurchase;
              delete block.subscriptionButtonText;
            }
          });
        }
      }
      return a;
    }) || [];
    data.defaultValues = updatedDefaultValues;
  }
  let selectedWidget = data?.defaultValues?.find(
    (widget) => widget.type === widgetType
  );
  if (selectedWidget?.type === "TIMER" /* Timer */ && isPostPurchaseAdvancedTimer && ["POST_PURCHASE_PAGE1" /* POST_PURCHASE_PAGE1 */, "POST_PURCHASE_PAGE2" /* POST_PURCHASE_PAGE2 */].includes(pageType)) {
    const advancedTimerWidget = lodash.cloneDeep(advancedTimerData[platform]?.[pageType]);
    selectedWidget = advancedTimerWidget?.defaultValues[0];
  }
  if (["POST_PURCHASE_PAGE1" /* POST_PURCHASE_PAGE1 */, "POST_PURCHASE_PAGE2" /* POST_PURCHASE_PAGE2 */, "PRE_PURCHASE_CART_PAGE" /* PRE_PURCHASE_CART_PAGE */, "PRE_PURCHASE_CART_DRAWER_PAGE" /* PRE_PURCHASE_CART_DRAWER_PAGE */, "PRE_PURCHASE_PRODUCT_PAGE" /* PRE_PURCHASE_PRODUCT_PAGE */, "CHECKOUT" /* CHECKOUT */].includes(pageType) && selectedWidget?.type === "UPSELL" /* Upsell */ && !isSubscriptionEnabled) {
    if (selectedWidget?.blocks?.length) {
      const deepCloneBlocks = lodash.cloneDeep(selectedWidget.blocks);
      const blocks = deepCloneBlocks?.filter((block) => !["SUBSCRIPTION"].includes(block.type));
      blocks.forEach((block) => {
        if (block.type === "ORDER_SUMMARY") {
          delete block.isVisibleRecurringSubtotalTooltip;
          delete block.recurringSubtotalTooltipText;
          delete block.recurringSubtotalText;
        }
      });
      selectedWidget.blocks = blocks;
    }
  }
  if (!selectedWidget) {
    return null;
  }
  let widgetData = lodash.cloneDeep(selectedWidget);
  widgetData.id = Ids();
  widgetData.slotId = slotId;
  widgetData.variantId = variantId;
  if (widgetData?.type) {
    if (parentWidgetType && MultiProduct.includes(parentWidgetType)) {
      const parentWidget = data?.defaultValues?.find(
        (widget) => widget.type === parentWidgetType
      );
      if (parentWidget) {
        const childWidget = parentWidget.widgets?.find((widget) => widget.type === widgetType) || parentWidget.blocks?.find((block) => block.type === widgetType);
        if (childWidget) {
          widgetData = getGroupData(data?.defaultValues, [childWidget], parentWidgetType);
        } else {
          widgetData = getWidgetsData(data?.defaultValues, widgetData);
        }
      }
    } else if (MultiProduct.includes(widgetData.type)) {
      widgetData = getWidgetsData(data?.defaultValues, widgetData);
    } else if (widgetData?.blocks?.length > 0) {
      widgetData.blocks = widgetData?.blocks.map((block) => ({ ...block, id: Ids() })) || [];
      const layout = widgetData?.upsellInfo?.layout;
      if (layout && [Layouts.TWO_COLUMN, Layouts.THREE_COLUMN].includes(
        layout
      )) {
        widgetData = changeLayout(
          widgetData,
          layout,
          Layouts.ONE_COLUMN,
          isSubscriptionEnabled
        );
      }
    }
  }
  return widgetData;
};
var getDefaultBlock = (platform, pageType, blockType, widgetType, parentWidgetType) => {
  const data = lodash.cloneDeep(defaultData[platform]?.[pageType]);
  const selectedWidget = data?.defaultValues?.find(
    (widget) => widget.type === widgetType
  );
  if (!selectedWidget) {
    return null;
  }
  let defaultBlockDataClone;
  const defaultBlockData = selectedWidget.blocks?.find(
    (block) => block.type === blockType
  );
  if (!defaultBlockData) {
    return null;
  }
  defaultBlockDataClone = lodash.cloneDeep(defaultBlockData);
  defaultBlockDataClone.id = Ids();
  if (parentWidgetType) {
    const parentWidget = data?.defaultValues?.find(
      (widget) => widget.type === parentWidgetType
    );
    if (parentWidget) {
      const widget = parentWidget?.widgets?.find(
        (b) => b.type === widgetType
      );
      if (widget) {
        const block = widget?.blocksDefaultValue?.find(
          (b) => b.type === blockType
        );
        if (block) {
          replaceBlock(defaultBlockDataClone, block);
        }
      }
    }
  }
  return defaultBlockDataClone;
};
var getDefaultBlocks = (platform, pageType, widgetType, parentWidgetType) => {
  const data = lodash.cloneDeep(defaultData[platform]?.[pageType]);
  const selectedWidget = data?.defaultValues?.find(
    (widget) => widget.type === widgetType
  );
  if (!selectedWidget || !("blocks" in selectedWidget) || !selectedWidget.blocks) {
    return null;
  }
  let defaultBlocksDataClone = lodash.cloneDeep(selectedWidget.blocks);
  if (parentWidgetType) {
    const parentWidget = data?.defaultValues?.find(
      (widget) => widget.type === parentWidgetType
    );
    if (parentWidget) {
      const widget = parentWidget?.widgets?.find(
        (b) => b.type === widgetType
      );
      if (widget) {
        widget.removeBlocks?.forEach((rBlockType) => {
          defaultBlocksDataClone = defaultBlocksDataClone?.filter(
            (block) => rBlockType !== block.type
          );
        });
        if (widget.removeBlockKeys?.length) {
          widget.removeBlockKeys?.forEach((rBlockKey) => {
            const key = rBlockKey.type;
            const blockValue = defaultBlocksDataClone?.find((block) => block.type === key);
            key && rBlockKey.keys?.forEach((value) => {
              if (blockValue && blockValue[value]) {
                delete blockValue[value];
              }
            });
          });
        }
        if (widget.blocksDefaultValue?.length) {
          defaultBlocksDataClone.forEach((block) => {
            const defaultValue = widget.blocksDefaultValue.find(
              (b) => b.type === block.type
            );
            if (defaultValue) {
              replaceBlock(block, defaultValue);
            }
          });
        }
      }
    }
  }
  return defaultBlocksDataClone;
};
var getDefaultAllBlocks = (platform, pageType) => {
  const data = lodash.cloneDeep(defaultData[platform]?.[pageType]);
  const blockArray = [];
  data?.defaultValues?.forEach((widget) => {
    if (widget?.blocks?.length > 0 && !widget.hideAddBlockSection) {
      widget.blocks.forEach((block) => {
        if (!blockArray.some((existingBlock) => existingBlock.type === block.type)) {
          blockArray.push(block);
        }
      });
    }
  });
  return blockArray;
};
var getDefaultFormEditorWidget = () => {
  const data = lodash.cloneDeep(form_editor_default_value_default)?.defaultValues;
  return data;
};

// src/flow/common.ts
var SEGMENT_TEXT_BY_PAGE_TYPE = {
  ["PRE_PURCHASE_PRODUCT_PAGE" /* PRE_PURCHASE_PRODUCT_PAGE */]: "product page",
  ["PRE_PURCHASE_CART_PAGE" /* PRE_PURCHASE_CART_PAGE */]: "cart page",
  ["PRE_PURCHASE_CART_DRAWER_PAGE" /* PRE_PURCHASE_CART_DRAWER_PAGE */]: "cart drawer",
  ["CHECKOUT" /* CHECKOUT */]: "checkout",
  ["POST_PURCHASE_PAGE1" /* POST_PURCHASE_PAGE1 */]: "post purchase 1",
  ["POST_PURCHASE_PAGE2" /* POST_PURCHASE_PAGE2 */]: "post purchase 2",
  ["THANK_YOU_PAGE" /* THANK_YOU_PAGE */]: "thank you page",
  ["ORDER_STATUS_PAGE" /* ORDER_STATUS_PAGE */]: "order status page"
};
var getProductToDisplayValue = (upsellType, location) => {
  const pageLocations = ["PRE_PURCHASE_PRODUCT_PAGE" /* PRE_PURCHASE_PRODUCT_PAGE */, "PRE_PURCHASE_CART_PAGE" /* PRE_PURCHASE_CART_PAGE */, "CHECKOUT" /* CHECKOUT */];
  const allUpsellTypes = {
    ["SHOPIFY_RECOMMENDATIONS" /* SHOPIFY_RECOMMENDATIONS */]: "Shopify recommendations",
    ["SPECIFIC_PRODUCT" /* SPECIFIC_PRODUCT */]: "Specific product",
    ["SPECIFIC_COLLECTION" /* SPECIFIC_COLLECTION */]: "Specific collection",
    ["MOST_EXPENSIVE" /* MOST_EXPENSIVE */]: `Most expensive product in the ${pageLocations.includes(location) ? "cart" : "order"}`,
    ["LEAST_EXPENSIVE" /* LEAST_EXPENSIVE */]: `Cheapest product in the ${pageLocations.includes(location) ? "cart" : "order"}`,
    ["PERSONALIZED_RECOMMENDATIONS" /* PERSONALIZED_RECOMMENDATIONS */]: "Personalized recommendations",
    ["RECOMATIC_RECOMMENDATIONS" /* RECOMATIC_RECOMMENDATIONS */]: "Recomatic recommendations"
  };
  return allUpsellTypes[upsellType] || "Random product";
};
var getWidgetTypeValue = (widgetType, defaultValue = "N/A") => {
  const allWidgetTypes = {
    ["MULTI_PRODUCT_UPSELL" /* MultiProductUpsell */]: "Product upsell",
    ["BANNER" /* Banner */]: "Banner",
    ["DIVIDER" /* Divider */]: "Divider",
    ["TEXT" /* Text */]: "Text",
    ["UPSELL" /* Upsell */]: "Product",
    ["TIMER" /* Timer */]: "Timer",
    ["DISCOUNT_TIMER" /* DiscountTimer */]: "Discount timer",
    ["BUNDLE" /* Bundle */]: "Bundle",
    ["RECOMMENDATIONS" /* Recommendations */]: "Product recommendations",
    ["FORM_WIDGET" /* FormWidget */]: "Birthday collector",
    ["THANK_YOU_PAGE_BAR" /* ThankYouPageBar */]: "Discount timer",
    ["ONLINE_STORE_BAR" /* OnlineStoreBar */]: "Discount timer",
    ["ORDER_STATUS_PAGE_BAR" /* OrderStatusPageBar */]: "Discount timer",
    ["IMAGE_WIDGET" /* ImageWidget */]: "Image"
  };
  return allWidgetTypes[widgetType] || defaultValue;
};
var getConditionCategoryValue = (conditionType) => {
  const allConditionTypes = {
    ["SPECIFIC_PRODUCT" /* SPECIFIC_PRODUCT */]: "Specific product",
    ["PRODUCT_TITLE" /* PRODUCT_TITLE */]: "Product title",
    ["PRODUCT_COLLECTION" /* PRODUCT_COLLECTION */]: "Product collection",
    ["PRODUCT_SKU" /* PRODUCT_SKU */]: "Product SKU",
    ["CART_OR_ORDER_VALUE" /* CART_OR_ORDER_VALUE */]: "Cart/Order value",
    ["PRODUCT_TAGS" /* PRODUCT_TAGS */]: "Product tags",
    ["PRODUCT_VARIANT_NAME" /* PRODUCT_VARIANT_NAME */]: "Variant name",
    ["DISCOUNT_CODE" /* DISCOUNT_CODE */]: "Discount code",
    ["CUSTOMER_LANGUAGE" /* CUSTOMER_LANGUAGE */]: "Language",
    ["CUSTOMER_COUNTRY" /* CUSTOMER_COUNTRY */]: "Customer country",
    ["CUSTOMER_SEGMENTS" /* CUSTOMER_SEGMENTS */]: "Customer segments",
    ["PREV_PAGE_OFFER" /* PREV_PAGE_OFFER */]: "Previous offer"
  };
  if (Array.isArray(conditionType)) {
    return conditionType.map((type) => allConditionTypes[type] || "N/A").join(",") || "N/A";
  }
  return allConditionTypes[conditionType] || "N/A";
};
var getConversionTypeValue = (location, oldOrderId, orderId) => {
  if (["CHECKOUT" /* CHECKOUT */, "PRE_PURCHASE_PRODUCT_PAGE" /* PRE_PURCHASE_PRODUCT_PAGE */, "PRE_PURCHASE_CART_PAGE" /* PRE_PURCHASE_CART_PAGE */, "PRE_PURCHASE_CART_DRAWER_PAGE" /* PRE_PURCHASE_CART_DRAWER_PAGE */].includes(location)) {
    return "added to order pre purchase";
  } else if (["POST_PURCHASE_PAGE1" /* POST_PURCHASE_PAGE1 */, "POST_PURCHASE_PAGE2" /* POST_PURCHASE_PAGE2 */].includes(location)) {
    return "post purchase";
  } else if (["THANK_YOU_PAGE" /* THANK_YOU_PAGE */, "ORDER_STATUS_PAGE" /* ORDER_STATUS_PAGE */].includes(location) && oldOrderId && oldOrderId == orderId) {
    return "edited order";
  } else if (["THANK_YOU_PAGE" /* THANK_YOU_PAGE */, "ORDER_STATUS_PAGE" /* ORDER_STATUS_PAGE */].includes(location) && orderId) {
    return "new order";
  }
  return "N/A";
};
var getLocationPageValue = (location) => {
  const allLocationPages = {
    ["CHECKOUT" /* CHECKOUT */]: "Checkout",
    ["THANK_YOU_PAGE" /* THANK_YOU_PAGE */]: "Thank you page",
    ["POST_PURCHASE_PAGE1" /* POST_PURCHASE_PAGE1 */]: "Post purchase page 1",
    ["POST_PURCHASE_PAGE2" /* POST_PURCHASE_PAGE2 */]: "Post purchase page 2",
    ["ORDER_STATUS_PAGE" /* ORDER_STATUS_PAGE */]: "Order status page",
    ["PRE_PURCHASE_PRODUCT_PAGE" /* PRE_PURCHASE_PRODUCT_PAGE */]: "Product page",
    ["PRE_PURCHASE_CART_DRAWER_PAGE" /* PRE_PURCHASE_CART_DRAWER_PAGE */]: "Cart drawer",
    ["PRE_PURCHASE_CART_PAGE" /* PRE_PURCHASE_CART_PAGE */]: "Cart page"
  };
  return allLocationPages[location] || "N/A";
};
var getCompressedImageUrl = (CUSTOM_IMAGE_BUCKET_NAME, CUSTOM_IMAGE_CDN_URL, imageUrl, size) => {
  const imageRequestObj = {
    bucket: CUSTOM_IMAGE_BUCKET_NAME,
    key: imageUrl,
    edits: {
      resize: {
        height: size,
        width: size
      }
    }
  };
  const jsonString = JSON.stringify(imageRequestObj);
  const payload = btoa(jsonString);
  return `${CUSTOM_IMAGE_CDN_URL}/image/${payload}`;
};
var compressedImageURL = (CUSTOM_IMAGE_BUCKET_NAME, CUSTOM_IMAGE_CDN_URL, RECONVERT_CDN_BASE_URL, imageUrl, width, Platform4) => {
  if (!imageUrl || Platform4 === PlatformType.Wix) {
    return imageUrl;
  }
  if (!imageUrl.startsWith("https://")) {
    return getCompressedImageUrl(CUSTOM_IMAGE_BUCKET_NAME, CUSTOM_IMAGE_CDN_URL, imageUrl, width);
  }
  const shopifyCDNUrl = "https://cdn.shopify.com";
  if (imageUrl.startsWith(shopifyCDNUrl)) {
    const lastDotIndex = imageUrl.lastIndexOf(".");
    if (lastDotIndex > -1) {
      const basePart = imageUrl.substring(0, lastDotIndex);
      const extensionPart = imageUrl.substring(lastDotIndex);
      return `${basePart}_${width}x${width}${extensionPart}`;
    }
    return imageUrl;
  }
  const key = imageUrl.split(`${RECONVERT_CDN_BASE_URL}/`)[1];
  return getCompressedImageUrl(CUSTOM_IMAGE_BUCKET_NAME, CUSTOM_IMAGE_CDN_URL, key, width);
};
var validateImageMagicBytes = (file) => {
  return new Promise((resolve) => {
    const reader = new FileReader();
    reader.onload = (e) => {
      try {
        const buf = new Uint8Array(e.target?.result);
        if (buf[0] === 255 && buf[1] === 216 && buf[2] === 255) {
          return resolve(true);
        }
        if (buf[0] === 137 && buf[1] === 80 && buf[2] === 78 && buf[3] === 71 && buf[4] === 13 && buf[5] === 10 && buf[6] === 26 && buf[7] === 10) {
          return resolve(true);
        }
        if (buf[0] === 71 && buf[1] === 73 && buf[2] === 70 && buf[3] === 56) {
          return resolve(true);
        }
        if (buf[0] === 82 && buf[1] === 73 && buf[2] === 70 && buf[3] === 70 && buf[8] === 87 && buf[9] === 69 && buf[10] === 66 && buf[11] === 80) {
          return resolve(true);
        }
        const text = new TextDecoder("utf-8", { fatal: false }).decode(buf);
        if (/<svg[\s>/]/i.test(text) || text.includes("<?xml") && text.includes("<svg")) {
          return resolve(true);
        }
        resolve(false);
      } catch {
        resolve(false);
      }
    };
    reader.onerror = () => resolve(false);
    reader.readAsArrayBuffer(file.slice(0, 512));
  });
};

// src/flow/addUniqueId.ts
import lodash2 from "lodash";
import { v4 as uuidv42 } from "uuid";
function hasExistingId(value) {
  return typeof value === "string" && value.length > 0;
}
function attachIdsForTranslatableObject(obj) {
  const translatableField = obj.translatableField;
  if (!Array.isArray(translatableField)) return;
  for (const field of translatableField) {
    const idKey = `${field}Id`;
    if (!hasExistingId(obj[idKey])) obj[idKey] = uuidv42();
  }
}
function walk(node) {
  if (node === null || typeof node !== "object") return;
  if (Array.isArray(node)) {
    for (const item of node) walk(item);
    return;
  }
  const obj = node;
  for (const key of Object.keys(obj)) {
    walk(obj[key]);
  }
  attachIdsForTranslatableObject(obj);
}
function addUniqueIds(flowJson) {
  const clone = lodash2.cloneDeep(flowJson);
  walk(clone);
  return clone;
}

// src/utils/language-utils.ts
var LANGUAGE = [
  { label: "\u010Ce\u0161tina", value: "cs" },
  { label: "Dansk", value: "da" },
  { label: "Deutsch", value: "de" },
  { label: "English", value: "en" },
  { label: "Espa\xF1ol", value: "es" },
  { label: "Fran\xE7ais", value: "fr" },
  { label: "Indonesia (Beta)", value: "id" },
  { label: "Italiano", value: "it" },
  { label: "Lietuvi\u0173 (Beta)", value: "lt" },
  { label: "Magyar (B\xE9ta)", value: "hu" },
  { label: "Nederlands", value: "nl" },
  { label: "Norsk (bokm\xE5l)", value: "nb" },
  { label: "Polski", value: "pl" },
  { label: "Portugu\xEAs (Brasil)", value: "pt-BR" },
  { label: "Portugu\xEAs (Portugal)", value: "pt" },
  { label: "Rom\xE2n\u0103 (Beta)", value: "ro" },
  { label: "Suomi", value: "fi" },
  { label: "Svenska", value: "sv" },
  { label: "T\xFCrk\xE7e", value: "tr" },
  { label: "\u0395\u03BB\u03BB\u03B7\u03BD\u03B9\u03BA\u03AC (Beta)", value: "el" },
  { label: "\u0411\u044A\u043B\u0433\u0430\u0440\u0441\u043A\u0438 (\u0411\u0435\u0442\u0430)", value: "bg" },
  { label: "\u0420\u0443\u0441\u0441\u043A\u0438\u0439 (\u0411\u0435\u0442\u0430)", value: "ru" },
  { label: "\u05E2\u05D1\u05E8\u05D9\u05EA", value: "he_IL" },
  { label: "\u0939\u093F\u0928\u094D\u0926\u0940 (\u092C\u0940\u091F\u093E)", value: "hi" },
  { label: "\u0E20\u0E32\u0E29\u0E32\u0E44\u0E17\u0E22", value: "th" },
  { label: "\u65E5\u672C\u8A9E", value: "ja" },
  { label: "\u7B80\u4F53\u4E2D\u6587", value: "zh-CN" },
  { label: "\u7E41\u9AD4\u4E2D\u6587", value: "zh-TW" },
  { label: "\uD55C\uAD6D\uC5B4", value: "ko" }
];
var languageCodes = new Set(LANGUAGE.map((lang) => lang.value));
var getSupportedLanguageCode = (language) => {
  if (!language) {
    return "en";
  }
  if (languageCodes.has(language)) {
    return language;
  }
  if (language.includes("-")) {
    const prefix = language.split("-")[0];
    if (prefix && languageCodes.has(prefix)) {
      return prefix;
    }
  }
  return "en";
};

// src/utils/extension-utils.ts
var transformExtensionPayload = (payload) => {
  if (!payload || !Array.isArray(payload)) {
    return [];
  }
  return payload?.map((item) => {
    let location;
    let slotNo;
    if (item.handle.includes("thank-you-page")) {
      location = "THANK_YOU_PAGE" /* THANK_YOU_PAGE */;
    } else if (item.handle.includes("order-status-page")) {
      location = "ORDER_STATUS_PAGE" /* ORDER_STATUS_PAGE */;
    } else if (item.handle.includes("checkout")) {
      location = "CHECKOUT" /* CHECKOUT */;
    }
    const match = item.handle.match(/slot-(\d+)/);
    if (match && match[1]) {
      slotNo = parseInt(match[1], 10);
    } else if (item.handle.includes("announcement-bar")) {
      slotNo = -1;
    }
    if (location && slotNo !== void 0) {
      return {
        slotNo,
        location,
        activations: item.activations
      };
    }
    return null;
  }).filter((item) => item !== null);
};
export {
  ConditionFact,
  EDITOR_CONFIG,
  LANGUAGE,
  MAX_CUSTOM_SLOT,
  PageLocations,
  PageType,
  PageTypeOrder,
  PagesWithAds,
  Platform,
  PreMadeTemplateSlotMapping,
  PreMadeTemplateType,
  SEGMENT_TEXT_BY_PAGE_TYPE,
  SlotLocations,
  SlotNameMapping,
  SlotTypeMapping,
  WidgetType,
  addUniqueIds,
  compressedImageURL,
  getConditionCategoryValue,
  getConditionText,
  getConditionTextBasedOnRule,
  getConversionTypeValue,
  getDefaultAllBlocks,
  getDefaultBlock,
  getDefaultBlocks,
  getDefaultFormEditorWidget,
  getDefaultWidget,
  getEditorRedirectionUrl,
  getLocationPageValue,
  getProductToDisplayValue,
  getSlotType,
  getSupportedLanguageCode,
  getWidgetTypeValue,
  initI18n,
  isPostPurchase,
  t,
  transformExtensionPayload,
  validateImageMagicBytes
};
//# sourceMappingURL=index.js.map